[
  {
    "id": "berlinwall",
    "deck": "anchors",
    "title": "נפילת חומת ברלין",
    "start": 1989,
    "end": 1989,
    "date": "1989",
    "place": "ברלין, גרמניה",
    "lat": 52.516,
    "lon": 13.378,
    "desc": "ב־9 בנובמבר פתחו שלטונות מזרח גרמניה במפתיע את מעברי הגבול, והמונים החלו לנתץ את החומה שחצתה את ברלין מאז 1961. הלחץ נבנה מהפגנות המוניות ומהרפורמות של מנהיג ברית המועצות מיכאיל גורבצ׳וב. גרמניה התאחדה בתוך שנה, ועד סוף 1991 התפרקה ברית המועצות עצמה.",
    "rank": 1
  },
  {
    "id": "columbus",
    "deck": "anchors",
    "title": "קולומבוס מגיע לאמריקה",
    "start": 1492,
    "end": 1492,
    "date": "1492",
    "place": "סן סלבדור, איי בהאמה",
    "lat": 24.05,
    "lon": -74.5,
    "desc": "הנווט הגנואזי כריסטופר קולומבוס, שהפליג מערבה בשליחות פרדיננד ואיזבלה מלכי ספרד, נחת באיי בהאמה ב־12 באוקטובר, משוכנע שהגיע לאסיה. מסעותיו פתחו מגע מתמשך בין אירופה לאמריקה. חילופי הגידולים, בעלי החיים והמחלות שבאו בעקבותיו שינו את שני חצאי כדור הארץ והחריבו את העמים הילידים.",
    "rank": 2
  },
  {
    "id": "pyramid",
    "deck": "anchors",
    "title": "בניית הפירמידה הגדולה בגיזה",
    "start": -2580,
    "end": -2560,
    "date": "בערך ⁦2580–2560⁩ לפנה״ס",
    "place": "גיזה, מצרים",
    "lat": 29.979,
    "lon": 31.134,
    "desc": "פרעה ח׳ופו, מהשושלת הרביעית של מצרים, בנה את הפירמידה הגדולה כקבר לעצמו ברמת גיזה, סמוך לבירה ממפיס. הבנייה נמשכה כעשרים שנה והעסיקה אלפי פועלים, צוותי עבודה בשכר ולא עבדים כפי שסברו בעבר. בגובה של כ־146 מטר היא נותרה המבנה הגבוה ביותר שבנה האדם במשך כמעט 4,000 שנה.",
    "rank": 3
  },
  {
    "id": "anc_hiroshima",
    "deck": "anchors",
    "title": "הפצצת הירושימה",
    "start": 1945,
    "end": 1945,
    "date": "1945",
    "place": "הירושימה, יפן",
    "lat": 34.395,
    "lon": 132.455,
    "desc": "מטוס אמריקני הטיל פצצה אטומית על הירושימה, שהרגה עשרות אלפי בני אדם מיד ועוד רבים בעקבות הקרינה. שלושה ימים אחר כך הוטלה פצצה נוספת על נגסאקי, ויפן נכנעה. זה היה השימוש היחיד בנשק גרעיני בלחימה, והוא פתח את העידן הגרעיני.",
    "rank": 4
  },
  {
    "id": "anc_israel1948",
    "deck": "anchors",
    "title": "הכרזת מדינת ישראל",
    "start": 1948,
    "end": 1948,
    "date": "1948",
    "place": "תל אביב, ישראל",
    "lat": 32.072,
    "lon": 34.774,
    "desc": "דוד בן־גוריון הכריז בתל אביב על הקמת מדינת ישראל עם סיום המנדט הבריטי. למחרת פלשו צבאות ערב, ובמלחמה שנמשכה כשנה נעקרו או נמלטו מאות אלפי פלסטינים מבתיהם, ויהודים רבים עלו ארצה. המדינה והסכסוך שמסביבה עיצבו את המזרח התיכון.",
    "rank": 5
  },
  {
    "id": "anc_apollo11",
    "deck": "anchors",
    "title": "הנחיתה על הירח",
    "start": 1969,
    "end": 1969,
    "date": "1969",
    "place": "קייפ קנוורל, פלורידה",
    "lat": 28.52,
    "lon": -80.68,
    "desc": "חללית אפולו 11 שוגרה מפלורידה, ושלושה ימים אחר כך נחתו נייל ארמסטרונג ובאז אולדרין על הירח, בים השלווה. מיליארדי אנשים צפו בשידור החי. זו הייתה הפעם הראשונה שבני אדם דרכו על גוף שמימי אחר, והאירוע סימן שיא של מרוץ החלל.",
    "rank": 6
  },
  {
    "id": "anc_sept11",
    "deck": "anchors",
    "title": "פיגועי 11 בספטמבר",
    "start": 2001,
    "end": 2001,
    "date": "2001",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.7115,
    "lon": -74.0134,
    "desc": "חטפי מטוסים מארגון אל־קאעידה התרסקו במגדלי התאומים בניו יורק, בפנטגון ובשדה בפנסילבניה. כ־3,000 בני אדם נהרגו. בתגובה פתחה ארצות הברית במלחמה באפגניסטן ואחר כך בעיראק, והאירועים עיצבו את הפוליטיקה והביטחון בעולם במשך שנים.",
    "rank": 7
  },
  {
    "id": "bastille",
    "deck": "anchors",
    "title": "כיבוש הבסטיליה",
    "start": 1789,
    "end": 1789,
    "date": "1789",
    "place": "פריז, צרפת",
    "lat": 48.853,
    "lon": 2.369,
    "desc": "ב־14 ביולי הסתערו המוני פריז על הבסטיליה, מבצר וכלא מלכותי, בחיפוש אחר אבק שרפה ונשק. זה קרה על רקע פשיטת רגל של המדינה ועימות בין המלך לואי השישה־עשר לאספה הלאומית שזה עתה הוכרזה. נפילת סמל השלטון המלכותי פתחה את המהפכה הצרפתית, שביטלה את המלוכה ב־1792.",
    "rank": 8
  },
  {
    "id": "anc_jesus",
    "deck": "anchors",
    "title": "צליבתו של ישו",
    "start": 30,
    "end": 30,
    "date": "בערך 30 לספירה",
    "place": "ירושלים, יהודה",
    "lat": 31.778,
    "lon": 35.23,
    "desc": "ישו מנצרת, מורה יהודי שאסף סביבו תלמידים בגליל ובירושלים, הוצא להורג בצליבה בידי הנציב הרומי פונטיוס פילאטוס. מקורות נוצריים ורומאיים, ובהם טקיטוס, מזכירים את האירוע. לפי האמונה הנוצרית הוא קם לתחייה, וסביבו התגבשה הדת הנוצרית שהפכה לגדולה בעולם.",
    "rank": 9
  },
  {
    "id": "anc_covid",
    "deck": "anchors",
    "title": "מגפת הקורונה",
    "start": 2019,
    "end": 2020,
    "date": "⁦2019–2020⁩",
    "place": "ווהאן, סין",
    "lat": 30.59,
    "lon": 114.3,
    "desc": "וירוס קורונה חדש זוהה לראשונה בעיר ווהאן בסוף 2019 ופשט במהירות בעולם. ארגון הבריאות העולמי הכריז על מגפה ב־2020. מדינות סגרו גבולות ופעילות, ומיליוני בני אדם מתו. חיסונים פותחו בפחות משנה ושינו את מהלך המגפה.",
    "rank": 10
  },
  {
    "id": "anc_caesar",
    "deck": "anchors",
    "title": "רצח יוליוס קיסר",
    "start": -44,
    "end": -44,
    "date": "44 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.896,
    "lon": 12.477,
    "desc": "יוליוס קיסר, שהוכרז דיקטטור לכל החיים, נרצח באידוס של מרס על ידי קבוצת סנאטורים, ובהם ברוטוס וקסיוס, שחששו מחזרה למלוכה. הרצח לא הציל את הרפובליקה אלא הוביל למלחמות אזרחים, ובסופן קם אוגוסטוס, הקיסר הראשון.",
    "rank": 11
  },
  {
    "id": "anc_declaration",
    "deck": "anchors",
    "title": "הכרזת העצמאות האמריקנית",
    "start": 1776,
    "end": 1776,
    "date": "1776",
    "place": "פילדלפיה, ארצות הברית",
    "lat": 39.95,
    "lon": -75.15,
    "desc": "נציגי שלוש עשרה המושבות הבריטיות באמריקה הצפונית אימצו הכרזה שכתב בעיקר תומס ג׳פרסון, ובה נטען שכל בני האדם נולדו שווים ובעלי זכויות טבעיות. המושבות היו כבר במלחמה עם בריטניה, וניצחונן הוביל להקמת ארצות הברית.",
    "rank": 12
  },
  {
    "id": "anc_sarajevo",
    "deck": "anchors",
    "title": "ההתנקשות בפרנץ פרדיננד",
    "start": 1914,
    "end": 1914,
    "date": "1914",
    "place": "סרייבו, בוסניה",
    "lat": 43.858,
    "lon": 18.43,
    "desc": "גברילו פרינציפ, לאומן סרבי צעיר, ירה בסרייבו ביורש העצר האוסטרי פרנץ פרדיננד ובאשתו. אוסטריה־הונגריה הגישה אולטימטום לסרביה, ובמהלך חודש נגררו מעצמות אירופה למלחמה ולקחו בה את בנות בריתן. מלחמת העולם הראשונה הרגה כ־20 מיליון איש.",
    "rank": 13
  },
  {
    "id": "anc_vesuvius",
    "deck": "anchors",
    "title": "התפרצות הר וזוב ופומפיי",
    "start": 79,
    "end": 79,
    "date": "79 לספירה",
    "place": "פומפיי, איטליה",
    "lat": 40.751,
    "lon": 14.486,
    "desc": "הר הגעש וזוב התפרץ וכיסה באפר ובחומר געשי את פומפיי, הרקולנאום וערים נוספות. פליניוס הצעיר תיאר את האירוע במכתב, ודודו פליניוס הזקן נהרג בניסיון הצלה. הערים נשמרו תחת האפר ונחשפו בחפירות, ומראות על חיי היום־יום ברומא העתיקה.",
    "rank": 14
  },
  {
    "id": "anc_wright",
    "deck": "anchors",
    "title": "הטיסה הראשונה במטוס",
    "start": 1903,
    "end": 1903,
    "date": "1903",
    "place": "קיטי הוק, ארצות הברית",
    "lat": 36,
    "lon": -75.67,
    "desc": "האחים וילבר ואורוויל רייט, מכונאי אופניים מאוהיו, טסו במטוס בעל מנוע שבנו בעצמם. הטיסה הראשונה נמשכה 12 שניות על חוף צפון קרוליינה. בתוך שנים אחדות נעשו הטיסות ארוכות ובטוחות, ובתוך כמה עשרות שנים התעופה חיברה את העולם.",
    "rank": 15
  },
  {
    "id": "romefall",
    "deck": "anchors",
    "title": "נפילת האימפריה הרומית המערבית",
    "start": 476,
    "end": 476,
    "date": "476 לספירה",
    "place": "רוונה, איטליה",
    "lat": 44.418,
    "lon": 12.204,
    "desc": "המצביא הגרמאני אודואקר הדיח את רומולוס אוגוסטולוס, הקיסר האחרון במערב, ברוונה, שהייתה אז בירת המערב. במקום ליטול את התואר לעצמו, שלח את סמלי הקיסרות לקונסטנטינופול. המערב נחלש במשך עשרות שנים ממלחמות אזרחים, מקריסה כלכלית ומפלישות, ואילו האימפריה המזרחית, הביזנטית, החזיקה מעמד עוד אלף שנה.",
    "rank": 16
  },
  {
    "id": "anc_rome",
    "deck": "anchors",
    "title": "ייסוד רומא",
    "start": -753,
    "end": -753,
    "date": "בערך 753 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.487,
    "desc": "לפי המסורת הרומית, רומולוס הקים את העיר על גבעת הפלטינוס ב־753 לפנה״ס, והרג את אחיו רמוס. החפירות מעידות על יישוב באזור כבר בימים ההם, אך הסיפור עצמו אגדה. רומא צמחה מכפר מלכים ושימשה לאורך אלף שנה מרכז של אימפריה.",
    "rank": 17
  },
  {
    "id": "anc_october",
    "deck": "anchors",
    "title": "המהפכה הבולשביקית",
    "start": 1917,
    "end": 1917,
    "date": "1917",
    "place": "פטרוגרד, רוסיה",
    "lat": 59.94,
    "lon": 30.32,
    "desc": "בעקבות מלחמת העולם הראשונה ורעב כבד בעורף, תפסו הבולשביקים בהנהגת לנין את השלטון בפטרוגרד מידי הממשלה הזמנית. אחרי מלחמת אזרחים ארוכה הוקמה ברית המועצות, שהפכה למעצמה קומוניסטית ושינתה את הפוליטיקה העולמית במאה העשרים.",
    "rank": 18
  },
  {
    "id": "anc_blackdeath",
    "deck": "anchors",
    "title": "המוות השחור",
    "start": 1347,
    "end": 1351,
    "date": "⁦1347–1351⁩",
    "place": "מסינה, סיציליה",
    "lat": 38.19,
    "lon": 15.55,
    "desc": "מגפת דבר פשטה מאסיה המרכזית דרך נתיבי הסחר, ואוניות מהים השחור הביאו אותה אל נמל מסינה. תוך ארבע שנים מתו עשרות אחוזים מאוכלוסיית אירופה, ומגפה דומה פגעה גם במזרח התיכון. המחסור בידיים עובדות שינה את החברה והכלכלה והניע מרידות ושינויים דתיים.",
    "rank": 19
  },
  {
    "id": "anc_ussr",
    "deck": "anchors",
    "title": "התפרקות ברית המועצות",
    "start": 1991,
    "end": 1991,
    "date": "1991",
    "place": "מוסקבה, רוסיה",
    "lat": 55.752,
    "lon": 37.617,
    "desc": "מיכאיל גורבצ׳וב התפטר מתפקידו, והדגל הסובייטי הורד מעל הקרמלין. ברית המועצות התפרקה לחמש עשרה מדינות עצמאיות, ובהן רוסיה, אוקראינה וקזחסטן. סיום המלחמה הקרה שינה את המפה הפוליטית של אירופה ואסיה.",
    "rank": 20
  },
  {
    "id": "marathon",
    "deck": "anchors",
    "title": "קרב מרתון",
    "start": -490,
    "end": -490,
    "date": "490 לפנה״ס",
    "place": "מרתון, יוון",
    "lat": 38.118,
    "lon": 23.978,
    "desc": "כוח פרסי ששלח המלך דריווש הראשון נחת במרתון כדי להעניש את אתונה על תמיכתה במרד היווני ביוניה. ההופליטים האתונאים ובני בריתם מפלטאה, בהנהגת מצביאים ובהם מילטיאדס, הסתערו והניסו את הצבא הגדול מהם. הניצחון הוכיח שאפשר להביס את פרס והפך לאגדת יסוד של הדמוקרטיה האתונאית.",
    "rank": 21
  },
  {
    "id": "anc_chernobyl",
    "deck": "anchors",
    "title": "אסון צ׳רנוביל",
    "start": 1986,
    "end": 1986,
    "date": "1986",
    "place": "צ׳רנוביל, אוקראינה",
    "lat": 51.39,
    "lon": 30.1,
    "desc": "בניסוי בטיחות כושל התפוצץ כור גרעיני בתחנת הכוח בצ׳רנוביל, ופליטת חומרים רדיואקטיביים כיסתה חלקים גדולים מאירופה. עשרות אלפי תושבים פונו וכמה עשרות מהצוותים נהרגו מיד. האסון נחשב לגרוע בתולדות האנרגיה הגרעינית וערער את אמון הציבור במשטר הסובייטי.",
    "rank": 22
  },
  {
    "id": "anc_gutenberg",
    "deck": "anchors",
    "title": "הדפסת התנ״ך של גוטנברג",
    "start": 1455,
    "end": 1455,
    "date": "בערך 1455",
    "place": "מיינץ, גרמניה",
    "lat": 50,
    "lon": 8.27,
    "desc": "יוהאן גוטנברג, צורף מעיר מיינץ, הדפיס את התנ״ך הלטיני הראשון באמצעות אותיות מתכת ניידות ומכבש. השיטה אפשרה להפיק ספרים בכמויות גדולות ובמחיר נמוך בהרבה מכתיבה ביד. בתוך עשרות שנים הופצו ספרים בכל אירופה, והדפוס האיץ את הרנסנס, הרפורמציה והמדע.",
    "rank": 23
  },
  {
    "id": "anc_stonehenge",
    "deck": "anchors",
    "title": "תחילת בניית סטונהנג׳",
    "start": -3000,
    "end": -3000,
    "date": "בערך 3000 לפנה״ס",
    "place": "ויילטשייר, אנגליה",
    "lat": 51.179,
    "lon": -1.826,
    "desc": "במישור סולסברי החלו להקים מערך עגול של סוללת עפר ותעלה, ובהמשך נוספו אבני הענק המפורסמות. האתר שימש כמרחב פולחני וכמקום קבורה במשך כאלף שנים. הוא מעיד על חברה שחסרה כתב אך ידעה לארגן אלפי אנשים ולכוון מבנה לשקיעת החמה ולזריחה בימי היפוך.",
    "rank": 24
  },
  {
    "id": "anc_luther",
    "deck": "anchors",
    "title": "95 התזות של לותר",
    "start": 1517,
    "end": 1517,
    "date": "1517",
    "place": "ויטנברג, גרמניה",
    "lat": 51.87,
    "lon": 12.65,
    "desc": "הנזיר והמלומד מרטין לותר פרסם בויטנברג 95 תזות נגד מכירת כתבי מחילה, ובהן ביקורת על סמכות האפיפיור. הדפוס הפיץ את דבריו במהירות ברחבי גרמניה ומעבר לה. הפולמוס הוליד את הרפורמציה הפרוטסטנטית ושבר את אחדות הנצרות המערבית.",
    "rank": 25
  },
  {
    "id": "anc_constantinople_2",
    "deck": "anchors",
    "title": "נפילת קונסטנטינופול",
    "start": 1453,
    "end": 1453,
    "date": "1453",
    "place": "איסטנבול, טורקיה",
    "lat": 41.015,
    "lon": 28.94,
    "desc": "הסולטאן העות׳מאני מהמט השני כבש את קונסטנטינופול אחרי מצור של כחמישים יום, בעזרת תותחים כבדים. הקיסר קונסטנטינוס האחד עשר נהרג בקרב, והאימפריה הביזנטית נעלמה אחרי כאלף שנה. העיר, שנקראה אחר כך איסטנבול, הפכה לבירת האימפריה העות׳מאנית.",
    "rank": 26
  },
  {
    "id": "anc_thermopylae",
    "deck": "anchors",
    "title": "קרב תרמופילאי",
    "start": -480,
    "end": -480,
    "date": "480 לפנה״ס",
    "place": "תרמופילאי, יוון",
    "lat": 38.797,
    "lon": 22.536,
    "desc": "מלך ספרטה לאונידס ומאות לוחמים נוספים, בסיוע אלפי יוונים, עצרו במעבר צר את צבאו הרב של המלך הפרסי כסרכסס. אחרי ימים של קרב עקף הצבא הפרסי דרך שביל הרים והשמיד את המגינים. הקרב הפך לסמל של גבורה ושל הקרבה למען המולדת.",
    "rank": 27
  },
  {
    "id": "anc_darwin",
    "deck": "anchors",
    "title": "מוצא המינים של דארווין",
    "start": 1859,
    "end": 1859,
    "date": "1859",
    "place": "דאון, אנגליה",
    "lat": 51.33,
    "lon": 0.05,
    "desc": "צ׳ארלס דארווין פרסם את ספרו על מוצא המינים, ובו הסביר כיצד מינים משתנים על ידי ברירה טבעית במשך דורות. התיאוריה שינתה את הביולוגיה והעמידה את האדם כחלק מעולם החי, והעלתה ויכוחים בין מדע לדת שנמשכים עד היום.",
    "rank": 28
  },
  {
    "id": "anc_jerusalem1099",
    "deck": "anchors",
    "title": "כיבוש ירושלים במסע הצלב הראשון",
    "start": 1099,
    "end": 1099,
    "date": "1099",
    "place": "ירושלים",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "צבא של אבירים אירופים, שנענה לקריאת האפיפיור אורבנוס השני, כבש את ירושלים אחרי מצור קצר. תושבי העיר, מוסלמים ויהודים, נטבחו בהמוניהם. הצלבנים הקימו את ממלכת ירושלים ומדינות צלבניות נוספות במזרח הים התיכון, ששרדו כמאתיים שנה.",
    "rank": 29
  },
  {
    "id": "anc_einstein",
    "deck": "anchors",
    "title": "שנת הפלאות של איינשטיין",
    "start": 1905,
    "end": 1905,
    "date": "1905",
    "place": "ברן, שווייץ",
    "lat": 46.95,
    "lon": 7.45,
    "desc": "אלברט איינשטיין, פקיד צעיר במשרד פטנטים בברן, פרסם בשנה אחת מאמרים על תורת היחסות הפרטית, על האפקט הפוטואלקטרי ועל התנועה הבראונית. הוא הראה ששעון ומרחק תלויים בצופה, ושמסה ואנרגיה שקולות. התגליות שינו את הפיזיקה לנצח.",
    "rank": 30
  },
  {
    "id": "anc_secondtemple",
    "deck": "anchors",
    "title": "חורבן בית המקדש השני",
    "start": 70,
    "end": 70,
    "date": "70 לספירה",
    "place": "ירושלים, יהודה",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "אחרי מרד היהודים ברומאים, צבא טיטוס כבש את ירושלים לאחר מצור וחרב את בית המקדש. יוספוס פלביוס תיאר את האירועים, וקשת טיטוס ברומא מתעדת את שלל המקדש. החורבן שינה את היהדות דת של מקדש לדת של לימוד תורה ובתי כנסת, ופתח את התקופה שבה רוב היהודים חיו בגלות.",
    "rank": 31
  },
  {
    "id": "anc_crash",
    "deck": "anchors",
    "title": "הקריסה בוול סטריט",
    "start": 1929,
    "end": 1929,
    "date": "1929",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.706,
    "lon": -74.009,
    "desc": "מחירי המניות בבורסת ניו יורק צנחו בימים אחדים באוקטובר ומחקו רבים מחסכונות האמריקנים. הקריסה האיצה את השפל הגדול, שפגע במדינות רבות והעלה אבטלה לעשרות אחוזים. מצוקה כלכלית זו תרמה לעליית משטרים קיצוניים בגרמניה וביפן.",
    "rank": 32
  },
  {
    "id": "anc_machupicchu",
    "deck": "anchors",
    "title": "בניית מאצ׳ו פיצ׳ו",
    "start": 1450,
    "end": 1450,
    "date": "בערך 1450",
    "place": "מאצ׳ו פיצ׳ו, פרו",
    "lat": -13.163,
    "lon": -72.545,
    "desc": "בימי הקיסר האינקה פצ׳קוטק נבנה בהרי האנדים אחוזה מלכותית גבוהה מעל נהר אורובמבה, בנויה אבנים מסותתות בלי מלט. האתר ננטש כנראה כשהספרדים כבשו את האימפריה, והם לא גילו אותו. בעולם המערבי הוכר רק בראשית המאה העשרים.",
    "rank": 33
  },
  {
    "id": "anc_firsttemple",
    "deck": "anchors",
    "title": "חורבן בית המקדש הראשון והגלות לבבל",
    "start": -586,
    "end": -586,
    "date": "586 לפנה״ס",
    "place": "ירושלים, ממלכת יהודה",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "צבא בבל בראשות נבוכדנצר השני כבש את ירושלים, שרף את בית המקדש וגלה חלק ניכר מתושבי יהודה לבבל. בגלות עוצבה היהדות מחדש, במרכזיות הכתב והקהילה במקום הפולחן במקדש. ההיסטוריה של האירוע מוכרת מן המקרא וממקורות בבליים.",
    "rank": 34
  },
  {
    "id": "anc_tajmahal",
    "deck": "anchors",
    "title": "בניית הטאג׳ מהאל",
    "start": 1632,
    "end": 1653,
    "date": "⁦1632–1653⁩",
    "place": "אגרה, הודו",
    "lat": 27.175,
    "lon": 78.042,
    "desc": "הקיסר המוגולי שאה ג׳האן גייס אלפי בעלי מלאכה ופועלים לבנות מבנה שיונצח את אשתו האהובה ממתאז מהאל שמתה בלידה. מבנה השיש הלבן המפורסם נבנה בעשרות שנים והוא שיא האדריכלות המוגולית. האתר הוא כיום סמל של הודו ושל אהבה.",
    "rank": 35
  },
  {
    "id": "anc_maccabees",
    "deck": "anchors",
    "title": "מרד החשמונאים",
    "start": -167,
    "end": -167,
    "date": "167 לפנה״ס",
    "place": "מודיעין, יהודה",
    "lat": 31.894,
    "lon": 35.011,
    "desc": "מתתיהו הכוהן ובניו מרדו בשלטון הסלווקי כשהמלך אנטיוכוס הרביעי אסר מנהגי יהדות וטימא את בית המקדש. יהודה המכבי טיהר את המקדש ב־164 לפנה״ס, ובהמשך קמה מדינה חשמונאית עצמאית. האירוע נחגג בחנוכה, והוא נשאר מקור השראה בהיסטוריה היהודית.",
    "rank": 36
  },
  {
    "id": "anc_cuba",
    "deck": "anchors",
    "title": "משבר הטילים בקובה",
    "start": 1962,
    "end": 1962,
    "date": "1962",
    "place": "הוואנה, קובה",
    "lat": 23.13,
    "lon": -82.38,
    "desc": "ארצות הברית גילתה שברית המועצות מציבה בקובה טילים גרעיניים. נשיא ארצות הברית קנדי הטיל מצור ימי על האי, ושני הצדדים עמדו בימים אחדים על סף מלחמה גרעינית. המשבר הסתיים בהסכם: הסובייטים הסירו את הטילים ואמריקה הבטיחה לא לפלוש.",
    "rank": 37
  },
  {
    "id": "anc_olympics",
    "deck": "anchors",
    "title": "האולימפיאדה הראשונה",
    "start": -776,
    "end": -776,
    "date": "776 לפנה״ס",
    "place": "אולימפיה, יוון",
    "lat": 37.638,
    "lon": 21.63,
    "desc": "לפי המסורת נערכו באולימפיה, באליס שבפלופונס, משחקים שנועדו לכבוד זאוס, וראשון הזוכים היה הרץ קורוֹיבוֹס. המשחקים נערכו אחת לארבע שנים, ובתקופתם פסקו מלחמות בין הערים היווניות. הם הפכו לנקודת ייחוס לספירת השנים ביוון העתיקה, עד שאסרם הקיסר תאודוסיוס.",
    "rank": 38
  },
  {
    "id": "anc_galileo",
    "deck": "anchors",
    "title": "הטלסקופ של גלילאו",
    "start": 1610,
    "end": 1610,
    "date": "1610",
    "place": "פדובה, איטליה",
    "lat": 45.41,
    "lon": 11.88,
    "desc": "גלילאו גלילי כיוון טלסקופ משופר אל השמיים וגילה ארבעה ירחים המקיפים את צדק, הרי הירח וכוכבים שלא נראו קודם בעין בלתי מזוינת. התגליות תמכו בתפיסה שהשמש במרכז, ולימים הובילו להרשעתו בידי האינקוויזיציה. הוא פרסם אותן בספר שיצא בוונציה.",
    "rank": 39
  },
  {
    "id": "anc_colosseum",
    "deck": "anchors",
    "title": "חנוכת הקולוסיאום",
    "start": 80,
    "end": 80,
    "date": "80 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.492,
    "desc": "הקיסר טיטוס חנך ברומא את האמפיתיאטרון הפלאבי, המכונה קולוסיאום, אחרי הרבה שנות בנייה בהוראת אביו וספסיאנוס. עשרות אלפי צופים צפו בו בקרבות גלדיאטורים ובציד חיות. מבנה הבטון והקשתות שלו מייצג את ההנדסה הרומית.",
    "rank": 40
  },
  {
    "id": "anc_tsunami2004",
    "deck": "anchors",
    "title": "צונאמי האוקיינוס ההודי",
    "start": 2004,
    "end": 2004,
    "date": "2004",
    "place": "חוף סומטרה, אינדונזיה",
    "lat": 3.3,
    "lon": 95.9,
    "desc": "רעידת אדמה חזקה מול חופי סומטרה, בעוצמה של כ־9.1, יצרה גלי ענק שפגעו בחופי יותר מארבע עשרה מדינות. כ־230 אלף בני אדם מתו, רובם באצ׳ה שבאינדונזיה. האסון הניע סיוע בינלאומי גדול ומערכות התרעה חדשות באוקיינוס.",
    "rank": 41
  },
  {
    "id": "anc_terracotta",
    "deck": "anchors",
    "title": "צבא הטרקוטה של קיסר צ׳ין",
    "start": -210,
    "end": -210,
    "date": "210 לפנה״ס",
    "place": "שיאן, סין",
    "lat": 34.384,
    "lon": 109.278,
    "desc": "צ׳ין שי הואנג נקבר בגל ענק, ולצדו אלפי חיילי חרס בגודל טבעי עם נשק אמיתי, שנועדו לשמור עליו בעולם הבא. הצבא התגלה בטעות ב־1974 על ידי איכרים בקידוח באר. כל פסל נראה שונה, והאתר מראה את גודל המבצע האימפריאלי ואת מיומנותם של האומנים.",
    "rank": 42
  },
  {
    "id": "anc_sputnik",
    "deck": "anchors",
    "title": "שיגור ספוטניק",
    "start": 1957,
    "end": 1957,
    "date": "1957",
    "place": "בייקונור, קזחסטן",
    "lat": 45.92,
    "lon": 63.34,
    "desc": "ברית המועצות שיגרה את הלווין המלאכותי הראשון בעולם, כדור מתכת קטן שצפצף בתדר רדיו. ההצלחה הפתיעה את ארצות הברית והתחילה את מרוץ החלל. תוך 12 שנה נחתו בני אדם על הירח.",
    "rank": 43
  },
  {
    "id": "anc_parthenon",
    "deck": "anchors",
    "title": "השלמת הפרתנון באתונה",
    "start": -432,
    "end": -432,
    "date": "432 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.971,
    "lon": 23.726,
    "desc": "בהנהגת פריקלס נבנה על האקרופוליס מקדש לאתנה, אלת העיר, מאבן שיש לבנה בעבודת האדריכלים איקטינוס וקליקרטס ופסלים בפיקוח פידיאס. הוא נבנה מכספי הברית הימית האתונאית. המבנה נחשב לשיא האדריכלות היוונית הקלאסית ולמופת של פרופורציה.",
    "rank": 44
  },
  {
    "id": "anc_india1947",
    "deck": "anchors",
    "title": "עצמאות הודו וחלוקתה",
    "start": 1947,
    "end": 1947,
    "date": "1947",
    "place": "דלהי, הודו",
    "lat": 28.614,
    "lon": 77.209,
    "desc": "בריטניה סיימה את שלטונה בהודו בחלוקת הארץ לשתי מדינות, הודו ופקיסטן. חלוקה זו עקרה כ־15 מיליון בני אדם, ומאות אלפי הודים, מוסלמים וסיקים נהרגו באלימות. הודו, בהנהגת ג׳והרלאל נהרו, הפכה לדמוקרטיה הגדולה בעולם.",
    "rank": 45
  },
  {
    "id": "anc_arabspring",
    "deck": "anchors",
    "title": "האביב הערבי",
    "start": 2010,
    "end": 2011,
    "date": "⁦2010–2011⁩",
    "place": "סידי בוזיד, תוניסיה",
    "lat": 35.04,
    "lon": 9.49,
    "desc": "מוחמד בועזיזי, רוכל ירקות, התאבד בהצתה בעיירה סידי בוזיד במחאה על השחיתות, והמעשה הצית גל הפגנות בתוניסיה. הנשיא נאלץ לברוח, והמחאות התפשטו למצרים, ללוב, לתימן ולסוריה. מדינות אחדות הידרדרו למלחמות אזרחים, ואחרות עברו שינויים מוגבלים.",
    "rank": 46
  },
  {
    "id": "anc_genghis",
    "deck": "anchors",
    "title": "הכרזת צ׳ינגיס חאן",
    "start": 1206,
    "end": 1206,
    "date": "בערך 1206",
    "place": "ערבות מונגוליה",
    "lat": 48.7,
    "lon": 110,
    "desc": "בכינוס של נכבדי השבטים, הקורולטאי, הוכרז תמוג׳ין שאיחד את שבטי מונגוליה כצ׳ינגיס חאן, השליט העליון. תוך שנים אחדות הקים צבא ממושמע שכבש את צפון סין, מרכז אסיה ופרס. צאצאיו הקימו את האימפריה היבשתית הגדולה ביותר בהיסטוריה.",
    "rank": 47
  },
  {
    "id": "anc_dna",
    "deck": "anchors",
    "title": "מבנה הדי־אן־איי",
    "start": 1953,
    "end": 1953,
    "date": "1953",
    "place": "קיימברידג׳, אנגליה",
    "lat": 52.21,
    "lon": 0.12,
    "desc": "ג׳יימס ווטסון ופרנסיס קריק בקמברידג׳ הציעו מודל של סליל כפול למולקולת הדי־אן־איי, בהתבסס על נתוני עקיפת קרני רנטגן של רוזלינד פרנקלין ומוריס וילקינס. המודל הסביר איך מידע תורשתי מועתק ועבר בין דורות, ופתח את הביולוגיה המולקולרית המודרנית.",
    "rank": 48
  },
  {
    "id": "anc_library",
    "deck": "anchors",
    "title": "הספרייה הגדולה של אלכסנדריה",
    "start": -285,
    "end": -285,
    "date": "בערך 285 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.909,
    "desc": "שליטי שושלת התלמים הקימו באלכסנדריה את המוזיאון והספרייה, ובהם נאספו מאות אלפי מגילות. חוקרים כמו אוקלידס, ארכימדס ואראטוסתנס עבדו שם. ירידת הספרייה הייתה הדרגתית ונמשכה מאות שנים, ואין אירוע חורבן בודד שאפשר לייחס לו אותה.",
    "rank": 49
  },
  {
    "id": "anc_penicillin",
    "deck": "anchors",
    "title": "גילוי הפניצילין",
    "start": 1928,
    "end": 1928,
    "date": "1928",
    "place": "לונדון, אנגליה",
    "lat": 51.52,
    "lon": -0.17,
    "desc": "הבקטריולוג אלכסנדר פלמינג שם לב שעובש בצלחת מעבדה הרג חיידקים סביבו, וזיהה בו חומר שנקרא פניצילין. עשור אחר כך פיתחו פלורי וצ׳יין שיטה להפקתו, והוא הציל מיליוני חיילים וחולים. זו הייתה האנטיביוטיקה הראשונה והתחיל עידן חדש ברפואה.",
    "rank": 50
  },
  {
    "id": "anc_fukushima",
    "deck": "anchors",
    "title": "רעידת האדמה והצונאמי ביפן",
    "start": 2011,
    "end": 2011,
    "date": "2011",
    "place": "פוקושימה, יפן",
    "lat": 37.42,
    "lon": 141.03,
    "desc": "רעידת אדמה חזקה מול חוף יפן יצרה צונאמי שהרג כ־18 אלף איש ושטף עיירות שלמות. הגלים הציפו את תחנת הכוח הגרעינית בפוקושימה דאיצ׳י, שבה נמסו כורים. כ־150 אלף בני אדם פונו, והאסון הוביל לבחינה מחודשת של האנרגיה הגרעינית בעולם.",
    "rank": 51
  },
  {
    "id": "anc_socrates",
    "deck": "anchors",
    "title": "משפטו ומותו של סוקרטס",
    "start": -399,
    "end": -399,
    "date": "399 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.725,
    "desc": "הפילוסוף סוקרטס הועמד לדין באתונה באשמת חוסר אמונה באלי העיר והשחתת הנוער, והורשע בהצבעה. הוא סירב לברוח ושתה רעל. תלמידו אפלטון הנציח את דבריו בדיאלוגים, ומותו הפך לדוגמה לאומץ אינטלקטואלי ולהתנגשות בין היחיד לחברה.",
    "rank": 52
  },
  {
    "id": "anc_circumnavigation",
    "deck": "anchors",
    "title": "ההקפה הראשונה של כדור הארץ",
    "start": 1519,
    "end": 1522,
    "date": "⁦1519–1522⁩",
    "place": "סביליה, ספרד",
    "lat": 37.39,
    "lon": -5.99,
    "desc": "חמש ספינות בפיקוד פרננדו מגלן יצאו מספרד בחיפוש דרך מערבית לאיי התבלינים. מגלן נהרג בפיליפינים ב־1521, וספינה אחת בפיקוד חואן סבסטיאן אלקאנו חזרה לספרד ב־1522 אחרי שהקיפה את הגלובוס. המסע הוכיח שהאוקיינוסים מחוברים ושהעולם עגול וגדול.",
    "rank": 53
  },
  {
    "id": "anc_iran1979",
    "deck": "anchors",
    "title": "המהפכה האיסלאמית באיראן",
    "start": 1979,
    "end": 1979,
    "date": "1979",
    "place": "טהראן, איראן",
    "lat": 35.69,
    "lon": 51.39,
    "desc": "הפגנות המוניות, שבהן השתתפו חילונים, שמאלנים ודתיים, הפילו את השאה מוחמד רזא פהלווי. האייתוללה חומייני חזר מהגלות והוקמה רפובליקה אסלאמית שבה לאנשי הדת יש סמכות עליונה. המהפכה שינתה את מאזן הכוחות והשפיעה על תנועות אסלאמיות במזרח התיכון כולו.",
    "rank": 54
  },
  {
    "id": "anc_domerock",
    "deck": "anchors",
    "title": "כיפת הסלע בירושלים",
    "start": 691,
    "end": 691,
    "date": "691 לספירה",
    "place": "ירושלים",
    "lat": 31.778,
    "lon": 35.236,
    "desc": "הח׳ליף עבד אל־מלך בן מרואן הקים על הר הבית מבנה מתומן מפואר מעל הסלע שממנו עלה לפי המסורת מוחמד לשמים. הוא אחד המבנים האיסלאמיים המוקדמים ביותר שנותרו, ובעל כיפה מוזהבת. המבנה סימן את נוכחות האסלאם בעיר שהייתה קדושה גם ליהודים ולנוצרים.",
    "rank": 55
  },
  {
    "id": "anc_flu1918",
    "deck": "anchors",
    "title": "מגפת השפעת הספרדית",
    "start": 1918,
    "end": 1920,
    "date": "⁦1918–1920⁩",
    "place": "פורט ריילי, קנזס",
    "lat": 39.07,
    "lon": -96.8,
    "desc": "מגפת שפעת קטלנית פשטה בעולם בעקבות מלחמת העולם הראשונה והרגה כ־50 מיליון איש, יותר מהמלחמה עצמה. נקראה שפעת ספרדית משום שעיתונות ספרד, שלא חלה עליה צנזורה, דיווחה עליה. מקורה אינו ידוע בוודאות, ואחד ממוקדיה המוקדמים המתועדים היה בבסיס צבאי בקנזס.",
    "rank": 56
  },
  {
    "id": "anc_charlemagne",
    "deck": "anchors",
    "title": "הכתרת קרל הגדול",
    "start": 800,
    "end": 800,
    "date": "800 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.902,
    "lon": 12.454,
    "desc": "האפיפיור ליאו השלישי הכתיר את קרל, מלך הפרנקים, לקיסר ברומא בחג המולד. קרל ריכז תחת שלטונו חלק גדול ממערב אירופה, עודד לימוד ושכתוב כתבי יד, והביא להחייאת הרעיון הקיסרי במערב. תקופתו נקראת רנסנס קרולינגי.",
    "rank": 57
  },
  {
    "id": "anc_saigon",
    "deck": "anchors",
    "title": "נפילת סייגון",
    "start": 1975,
    "end": 1975,
    "date": "1975",
    "place": "סייגון, וייטנאם",
    "lat": 10.78,
    "lon": 106.7,
    "desc": "טנקים של צפון וייטנאם נכנסו לסייגון, בירת דרום וייטנאם, וסיימו את מלחמת וייטנאם שנמשכה עשרים שנה. מאות אלפי בני אדם נמלטו, רבים בסירות, ומיליונים נהרגו במלחמה. ארצות הברית, שפרשה כבר ב־1973, נותרה בטראומה לאומית.",
    "rank": 58
  },
  {
    "id": "anc_vascodagama",
    "deck": "anchors",
    "title": "ואסקו דה גאמה מגיע להודו",
    "start": 1498,
    "end": 1498,
    "date": "1498",
    "place": "קליקוט, הודו",
    "lat": 11.25,
    "lon": 75.78,
    "desc": "הנווט הפורטוגלי ואסקו דה גאמה הקיף את אפריקה והגיע בים לעיר הנמל קליקוט שבחוף מלבר. זו הייתה הפעם הראשונה שספינות אירופיות הגיעו להודו בדרך הים. המסלול איפשר לפורטוגל לעקוף את הסוחרים הערבים והוונציאנים ולשלוט בסחר התבלינים.",
    "rank": 59
  },
  {
    "id": "anc_wannsee",
    "deck": "anchors",
    "title": "ועידת וואנזה",
    "start": 1942,
    "end": 1942,
    "date": "1942",
    "place": "ברלין, גרמניה",
    "lat": 52.433,
    "lon": 13.164,
    "desc": "בפגישה בווילה בפרבר ברלין התכנסו בכירי המשטר הנאצי כדי לתאם את ביצוע ״הפתרון הסופי״, רצח שיטתי של יהודי אירופה. עד תום המלחמה נרצחו כשישה מיליון יהודים במחנות השמדה, ביריות ובגטאות. השואה היא הרצח ההמוני התעשייתי הידוע ביותר בהיסטוריה.",
    "rank": 60
  },
  {
    "id": "anc_sistine",
    "deck": "anchors",
    "title": "תקרת הקפלה הסיסטינית",
    "start": 1508,
    "end": 1512,
    "date": "⁦1508–1512⁩",
    "place": "קריית הוותיקן, רומא",
    "lat": 41.9,
    "lon": 12.455,
    "desc": "האפיפיור יוליוס השני הזמין את מיכלאנג׳לו, שהיה בראש ובראשונה פסל, לצייר את תקרת הקפלה הסיסטינית. האמן עבד כארבע שנים ויצר מאות דמויות, ובהן סצנות מספר בראשית כמו בריאת אדם. היצירה היא שיא של אמנות הרנסנס.",
    "rank": 61
  },
  {
    "id": "anc_prc",
    "deck": "anchors",
    "title": "הקמת הרפובליקה העממית של סין",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "בייג׳ינג, סין",
    "lat": 39.905,
    "lon": 116.39,
    "desc": "מאו דזה־דונג הכריז מעל שער טיינאנמן על הקמת הרפובליקה העממית, אחרי ניצחון הקומוניסטים במלחמת האזרחים. הכוחות הלאומנים נמלטו לטאיוואן. בעשורים הבאים עברה סין קמפיינים אלימים כמו הקפיצה הגדולה והמהפכה התרבותית, ולאחר מכן נפתחה לכלכלת שוק.",
    "rank": 62
  },
  {
    "id": "anc_angkorwat",
    "deck": "anchors",
    "title": "בניית אנגקור וואט",
    "start": 1113,
    "end": 1150,
    "date": "בערך ⁦1113–1150⁩",
    "place": "אנגקור, קמבודיה",
    "lat": 13.412,
    "lon": 103.867,
    "desc": "המלך החמרי סוריאוורמן השני הקים בבירתו מקדש ענק שהוקדש לוישנו, בצורת הר מרוכז ברוחב של מאות מטרים ומוקף חפיר. זהו המבנה הדתי הגדול בעולם, ובמרוצת הזמן הפך ממקדש הינדי למקדש בודהיסטי. הוא סמל לאימפריה החמרית בשיאה.",
    "rank": 63
  },
  {
    "id": "anc_copernicus",
    "deck": "anchors",
    "title": "תיאוריית השמש במרכז של קופרניקוס",
    "start": 1543,
    "end": 1543,
    "date": "1543",
    "place": "פרומבורק, פולין",
    "lat": 54.36,
    "lon": 19.68,
    "desc": "הכומר והאסטרונום ניקולאוס קופרניקוס פרסם את ספרו על סיבובי גרמי השמים, ובו טען שכדור הארץ וכוכבי הלכת נעים סביב השמש. הרעיון סתר את תפיסת העולם הגיאוצנטרית שנהגה אלפי שנים. הוא פתח את המהפכה המדעית.",
    "rank": 64
  },
  {
    "id": "anc_confucius",
    "deck": "anchors",
    "title": "לידת קונפוציוס",
    "start": -551,
    "end": -551,
    "date": "בערך 551 לפנה״ס",
    "place": "צ׳ופו, סין",
    "lat": 35.597,
    "lon": 116.987,
    "desc": "קונפוציוס נולד במדינת לו שבצפון סין, וחי בעיקר כמורה וכיועץ לשליטים ששמעו בו מעט. תורתו הדגישה סדר חברתי, כבוד להורים ולמלך ופיתוח המוסר האישי. תלמידיו ערכו את דבריו בספר המשפטים, והמסורת הקונפוציאנית עיצבה את התרבות והמדינה בסין ובמזרח אסיה במשך אלפיים שנה.",
    "rank": 65
  },
  {
    "id": "anc_suez",
    "deck": "anchors",
    "title": "פתיחת תעלת סואץ",
    "start": 1869,
    "end": 1869,
    "date": "1869",
    "place": "פורט סעיד, מצרים",
    "lat": 31.26,
    "lon": 32.3,
    "desc": "תעלה שתכנן המהנדס הצרפתי פרדיננד דה לסעפס חיברה את הים התיכון עם הים האדום וקיצרה את הדרך לאסיה באלפי קילומטרים. מאות אלפי פועלים מצרים חפרו אותה, ורבים מתו. התעלה הפכה לנתיב סחר חיוני והבריטים שלטו בה במשך שנים.",
    "rank": 66
  },
  {
    "id": "anc_pharos",
    "deck": "anchors",
    "title": "מגדלור אלכסנדריה",
    "start": -280,
    "end": -280,
    "date": "בערך 280 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.214,
    "lon": 29.885,
    "desc": "תלמי השני בנה על האי פארוס מגדלור, שהיה אולי בגובה של יותר ממאה מטרים וחיזק את מעמדה של אלכסנדריה כנמל מרכזי. הוא התקיים כאלף שנה עד שנהרס ברעידות אדמה, ונחשב לאחד משבעת פלאי תבל. השם פארוס נכנס לשפות רבות כמילה למגדלור.",
    "rank": 67
  },
  {
    "id": "anc_watt",
    "deck": "anchors",
    "title": "מנוע הקיטור של ג׳יימס ווט",
    "start": 1769,
    "end": 1769,
    "date": "1769",
    "place": "גלזגו, סקוטלנד",
    "lat": 55.86,
    "lon": -4.25,
    "desc": "ג׳יימס ווט, מהנדס סקוטי, רשם פטנט על מעבה נפרד שהפך את מנוע הקיטור ליעיל פי כמה. המנוע האיץ את המהפכה התעשייתית, כי איפשר להפעיל מפעלים, מכרות ובהמשך קטרים וספינות בלי להיות תלויים במים זורמים או בבהמות.",
    "rank": 68
  },
  {
    "id": "anc_buddha",
    "deck": "anchors",
    "title": "הארתו של בודהה",
    "start": -528,
    "end": -528,
    "date": "בערך 528 לפנה״ס",
    "place": "בודהגאיה, הודו",
    "lat": 24.696,
    "lon": 84.991,
    "desc": "לפי המסורת התיישב הנסיך סידהרתה גוטמה מתחת לעץ בודהי בבודהגאיה, ולאחר מדיטציה הגיע להארה. הוא לימד את דרך האמצע ואת ארבע האמיתות הנאצלות על הסבל ועל שחרור ממנו. התאריך המדויק שנוי במחלוקת, ויש הסוברים שחי כמאה שנה מאוחר יותר.",
    "rank": 69
  },
  {
    "id": "anc_tenochtitlanfall",
    "deck": "anchors",
    "title": "נפילת האימפריה האצטקית",
    "start": 1521,
    "end": 1521,
    "date": "1521",
    "place": "טנוצ׳טיטלן, מקסיקו",
    "lat": 19.435,
    "lon": -99.14,
    "desc": "הכובש הספרדי הרנן קורטס וכוחותיו, יחד עם אלפי לוחמים ממקומיים שנאבקו באצטקים, כבשו את טנוצ׳טיטלן אחרי מצור של כשלושה חודשים. אבעבועות שחורות שהביאו האירופים הרגו חלק גדול מהתושבים. על חורבות העיר נבנתה מקסיקו סיטי, בירת משנה־המלכות של ספרד החדשה.",
    "rank": 70
  },
  {
    "id": "anc_dolly",
    "deck": "anchors",
    "title": "הכבשה דולי",
    "start": 1996,
    "end": 1996,
    "date": "1996",
    "place": "אדינבורו, סקוטלנד",
    "lat": 55.86,
    "lon": -3.2,
    "desc": "חוקרים במכון רוזלין שליד אדינבורו שיבטו כבשה מתא בוגר של כבשה אחרת, והיא הייתה היונק הראשון שיוצר כך. ההישג הוכיח שאפשר להפוך תא מבוגר לתא עובר, ועורר דיון אתי ער על שיבוט בני אדם ועל עתיד הרפואה הגנטית.",
    "rank": 71
  },
  {
    "id": "anc_hijra",
    "deck": "anchors",
    "title": "ההג׳רה של מוחמד למדינה",
    "start": 622,
    "end": 622,
    "date": "622 לספירה",
    "place": "מדינה, ערב הסעודית",
    "lat": 24.47,
    "lon": 39.61,
    "desc": "הנביא מוחמד ועוקביו עזבו את מכה, שבה נרדפו, והגיעו לעיר ינת׳רב, שנקראה מאז מדינה. שם הקים קהילה דתית ומדינית. ההג׳רה היא נקודת ההתחלה של הלוח המוסלמי, והיא נחשבת למפנה בהיווצרות האסלאם כקהילה.",
    "rank": 72
  },
  {
    "id": "anc_saltmarch",
    "deck": "anchors",
    "title": "צעדת המלח של גנדי",
    "start": 1930,
    "end": 1930,
    "date": "1930",
    "place": "דנדי, הודו",
    "lat": 20.89,
    "lon": 72.81,
    "desc": "מהטמה גנדי יצא בצעדה של כ־380 קילומטרים אל חוף הים כדי לייצר מלח בלי לשלם מס לשלטון הבריטי. אלפי הודים הצטרפו אליו, ועשרות אלפים נעצרו. התנועה בלי אלימות משכה תשומת לב עולמית והעמידה את ההתנגדות הבלתי אלימה כאמצעי פוליטי חזק.",
    "rank": 73
  },
  {
    "id": "anc_hadrianwall",
    "deck": "anchors",
    "title": "חומת אדריאנוס",
    "start": 122,
    "end": 122,
    "date": "122 לספירה",
    "place": "צפון אנגליה",
    "lat": 55.012,
    "lon": -2.33,
    "desc": "הקיסר אדריאנוס הורה לבנות חומה בצפון בריטניה שתגדיר את גבול האימפריה. החומה, באורך של כ־117 ק״מ, כללה מבצרים ומגדלי שמירה, ושימשה לפיקוח על מעברים ולא רק להגנה. שרידיה בולטים בנוף עד היום, ומעידים על גבולות הכוח הרומי.",
    "rank": 74
  },
  {
    "id": "anc_hattin",
    "deck": "anchors",
    "title": "קרב קרני חיטין",
    "start": 1187,
    "end": 1187,
    "date": "1187",
    "place": "קרני חיטין, הגליל",
    "lat": 32.8,
    "lon": 35.45,
    "desc": "צבא איובי בראשות צלאח א־דין הביס בקרב את צבא ממלכת ירושלים הצלבנית, בלי מים בחום הקיץ. רבים מהאבירים נשבו והממלכה איבדה את כוחה הצבאי. בתוך חודשים נכבשה ירושלים, והצלבנים נותרו עם רצועת חוף מצומצמת.",
    "rank": 75
  },
  {
    "id": "anc_apartheid",
    "deck": "anchors",
    "title": "הבחירות הדמוקרטיות בדרום אפריקה",
    "start": 1994,
    "end": 1994,
    "date": "1994",
    "place": "פרטוריה, דרום אפריקה",
    "lat": -25.74,
    "lon": 28.21,
    "desc": "בבחירות הראשונות שבהן יכלו כל אזרחי דרום אפריקה להצביע, בלי הבדל גזע, ניצח הקונגרס הלאומי האפריקאי בהנהגת נלסון מנדלה, שישב בכלא 27 שנה. מנדלה הפך לנשיא, וסיים עשרות שנות של משטר האפרטהייד.",
    "rank": 76
  },
  {
    "id": "anc_archimedes",
    "deck": "anchors",
    "title": "מות ארכימדס בסירקוסי",
    "start": -212,
    "end": -212,
    "date": "212 לפנה״ס",
    "place": "סירקוסה, סיציליה",
    "lat": 37.075,
    "lon": 15.286,
    "desc": "ארכימדס היה מתמטיקאי ומהנדס שתרם למכניקה, להידרוסטטיקה ולחישוב המספר פאי. כשהרומאים כבשו את סירקוסה במלחמה הפונית השנייה נהרג על ידי חייל, אף שהמפקד ביקש להשאירו בחיים. הוא נזכר כמי שהמציא מכונות מלחמה ומשפט הציפה המפורסם.",
    "rank": 77
  },
  {
    "id": "anc_cook",
    "deck": "anchors",
    "title": "קוק מגיע לחופי אוסטרליה",
    "start": 1770,
    "end": 1770,
    "date": "1770",
    "place": "מפרץ בוטני, אוסטרליה",
    "lat": -34,
    "lon": 151.22,
    "desc": "הקפטן הבריטי ג׳יימס קוק, שחקר את דרום האוקיינוס השקט, נחת במפרץ בוטני והכריז על החוף המזרחי של אוסטרליה כשטח בריטי. אנשי האבוריג׳ינים חיו ביבשת עשרות אלפי שנים. ב־1788 הוקמה במקום מושבת עבריינים שהפכה למדינה המודרנית.",
    "rank": 78
  },
  {
    "id": "anc_alexdeath",
    "deck": "anchors",
    "title": "מותו של אלכסנדר בבבל",
    "start": -323,
    "end": -323,
    "date": "323 לפנה״ס",
    "place": "בבל, מסופוטמיה",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "אלכסנדר מת בגיל 32 בארמון נבוכדנצר בבבל, אחרי ימים של חום, ולא קבע יורש ברור. מצביאיו, הדיאדוכים, חילקו ביניהם את האימפריה והקימו ממלכות הלניסטיות בעיקר במצרים, בסוריה ובמקדוניה, שהפיצו את התרבות היוונית במזרח.",
    "rank": 79
  },
  {
    "id": "anc_krakatoa",
    "deck": "anchors",
    "title": "התפרצות הר הגעש קרקטאו",
    "start": 1883,
    "end": 1883,
    "date": "1883",
    "place": "קרקטאו, אינדונזיה",
    "lat": -6.1,
    "lon": 105.42,
    "desc": "האי הוולקני קרקטאו שבין ג׳אווה לסומטרה התפוצץ בהתפרצות אדירה, ששמעו את קולה במרחק של אלפי קילומטרים. צונאמי הרג יותר מ־36 אלף איש בחופי האזור. זו הייתה אחת הקטסטרופות הראשונות שהתפרסמו בעולם במהירות בזכות הטלגרף.",
    "rank": 80
  },
  {
    "id": "anc_constantinople",
    "deck": "anchors",
    "title": "ייסוד קונסטנטינופול",
    "start": 330,
    "end": 330,
    "date": "330 לספירה",
    "place": "איסטנבול, טורקיה",
    "lat": 41.012,
    "lon": 28.976,
    "desc": "הקיסר קונסטנטינוס הראשון הקדיש על חוף הבוספורוס, ליד ביזנטיון היוונית, בירה חדשה שנקראה על שמו. מיקומה בין אירופה לאסיה ובין הים השחור לים התיכון העניק לה יתרון. העיר שימשה בירת האימפריה הביזנטית כאלף שנה, עד 1453.",
    "rank": 81
  },
  {
    "id": "anc_principia",
    "deck": "anchors",
    "title": "הפרינקיפיה של ניוטון",
    "start": 1687,
    "end": 1687,
    "date": "1687",
    "place": "לונדון, אנגליה",
    "lat": 51.51,
    "lon": -0.13,
    "desc": "אייזק ניוטון פרסם את ספרו העקרונות המתמטיים של הפילוסופיה של הטבע, ובו שלושת חוקי התנועה וחוק הכבידה האוניברסלי. לראשונה הוסברו תנועות כוכבי הלכת ונפילת התפוח בחוק אחד. הספר הפך ליסוד הפיזיקה למשך יותר ממאתיים שנה.",
    "rank": 82
  },
  {
    "id": "anc_rwanda",
    "deck": "anchors",
    "title": "רצח העם ברואנדה",
    "start": 1994,
    "end": 1994,
    "date": "1994",
    "place": "קיגאלי, רואנדה",
    "lat": -1.95,
    "lon": 30.06,
    "desc": "אחרי הפלת מטוס נשיא רואנדה החלו קיצונים מקרב ההוטו בטבח שיטתי של בני הטוטסי והוטו מתונים. בתוך כמאה ימים נרצחו כ־800 אלף בני אדם, ברובם במצ׳טות. הקהילה הבינלאומית לא התערבה, והטבח הסתיים כשמורדים טוטסים כבשו את הבירה.",
    "rank": 83
  },
  {
    "id": "anc_hammurabi",
    "deck": "anchors",
    "title": "חוקי חמורבי",
    "start": -1754,
    "end": -1754,
    "date": "בערך 1754 לפנה״ס",
    "place": "בבל, מסופוטמיה",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "מלך בבל חמורבי חרט כ־280 חוקים על עמוד אבן שהוצב ברבים, מדיני ממון ועד פגיעות בגוף. העיקרון של פיצוי המותאם לעבירה ולמעמד החברתי נראה לנו קשה, אך הציג את החוק ככתוב וידוע ולא כשרירות. העמוד נמצא בסוסה ב־1901 ושמור כיום בלובר.",
    "rank": 84
  },
  {
    "id": "anc_rosetta_2",
    "deck": "anchors",
    "title": "גילוי אבן רוזטה",
    "start": 1799,
    "end": 1799,
    "date": "1799",
    "place": "ראשיד, מצרים",
    "lat": 31.4,
    "lon": 30.42,
    "desc": "חיילים צרפתים בשירותו של נפוליאון, שפלש למצרים, גילו בעיירה ראשיד לוח אבן שעליו אותו צו כתוב בהירוגליפים, בדמוטית ביוונית. בעזרת הטקסט היווני פיענח ז׳אן־פרנסואה שמפוליון ב־1822 את ההירוגליפים, ופתח את הדרך להבנת מצרים העתיקה.",
    "rank": 85
  },
  {
    "id": "anc_hagiasophia",
    "deck": "anchors",
    "title": "בניית איה סופיה",
    "start": 537,
    "end": 537,
    "date": "537 לספירה",
    "place": "איסטנבול, טורקיה",
    "lat": 41.0086,
    "lon": 28.9802,
    "desc": "הקיסר יוסטיניאנוס הראשון הזמין מהאדריכלים איזידורוס מן מילטוס ואנתמיוס מטראלס כנסייה עצומה בבירה, וזו נבנתה תוך כחמש שנים. כיפתה הענקית נתמכת בתומכות ובקמרונות, והייתה אחד הישגי ההנדסה הגדולים. היא שימשה כנסייה, מסגד ומוזיאון.",
    "rank": 86
  },
  {
    "id": "anc_vaccine",
    "deck": "anchors",
    "title": "החיסון הראשון נגד אבעבועות שחורות",
    "start": 1796,
    "end": 1796,
    "date": "1796",
    "place": "ברקלי, אנגליה",
    "lat": 51.69,
    "lon": -2.46,
    "desc": "הרופא הכפרי אדוארד ג׳נר חיסן ילד בחומר מפצעי אבעבועות הפרות, ואחר כך הראה שהילד חסין מפני אבעבועות שחורות. השיטה התפשטה ברחבי העולם, ובשנת 1980 הוכרזה המחלה כמחוסלת. זו הייתה המחלה האנושית הראשונה שחוסלה.",
    "rank": 87
  },
  {
    "id": "anc_tours",
    "deck": "anchors",
    "title": "קרב פואטייה",
    "start": 732,
    "end": 732,
    "date": "732 לספירה",
    "place": "פואטייה, צרפת",
    "lat": 46.7,
    "lon": 0.5,
    "desc": "צבא של קרל מרטל ניצח כוח מוסלמי בהנהגת עבד אל־רחמן על הגבול בין צפון לדרום צרפת, בנקודה שאינה ידועה במדויק. הקרב נחשב לעצירת ההתפשטות המוסלמית בצפון אירופה, אף שחוקרים מדגישים שהיה פשיטה ולא כיבוש. עליית כוחו של בית קרל נבעה גם מכך.",
    "rank": 88
  },
  {
    "id": "anc_turkey",
    "deck": "anchors",
    "title": "הכרזת הרפובליקה של טורקיה",
    "start": 1923,
    "end": 1923,
    "date": "1923",
    "place": "אנקרה, טורקיה",
    "lat": 39.93,
    "lon": 32.86,
    "desc": "מוסטפא כמאל אתאטורק, מצביא שניצח ביוון אחרי התפרקות האימפריה העות׳מאנית, הכריז על הרפובליקה והפך לנשיאה הראשון. תוך שנים אחדות ביטל את החליפות, הנהיג כתב לטיני והכניס מערכת משפט חילונית. טורקיה המודרנית נבנתה על מפעלו.",
    "rank": 89
  },
  {
    "id": "anc_qin",
    "deck": "anchors",
    "title": "איחוד סין בידי צ׳ין",
    "start": -221,
    "end": -221,
    "date": "221 לפנה״ס",
    "place": "שיאניאנג, סין",
    "lat": 34.33,
    "lon": 108.71,
    "desc": "מלך מדינת צ׳ין סיים כמאתיים וחמישים שנות מלחמות בין ממלכות ונקרא צ׳ין שי הואנג, הקיסר הראשון. הוא איחד משקולות, מדידות, מטבעות וכתב, והקים מנגנון ריכוזי. שלטונו הקשה נמשך שנים ספורות, אך מבנה האימפריה נשאר דגם לשושלות הסיניות הבאות.",
    "rank": 90
  },
  {
    "id": "anc_jamestown",
    "deck": "anchors",
    "title": "ייסוד ג׳יימסטאון",
    "start": 1607,
    "end": 1607,
    "date": "1607",
    "place": "ג׳יימסטאון, וירג׳יניה",
    "lat": 37.21,
    "lon": -76.78,
    "desc": "מתיישבים אנגלים של חברת וירג׳יניה הקימו את ג׳יימסטאון, היישוב האנגלי הקבוע הראשון בצפון אמריקה. הם סבלו מרעב ומחלות ובסכסוכים עם שבטי הפובהטן. גידול הטבק הציל את המושבה כלכלית, וממנה צמחו מושבות נוספות שהפכו לארצות הברית.",
    "rank": 91
  },
  {
    "id": "anc_schism",
    "deck": "anchors",
    "title": "הפילוג הגדול בין הכנסייה המזרחית למערבית",
    "start": 1054,
    "end": 1054,
    "date": "1054",
    "place": "קונסטנטינופול, האימפריה הביזנטית",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "שליח האפיפיור הניח בכנסיית איה סופיה גזר חרם נגד הפטריארך מיכאל קרולריוס, והפטריארך הנחית חרם נגדו. סכסוכים על סמכות האפיפיור ועל נוסח האמונה העמיקו את הנתק בין הנצרות הלטינית לנצרות האורתודוקסית. הפילוג נשאר בעינו עד היום.",
    "rank": 92
  },
  {
    "id": "anc_meiji",
    "deck": "anchors",
    "title": "שיקום מייג׳י",
    "start": 1868,
    "end": 1868,
    "date": "1868",
    "place": "קיוטו, יפן",
    "lat": 35.01,
    "lon": 135.77,
    "desc": "קבוצת שליטים צעירים הדיחו את השוגון, החזירו את הכוח הפוליטי לקיסר מייג׳י והעבירו את הבירה לטוקיו. בתוך עשורים בנתה יפן צבא, תעשייה, מערכת חינוך ושלטון חוק מערביים, והפכה למעצמה היחידה שאינה אירופית או אמריקנית.",
    "rank": 93
  },
  {
    "id": "anc_actium",
    "deck": "anchors",
    "title": "קרב אקטיום",
    "start": -31,
    "end": -31,
    "date": "31 לפנה״ס",
    "place": "אקטיום, יוון",
    "lat": 38.93,
    "lon": 20.76,
    "desc": "אוקטביאנוס הביס בים את צי אנטוניוס וקלאופטרה, מלכת מצרים. השניים נמלטו למצרים והתאבדו שנה אחר כך, ומצרים הפכה לפרובינציה רומית. אוקטביאנוס קיבל את התואר אוגוסטוס ושם קץ למאה שנות מלחמות אזרחים, והחל עידן הקיסרות.",
    "rank": 94
  },
  {
    "id": "anc_tenochtitlan",
    "deck": "anchors",
    "title": "ייסוד טנוצ׳טיטלן",
    "start": 1325,
    "end": 1325,
    "date": "בערך 1325",
    "place": "מקסיקו סיטי, מקסיקו",
    "lat": 19.43,
    "lon": -99.13,
    "desc": "לפי המסורת האצטקית, בני המשיקה מצאו נשר על קקטוס באי באגם טקסקוקו, ובנו שם את עירם. טנוצ׳טיטלן גדלה לאחת הערים הגדולות בעולם ולבירת אימפריה אצטקית שהשתרעה על מרכז מקסיקו. כיום שוכנת על אתרה מקסיקו סיטי.",
    "rank": 95
  },
  {
    "id": "anc_carthage",
    "deck": "anchors",
    "title": "הקמת קרתגו",
    "start": -814,
    "end": -814,
    "date": "בערך 814 לפנה״ס",
    "place": "קרתגו, תוניסיה",
    "lat": 36.853,
    "lon": 10.323,
    "desc": "לפי המסורת הקימו מתיישבים פיניקים מצור את קרתגו בחוף תוניסיה, ושמה פירושו העיר החדשה. מעיר נמל קטנה היא הפכה לאימפריה ימית שהתחרתה ברומא על השליטה בים התיכון המערבי. התאריך מבוסס על מסורת יוונית ורומית, והחפירות מעידות על יישוב מן המאה ה־8 לפנה״ס.",
    "rank": 96
  },
  {
    "id": "anc_slavery1619",
    "deck": "anchors",
    "title": "בואם של האפריקאים הראשונים לווירג׳יניה",
    "start": 1619,
    "end": 1619,
    "date": "1619",
    "place": "פוינט קומפורט, וירג׳יניה",
    "lat": 37,
    "lon": -76.31,
    "desc": "ספינה שהביאה כעשרים אפריקאים משועבדים עגנה בוירג׳יניה האנגלית. מדובר בראשיתה של העבדות באמריקה הצפונית האנגלית, שהתרחבה בהמשך למוסד שהתבסס על מיליוני בני אדם. רשת הסחר בעבדים חיברה את אפריקה, אמריקה ואירופה במשך כמאתיים וחמישים שנה.",
    "rank": 97
  },
  {
    "id": "anc_salamis",
    "deck": "anchors",
    "title": "קרב סלמיס",
    "start": -480,
    "end": -480,
    "date": "480 לפנה״ס",
    "place": "סלמיס, יוון",
    "lat": 37.94,
    "lon": 23.51,
    "desc": "הצי היווני בהנהגת תמיסטוקלס פיתה את צי פרס למים הצרים בין האי סלמיס ליבשה, והטריאמות היווניות הקלות הכריעו את הספינות הפרסיות הרבות. כסרכסס נסוג עם רוב צבאו, וכוחו נפגע קשות. הניצחון הציל את יוון מכיבוש ושמר על התפתחות התרבות המערבית.",
    "rank": 98
  },
  {
    "id": "anc_baghdad1258",
    "deck": "anchors",
    "title": "נפילת בגדאד לידי המונגולים",
    "start": 1258,
    "end": 1258,
    "date": "1258",
    "place": "בגדאד, עיראק",
    "lat": 33.31,
    "lon": 44.36,
    "desc": "צבא מונגולי בפיקוד הולאגו, נכדו של צ׳ינגיס חאן, כבש את בגדאד אחרי מצור קצר. החליף העבאסי אל־מוסתעצם הוצא להורג, ואלפים רבים מתושבי העיר נהרגו. בכך תמה כהונתם של החליפים העבאסים כשליטים של העולם המוסלמי, ובגדאד איבדה את מעמדה.",
    "rank": 99
  },
  {
    "id": "anc_www",
    "deck": "anchors",
    "title": "האתר הראשון באינטרנט",
    "start": 1991,
    "end": 1991,
    "date": "1991",
    "place": "ז׳נבה, שווייץ",
    "lat": 46.23,
    "lon": 6.05,
    "desc": "טים ברנרס־לי, חוקר במעבדה האירופית לפיזיקת חלקיקים סרן, פיתח את הרשת העולמית, בה מסמכים מקושרים זה לזה באמצעות קישורים. האתר הראשון עלה ב־1991, וב־1993 החליט המרכז לשחרר את הטכנולוגיה לשימוש חופשי. תוך שנים אחדות חיברה הרשת מיליארדי אנשים.",
    "rank": 100
  },
  {
    "id": "anc_cyrus",
    "deck": "anchors",
    "title": "כיבוש בבל בידי כורש",
    "start": -539,
    "end": -539,
    "date": "539 לפנה״ס",
    "place": "בבל, מסופוטמיה",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "כורש השני, מלך פרס, כבש את בבל ללא קרב כבד וצירף אותה לאימפריה האחמנית, הגדולה בעולם עד אז. על גליל חרס הכריז על כיבוד אלי הנכבשים, והמקרא מספר שאִפשר ליהודים לשוב לציון. השליטה הפרסית הכירה בגיוון תרבותי ושימשה מודל לשלטון אימפריאלי סובלני יחסית.",
    "rank": 101
  },
  {
    "id": "anc_cajamarca",
    "deck": "anchors",
    "title": "לכידת אטאוואלפה בקחמרקה",
    "start": 1532,
    "end": 1532,
    "date": "1532",
    "place": "קחמרקה, פרו",
    "lat": -7.16,
    "lon": -78.51,
    "desc": "פרנסיסקו פיסארו וכמאה וחמישים חיילים ספרדים אחזו במארב ולכדו את שליט האינקה אטאוואלפה בעיר קחמרקה, והרגו אלפים מאנשיו. אטאוואלפה שילם כופר גדול בזהב וכסף ובכל זאת הוצא להורג. האימפריה, שנפגעה גם ממלחמת אחים ומאבעבועות, קרסה בתוך שנים.",
    "rank": 102
  },
  {
    "id": "anc_baghdad",
    "deck": "anchors",
    "title": "ייסוד בגדאד",
    "start": 762,
    "end": 762,
    "date": "762 לספירה",
    "place": "בגדאד, עיראק",
    "lat": 33.31,
    "lon": 44.36,
    "desc": "הח׳ליף העבאסי אבו ג׳עפר אל־מנצור הקים עיר חדשה עגולה על נהר החידקל. בגדאד הפכה לבירת הח׳ליפות ולמרכז של מדע, תרגומים וספרות. בהמשך הוקם בה בית החוכמה, והיא נשארה העיר המרכזית בעולם האסלאם כחמש מאות שנה.",
    "rank": 103
  },
  {
    "id": "anc_opiumwar",
    "deck": "anchors",
    "title": "מלחמת האופיום הראשונה",
    "start": 1839,
    "end": 1842,
    "date": "⁦1839–1842⁩",
    "place": "גואנגג׳ואו, סין",
    "lat": 23.13,
    "lon": 113.26,
    "desc": "סין ניסתה לעצור את הברחת האופיום שהביאו סוחרים בריטים, ובריטניה הגיבה במלחמה. הצי הבריטי ניצח, וההסכם בנאנג׳ינג כפה על סין לוותר על הונג קונג ולפתוח נמלים. הוא פתח את מה שסינים מכנים מאה השפלה.",
    "rank": 104
  },
  {
    "id": "anc_karbala",
    "deck": "anchors",
    "title": "קרב כרבלא",
    "start": 680,
    "end": 680,
    "date": "680 לספירה",
    "place": "כרבלא, עיראק",
    "lat": 32.61,
    "lon": 44.03,
    "desc": "חוסיין בן עלי, נכדו של מוחמד, ומשפחתו נהרגו בידי כוחות הח׳ליף היזיד הראשון. האירוע העמיק את הפילוג בין השיעים לסונים, והוא מונצח בעשוראא. כרבלא נשארה אתר עלייה לרגל מרכזי בעולם השיעי.",
    "rank": 105
  },
  {
    "id": "anc_tordesillas",
    "deck": "anchors",
    "title": "הסכם טורדסיליאס",
    "start": 1494,
    "end": 1494,
    "date": "1494",
    "place": "טורדסיליאס, ספרד",
    "lat": 41.5,
    "lon": -5,
    "desc": "ספרד ופורטוגל חילקו ביניהן בהסכם את העולם שמחוץ לאירופה בקו דמיוני באוקיינוס האטלנטי, בתיווך האפיפיור. מערבו הוקצה לספרד, מזרחו לפורטוגל. לכן מדברים ברזיל בפורטוגלית ושאר דרום אמריקה בספרדית. עמי הארצות עצמם לא נשאלו.",
    "rank": 106
  },
  {
    "id": "anc_republic",
    "deck": "anchors",
    "title": "הקמת הרפובליקה הרומית",
    "start": -509,
    "end": -509,
    "date": "בערך 509 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "לפי המסורת גירשו הרומים את המלך האחרון טרקווין הגאה, והחליפו אותו בשני קונסולים שנבחרו לשנה. הרפובליקה פיתחה סנאט, אסיפות ושופטים, והפכה לכוח השולט באיטליה ומאוחר יותר בים התיכון. הדעות בין החוקרים חלוקות בשאלה כמה מהסיפור היסטורי, והתאריך מסורתי.",
    "rank": 107
  },
  {
    "id": "anc_ming",
    "deck": "anchors",
    "title": "הקמת שושלת מינג",
    "start": 1368,
    "end": 1368,
    "date": "1368",
    "place": "נאנג׳ינג, סין",
    "lat": 32.06,
    "lon": 118.8,
    "desc": "ג׳ו יואנג׳אנג, בן איכרים שהפך למנהיג מורדים, הכריז על עצמו קיסר בשם הונגוו והדיח את שושלת יואן המונגולית מסין. שושלת מינג שלטה כשלוש מאות שנה. בתקופתה נבנו החומה הגדולה בצורתה המוכרת והעיר האסורה, והמדינה פרחה כלכלית ותרבותית.",
    "rank": 108
  },
  {
    "id": "anc_akhenaten",
    "deck": "anchors",
    "title": "המהפכה הדתית של אחנאתן",
    "start": -1350,
    "end": -1350,
    "date": "בערך 1350 לפנה״ס",
    "place": "אמרנה, מצרים",
    "lat": 27.645,
    "lon": 30.9,
    "desc": "הפרעה אחנאתן ניסה להעמיד את אל השמש אתון במקום שאר האלים, הקים בירה חדשה באמרנה ועודד סגנון אמנות מציאותי יותר. אחרי מותו חזרו המצרים לאלים הקודמים ומחקו את זכרו, ובין היורשים היה בנו תותענחאמון. חלק מהחוקרים רואים בכך צעד ראשון לקראת אמונה באל אחד.",
    "rank": 109
  },
  {
    "id": "anc_angkor",
    "deck": "anchors",
    "title": "ייסוד האימפריה החמרית",
    "start": 802,
    "end": 802,
    "date": "802 לספירה",
    "place": "אנגקור, קמבודיה",
    "lat": 13.57,
    "lon": 104.07,
    "desc": "ג׳יוורמן השני הכריז על עצמו כמלך עולם ומייסד האימפריה החמרית בהר קולן. בהמשך נבנו בירות ומקדשים, ובהם אנגקור ואט. האימפריה שלטה בדרום מזרח אסיה לאורך שש מאות שנה, ופיתחה מערכת השקיה מורכבת.",
    "rank": 110
  },
  {
    "id": "anc_benz",
    "deck": "anchors",
    "title": "הרכב המנועי של קרל בנץ",
    "start": 1886,
    "end": 1886,
    "date": "1886",
    "place": "מנהיים, גרמניה",
    "lat": 49.49,
    "lon": 8.47,
    "desc": "קרל בנץ, מהנדס גרמני, קיבל פטנט על כלי רכב בעל שלושה גלגלים שהונע במנוע בעירה פנימית, והוא נחשב לרכב הראשון שיוצר כמוצר. לאחר מכן התפתחה תעשיית הרכב, ששינתה את הערים, התחבורה והחיים בכל העולם.",
    "rank": 111
  },
  {
    "id": "anc_justinianplague",
    "deck": "anchors",
    "title": "מגפת יוסטיניאנוס",
    "start": 541,
    "end": 541,
    "date": "541 לספירה",
    "place": "פלוסיון, מצרים",
    "lat": 31.03,
    "lon": 32.55,
    "desc": "מגפה פרצה בנמל פלוסיון שבדלתא של הנילוס, והגיעה לקונסטנטינופול ב־542 ולמדינות רבות באגן הים התיכון. מחקרי דנ״א זיהו שהמחלה הייתה דבר שנגרם מחיידק הירסיניה. המגפה גבתה מאות אלפי קורבנות והחלישה את האימפריה הביזנטית.",
    "rank": 112
  },
  {
    "id": "anc_zhenghe",
    "deck": "anchors",
    "title": "מסעות האוניות של ג׳נג הה",
    "start": 1405,
    "end": 1433,
    "date": "⁦1405–1433⁩",
    "place": "נאנג׳ינג, סין",
    "lat": 31.45,
    "lon": 121.1,
    "desc": "האדמירל המוסלמי ג׳נג הה הוביל מטעם קיסרי מינג שבעה מסעות ימיים עם מאות אוניות וכ־27 אלף איש. הצי הגיע להודו, לחצי האי ערב ולחופי מזרח אפריקה. אחרי המסעות ויתרה סין על משלחות כאלה, ושנים אחר כך החלו האירופים בחקר ימי משלהם.",
    "rank": 113
  },
  {
    "id": "anc_paper",
    "deck": "anchors",
    "title": "המצאת הנייר בסין",
    "start": 105,
    "end": 105,
    "date": "בערך 105 לספירה",
    "place": "לויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "לפי הדיווח הרשמי הציג יועץ החצר צאי לון לקיסר נייר העשוי מקליפות עץ, סמרטוטים ורשתות דיג. ממצאים ארכאולוגיים מעידים שנייר כזה היה קיים קודם, אך צאי לון שיפר ותקנן אותו. הנייר היה זול וקל מבמבוק ומשי, והפך מאוחר יותר לבסיס להפצת ספרים בעולם.",
    "rank": 114
  },
  {
    "id": "anc_cordoba",
    "deck": "anchors",
    "title": "ח׳ליפות קורדובה",
    "start": 929,
    "end": 929,
    "date": "929 לספירה",
    "place": "קורדובה, ספרד",
    "lat": 37.88,
    "lon": -4.78,
    "desc": "עבד אל־רחמן השלישי הכריז על עצמו כח׳ליף באנדלוס והפך את קורדובה לאחת הערים המפוארות באירופה, עם ספריות, בתי ספר ומסגד גדול. התקופה נחשבת לתור זהב של מדע, רפואה ופילוסופיה, שבו חיו יחד מוסלמים, יהודים ונוצרים.",
    "rank": 115
  },
  {
    "id": "anc_longmarch",
    "deck": "anchors",
    "title": "המצעד הארוך בסין",
    "start": 1934,
    "end": 1935,
    "date": "⁦1934–1935⁩",
    "place": "רואיג׳ין, סין",
    "lat": 25.88,
    "lon": 116.03,
    "desc": "הצבא האדום הקומוניסטי נסוג מבסיסו בדרום סין לאחר מצור של הכוחות הלאומנים, ועבר כ־9,000 קילומטרים במשך שנה בהרים ובנהרות. רק חלק קטן מהלוחמים שרד. במהלך המצעד עלה מאו דזה־דונג למנהיגות המפלגה, ותנועתו ניצחה בסופו של דבר ב־1949.",
    "rank": 116
  },
  {
    "id": "anc_benedict",
    "deck": "anchors",
    "title": "מנזר מונטה קסינו",
    "start": 529,
    "end": 529,
    "date": "בערך 529 לספירה",
    "place": "מונטה קסינו, איטליה",
    "lat": 41.49,
    "lon": 13.814,
    "desc": "בנדיקטוס מנורסיה ייסד מנזר על הר בדרום איטליה, וכתב את כלל המנזר המסדיר חיים של תפילה, עבודה ולימוד. הכלל התפשט לאלפי מנזרים באירופה, ששימרו כתבים עתיקים ושימשו מרכזי חקלאות וחינוך בימי הביניים המוקדמים.",
    "rank": 117
  },
  {
    "id": "anc_yuan",
    "deck": "anchors",
    "title": "הקמת שושלת יואן בסין",
    "start": 1271,
    "end": 1271,
    "date": "1271",
    "place": "בייג׳ינג, סין",
    "lat": 39.91,
    "lon": 116.39,
    "desc": "קובלאי חאן, נכדו של צ׳ינגיס חאן, הכריז על שושלת יואן ובנה בדאדו, היא בייג׳ינג, בירה חדשה. עד 1279 השלים את כיבוש דרום סין של שושלת סונג, וכך איחד לראשונה את כל סין תחת שלטון זר. תחת שלטונו פרח המסחר לאורך דרך המשי.",
    "rank": 118
  },
  {
    "id": "anc_kadesh",
    "deck": "anchors",
    "title": "קרב קדש",
    "start": -1274,
    "end": -1274,
    "date": "בערך 1274 לפנה״ס",
    "place": "קדש, סוריה",
    "lat": 34.57,
    "lon": 36.51,
    "desc": "צבאות רעמסס השני מצרים ומוואטלי השני מחתי נפגשו ליד העיר קדש על נהר האורונטס, בקרב המרכבות הגדול בעת העתיקה. שני הצדדים ייחסו לעצמם ניצחון, ואחר כך נחתם הסכם שלום שנשמר בנוסחים מצרי וחתי, מן הראשונים הידועים בהיסטוריה.",
    "rank": 119
  },
  {
    "id": "anc_lindisfarne",
    "deck": "anchors",
    "title": "פשיטת הוויקינגים על לינדיספרן",
    "start": 793,
    "end": 793,
    "date": "793 לספירה",
    "place": "לינדיספרן, אנגליה",
    "lat": 55.67,
    "lon": -1.8,
    "desc": "ספינות נורדיות תקפו את המנזר על האי הקדוש ביותר בנורת׳מברי ובזזו אותו. האירוע זעזע את אירופה הנוצרית ולרוב נחשב לפתיחה של עידן הוויקינגים. בעקבותיו יצאו מסעות של פשיטות, מסחר והתיישבות שהגיעו עד איסלנד, רוסיה וצפון אמריקה.",
    "rank": 120
  },
  {
    "id": "anc_railway",
    "deck": "anchors",
    "title": "הרכבת הנוסעים הראשונה בין ערים",
    "start": 1830,
    "end": 1830,
    "date": "1830",
    "place": "ליברפול, אנגליה",
    "lat": 53.41,
    "lon": -2.99,
    "desc": "קו הרכבת בין ליברפול למנצ׳סטר נפתח כקו הנוסעים הראשון שכל הקרונות בו נגררו בקטרי קיטור. הקו הוכיח שאפשר להסיע אנשים וסחורות מהר וזול. בתוך עשורים כיסו מסילות ברזל את בריטניה, אירופה, צפון אמריקה והודו.",
    "rank": 121
  },
  {
    "id": "anc_nicaea",
    "deck": "anchors",
    "title": "הוועידה הנוצרית בניקיאה",
    "start": 325,
    "end": 325,
    "date": "325 לספירה",
    "place": "ניקיאה, טורקיה",
    "lat": 40.43,
    "lon": 29.72,
    "desc": "הקיסר קונסטנטינוס כינס כמה מאות בישופים כדי ליישב את המחלוקת בין אריוס, שטען שישו נברא, לבין מתנגדיו. הוועידה קבעה נוסח אמונה שקבע שהבן בעל אותה מהות כמו האב. זו הוועידה האקומנית הראשונה, והיא חיזקה את הקשר בין הכנסייה לשלטון הקיסרי.",
    "rank": 122
  },
  {
    "id": "anc_canon",
    "deck": "anchors",
    "title": "הקאנון ברפואה של אבן סינא",
    "start": 1025,
    "end": 1025,
    "date": "בערך 1025",
    "place": "המדאן, פרס",
    "lat": 34.8,
    "lon": 48.51,
    "desc": "הרופא והפילוסוף הפרסי אבן סינא, המוכר באירופה בשם אביצנה, השלים את ספר הקאנון ברפואה. החיבור סיכם את הידע הרפואי של יוון והעולם המוסלמי במערכת מסודרת אחת. במשך כחמש מאות שנה שימש ספר הלימוד המרכזי בבתי ספר לרפואה במזרח ובאירופה.",
    "rank": 123
  },
  {
    "id": "anc_attila",
    "deck": "anchors",
    "title": "קרב מישורי קטלאוניה",
    "start": 451,
    "end": 451,
    "date": "451 לספירה",
    "place": "שאלון, צרפת",
    "lat": 48.96,
    "lon": 4.37,
    "desc": "כוח רומי וגותי בראשות אטיוס וממלך הוויזיגותים תאודוריק הראשון עצר את צבא האנים של אטילה בצפון גאליה. תאודוריק נהרג, ואטילה נסוג, אך שנה אחר כך פלש לאיטליה. מיקום הקרב המדויק אינו ברור.",
    "rank": 124
  },
  {
    "id": "anc_vladimir",
    "deck": "anchors",
    "title": "התנצרות רוסיה של קייב",
    "start": 988,
    "end": 988,
    "date": "בערך 988 לספירה",
    "place": "קייב, אוקראינה",
    "lat": 50.45,
    "lon": 30.52,
    "desc": "הנסיך ולדימיר הראשון של קייב אימץ את הנצרות הביזנטית והורה להטביל את אנשיו בנהר הדנייפר. כך נקשרה רוסיה של קייב לעולם הנוצרי המזרחי ולתרבותו, וכתב הקירילי והספרות הכנסייתית התפשטו בארצות הסלאבים המזרחיים.",
    "rank": 125
  },
  {
    "id": "anc_teotihuacan",
    "deck": "anchors",
    "title": "פירמידת השמש בטאוטיוואקאן",
    "start": 100,
    "end": 100,
    "date": "בערך 100 לספירה",
    "place": "טאוטיוואקאן, מקסיקו",
    "lat": 19.692,
    "lon": -98.844,
    "desc": "בעמק מקסיקו קמה טאוטיוואקאן, אחת הערים הגדולות בעולם בזמנה, עם רחוב המתים ושתי פירמידות ענק. פירמידת השמש, בגובה של 65 מטר, נבנתה סביב שנת 100. איש אינו יודע איך נקרא העם שבנה אותה, והאצטקים נתנו לעיר את שמה כשמצאו חורבות.",
    "rank": 126
  },
  {
    "id": "anc_khwarizmi",
    "deck": "anchors",
    "title": "בית החוכמה והאלגברה של אל־ח׳וארזמי",
    "start": 820,
    "end": 820,
    "date": "בערך 820 לספירה",
    "place": "בגדאד, עיראק",
    "lat": 33.31,
    "lon": 44.36,
    "desc": "מוחמד אבן מוסא אל־ח׳וארזמי עבד בבית החוכמה בבגדאד וחיבר ספר על חישוב בדרך השלמה ואיזון, שממנו נגזרה המילה אלגברה. ספר נוסף שלו הציג את המספרים ההודיים בשיטה העשרונית, ושמו יצר את המונח אלגוריתם.",
    "rank": 127
  },
  {
    "id": "anc_milan",
    "deck": "anchors",
    "title": "צו מילאנו",
    "start": 313,
    "end": 313,
    "date": "313 לספירה",
    "place": "מילאנו, איטליה",
    "lat": 45.465,
    "lon": 9.19,
    "desc": "הקיסרים קונסטנטינוס וליקיניוס הסכימו על מדיניות סובלנות כלפי הנוצרים ודתות אחרות, והחזירו רכוש שנלקח. אחרי עשרות שנות רדיפות הפכה הנצרות לדת חוקית. קונסטנטינוס עצמו תמך בה בהדרגה, והדבר סלל את דרכה להיות דת הקיסרות.",
    "rank": 128
  },
  {
    "id": "anc_ainjalut",
    "deck": "anchors",
    "title": "קרב עין ג׳אלות",
    "start": 1260,
    "end": 1260,
    "date": "1260",
    "place": "עין ג׳אלות, ארץ ישראל",
    "lat": 32.55,
    "lon": 35.35,
    "desc": "צבא ממלוכי בפיקוד קוטוז ובייברס פגש כוח מונגולי קטן יחסית של קיטבוקה בעמק יזרעאל והביס אותו. זו הייתה אחת התבוסות הגדולות הראשונות של המונגולים, וחסמה את התפשטותם דרומה אל מצרים. הממלוכים נהפכו לכוח הדומיננטי באזור.",
    "rank": 129
  },
  {
    "id": "anc_gaugamela",
    "deck": "anchors",
    "title": "קרב גאוגמלה",
    "start": -331,
    "end": -331,
    "date": "331 לפנה״ס",
    "place": "גאוגמלה, עיראק",
    "lat": 36.56,
    "lon": 43.45,
    "desc": "אלכסנדר מוקדון הביס את דריווש השלישי בשדה פתוח, אף שצבא פרס היה גדול בהרבה. אחרי הקרב ברח דריווש, ואלכסנדר כבש את בבל ואת שושן ופרספוליס. הניצחון סימן את קץ האימפריה האחמנית ופתח עידן הלניסטי שבו תרבות יוון התפשטה עד הודו.",
    "rank": 130
  },
  {
    "id": "anc_borobudur",
    "deck": "anchors",
    "title": "הקמת בורובודור",
    "start": 800,
    "end": 800,
    "date": "בערך 800 לספירה",
    "place": "מרכז ג׳אווה, אינדונזיה",
    "lat": -7.608,
    "lon": 110.204,
    "desc": "בעת שלטון שושלת שיילנדרה נבנה בג׳אווה מקדש בודהיסטי ענקי בצורת מנדלה עם תבליטים רבים. הבנייה הושלמה כנראה בתחילת המאה ה־9. המקדש נעזב ונקבר בהמשך, והוא הגדול בעולם מסוגו.",
    "rank": 131
  },
  {
    "id": "anc_ghana",
    "deck": "anchors",
    "title": "עצמאות גאנה",
    "start": 1957,
    "end": 1957,
    "date": "1957",
    "place": "אקרה, גאנה",
    "lat": 5.56,
    "lon": -0.2,
    "desc": "קוואמה נקרומה הוביל את גאנה לעצמאות מבריטניה, והיא הייתה המושבה הראשונה באפריקה שמדרום לסהרה שהשיגה אותה. האירוע עורר תקווה בקרב תנועות לשחרור ברחבי אפריקה. תוך שלושה עשורים השיגו כמעט כל מדינות היבשת עצמאות מהאימפריות האירופיות.",
    "rank": 132
  },
  {
    "id": "anc_mohenjodaro",
    "deck": "anchors",
    "title": "תרבות עמק האינדוס בשיאה",
    "start": -2500,
    "end": -2500,
    "date": "בערך 2500 לפנה״ס",
    "place": "מוהנג׳ו־דארו, פקיסטן",
    "lat": 27.329,
    "lon": 68.135,
    "desc": "לאורך נהר האינדוס קמו ערים מתוכננות ובהן מוהנג׳ו־דארו, עם רחובות בצורת רשת, מערכות ניקוז וחדרי רחצה בבתים. התרבות סחרה עם מסופוטמיה והשתמשה בחותמות עם כתב שטרם פוענח. סיבות ירידתה, כנראה שינויי אקלים ושינוי מסלולי הנהרות, עדיין שנויות במחלוקת.",
    "rank": 133
  },
  {
    "id": "anc_tang",
    "deck": "anchors",
    "title": "הקמת שושלת טאנג",
    "start": 618,
    "end": 618,
    "date": "618 לספירה",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.95,
    "desc": "לי יואן הכריז על עצמו כקיסר וייסד את שושלת טאנג, אחת התקופות המבריקות של סין. בירתה צ׳אנגאן הייתה אולי העיר הגדולה בעולם, פתוחה לסוחרים, לנזירים ולשליחים מכל אסיה. בתקופה זו פרחו השירה, הדפוס והתפתח הסחר בדרך המשי.",
    "rank": 134
  },
  {
    "id": "anc_haiti",
    "deck": "anchors",
    "title": "המרד בסן דומינג",
    "start": 1791,
    "end": 1791,
    "date": "1791",
    "place": "קאפ־אית׳יין, האיטי",
    "lat": 19.76,
    "lon": -72.2,
    "desc": "עבדים במושבה הצרפתית העשירה סן דומינג, בעיקר בהנהגת טוסן לוברטיר, יצאו למרד גדול בשדות הסוכר. אחרי שנים של לחימה מול הצרפתים, האנגלים והספרדים הוכרזה ב־1804 עצמאות האיטי, הרפובליקה השחורה הראשונה. זה המרד היחיד של עבדים שהצליח להקים מדינה.",
    "rank": 135
  },
  {
    "id": "anc_zama",
    "deck": "anchors",
    "title": "קרב זאמה",
    "start": -202,
    "end": -202,
    "date": "בערך 202 לפנה״ס",
    "place": "זאמה, צפון אפריקה",
    "lat": 36.08,
    "lon": 9.37,
    "desc": "סקיפיו אפריקנוס ניצח בקרב את חניבעל, מצביא קרתגו, וחתם את המלחמה הפונית השנייה. קרתגו איבדה את כוחה הצבאי ואת שטחי הים שלה, ורומא הפכה לשליטה הבלתי מעורערת בים התיכון המערבי. מיקום הקרב המדויק אינו ידוע.",
    "rank": 136
  },
  {
    "id": "anc_genji",
    "deck": "anchors",
    "title": "סיפור גנג׳י",
    "start": 1008,
    "end": 1008,
    "date": "בערך 1008",
    "place": "קיוטו, יפן",
    "lat": 35.01,
    "lon": 135.77,
    "desc": "האשה האצילה מוראסאקי שיקיבו, מגברות החצר בתקופת הייאן, כתבה את סיפור גנג׳י על חיי הנסיך המבריק גנג׳י ועל נאהביו. זהו אחד הרומנים הארוכים והמפורסמים הראשונים בתולדות הספרות, והוא נחשב ליצירת המופת של הספרות היפנית. הכתיבה מתוארכת לראשית המאה האחת עשרה.",
    "rank": 137
  },
  {
    "id": "anc_cleisthenes",
    "deck": "anchors",
    "title": "הרפורמה הדמוקרטית של קליסתנס",
    "start": -508,
    "end": -508,
    "date": "508 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "קליסתנס חילק את אזרחי אתונה לפי אזורי מגורים ולא לפי שושלות אצולה, והקים מועצה של חמש מאות נציגים שנבחרו בהגרלה. אסיפת העם קיבלה כוח של ממש. זו נקודת ההתחלה של הדמוקרטיה האתונאית, ומערכת שלטון שבה אזרחים החליטו ישירות.",
    "rank": 138
  },
  {
    "id": "anc_grandcanal",
    "deck": "anchors",
    "title": "התעלה הגדולה של סין",
    "start": 605,
    "end": 611,
    "date": "⁦605–611⁩ לספירה",
    "place": "לויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "הקיסר יאנג משושלת סוי גייס מיליוני עובדים כדי לחבר בין נהר הצהוב לנהר היאנגצה. התעלה, שהורחבה בהמשך לאורך 1,800 ק״מ, אפשרה העברת אורז מהדרום לצפון ופעלה כעורק כלכלי עד העת החדשה. המאמץ הכביד על האוכלוסייה והביא לנפילת השושלת.",
    "rank": 139
  },
  {
    "id": "anc_tokugawa",
    "deck": "anchors",
    "title": "פתיחת שוגונות טוקוגאווה",
    "start": 1603,
    "end": 1603,
    "date": "1603",
    "place": "אדו, יפן",
    "lat": 35.68,
    "lon": 139.76,
    "desc": "טוקוגאווה איאיאסו, שניצח בקרב סקיגהרה, קיבל מהקיסר את התואר שוגון והקים את בירתו באדו, היא טוקיו. שושלתו שלטה ביפן כ־260 שנה בשלום יחסי, בבידוד מהעולם ובמבנה חברתי נוקשה. תקופה זו עיצבה את התרבות היפנית הקלאסית.",
    "rank": 140
  },
  {
    "id": "anc_persepolis",
    "deck": "anchors",
    "title": "שריפת פרספוליס",
    "start": -330,
    "end": -330,
    "date": "330 לפנה״ס",
    "place": "פרספוליס, איראן",
    "lat": 29.935,
    "lon": 52.892,
    "desc": "אחרי ניצחונותיו נכנס אלכסנדר מוקדון לפרספוליס, בירת הטקסים של פרס, ושרף את ארמונה. מקורות עתיקים מספרים שהדבר נעשה בעידוד חגיגי או כנקמה על חורבן אתונה. האירוע סימל את קץ שושלת האחמנים והותיר ממצאים ארכאולוגיים עשירים.",
    "rank": 141
  },
  {
    "id": "anc_palenque",
    "deck": "anchors",
    "title": "קבר פאקאל במקדש הכתובות",
    "start": 683,
    "end": 683,
    "date": "683 לספירה",
    "place": "פלנקה, מקסיקו",
    "lat": 17.485,
    "lon": -92.046,
    "desc": "המלך פאקאל הגדול של פלנקה מת, וקברו הוסתר במקדש שנבנה בצורת פירמידה. הקבר נמצא ב־1952, ובו סרקופג עם תבליט ומסכת ירקן. הכתובות במקדש הן ממקורות החשובים להבנת ההיסטוריה והכתב של המאיה.",
    "rank": 142
  },
  {
    "id": "anc_berlinconf",
    "deck": "anchors",
    "title": "ועידת ברלין",
    "start": 1884,
    "end": 1885,
    "date": "⁦1884–1885⁩",
    "place": "ברלין, גרמניה",
    "lat": 52.52,
    "lon": 13.38,
    "desc": "נציגי מעצמות אירופה נפגשו בברלין כדי להסדיר את חלוקת אפריקה ביניהם, בלי שאף נציג אפריקאי נכח. ההסכמים קבעו כללים ל״כיבוש יעיל״ ופתחו את התחרות על המושבות. תוך שנים אחדות נחלקה כמעט כל היבשת, וגבולות מלאכותיים מהתקופה נשארו.",
    "rank": 143
  },
  {
    "id": "anc_seapeoples",
    "deck": "anchors",
    "title": "מפלתם של עמי הים והמפנה בתקופת הברונזה",
    "start": -1177,
    "end": -1177,
    "date": "בערך 1177 לפנה״ס",
    "place": "מדינת חבו, מצרים",
    "lat": 25.72,
    "lon": 32.601,
    "desc": "בשנת 1177 לפנה״ס הדף רעמסס השלישי התקפת קואליציית עמי הים בדלתא של הנילוס, כפי שנחרט בתבליטי מדינת חבו. סביב אותה תקופה נחרבו אוגרית, החתים ועוד ערים לאורך הים התיכון. הסיבות, ובהן בצורת, רעידות אדמה ותנועות עמים, עדיין נתונות לוויכוח.",
    "rank": 144
  },
  {
    "id": "anc_hangul",
    "deck": "anchors",
    "title": "יצירת האלפבית הקוריאני",
    "start": 1443,
    "end": 1446,
    "date": "⁦1443–1446⁩",
    "place": "סיאול, קוריאה",
    "lat": 37.57,
    "lon": 126.98,
    "desc": "המלך סז׳ונג של שושלת ג׳וסון ופקידי החצר שלו יצרו כתב פשוט שמותאם לצלילי השפה הקוריאנית, כדי שגם פשוטי העם יוכלו לקרוא ולכתוב. עד אז כתבו קוריאנים רק בסינית מסובכת. הכתב הוכרז רשמית ב־1446, והוא משמש עד היום את קוריאה.",
    "rank": 145
  },
  {
    "id": "anc_hatshepsut",
    "deck": "anchors",
    "title": "משלחת המלכה חתשפסות לפונט",
    "start": -1470,
    "end": -1470,
    "date": "בערך 1470 לפנה״ס",
    "place": "דיר אל־בחרי, מצרים",
    "lat": 25.738,
    "lon": 32.607,
    "desc": "המלכה חתשפסות שלחה משלחת ימית לארץ פונט, כנראה באזור הקרן האפריקית, וזו חזרה עם קטורת, עצי מור, זהב ובעלי חיים. הדבר תועד בתבליטים במקדשה בדיר אל־בחרי. המשלחת היא אחד התיעודים הראשונים של מסע חקר ומסחר רחוק ביבשת אפריקה.",
    "rank": 146
  },
  {
    "id": "anc_uthman",
    "deck": "anchors",
    "title": "הנוסח הרשמי של הקוראן",
    "start": 650,
    "end": 650,
    "date": "בערך 650 לספירה",
    "place": "מדינה, ערב הסעודית",
    "lat": 24.47,
    "lon": 39.61,
    "desc": "לפי המסורת המוסלמית הורה הח׳ליף עות׳מאן לאסוף את גרסאות הקוראן ולהכין נוסח אחיד, ולהפיץ עותקים לערים הגדולות. הנוסח התקבל כנוסח הקנוני. הוא שימש בסיס לשפה הערבית הכתובה ולאחדות הדת בשטחים שהלכו והתרחבו.",
    "rank": 147
  },
  {
    "id": "anc_xinhai",
    "deck": "anchors",
    "title": "מהפכת שינהאי",
    "start": 1911,
    "end": 1911,
    "date": "1911",
    "place": "ווהאן, סין",
    "lat": 30.55,
    "lon": 114.3,
    "desc": "מרד חיילים בעיר ווצ׳אנג הפך למהפכה שהתפשטה בכל סין. בראשית 1912 התפטר הקיסר הילד האחרון, וסין הפכה לרפובליקה בהנהגת סון יאט־סן. בכך הסתיימו יותר מאלפיים שנות שלטון קיסרי, ואחריהן באו עשורים של פילוג ומלחמות.",
    "rank": 148
  },
  {
    "id": "anc_thera",
    "deck": "anchors",
    "title": "התפרצות הר הגעש בתרה",
    "start": -1627,
    "end": -1600,
    "date": "בערך ⁦1627–1600⁩ לפנה״ס",
    "place": "תרה, הים האגאי",
    "lat": 36.404,
    "lon": 25.396,
    "desc": "אחת ההתפרצויות הוולקניות החזקות בהיסטוריה העיפה את מרכז האי סנטוריני וכיסתה את אקרוטירי באפר, כך שהעיר נשמרה כפומפיי של הים התיכון. מועד האירוע שנוי במחלוקת בין תיארוך רדיוקרבוני לתיארוך ארכאולוגי. יש חוקרים המקשרים אותו להיחלשות הציביליזציה המינואית בכרתים.",
    "rank": 149
  },
  {
    "id": "anc_plassey",
    "deck": "anchors",
    "title": "קרב פלאסי",
    "start": 1757,
    "end": 1757,
    "date": "1757",
    "place": "פלאסי, בנגל",
    "lat": 23.8,
    "lon": 88.25,
    "desc": "כוחות חברת הודו המזרחית הבריטית בפיקוד רוברט קלייב הביסו את נוואב בנגל סיראג׳ א־דאולה, בעיקר בעזרת בגידת מצביאיו. הניצחון העניק לחברה שליטה בבנגל העשירה והיה צעד ראשון בדרך לשלטון הבריטי בהודו שנמשך כמאתיים שנה.",
    "rank": 150
  },
  {
    "id": "anc_rosetta",
    "deck": "anchors",
    "title": "צו ממפיס ואבן הרוזטה",
    "start": -196,
    "end": -196,
    "date": "196 לפנה״ס",
    "place": "ממפיס, מצרים",
    "lat": 29.85,
    "lon": 31.25,
    "desc": "כוהני מצרים ציינו בצו את מעשי תלמי החמישי, והוא נחרט על אבן בשלושה כתבים: הירוגליפים, דמוטית ויוונית. כשנמצאה האבן ב־1799 במצרים, שימשה את שמפוליון ב־1822 לפענוח ההירוגליפים, והחזירה לאנושות מצרים העתיקה שנדמתה אילמת.",
    "rank": 151
  },
  {
    "id": "anc_timur",
    "deck": "anchors",
    "title": "כיבוש דלהי בידי טימור",
    "start": 1398,
    "end": 1398,
    "date": "1398",
    "place": "דלהי, הודו",
    "lat": 28.61,
    "lon": 77.21,
    "desc": "טימור, שליט מרכז אסיה המכונה תמרלנג, פשט על צפון הודו וכבש את דלהי, בירת הסולטנות. העיר נבזזה ותושבים רבים נטבחו. הפשיטה החלישה את הסולטנות באופן בלתי הפיך, ובכך סללה את הדרך לשושלות חדשות, ובהמשך לשלטון המוגולי.",
    "rank": 152
  },
  {
    "id": "anc_sargon",
    "deck": "anchors",
    "title": "האימפריה האכדית של סרגון",
    "start": -2334,
    "end": -2334,
    "date": "בערך 2334 לפנה״ס",
    "place": "אכד, מסופוטמיה",
    "lat": 33.1,
    "lon": 44.3,
    "desc": "סרגון מאכד איחד את ערי שומר תחת שלטונו ויצר את מה שנחשב לאימפריה הראשונה בהיסטוריה, מהמפרץ הפרסי ועד לבנון. הוא הציב מושלים נאמנים, והאכדית הפכה לשפת המנהל. האימפריה נמשכה כמאה ושמונים שנה, ושם סרגון נשאר סמל למלך כובש. מיקום אכד עצמה אינו ידוע בדיוק.",
    "rank": 153
  },
  {
    "id": "anc_yarmouk",
    "deck": "anchors",
    "title": "קרב ירמוך",
    "start": 636,
    "end": 636,
    "date": "636 לספירה",
    "place": "נהר הירמוך, סוריה",
    "lat": 32.74,
    "lon": 35.97,
    "desc": "צבא מוסלמי בהנהגת ח׳אלד בן אל־ווליד ניצח את הצבא הביזנטי בקרב שנמשך כמה ימים בעמק הירמוך. הניצחון הכריע את גורל סוריה ופתח את הדרך להשתלטות מוסלמית על אזורים בהם שלטה ביזנטיון. תוך עשור נכבשו סוריה, מצרים ופרס.",
    "rank": 154
  },
  {
    "id": "anc_tambora",
    "deck": "anchors",
    "title": "התפרצות הר הגעש טמבורה",
    "start": 1815,
    "end": 1815,
    "date": "1815",
    "place": "סומבאווה, אינדונזיה",
    "lat": -8.25,
    "lon": 118,
    "desc": "התפרצות ענק של הר טמבורה היא הגדולה שתועדה בהיסטוריה, והרגה עשרות אלפי בני אדם באופן ישיר ועוד רבים ברעב. האפר שנפלט בשמיים הוריד את הטמפרטורה העולמית, ו־1816 נודעה כשנה ללא קיץ, שבה נפגעו יבולים באירופה ובצפון אמריקה.",
    "rank": 155
  },
  {
    "id": "anc_ashurbanipal",
    "deck": "anchors",
    "title": "ספריית אשורבניפל בנינוה",
    "start": -668,
    "end": -631,
    "date": "בערך ⁦668–631⁩ לפנה״ס",
    "place": "נינוה, אשור",
    "lat": 36.36,
    "lon": 43.15,
    "desc": "מלך אשור אשורבניפל אסף בבירתו נינוה עשרות אלפי לוחות חרס, ובהם אפוס גילגמש, כתבי אסטרונומיה ורפואה, ורשימות של מילים ותפילות. הספרייה נקברה בחורבן העיר ב־612 לפנה״ס ונחפרה במאה ה־19. בזכותה שרד חלק גדול מהספרות המסופוטמית.",
    "rank": 156
  },
  {
    "id": "anc_manzikert",
    "deck": "anchors",
    "title": "קרב מנזיקרט",
    "start": 1071,
    "end": 1071,
    "date": "1071",
    "place": "מלאזגירט, אנטוליה",
    "lat": 39.14,
    "lon": 42.54,
    "desc": "הסולטאן הסלג׳וקי אלפ ארסלאן הביס את צבא הקיסר הביזנטי רומנוס הרביעי דיוגנס והשבה אותו. בעקבות הקרב נפתחה אנטוליה להתיישבות של שבטים טורקיים, והאזור הפך בהדרגה מנוצרי ויווני למוסלמי וטורקי. התבוסה גם הכינה את הקרקע לקריאה של הביזנטים לעזרה מהמערב.",
    "rank": 157
  },
  {
    "id": "anc_perry",
    "deck": "anchors",
    "title": "הסכם קנגאווה",
    "start": 1854,
    "end": 1854,
    "date": "1854",
    "place": "יוקוהמה, יפן",
    "lat": 35.44,
    "lon": 139.64,
    "desc": "הקומודור האמריקני מתיו פרי הגיע ליפן עם ספינות קיטור חמושות ואילץ את הממשל לחתום על הסכם שפתח נמלים לספינות אמריקניות. יפן שהייתה סגורה כמעט מאתיים שנה נחשפה לטכנולוגיה המערבית, והמשבר הוביל לנפילת השוגונות ולרפורמות מייג׳י.",
    "rank": 158
  },
  {
    "id": "anc_urziggurat",
    "deck": "anchors",
    "title": "הזיגורט הגדול באור",
    "start": -2100,
    "end": -2100,
    "date": "בערך 2100 לפנה״ס",
    "place": "אור, מסופוטמיה",
    "lat": 30.963,
    "lon": 46.103,
    "desc": "המלך אור־נמו בנה באור מקדש מדורג עצום לאל הירח נאנה, מבנה שהיה מרכז דתי וכלכלי של העיר. הזיגורטים של מסופוטמיה, שאולי עמדו ברקע לסיפור מגדל בבל, היו הר מלאכותי בין האדם לאלים. אור־נמו ידוע גם בקובץ החוקים הקדום ביותר שהגיע אלינו.",
    "rank": 159
  },
  {
    "id": "anc_xuanzang",
    "deck": "anchors",
    "title": "מסעו של שואנזנג להודו",
    "start": 629,
    "end": 645,
    "date": "⁦629–645⁩ לספירה",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.95,
    "desc": "הנזיר הסיני שואנזנג יצא ברגל לאורך דרך המשי להודו כדי ללמוד ולהביא כתבי בודהיזם. הוא שהה בנלנדה, ובשובו הביא מאות כתבים ותרגם אותם. רשימותיו על ארצות מרכז אסיה והודו הן מקור היסטורי חשוב, והשראה לרומן המסע למערב.",
    "rank": 160
  },
  {
    "id": "anc_adwa",
    "deck": "anchors",
    "title": "קרב אדוואה",
    "start": 1896,
    "end": 1896,
    "date": "1896",
    "place": "אדוואה, אתיופיה",
    "lat": 14.16,
    "lon": 38.89,
    "desc": "צבא אתיופי בפיקוד הקיסר מנליק השני הביס כוח איטלקי שניסה לכבוש את הממלכה. זו הייתה אחת התבוסות הבודדות של צבא אירופי מידי כוח אפריקאי בעידן הקולוניאליזם. הניצחון שימר את עצמאות אתיופיה והפך לסמל לאפריקאים רבים.",
    "rank": 161
  },
  {
    "id": "anc_athensplague",
    "deck": "anchors",
    "title": "המגפה באתונה",
    "start": -430,
    "end": -430,
    "date": "430 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.98,
    "lon": 23.72,
    "desc": "בשנה השנייה של מלחמת פלופונסוס פרצה באתונה הצפופה מגפה שהרגה אולי רבע מהאוכלוסייה, ובכללם פריקלס. תוקידידס, שחלה ושרד, תיאר את התסמינים בדייקנות, ותיאורו נחשב לתיעוד הרפואי הקדום ביותר מסוגו. סיבת המחלה אינה ידועה. המגפה החלישה את אתונה ותרמה לתבוסתה.",
    "rank": 162
  },
  {
    "id": "anc_diamondsutra",
    "deck": "anchors",
    "title": "סוטרת היהלום המודפסת",
    "start": 868,
    "end": 868,
    "date": "868 לספירה",
    "place": "דונהואנג, סין",
    "lat": 40.14,
    "lon": 94.66,
    "desc": "במערות דונהואנג נמצא עותק מודפס של סוטרת היהלום, שנחשב לספר המודפס המתוארך הוותיק בעולם. הדפוס נעשה בלוחות עץ, והתאריך מצוין בכתב. ההדפסה שימשה בעיקר לצורכי דת, ומאות שנים לפני גוטנברג כבר הפיצה ספרים בסין.",
    "rank": 163
  },
  {
    "id": "anc_taiping",
    "deck": "anchors",
    "title": "מרד טאיפינג",
    "start": 1850,
    "end": 1864,
    "date": "⁦1850–1864⁩",
    "place": "נאנג׳ינג, סין",
    "lat": 32.06,
    "lon": 118.8,
    "desc": "הונג שיוצ׳ואן, שהאמין שהוא אחיו הצעיר של ישו, הוביל בדרום סין תנועה עממית שהכריזה על ממלכה נוצרית ועל רפורמות חברתיות. המרד נמשך 14 שנה והכריע ערים רבות לפני שנכבשה נאנג׳ינג. עשרות מיליוני בני אדם מתו, ומרד זה נחשב אחד המלחמות הקטלניות בהיסטוריה.",
    "rank": 164
  },
  {
    "id": "anc_hanfound",
    "deck": "anchors",
    "title": "הקמת שושלת האן",
    "start": -202,
    "end": -202,
    "date": "202 לפנה״ס",
    "place": "צ׳אנגאן, סין",
    "lat": 34.3,
    "lon": 108.95,
    "desc": "ליו באנג, איכר שהפך למנהיג מרד, ניצח את יריבו והקים את שושלת האן. היא שלטה בסין כארבע מאות שנה ושמה נשאר שם העם הסיני העיקרי. תחת האן התעצבו מוסדות המדינה, התקבלה תורת קונפוציוס כאידאולוגיה, והתפתח הסחר בדרך המשי.",
    "rank": 165
  },
  {
    "id": "anc_mansamusa",
    "deck": "anchors",
    "title": "העלייה לרגל של מאנסה מוסא",
    "start": 1324,
    "end": 1324,
    "date": "1324",
    "place": "מאלי, מערב אפריקה",
    "lat": 11.43,
    "lon": -8.83,
    "desc": "מוסא הראשון, שליט אימפריית מאלי, יצא לעלייה לרגל למכה עם פמליה ענקית ועם כמויות עצומות של זהב. בקהיר חילק זהב רב עד שערכו צנח במשך שנים. המסע הציג את מערב אפריקה לעולם הים תיכוני, וערים כמו טימבוקטו הפכו למרכזי לימוד.",
    "rank": 166
  },
  {
    "id": "anc_tikal",
    "deck": "anchors",
    "title": "כניסת סיה קאק לטיקל",
    "start": 378,
    "end": 378,
    "date": "378 לספירה",
    "place": "טיקל, גואטמלה",
    "lat": 17.222,
    "lon": -89.623,
    "desc": "לפי כתובות מאיה, מצביא בשם סיה קאק הגיע לטיקל ב־378, ובאותו זמן מת מלך העיר. הוא כנראה בא מטאוטיוואקאן, והדבר מעיד על קשרים עמוקים בין שתי הציביליזציות. טיקל פרחה בהמשך כאחת הערים החזקות של המאיה, עם מקדשים שגובהם עולה על 60 מטר.",
    "rank": 167
  },
  {
    "id": "anc_optics",
    "deck": "anchors",
    "title": "ספר האופטיקה של אבן אל־היית׳ם",
    "start": 1011,
    "end": 1021,
    "date": "בערך ⁦1011–1021⁩",
    "place": "קהיר, מצרים",
    "lat": 30.04,
    "lon": 31.24,
    "desc": "המדען אבן אל־היית׳ם כתב בקהיר את חיבורו על הראייה והאור. הוא הוכיח בניסויים שאנו רואים משום שאור מוחזר מחפצים אל העין, ולא משום שהעין פולטת קרניים, כפי שסברו יוונים רבים. שיטתו הניסויית השפיעה עמוקות על המדע באירופה בימי הביניים המאוחרים.",
    "rank": 168
  },
  {
    "id": "anc_ashoka",
    "deck": "anchors",
    "title": "קרב קלינגה ותפנית אשוקה",
    "start": -261,
    "end": -261,
    "date": "בערך 261 לפנה״ס",
    "place": "קלינגה, הודו",
    "lat": 20.19,
    "lon": 85.84,
    "desc": "המלך המאורי אשוקה כבש את קלינגה במלחמה שבה נהרגו ונפגעו מאות אלפי בני אדם. לפי כתובות הסלע שלו, הוא נחרד, אימץ את הבודהיזם והטיף לשלום ולסובלנות. הוא שלח שליחים לשרי לנקה ולארצות רחוקות, וכך עזר להפוך את הבודהיזם לדת עולמית.",
    "rank": 169
  },
  {
    "id": "anc_safavid",
    "deck": "anchors",
    "title": "הקמת האימפריה הספווית",
    "start": 1501,
    "end": 1501,
    "date": "1501",
    "place": "תבריז, איראן",
    "lat": 38.08,
    "lon": 46.29,
    "desc": "איסמאעיל הראשון, מנהיג צעיר של מסדר סופי, כבש את תבריז והוכרז כשאה של פרס. הוא הכריז על האסלאם השיעי הדוואר כדת המדינה, ואילץ את האוכלוסייה להמיר דתה. בכך עיצב את זהותה הדתית של איראן עד היום ויצר יריב חזק לעות׳מאנים הסונים.",
    "rank": 170
  },
  {
    "id": "anc_behistun",
    "deck": "anchors",
    "title": "כתובת בהיסטון של דריווש",
    "start": -520,
    "end": -520,
    "date": "בערך 520 לפנה״ס",
    "place": "הר בהיסטון, איראן",
    "lat": 34.39,
    "lon": 47.436,
    "desc": "דריווש הראשון חרט על צוק גבוה בהר בהיסטון תיאור עלייתו לשלטון, בשלוש שפות: פרסית עתיקה, עילמית ואכדית. במאה ה־19 סייעה הכתובת לפענח את הכתב היתדי, והדבר אפשר לקרוא שוב טקסטים משומריים ואשוריים וליצור מחדש היסטוריה של מסופוטמיה.",
    "rank": 171
  },
  {
    "id": "anc_nara",
    "deck": "anchors",
    "title": "הקמת הבירה הקבועה בנארה",
    "start": 710,
    "end": 710,
    "date": "710 לספירה",
    "place": "נארה, יפן",
    "lat": 34.69,
    "lon": 135.8,
    "desc": "בעקבות הדוגמה של צ׳אנגאן הוקמה הבירה הקבועה הראשונה של יפן, נארה, בתוכנית רשתית. בתקופה זו התפתחו הבודהיזם, האמנות והכתיבה, ובהם נכתב הקוג׳יקי. מקדש טודאיג׳י בעל פסל הבודהה הענקי נבנה בה.",
    "rank": 172
  },
  {
    "id": "anc_gupta",
    "deck": "anchors",
    "title": "עליית שושלת גופטה",
    "start": 320,
    "end": 320,
    "date": "בערך 320 לספירה",
    "place": "פטאליפוטרה, הודו",
    "lat": 25.61,
    "lon": 85.14,
    "desc": "צ׳נדרגופטה הראשון הקים בצפון הודו את שושלת גופטה, שהגיעה לשיאה בימי סמודרגופטה וצ׳נדרגופטה השני. תקופתם נחשבת לתור זהב של מדע, אמנות וספרות: הוצג מושג האפס, התפתחו האסטרונומיה והמתמטיקה, ופעל המשורר קאלידאסה.",
    "rank": 173
  },
  {
    "id": "anc_nalanda",
    "deck": "anchors",
    "title": "חורבן אוניברסיטת נלנדה",
    "start": 1193,
    "end": 1193,
    "date": "בערך 1193",
    "place": "נלנדה, הודו",
    "lat": 25.14,
    "lon": 85.44,
    "desc": "נלנדה הייתה מרכז לימוד בודהיסטי גדול שמשך תלמידים מרחבי אסיה במשך כאלף שנה. כוחות של בכתיאר ח׳לג׳י, מצביא טורקי־אפגני, הרסו אותה וכמעט כל ספריותיה עלו באש. החורבן סימן את דעיכת הבודהיזם בצפון הודו, והאתר הוכרז אתר מורשת עולמית.",
    "rank": 174
  },
  {
    "id": "anc_sasanian",
    "deck": "anchors",
    "title": "הקמת האימפריה הסאסאנית",
    "start": 224,
    "end": 224,
    "date": "224 לספירה",
    "place": "פירוזאבאד, איראן",
    "lat": 28.84,
    "lon": 52.57,
    "desc": "ארדשיר, שליט פרסי מפארס, ניצח את המלך הפרתי ארטבנוס הרביעי וייסד את השושלת הסאסאנית. האימפריה שלטה בפרס ובמסופוטמיה כ־400 שנה, אימצה את הזורואסטריות כדת רשמית והייתה היריבה הגדולה של רומא ושל ביזנטיון עד לכיבוש המוסלמי.",
    "rank": 175
  },
  {
    "id": "anc_jiaozi",
    "deck": "anchors",
    "title": "השטר הממשלתי הראשון בסין",
    "start": 1024,
    "end": 1024,
    "date": "בערך 1024",
    "place": "צ׳נגדו, סין",
    "lat": 30.66,
    "lon": 104.07,
    "desc": "בתקופת שושלת סונג הנפיקה הממשלה בסצ׳ואן את ה־ג׳יאוזי, כסף נייר שהוצא בפיקוח המדינה. שטרות פרטיים קדמו להם, אך זו הייתה אחת ההנפקות הממלכתיות הראשונות בעולם. הכסף הקל על מסחר בעידן שבו מטבעות הנחושת היו כבדים ומסורבלים.",
    "rank": 176
  },
  {
    "id": "anc_olmec",
    "deck": "anchors",
    "title": "תרבות האולמקים בסן לורנסו",
    "start": -1200,
    "end": -1200,
    "date": "בערך 1200 לפנה״ס",
    "place": "וראקרוס, מקסיקו",
    "lat": 17.73,
    "lon": -94.76,
    "desc": "בסן לורנסו שבחוף המפרץ של מקסיקו יצרו האולמקים ראשי אבן ענקיים במשקל טונות רבות, שהובלו ממרחק רב. תרבותם נחשבת לאם תרבויות מסואמריקה, ומשחק הכדור, לוח השנה והדת המאוחרים בעולם המאיה והאצטקים נשענו על מסורת שהתחילה אצלם.",
    "rank": 177
  },
  {
    "id": "anc_brahmagupta",
    "deck": "anchors",
    "title": "הספר של ברהמגופטה על האפס",
    "start": 628,
    "end": 628,
    "date": "628 לספירה",
    "place": "בהינמל, הודו",
    "lat": 25,
    "lon": 72.27,
    "desc": "המתמטיקאי והאסטרונום ברהמגופטה כתב ספר שבו מוגדרים כללי חשבון עם האפס ועם מספרים שליליים, לצד תוצאות בגיאומטריה ובאסטרונומיה. המספר אפס הופיע בהודו כבר קודם, אך כאן הוא קיבל מעמד של מספר ממש. הידע עבר לעולם הערבי ומשם לאירופה.",
    "rank": 178
  },
  {
    "id": "anc_tanegashima",
    "deck": "anchors",
    "title": "הגעת הרובים הראשונים ליפן",
    "start": 1543,
    "end": 1543,
    "date": "1543",
    "place": "טנגשימה, יפן",
    "lat": 30.73,
    "lon": 131,
    "desc": "ספנים פורטוגלים שהגיעו לאי טנגשימה, בדרומה של יפן, הביאו אתם רובי פתיל. אדוני האדמות היפנים למדו במהירות לייצר אותם, ובתוך שנים חדשות היו אלפי רובים בצבאות. הנשק שינה את דרך הלחימה בתקופת המדינות הלוחמות ועזר לאחד את יפן.",
    "rank": 179
  },
  {
    "id": "anc_twelvetables",
    "deck": "anchors",
    "title": "לוחות שנים עשר",
    "start": -451,
    "end": -451,
    "date": "451 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.486,
    "desc": "בעקבות לחץ של פשוטי העם נחקקו ברומא חוקי הרפובליקה על שנים עשר לוחות והוצבו בפורום. לראשונה היה החוק גלוי לכול ולא רק בידי כוהנים ופטריקים. הלוחות, שאבדו, היו בסיס למשפט הרומי שהשפיע על דיני מדינות באירופה ובעולם.",
    "rank": 180
  },
  {
    "id": "anc_anlushan",
    "deck": "anchors",
    "title": "מרד אן לושאן",
    "start": 755,
    "end": 755,
    "date": "755 לספירה",
    "place": "בייג׳ינג, סין",
    "lat": 39.9,
    "lon": 116.4,
    "desc": "הגנרל אן לושאן, מפקד בצפון, מרד בקיסר ושלט בלויאנג ובצ׳אנגאן לתקופה מסוימת. המרד נמשך שמונה שנים וגבה מיליוני קורבנות, והחליש את שושלת טאנג לצמיתות. המדינה איבדה שליטה על אזורים, והמעמד הצבאי המקומי התחזק.",
    "rank": 181
  },
  {
    "id": "anc_redcliffs",
    "deck": "anchors",
    "title": "קרב המצוקים האדומים",
    "start": 208,
    "end": 208,
    "date": "208 לספירה",
    "place": "צ׳יבי, סין",
    "lat": 29.87,
    "lon": 113.9,
    "desc": "בקרב על נהר היאנגצה ניצחו בעלות הברית של סון צ׳ואן וליו ביי, בהנהגת ג׳ואו יו, צי גדול של צאו צאו. הניצחון מנע איחוד סין תחת שליט אחד ויצר את מצב שלוש הממלכות, תקופה שהפכה לאגדה בספרות הסינית ובמיוחד בספר רומן שלוש הממלכות.",
    "rank": 182
  },
  {
    "id": "anc_panipat",
    "deck": "anchors",
    "title": "קרב פאניפט הראשון",
    "start": 1526,
    "end": 1526,
    "date": "1526",
    "place": "פאניפט, הודו",
    "lat": 29.39,
    "lon": 76.97,
    "desc": "בבור, נסיך ממוצא טורקי־מונגולי מאפגניסטן, הביס את סולטאן דלהי איברהים לודי בעזרת תותחים ורובים. הניצחון הניח את היסוד לאימפריה המוגולית, ששלטה בחלק גדול מהודו קרוב לשלוש מאות שנה. בתקופתה פרחו באזור האדריכלות, האמנות והשפה האורדו.",
    "rank": 183
  },
  {
    "id": "anc_zhangqian",
    "deck": "anchors",
    "title": "משלחתו של ג׳אנג צ׳יין למרכז אסיה",
    "start": -138,
    "end": -126,
    "date": "בערך ⁦138–126⁩ לפנה״ס",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.95,
    "desc": "הקיסר וו משושלת האן שלח את ג׳אנג צ׳יין ליצור ברית עם היואז׳י נגד ההסיונגנו. הוא נתפס ושהה שנים בשבי, ולבסוף חזר עם מידע על פרגנה, בקטריה ועוד. מסעו פתח את הדרך לקשרי מסחר בין סין למערב והניח את היסוד לדרך המשי.",
    "rank": 184
  },
  {
    "id": "anc_srivijaya",
    "deck": "anchors",
    "title": "ממלכת סריוויג׳איה",
    "start": 683,
    "end": 683,
    "date": "683 לספירה",
    "place": "פאלמבאנג, אינדונזיה",
    "lat": -2.99,
    "lon": 104.76,
    "desc": "כתובת מסומטרה מתעדת את ייסוד ממלכת סריוויג׳איה, שהפכה בהמשך לאימפריה ימית ששלטה במיצרי מלאקה ובמסחר בין הודו לסין. היא הייתה גם מרכז לימוד בודהיסטי חשוב, והשפיעה על התרבות והדת בדרום מזרח אסיה.",
    "rank": 185
  },
  {
    "id": "anc_shang",
    "deck": "anchors",
    "title": "כתובות העצמות של שושלת שאנג",
    "start": -1250,
    "end": -1250,
    "date": "בערך 1250 לפנה״ס",
    "place": "אנאיאנג, סין",
    "lat": 36.12,
    "lon": 114.32,
    "desc": "מלכי שאנג חרטו שאלות על עצמות כתף ושריונות צבים, חיממו אותן עד שנסדקו ופירשו את הסדקים כתשובות האלים. אלה הדוגמאות הקדומות ביותר לכתב סיני מפותח, והסימנים שלהן הם אבות הסימנים בשימוש עד היום. הכתובות נתגלו בסוף המאה ה־19 ליד אנאיאנג, בירת השושלת.",
    "rank": 186
  },
  {
    "id": "anc_silla",
    "deck": "anchors",
    "title": "איחוד קוריאה בידי סילה",
    "start": 676,
    "end": 676,
    "date": "676 לספירה",
    "place": "גיונגג׳ו, קוריאה",
    "lat": 35.84,
    "lon": 129.22,
    "desc": "ממלכת סילה, בסיוע שושלת טאנג הסינית, כבשה את ממלכות בייג׳ה וגוגוריאו, ואחר כך הדפה את בעלת בריתה. כך נוצרה לראשונה מדינה קוריאנית מאוחדת על רוב חצי האי, שבירתה גיונגג׳ו. סילה עודדה בודהיזם, אמנות ומדע, והיא אבי התרבות הקוריאנית.",
    "rank": 187
  },
  {
    "id": "anc_necho",
    "deck": "anchors",
    "title": "סיבוב אפריקה במסע פיניקי",
    "start": -600,
    "end": -600,
    "date": "בערך 600 לפנה״ס",
    "place": "ים סוף, מצרים",
    "lat": 29.95,
    "lon": 32.55,
    "desc": "לפי הרודוטוס שלח הפרעה נכו השני מלחים פיניקים ממפרץ סואץ להקיף את אפריקה. הם הפליגו שלוש שנים, ונחתו בחוף כדי לזרוע ולקצור, ובשובם דיווחו שהשמש עלתה מימין. הרודוטוס עצמו פקפק בפרט הזה, אך כיום רואים בו עדות אפשרית לאמיתות המסע.",
    "rank": 188
  },
  {
    "id": "anc_thanjavur",
    "deck": "anchors",
    "title": "מקדש בריהאדישווארה בתנג׳ור",
    "start": 1010,
    "end": 1010,
    "date": "1010",
    "place": "תנג׳ור, הודו",
    "lat": 10.783,
    "lon": 79.132,
    "desc": "המלך הצ׳ולי רג׳ראג׳ה הראשון השלים את מקדש שיווה הענק בתנג׳ור, שמגדלו מתנשא לכ־60 מטר. המקדש סימל את שיאה של ממלכת צ׳ולה, שהשתלטה על דרום הודו ושלחה ציי מלחמה וסחר עד דרום מזרח אסיה. הוא נחשב ליצירת מופת של האדריכלות הדרווידית.",
    "rank": 189
  },
  {
    "id": "anc_caral",
    "deck": "anchors",
    "title": "העיר קראל בעמק סופה",
    "start": -2600,
    "end": -2600,
    "date": "בערך 2600 לפנה״ס",
    "place": "עמק סופה, פרו",
    "lat": -10.893,
    "lon": -77.52,
    "desc": "בעמק חוף צר בפרו קמה אחת הערים העתיקות ביותר באמריקה, עם מבני פסגה, כיכרות ומתחמים ציבוריים. תושביה חיו מחקלאות כותנה ושעועית ומסחר בדגים, ולא השאירו אחריהם כלי חרס. קראל מלמדת שחברה מורכבת צמחה ביבשת בעת שבה קמו הפירמידות במצרים.",
    "rank": 190
  },
  {
    "id": "anc_talas",
    "deck": "anchors",
    "title": "קרב טלאס",
    "start": 751,
    "end": 751,
    "date": "751 לספירה",
    "place": "טאראז, קזחסטן",
    "lat": 42.9,
    "lon": 71.37,
    "desc": "צבא עבאסי ניצח את צבא שושלת טאנג על נהר טלאס במרכז אסיה, ובכך הסתיימה ההתפשטות הסינית מערבה. לפי המסורת נשבו אומנים סינים שהקימו בסמרקנד בית חרושת לנייר, ומשם התפשטה המלאכה לעולם האסלאם ולאירופה.",
    "rank": 191
  },
  {
    "id": "anc_piye",
    "deck": "anchors",
    "title": "כיבוש מצרים בידי מלך כוש",
    "start": -744,
    "end": -744,
    "date": "בערך 744 לפנה״ס",
    "place": "נפטה, סודן",
    "lat": 18.534,
    "lon": 31.832,
    "desc": "פיעה, מלך כוש מנפטה שבסודן של ימינו, יצא צפונה וכבש את מצרים שהייתה מפולגת. צאצאיו שלטו בה כשושלת ה־25 והחזירו אליה מסורות מצריות קדומות, ובהן בניית פירמידות. נצחונו ידוע מהסטלה שהקים בנפטה, ומשמש עדות לעוצמה אפריקאית בעולם העתיק.",
    "rank": 192
  },
  {
    "id": "anc_shotoku",
    "deck": "anchors",
    "title": "החוקה של הנסיך שוטוקו",
    "start": 604,
    "end": 604,
    "date": "604 לספירה",
    "place": "אסוקה, יפן",
    "lat": 34.47,
    "lon": 135.82,
    "desc": "הנסיך שוטוקו, יורש העצר של יפן, פרסם תקנון של שבעה עשר סעיפים הקורא להרמוניה, לכבוד הבודהיזם ולנאמנות לקיסר. הוא הושפע מתורת קונפוציוס, ופעל להקים מנגנון ממשל ריכוזי לפי המודל הסיני. התקנון הוא אחד הכתבים הפוליטיים הקדומים של יפן.",
    "rank": 193
  },
  {
    "id": "anc_erlitou",
    "deck": "anchors",
    "title": "ארליטו ותחילת התרבות הסינית העירונית",
    "start": -1900,
    "end": -1900,
    "date": "בערך 1900 לפנה״ס",
    "place": "נהר הצהוב, סין",
    "lat": 34.69,
    "lon": 112.7,
    "desc": "באתר ארליטו שבעמק הנהר הצהוב נחשפו ארמונות, בתי יציקה לארד וקברים מפוארים. חוקרים רבים רואים בו עיר בירה של שושלת שיה המסורתית, אף שהקשר לא הוכח בכתובות. זהו אחד הסימנים הראשונים למדינה מרוכזת בסין ולמסורת הארד שתאפיין אותה.",
    "rank": 194
  },
  {
    "id": "anc_vijayanagara",
    "deck": "anchors",
    "title": "הקמת האימפריה של וג׳יינגארה",
    "start": 1336,
    "end": 1336,
    "date": "בערך 1336",
    "place": "האמפי, הודו",
    "lat": 15.335,
    "lon": 76.46,
    "desc": "האחים הרהרה ובוקה הקימו בדרום הודו ממלכה הינדית שנועדה לעמוד מול הסולטנויות המוסלמיות בצפון. בירתה, וג׳יינגארה, הייתה אחת הערים העשירות בעולם, ושלטונה ארך כמאתיים וחמישים שנה. התרבות, הארכיטקטורה והמסחר שלה עיצבו את דרום הודו.",
    "rank": 195
  },
  {
    "id": "anc_chavin",
    "deck": "anchors",
    "title": "המקדש בצ׳אבין דה וואנטאר",
    "start": -900,
    "end": -900,
    "date": "בערך 900 לפנה״ס",
    "place": "האנדים, פרו",
    "lat": -9.593,
    "lon": -77.177,
    "desc": "במרומי האנדים הקימו אנשי צ׳אבין מתחם מקדשי אבן עם מבוך מעברים תת־קרקעיים ופסל אל בדמות חתול טורף. האתר משך עולי רגל מכל האזור, והסגנון האמנותי שלו הופיע במרחבים רחבים בפרו. הוא נחשב לאחד המרכזים הדתיים החשובים בהיסטוריה הקדם־אינקית.",
    "rank": 196
  },
  {
    "id": "anc_nestorian",
    "deck": "anchors",
    "title": "האבן הנסטוריאנית בצ׳אנגאן",
    "start": 781,
    "end": 781,
    "date": "781 לספירה",
    "place": "שיאן, סין",
    "lat": 34.25,
    "lon": 108.95,
    "desc": "בצ׳אנגאן הוקמה אבן חרוטה בסינית ובסורית המתארת את הגעת הנצרות הנסטוריאנית לסין ב־635 ואת מעמדה. האבן מעידה על סובלנות שושלת טאנג ועל קשרים תרבותיים בדרך המשי. היא נקברה במאה ה־9 ונחשפה ב־1625.",
    "rank": 197
  },
  {
    "id": "anc_pytheas",
    "deck": "anchors",
    "title": "מסעו של פיתיאס הצפוני",
    "start": -325,
    "end": -325,
    "date": "בערך 325 לפנה״ס",
    "place": "מסליה, צרפת",
    "lat": 43.296,
    "lon": 5.37,
    "desc": "פיתיאס, יווני ממסליה (מרסיי), הפליג מעבר לעמודי הרקולס צפונה אל בריטניה וסיפר על ארץ שבה אין לילה בקיץ, והיא כנראה תולה. כתביו אבדו וידועים רק מציטוטים. הוא נחשב לאחד החוקרים הראשונים של צפון אירופה ולמי שתיאר את הקשר בין הירח לגאות.",
    "rank": 198
  },
  {
    "id": "anc_ayacucho",
    "deck": "anchors",
    "title": "קרב איאקוצ׳ו",
    "start": 1824,
    "end": 1824,
    "date": "1824",
    "place": "איאקוצ׳ו, פרו",
    "lat": -13.16,
    "lon": -74.22,
    "desc": "כוחות המורדים בפיקוד אנטוניו חוסה דה סוקרה, יד ימינו של סימון בוליבר, הביסו את הצבא הספרדי הנאמן למלוכה בהרי האנדים. הקרב סיים למעשה את שלטון ספרד ביבשת דרום אמריקה, אחרי עשור וחצי של מלחמות עצמאות.",
    "rank": 199
  },
  {
    "id": "anc_ezana",
    "deck": "anchors",
    "title": "התנצרות מלכות אקסום",
    "start": 330,
    "end": 330,
    "date": "בערך 330 לספירה",
    "place": "אקסום, אתיופיה",
    "lat": 14.13,
    "lon": 38.72,
    "desc": "המלך עזנה, שליט הממלכה האקסומית בצפון אתיופיה, אימץ את הנצרות בהשפעת פרומנטיוס, מי שנתמנה לבישוף. אקסום הייתה כוח מסחרי בין רומא להודו ובעלת מטבעות ובתי קברות מונומנטליים. התנצרותה יצרה אחת הקהילות הנוצריות הוותיקות בעולם, שנשארה עד היום.",
    "rank": 200
  },
  {
    "id": "crusade",
    "deck": "anchors",
    "title": "מסע הצלב הראשון כובש את ירושלים",
    "start": 1099,
    "end": 1099,
    "date": "1099",
    "place": "ירושלים",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "בהיענות לקריאת האפיפיור אורבנוס השני מ־1095 צעדו צבאות של אבירים ממערב אירופה מזרחה וכבשו את ירושלים אחרי מצור. רבים מתושבי העיר המוסלמים והיהודים נטבחו. הצלבנים ייסדו את ממלכת ירושלים, ומדינות צלבניות החזיקו בחלקים מהחוף עד 1291.",
    "rank": 201
  },
  {
    "id": "israel",
    "deck": "anchors",
    "title": "הכרזת העצמאות של ישראל",
    "start": 1948,
    "end": 1948,
    "date": "1948",
    "place": "תל אביב",
    "lat": 32.0636,
    "lon": 34.7713,
    "desc": "ב־14 במאי, עם תום המנדט הבריטי, קרא דוד בן־גוריון את מגילת העצמאות במוזיאון תל אביב. ההכרזה באה בעקבות תוכנית החלוקה של האו״ם מ־1947 ועשרות שנים של התיישבות ציונית. למחרת פלשו מדינות ערב השכנות, והמלחמה שפרצה אחרי החלטת החלוקה התרחבה.",
    "rank": 202
  },
  {
    "id": "temple",
    "deck": "anchors",
    "title": "חורבן בית שני",
    "start": 70,
    "end": 70,
    "date": "70 לספירה",
    "place": "ירושלים",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "לגיונות רומיים בפיקוד טיטוס צרו על ירושלים והחריבו את בית המקדש השני, ובכך דיכאו את המרד הגדול שפרץ ב־66 לספירה. עשרות אלפים נהרגו או נמכרו לעבדות. בהיעדר המקדש עבר מרכז החיים היהודיים לבית הכנסת, ללימוד ולהלכה של חז״ל, אובדן שמצוין עד היום בתשעה באב.",
    "rank": 203
  },
  {
    "id": "plague",
    "deck": "anchors",
    "title": "המוות השחור פוקד את אירופה",
    "start": 1347,
    "end": 1351,
    "date": "⁦1347–1351⁩",
    "place": "מגיע למסינה, סיציליה",
    "lat": 38.193,
    "lon": 15.554,
    "desc": "המגפה, שנישאה בנתיבי המסחר ממרכז אסיה, הגיעה לסיציליה באוניות גנואזיות ב־1347. בארבע השנים הבאות היא הרגה בין שליש למחצית מאוכלוסיית אירופה. המחסור בידיים עובדות שבא בעקבותיה העלה את השכר והחליש את אחיזתו של הסדר הפאודלי.",
    "rank": 204
  },
  {
    "id": "mod_hiroshima",
    "deck": "anchors",
    "title": "הפצצה האטומית על הירושימה",
    "start": 1945,
    "end": 1945,
    "date": "1945",
    "place": "הירושימה, יפן",
    "lat": 34.39,
    "lon": 132.46,
    "desc": "ב־6 באוגוסט הטיל מטוס אמריקני פצצה אטומית על הירושימה. כ־70 אלף בני אדם נהרגו מיד, ועד סוף השנה עלה המספר ליותר מ־100 אלף, בגלל כוויות ומחלות קרינה. הפצצה הייתה השימוש הראשון בנשק גרעיני בלחימה.",
    "rank": 205
  },
  {
    "id": "anq_jesus",
    "deck": "anchors",
    "title": "צליבת ישו",
    "start": 30,
    "end": 33,
    "date": "בערך ⁦30–33⁩ לספירה",
    "place": "ירושלים, יהודה",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "ישו מנצרת, מורה יהודי שפעל בגליל וביהודה, הוצא להורג בצליבה בידי השלטון הרומי בימי הנציב פונטיוס פילטוס. לפי הברית החדשה קמו תלמידיו לאחר מכן להפיץ את תורתו. בעקבות פעולתם צמחה הנצרות, שהפכה בהמשך לדת העולמית הגדולה.",
    "rank": 206
  },
  {
    "id": "med_columbus",
    "deck": "anchors",
    "title": "קולומבוס מגיע לאיים הקריביים",
    "start": 1492,
    "end": 1492,
    "date": "1492",
    "place": "איי בהאמה, האוקיינוס האטלנטי",
    "lat": 24.1,
    "lon": -74.5,
    "desc": "כריסטופר קולומבוס, נווט ממוצא גנואזי בשירות הכתר הספרדי, חצה את האוקיינוס האטלנטי בחיפוש אחר דרך מערבית להודו. הוא הגיע לאחד מאיי בהאמה ואחר כך לקובה ולהיספניולה. מסעו פתח עידן של מגע קבוע, ולעיתים אלים, בין אירופה לאמריקה.",
    "rank": 207
  },
  {
    "id": "mod_dday",
    "deck": "anchors",
    "title": "הנחיתה בנורמנדי",
    "start": 1944,
    "end": 1944,
    "date": "1944",
    "place": "חופי נורמנדי, צרפת",
    "lat": 49.37,
    "lon": -0.87,
    "desc": "ב־6 ביוני נחתו בחופי נורמנדי עשרות אלפי חיילים אמריקנים, בריטים, קנדים ובעלי ברית נוספים, בתמיכת אלפי ספינות ומטוסים, בפיקוד הגנרל אייזנהאואר. זו הייתה הפלישה הימית הגדולה בהיסטוריה, ופתחה את חזית המערב. תוך חודשים שוחררה צרפת.",
    "rank": 208
  },
  {
    "id": "anq_thermopylae",
    "deck": "anchors",
    "title": "קרב תרמופילי",
    "start": -480,
    "end": -480,
    "date": "480 לפנה״ס",
    "place": "תרמופילי, יוון",
    "lat": 38.8,
    "lon": 22.54,
    "desc": "כוח יווני קטן בפיקוד המלך הספרטני לאונידס עצר במשך כמה ימים את צבא הענק של קסרקסס הראשון במעבר צר שבין ההר לים. כשפרסים עקפו אותם במסלול הרים, נשארו לאונידס ובני לוויתו להגן על נסיגת היתר ונפלו עד אחד. הקרב הפך לסמל של אומץ והקרבה.",
    "rank": 209
  },
  {
    "id": "luther",
    "deck": "anchors",
    "title": "לותר מפרסם את 95 התזות",
    "start": 1517,
    "end": 1517,
    "date": "1517",
    "place": "ויטנברג, גרמניה",
    "lat": 51.866,
    "lon": 12.646,
    "desc": "מרטין לותר, נזיר ופרופסור לתאולוגיה, פרסם 95 תזות שתקפו את מכירת שטרי המחילה בידי הכנסייה. בזכות הדפוס התפשטו רעיונותיו במהירות וקראו תיגר על סמכות האפיפיור. המחלוקת התפתחה לרפורמציה הפרוטסטנטית ופילגה את הנצרות המערבית.",
    "rank": 210
  },
  {
    "id": "poland",
    "deck": "anchors",
    "title": "גרמניה פולשת לפולין",
    "start": 1939,
    "end": 1939,
    "date": "1939",
    "place": "וסטרפלטה, סמוך לגדנסק, פולין",
    "lat": 54.407,
    "lon": 18.668,
    "desc": "ב־1 בספטמבר פלשה גרמניה הנאצית בהנהגת אדולף היטלר לפולין, ומהיריות הראשונות נורו על חיל המצב הפולני בווסטרפלטה. בריטניה וצרפת, בעלות בריתה של פולין, הכריזו מלחמה יומיים אחר כך. ב־17 בספטמבר פלשה ברית המועצות ממזרח, על פי הסכם סודי עם גרמניה.",
    "rank": 211
  },
  {
    "id": "anq_vesuvius",
    "deck": "anchors",
    "title": "התפרצות הר הגעש וזוב",
    "start": 79,
    "end": 79,
    "date": "79 לספירה",
    "place": "פומפיי, איטליה",
    "lat": 40.75,
    "lon": 14.49,
    "desc": "התפרצות פתאומית כיסתה את פומפיי ואת הרקולנאום באפר וגז. פליניוס הצעיר תיאר את האירוע במכתב לטקיטוס, ודודו פליניוס הזקן נספה כשיצא להציל נפגעים. החפירות בפומפיי חושפות בתים, ציורי קיר וגופות קפואים בזמן.",
    "rank": 212
  },
  {
    "id": "med_hastings",
    "deck": "anchors",
    "title": "קרב הייסטינגס",
    "start": 1066,
    "end": 1066,
    "date": "1066",
    "place": "הייסטינגס, אנגליה",
    "lat": 50.91,
    "lon": 0.49,
    "desc": "ויליאם, דוכס נורמנדי, פלש לאנגליה והביס את הצבא של המלך הרולד גודווינסון ליד הייסטינגס. הרולד נהרג בקרב. ויליאם הוכתר בלונדון, והנורמנים החליפו את האצולה האנגלו־סקסית ושינו את השפה ואת החברה האנגלית.",
    "rank": 213
  },
  {
    "id": "mod_titanic",
    "deck": "anchors",
    "title": "טביעת הטיטאניק",
    "start": 1912,
    "end": 1912,
    "date": "1912",
    "place": "צפון האוקיינוס האטלנטי, דרום־מזרחית לניופאונדלנד",
    "lat": 41.73,
    "lon": -49.95,
    "desc": "ספינת הנוסעים הבריטית הענקית פגעה בלילה ב־14 באפריל בקרחון בהפלגת הבכורה שלה מסאות׳המפטון לניו יורק, וטבעה כעבור שעתיים וחצי. כ־1,500 מהנוסעים וחברי הצוות נספו, בין השאר מפני שלא היו די סירות הצלה. האסון הוביל לתקנות בטיחות בין־לאומיות חדשות בים.",
    "rank": 214
  },
  {
    "id": "anq_jerusalem_586",
    "deck": "anchors",
    "title": "חורבן ירושלים והמקדש הראשון",
    "start": -586,
    "end": -586,
    "date": "בערך 586 לפנה״ס",
    "place": "ירושלים, ארץ ישראל",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "צבא בבל בהנהגת נבוכדנאצר השני כבש את ירושלים לאחר מצור ארוך, שרף את המקדש וחלק גדול מהעיר והגלה חלק מתושבי יהודה לבבל. ממלכת יהודה חדלה להתקיים. מתקופת הגלות נוצרו חלקים חשובים בכתבי המקרא.",
    "rank": 215
  },
  {
    "id": "med_gutenberg",
    "deck": "anchors",
    "title": "גוטנברג והדפוס",
    "start": 1455,
    "end": 1455,
    "date": "בערך 1455",
    "place": "מיינץ, גרמניה",
    "lat": 49.99,
    "lon": 8.27,
    "desc": "יוהאן גוטנברג, צורף ממיינץ, פיתח שיטת הדפסה באותיות מתכת ניתנות להזזה, והדפיס את תנ״ך גוטנברג. הדפוס הוזיל ספרים והפיץ ידע ורעיונות דתיים ומדיניים במהירות. ללא הדפוס קשה לדמיין את הרפורמציה ואת המהפכה המדעית.",
    "rank": 216
  },
  {
    "id": "mod_bastille",
    "deck": "anchors",
    "title": "הסערה על הבסטיליה",
    "start": 1789,
    "end": 1789,
    "date": "1789",
    "place": "פריז, צרפת",
    "lat": 48.85,
    "lon": 2.37,
    "desc": "ב־14 ביולי הסתערו המוני פריז על מבצר הכלא, כדי להשיג נשק ואבק שריפה, ושחררו את האסירים. האירוע הפך לסמל של התקוממות העם נגד המלוכה המוחלטת בימי המהפכה הצרפתית. הוא הוכר לימים כיום הלאומי של צרפת.",
    "rank": 217
  },
  {
    "id": "charlemagne",
    "deck": "anchors",
    "title": "קרל הגדול מוכתר לקיסר",
    "start": 800,
    "end": 800,
    "date": "800",
    "place": "רומא, איטליה",
    "lat": 41.902,
    "lon": 12.454,
    "desc": "ביום חג המולד הכתיר האפיפיור לאו השלישי את קרל הגדול, מלך הפרנקים, לקיסר בבזיליקת פטרוס הקדוש. קרל איחד חלקים נרחבים ממערב אירופה בעשרות שנים של מסעות מלחמה. ההכתרה החיתה את רעיון הקיסר הרומי במערב והניחה את היסוד לקיסרות הרומית הקדושה.",
    "rank": 218
  },
  {
    "id": "usa",
    "deck": "anchors",
    "title": "הכרזת העצמאות של ארצות הברית",
    "start": 1776,
    "end": 1776,
    "date": "1776",
    "place": "פילדלפיה, ארה״ב",
    "lat": 39.949,
    "lon": -75.15,
    "desc": "ב־4 ביולי אימץ הקונגרס הקונטיננטלי הכרזה שניסח בעיקר תומס ג׳פרסון. שלוש־עשרה המושבות נלחמו בבריטניה מאז 1775 על מיסוי ועל שלטון עצמי. ההכרזה הצהירה על זכויות אוניברסליות ועל הולדתה של ארצות הברית, שעצמאותה הובטחה ב־1783.",
    "rank": 219
  },
  {
    "id": "med_magna_carta",
    "deck": "anchors",
    "title": "מגנה קרטה",
    "start": 1215,
    "end": 1215,
    "date": "1215",
    "place": "ראנימייד, אנגליה",
    "lat": 51.444,
    "lon": -0.564,
    "desc": "בארונים אנגלים מורדים אילצו את המלך יוחנן להסכים למסמך שהגביל את סמכותו וקבע שגם המלך כפוף לחוק. המסמך הבטיח בין היתר משפט הוגן לבני חורין. האפיפיור ביטל אותו עד מהרה, אך הוא הונפק מחדש בגרסאות מאוחרות והפך לסמל של שלטון מוגבל.",
    "rank": 220
  },
  {
    "id": "mod_berlin_surrender",
    "deck": "anchors",
    "title": "כניעת גרמניה הנאצית",
    "start": 1945,
    "end": 1945,
    "date": "1945",
    "place": "קרלסהורסט, ברלין, גרמניה",
    "lat": 52.49,
    "lon": 13.54,
    "desc": "אחרי שהיטלר התאבד באפריל וברלין נכבשה בידי הצבא האדום, חתמו נציגי הוורמאכט על כניעה ללא תנאי. החתימה הסופית נערכה בקרלסהורסט בלילה שבין 8 ל־9 במאי. באירופה הסתיימה המלחמה, ובמזרח הרחוק נמשכה עד הכניעה היפנית בקיץ.",
    "rank": 221
  },
  {
    "id": "med_joan_of_arc",
    "deck": "anchors",
    "title": "ז׳אן דארק משחררת את אורלאן",
    "start": 1429,
    "end": 1429,
    "date": "1429",
    "place": "אורלאן, צרפת",
    "lat": 47.9,
    "lon": 1.9,
    "desc": "ז׳אן דארק, נערה איכרית שטענה כי שמעה קולות מאלוהים, הובילה כוח צרפתי להסרת המצור האנגלי על אורלאן. הניצחון אפשר להכתיר את יורש העצר שארל השביעי בריימס. ז׳אן נתפסה ב־1430 ונשרפה על המוקד ב־1431, ובהמשך הוכרזה כקדושה.",
    "rank": 222
  },
  {
    "id": "anq_alex_death",
    "deck": "anchors",
    "title": "מות אלכסנדר הגדול",
    "start": -323,
    "end": -323,
    "date": "323 לפנה״ס",
    "place": "בבל, עיראק",
    "lat": 32.54,
    "lon": 44.42,
    "desc": "אלכסנדר מת בגיל כמעט 33 לאחר מחלה קצרה בארמון נבוכדנצר, ללא יורש ברור. עילת המוות עדיין נתונה בוויכוח. מצביאיו, הדיאדוכים, חילקו ביניהם את האימפריה ונלחמו זה בזה, וכך קמו הממלכות ההלניסטיות של התלמיים, הסלווקים והאנטיגונים.",
    "rank": 223
  },
  {
    "id": "med_expulsion",
    "deck": "anchors",
    "title": "גירוש יהודי ספרד",
    "start": 1492,
    "end": 1492,
    "date": "1492",
    "place": "גרנדה, ספרד",
    "lat": 37.176,
    "lon": -3.59,
    "desc": "בצו שנחתם בארמון האלהמברה הורו הכתר הספרדי ליהודים להתנצר או לעזוב את הממלכה תוך כמה חודשים. לפי ההערכות עזבו עשרות אלפי יהודים ויותר, בעיקר לפורטוגל, לצפון אפריקה ולאימפריה העות׳מאנית. הקהילות המפוזרות כונו אחר כך ספרדים.",
    "rank": 224
  },
  {
    "id": "mod_apollo",
    "deck": "anchors",
    "title": "הנחיתה הראשונה על הירח",
    "start": 1969,
    "end": 1969,
    "date": "1969",
    "place": "קייפ קנדי, פלורידה, ארה״ב",
    "lat": 28.57,
    "lon": -80.65,
    "desc": "ב־16 ביולי שוגרה חללית אפולו 11 מקייפ קנדי, וב־20 ביולי נחתו על הירח נייל ארמסטרונג ובאז אולדרין, בעוד מייקל קולינס נשאר במסלול. ארמסטרונג היה האדם הראשון שדרך על הירח. המסע הושלם בהצלחה כמעט לגמרי, והוא היה שיא המרוץ לחלל בין ארצות הברית לברית המועצות.",
    "rank": 225
  },
  {
    "id": "anq_masada",
    "deck": "anchors",
    "title": "נפילת מצדה",
    "start": 73,
    "end": 74,
    "date": "בערך ⁦73–74⁩ לספירה",
    "place": "מצדה, מדבר יהודה",
    "lat": 31.32,
    "lon": 35.35,
    "desc": "בסיום המרד הגדול צרו הרומאים בפיקוד פלביוס סילווה על המבצר שבו התבצרו מורדים בהנהגת אלעזר בן יאיר. לפי יוסף בן מתתיהו התאבדו המגינים כדי לא ליפול בשבי, ואופי הדברים נתון בוויכוח. בשטח נשמרו מחנות המצור וסוללת הכיבוש הרומית.",
    "rank": 226
  },
  {
    "id": "med_marco_polo",
    "deck": "anchors",
    "title": "מסעו של מרקו פולו לסין",
    "start": 1271,
    "end": 1295,
    "date": "⁦1271–1295⁩",
    "place": "ונציה, איטליה",
    "lat": 45.44,
    "lon": 12.335,
    "desc": "הסוחר הוונציאני מרקו פולו יצא עם אביו ודודו מזרחה לאורך דרך המשי וחי שנים בחצרו של קובלאי חאן. עם שובו הכתיב את זכרונותיו, ״ספר המיליון״, שהציג לאירופים את סין ואסיה. חוקרים חלוקים עד כמה הוא מתאר ניסיון אישי.",
    "rank": 227
  },
  {
    "id": "mod_pearl_harbor",
    "deck": "anchors",
    "title": "המתקפה על פרל הארבור",
    "start": 1941,
    "end": 1941,
    "date": "1941",
    "place": "פרל הארבור, הוואי, ארה״ב",
    "lat": 21.35,
    "lon": -157.97,
    "desc": "ב־7 בדצמבר תקפו מטוסי יפן את הבסיס הימי האמריקני בפרל הארבור. כ־2,400 אמריקנים נהרגו, וכמה ספינות מערכה הושמדו או ניזוקו. למחרת הכריזה ארצות הברית מלחמה על יפן, ובהמשך גרמניה ואיטליה הכריזו עליה מלחמה, והמלחמה הפכה לעולמית באמת.",
    "rank": 228
  },
  {
    "id": "anq_troy",
    "deck": "anchors",
    "title": "חורבן טרויה השביעית",
    "start": -1180,
    "end": -1180,
    "date": "בערך 1180 לפנה״ס",
    "place": "חיסרליק, טורקיה",
    "lat": 39.957,
    "lon": 26.239,
    "desc": "באתר חיסרליק שבצפון מערב אנטוליה נחשפו שכבות רבות של העיר טרויה, ואחת מהן, השביעית, נשרפה סביב 1180 לפנה״ס. אפשר שהחורבן עומד ברקע האגדה על מלחמת טרויה שבה ספר הומרוס, אך הקשר אינו מוכח.",
    "rank": 229
  },
  {
    "id": "med_granada",
    "deck": "anchors",
    "title": "נפילת גרנדה",
    "start": 1492,
    "end": 1492,
    "date": "1492",
    "place": "גרנדה, ספרד",
    "lat": 37.177,
    "lon": -3.588,
    "desc": "פרננדו ואיזבלה כבשו את גרנדה, מעוזו האחרון של הממלכה המוסלמית בספרד, אחרי מצור ארוך. עם כניעת האמיר מוחמד השתים־עשר הסתיימה הרקונקיסטה הנוצרית, שנמשכה כמה מאות שנים. חוזה הכניעה הבטיח תחילה חופש דת למוסלמים, אך לא כובד לאורך זמן.",
    "rank": 230
  },
  {
    "id": "mod_jfk",
    "deck": "anchors",
    "title": "רצח הנשיא קנדי",
    "start": 1963,
    "end": 1963,
    "date": "1963",
    "place": "דאלאס, טקסס, ארה״ב",
    "lat": 32.779,
    "lon": -96.809,
    "desc": "ב־22 בנובמבר נורה הנשיא ג׳ון קנדי למוות בשיירת מכוניות פתוחה בדאלאס. לי הארווי אוסוולד נעצר וחוסל כעבור יומיים בידי ג׳ק רובי. ועדת וורן קבעה שאוסוולד פעל לבדו, אך השערות אחרות המשיכו לעסוק בציבור. סגנו, לינדון ג׳ונסון, נכנס לתפקיד.",
    "rank": 231
  },
  {
    "id": "anq_stonehenge",
    "deck": "anchors",
    "title": "הקמת המעגל הראשון בסטונהנג׳",
    "start": -3000,
    "end": -3000,
    "date": "בערך 3000 לפנה״ס",
    "place": "סולסברי, אנגליה",
    "lat": 51.179,
    "lon": -1.826,
    "desc": "בשלב הראשון של סטונהנג׳ נחפרו תעלה ועליה סוללה עגולה, ובה חורים שבהם נקברו שרידי שריפה. אבני הענק המפורסמות הוקמו רק כאלף שנה מאוחר יותר. מטרת האתר שנויה במחלוקת, וההשערות כוללות מקום קבורה, פולחן ותצפית על השמש.",
    "rank": 232
  },
  {
    "id": "med_genghis",
    "deck": "anchors",
    "title": "ג׳ינגיס חאן מוכרז כשליט המונגולים",
    "start": 1206,
    "end": 1206,
    "date": "1206",
    "place": "נהר אונון, מונגוליה",
    "lat": 48.8,
    "lon": 110.9,
    "desc": "בכינוס שבטים גדול הוכרז טמוג׳ין, שאיחד את השבטים המונגוליים, כג׳ינגיס חאן. הוא ארגן צבא ממושמע וחוק אחיד, והחל במסעות שיצרו את האימפריה הגדולה ביותר ברצף יבשתי בהיסטוריה. עד מותו ב־1227 השתרעה האימפריה מהים הצהוב ועד הים הכספי.",
    "rank": 233
  },
  {
    "id": "waterloo",
    "deck": "anchors",
    "title": "קרב ווטרלו",
    "start": 1815,
    "end": 1815,
    "date": "1815",
    "place": "ווטרלו, בלגיה",
    "lat": 50.68,
    "lon": 4.41,
    "desc": "נפוליאון, ששב מגלותו באלבה, הובס בידי צבא בהובלה בריטית בפיקוד ולינגטון ובידי צבא פרוסי בפיקוד בליכר. הקרב שם קץ לשובו לשלטון, ״מאה הימים״. נפוליאון הוגלה לאי סנט הלנה, וקונגרס וינה עיצב את אירופה לעשרות שנים.",
    "rank": 234
  },
  {
    "id": "anq_tutankhamun",
    "deck": "anchors",
    "title": "מות תות־ענח־אמון",
    "start": -1323,
    "end": -1323,
    "date": "בערך 1323 לפנה״ס",
    "place": "עמק המלכים, מצרים",
    "lat": 25.74,
    "lon": 32.6,
    "desc": "תות־ענח־אמון עלה לשלטון כילד וחזר לפולחן האלים המסורתי אחרי ימי אחנאתון, ומת בגיל כשמונה עשרה. קברו נמצא כמעט שלם ב־1922 בידי הווארד קרטר, ובו מסכת זהב ואוצרות רבים. סיבת מותו אינה ידועה בוודאות.",
    "rank": 235
  },
  {
    "id": "med_magellan",
    "deck": "anchors",
    "title": "מסע ההקפה של מגלן",
    "start": 1519,
    "end": 1522,
    "date": "⁦1519–1522⁩",
    "place": "סביליה, ספרד",
    "lat": 37.39,
    "lon": -5.99,
    "desc": "צי של חמש ספינות בפיקוד פרדיננד מגלן יצא מספרד כדי להגיע לאיי התבלינים דרך המערב. מגלן נהרג בפיליפינים ב־1521. ספינה אחת, ויקטוריה, בפיקוד חואן סבסטיאן אלקנו, חזרה ב־1522 וסיימה את ההקפה הראשונה של העולם.",
    "rank": 236
  },
  {
    "id": "sarajevo",
    "deck": "anchors",
    "title": "ההתנקשות בסרייבו",
    "start": 1914,
    "end": 1914,
    "date": "1914",
    "place": "סרייבו, בוסניה",
    "lat": 43.858,
    "lon": 18.428,
    "desc": "ב־28 ביוני ירה הסטודנט הסרבי־בוסני גברילו פרינציפ בארכידוכס פרנץ פרדיננד, יורש העצר של אוסטרו־הונגריה, ובאשתו סופי. אוסטרו־הונגריה האשימה את סרביה, ובתוך שבועות משכה מערכת הבריתות את רוסיה, גרמניה, צרפת ובריטניה. המשבר הפך למלחמת העולם הראשונה.",
    "rank": 237
  },
  {
    "id": "cyrus",
    "deck": "anchors",
    "title": "כורש הגדול כובש את בבל",
    "start": -539,
    "end": -539,
    "date": "539 לפנה״ס",
    "place": "בבל, מסופוטמיה",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "כורש השני, מלך פרס, כבש את בבל ושם קץ לאימפריה הבבלית החדשה של מלכה האחרון, נבונאיד. הכיבוש הפך את האימפריה הפרסית האחמנית לגדולה ביותר שידע העולם עד אז. כורש התיר לעמים שהוגלו, ובהם גולי יהודה שהגלה נבוכדנאצר, לשוב לארצם ולבנות מחדש את מקדשיהם.",
    "rank": 238
  },
  {
    "id": "med_cortes",
    "deck": "anchors",
    "title": "קורטס כובש את האימפריה האצטקית",
    "start": 1519,
    "end": 1521,
    "date": "⁦1519–1521⁩",
    "place": "טנוצ׳טיטלן, מקסיקו",
    "lat": 19.43,
    "lon": -99.13,
    "desc": "ארנאן קורטס הגיע עם כמה מאות ספרדים לחוף מקסיקו, בעזרת בריתות עם עמי המקום שהתנגדו לאצטקים הוביל למצור על טנוצ׳טיטלן. העיר נפלה ב־1521, אחרי מגפת האבעבועות שהכתה את תושביה. בירה ספרדית הוקמה על חורבותיה.",
    "rank": 239
  },
  {
    "id": "october",
    "deck": "anchors",
    "title": "מהפכת אוקטובר",
    "start": 1917,
    "end": 1917,
    "date": "1917",
    "place": "פטרוגרד (סנקט פטרבורג), רוסיה",
    "lat": 59.94,
    "lon": 30.314,
    "desc": "הבולשביקים בהנהגת ולדימיר לנין תפסו את השלטון בפטרוגרד מידי הממשלה הזמנית, שהחליפה את הצאר מוקדם יותר באותה שנה. האבדות במלחמה, הרעב והתסיסה הפכו את הממשלה ללא פופולרית בעליל. פרצה מלחמת אזרחים, וב־1922 נוסדה ברית המועצות.",
    "rank": 240
  },
  {
    "id": "hammurabi",
    "deck": "anchors",
    "title": "חמורבי מפרסם את קובץ החוקים שלו",
    "start": -1754,
    "end": -1754,
    "date": "בערך 1754 לפנה״ס",
    "place": "בבל, מסופוטמיה",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "חמורבי, מלך בבל, פרסם את אחד מקובצי החוקים הכתובים המוקדמים והשלמים ביותר: 282 חוקים שנחקקו על אסטלה של אבן שחורה. העונשים נקבעו לפי מעמד חברתי, וביניהם עיקרון ״עין תחת עין״. בימי שלטונו הפכה בבל זה עתה למעצמה השלטת במסופוטמיה.",
    "rank": 241
  },
  {
    "id": "med_gama",
    "deck": "anchors",
    "title": "ואסקו דה גמה מגיע להודו",
    "start": 1498,
    "end": 1498,
    "date": "1498",
    "place": "קליקוט, הודו",
    "lat": 11.25,
    "lon": 75.78,
    "desc": "הנווט הפורטוגלי ואסקו דה גמה עקף את אפריקה והגיע לחוף מלבר בהודו, בעזרת נווטים מקומיים ממזרח אפריקה. נתיב הים החדש איפשר לפורטוגל לעקוף את הסוחרים המוסלמים והוונציאנים ולשלוט בסחר התבלינים. אירופה נכנסה לאוקיינוס ההודי.",
    "rank": 242
  },
  {
    "id": "mod_six_day",
    "deck": "anchors",
    "title": "מלחמת ששת הימים",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "ירושלים",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "ב־5 ביוני פתחה ישראל בהתקפה על מצרים, אחרי סגירת מצרי טיראן והתגברות המתיחות, וחברו אליה ירדן וסוריה. תוך שישה ימים כבשה ישראל את סיני, רצועת עזה, הגדה המערבית כולל מזרח ירושלים ואת רמת הגולן. הכיבוש שינה את המפה והוא עדיין מרכזי בסכסוך.",
    "rank": 243
  },
  {
    "id": "anq_bar_kokhba",
    "deck": "anchors",
    "title": "מרד בר כוכבא",
    "start": 132,
    "end": 135,
    "date": "⁦132–135⁩ לספירה",
    "place": "ביתר, יהודה",
    "lat": 31.7,
    "lon": 35.12,
    "desc": "שמעון בר כוכבא הנהיג מרד יהודי נגד רומא, בין היתר בעקבות תוכניות אדריאנוס להקים באיליה קפיטולינה על חורבות ירושלים. המורדים הקימו מדינה זמנית והטביעו מטבעות. המרד דוכא בקשיות, ורבים נהרגו ונמכרו לעבדות; היהודים נאסרו להיכנס לירושלים.",
    "rank": 244
  },
  {
    "id": "med_armada",
    "deck": "anchors",
    "title": "הארמדה הספרדית",
    "start": 1588,
    "end": 1588,
    "date": "1588",
    "place": "גרוולין, צרפת",
    "lat": 51,
    "lon": 2.1,
    "desc": "פליפה השני שלח צי גדול כדי להפיל את אליזבת הראשונה ולהחזיר את אנגליה לקתוליות. ספינות אנגליות קטנות ומהירות, סערות ומחסור באספקה גרמו לכישלון הצי. הצי חזר בהפסדים כבדים, ובעיני האנגלים הכישלון נחשב לניצחון מוסרי.",
    "rank": 245
  },
  {
    "id": "mod_auschwitz",
    "deck": "anchors",
    "title": "אושוויץ־בירקנאו",
    "start": 1940,
    "end": 1945,
    "date": "⁦1940–1945⁩",
    "place": "אושוויץ, פולין",
    "lat": 50.03,
    "lon": 19.18,
    "desc": "המחנה הוקם ב־1940 סמוך לקראקוב כמחנה ריכוז, ובמחצית 1942 הפך בבירקנאו למחנה השמדה עם תאי גזים. כמיליון יהודים נרצחו בו, וגם עשרות אלפי פולנים, צוענים, שבויים סובייטים ואחרים. הצבא האדום שחרר את המחנה ב־27 בינואר 1945.",
    "rank": 246
  },
  {
    "id": "anq_alexandria",
    "deck": "anchors",
    "title": "ייסוד אלכסנדריה",
    "start": -331,
    "end": -331,
    "date": "331 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.92,
    "desc": "אלכסנדר הגדול יסד על חוף הים התיכון, לצד האי פארוס, עיר שנקראה על שמו. בתקופת התלמיים הפכה לבירה, לנמל גדול ולמרכז מדע ותרבות עם ספרייה ומוזיאון. קהילה יהודית גדולה חיה בה, ושם נעשה תרגום התורה ליוונית.",
    "rank": 247
  },
  {
    "id": "mod_kristallnacht",
    "deck": "anchors",
    "title": "ליל הבדולח",
    "start": 1938,
    "end": 1938,
    "date": "1938",
    "place": "ברלין, גרמניה",
    "lat": 52.504,
    "lon": 13.328,
    "desc": "בלילה שבין 9 ל־10 בנובמבר פרעו אנשי המפלגה הנאצית והאס־אה ביהודי גרמניה ואוסטריה. כ־1,400 בתי כנסת נשרפו, חנויות יהודיות נבזזו, כ־90 יהודים נרצחו וכ־30 אלף גברים נשלחו למחנות ריכוז. האירוע סימן החרפה חדה ברדיפת היהודים בגרמניה הנאצית.",
    "rank": 248
  },
  {
    "id": "anq_carthage_fall",
    "deck": "anchors",
    "title": "חורבן קרתגו",
    "start": -146,
    "end": -146,
    "date": "146 לפנה״ס",
    "place": "קרתגו, טוניסיה",
    "lat": 36.85,
    "lon": 10.32,
    "desc": "בתום מלחמת פוניק השלישית כבש סקיפיו אמיליאנוס את קרתגו אחרי מצור של שלוש שנים והחריב אותה. שרידי האוכלוסייה נמכרו לעבדות והעיר נשרפה. אותה שנה הרסו הרומאים גם את קורינתוס ביוון, ורומא נעשתה המעצמה העיקרית בים התיכון.",
    "rank": 249
  },
  {
    "id": "med_last_supper",
    "deck": "anchors",
    "title": "הסעודה האחרונה של לאונרדו",
    "start": 1495,
    "end": 1498,
    "date": "⁦1495–1498⁩",
    "place": "מילאנו, איטליה",
    "lat": 45.466,
    "lon": 9.171,
    "desc": "לאונרדו דה וינצ׳י צייר את הסעודה האחרונה על קיר חדר האוכל של מנזר סנטה מריה דלה גרציה. היצירה הציגה את רגע הבשורה על הבגידה בעומק פסיכולוגי וביחס מדויק בין הדמויות. בשל שיטת הציור הניסיונית, הצבע החל להתקלף כבר בימי חייו.",
    "rank": 250
  },
  {
    "id": "mod_yom_kippur",
    "deck": "anchors",
    "title": "מלחמת יום הכיפורים",
    "start": 1973,
    "end": 1973,
    "date": "1973",
    "place": "תעלת סואץ",
    "lat": 30.6,
    "lon": 32.3,
    "desc": "ב־6 באוקטובר, ביום הכיפורים, תקפו מצרים וסוריה את ישראל בהפתעה, והיא נאלצה לסגת בימים הראשונים. אחר כך התייצבו כוחות ישראל והתקדמו בשני החזיתות. המלחמה שנמשכה כשלושה שבועות, הובילה לאובדן של אלפי חיילים ולמשבר פוליטי, ולהסכמי הפרדת כוחות.",
    "rank": 251
  },
  {
    "id": "anq_hannibal_alps",
    "deck": "anchors",
    "title": "חניבעל חוצה את האלפים",
    "start": -218,
    "end": -218,
    "date": "218 לפנה״ס",
    "place": "האלפים, צרפת ואיטליה",
    "lat": 45.1,
    "lon": 6.9,
    "desc": "חניבעל, מצביא קרתגי, הוביל צבא ובו פילים מספרד דרך הרי האלפים והגיע לצפון איטליה בתחילת מלחמת פוניק השנייה. הצבא איבד חלק גדול מאנשיו במעבר. הוא ניצח את הרומאים בקרבות הראשונים ופתח במסע של שנים באיטליה.",
    "rank": 252
  },
  {
    "id": "med_copernicus",
    "deck": "anchors",
    "title": "קופרניקוס מפרסם את תורת השמש במרכז",
    "start": 1543,
    "end": 1543,
    "date": "1543",
    "place": "פרומבורק, פולין",
    "lat": 54.37,
    "lon": 19.69,
    "desc": "ניקולאוס קופרניקוס, כנסייתן ואסטרונום, פרסם את ספרו על סיבובי הגרמים השמימיים, שבו הציע שכדור הארץ וכוכבי הלכת נעים סביב השמש. הספר יצא לאור סמוך למותו. הרעיון היה נקודת מוצא למהפכה המדעית.",
    "rank": 253
  },
  {
    "id": "mod_wall_street",
    "deck": "anchors",
    "title": "התרסקות וול סטריט",
    "start": 1929,
    "end": 1929,
    "date": "1929",
    "place": "וול סטריט, ניו יורק, ארה״ב",
    "lat": 40.707,
    "lon": -74.011,
    "desc": "באוקטובר התרסקו מניות בבורסה של ניו יורק אחרי שנים של עליות מהירות ושל קנייה באשראי. הבנקים קרסו, והמשבר התפשט לכל העולם והפך לשפל הגדול. מיליוני בני אדם איבדו את עבודתם, והאבטלה ועוני הניעו תנועות קיצוניות באירופה.",
    "rank": 254
  },
  {
    "id": "anq_rubicon",
    "deck": "anchors",
    "title": "חציית הרוביקון",
    "start": -49,
    "end": -49,
    "date": "49 לפנה״ס",
    "place": "רימיני, איטליה",
    "lat": 44.1,
    "lon": 12.3,
    "desc": "יוליוס קיסר חצה את נהר הרוביקון שהיה גבול פרובינקיית גאליה, עם לגיון חמוש, בניגוד לחוק, ופתח במלחמת אזרחים נגד פומפיוס והסנאט. הביטוי ״חציית הרוביקון״ הפך משל להחלטה שאין ממנה חזרה. לפי המסורת אמר קיסר ״הקוביה נפלה״. המלחמה הסתיימה בניצחונו ובשלטונו כדיקטטור.",
    "rank": 255
  },
  {
    "id": "med_galileo",
    "deck": "anchors",
    "title": "גלילאו מכוון טלסקופ לשמים",
    "start": 1610,
    "end": 1610,
    "date": "1610",
    "place": "פדובה, איטליה",
    "lat": 45.41,
    "lon": 11.88,
    "desc": "גלילאו גליליי השתמש בטלסקופ כדי לצפות בירחי צדק, בהרי הירח ובשלבי נוגה, ופרסם את תצפיותיו בספר שליח הכוכבים. התצפיות סתרו תפיסות עתיקות והפכו את התאוריה של קופרניקוס לאמינה יותר. בהמשך נקלע גלילאו לסכסוך עם הכנסייה.",
    "rank": 256
  },
  {
    "id": "mod_wall_built",
    "deck": "anchors",
    "title": "בניית חומת ברלין",
    "start": 1961,
    "end": 1961,
    "date": "1961",
    "place": "ברלין, גרמניה",
    "lat": 52.535,
    "lon": 13.39,
    "desc": "בלילה שבין 12 ל־13 באוגוסט החלו שלטונות מזרח גרמניה לגדר את מערב ברלין בגדרות תיל, ואחר כך בחומת בטון. מיליוני גרמנים כבר ברחו מהמזרח למערב דרך העיר, ושלטונות המזרח ביקשו לעצור את הנהירה. החומה, שניצבה עד 1989, הפכה לסמל המלחמה הקרה.",
    "rank": 257
  },
  {
    "id": "anq_spartacus",
    "deck": "anchors",
    "title": "מרד ספרטקוס",
    "start": -73,
    "end": -71,
    "date": "⁦73–71⁩ לפנה״ס",
    "place": "קפואה והר וזוב, איטליה",
    "lat": 41.08,
    "lon": 14.33,
    "desc": "עבדים וגלדיאטורים ברחו מבית ספר ללוחמים בקפואה בהנהגת ספרטקוס, ולמרד הצטרפו עשרות אלפי עבדים. הם ניצחו כמה צבאות רומיים לפני שקראסוס הביס אותם. אלפי שבויים נצלבו לאורך הדרך האפיית. המרד, שנמשך כשנתיים, היה מהמרדות החמורות של עבדים בעולם העתיק, והוא הדאיג את רומא עמוקות.",
    "rank": 258
  },
  {
    "id": "hijra",
    "deck": "anchors",
    "title": "ההג׳רה למדינה",
    "start": 622,
    "end": 622,
    "date": "622",
    "place": "מדינה, חצי האי ערב",
    "lat": 24.468,
    "lon": 39.611,
    "desc": "בעקבות רדיפות במכה היגרו הנביא מוחמד ומאמיניו לעיר הנווה יאת׳ריב, שלימים נקראה מדינה. שם הפך למנהיג פוליטי ולא רק דתי של קהילה הולכת וגדלה. שנת ההג׳רה נקבעה מאוחר יותר כשנה הראשונה בלוח השנה המוסלמי.",
    "rank": 259
  },
  {
    "id": "anq_olympics",
    "deck": "anchors",
    "title": "אולימפיאדה ראשונה",
    "start": -776,
    "end": -776,
    "date": "בערך 776 לפנה״ס",
    "place": "אולימפיה, יוון",
    "lat": 37.638,
    "lon": 21.63,
    "desc": "התאריך המסורתי למשחקים האולימפיים הראשונים, שנערכו לכבוד זאוס באולימפיה שבפלופונס. בתחרות הראשונה נערך כנראה רק מרוץ אחד, וערים יווניות הפסיקו את מלחמותיהן בזמן המשחקים. היוונים מנו את השנים לפי האולימפיאדות.",
    "rank": 260
  },
  {
    "id": "med_inquisition",
    "deck": "anchors",
    "title": "האינקוויזיציה הספרדית",
    "start": 1478,
    "end": 1478,
    "date": "1478",
    "place": "סביליה, ספרד",
    "lat": 37.39,
    "lon": -5.99,
    "desc": "בהסכמת האפיפיור סיקסטוס הרביעי הקימו המלכים הקתוליים בית דין שעסק בחקירת כפירה, בעיקר בקרב מומרים מיהדות שנחשדו בהמשך שמירת מנהגיהם. הוא פעל תחילה בסביליה ואחר כך ברחבי ספרד. אלפים נשרפו על המוקד או נענשו בדרכים אחרות.",
    "rank": 261
  },
  {
    "id": "mod_nagasaki",
    "deck": "anchors",
    "title": "הפצצה האטומית על נגסאקי",
    "start": 1945,
    "end": 1945,
    "date": "1945",
    "place": "נגסאקי, יפן",
    "lat": 32.77,
    "lon": 129.87,
    "desc": "ב־9 באוגוסט, שלושה ימים אחרי הירושימה, הוטלה על נגסאקי פצצה אטומית שנייה. עשרות אלפי בני אדם נהרגו מיד, ובשנים הבאות מתו רבים מהקרינה. ב־15 באוגוסט הודיע הקיסר הירוהיטו על כניעת יפן, והמלחמה העולמית השנייה הסתיימה.",
    "rank": 262
  },
  {
    "id": "med_vinland",
    "deck": "anchors",
    "title": "הוויקינגים ביבשת אמריקה",
    "start": 1000,
    "end": 1000,
    "date": "בערך 1000",
    "place": "לאנס או מדוז, ניופאונדלנד (קנדה)",
    "lat": 51.62,
    "lon": -55.53,
    "desc": "לפי הסאגות הנורדיות הגיע לייף אריקסון מגרינלנד אל חוף שקרא לו וינלנד. באתר ארכאולוגי בצפון ניופאונדלנד נחשפו שרידי יישוב נורדי מתחילת המאה ה־11, והוא מוכיח שהוויקינגים הגיעו לאמריקה כ־500 שנה לפני קולומבוס. היישוב לא האריך ימים.",
    "rank": 263
  },
  {
    "id": "mod_hitler",
    "deck": "anchors",
    "title": "מינוי היטלר לקנצלר",
    "start": 1933,
    "end": 1933,
    "date": "1933",
    "place": "ברלין, גרמניה",
    "lat": 52.516,
    "lon": 13.38,
    "desc": "ב־30 בינואר מינה הנשיא הינדנבורג את אדולף היטלר, מנהיג המפלגה הנאצית, לקנצלר גרמניה. בתוך חודשים, לאחר שריפת הרייכסטאג וחוק ההסמכה, ביטל היטלר את הדמוקרטיה, הוציא מחוץ לחוק את יריביו והקים דיקטטורה חד־מפלגתית.",
    "rank": 264
  },
  {
    "id": "anq_parthenon",
    "deck": "anchors",
    "title": "בניית הפרתנון",
    "start": -447,
    "end": -432,
    "date": "⁦447–432⁩ לפנה״ס",
    "place": "האקרופוליס, אתונה, יוון",
    "lat": 37.97,
    "lon": 23.73,
    "desc": "בימי פריקלס נבנה מקדש לאתנה על האקרופוליס בידי האדריכלים איקטינוס וקליקראטס, ופידיאס פיקח על הפיסול. המימון בא בחלקו מקופת ברית דלוס. המבנה הדורי הוא מהישגי האדריכלות היוונית הקלאסית ומסמל את שיא פריחתה של אתונה.",
    "rank": 265
  },
  {
    "id": "med_pizarro",
    "deck": "anchors",
    "title": "פיסארו תופס את הקיסר אטאוואלפה",
    "start": 1532,
    "end": 1532,
    "date": "1532",
    "place": "קחמרקה, פרו",
    "lat": -7.16,
    "lon": -78.51,
    "desc": "פרנסיסקו פיסארו, עם כ־170 ספרדים, תפס את אטאוואלפה, קיסר האינקה, בקחמרקה. אטאוואלפה שילם כופר בזהב וכסף, אך הוצא להורג ב־1533. אחרי מלחמת אזרחים בין שני אחים יורשי הכתר ומחלות שהכו בתושבים, נפלה האימפריה האינקית לידי הספרדים.",
    "rank": 266
  },
  {
    "id": "mod_ussr_end",
    "deck": "anchors",
    "title": "פירוק ברית המועצות",
    "start": 1991,
    "end": 1991,
    "date": "1991",
    "place": "מוסקבה, ברית המועצות",
    "lat": 55.75,
    "lon": 37.62,
    "desc": "אחרי הפיכה כושלת באוגוסט ובעקבות הכרזות עצמאות של הרפובליקות, התפטר מיכאיל גורבצ׳וב ב־25 בדצמבר מנשיאות ברית המועצות. למחרת פורקה המדינה רשמית ל־15 מדינות עצמאיות. פירוק הברית סיים את המלחמה הקרה ואת עידן העולם הדו־קוטבי.",
    "rank": 267
  },
  {
    "id": "qin",
    "deck": "anchors",
    "title": "צ׳ין מאחדת את סין",
    "start": -221,
    "end": -221,
    "date": "221 לפנה״ס",
    "place": "שיאניאנג, סין",
    "lat": 34.33,
    "lon": 108.71,
    "desc": "המלך יינג ג׳נג ממדינת צ׳ין כבש את אחרונת המדינות הלוחמות היריבות ונטל את התואר צ׳ין שי חואנג, ״הקיסר הראשון״. הוא האחיד את הכתב, המטבע, המשקלות והמידות, וחיבר חומות גבול קדומות לחומה גדולה מוקדמת. שושלתו נפלה זמן קצר אחרי מותו, אך רעיון סין המאוחדת שרד.",
    "rank": 268
  },
  {
    "id": "med_lindisfarne",
    "deck": "anchors",
    "title": "פשיטת הוויקינגים על המנזר בלינדיספרן",
    "start": 793,
    "end": 793,
    "date": "793 לספירה",
    "place": "האי הקדוש לינדיספרן, אנגליה",
    "lat": 55.67,
    "lon": -1.8,
    "desc": "לוחמים סקנדינבים הגיעו בספינות אל מנזר על אי ליד חופי נורת׳מבריה, בזזו אותו והרגו נזירים. הפשיטה נחשבת לפתיחת עידן הוויקינגים באירופה. בעקבותיה פשטו הוויקינגים על חופי איי הבריטים ואירלנד וצרפת, ובהמשך התיישבו שם.",
    "rank": 269
  },
  {
    "id": "mod_stalingrad",
    "deck": "anchors",
    "title": "קרב סטלינגרד",
    "start": 1942,
    "end": 1943,
    "date": "⁦1942–1943⁩",
    "place": "סטלינגרד (וולגוגרד), רוסיה",
    "lat": 48.71,
    "lon": 44.51,
    "desc": "מאוגוסט 1942 ועד פברואר 1943 נלחמו הגרמנים והסובייטים על העיר ברחובותיה ובחורבותיה. מתקפת נגד סובייטית כתרה את הארמייה השישית של גרמניה, וכ־90 אלף חיילים נפלו בשבי. הקרב נחשב לנקודת מפנה במלחמה בחזית המזרחית, ומאז נסוג הצבא הגרמני.",
    "rank": 270
  },
  {
    "id": "med_muhammadbirth",
    "deck": "anchors",
    "title": "לידת מוחמד",
    "start": 570,
    "end": 570,
    "date": "בערך 570 לספירה",
    "place": "מכה, חצי האי ערב",
    "lat": 21.42,
    "lon": 39.83,
    "desc": "לפי המסורת המוסלמית נולד מוחמד בן עבדאללה בעיר מכה, שבטה של קורייש. הוא נולד יתום מאב וגדל אצל סבו ואחר כך אצל דודו. היסטוריונים מציינים כי התאריך המדויק אינו ידוע, והמקובל הוא סביב שנות ה־570.",
    "rank": 271
  },
  {
    "id": "med_tours",
    "deck": "anchors",
    "title": "קרב טור ופואטייה",
    "start": 732,
    "end": 732,
    "date": "732 לספירה",
    "place": "בין טור לפואטייה, צרפת",
    "lat": 46.75,
    "lon": 0.55,
    "desc": "צבא פרנקי בפיקוד קרל מרטל עצר פשיטה מוסלמית גדולה מאנדלוסיה, בהנהגת עבד אל־רחמן אל־גאפקי. הקרב מוזכר בהיסטוריוגרפיה האירופית כנקודת תפנית. היסטוריונים רבים רואים בו היום פשיטה גדולה, ולא ניסיון כיבוש שלם של גאליה.",
    "rank": 272
  },
  {
    "id": "mod_balfour",
    "deck": "anchors",
    "title": "הצהרת בלפור",
    "start": 1917,
    "end": 1917,
    "date": "1917",
    "place": "לונדון, בריטניה",
    "lat": 51.5,
    "lon": -0.127,
    "desc": "ב־2 בנובמבר שלח שר החוץ הבריטי ארתור בלפור מכתב לליונל וולטר רוטשילד, ובו הצהרת ממשלת בריטניה שהיא רואה בעין יפה הקמת בית לאומי לעם היהודי בארץ ישראל, בלי לפגוע בזכויותיהן של הקהילות הלא־יהודיות. ההצהרה נכללה במנדט הבריטי על ארץ ישראל מ־1922.",
    "rank": 273
  },
  {
    "id": "anq_nicaea",
    "deck": "anchors",
    "title": "מועצת ניקיאה",
    "start": 325,
    "end": 325,
    "date": "325 לספירה",
    "place": "ניקיאה, טורקיה",
    "lat": 40.43,
    "lon": 29.72,
    "desc": "קונסטנטינוס כינס בישופים מכל האימפריה כדי ליישב את המחלוקת על טבעו של ישו בין אריוס לאתנסיוס. המועצה ניסחה את אמונת ניקיאה וקבעה סדרי כנסייה. זו המועצה האקומנית הראשונה בתולדות הנצרות. המועצה גינתה את אריוס וקבעה שהבן והאב הם ״מאותו חומר״, וגם החליטה על חישוב מועד חג הפסחא.",
    "rank": 274
  },
  {
    "id": "med_fourth_crusade",
    "deck": "anchors",
    "title": "צלבנים כובשים את קונסטנטינופול",
    "start": 1204,
    "end": 1204,
    "date": "1204",
    "place": "קונסטנטינופול",
    "lat": 41,
    "lon": 28.97,
    "desc": "צלבנים וצי ונציאני, שנקלעו לחובות וסטו מיעדם המקורי במצרים, כבשו את בירת האימפריה הביזנטית ובזזו אותה. הם הקימו את האימפריה הלטינית, ואילו יורשי ביזנטיון הקימו מדינות נפרדות, ובהן ניקאה. הביזנטים חזרו לעיר ב־1261, אך האימפריה לא התאוששה לגמרי.",
    "rank": 275
  },
  {
    "id": "mod_basel",
    "deck": "anchors",
    "title": "הקונגרס הציוני הראשון",
    "start": 1897,
    "end": 1897,
    "date": "1897",
    "place": "באזל, שווייץ",
    "lat": 47.56,
    "lon": 7.59,
    "desc": "באוגוסט כינס בנימין זאב הרצל בבאזל את הקונגרס הציוני הראשון, בהשתתפות כ־200 צירים יהודים. תוכנית באזל קבעה כמטרה להקים בית לאומי לעם היהודי בארץ ישראל בהכרה משפטית. הקונגרס ייסד את ההסתדרות הציונית כגוף מארגן, והוא נחשב לנקודת מוצא של הציונות המדינית.",
    "rank": 276
  },
  {
    "id": "anq_augustus",
    "deck": "anchors",
    "title": "אוגוסטוס הופך לקיסר הראשון",
    "start": -27,
    "end": -27,
    "date": "27 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.49,
    "desc": "הסנאט העניק לאוקטביאנוס את התואר אוגוסטוס ואת סמכויות נרחבות, ואילו הוא הצהיר על החזרת הרפובליקה. בפועל הנהיג שלטון יחיד שנקרא הפרינקיפט ושרד כמאתיים שנה. תקופת שלטונו הסתיימה בשלום יחסי, בפיתוח מבנים ובצמיחה כלכלית.",
    "rank": 277
  },
  {
    "id": "mod_louis16",
    "deck": "anchors",
    "title": "הוצאתו להורג של לואי ה־16",
    "start": 1793,
    "end": 1793,
    "date": "1793",
    "place": "פריז, צרפת",
    "lat": 48.866,
    "lon": 2.321,
    "desc": "לאחר משפט בפני הוועידה הלאומית הוצא המלך לשעבר להורג בגיליוטינה בכיכר המהפכה. הוצאתו הביאה את המלכים של אירופה להתאחד נגד צרפת, ומילאה תפקיד מרכזי בהקצנת המהפכה. חודשים אחר כך החלה תקופת הטרור.",
    "rank": 278
  },
  {
    "id": "anq_odoacer",
    "deck": "anchors",
    "title": "הדחת רומולוס אוגוסטולוס",
    "start": 476,
    "end": 476,
    "date": "476 לספירה",
    "place": "ראוונה, איטליה",
    "lat": 44.42,
    "lon": 12.2,
    "desc": "אודואקר, מפקד גרמני בצבא איטליה, הדיח את הקיסר הנער רומולוס אוגוסטולוס ופנה לקיסר במזרח. תאריך זה נחשב מסורתית לקץ האימפריה הרומית המערבית. במציאות הייתה זו תקופה של שקיעה הדרגתית. אודואקר שלט באיטליה כמלך כשלוש־עשרה שנים, עד שהוחלף בידי תאודוריך האוסטרוגותי.",
    "rank": 279
  },
  {
    "id": "med_acre",
    "deck": "anchors",
    "title": "נפילת עכו",
    "start": 1291,
    "end": 1291,
    "date": "1291",
    "place": "עכו, ישראל",
    "lat": 32.92,
    "lon": 35.07,
    "desc": "הסולטן הממלוכי אל־אשרף ח׳ליל כבש את עכו, מעוזם האחרון של הצלבנים בארץ ישראל, אחרי מצור של כמה שבועות. תושבים רבים נטבחו או נמלטו בים. בתוך שנים ספורות איבדו הצלבנים את שאר אחיזתם בחוף המזרחי של הים התיכון.",
    "rank": 280
  },
  {
    "id": "mod_versailles",
    "deck": "anchors",
    "title": "הסכם ורסאי",
    "start": 1919,
    "end": 1919,
    "date": "1919",
    "place": "ורסאי, צרפת",
    "lat": 48.805,
    "lon": 2.12,
    "desc": "ב־28 ביוני נחתם באולם המראות בארמון ורסאי ההסכם שסיים רשמית את מלחמת העולם הראשונה. גרמניה נאלצה לוותר על שטחים, לצמצם את צבאה ולשלם פיצויים, ולקבל אחריות למלחמה. תנאי ההסכם עוררו מרירות גדולה בגרמניה וניצלו מאוחר יותר בתעמולה הלאומנית.",
    "rank": 281
  },
  {
    "id": "anq_rome_fire",
    "deck": "anchors",
    "title": "השריפה הגדולה ברומא",
    "start": 64,
    "end": 64,
    "date": "64 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.49,
    "desc": "שריפה פרצה ליד קרקס מכסימוס ובערה כשבעה ימים, והרסה חלקים נרחבים מן העיר. נרון האשים את הנוצרים, ובעקבות כך נערפו נוצרים רבים לפי טקיטוס. נרון בנה לעצמו ארמון ענק, ״הבית הזהב״, באדמות שפונו. ממדי הנזק, הקשר לנרון והרדיפה שבאה בעקבותיה נותרו נושא לוויכוח בין היסטוריונים.",
    "rank": 282
  },
  {
    "id": "med_dante",
    "deck": "anchors",
    "title": "דנטה כותב את הקומדיה האלוהית",
    "start": 1320,
    "end": 1320,
    "date": "בערך 1320",
    "place": "ראוונה, איטליה",
    "lat": 44.418,
    "lon": 12.197,
    "desc": "המשורר הפירנצי דנטה אליגיירי, שגורש מעירו, השלים בראוונה את הקומדיה האלוהית, שיר ארוך על מסעו בגיהינום, במכון הטוהר ובגן העדן. הוא כתב אותה באיטלקית טוסקנית ולא בלטינית, וכך תרם לעיצוב השפה הספרותית האיטלקית. דנטה מת ב־1321.",
    "rank": 283
  },
  {
    "id": "mod_oslo",
    "deck": "anchors",
    "title": "הסכמי אוסלו",
    "start": 1993,
    "end": 1993,
    "date": "1993",
    "place": "וושינגטון הבירה, ארה״ב",
    "lat": 38.9,
    "lon": -77.04,
    "desc": "ב־13 בספטמבר חתמו ראש ממשלת ישראל יצחק רבין ויו״ר אש״ף יאסר ערפאת בבית הלבן על הצהרת עקרונות, אחרי משא ומתן חשאי באוסלו. הצדדים הכירו זה בזה, והוקמה הרשות הפלסטינית לשלטון עצמי זמני. תהליך השלום נתקל בהמשך באלימות ובמחלוקות וטרם הושג הסדר קבע.",
    "rank": 284
  },
  {
    "id": "anq_alaric",
    "deck": "anchors",
    "title": "שוד רומא בידי אלאריק",
    "start": 410,
    "end": 410,
    "date": "410 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.49,
    "desc": "אלאריק, מלך הוויזיגותים, נכנס לרומא ובזז אותה שלושה ימים. זו הפעם הראשונה מזה כמעט שמונה מאות שנה שעיר זו נפלה לאויב. האירוע זעזע את העולם הרומי והניע את אוגוסטינוס לכתוב את ״עיר האלוהים״. הקיסר אונוריוס ישב באותה עת בראוונה המבוצרת, ולא ברומא.",
    "rank": 285
  },
  {
    "id": "med_vienna",
    "deck": "anchors",
    "title": "המצור הראשון על וינה",
    "start": 1529,
    "end": 1529,
    "date": "1529",
    "place": "וינה, אוסטריה",
    "lat": 48.21,
    "lon": 16.37,
    "desc": "סולימאן המפואר הטיל מצור על וינה, בירת הבסבורג, אך חורף מוקדם, גשמים וגם חומות העיר אילצו אותו לסגת. זה היה הקצה הצפוני־מערבי של התפשטות העות׳מאנים באירופה. האיום העות׳מאני עיצב את מדיניות מרכז אירופה גם בעשורים הבאים.",
    "rank": 286
  },
  {
    "id": "mod_mandela",
    "deck": "anchors",
    "title": "בחירתו של נלסון מנדלה",
    "start": 1994,
    "end": 1994,
    "date": "1994",
    "place": "פרטוריה, דרום אפריקה",
    "lat": -25.74,
    "lon": 28.21,
    "desc": "באפריל נערכו בדרום אפריקה הבחירות הדמוקרטיות הראשונות לכל האזרחים, ללא הבדל גזע, בסיום מדיניות האפרטהייד. נלסון מנדלה, שהשתחרר ב־1990 אחרי 27 שנות מאסר, נבחר לנשיא, ונכנס לתפקיד בטקס בבניין האיחוד בפרטוריה. מנדלה עודד פיוס בין קבוצות האוכלוסייה.",
    "rank": 287
  },
  {
    "id": "med_bartholomew",
    "deck": "anchors",
    "title": "טבח ליל בר תלמאי",
    "start": 1572,
    "end": 1572,
    "date": "1572",
    "place": "פריז, צרפת",
    "lat": 48.86,
    "lon": 2.35,
    "desc": "בימי מלחמות הדת בצרפת נטבחו אלפי הוגנוטים, פרוטסטנטים צרפתים, בפריז ואחר כך ברחבי הממלכה. הטבח פרץ ימים אחדים אחרי חתונת אנרי מנווארה הפרוטסטנטי עם מרגריט מבית ולואה. המלחמות נמשכו עד צו נאנט ב־1598.",
    "rank": 288
  },
  {
    "id": "mod_iran_rev",
    "deck": "anchors",
    "title": "המהפכה האיראנית",
    "start": 1979,
    "end": 1979,
    "date": "1979",
    "place": "טהראן, איראן",
    "lat": 35.69,
    "lon": 51.39,
    "desc": "אחרי הפגנות המוניות במהלך 1978 עזב השאה מוחמד רזא פהלווי את איראן בינואר 1979. האייתוללה רוחאללה חומייני שב מהגלות, ובאפריל הוכרזה רפובליקה אסלאמית. המהפכה שינתה את איראן למדינה תאוקרטית, ושינתה את מאזן הכוחות במזרח התיכון.",
    "rank": 289
  },
  {
    "id": "anq_homer",
    "deck": "anchors",
    "title": "חיבור האיליאדה והאודיסיאה",
    "start": -750,
    "end": -750,
    "date": "בערך 750 לפנה״ס",
    "place": "איוניה, אסיה הקטנה",
    "lat": 38.4,
    "lon": 27.1,
    "desc": "שני האפוסים היווניים הגדולים, האיליאדה והאודיסיאה, מיוחסים להומרוס. הם נוצרו בעל פה לפני שנכתבו, בערך במאה השמינית לפנה״ס, אחרי הפצת האלפבית היווני. הם שימשו יסוד לחינוך היווני ולשפה ולדת, ושאלת זהות המחבר נתונה בוויכוח עד ימינו.",
    "rank": 290
  },
  {
    "id": "med_templars",
    "deck": "anchors",
    "title": "הקמת מסדר הטמפלרים",
    "start": 1119,
    "end": 1119,
    "date": "1119",
    "place": "ירושלים",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "קבוצת אבירים בראשות הוגו דה פיין התחייבה להגן על עולי רגל בדרכים לירושלים. המלך בולדווין השני התיר להם להתגורר בהר הבית. המסדר הצבאי־דתי, שאושר רשמית ב־1129, צבר עושר וסמכות וגם פעל כמעין בנקאי של העולם הנוצרי.",
    "rank": 291
  },
  {
    "id": "mod_tiananmen",
    "deck": "anchors",
    "title": "הפגנות כיכר טיאננמן",
    "start": 1989,
    "end": 1989,
    "date": "1989",
    "place": "כיכר טיאננמן, בייג׳ינג, סין",
    "lat": 39.9,
    "lon": 116.39,
    "desc": "באביב 1989 התכנסו בכיכר טיאננמן אלפי סטודנטים ופועלים בדרישה לרפורמות ולחופש. ב־3 וב־4 ביוני פינו כוחות הצבא את הכיכר בכוח, וטנקים ירו לעבר מפגינים ברחובות הסמוכים. מספר ההרוגים נשאר שנוי במחלוקת, ממאות ועד אלפים, והאירוע מצונזר בסין.",
    "rank": 292
  },
  {
    "id": "anq_peloponnese",
    "deck": "anchors",
    "title": "מלחמת הפלופונסוס",
    "start": -431,
    "end": -404,
    "date": "⁦431–404⁩ לפנה״ס",
    "place": "אתונה וספרטה, יוון",
    "lat": 37.97,
    "lon": 23.73,
    "desc": "אתונה וברית דלוס נאבקו בספרטה ובבעלות בריתה על ההגמוניה ביוון. המלחמה כללה מגפה באתונה, משלחת כושלת לסיציליה ותמיכה פרסית בספרטה. אתונה נכנעה ב־404 לפנה״ס, ותוצאות המלחמה תוארו בידי תוקידידס, אבי ההיסטוריוגרפיה המדעית.",
    "rank": 293
  },
  {
    "id": "mod_nuremberg",
    "deck": "anchors",
    "title": "משפטי נירנברג",
    "start": 1945,
    "end": 1946,
    "date": "⁦1945–1946⁩",
    "place": "נירנברג, גרמניה",
    "lat": 49.45,
    "lon": 11.08,
    "desc": "בבית המשפט בנירנברג הועמדו לדין בפני בית דין צבאי בין־לאומי בכירי המשטר הנאצי בעוון פשעי מלחמה, פשעים נגד האנושות ופשעי שלום. 12 נאשמים נגזר דינם למוות, ואחרים נשלחו למאסר. המשפטים ביססו עקרונות של משפט פלילי בין־לאומי והשפיעו על אמנות מאוחרות.",
    "rank": 294
  },
  {
    "id": "med_hispania",
    "deck": "anchors",
    "title": "הכיבוש המוסלמי של ספרד",
    "start": 711,
    "end": 711,
    "date": "711 לספירה",
    "place": "גיברלטר, חצי האי האיברי",
    "lat": 36.14,
    "lon": -5.35,
    "desc": "טארק בן זיאד חצה עם צבא ברברי את המיצר שנקרא על שמו, ג׳בל טארק, והביס את מלך הוויזיגותים רודריק. תוך כמה שנים נכבש רוב חצי האי. האזור, שנקרא אל־אנדלוס, נשאר בחלקו תחת שלטון מוסלמי כשמונה מאות שנה.",
    "rank": 295
  },
  {
    "id": "mod_iraq_war",
    "deck": "anchors",
    "title": "הפלישה לעיראק",
    "start": 2003,
    "end": 2003,
    "date": "2003",
    "place": "בגדד, עיראק",
    "lat": 33.31,
    "lon": 44.37,
    "desc": "ב־20 במרס פלשה קואליציה בהנהגת ארצות הברית ובריטניה לעיראק, בנימוק שיש לה נשק להשמדה המונית, ולא נמצא כזה. משטרו של סדאם חוסיין קרס תוך שבועות, ובדצמבר נתפס. בעיראק התפתחו מרד, אלימות עדתית ומלחמת אזרחים, ומאות אלפי איש נהרגו. ארצות הברית נסוגה ב־2011.",
    "rank": 296
  },
  {
    "id": "mod_darwin",
    "deck": "anchors",
    "title": "פרסום ״מוצא המינים״",
    "start": 1859,
    "end": 1859,
    "date": "1859",
    "place": "דאון, אנגליה",
    "lat": 51.33,
    "lon": 0.05,
    "desc": "צ׳רלס דרווין פרסם את התיאוריה של התפתחות המינים באמצעות ברירה טבעית, לאחר עשרים שנות מחקר ומסע על הספינה ביגל. הספר עורר ויכוח בין מדענים לדתיים וביסס את תורת האבולוציה כבסיס של הביולוגיה. הספר הודפס במהירות והפך לרב־מכר.",
    "rank": 297
  },
  {
    "id": "anq_pompey",
    "deck": "anchors",
    "title": "פומפיוס כובש את ירושלים",
    "start": -63,
    "end": -63,
    "date": "63 לפנה״ס",
    "place": "ירושלים, יהודה",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "בעקבות מלחמת אחים בין הורקנוס השני לאריסטובולוס השני צר פומפיוס על ירושלים ופרץ אל הר הבית. המקדש נשאר על כנו, אך יהודה הפכה למדינת חסות רומית ושילמה מס. נסתיימה עצמאות החשמונאים, והחלה שליטה רומית שהובילה בהמשך למרד הגדול.",
    "rank": 298
  },
  {
    "id": "med_clermont",
    "deck": "anchors",
    "title": "אורבנוס השני קורא למסע הצלב בקלרמון",
    "start": 1095,
    "end": 1095,
    "date": "1095",
    "place": "קלרמון, צרפת",
    "lat": 45.78,
    "lon": 3.08,
    "desc": "בפני מועצת כנסייה גדולה קרא האפיפיור אורבנוס השני לאצילים ולאבירים לצאת לסייע לביזנטים ולשחרר את ירושלים מידי המוסלמים. הנאום עורר התלהבות עצומה והוביל למסע הצלב הראשון. מנהיגי המסע והעם הפשוט יצאו לדרך בשנה שלאחר מכן.",
    "rank": 299
  },
  {
    "id": "mod_camp_david",
    "deck": "anchors",
    "title": "הסכמי קמפ דייוויד",
    "start": 1978,
    "end": 1978,
    "date": "1978",
    "place": "קמפ דייוויד, מרילנד, ארה״ב",
    "lat": 39.65,
    "lon": -77.47,
    "desc": "בספטמבר 1978 נפגשו בחסות הנשיא האמריקני ג׳ימי קרטר נשיא מצרים אנואר סאדאת וראש ממשלת ישראל מנחם בגין בקמפ דייוויד. ההסכמים הובילו לחוזה השלום בין ישראל למצרים ב־1979, שבו נסוגה ישראל מסיני. סאדאת ובגין זכו בפרס נובל לשלום, וסאדאת נרצח ב־1981.",
    "rank": 300
  },
  {
    "id": "med_maimonides",
    "deck": "anchors",
    "title": "פטירתו של הרמב״ם",
    "start": 1204,
    "end": 1204,
    "date": "1204",
    "place": "פוסטאט (קהיר העתיקה), מצרים",
    "lat": 30.006,
    "lon": 31.231,
    "desc": "הרמב״ם, רופא החצר בשלטון האיובי ומנהיג הקהילה היהודית במצרים, נפטר בפוסטאט. הוא חיבר את משנה תורה ואת מורה נבוכים, שניסה ליישב בין האמונה לפילוסופיה. לפי המסורת הועברו עצמותיו לקבורה בטבריה.",
    "rank": 301
  },
  {
    "id": "mod_manifesto",
    "deck": "anchors",
    "title": "פרסום המניפסט הקומוניסטי",
    "start": 1848,
    "end": 1848,
    "date": "1848",
    "place": "לונדון, אנגליה",
    "lat": 51.51,
    "lon": -0.13,
    "desc": "קרל מרקס ופרידריך אנגלס כתבו עבור ליגת הקומוניסטים חוברת שהציגה את ההיסטוריה כמאבק מעמדות וקראה לפועלים להתאחד. החוברת הופיעה בתחילה בהשפעה מועטה. רעיונותיה עיצבו תנועות פוליטיות עצומות במאה ה־19 וה־20.",
    "rank": 302
  },
  {
    "id": "anq_rosetta",
    "deck": "anchors",
    "title": "אבן רוזטה",
    "start": -196,
    "end": -196,
    "date": "196 לפנה״ס",
    "place": "ממפיס, מצרים",
    "lat": 29.85,
    "lon": 31.25,
    "desc": "כמרים מצרים חרטו על לוח אבן צו לכבוד תלמי החמישי בשלוש כתיבות: הירוגליפית, דמוטית ויוונית. כשהאבן נמצאה ב־1799 איפשרה ההשוואה לטקסט היווני לז׳אן־פרנסואה שאמפוליון לפענח את ההירוגליפים. האבן ממחישה את העולם הדו־לשוני של מצרים התלמית.",
    "rank": 303
  },
  {
    "id": "mod_eichmann",
    "deck": "anchors",
    "title": "משפט אייכמן",
    "start": 1961,
    "end": 1961,
    "date": "1961",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.22,
    "desc": "אדולף אייכמן, ממארגני גירוש יהודי אירופה למחנות, נחטף בידי סוכני ישראל בארגנטינה ב־1960, והועמד למשפט בירושלים. המשפט, שהועבר בשידור ושבו העידו מאות ניצולים, העלה את סיפור השואה למודעות ציבורית רחבה. אייכמן הורשע ונגזר עליו עונש מוות, והוא הוצא להורג ב־1962.",
    "rank": 304
  },
  {
    "id": "anq_archimedes",
    "deck": "anchors",
    "title": "מות ארכימדס בסירקוסה",
    "start": -212,
    "end": -212,
    "date": "212 לפנה״ס",
    "place": "סירקוסה, סיציליה",
    "lat": 37.07,
    "lon": 15.29,
    "desc": "כשהצבא הרומי בפיקוד מרקלוס כבש את סירקוסה לאחר מצור ארוך, נהרג בה ארכימדס, מתמטיקאי וממציא. הוא ידוע בחישובי שטח ונפח, בעקרון הציפה ובמכונות שהגנו על העיר. לפי המסורת הורה מרקלוס לשמור על חייו, אך חייל רומי הרג אותו בלי לזהותו.",
    "rank": 305
  },
  {
    "id": "med_canossa",
    "deck": "anchors",
    "title": "הנרי הרביעי בקנוסה",
    "start": 1077,
    "end": 1077,
    "date": "1077",
    "place": "קנוסה, איטליה",
    "lat": 44.57,
    "lon": 10.45,
    "desc": "הקיסר הנרי הרביעי, שהאפיפיור גרגוריוס השביעי נידה בגלל מאבק על מינוי בישופים, עמד ימים אחדים בשלג מחוץ לטירת קנוסה וביקש מחילה. האפיפיור הסיר את הנידוי. האירוע מסמל את מאבק ההשקעה, ההתנגשות בין הקיסר לאפיפיור על הסמכות.",
    "rank": 306
  },
  {
    "id": "mod_barbarossa",
    "deck": "anchors",
    "title": "מבצע ברברוסה",
    "start": 1941,
    "end": 1941,
    "date": "1941",
    "place": "ברסט־ליטובסק, על הגבול הסובייטי־גרמני",
    "lat": 52.08,
    "lon": 23.66,
    "desc": "ב־22 ביוני פלשה גרמניה הנאצית לברית המועצות בחזית שאורכה אלפי קילומטרים, בהשתתפות יותר משלושה מיליון חיילים. הצבא האדום ספג תבוסות כבדות, אך הגרמנים נעצרו בסתיו ליד מוסקבה. הפלישה הפכה את המלחמה לזירת הקרבות הגדולה והעקובה מדם בהיסטוריה.",
    "rank": 307
  },
  {
    "id": "anq_milvian",
    "deck": "anchors",
    "title": "קרב גשר מילוויוס",
    "start": 312,
    "end": 312,
    "date": "312 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.93,
    "lon": 12.47,
    "desc": "קונסטנטינוס הביס את מקסנטיוס בגשר שליד רומא ונעשה לשליט המערב. לפי המסורת הנוצרית ראה סימן בשמיים והורה לחייליו לצייר סמל נוצרי על מגיניהם. ניצחונו פתח את הדרך לתמיכה בנצרות. מאוחר יותר ייחס אוסביוס את הניצחון לאל הנוצרי, ובתולדות הנצרות נחשב הקרב ציון דרך.",
    "rank": 308
  },
  {
    "id": "med_deathmuhammad",
    "deck": "anchors",
    "title": "מותו של מוחמד",
    "start": 632,
    "end": 632,
    "date": "632 לספירה",
    "place": "מדינה, חצי האי ערב",
    "lat": 24.468,
    "lon": 39.611,
    "desc": "מוחמד נפטר במדינה אחרי שאיחד את רוב חצי האי ערב תחת הנהגתו. אבו בכר, שנבחר לרשותו, נעשה לח׳ליף הראשון. חילוקי דעות על הירושה היו המקור לפילוג בין סונים לשיעים.",
    "rank": 309
  },
  {
    "id": "anq_cannae",
    "deck": "anchors",
    "title": "קרב קאנאי",
    "start": -216,
    "end": -216,
    "date": "216 לפנה״ס",
    "place": "קאנאי, אפוליה, איטליה",
    "lat": 41.3,
    "lon": 16.13,
    "desc": "חניבעל כיתר צבא רומי גדול והשמיד אותו בטקטיקת מלקחיים; הרוגי הרומאים נמנו בעשרות אלפים. הקרב נחשב למופת של חיל כיתור. למרות הניצחון לא הצליח חניבעל לשבור את רומא, שהמשיכה להילחם ושלחה צבא לאפריקה. בעקבות הקרב ערים רבות בדרום איטליה, וביניהן קפואה, עברו לצד קרתגו לזמן מה.",
    "rank": 310
  },
  {
    "id": "med_rashi",
    "deck": "anchors",
    "title": "רש״י נולד בטרואה",
    "start": 1040,
    "end": 1040,
    "date": "1040",
    "place": "טרואה, צרפת",
    "lat": 48.3,
    "lon": 4.08,
    "desc": "שלמה יצחקי נולד בטרואה ולמד בישיבות וורמס ומיינץ. פירושו לתנ״ך ולתלמוד נחשב לבהיר ולשימושי, והוא נלמד בכל רחבי העולם היהודי. הפירוש לתלמוד נדפס ברוב המהדורות לצד הטקסט.",
    "rank": 311
  },
  {
    "id": "mod_warsaw_ghetto",
    "deck": "anchors",
    "title": "מרד גטו ורשה",
    "start": 1943,
    "end": 1943,
    "date": "1943",
    "place": "ורשה, פולין",
    "lat": 52.25,
    "lon": 21,
    "desc": "באפריל 1943, כשהגרמנים החלו לחסל את הגטו שבו נדחסו מאות אלפי יהודים, פרצה התנגדות מזוינת בהנהגת ארגון הלוחמים היהודי ומרדכי אנילביץ׳. מאות לוחמים, מזוינים בנשק דל, עמדו בפני כוח גרמני חזק במשך כארבעה שבועות. המרד הוא סמל להתנגדות יהודית בשואה.",
    "rank": 312
  },
  {
    "id": "anq_carthage",
    "deck": "anchors",
    "title": "ייסוד קרתגו",
    "start": -814,
    "end": -814,
    "date": "בערך 814 לפנה״ס",
    "place": "קרתגו, תוניסיה",
    "lat": 36.853,
    "lon": 10.323,
    "desc": "לפי המסורת ייסדו פיניקים מצור את קרתגו בחוף צפון אפריקה, בהנהגת המלכה אלישה (דידו). התאריך המסורתי אינו מוכח: הממצאים הארכאולוגיים הקדומים ביותר בקרתגו מן המאה השמינית לפנה״ס בקירוב. העיר גדלה והפכה למעצמה ימית וסוחרת.",
    "rank": 313
  },
  {
    "id": "med_revelation",
    "deck": "anchors",
    "title": "ההתגלות הראשונה בהר חירא",
    "start": 610,
    "end": 610,
    "date": "בערך 610 לספירה",
    "place": "הר חירא, ליד מכה",
    "lat": 21.46,
    "lon": 39.86,
    "desc": "לפי המסורת האסלאמית קיבל מוחמד כשהתבודד במערה בהר חירא את ההתגלות הראשונה, באמצעות המלאך ג׳יבריל. הדברים שנאמרו לו נאספו בקוראן. זה נקודת ההתחלה של האסלאם כדת ייחודית, וממנה החל מוחמד להטיף לאנשי מכה.",
    "rank": 314
  },
  {
    "id": "mod_gaza_withdrawal",
    "deck": "anchors",
    "title": "ההתנתקות מרצועת עזה",
    "start": 2005,
    "end": 2005,
    "date": "2005",
    "place": "גוש קטיף, רצועת עזה",
    "lat": 31.35,
    "lon": 34.3,
    "desc": "באוגוסט וספטמבר 2005, ביוזמת ראש הממשלה אריאל שרון, פינתה ישראל את כל 21 היישובים הישראליים ברצועת עזה ואת ארבעה יישובים בצפון השומרון, וכ־8,000 מתיישבים הוצאו מבתיהם. צה״ל הוצא מהרצועה. ב־2007 תפס חמאס את השלטון ברצועה, וישראל ומצרים החמירו את ההגבלות על המעברים.",
    "rank": 315
  },
  {
    "id": "med_westphalia",
    "deck": "anchors",
    "title": "שלום וסטפליה",
    "start": 1648,
    "end": 1648,
    "date": "1648",
    "place": "מינסטר, גרמניה",
    "lat": 51.96,
    "lon": 7.63,
    "desc": "הסכמים שנחתמו במינסטר ובאוסנברוק סיימו את מלחמת שלושים השנים ואת מלחמת שמונים השנים בין ספרד להולנד. הם אישרו את ריבונות המדינות בגבולותיהן ושמרו חופש דת מוגבל. ההסכם נחשב לבסיס של הסדר המדינות האירופי.",
    "rank": 316
  },
  {
    "id": "mod_tsunami",
    "deck": "anchors",
    "title": "הצונאמי באוקיינוס ההודי",
    "start": 2004,
    "end": 2004,
    "date": "2004",
    "place": "בנדה אצ׳ה, אינדונזיה",
    "lat": 5.55,
    "lon": 95.32,
    "desc": "ב־26 בדצמבר גרם רעידת אדמה חזקה מול חופי סומטרה לגלי ענק שפגעו בחופי אינדונזיה, סרי לנקה, הודו, תאילנד ומדינות נוספות. כ־230 אלף בני אדם נהרגו, יותר ממחציתם באצ׳ה. האסון עורר גל סיוע בין־לאומי ללא תקדים.",
    "rank": 317
  },
  {
    "id": "med_becket",
    "deck": "anchors",
    "title": "רצח תומאס בקט בקנטרברי",
    "start": 1170,
    "end": 1170,
    "date": "1170",
    "place": "קנטרברי, אנגליה",
    "lat": 51.28,
    "lon": 1.08,
    "desc": "בעקבות סכסוך בין המלך הנרי השני לבין הארכיבישוף תומאס בקט על זכויות הכנסייה, הרגו ארבעה אבירים את בקט בקתדרלה. הרצח עורר זעזוע ברחבי אירופה, והמלך עשה פומבית חרטה. בקט הוכרז קדוש, וקנטרברי הפכה ליעד עלייה לרגל.",
    "rank": 318
  },
  {
    "id": "mod_korea",
    "deck": "anchors",
    "title": "מלחמת קוריאה",
    "start": 1950,
    "end": 1953,
    "date": "⁦1950–1953⁩",
    "place": "הקו ה־38, קוריאה",
    "lat": 38,
    "lon": 127,
    "desc": "ב־25 ביוני 1950 פלשה צפון קוריאה הקומוניסטית לדרום. ארצות הברית ומדינות נוספות בחסות האו״ם סייעו לדרום, וסין שלחה מאות אלפי חיילים לצפון. המלחמה, שגבתה כמיליוני חללים, הסתיימה בשביתת נשק ב־1953 בקרבת קו הרוחב ה־38, ללא הסכם שלום, ועד היום שתי קוריאות נפרדות.",
    "rank": 319
  },
  {
    "id": "anq_herod_temple",
    "deck": "anchors",
    "title": "בניית בית המקדש של הורדוס",
    "start": -20,
    "end": -20,
    "date": "בערך 20 לפנה״ס",
    "place": "ירושלים, יהודה",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "המלך הורדוס, שליט יהודה מטעם רומא, החל בבנייה מחדש ובהרחבה של בית המקדש והרחיב את הר הבית לכדי במה ענקית. הפרויקט נמשך עשרות שנים, וחלקים ממנו הושלמו רק אחרי מותו. הכותל המערבי הוא אחד משרידי קירות התמך.",
    "rank": 320
  },
  {
    "id": "med_jamestown",
    "deck": "anchors",
    "title": "ג׳יימסטאון",
    "start": 1607,
    "end": 1607,
    "date": "1607",
    "place": "ג׳יימסטאון, ארצות הברית",
    "lat": 37.21,
    "lon": -76.78,
    "desc": "מתיישבים אנגלים מטעם חברת וירג׳יניה הקימו את היישוב האנגלי הקבוע הראשון בצפון אמריקה. בשנים הראשונות מתו רבים ברעב ובמחלות. גידול הטבק והיחסים עם בני הפואטן, עם הילידים בסביבה, עיצבו את המושבה.",
    "rank": 321
  },
  {
    "id": "mod_march_washington",
    "deck": "anchors",
    "title": "צעדת וושינגטון",
    "start": 1963,
    "end": 1963,
    "date": "1963",
    "place": "וושינגטון הבירה, ארה״ב",
    "lat": 38.89,
    "lon": -77.05,
    "desc": "ב־28 באוגוסט צעדו כ־250 אלף איש אל אנדרטת לינקולן בדרישה לזכויות אזרח ולשוויון כלכלי לשחורים בארצות הברית. מרטין לותר קינג נשא שם את נאום ״יש לי חלום״. הצעדה זירזה את חקיקת חוק זכויות האזרח ב־1964 ואת חוק זכויות ההצבעה ב־1965.",
    "rank": 322
  },
  {
    "id": "anq_buddha",
    "deck": "anchors",
    "title": "הארה של בודהה",
    "start": -528,
    "end": -528,
    "date": "בערך 528 לפנה״ס",
    "place": "בודהגאיה, הודו",
    "lat": 24.7,
    "lon": 84.99,
    "desc": "לפי המסורת הבודהיסטית ישב הנסיך סידהרתה גאוטמה מתחת לעץ בבודהגאיה והגיע להארה, ומכאן נקרא בודהה. התאריך מקורב ושנוי במחלוקת, וחוקרים מציבים את חייו במאה השישית או החמישית לפנה״ס. תורתו נפוצה ברחבי אסיה.",
    "rank": 323
  },
  {
    "id": "mod_gulf_war",
    "deck": "anchors",
    "title": "מלחמת המפרץ",
    "start": 1990,
    "end": 1991,
    "date": "⁦1990–1991⁩",
    "place": "כווית",
    "lat": 29.37,
    "lon": 47.98,
    "desc": "באוגוסט 1990 פלש עיראק של סדאם חוסיין לכווית וסיפח אותה. קואליציה של כ־35 מדינות בהובלת ארצות הברית פתחה בינואר 1991 במתקפה אווירית ואחר כך קרקעית, ובתוך ימים אחדים שחררה את כווית. עיראק שיגרה טילים לישראל, וישראל לא הגיבה. על עיראק הוטלו סנקציות ופיקוח.",
    "rank": 324
  },
  {
    "id": "anq_julian_cal",
    "deck": "anchors",
    "title": "הלוח היוליאני",
    "start": -45,
    "end": -45,
    "date": "45 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.49,
    "desc": "יוליוס קיסר, בעצת האסטרונום סוסיגנס, ביטל את לוח השנה הרומי המסורבל והנהיג שנה שמשית של 365 ימים ויום מעובר אחת לארבע שנים. הלוח שימש את אירופה כמעט שבע־עשרה מאות שנה עד שהוחלף בלוח הגרגוריאני. כדי ליישר את הלוח הוארכה שנת 46 לפנה״ס לכ־445 ימים, והיא נקראת ״שנת הבלבול״.",
    "rank": 325
  },
  {
    "id": "med_crecy",
    "deck": "anchors",
    "title": "קרב קרסי",
    "start": 1346,
    "end": 1346,
    "date": "1346",
    "place": "קרסי, צרפת",
    "lat": 50.25,
    "lon": 1.88,
    "desc": "במהלך מלחמת מאה השנים ניצח צבא אנגלי קטן בפיקוד אדוארד השלישי צבא צרפתי גדול ממנו. הקשתים האנגלים ירו חיצים בטווח ארוך וקטלו את הפרשים הכבדים. הקרב הדגים את ירידת עליונותו של האביר הרכוב בשדה הקרב.",
    "rank": 326
  },
  {
    "id": "mod_watergate",
    "deck": "anchors",
    "title": "פרשת ווטרגייט",
    "start": 1972,
    "end": 1974,
    "date": "⁦1972–1974⁩",
    "place": "וושינגטון הבירה, ארה״ב",
    "lat": 38.9,
    "lon": -77.05,
    "desc": "ביוני 1972 נתפסו פורצים במשרדי המפלגה הדמוקרטית במתחם ווטרגייט, והחקירה העלתה שאנשי הנשיא ריצ׳רד ניקסון ניסו לטשטש את הפרשה. אחרי חשיפת הקלטות ואיום בהדחה התפטר ניקסון באוגוסט 1974, כנשיא הראשון בהיסטוריה של ארצות הברית שעשה זאת.",
    "rank": 327
  },
  {
    "id": "anq_confucius",
    "deck": "anchors",
    "title": "הולדת קונפוציוס",
    "start": -551,
    "end": -551,
    "date": "בערך 551 לפנה״ס",
    "place": "צ׳יופו, סין",
    "lat": 35.6,
    "lon": 117.01,
    "desc": "קונפוציוס נולד במדינת לו, בתקופה של מלחמות בין נסיכויות. הוא לימד מוסר, כבוד להורים ולמסורת, ושלטון המבוסס על דוגמה אישית. תלמידיו אספו את דבריו ב״שיחות״. ההגות הקונפוציאנית עיצבה את סין והמזרח כאלפיים וחמש מאות שנה.",
    "rank": 328
  },
  {
    "id": "med_mishneh",
    "deck": "anchors",
    "title": "הרמב״ם משלים את משנה תורה",
    "start": 1180,
    "end": 1180,
    "date": "בערך 1180",
    "place": "פוסטאט (קהיר), מצרים",
    "lat": 30,
    "lon": 31.23,
    "desc": "משה בן מימון, שנולד בקורדובה וחי במצרים, כתב כ־1170–1180 את משנה תורה, קודקס הלכתי שכולל את כל ההלכה בעברית בהירה. היצירה שימשה בסיס לפסיקה, ועוררה גם ביקורת. הרמב״ם היה גם רופא וגם פילוסוף.",
    "rank": 329
  },
  {
    "id": "med_richard",
    "deck": "anchors",
    "title": "מות ריצ׳רד לב הארי",
    "start": 1199,
    "end": 1199,
    "date": "1199",
    "place": "שאלוס, צרפת",
    "lat": 45.65,
    "lon": 0.99,
    "desc": "ריצ׳רד הראשון, מלך אנגליה, נפצע מחץ כשצר על טירה קטנה בלימוזן ומת מזיהום אחרי כשבועיים. הוא נודע בלחימתו במסע הצלב השלישי ובמאבקו מול סלאדין. אחיו ג׳ון עלה לכס, ובימי שלטונו אבדו לאנגליה רוב נכסיה בצרפת.",
    "rank": 330
  },
  {
    "id": "mod_afghanistan",
    "deck": "anchors",
    "title": "הפלישה הסובייטית לאפגניסטן",
    "start": 1979,
    "end": 1989,
    "date": "⁦1979–1989⁩",
    "place": "קאבול, אפגניסטן",
    "lat": 34.53,
    "lon": 69.17,
    "desc": "בדצמבר 1979 נכנסו כוחות סובייטים לאפגניסטן כדי לתמוך בממשלה הקומוניסטית שם. המוג׳אהדין האפגנים לחמו בהם, בסיוע ארצות הברית ופקיסטן. אחרי כעשור, כמיליון אפגנים וכ־15 אלף חיילים סובייטים מתו, והסובייטים נסוגו ב־1989.",
    "rank": 331
  },
  {
    "id": "anq_pythagoras",
    "deck": "anchors",
    "title": "פיתגורס בקרוטון",
    "start": -530,
    "end": -530,
    "date": "בערך 530 לפנה״ס",
    "place": "קרוטון, איטליה",
    "lat": 39.08,
    "lon": 17.13,
    "desc": "פיתגורס מסמוס עבר לקרוטון שבדרום איטליה והקים אגודה של תלמידים שחיו בחיי קהילה והתעמקו במתמטיקה ובפילוסופיה. האגודה האמינה בגלגול נשמות ובכוחם של מספרים. משפט פיתגורס נקרא על שמו, אך הוא היה מוכר גם לבבלים.",
    "rank": 332
  },
  {
    "id": "med_corpusjuris",
    "deck": "anchors",
    "title": "קובץ החוקים של יוסטיניאנוס",
    "start": 529,
    "end": 534,
    "date": "⁦529–534⁩ לספירה",
    "place": "קונסטנטינופול, האימפריה הביזנטית",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "הקיסר יוסטיניאנוס הראשון הורה לוועדת משפטנים לאסוף ולסדר את החוק הרומי הישן והסותר. התוצאה, הקודקס, הדיגסטה והאינסטיטוציות, נודעה בהמשך כ״קובץ החוק האזרחי״. במאה ה־11 החל המערב ללמוד אותו מחדש, והוא הפך לבסיס של דיני מדינות באירופה.",
    "rank": 333
  },
  {
    "id": "mod_battle_britain",
    "deck": "anchors",
    "title": "הקרב על בריטניה",
    "start": 1940,
    "end": 1940,
    "date": "1940",
    "place": "דרום אנגליה ולונדון, בריטניה",
    "lat": 51.5,
    "lon": -0.12,
    "desc": "אחרי נפילת צרפת ניסה חיל האוויר הגרמני בקיץ ובסתיו להשיג שליטה בשמי בריטניה לקראת פלישה. חיל האוויר המלכותי, שנעזר במכ״ם, עמד בהתקפות, וגם ההפצצות על לונדון וערים אחרות לא שברו את רוח העם. היטלר דחה את הפלישה, והקרב היה כישלון הגרמני הראשון.",
    "rank": 334
  },
  {
    "id": "anq_pantheon",
    "deck": "anchors",
    "title": "הפנתיאון ברומא",
    "start": 126,
    "end": 126,
    "date": "בערך 126 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.899,
    "lon": 12.477,
    "desc": "הקיסר אדריאנוס בנה מחדש את מקדש הפנתיאון, שנשרף קודם לכן, והוסיף לו כיפת בטון ענקית. הכיפה נשארת עד היום הכיפה הגדולה בעולם שנבנתה מבטון בלתי מזוין. הבניין נשמר כמעט שלם מפני שהוסב לכנסייה בראשית המאה השביעית.",
    "rank": 335
  },
  {
    "id": "med_zheng_he",
    "deck": "anchors",
    "title": "מסעות האוצר של ג׳נג הה",
    "start": 1405,
    "end": 1433,
    "date": "⁦1405–1433⁩",
    "place": "טאיצ׳אנג, סין",
    "lat": 31.45,
    "lon": 121.1,
    "desc": "האדמירל ג׳נג הה, מוסלמי בשירות קיסרי מינג, הוביל שבעה מסעות עם צי עצום של ספינות ענק. המסעות הגיעו לדרום־מזרח אסיה, להודו, לחצי האי ערב ולחופי מזרח אפריקה. אחריהם הפסיקה סין את המסעות הימיים הרשמיים.",
    "rank": 336
  },
  {
    "id": "mod_trinity",
    "deck": "anchors",
    "title": "ניסוי הגרעין הראשון",
    "start": 1945,
    "end": 1945,
    "date": "1945",
    "place": "המדבר ליד אלמוגורדו, ניו מקסיקו, ארה״ב",
    "lat": 33.68,
    "lon": -106.48,
    "desc": "ב־16 ביולי פוצצה בבדיקת טרינטי הפצצה האטומית הראשונה בהיסטוריה, בחלק מפרויקט מנהטן שהנהיג רוברט אופנהיימר. כעבור פחות מחודש הוטלו פצצות דומות על יפן. הניסוי פתח את העידן הגרעיני ואת מרוץ החימוש בין המעצמות.",
    "rank": 337
  },
  {
    "id": "anq_roman_republic",
    "deck": "anchors",
    "title": "ייסוד הרפובליקה הרומית",
    "start": -509,
    "end": -509,
    "date": "בערך 509 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.485,
    "desc": "לפי המסורת הרומית גורש טרקוויניוס סופרבוס, המלך האחרון, ורומא הפכה לרפובליקה בראשות שני קונסולים שנבחרו לשנה. התאריך המסורתי אינו ודאי. הרפובליקה שלטה ברומא כחמש מאות שנה.",
    "rank": 338
  },
  {
    "id": "med_jerusalem638",
    "deck": "anchors",
    "title": "כיבוש ירושלים בידי המוסלמים",
    "start": 637,
    "end": 638,
    "date": "⁦637–638⁩ לספירה",
    "place": "ירושלים",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "אחרי מצור נכנעה ירושלים לצבא הח׳ליף עומר. לפי המסורת הגיע עומר בעצמו להסכם עם הפטריארך סופרוניוס. התושבים הנוצרים קיבלו הגנה ופרנסה תמורת מס. שאלת התאריך המדויק שנויה במחלוקת בין המקורות.",
    "rank": 339
  },
  {
    "id": "mod_refugees48",
    "deck": "anchors",
    "title": "פליטי המלחמה הערבית־ישראלית הראשונה",
    "start": 1948,
    "end": 1948,
    "date": "1948",
    "place": "לוד, ארץ ישראל",
    "lat": 31.95,
    "lon": 34.89,
    "desc": "במהלך מלחמת 1948 ברחו או גורשו כ־700 אלף ערבים פלסטינים מבתיהם, ורובם נשארו מחוץ לישראל כפליטים ובני צאצאיהם. הפלסטינים מכנים את האירוע ״הנכבה״. במקביל, ובשנים אחר כך, עזבו או גורשו כ־850 אלף יהודים מארצות ערב ואיראן, רבים מהם הגיעו לישראל. סוגיית הפליטים נותרה מרכזית בסכסוך.",
    "rank": 340
  },
  {
    "id": "anq_punic1",
    "deck": "anchors",
    "title": "מלחמת פוניק הראשונה",
    "start": -264,
    "end": -241,
    "date": "⁦264–241⁩ לפנה״ס",
    "place": "סיציליה, איטליה",
    "lat": 38.19,
    "lon": 15.55,
    "desc": "רומא וקרתגו נאבקו על השליטה בסיציליה. כדי להתמודד עם הצי הקרתגי בנו הרומאים צי משלהם, ובקרב איי אגטס ניצחו סופית. קרתגו נאלצה לפנות את סיציליה ולשלם פיצויים, ורומא הפכה למעצמה ימית וקיבלה את האי הראשון מחוץ לאיטליה.",
    "rank": 341
  },
  {
    "id": "med_angkorwat",
    "deck": "anchors",
    "title": "בניית אנגקור ואט",
    "start": 1113,
    "end": 1150,
    "date": "בערך ⁦1113–1150⁩",
    "place": "אנגקור, קמבודיה",
    "lat": 13.41,
    "lon": 103.87,
    "desc": "המלך סוריאוורמן השני הקים מקדש הינדי לוישנו בבירת האימפריה החמרית. המקדש מתאר את הר מרו ונחשב למבנה הדתי הגדול בעולם. עם הזמן הפך למקדש בודהיסטי והוא סמל לאומי של קמבודיה.",
    "rank": 342
  },
  {
    "id": "mod_prague",
    "deck": "anchors",
    "title": "אביב פראג",
    "start": 1968,
    "end": 1968,
    "date": "1968",
    "place": "פראג, צ׳כוסלובקיה",
    "lat": 50.08,
    "lon": 14.42,
    "desc": "בראשות אלכסנדר דובצ׳ק ניסתה צ׳כוסלובקיה בראשית 1968 להנהיג קומוניזם עם פנים אנושיות, עם חופש הביטוי והתקשורת. במחצית אוגוסט פלשו לארץ כוחות ברית ורשה בהנהגת ברית המועצות. הרפורמות בוטלו, ודובצ׳ק הודח, אך הרעיון נשאר חי גם אחר כך.",
    "rank": 343
  },
  {
    "id": "anq_cai_lun",
    "deck": "anchors",
    "title": "המצאת הנייר",
    "start": 105,
    "end": 105,
    "date": "בערך 105 לספירה",
    "place": "לויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "צאי לון, סריס בחצר קיסר האן, דיווח לקיסר על שיטה לייצור נייר מקליפת עצים, סמרטוטים ורשתות דיג. נמצאו שרידי נייר קדומים יותר, ולכן הוא נחשב למי ששכלל את התהליך. הנייר החליף בהדרגה את המשי ואת לוחות הבמבוק ככלי כתיבה.",
    "rank": 344
  },
  {
    "id": "med_domesday",
    "deck": "anchors",
    "title": "ספר דומסדיי",
    "start": 1086,
    "end": 1086,
    "date": "1086",
    "place": "וינצ׳סטר, אנגליה",
    "lat": 51.06,
    "lon": -1.31,
    "desc": "ויליאם הכובש הורה על סקר מפורט של אדמות, בעלים ונכסים בכל אנגליה, כדי לדעת מה מגיע לכתר ולהטיל מסים. הסקר, שהושלם בתוך שנה, נודע בשם ״ספר דומסדיי״. הוא נשמר עד היום והוא אחד מתיעודי השלטון והחברה המפורטים ביותר מימי הביניים.",
    "rank": 345
  },
  {
    "id": "anq_eratosthenes",
    "deck": "anchors",
    "title": "מדידת היקף כדור הארץ",
    "start": -240,
    "end": -240,
    "date": "בערך 240 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.92,
    "desc": "ארטוסתנס, ראש הספרייה באלכסנדריה, שמע שבסיינה שבדרום מצרים אין צל בצהרי היום הארוך ביותר בשנה, והשווה זאת לאורך הצל באלכסנדריה. מן הזווית חישב את היקף כדור הארץ. התוצאה, כ־40 אלף קילומטר, קרובה מאוד למציאות, וזו דוגמה מוקדמת למדידה גאומטרית של העולם.",
    "rank": 346
  },
  {
    "id": "med_cabral",
    "deck": "anchors",
    "title": "קברל מגיע לברזיל",
    "start": 1500,
    "end": 1500,
    "date": "1500",
    "place": "פורטו סגורו, ברזיל",
    "lat": -16.45,
    "lon": -39.06,
    "desc": "צי פורטוגלי בפיקוד פדרו אלווארס קברל, שיצא להודו, נסחף מערבה והגיע לחוף ברזיל, שאותו תבע לפורטוגל. במקום חיו עמי הטופי. ברזיל הפכה לימים למושבה פורטוגלית גדולה, מבוססת על עצי צבע וסוכר ועל עבודת עבדים.",
    "rank": 347
  },
  {
    "id": "mod_spain_civil",
    "deck": "anchors",
    "title": "מלחמת האזרחים בספרד",
    "start": 1936,
    "end": 1939,
    "date": "⁦1936–1939⁩",
    "place": "מדריד, ספרד",
    "lat": 40.42,
    "lon": -3.7,
    "desc": "הצבא בהנהגת הגנרל פרנקו מרד ברפובליקה הספרדית ב־1936, והמלחמה שפרצה הפכה לזירה של מאבק בין פשיזם לשמאל. גרמניה ואיטליה סייעו ללאומנים, וברית המועצות ומתנדבים זרים סייעו לרפובליקנים. פרנקו ניצח באביב 1939 ושלט בספרד עד מותו ב־1975.",
    "rank": 348
  },
  {
    "id": "anq_thessalonica",
    "deck": "anchors",
    "title": "נצרות כדת המדינה",
    "start": 380,
    "end": 380,
    "date": "380 לספירה",
    "place": "סלוניקי, יוון",
    "lat": 40.64,
    "lon": 22.94,
    "desc": "הקיסר תאודוסיוס הראשון הכריז בצו על הנצרות הניקיאית כדת המדינה. בהמשך נאסרו פולחנות פגאניים ונסגרו מקדשים. הצו סימן מעבר מדת מגוונת באימפריה לכנסייה אחת שנעשתה חלק מהשלטון. התקנה לא הייתה סופית, והפגניות נעלמה מן האימפריה רק לאחר כמה דורות.",
    "rank": 349
  },
  {
    "id": "med_talmud",
    "deck": "anchors",
    "title": "חתימת התלמוד הבבלי",
    "start": 550,
    "end": 550,
    "date": "בערך 550 לספירה",
    "place": "בבל, עיראק",
    "lat": 32.4,
    "lon": 44.4,
    "desc": "התלמוד הבבלי נערך בישיבות סורא ופומבדיתא על ידי חכמים, והושלם במהלך שלב הסבוראים. הוא כולל פירוש למשנה ודיונים בהלכה ובאגדה. התלמוד נחשב ליסוד מרכזי של היהדות הרבנית ונלמד עד היום.",
    "rank": 350
  },
  {
    "id": "anq_second_temple",
    "deck": "anchors",
    "title": "חנוכת בית שני",
    "start": -516,
    "end": -516,
    "date": "בערך 516 לפנה״ס",
    "place": "ירושלים, ארץ ישראל",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "שבי ציון שחזרו מבבל בימי כורש ודריוש השלימו את בנייתו מחדש של המקדש בירושלים, כפי שמתואר בספר עזרא. המקדש השני עמד כחמש מאות שנים, עד שנחרב בידי הרומאים. בימיו נעשתה ירושלים מרכז הדת היהודית.",
    "rank": 351
  },
  {
    "id": "med_dias",
    "deck": "anchors",
    "title": "דיאש מקיף את כף התקווה הטובה",
    "start": 1488,
    "end": 1488,
    "date": "1488",
    "place": "כף התקווה הטובה, דרום אפריקה",
    "lat": -34.36,
    "lon": 18.47,
    "desc": "הנווט הפורטוגלי ברטולומאו דיאש הפליג דרומה לאורך חופי אפריקה ועקף את קצה היבשת, והוכיח שהאוקיינוס האטלנטי והאוקיינוס ההודי מחוברים. לפי המסורת קרא למקום כף הסערות, ושמו שונה אחר כך לכף התקווה הטובה, כסימן לסיכוי להגיע להודו.",
    "rank": 352
  },
  {
    "id": "mod_cuba_rev",
    "deck": "anchors",
    "title": "המהפכה בקובה",
    "start": 1959,
    "end": 1959,
    "date": "1959",
    "place": "סנטה קלרה, קובה",
    "lat": 22.4,
    "lon": -79.97,
    "desc": "בראשות פידל קסטרו וצ׳ה גווארה הובסו כוחות השליט פולחנסיו בטיסטה. הקרב בסנטה קלרה בדצמבר 1958 הכריע, ובטיסטה ברח ב־1 בינואר 1959. קסטרו הקים משטר קומוניסטי, הלאים נכסים אמריקניים וקשר ברית עם ברית המועצות, וסבב היחסים עם ארצות הברית הלך והחמיר.",
    "rank": 353
  },
  {
    "id": "anq_claudius_britain",
    "deck": "anchors",
    "title": "פלישת רומא לבריטניה",
    "start": 43,
    "end": 43,
    "date": "43 לספירה",
    "place": "ריצ׳בורו, קנט, אנגליה",
    "lat": 51.29,
    "lon": 1.33,
    "desc": "הקיסר קלאודיוס שלח כוח של ארבעה לגיונות לאי וכבש את דרום בריטניה. הצבא נחת בקנט, ובהמשך נוסדה לונדיניום (לונדון) ונסללו דרכים רומיות. בריטניה נשארה פרובינקיה רומית כארבע מאות שנה, עד שהלגיונות עזבו בראשית המאה החמישית.",
    "rank": 354
  },
  {
    "id": "med_baghdad_2",
    "deck": "anchors",
    "title": "המונגולים מחריבים את בגדאד",
    "start": 1258,
    "end": 1258,
    "date": "1258",
    "place": "בגדאד, עיראק",
    "lat": 33.315,
    "lon": 44.366,
    "desc": "צבא מונגולי בפיקוד הולאגו, נכדו של ג׳ינגיס חאן, כבש את בגדאד אחרי מצור קצר והוציא להורג את הח׳ליף העבאסי אל־מוסתעצם. העיר נבזזה, תושבים רבים נטבחו וספריות ובהן בית החוכמה נהרסו. הח׳ליפות העבאסית חדלה להיות כוח שלטוני.",
    "rank": 355
  },
  {
    "id": "mod_intifada1",
    "deck": "anchors",
    "title": "האינתיפאדה הראשונה",
    "start": 1987,
    "end": 1993,
    "date": "⁦1987–1993⁩",
    "place": "ג׳בליה, רצועת עזה",
    "lat": 31.53,
    "lon": 34.48,
    "desc": "בדצמבר 1987 פרצו הפגנות ועימותים אלימים נגד השלטון הישראלי בגדה המערבית וברצועת עזה, אחרי תאונה בג׳בליה. הפלסטינים השתמשו באבנים, בשביתות ובאי־ציות אזרחי, וישראל פעלה בכוח צבאי. מאות ישראלים וכאלף פלסטינים נהרגו. האינתיפאדה סללה את הדרך להסכמי אוסלו.",
    "rank": 356
  },
  {
    "id": "anq_abu_simbel",
    "deck": "anchors",
    "title": "המקדשים הסלעיים באבו סימבל",
    "start": -1264,
    "end": -1264,
    "date": "בערך 1264 לפנה״ס",
    "place": "אבו סימבל, מצרים",
    "lat": 22.337,
    "lon": 31.626,
    "desc": "רעמסס השני הקים בנוביה מקדש חצוב בסלע, ובחזיתו ארבעה פסלי ענק שלו. לצדו הוקם מקדש קטן יותר לאשתו נפרטרי. בשנות השישים של המאה ה־20 פורקו המקדשים והועברו למקום גבוה יותר, כדי להצילם ממי סכר אסואן.",
    "rank": 357
  },
  {
    "id": "med_tordesillas",
    "deck": "anchors",
    "title": "הסכם טורדסיאס",
    "start": 1494,
    "end": 1494,
    "date": "1494",
    "place": "טורדסיאס, ספרד",
    "lat": 41.5,
    "lon": -5,
    "desc": "ספרד ופורטוגל חילקו ביניהן את העולם שמחוץ לאירופה בקו דמיוני באוקיינוס האטלנטי, בעקבות פסיקות של האפיפיור. הרוב המערבי נועד לספרד והמזרחי לפורטוגל. מעצמות אחרות לא הכירו בחלוקה, אך היא עיצבה את ההתפשטות האירופית, ובין השאר נתנה לפורטוגל את ברזיל.",
    "rank": 358
  },
  {
    "id": "mod_armenian",
    "deck": "anchors",
    "title": "רדיפת הארמנים באימפריה העות׳מאנית",
    "start": 1915,
    "end": 1915,
    "date": "1915",
    "place": "קונסטנטינופול (איסטנבול), האימפריה העות׳מאנית",
    "lat": 41.01,
    "lon": 28.98,
    "desc": "ב־24 באפריל נעצרו בבירה העות׳מאנית מאות מאנשי הציבור הארמנים, ובעקבות זאת גורשו מאות אלפי ארמנים ממקומותיהם בצעדות מוות לעבר המדבר הסורי. מאות אלפי בני אדם, ולפי הערכות רבות מעל מיליון, מתו. ארמניה ומדינות רבות מגדירות זאת רצח עם, וטורקיה דוחה את ההגדרה.",
    "rank": 359
  },
  {
    "id": "med_cairo",
    "deck": "anchors",
    "title": "ייסוד קהיר",
    "start": 969,
    "end": 969,
    "date": "969 לספירה",
    "place": "קהיר, מצרים",
    "lat": 30.05,
    "lon": 31.26,
    "desc": "המצביא ג׳והר הסיקילי כבש את מצרים בשם הפאטמים והקים עיר חדשה, אל־קאהירה, ליד פוסטאט. כמה שנים אחר כך עבר אליה הח׳ליף הפאטמי. קהיר נשארה הבירה, ושם הוקם גם אל־אזהר, מוסד לימוד שנחשב לוותיק בעולם.",
    "rank": 360
  },
  {
    "id": "anq_akhenaten",
    "deck": "anchors",
    "title": "המהפכה הדתית של אחנאתון",
    "start": -1353,
    "end": -1336,
    "date": "בערך ⁦1353–1336⁩ לפנה״ס",
    "place": "עמרנה, מצרים",
    "lat": 27.645,
    "lon": 30.9,
    "desc": "הפרעה אמנחותפ הרביעי שינה את שמו לאחנאתון, העלה את פולחן האל אתון והקים בירה חדשה, עמרנה. הוא הגביל את פולחן האלים האחרים. לאחר מותו נעזב הפולחן החדש והעיר ננטשה. בארכיון עמרנה נמצאו מכתבי דיפלומטיה של מלכי המזרח.",
    "rank": 361
  },
  {
    "id": "med_mansa_musa",
    "deck": "anchors",
    "title": "מסע החג׳ של מנסא מוסא",
    "start": 1324,
    "end": 1324,
    "date": "1324",
    "place": "קהיר, מצרים",
    "lat": 30.044,
    "lon": 31.236,
    "desc": "מנסא מוסא, שליט מאלי העשיר, יצא למכה בשיירה ענקית שנשאה כמויות זהב. שהותו בקהיר ובזבוזו הרב גרמו, לפי המקורות, לירידה זמנית בערך הזהב. המסע הציב את מאלי על מפות אירופה, ובעקבותיו נבנו מסגדים וספריות בטימבוקטו.",
    "rank": 362
  },
  {
    "id": "mod_goldrush",
    "deck": "anchors",
    "title": "תחילת הבהלה לזהב בקליפורניה",
    "start": 1848,
    "end": 1848,
    "date": "1848",
    "place": "קולומה, קליפורניה",
    "lat": 38.8,
    "lon": -120.89,
    "desc": "ג׳יימס מרשל מצא זהב בטחנת הנסרים של סוטר, והידיעה גרמה לכ־300 אלף איש להגיע לקליפורניה מרחבי ארצות הברית והעולם. סן פרנסיסקו גדלה מכפר לעיר, וקליפורניה הפכה למדינה ב־1850. הבהלה פגעה קשות באוכלוסייה הילידית.",
    "rank": 363
  },
  {
    "id": "anq_aeneid",
    "deck": "anchors",
    "title": "כתיבת האנאיס",
    "start": -29,
    "end": -19,
    "date": "⁦29–19⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.49,
    "desc": "המשורר ורגיליוס כתב בעשור האחרון לחייו אפוס על אניאס, פליט מטרויה שהגיע לאיטליה והיה לאבי הרומאים. היצירה, שנכתבה בחסות אוגוסטוס, קשרה את מיתוס המוצא הרומי לתפיסה של ייעוד אימפריאלי, והיא נחשבת ליצירה הגדולה ביותר של הספרות הלטינית.",
    "rank": 364
  },
  {
    "id": "med_normandy",
    "deck": "anchors",
    "title": "רולו מקבל את נורמנדי",
    "start": 911,
    "end": 911,
    "date": "911 לספירה",
    "place": "סן־קלר־סור־אפט, צרפת",
    "lat": 49.15,
    "lon": 1.75,
    "desc": "מלך צרפת המערבית שארל הפשוט הסכים להעניק לרולו, מנהיג ויקינגי, שטח בעמק הסן. תמורת זאת התחייב רולו להתנצר ולהגן על האזור מפני פשיטות נוספות. מהמחוז החדש, נורמנדי, יצאו הנורמנים שכבשו מאוחר יותר את אנגליה ודרום איטליה.",
    "rank": 365
  },
  {
    "id": "anq_hatshepsut",
    "deck": "anchors",
    "title": "משלחת חתשפסות לפונט",
    "start": -1470,
    "end": -1470,
    "date": "בערך 1470 לפנה״ס",
    "place": "דיר אל־בחרי, מצרים",
    "lat": 25.738,
    "lon": 32.607,
    "desc": "המלכה חתשפסות שלחה משלחת ימית לארץ פונט, אולי בחוף הים האדום, והביאה משם עצי בשמים, זהב ובעלי חיים. תיאור המסע מופיע בתבליטי מקדש המתים שלה בדיר אל־בחרי, והוא אחד התיעודים המפורטים הראשונים של מסע מסחרי.",
    "rank": 366
  },
  {
    "id": "med_battuta",
    "deck": "anchors",
    "title": "אבן בטוטה יוצא למסעותיו",
    "start": 1325,
    "end": 1325,
    "date": "1325",
    "place": "טנג׳יר, מרוקו",
    "lat": 35.78,
    "lon": -5.81,
    "desc": "אבן בטוטה, משפטן צעיר מטנג׳יר, יצא לעלייה לרגל למכה ונשאר בדרכים כשלושים שנה. הוא חצה את העולם המוסלמי, ביקר בהודו, בסין ובמזרח אפריקה, ולבסוף הכתיב את תיאור מסעותיו. כתביו הם מקור חשוב להיסטוריה של ימי הביניים המאוחרים.",
    "rank": 367
  },
  {
    "id": "anq_teutoburg",
    "deck": "anchors",
    "title": "קרב יער טויטובורג",
    "start": 9,
    "end": 9,
    "date": "9 לספירה",
    "place": "קלקרישה, גרמניה",
    "lat": 52.4,
    "lon": 8.13,
    "desc": "מנהיג הגרמנים ארמיניוס, ששירת בעבר בצבא רומא, פיתה שלושה לגיונות בפיקוד פובליוס קווינקטיליוס וארוס לארוב ביער ושחט אותם. אוגוסטוס, לפי המסורת, זעק לוארוס להחזיר לו את לגיוניו. רומא נמנעה מלכבוש את גרמניה שמזרח לריין.",
    "rank": 368
  },
  {
    "id": "mod_babi_yar",
    "deck": "anchors",
    "title": "טבח בבאבי יאר",
    "start": 1941,
    "end": 1941,
    "date": "1941",
    "place": "קייב, אוקראינה",
    "lat": 50.47,
    "lon": 30.45,
    "desc": "ב־29 וב־30 בספטמבר רצחו כוחות גרמניים ועוזריהם המקומיים בגיא סמוך לקייב יותר מ־33 אלף יהודים. זה היה אחד הטבחים הגדולים ביותר בשואה בידי יחידות הירי, לפני הקמת מחנות ההשמדה. בשנים שלאחר מכן נרצחו במקום עוד רבים, בהם שבויי מלחמה ותושבים אחרים.",
    "rank": 369
  },
  {
    "id": "anq_persepolis",
    "deck": "anchors",
    "title": "בניית פרספוליס",
    "start": -518,
    "end": -518,
    "date": "בערך 518 לפנה״ס",
    "place": "פרספוליס, איראן",
    "lat": 29.935,
    "lon": 52.892,
    "desc": "דריוש הראשון החל לבנות את פרספוליס, מרכז טקסי של האימפריה הפרסית, על במה גדולה עם ארמונות ואולמות עמודים. תבליטי אפדנה מראים נציגי עמי האימפריה מביאים מנחות. העיר נשרפה בידי אלכסנדר מוקדוני ב־330 לפנה״ס.",
    "rank": 370
  },
  {
    "id": "med_osman",
    "deck": "anchors",
    "title": "אוסמאן הראשון וראשית העות׳מאנים",
    "start": 1299,
    "end": 1299,
    "date": "בערך 1299",
    "place": "סוגוט, תורכיה",
    "lat": 40.02,
    "lon": 30.17,
    "desc": "אוסמאן, מנהיג שבט תורכי בצפון־מערב אנטוליה, הרחיב את אחיזתו על חשבון הביזנטים בימי היחלשות הסלג׳וקים והמונגולים. שמו העניק את שמה לשושלת העות׳מאנית. בתוך כמאה וחמישים שנה הפכה הנסיכות הקטנה לאימפריה.",
    "rank": 371
  },
  {
    "id": "mod_cultural_rev",
    "deck": "anchors",
    "title": "מהפכת התרבות בסין",
    "start": 1966,
    "end": 1976,
    "date": "⁦1966–1976⁩",
    "place": "בייג׳ינג, סין",
    "lat": 39.99,
    "lon": 116.31,
    "desc": "מאו דזה־דונג יצא ב־1966 לקמפיין להסרת יריבים פוליטיים ולשימור המהפכה, ועודד סטודנטים צעירים, ״המשמרות האדומים״, לתקוף אינטלקטואלים ופקידים. מיליוני בני אדם הושפלו, הוגלו או נהרגו, והחינוך והכלכלה נפגעו קשות. התקופה הסתיימה במות מאו ב־1976.",
    "rank": 372
  },
  {
    "id": "anq_alesia",
    "deck": "anchors",
    "title": "קרב אלזיה",
    "start": -52,
    "end": -52,
    "date": "52 לפנה״ס",
    "place": "אלזיה, צרפת",
    "lat": 47.54,
    "lon": 4.5,
    "desc": "יוליוס קיסר צר על ורצינג׳טוריקס, מנהיג מרד הגאלים, מאחורי חומת מצור כפולה, ובו־זמנית הדף צבא הצלה גאלי גדול. ורצינג׳טוריקס נכנע, והגאליה כולה נשארה בידי רומא. הקרב נחשב אחד ממעשי ההנדסה והפיקוד הגדולים של קיסר.",
    "rank": 373
  },
  {
    "id": "med_hus",
    "deck": "anchors",
    "title": "יאן הוס נשרף על המוקד",
    "start": 1415,
    "end": 1415,
    "date": "1415",
    "place": "קונסטנץ, גרמניה",
    "lat": 47.66,
    "lon": 9.18,
    "desc": "יאן הוס, כומר ומרצה מפראג שקרא לתיקון הכנסייה והושפע מרעיונות ג׳ון וויקליף, הועמד למשפט במועצת קונסטנץ ונשרף על המוקד בעוון כפירה. מותו הצית את מלחמות ההוסים בבוהמיה. הוא נחשב לאחד מקודמיה של הרפורמציה.",
    "rank": 374
  },
  {
    "id": "mod_pyramids",
    "deck": "anchors",
    "title": "קרב הפירמידות ומסע נפוליאון למצרים",
    "start": 1798,
    "end": 1798,
    "date": "1798",
    "place": "גיזה, מצרים",
    "lat": 30.05,
    "lon": 31.2,
    "desc": "נפוליאון בונפרטה נחת במצרים עם צבא ועם מדענים, והביס את צבא המממלוכים סמוך לקהיר. הצי הצרפתי הושמד בקרב הנילוס על ידי נלסון, והצבא נותר מנותק. המסע חשף למערב את מצרים העתיקה ויצר את מחקר מצרים המודרני.",
    "rank": 375
  },
  {
    "id": "anq_assurbanipal_library",
    "deck": "anchors",
    "title": "ספריית אשורבניפל",
    "start": -650,
    "end": -650,
    "date": "בערך 650 לפנה״ס",
    "place": "נינוה, עיראק",
    "lat": 36.36,
    "lon": 43.15,
    "desc": "אשורבניפל, אחרון המלכים הגדולים של אשור, אסף בנינוה ספרייה של אלפי לוחות חימר: אפוסים, קסמים, רשימות ידע ואסטרונומיה. בהם נמצא הנוסח המלא ביותר של עלילות גלגמש. הספרייה נחשפה במאה ה־19 והיא מקור עיקרי להכרת התרבות המסופוטמית.",
    "rank": 376
  },
  {
    "id": "med_plaguejust",
    "deck": "anchors",
    "title": "המגפה של יוסטיניאנוס",
    "start": 541,
    "end": 542,
    "date": "⁦541–542⁩ לספירה",
    "place": "קונסטנטינופול, האימפריה הביזנטית",
    "lat": 41.01,
    "lon": 28.95,
    "desc": "מגפת דבר פרצה במצרים, התפשטה אל הים התיכון והגיעה לבירה הביזנטית ב־542. מקורות בני התקופה מדברים על אלפי מתים ביום בשיא המגפה. היא פגעה קשות באוכלוסייה ובצבא, וגלים חוזרים שלה נמשכו כמאתיים שנה.",
    "rank": 377
  },
  {
    "id": "mod_first_aliyah",
    "deck": "anchors",
    "title": "העלייה הראשונה",
    "start": 1882,
    "end": 1903,
    "date": "⁦1882–1903⁩",
    "place": "ראשון לציון, ארץ ישראל",
    "lat": 31.97,
    "lon": 34.8,
    "desc": "בעקבות הפרעות ביהודי האימפריה הרוסית ב־1881 עלו לארץ ישראל העות׳מאנית, ששלט בה, אלפי יהודים. הם ייסדו מושבות חקלאיות כמו ראשון לציון ופתח תקווה, בסיוע הברון רוטשילד. העלייה הייתה גל ההגירה הציוני המאורגן הראשון, והניחה יסוד להתיישבות היהודית המתחדשת.",
    "rank": 378
  },
  {
    "id": "anq_septuagint",
    "deck": "anchors",
    "title": "תרגום השבעים",
    "start": -250,
    "end": -250,
    "date": "בערך 250 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.92,
    "desc": "לפי איגרת אריסטיאס עשו שבעים ושניים חכמים את תרגום התורה ליוונית לבקשת תלמי השני. התרגום נועד לקהילה היהודית דוברת היוונית באלכסנדריה, ובהמשך נתרגמו אליו גם שאר ספרי המקרא. הוא נעשה לבסיס המקרא של הנצרות הקדומה.",
    "rank": 379
  },
  {
    "id": "med_dome",
    "deck": "anchors",
    "title": "כיפת הקתדרלה של פירנצה",
    "start": 1436,
    "end": 1436,
    "date": "1436",
    "place": "פירנצה, איטליה",
    "lat": 43.773,
    "lon": 11.256,
    "desc": "האדריכל פיליפו ברונלסקי השלים את כיפת הקתדרלה של פירנצה, ללא מסגרת עץ תומכת, בשיטת בנייה מקורית. היא הייתה הכיפה הגדולה ביותר שנבנתה באירופה מאז העת העתיקה. הכיפה נחשבת לסמל מוקדם של הרנסנס האיטלקי.",
    "rank": 380
  },
  {
    "id": "mod_falklands",
    "deck": "anchors",
    "title": "מלחמת פוקלנד",
    "start": 1982,
    "end": 1982,
    "date": "1982",
    "place": "איי פוקלנד, דרום האוקיינוס האטלנטי",
    "lat": -51.7,
    "lon": -57.85,
    "desc": "ב־2 באפריל פלשה ארגנטינה לאיי פוקלנד השנויים במחלוקת, שבריטניה שלטה בהם. ממשלת מרגרט תאצ׳ר שלחה כוח ימי, והאיים נכבשו מחדש ביוני, אחרי כ־900 הרוגים משני הצדדים. התבוסה תרמה לנפילת החונטה הצבאית בארגנטינה.",
    "rank": 381
  },
  {
    "id": "anq_catalaunian",
    "deck": "anchors",
    "title": "קרב המישורים הקטלאוניים",
    "start": 451,
    "end": 451,
    "date": "451 לספירה",
    "place": "שאלון, צרפת",
    "lat": 48.9,
    "lon": 4.4,
    "desc": "קואליציית רומאים וויזיגותים בפיקוד איציוס נלחמה בצבא ההונים של אטילה. הקרב היה עקוב מדם וללא הכרעה ברורה, אך אטילה נסוג מגאליה. הוא פלש בשנה שלאחר מכן לאיטליה, ומת ב־453. הקרב מוכר כניצחון אחרון גדול של הצבא הרומי המערבי.",
    "rank": 382
  },
  {
    "id": "med_manzikert",
    "deck": "anchors",
    "title": "קרב מנצקרט",
    "start": 1071,
    "end": 1071,
    "date": "1071",
    "place": "מנצקרט, אנטוליה (טורקיה)",
    "lat": 39.14,
    "lon": 42.54,
    "desc": "הסלג׳וקים בראשות אלפ ארסלאן הביסו את הצבא הביזנטי ולכדו את הקיסר רומנוס הרביעי. ההפסד גרם למשבר פוליטי בביזנטיון ופתח את אנטוליה להתיישבות שבטים טורקים. בהמשך פנה הקיסר אלכסיוס הראשון לאפיפיור בבקשת סיוע.",
    "rank": 383
  },
  {
    "id": "anq_ishtar_gate",
    "deck": "anchors",
    "title": "שער עשתר בבבל",
    "start": -575,
    "end": -575,
    "date": "בערך 575 לפנה״ס",
    "place": "בבל, עיראק",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "נבוכדנאצר השני שיקם את בבל והקים שער מפואר מלבנים מזוגגות כחולות, ועליהן שוורים ודרקונים. השער היה בכניסה לדרך התהלוכות לעבר מקדש מרדוך. שחזור שלו מוצג במוזיאון פרגמון בברלין.",
    "rank": 384
  },
  {
    "id": "med_avignon",
    "deck": "anchors",
    "title": "האפיפיור עובר לאביניון",
    "start": 1309,
    "end": 1309,
    "date": "1309",
    "place": "אביניון, צרפת",
    "lat": 43.95,
    "lon": 4.81,
    "desc": "האפיפיור קלמנס החמישי, צרפתי שנבחר בלחץ המלך הצרפתי, התיישב באביניון ולא ברומא, וכך עשו יורשיו עד 1377. התקופה, שכונתה ״השבי הבבלי של הכנסייה״, פגעה בהערכה לאפיפיורות. בהמשך פרץ הפילוג הגדול, כששני אפיפיורים כיהנו בו בזמן.",
    "rank": 385
  },
  {
    "id": "mod_alamein",
    "deck": "anchors",
    "title": "קרב אל־עלמיין",
    "start": 1942,
    "end": 1942,
    "date": "1942",
    "place": "אל־עלמיין, מצרים",
    "lat": 30.83,
    "lon": 28.95,
    "desc": "באוקטובר ובנובמבר פתח הצבא הבריטי השמיני בפיקוד ברנרד מונטגומרי במתקפה על כוחות גרמניה ואיטליה בפיקוד ארווין רומל במדבר המערבי. הכוחות הגרמניים נסוגו, ולא חזרו להתקדם לעבר תעלת סואץ. הקרב נחשב לנקודת מפנה בחזית צפון אפריקה.",
    "rank": 386
  },
  {
    "id": "anq_chandragupta",
    "deck": "anchors",
    "title": "הקמת האימפריה המאורית",
    "start": -321,
    "end": -321,
    "date": "בערך 321 לפנה״ס",
    "place": "פאטליפוטרה, הודו",
    "lat": 25.61,
    "lon": 85.14,
    "desc": "צ׳נדרגופטה מאוריה, לפי המסורת בעצת הוגה המדינה קאוטיליה, הדיח את שושלת ננדה ויסד אימפריה בצפון הודו. הוא הדף את סלווקוס הראשון והשיג בהסכם שטחים בצפון־מערב. נכדו אשוקה הרחיב אותה, והיא הייתה לאימפריה הגדולה ביותר שקמה בהודו העתיקה.",
    "rank": 387
  },
  {
    "id": "med_timur",
    "deck": "anchors",
    "title": "עליית תימור",
    "start": 1370,
    "end": 1370,
    "date": "1370",
    "place": "סמרקנד, אוזבקיסטן",
    "lat": 39.655,
    "lon": 66.975,
    "desc": "תימור, שליט תורכי־מונגולי שראה עצמו יורשו של ג׳ינגיס חאן, תפס את השלטון בטרנסאוקסיאנה וקבע את בירתו בסמרקנד. משם יצא למסעות כיבוש ברחבי פרס, הודו וסוריה. בימיו הפכה סמרקנד למרכז אדריכלות ותרבות מפואר.",
    "rank": 388
  },
  {
    "id": "mod_solidarity",
    "deck": "anchors",
    "title": "סולידריות בגדנסק",
    "start": 1980,
    "end": 1980,
    "date": "1980",
    "place": "גדנסק, פולין",
    "lat": 54.36,
    "lon": 18.65,
    "desc": "באוגוסט פתחו פועלי המספנה על שם לנין בגדנסק בשביתה בהנהגת לך ואלנסה. הממשלה הקומוניסטית נאלצה להסכים להקמת איגוד עובדים עצמאי, סולידריות, הראשון מסוגו בגוש הסובייטי. מיליוני פולנים הצטרפו אליו, ולמרות הכרזת המצור ב־1981 הוא תרם לנפילת הקומוניזם בפולין ב־1989.",
    "rank": 389
  },
  {
    "id": "anq_hypatia",
    "deck": "anchors",
    "title": "רצח היפטיה",
    "start": 415,
    "end": 415,
    "date": "415 לספירה",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.92,
    "desc": "היפטיה, פילוסופית ומתמטיקאית, נרצחה בידי המון נוצרי בעיר. היא לימדה פלטוניזם ואסטרונומיה, והייתה בין המלומדים הבולטים של זמנה. מותה נתפס בעיני רבים כסימן להתערערות הלימוד הקלאסי באלכסנדריה. הרצח בא על רקע מתיחות בין הנציב אורסטס לבין הארכיבישוף קיריל, והוא נותר סמל מוכר.",
    "rank": 390
  },
  {
    "id": "med_houseofwisdom",
    "deck": "anchors",
    "title": "בית החוכמה בבגדאד",
    "start": 830,
    "end": 830,
    "date": "בערך 830 לספירה",
    "place": "בגדאד, עיראק",
    "lat": 33.34,
    "lon": 44.4,
    "desc": "בימי הח׳ליף אל־מאמון פרח מרכז מחקר ותרגום בבגדאד שתרגם לערבית כתבים יווניים, פרסיים והודיים. מלומדים כמו אל־ח׳ואריזמי פיתחו בו אלגברה ואסטרונומיה. פעילות המוסד היא מסימני תור הזהב האסלאמי.",
    "rank": 391
  },
  {
    "id": "mod_alamo",
    "deck": "anchors",
    "title": "קרב אלאמו",
    "start": 1836,
    "end": 1836,
    "date": "1836",
    "place": "סן אנטוניו, טקסס",
    "lat": 29.43,
    "lon": -98.49,
    "desc": "כוחות מקסיקניים בפיקוד הגנרל סנטה אנה כבשו את המצודה שהחזיקו מתיישבים אמריקאים ותומכי עצמאות מטקסס, וכל מגיניה נהרגו. הקרב הפך לסמל ולקריאת קרב, ״זכרו את אלאמו״. כעבור שבועות הביסו הטקסנים את סנטה אנה וביססו רפובליקה עצמאית.",
    "rank": 392
  },
  {
    "id": "anq_nineveh",
    "deck": "anchors",
    "title": "נפילת נינוה",
    "start": -612,
    "end": -612,
    "date": "בערך 612 לפנה״ס",
    "place": "נינוה, עיראק",
    "lat": 36.36,
    "lon": 43.15,
    "desc": "ברית של בבלים בראשות נבופולסר ומדים בראשות קיאקסרס כבשה והחריבה את נינוה, בירת אשור. האימפריה האשורית התמוטטה תוך שנים ספורות. בבל ומדי חילקו ביניהן את נחלותיה. העיר לא שבה לגדולתה.",
    "rank": 393
  },
  {
    "id": "med_rumi",
    "deck": "anchors",
    "title": "פטירתו של רומי",
    "start": 1273,
    "end": 1273,
    "date": "1273",
    "place": "קוניה, תורכיה",
    "lat": 37.871,
    "lon": 32.493,
    "desc": "ג׳לאל א־דין רומי, משורר ומיסטיקן סופי שנולד באזור בלח׳ ונמלט מפני המונגולים, נפטר בקוניה שבאנטוליה. הוא חיבר את המתנוי, שיר ארוך בפרסית, ואת דיוואן שמס תבריזי. חסידיו ייסדו את מסדר המוולווים, ״הדרווישים המסתובבים״.",
    "rank": 394
  },
  {
    "id": "mod_srebrenica",
    "deck": "anchors",
    "title": "הטבח בסרברניצה",
    "start": 1995,
    "end": 1995,
    "date": "1995",
    "place": "סרברניצה, בוסניה והרצגובינה",
    "lat": 44.1,
    "lon": 19.3,
    "desc": "ביולי השתלטו כוחות סרבים־בוסנים בפיקוד רטקו מלאדיץ׳ על העיר סרברניצה, שהוגדרה אזור מוגן של האו״ם. יותר מ־8,000 גברים ונערים בוסנים מוסלמים נרצחו תוך ימים. בית הדין הבין־לאומי לצדק ובית הדין לפשעי מלחמה ביוגוסלביה קבעו שהיה זה רצח עם.",
    "rank": 395
  },
  {
    "id": "anq_via_appia",
    "deck": "anchors",
    "title": "סלילת הדרך האפיית",
    "start": -312,
    "end": -312,
    "date": "312 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.85,
    "lon": 12.52,
    "desc": "הצנזור אפיוס קלאודיוס קאקוס יזם סלילת דרך מרומא לקפואה וכן אמת המים הראשונה של העיר. הדרך שירתה את הלגיונות במלחמות בסמניטים, ובהמשך הורחבה עד ברונדיסיום. מערכת הדרכים הרומית נעשתה לאחד מיסודות השלטון של רומא.",
    "rank": 396
  },
  {
    "id": "med_peasants_revolt",
    "deck": "anchors",
    "title": "מרד האיכרים באנגליה",
    "start": 1381,
    "end": 1381,
    "date": "1381",
    "place": "לונדון, אנגליה",
    "lat": 51.51,
    "lon": -0.09,
    "desc": "אחרי המגפה ובעקבות מס גולגולת חדש התקוממו אלפי איכרים ועירונים בדרום־מזרח אנגליה, בהנהגת וואט טיילר וג׳ון בול. הם נכנסו ללונדון והרגו בכירים. המלך הצעיר ריצ׳רד השני הבטיח ויתורים, אך המרד דוכא ומנהיגיו הוצאו להורג.",
    "rank": 397
  },
  {
    "id": "mod_trafalgar",
    "deck": "anchors",
    "title": "קרב טרפלגר",
    "start": 1805,
    "end": 1805,
    "date": "1805",
    "place": "כף טרפלגר, ספרד",
    "lat": 36.18,
    "lon": -6.03,
    "desc": "הצי הבריטי בפיקוד האדמירל נלסון הביס את הצי המשולב של צרפת וספרד מול חופי ספרד. נלסון נהרג בקרב. הניצחון הבטיח את עליונות בריטניה בים לכל המאה ה־19 ושם קץ לתוכניות הפלישה של נפוליאון.",
    "rank": 398
  },
  {
    "id": "anq_narmer",
    "deck": "anchors",
    "title": "איחוד מצרים העליונה והתחתונה",
    "start": -3100,
    "end": -3100,
    "date": "בערך 3100 לפנה״ס",
    "place": "היראקונפוליס, מצרים",
    "lat": 25.1,
    "lon": 32.78,
    "desc": "לפי המסורת המצרית ולפי פלטת נרמר, המלך נרמר איחד את דרום מצרים ואת הדלתה בצפון לממלכה אחת. המדינה המאוחדת נשלטה מאות שנים בידי שושלות פרעונים והייתה אחת המדינות הראשונות בעולם. פרטי האיחוד אינם ברורים, ושמו של המלך המאחד שנוי במחלוקת בין החוקרים.",
    "rank": 399
  },
  {
    "id": "med_umayyad",
    "deck": "anchors",
    "title": "הקמת הח׳ליפות האומיית בדמשק",
    "start": 661,
    "end": 661,
    "date": "661 לספירה",
    "place": "דמשק, סוריה",
    "lat": 33.51,
    "lon": 36.29,
    "desc": "אחרי המלחמה בין עלי למואוויה ורצח עלי הפך מואוויה, מושל סוריה, לח׳ליף והקים שושלת אומיית. הבירה הועברה מהחיג׳אז לדמשק. בימי האומיים התרחבה הח׳ליפות עד ספרד והודו, והערבית הפכה לשפת השלטון.",
    "rank": 400
  },
  {
    "id": "mod_gettysburg",
    "deck": "anchors",
    "title": "קרב גטיסברג",
    "start": 1863,
    "end": 1863,
    "date": "1863",
    "place": "גטיסברג, פנסילבניה, ארה״ב",
    "lat": 39.83,
    "lon": -77.23,
    "desc": "במשך שלושה ימים נלחמו הצבא הפדרלי בפיקוד מיד וצבא הקונפדרציה בפיקוד לי. הקרב היה עקוב מדם במיוחד, עם יותר מ־50 אלף נפגעים. הוא נחשב לנקודת מפנה במלחמה, ולינקולן נשא בבית הקברות נאום קצר, ״נאום גטיסברג״.",
    "rank": 401
  },
  {
    "id": "anq_twelve_tables",
    "deck": "anchors",
    "title": "לוחות שנים העשר",
    "start": -451,
    "end": -450,
    "date": "⁦451–450⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.49,
    "desc": "בעקבות דרישות הפלבאים הוועדה של עשרה אנשים כתבה את חוקי רומא על לוחות והציבה אותם בפורום, כך שהכול יכלו להכירם. הלוחות עסקו במשפט, בחובות ובמשפחה. הם היו יסוד המשפט הרומי שעליו התפתחו חוקי רומא במשך מאות שנים.",
    "rank": 402
  },
  {
    "id": "med_lepanto",
    "deck": "anchors",
    "title": "קרב לפנטו",
    "start": 1571,
    "end": 1571,
    "date": "1571",
    "place": "מפרץ פטרס, יוון",
    "lat": 38.3,
    "lon": 21.1,
    "desc": "צי של הליגה הקדושה, בהנהגת ספרד וונציה והאפיפיור, הביס את הצי העות׳מאני במפרץ פטרס. הקרב נחשב לאחד הגדולים בהיסטוריה של הספינות המשוטים. העות׳מאנים בנו צי חדש תוך שנה, ובכל זאת הקרב עצר את התקדמותם בים התיכון המערבי.",
    "rank": 403
  },
  {
    "id": "mod_suez_2",
    "deck": "anchors",
    "title": "משבר סואץ",
    "start": 1956,
    "end": 1956,
    "date": "1956",
    "place": "פורט סעיד, מצרים",
    "lat": 31.26,
    "lon": 32.3,
    "desc": "אחרי שנאצר הלאים ביולי את תעלת סואץ, תקפו ישראל, בריטניה וצרפת את מצרים באוקטובר ובנובמבר. ארצות הברית וברית המועצות התנגדו, והכוחות נסוגו תחת לחץ, בעוד כוח של האו״ם נפרס בסיני. המשבר חשף את חולשת המעצמות הקולוניאליות הישנות ואת עליית המעצמות החדשות.",
    "rank": 404
  },
  {
    "id": "anq_teotihuacan",
    "deck": "anchors",
    "title": "מקדש השמש בטאוטיווקאן",
    "start": 100,
    "end": 100,
    "date": "בערך 100 לספירה",
    "place": "טאוטיווקאן, מקסיקו",
    "lat": 19.69,
    "lon": -98.84,
    "desc": "במרכז העיר הגדולה של עמק מקסיקו נבנתה פירמידת השמש, המבנה הגדול ביותר בעיר. טאוטיווקאן הייתה מהגדולות בעולם בימיה, עם עשרות אלפי תושבים, שדרה ראשית וקשרי מסחר עם המאיה. את הפירמידה בנו כנראה בסביבות שנת 100.",
    "rank": 405
  },
  {
    "id": "med_otto",
    "deck": "anchors",
    "title": "אוטו הראשון מוכתר לקיסר",
    "start": 962,
    "end": 962,
    "date": "962 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.9,
    "lon": 12.47,
    "desc": "האפיפיור יוחנן השנים עשר הכתיר את אוטו הראשון, מלך גרמניה, לקיסר ברומא. הכתרה זו מציינת את התחלת האימפריה הרומית הקדושה כישות פוליטית שנמשכה עד 1806. הקיסרים הגרמנים התחרו מאז באפיפיורים על הסמכות בעולם הנוצרי.",
    "rank": 406
  },
  {
    "id": "mod_teaparty",
    "deck": "anchors",
    "title": "מסיבת התה של בוסטון",
    "start": 1773,
    "end": 1773,
    "date": "1773",
    "place": "בוסטון, ארה״ב",
    "lat": 42.36,
    "lon": -71.05,
    "desc": "קבוצת מתיישבים, חלקם מחופשים לאינדיאנים, עלתה על ספינות של חברת הודו המזרחית והשליכה לנמל מאות תיבות תה במחאה על מיסוי ללא ייצוג. בריטניה הגיבה בחוקים שנקראו בפי המתיישבים ״החוקים בלתי נסבלים״. התגובה הובילה להסלמה ולפרוץ מלחמת העצמאות.",
    "rank": 407
  },
  {
    "id": "anq_djoser",
    "deck": "anchors",
    "title": "הפירמידה המדורגת של ג׳וסר",
    "start": -2670,
    "end": -2670,
    "date": "בערך 2670 לפנה״ס",
    "place": "סקארה, מצרים",
    "lat": 29.871,
    "lon": 31.216,
    "desc": "המלך ג׳וסר הקים בסקארה קבר מאבן מעובדת בשש מדרגות, בתכנון האדריכל והחכם אימהוטפ. המבנה היה הגדול הראשון בעולם שנבנה כולו מאבן, ופתח את תקופת הפירמידות. מעליו נבנו אחר כך הפירמידות החלקות של גיזה.",
    "rank": 408
  },
  {
    "id": "med_prague",
    "deck": "anchors",
    "title": "ההשלכה מחלון בפראג",
    "start": 1618,
    "end": 1618,
    "date": "1618",
    "place": "פראג, צ׳כיה",
    "lat": 50.09,
    "lon": 14.4,
    "desc": "אצילים פרוטסטנטים בבוהמיה השליכו שני נציגי הקיסר הקתולי מחלון הארמון בפראג. האירוע הצית את מלחמת שלושים השנים, שהפכה ממרד מקומי לסכסוך כלל־אירופי. עד סופה נהרסו חלקים נרחבים מגרמניה.",
    "rank": 409
  },
  {
    "id": "mod_somme",
    "deck": "anchors",
    "title": "קרב הסום",
    "start": 1916,
    "end": 1916,
    "date": "1916",
    "place": "הסום, צרפת",
    "lat": 50,
    "lon": 2.7,
    "desc": "בין יולי לנובמבר תקפו כוחות בריטיים וצרפתיים את הקווים הגרמניים לאורך נהר הסום. ביום הראשון בלבד נפלו כ־20 אלף חיילים בריטים. בקרב הופעלו לראשונה טנקים, אך הקו לא נפרץ, ובסך הכול נפצעו או נהרגו יותר ממיליון לוחמים משני הצדדים.",
    "rank": 410
  },
  {
    "id": "anq_croesus",
    "deck": "anchors",
    "title": "כורש כובש את ליודיה",
    "start": -546,
    "end": -546,
    "date": "בערך 546 לפנה״ס",
    "place": "סרדיס, טורקיה",
    "lat": 38.488,
    "lon": 28.04,
    "desc": "כורש השני, מלך פרס, כבש את ליודיה והביס את קרויסוס, שנודע בעושרו, ובכך איחד את אנטוליה לאימפריה הפרסית. הערים היווניות באיוניה נעשו כפופות לפרס. סרדיס הפכה לבירת נציב.",
    "rank": 411
  },
  {
    "id": "med_montecassino",
    "deck": "anchors",
    "title": "בנדיקטוס מייסד את מנזר מונטה קאסינו",
    "start": 529,
    "end": 529,
    "date": "בערך 529 לספירה",
    "place": "מונטה קאסינו, איטליה",
    "lat": 41.49,
    "lon": 13.81,
    "desc": "לפי המסורת ייסד בנדיקטוס מנורסיה את המנזר על הר שמעל קאסינו. הכללים הנזיריים שכתב, שנודעו כ״כלל בנדיקטוס״, עיצבו את חיי המנזרים במערב אירופה לאורך מאות שנים. המנזרים שימרו ידע, כתבי יד ולימוד בימי הביניים המוקדמים.",
    "rank": 412
  },
  {
    "id": "mod_nanjing_2",
    "deck": "anchors",
    "title": "הטבח בנאנג׳ינג",
    "start": 1937,
    "end": 1938,
    "date": "⁦1937–1938⁩",
    "place": "נאנג׳ינג, סין",
    "lat": 32.06,
    "lon": 118.79,
    "desc": "בדצמבר 1937 כבשו כוחות יפן את נאנג׳ינג, בירת סין דאז, וביצעו בה במשך שבועות רצח, אונס ובזיזה. ההערכה הסינית היא שנרצחו 300 אלף בני אדם, והחוקרים מעריכים מספרים נמוכים יותר, אך מסכימים על עשרות אלפי הרוגים לפחות. הטבח נשאר נושא טעון ביחסי סין ויפן.",
    "rank": 413
  },
  {
    "id": "anq_red_cliffs",
    "deck": "anchors",
    "title": "קרב הצוקים האדומים",
    "start": 208,
    "end": 208,
    "date": "208 לספירה",
    "place": "צ׳יבי, סין",
    "lat": 29.87,
    "lon": 113.65,
    "desc": "בהרי היאנגצה הביסו בעלי הברית סון צ׳יואן ולוביי את צבאו של קאו קאו, שניסה לאחד את סין, בין היתר באמצעות ספינות אש. התבוסה מנעה איחוד מיידי של סין, וסללה את הדרך לתקופת שלוש הממלכות. הקרב מתואר בהרחבה בספרות ובתרבות הסינית, ובעיקר ברומן שלוש הממלכות.",
    "rank": 414
  },
  {
    "id": "med_rhineland",
    "deck": "anchors",
    "title": "פרעות הצלבנים ביהודי הריין",
    "start": 1096,
    "end": 1096,
    "date": "1096",
    "place": "מיינץ, גרמניה",
    "lat": 50,
    "lon": 8.27,
    "desc": "בדרכם לארץ הקודש תקפו להקות צלבנים ופשוטי עם קהילות יהודיות בערי הריין: שפייר, וורמס ומיינץ. רבים נהרגו, וחלקם בחרו להתאבד במקום להמיר דת. הפרעות פתחו תקופה של פגיעה ביהודי אשכנז.",
    "rank": 415
  },
  {
    "id": "mod_londonfire",
    "deck": "anchors",
    "title": "השריפה הגדולה של לונדון",
    "start": 1666,
    "end": 1666,
    "date": "1666",
    "place": "לונדון, אנגליה",
    "lat": 51.51,
    "lon": -0.09,
    "desc": "השריפה פרצה במאפייה ברחוב פודינג ליין ובמשך ארבעה ימים אכלה את רוב העיר העתיקה, ובהם קתדרלת סנט פול ועשרות אלפי בתים. מספר ההרוגים המתועדים היה קטן. העיר נבנתה מחדש בחומרי בנייה עמידים יותר, וכריסטופר רן תכנן את הקתדרלה החדשה.",
    "rank": 416
  },
  {
    "id": "anq_gilgamesh",
    "deck": "anchors",
    "title": "גלגמש מלך אורוק",
    "start": -2700,
    "end": -2700,
    "date": "בערך 2700 לפנה״ס",
    "place": "אורוק, מסופוטמיה",
    "lat": 31.32,
    "lon": 45.64,
    "desc": "גלגמש, מלך אורוק, מופיע ברשימות מלכים שומריות כשליט היסטורי, ובעקבותיו נכתבו שירים ובהם עלילות אל מעבר למציאות. אלפי שנים אחר כך נאספו הסיפורים ל״עלילות גלגמש״, אחת היצירות הספרותיות הקדומות בעולם. חומות אורוק מיוחסות לו במסורת.",
    "rank": 417
  },
  {
    "id": "med_forbidden_city",
    "deck": "anchors",
    "title": "העיר האסורה בבייג׳ינג",
    "start": 1420,
    "end": 1420,
    "date": "1420",
    "place": "בייג׳ינג, סין",
    "lat": 39.916,
    "lon": 116.397,
    "desc": "הקיסר יונגלה העביר את בירת מינג מנאנג׳ינג לבייג׳ינג ובנה בה ארמון עצום. העיר האסורה, שבנייתה נמשכה כשנים־עשר שנה, שימשה את הקיסרים עד 1912. בימיה כללה כאלף בניינים, והייתה סגורה לרוב האוכלוסייה.",
    "rank": 418
  },
  {
    "id": "mod_gallipoli",
    "deck": "anchors",
    "title": "קרב גליפולי",
    "start": 1915,
    "end": 1916,
    "date": "⁦1915–1916⁩",
    "place": "חצי האי גליפולי, טורקיה",
    "lat": 40.23,
    "lon": 26.28,
    "desc": "בעלות הברית ניסו לפתוח את מיצרי הדרדנלים ולכבוש את איסטנבול, ובאפריל 1915 נחתו חייליהן בגליפולי. הכוחות העות׳מאניים, בהם הקצין מוסטפא כמאל, עצרו אותם, והקרבות הפכו למלחמת חפירות. בינואר 1916 פונו כוחות בעלות הברית. הקרב הפך לסמל לאומי באוסטרליה, בניו זילנד ובטורקיה.",
    "rank": 419
  },
  {
    "id": "anq_thales",
    "deck": "anchors",
    "title": "תאלס ממילטוס",
    "start": -585,
    "end": -585,
    "date": "בערך 585 לפנה״ס",
    "place": "מילטוס, טורקיה",
    "lat": 37.53,
    "lon": 27.28,
    "desc": "תאלס הפילוסוף ממילטוס ניבא, לפי הרודוטוס, ליקוי חמה שאירע בעת קרב בין הליודים והמדים, מה שהפסיק את הקרב. נהוג לראות בו הפילוסוף הראשון, שהציע הסברים טבעיים במקום מיתיים לעולם.",
    "rank": 420
  },
  {
    "id": "mod_tunisia",
    "deck": "anchors",
    "title": "העלאתו באש של בועזיזי",
    "start": 2010,
    "end": 2010,
    "date": "2010",
    "place": "סידי בוזיד, תוניסיה",
    "lat": 35.04,
    "lon": 9.49,
    "desc": "ב־17 בדצמבר הצית את עצמו בסידי בוזיד מוחמד בועזיזי, רוכל פירות צעיר, במחאה על הטרדת רשויות ועל עוני. המוות שלו הצית הפגנות ברחבי תוניסיה, וב־14 בינואר 2011 ברח הנשיא בן עלי. המחאה התפשטה למדינות ערב אחרות והוכרה כ״האביב הערבי״.",
    "rank": 421
  },
  {
    "id": "anq_adrianople",
    "deck": "anchors",
    "title": "קרב אדריאנופול",
    "start": 378,
    "end": 378,
    "date": "378 לספירה",
    "place": "אדריאנופול (אדירנה), טורקיה",
    "lat": 41.68,
    "lon": 26.55,
    "desc": "הגותים, שנכנסו לאימפריה כפליטים והתקוממו, הביסו את צבא הקיסר ולנס. הקיסר נהרג והפרשים הגותיים ניצחו את חיל הרגלים הרומי. הקרב הראה את חולשת הצבא ואת חדירת הברברים אל גבולות האימפריה. הצבא הרומי איבד כשני שלישים מכוחו, ותבוסה זו נזכרת כנקודת מפנה בהיחלשות המערב.",
    "rank": 422
  },
  {
    "id": "med_yuan",
    "deck": "anchors",
    "title": "קובלאי חאן מכריז על שושלת יואן",
    "start": 1271,
    "end": 1271,
    "date": "1271",
    "place": "דאדו (בייג׳ינג), סין",
    "lat": 39.905,
    "lon": 116.39,
    "desc": "קובלאי חאן, נכדו של ג׳ינגיס, אימץ שם שושלת סיני, יואן, ובנה בירה חדשה בדאדו, היא בייג׳ינג. עד 1279 השלים את כיבוש דרום סין. תחת שלטונו נפתחו נתיבי המסחר בין סין לאירופה, ובשירותו שהו זרים רבים.",
    "rank": 423
  },
  {
    "id": "mod_austerlitz",
    "deck": "anchors",
    "title": "קרב אוסטרליץ",
    "start": 1805,
    "end": 1805,
    "date": "1805",
    "place": "אוסטרליץ (סלאבקוב), צ׳כיה",
    "lat": 49.13,
    "lon": 16.76,
    "desc": "נפוליאון הביס את צבאות אוסטריה ורוסיה בקרב שנקרא ״קרב שלושת הקיסרים״, בעזרת תמרון שהוליך את בעלי בריתו לתקוף את אגפו החלש. אוסטריה חתמה על הסכם פרסבורג והאימפריה הרומית הקדושה פורקה ב־1806. הקרב נחשב לניצחון הגדול ביותר של נפוליאון.",
    "rank": 424
  },
  {
    "id": "anq_mohenjo",
    "deck": "anchors",
    "title": "מוהנג׳ו־דארו בציוויליזציית עמק האינדוס",
    "start": -2500,
    "end": -2500,
    "date": "בערך 2500 לפנה״ס",
    "place": "סינד, פקיסטן",
    "lat": 27.329,
    "lon": 68.135,
    "desc": "מוהנג׳ו־דארו הייתה אחת הערים הגדולות בציוויליזציית עמק האינדוס. תוכנית רחובותיה אורתוגונלית, בתיה נבנו מלבנים אחידות, ובה מערכת ביוב ומרחצה גדולה. הכתב של התרבות הזאת לא פוענח עד היום, ולכן מעט ידוע על שליטיה.",
    "rank": 425
  },
  {
    "id": "med_voc",
    "deck": "anchors",
    "title": "חברת הודו המזרחית ההולנדית",
    "start": 1602,
    "end": 1602,
    "date": "1602",
    "place": "אמסטרדם, הולנד",
    "lat": 52.37,
    "lon": 4.9,
    "desc": "הולנד איחדה חברות סחר קטנות לחברה אחת, בעלת מונופול על המסחר עם אסיה. החברה הייתה בין הראשונות שמכרו מניות לציבור, והפעילה צי, צבא ומבצרים. היא שלטה בסחר התבלינים ובאינדונזיה והייתה לגורם מרכזי בעידן הזהב ההולנדי.",
    "rank": 426
  },
  {
    "id": "mod_edison",
    "deck": "anchors",
    "title": "המנורה החשמלית של אדיסון",
    "start": 1879,
    "end": 1879,
    "date": "1879",
    "place": "מנלו פארק, ניו ג׳רזי, ארה״ב",
    "lat": 40.55,
    "lon": -74.34,
    "desc": "תומאס אדיסון ועוזריו במעבדה בניו ג׳רזי הצליחו להפעיל נורת להט עם חוט פחמן במשך כמה עשרות שעות. הוא פיתח גם מערכת לייצור והפצה של חשמל. הנורה הפכה לצרכנית מסחרית והקדימה את החשמול של הערים.",
    "rank": 427
  },
  {
    "id": "anq_lydian_coins",
    "deck": "anchors",
    "title": "המטבעות הראשונים בליודיה",
    "start": -600,
    "end": -600,
    "date": "בערך 600 לפנה״ס",
    "place": "סרדיס, טורקיה",
    "lat": 38.488,
    "lon": 28.04,
    "desc": "במלכות ליודיה באנטוליה הוטבעו מטבעות מאלקטרום, סגסוגת טבעית של זהב וכסף, ועליהם סמל המלך. הם היו בין המטבעות הקדומים ביותר בעולם. המצאה זו קלה את הסחר ופשטה במהירות בערי יוון ובפרס.",
    "rank": 428
  },
  {
    "id": "med_gregory",
    "deck": "anchors",
    "title": "גרגוריוס הגדול נבחר לאפיפיור",
    "start": 590,
    "end": 590,
    "date": "590 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.9,
    "lon": 12.47,
    "desc": "גרגוריוס הראשון, נזיר לשעבר ופקיד בכיר, נבחר לאפיפיור בתקופת מגפה ומלחמה באיטליה. הוא ארגן את מנהל נכסי הכנסייה, פיקח על חלוקת מזון לעניים ושלח מיסיון לאנגליה. כהונתו הניחה יסוד לכוחו המדיני של האפיפיור בימי הביניים.",
    "rank": 429
  },
  {
    "id": "mod_khmer_rouge",
    "deck": "anchors",
    "title": "שלטון החמר האדום",
    "start": 1975,
    "end": 1979,
    "date": "⁦1975–1979⁩",
    "place": "פנום פן, קמבודיה",
    "lat": 11.56,
    "lon": 104.92,
    "desc": "אחרי כיבוש פנום פן באפריל 1975 הקים פול פוט משטר קומוניסטי קיצוני שפינה את הערים, ביטל את הכסף והעביר אנשים לעבודה בכפייה בשדות. בין 1.5 ל־2 מיליון בני אדם מתו מהרעב, ממחלות ומהוצאות להורג. המשטר נפל ב־1979 בפלישת וייטנאם.",
    "rank": 430
  },
  {
    "id": "anq_tyre",
    "deck": "anchors",
    "title": "המצור על צור",
    "start": -332,
    "end": -332,
    "date": "332 לפנה״ס",
    "place": "צור, לבנון",
    "lat": 33.27,
    "lon": 35.2,
    "desc": "אלכסנדר הגדול צר שבעה חודשים על העיר הפיניקית המבוצרת באי, ובנה סוללה מן החוף כדי להגיע אליה. לאחר שכבש אותה הרג רבים ומכר אחרים לעבדות. הסוללה חיברה את האי ליבשה, וצור נותרה חצי־אי עד היום. הכיבוש שלל מאלכסנדר את אחד הנמלים החשובים של הצי הפרסי ופתח לו את הדרך דרומה אל מצרים.",
    "rank": 431
  },
  {
    "id": "med_timbuktu",
    "deck": "anchors",
    "title": "ייסוד טימבוקטו",
    "start": 1100,
    "end": 1100,
    "date": "בערך 1100",
    "place": "טימבוקטו, מאלי",
    "lat": 16.77,
    "lon": -3,
    "desc": "לפי המסורת הקימו נוודים טוארגים מחנה עונתי ליד נהר הניז׳ר, ומשם צמחה עיר סחר. בהמשך הפכה טימבוקטו לצומת של שיירות הסהרה, לסחר בזהב ובמלח, ולמרכז לימוד מוסלמי.",
    "rank": 432
  },
  {
    "id": "mod_famine",
    "deck": "anchors",
    "title": "הרעב הגדול באירלנד",
    "start": 1845,
    "end": 1852,
    "date": "⁦1845–1852⁩",
    "place": "אירלנד",
    "lat": 53.35,
    "lon": -7.9,
    "desc": "מחלה שפגעה בתפוחי האדמה, מזונם העיקרי של העניים, הביאה לרעב שהרג כמיליון איש. עוד כמיליון היגרו, רבים לארצות הברית. מדיניות הממשלה הבריטית הואשמה בהחמרת האסון. אוכלוסיית אירלנד לא שבה לגודלה הקודם.",
    "rank": 433
  },
  {
    "id": "anq_sargon",
    "deck": "anchors",
    "title": "סרגון מייסד האימפריה האכדית",
    "start": -2334,
    "end": -2334,
    "date": "בערך 2334 לפנה״ס",
    "place": "אכד, מסופוטמיה",
    "lat": 33.1,
    "lon": 44.3,
    "desc": "סרגון מאכד כבש את ערי שומר והקים את האימפריה הראשונה בהיסטוריה, שהשתרעה מהמפרץ הפרסי עד הים התיכון. את שפת האכדית הפך לשפת המנהל. עיר הבירה אכד טרם אותרה בוודאות, והאימפריה התפוררה כמאה וחמישים שנה אחריו.",
    "rank": 434
  },
  {
    "id": "med_sundiata",
    "deck": "anchors",
    "title": "סונדיאטה ואימפריית מאלי",
    "start": 1235,
    "end": 1235,
    "date": "בערך 1235",
    "place": "קנגאבה, מאלי",
    "lat": 11.94,
    "lon": -8.41,
    "desc": "סונדיאטה קייטה, מנהיג המאנדינקה, ניצח את שליט הסוסו סומאורו ואיחד את ערי הסאהל והסוואנה במערב אפריקה. כך נוסדה אימפריית מאלי, ששלטה בנתיבי הזהב והמלח. אפוס סונדיאטה, שנמסר בעל פה בידי גריוטים, שימר את סיפורו.",
    "rank": 435
  },
  {
    "id": "anq_ephesus",
    "deck": "anchors",
    "title": "מקדש ארטמיס באפסוס",
    "start": -550,
    "end": -550,
    "date": "בערך 550 לפנה״ס",
    "place": "אפסוס, טורקיה",
    "lat": 37.95,
    "lon": 27.36,
    "desc": "בעיר היוונית אפסוס שבאיוניה החל קרויסוס מלך ליודיה לממן בניית מקדש ענק לארטמיס, שנחשב אחד משבעת פלאי תבל. המקדש כולו נבנה משיש ועמודיו הגיעו לגובה של כ־18 מטרים.",
    "rank": 436
  },
  {
    "id": "med_abbasid",
    "deck": "anchors",
    "title": "המהפכה העבאסית",
    "start": 750,
    "end": 750,
    "date": "750 לספירה",
    "place": "הזאב הגדול, עיראק",
    "lat": 36,
    "lon": 43.4,
    "desc": "צבא עבאסי, בהנהגת אבו מוסלם מח׳וראסאן, הביס את הח׳ליף האומיי האחרון מרואן השני בקרב על נהר הזאב. השושלת העבאסית עלתה לשלטון. התנועה שאבה תמיכה מבני אדם לא ערבים, ובמיוחד מפרסים, והעבירה את מרכז הח׳ליפות מזרחה.",
    "rank": 437
  },
  {
    "id": "mod_long_march",
    "deck": "anchors",
    "title": "המצעד הארוך",
    "start": 1934,
    "end": 1935,
    "date": "⁦1934–1935⁩",
    "place": "רויג׳ין, ג׳יאנגשי, סין",
    "lat": 25.85,
    "lon": 116.03,
    "desc": "הקומוניסטים הסינים, שנקלעו לכיתור של כוחות הקוומינטנג ברויג׳ין, פרצו מהמצור. במהלך שנה צעדו עשרות אלפי חיילים כ־9,000 קילומטרים לצפון־מערב סין, ורבים מתו בדרך. בצעדה התבסס מאו דזה־דונג כמנהיג המפלגה, והיא הפכה לאגדה מכוננת של הקומוניזם הסיני.",
    "rank": 438
  },
  {
    "id": "anq_mishnah",
    "deck": "anchors",
    "title": "חתימת המשנה",
    "start": 200,
    "end": 200,
    "date": "בערך 200 לספירה",
    "place": "ציפורי, גליל",
    "lat": 32.75,
    "lon": 35.28,
    "desc": "רבי יהודה הנשיא ערך את המשנה, חיבור הלכתי ובו שישה סדרים, לאחר דורות שבהם התקיימה תורה שבעל פה. העריכה נעשתה בגליל, ככל הנראה בבית שערים ובציפורי. המשנה היא יסוד התלמוד ומקור מרכזי של ההלכה היהודית. היא נערכה בעברית על בסיס מסורות שנוצרו בידי דורות של תנאים.",
    "rank": 439
  },
  {
    "id": "med_mongol_japan",
    "deck": "anchors",
    "title": "הפלישות המונגוליות ליפן",
    "start": 1274,
    "end": 1281,
    "date": "⁦1274–1281⁩",
    "place": "מפרץ הקאטה, יפן",
    "lat": 33.62,
    "lon": 130.4,
    "desc": "קובלאי חאן שלח שני צי פלישה גדולים אל חופי קיושו. ב־1281 הרס טייפון חלק ניכר מהצי, והיפנים ראו בו ״רוח אלוהית״, קמיקאזה. הצורך להחזיק כוחות הגנה בחוף הכביד על שלטון הקמקורה ותרם להיחלשותו.",
    "rank": 440
  },
  {
    "id": "mod_cook",
    "deck": "anchors",
    "title": "הנחיתה של ג׳יימס קוק במפרץ בוטני",
    "start": 1770,
    "end": 1770,
    "date": "1770",
    "place": "מפרץ בוטני, אוסטרליה",
    "lat": -34,
    "lon": 151.23,
    "desc": "המפקד הבריטי ג׳יימס קוק, שחקר את מזרח אוסטרליה בספינה אנדוור, ירד ליבשה ותבע את החוף בשם הכתר הבריטי, ושם לו שם ניו סאות׳ ויילס. הוא פגש שם את בני העם הגורינג. הדיווח עליו הוביל לבחירת האזור להקמת מושבת עבריינים בשנת 1788.",
    "rank": 441
  },
  {
    "id": "anq_knossos",
    "deck": "anchors",
    "title": "ארמון קנוסוס בכרתים",
    "start": -1900,
    "end": -1900,
    "date": "בערך 1900 לפנה״ס",
    "place": "קנוסוס, כרתים",
    "lat": 35.298,
    "lon": 25.163,
    "desc": "התרבות המינואית בכרתים בנתה ארמונות גדולים, והמפורסם בהם הוא קנוסוס, ובו חצרות, מחסנים וציורי קיר. הארמון שימש מרכז מנהלי ודתי. החופר ארתור אוונס נתן לתרבות את שמה על שם מינוס, מלך כרתים באגדה.",
    "rank": 442
  },
  {
    "id": "med_kosovo",
    "deck": "anchors",
    "title": "קרב קוסובו",
    "start": 1389,
    "end": 1389,
    "date": "1389",
    "place": "קוסובו פולה, קוסובו",
    "lat": 42.66,
    "lon": 21.1,
    "desc": "צבא עות׳מאני בפיקוד הסולטן מוראד הראשון נלחם בקואליציה סרבית בראשות הנסיך לזר. שני המנהיגים נהרגו, והקרב הסתיים ללא הכרעה ברורה. בפועל הפכה סרביה בהדרגה לווסאלית של העות׳מאנים, והקרב נחרת בזיכרון הלאומי הסרבי.",
    "rank": 443
  },
  {
    "id": "mod_panama_canal",
    "deck": "anchors",
    "title": "פתיחת תעלת פנמה",
    "start": 1914,
    "end": 1914,
    "date": "1914",
    "place": "תעלת פנמה, פנמה",
    "lat": 9.1,
    "lon": -79.7,
    "desc": "ב־15 באוגוסט עברה הספינה הראשונה בתעלה שחוצה את פנמה ומחברת את האוקיינוס האטלנטי עם השקט. ארצות הברית השלימה את הפרויקט אחרי ניסיון צרפתי כושל ועשר שנות עבודה, שבהן מתו אלפי פועלים ממחלות ומתאונות. התעלה קיצרה בהרבה את דרך הים בין החופים.",
    "rank": 444
  },
  {
    "id": "anq_draco",
    "deck": "anchors",
    "title": "חוקי דראקון באתונה",
    "start": -621,
    "end": -621,
    "date": "בערך 621 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.97,
    "lon": 23.73,
    "desc": "דראקון כתב את החוקים הכתובים הראשונים באתונה, והם נודעו בחומרתם: עונש מוות גם על עבירות קלות. מכאן הביטוי ״חוק דרקוני״. עצם הכתיבה צמצמה את שרירותם של האצילים השופטים, והייתה צעד בדרך לשלטון החוק.",
    "rank": 445
  },
  {
    "id": "med_augustine",
    "deck": "anchors",
    "title": "אוגוסטינוס מגיע לקנט להטפת הנצרות",
    "start": 597,
    "end": 597,
    "date": "597 לספירה",
    "place": "קנטרברי, אנגליה",
    "lat": 51.28,
    "lon": 1.08,
    "desc": "האפיפיור גרגוריוס הראשון שיגר נזיר בשם אוגוסטינוס עם כארבעים בני לוויה אל ממלכת קנט. המלך אתלברט קיבל אותם, ובהמשך המיר את דתו. אוגוסטינוס הפך לארכיבישוף הראשון של קנטרברי, וממנו החלה התנצרות רחבה של האנגלו־סקסים.",
    "rank": 446
  },
  {
    "id": "mod_hungary",
    "deck": "anchors",
    "title": "המהפכה ההונגרית נגד השלטון הסובייטי",
    "start": 1956,
    "end": 1956,
    "date": "1956",
    "place": "בודפשט, הונגריה",
    "lat": 47.5,
    "lon": 19.04,
    "desc": "ב־23 באוקטובר החלה בבודפשט הפגנת סטודנטים נגד השלטון הקומוניסטי והשליטה הסובייטית, והפכה לעימות מזוין. ממשלת אימרה נאג׳ הכריזה על כוונה לצאת מברית ורשה. ב־4 בנובמבר נכנסו טנקים סובייטים לעיר ודיכאו את המרד, וכ־2,500 הונגרים נהרגו ועשרות אלפים ברחו.",
    "rank": 447
  },
  {
    "id": "anq_nehemiah",
    "deck": "anchors",
    "title": "בניית חומות ירושלים בימי נחמיה",
    "start": -445,
    "end": -445,
    "date": "בערך 445 לפנה״ס",
    "place": "ירושלים, יהודה",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "נחמיה, מדינאי יהודי בחצר המלך הפרסי ארתחשסתא הראשון, קיבל רשות לעלות ליהודה ולבנות מחדש את חומות ירושלים. לפי ספר נחמיה העבודה הושלמה בזמן קצר למרות התנגדות שכנים. החומה חיזקה את העיר שהתאוששה מגלות בבל, ועזרא הסופר חיזק את חיי הדת.",
    "rank": 448
  },
  {
    "id": "med_temujin",
    "deck": "anchors",
    "title": "הולדת גנגיס חאן",
    "start": 1162,
    "end": 1162,
    "date": "בערך 1162",
    "place": "נהר אונון, מונגוליה",
    "lat": 48.9,
    "lon": 110.6,
    "desc": "תמוג׳ין נולד בערבות מונגוליה לשבט בורג׳יגין. אחרי מות אביו עברה משפחתו שנים קשות. בהמשך איחד את השבטים המונגוליים וקיבל את התואר גנגיס חאן. שנת לידתו שנויה במחלוקת, בין 1155 ל־1167.",
    "rank": 449
  },
  {
    "id": "mod_easter_rising",
    "deck": "anchors",
    "title": "מרד חג הפסחא",
    "start": 1916,
    "end": 1916,
    "date": "1916",
    "place": "דבלין, אירלנד",
    "lat": 53.349,
    "lon": -6.26,
    "desc": "בשבוע שאחרי חג הפסחא כבשו כאלף מורדים אירים את משרד הדואר המרכזי בדבלין והכריזו על רפובליקה אירית. הצבא הבריטי דיכא את המרד בתוך ימים, ומנהיגיו הוצאו להורג. ההוצאות להורג הגבירו את התמיכה הציבורית בעצמאות, שהושגה בחלקה של אירלנד כעבור כחמש שנים.",
    "rank": 450
  },
  {
    "id": "anq_palmyra",
    "deck": "anchors",
    "title": "כיבוש תדמור בידי אורליאנוס",
    "start": 273,
    "end": 273,
    "date": "273 לספירה",
    "place": "תדמור, סוריה",
    "lat": 34.55,
    "lon": 38.27,
    "desc": "הקיסר אורליאנוס הביס את ממלכת תדמור (פלמירה) בהנהגת המלכה זנוביה, שניתקה את המזרח מרומא. העיר נכבשה והמלכה נשבתה. אורליאנוס איחד מחדש את האימפריה, ובשלב מסוים אף את גאליה, וייצב אותה אחרי המשבר. לאחר מכן מרדה העיר שוב ונהרסה, ושקעה בהדרגה.",
    "rank": 451
  },
  {
    "id": "med_qing",
    "deck": "anchors",
    "title": "הצ׳ינג כובשים את בייג׳ינג",
    "start": 1644,
    "end": 1644,
    "date": "1644",
    "place": "בייג׳ינג, סין",
    "lat": 39.9,
    "lon": 116.4,
    "desc": "המורד לי זיצ׳נג כבש את בייג׳ינג, והקיסר האחרון של מינג התאבד. הגנרל וו סאנגווי פתח את שער שאנהאי שבחומה הגדולה לצבא המאנצ׳ורי, שגירש את לי וביסס את שלטון שושלת צ׳ינג. השושלת שלטה בסין עד 1912.",
    "rank": 452
  },
  {
    "id": "mod_allende",
    "deck": "anchors",
    "title": "ההפיכה בצ׳ילה",
    "start": 1973,
    "end": 1973,
    "date": "1973",
    "place": "סנטיאגו, צ׳ילה",
    "lat": -33.443,
    "lon": -70.654,
    "desc": "ב־11 בספטמבר הפילו קציני הצבא בראשות אוגוסטו פינושה את הממשלה הסוציאליסטית הנבחרת של סלבדור אלנדה. אלנדה מת בארמון לה מונדה, וצבא ההפיכה הפציץ אותו. משטרו של פינושה נמשך עד 1990, ובמסגרתו נרצחו וגורשו אלפי מתנגדים.",
    "rank": 453
  },
  {
    "id": "med_khazars",
    "deck": "anchors",
    "title": "המרת הח׳זרים ליהדות",
    "start": 740,
    "end": 740,
    "date": "בערך 740 לספירה",
    "place": "איטיל, ממלכת הח׳זרים (דרום רוסיה)",
    "lat": 46.3,
    "lon": 48,
    "desc": "הח׳זרים, עם טורקי שהקים ממלכה בין הים הכספי לים השחור, אימצו לפי מקורות מאוחרים את היהדות כדת של המלך והאצולה. מידת היקף ההמרה ותאריכה שנויים במחלוקת בין היסטוריונים. הממלכה קרסה במאה ה־10.",
    "rank": 454
  },
  {
    "id": "mod_vienna1815",
    "deck": "anchors",
    "title": "קונגרס וינה",
    "start": 1814,
    "end": 1815,
    "date": "⁦1814–1815⁩",
    "place": "וינה, אוסטריה",
    "lat": 48.21,
    "lon": 16.37,
    "desc": "דיפלומטים של המעצמות, בהובלת מטרניך הממלכה האוסטרית וקאסלריי הבריטי, עיצבו מחדש את אירופה לאחר נפילת נפוליאון והחזירו שליטים לגיטימיים. הם יצרו קונפדרציה גרמנית ומערכת של איזון כוחות. הסדר שהוקם שמר על שלום יחסי בין המעצמות עשרות שנים.",
    "rank": 455
  },
  {
    "id": "anq_solon",
    "deck": "anchors",
    "title": "רפורמות סולון באתונה",
    "start": -594,
    "end": -594,
    "date": "בערך 594 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.97,
    "lon": 23.73,
    "desc": "סולון, אצילי נבחר לשלוט באתונה, ביטל חובות שהפכו איכרים לעבדים וחילק את האזרחים לפי עושרם ולא לפי מוצאם. הוא יצר מועצה ובית דין עממי. רפורמותיו הניחו את היסוד לדמוקרטיה האתונאית.",
    "rank": 456
  },
  {
    "id": "med_mamluk",
    "deck": "anchors",
    "title": "שלטון הממלוכים במצרים",
    "start": 1250,
    "end": 1250,
    "date": "1250",
    "place": "קהיר, מצרים",
    "lat": 30.044,
    "lon": 31.236,
    "desc": "אחרי מות הסולטן האיובי א־צאליח ורצח יורשו תפסו הממלוכים, חיילי עבדים תורכיים, את השלטון במצרים. הם שלטו במצרים, בסוריה ובארץ ישראל עד הכיבוש העות׳מאני ב־1517. מקרבם יצאו שליטים מצליחים, ובהם בייברס.",
    "rank": 457
  },
  {
    "id": "mod_mexico_rev",
    "deck": "anchors",
    "title": "המהפכה המקסיקנית",
    "start": 1910,
    "end": 1920,
    "date": "⁦1910–1920⁩",
    "place": "מקסיקו סיטי, מקסיקו",
    "lat": 19.43,
    "lon": -99.13,
    "desc": "ב־1910 קרא פרנסיסקו מדרו למרד נגד הנשיא פורפיריו דיאס, ששלט כשלושה עשורים. המאבק עם כוחות של אמיליאנו סאפאטה ופאנצ׳ו ויה התפתח למלחמה אזרחית ממושכת, שעלתה בחייהם של כמיליון בני אדם. בסופה התקבלה ב־1917 חוקה שהבטיחה רפורמה בקרקעות וזכויות עובדים.",
    "rank": 458
  },
  {
    "id": "anq_almagest",
    "deck": "anchors",
    "title": "האלמגסט של תלמי",
    "start": 150,
    "end": 150,
    "date": "בערך 150 לספירה",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.92,
    "desc": "האסטרונום קלאודיוס תלמיאוס כתב סיכום של האסטרונומיה היוונית ובו מודל גיאוצנטרי של תנועת הכוכבים. הספר שימש את האסטרונומים במשך כאלף וארבע מאות שנה, בעולם הערבי ובאירופה, עד המהפכה הקופרניקאית. בספר גם קטלוג של כאלף כוכבים ושיטות לחישוב ליקויים ותנועת כוכבי הלכת.",
    "rank": 459
  },
  {
    "id": "med_sekigahara",
    "deck": "anchors",
    "title": "קרב סקיגהארה",
    "start": 1600,
    "end": 1600,
    "date": "1600",
    "place": "סקיגהארה, יפן",
    "lat": 35.37,
    "lon": 136.47,
    "desc": "טוקוגאווה אייאסו ניצח את הברית של הנאמנים לבית הידיושי בקרב ענק. הניצחון הפך אותו לשליט יפן, ושלוש שנים אחר כך הכריז עליו הקיסר כשוגון. שושלת טוקוגאווה שלטה ביפן יותר משתי מאות וחצי שנה בשלום יחסי.",
    "rank": 460
  },
  {
    "id": "mod_louisiana",
    "deck": "anchors",
    "title": "רכישת לואיזיאנה",
    "start": 1803,
    "end": 1803,
    "date": "1803",
    "place": "ניו אורלינס, ארה״ב",
    "lat": 29.95,
    "lon": -90.07,
    "desc": "נפוליאון, שהפסיד במאבק על האיטי ונזקק לכסף למלחמה, מכר לארצות הברית את שטחי לואיזיאנה הצרפתית בכ־15 מיליון דולר. השטח כמעט הכפיל את גודל המדינה. הנשיא ג׳פרסון הציע בכך מרחב להתפשטות מערבה וחיזק את השליטה על נהר המיסיסיפי.",
    "rank": 461
  },
  {
    "id": "anq_uruk_writing",
    "deck": "anchors",
    "title": "הכתב המסופוטמי הקדום באורוק",
    "start": -3200,
    "end": -3200,
    "date": "בערך 3200 לפנה״ס",
    "place": "אורוק, מסופוטמיה",
    "lat": 31.32,
    "lon": 45.64,
    "desc": "באורוק שבדרום מסופוטמיה נוצרו לוחות החימר הראשונים שנושאים סימני כתב, ובהם רישומי תבואה, צאן ושמן של המקדשים. מן הסימנים האלה התפתח בהמשך הכתב המסמרי, אחד משני הכתבים העתיקים בעולם. הכתב נולד מצורכי הנהלת חשבונות ולא מצורכי ספרות.",
    "rank": 462
  },
  {
    "id": "med_verdun",
    "deck": "anchors",
    "title": "אמנת ורדן מחלקת את האימפריה הקרולינגית",
    "start": 843,
    "end": 843,
    "date": "843 לספירה",
    "place": "ורדן, צרפת",
    "lat": 49.16,
    "lon": 5.38,
    "desc": "נכדיו של קרל הגדול חילקו ביניהם אחרי מלחמת אחים את האימפריה לשלושה חלקים: מזרח, מערב ואמצע. החלק המערבי הוא הבסיס לצרפת, והמזרחי לגרמניה. רצועת האמצע, מהולנד ועד איטליה, נותרה אזור מריבה לאורך מאות שנים.",
    "rank": 463
  },
  {
    "id": "mod_holodomor",
    "deck": "anchors",
    "title": "הרעב הגדול באוקראינה",
    "start": 1932,
    "end": 1933,
    "date": "⁦1932–1933⁩",
    "place": "אוקראינה, ברית המועצות",
    "lat": 49.99,
    "lon": 36.23,
    "desc": "מדיניות ההפקעה והקולקטיביזציה של סטלין גרמה לרעב כבד באוקראינה ובאזורי תבואה נוספים בברית המועצות. מיליוני בני אדם מתו, ובהם כ־3.5 מיליון באוקראינה לפי הערכות נפוצות. אוקראינה ומדינות רבות מכירות באסון כרצח עם, וחוקרים חלוקים אם הוא כוון נגד האוקראינים במיוחד.",
    "rank": 464
  },
  {
    "id": "anq_samaria",
    "deck": "anchors",
    "title": "נפילת שומרון",
    "start": -722,
    "end": -722,
    "date": "בערך 722 לפנה״ס",
    "place": "שומרון, ארץ ישראל",
    "lat": 32.277,
    "lon": 35.194,
    "desc": "צבא אשור, בהנהגת שלמנאסר החמישי וסרגון השני, כבש את שומרון בירת ממלכת ישראל. אלפים מתושבי הממלכה הוגלו למסופוטמיה ולמדי, ובמקומם הובאו אנשים ממקומות אחרים. הממלכה חדלה להתקיים, ופליטים רבים פנו אל יהודה.",
    "rank": 465
  },
  {
    "id": "med_kamakura_buddha",
    "deck": "anchors",
    "title": "הבודהה הגדול של קמקורה",
    "start": 1252,
    "end": 1252,
    "date": "בערך 1252",
    "place": "קמקורה, יפן",
    "lat": 35.317,
    "lon": 139.536,
    "desc": "בקמקורה, מושב השוגונים, החלו להקים פסל ענק של בודהה אמידה מברונזה, בגובה כ־13 מטרים. הפסל ניצב בתחילה בתוך אולם עץ, שנהרס בסערות ובצונאמי, ומאז הוא עומד תחת כיפת השמיים. הוא אחד הסמלים הבולטים של הבודהיזם היפני.",
    "rank": 466
  },
  {
    "id": "mod_egypt_rev",
    "deck": "anchors",
    "title": "מהפכת הקצינים החופשיים",
    "start": 1952,
    "end": 1952,
    "date": "1952",
    "place": "קהיר, מצרים",
    "lat": 30.04,
    "lon": 31.24,
    "desc": "ב־23 ביולי תפסו הקצינים החופשיים, בהנהגת מוחמד נגיב וגמאל עבד אל־נאצר, את השלטון במצרים והדיחו את המלך פארוק. ב־1953 בוטלה המלוכה והוכרזה רפובליקה. נאצר, שהפך לנשיא ב־1956, הנהיג מדיניות לאומנית ערבית ופעל נגד השפעה זרה.",
    "rank": 467
  },
  {
    "id": "anq_chaeronea",
    "deck": "anchors",
    "title": "קרב כרונאה",
    "start": -338,
    "end": -338,
    "date": "338 לפנה״ס",
    "place": "כרונאה, בואוטיה, יוון",
    "lat": 38.49,
    "lon": 22.85,
    "desc": "פיליפוס השני ממקדון ובנו הצעיר אלכסנדר הביסו את צבאות ערי יוון, ובראשן אתונה ותבאי. הקרב סיים את עצמאות הערים היווניות, ובהמשך הוקמה ברית קורינתוס בהנהגת מקדון. הצבא שהכין פיליפוס שימש אחר כך את אלכסנדר בכיבוש האימפריה הפרסית.",
    "rank": 468
  },
  {
    "id": "med_shulchan_aruch",
    "deck": "anchors",
    "title": "שולחן ערוך",
    "start": 1565,
    "end": 1565,
    "date": "1565",
    "place": "צפת, ישראל",
    "lat": 32.96,
    "lon": 35.5,
    "desc": "הרב יוסף קארו, מגדולי המקובלים והפוסקים בצפת, חיבר את שולחן ערוך, קיצור של ההלכה היהודית, והוא הודפס בוונציה. אחרי שהרמ״א הוסיף את מנהגי האשכנזים, נעשה החיבור לספר ההלכה המקובל ביותר בעם ישראל.",
    "rank": 469
  },
  {
    "id": "mod_vienna1683",
    "deck": "anchors",
    "title": "המצור השני על וינה",
    "start": 1683,
    "end": 1683,
    "date": "1683",
    "place": "וינה, אוסטריה",
    "lat": 48.21,
    "lon": 16.37,
    "desc": "צבא עות׳מאני גדול בפיקוד הווזיר הגדול קרה מוסטפא פשה צר על בירת הבסבורג חודשים ארוכים. צבא סיוע של בעלות הברית בהנהגת המלך יאן סובייסקי מפולין הביס אותו בקרב על גבעות קאלנברג. התבוסה סימנה את סוף התפשטות העות׳מאנים באירופה, ובעשורים הבאים איבדו את הונגריה.",
    "rank": 470
  },
  {
    "id": "anq_israel_judah_split",
    "deck": "anchors",
    "title": "ממלכת ישראל וממלכת יהודה",
    "start": -930,
    "end": -930,
    "date": "בערך 930 לפנה״ס",
    "place": "שכם, ארץ ישראל",
    "lat": 32.21,
    "lon": 35.28,
    "desc": "לפי המסורת המקראית התפצלה הממלכה המאוחדת לאחר מות שלמה לשתי ממלכות, ישראל בצפון ויהודה בדרום. ממלכת ישראל הייתה גדולה ועשירה יותר. החוקרים חלוקים בשאלה אם הממלכה המאוחדת הייתה כה גדולה כפי שמתואר, וממצאים מעטים נוגעים למאה העשירית.",
    "rank": 471
  },
  {
    "id": "med_saladincairo",
    "deck": "anchors",
    "title": "סלאח א־דין נעשה לשליט מצרים",
    "start": 1171,
    "end": 1171,
    "date": "1171",
    "place": "קהיר, מצרים",
    "lat": 30.05,
    "lon": 31.26,
    "desc": "סלאח א־דין, פקודו של נור א־דין, ביטל את הח׳ליפות הפאטמית והחזיר את מצרים להכרה בעבאסים. הוא ייסד את השושלת האיובית והפך לשליט חזק במזרח התיכון. מבסיסו במצרים ובסוריה פעל להתמודד עם הצלבנים.",
    "rank": 472
  },
  {
    "id": "mod_alaska",
    "deck": "anchors",
    "title": "מכירת אלסקה לארצות הברית",
    "start": 1867,
    "end": 1867,
    "date": "1867",
    "place": "סיטקה, אלסקה",
    "lat": 57.05,
    "lon": -135.33,
    "desc": "רוסיה, שחששה מאובדן השטח לבריטניה וחסרה כסף אחרי מלחמת קרים, מכרה את אלסקה לארצות הברית ב־7.2 מיליון דולר. רבים באמריקה לגלגו על הרכישה וכינו אותה ״השטות של סיוורד״. גילוי הזהב והנפט בהמשך שינה את התפיסה.",
    "rank": 473
  },
  {
    "id": "anq_sennacherib_jerusalem",
    "deck": "anchors",
    "title": "המצור האשורי על ירושלים",
    "start": -701,
    "end": -701,
    "date": "בערך 701 לפנה״ס",
    "place": "ירושלים, ארץ ישראל",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "סנחריב מלך אשור פשט על יהודה בימי חזקיהו, כבש ערים רבות ובהן לכיש, והטיל מצור על ירושלים. הגרסה האשורית והמקראית של האירועים שונות: אשור מתארת את חזקיהו ״כציפור בכלוב״ והמקרא מספר על נס שהציל את העיר. הצבא האשורי נסוג והעיר לא נכבשה.",
    "rank": 474
  },
  {
    "id": "med_khmelnytsky",
    "deck": "anchors",
    "title": "מרד חמלניצקי",
    "start": 1648,
    "end": 1648,
    "date": "1648",
    "place": "צ׳יהירין, אוקראינה",
    "lat": 49.08,
    "lon": 32.66,
    "desc": "הקוזקים בראשות בוהדן חמלניצקי קמו נגד שלטון הממלכה הפולנית־ליטאית באוקראינה. במהלך המרד נהרגו והושמדו קהילות יהודיות רבות, ויהודים רבים נמלטו. נוצר ההטמנאט הקוזקי, שהתקרב בהמשך לרוסיה.",
    "rank": 475
  },
  {
    "id": "mod_boxer",
    "deck": "anchors",
    "title": "מרד הבוקסרים",
    "start": 1900,
    "end": 1900,
    "date": "1900",
    "place": "בייג׳ינג, סין",
    "lat": 39.9,
    "lon": 116.4,
    "desc": "אגודה סינית לאומנית וקסנופובית, ״הבוקסרים״, תקפה נוצרים וזרים והטילה מצור על רובע הנציגויות בבייג׳ינג. ממשלת צ׳ינג תמכה במרד. קואליציה של שמונה מדינות שלחה כוח צבאי שכבש את בייג׳ינג באוגוסט. הסכם שנחתם אחר כך חייב את סין בפיצויים כבדים.",
    "rank": 476
  },
  {
    "id": "anq_hydaspes",
    "deck": "anchors",
    "title": "קרב ההידספס",
    "start": -326,
    "end": -326,
    "date": "326 לפנה״ס",
    "place": "נהר ג׳לאם, פנג׳אב",
    "lat": 32.7,
    "lon": 73.6,
    "desc": "אלכסנדר חצה את הנהר בלילה סוער והביס את המלך פורוס, שנעזר בפילי מלחמה. אלכסנדר הניח לפורוס למלוך כוואסל שלו. חייליו סירבו לצעוד מזרחה מעבר לנהר היפאסיס, ואלכסנדר הסתפק בגבול הזה ושב מערבה. זה הקרב הגדול האחרון של אלכסנדר, והוא העמיק את השפעת התרבות היוונית בצפון־מערב הודו.",
    "rank": 477
  },
  {
    "id": "med_wuzetian",
    "deck": "anchors",
    "title": "וו זטיאן מכריזה על עצמה קיסרית",
    "start": 690,
    "end": 690,
    "date": "690 לספירה",
    "place": "לואויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "וו זטיאן, שהייתה פילגש ואחר כך אשת קיסר, הכריזה על שושלת חדשה, ג׳ואו. היא האישה היחידה שנשאה את התואר קיסר בהיסטוריה הסינית. בשלטונה חיזקה את הבחינות הממלכתיות ואת הבודהיזם.",
    "rank": 478
  },
  {
    "id": "mod_principia",
    "deck": "anchors",
    "title": "פרסום ״העקרונות המתמטיים של הפילוסופיה הטבעית״ של ניוטון",
    "start": 1687,
    "end": 1687,
    "date": "1687",
    "place": "קיימברידג׳, אנגליה",
    "lat": 52.2,
    "lon": 0.12,
    "desc": "אייזק ניוטון פרסם בעידוד אדמונד האלי את החיבור שהציג את חוקי התנועה ואת חוק הכבידה האוניברסלי. החיבור הסביר באמצעות אותם חוקים את תנועת כוכבי הלכת ואת הגאות והשפל. הוא הפך לאבן יסוד של הפיזיקה הקלאסית ושל המהפכה המדעית.",
    "rank": 479
  },
  {
    "id": "anq_phoenician_alphabet",
    "deck": "anchors",
    "title": "האלפבית הפיניקי",
    "start": -1050,
    "end": -1050,
    "date": "בערך 1050 לפנה״ס",
    "place": "גבל (ביבלוס), לבנון",
    "lat": 34.12,
    "lon": 35.65,
    "desc": "הפיניקים בערי הלבנט, בהן גבל וצור, פיתחו אלפבית של 22 אותיות עיצוריות. כתב זה היה פשוט ללימוד ופשט בים התיכון. ממנו התפתחו הכתבים היווני, הלטיני והארמי, ועימם גם העברי הקדום. הכתובת על ארון אחירם ממלכי גבל היא מן הקדומות.",
    "rank": 480
  },
  {
    "id": "med_iceland",
    "deck": "anchors",
    "title": "ההתיישבות הנורדית באיסלנד",
    "start": 874,
    "end": 874,
    "date": "בערך 874 לספירה",
    "place": "ריקיאוויק, איסלנד",
    "lat": 64.15,
    "lon": -21.94,
    "desc": "לפי מקורות איסלנדיים מימי הביניים הגיע המתיישב הנורבגי אינגולפור ארנרסון אל האי והקים חווה במקום שנקרא ריקיאוויק. במהלך עשורים הגיעו אליו אלפי נורבגים ובני האיים הבריטיים. התיישבות האי הולידה חברה ייחודית בלי מלך, שכתבה את הסאגות.",
    "rank": 481
  },
  {
    "id": "mod_chicagofire",
    "deck": "anchors",
    "title": "השריפה הגדולה של שיקגו",
    "start": 1871,
    "end": 1871,
    "date": "1871",
    "place": "שיקגו, ארה״ב",
    "lat": 41.88,
    "lon": -87.63,
    "desc": "שריפה שפרצה באוקטובר הפכה את רוב מרכז העיר, שבנייניה היו מעץ, לאפר. כ־300 איש נהרגו ועשרות אלפים נותרו ללא קורת גג. שיקגו נבנתה מחדש במהירות עם מבני פלדה, ומשם התפתחו גורדי השחקים הראשונים.",
    "rank": 482
  },
  {
    "id": "anq_josiah",
    "deck": "anchors",
    "title": "רפורמת יאשיהו",
    "start": -622,
    "end": -622,
    "date": "בערך 622 לפנה״ס",
    "place": "ירושלים, ארץ ישראל",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "לפי ספר מלכים גילה הכהן הגדול ספר תורה במקדש, ובעקבות זאת יאשיהו מלך יהודה ריכז את הפולחן בירושלים והסיר מזבחות במה ופולחנים זרים. חוקרים רבים רואים ברפורמה שלב חשוב בעיצוב הדת העברית.",
    "rank": 483
  },
  {
    "id": "med_swiss",
    "deck": "anchors",
    "title": "ברית הקנטונים השוויצרית",
    "start": 1291,
    "end": 1291,
    "date": "1291",
    "place": "אגם לוצרן, שווייץ",
    "lat": 46.97,
    "lon": 8.59,
    "desc": "שלושה קנטונים באלפים המרכזיים, אורי, שוויץ ואונטרוואלדן, כרתו ברית הגנה הדדית בעקבות מות המלך רודולף מבית הבסבורג. הברית נחשבת ליסוד הקונפדרציה השוויצרית, ובמסורת הלאומית היא קשורה לשבועת הרוטלי ולווילהלם טל. עם השנים הצטרפו קנטונים נוספים.",
    "rank": 484
  },
  {
    "id": "mod_perry",
    "deck": "anchors",
    "title": "בואו של הקומודור פרי ליפן",
    "start": 1853,
    "end": 1853,
    "date": "1853",
    "place": "אורגה, יפן",
    "lat": 35.25,
    "lon": 139.72,
    "desc": "הקומודור האמריקאי מתיו פרי הגיע עם ספינות קיטור שחורות למפרץ אדו, ודרש מיפן, תוך איום בכוח, לפתוח את נמליה. שוגונות טוקוגאווה נכנעה וחתמה על הסכם ב־1854. האירוע חשף את חולשת השוגונות והאיץ את סופה.",
    "rank": 485
  },
  {
    "id": "anq_kalinga",
    "deck": "anchors",
    "title": "מלחמת קלינגה",
    "start": -261,
    "end": -261,
    "date": "261 לפנה״ס",
    "place": "קלינגה, אודישה, הודו",
    "lat": 20.19,
    "lon": 85.84,
    "desc": "הקיסר אשוקה המאורי כבש את קלינגה במלחמה שגבתה, לפי כתובותיו, מאות אלפי הרוגים וגולים. לפי הכתובות הוא התחרט עמוקות והפנה את מדיניותו לדהרמה בודהיסטית של שלום, סובלנות ורווחת נתינים. את דבריו חרת על עמודי אבן וסלעים בכל רחבי הודו.",
    "rank": 486
  },
  {
    "id": "med_ottoman_egypt",
    "deck": "anchors",
    "title": "העות׳מאנים כובשים את מצרים",
    "start": 1517,
    "end": 1517,
    "date": "1517",
    "place": "קהיר, מצרים",
    "lat": 30.044,
    "lon": 31.236,
    "desc": "הסולטן סליים הראשון הביס את הממלוכים בסוריה ובמצרים, ובכך כבש את הלבנט, מצרים והחיג׳אז. השליטה בערים הקדושות מכה ומדינה העניקה לעות׳מאנים מעמד מוביל בעולם המוסלמי הסוני. ארץ ישראל הייתה לחלק מהאימפריה העות׳מאנית ונשארה כך 400 שנה.",
    "rank": 487
  },
  {
    "id": "mod_bighorn",
    "deck": "anchors",
    "title": "קרב ליטל ביגהורן",
    "start": 1876,
    "end": 1876,
    "date": "1876",
    "place": "מונטנה, ארה״ב",
    "lat": 45.57,
    "lon": -107.43,
    "desc": "כוחות לקוטה וצ׳יין בהנהגת סיטינג בול וקרייזי הורס הביסו את גדוד הפרשים השביעי של הצבא האמריקאי, ובראשו ג׳ורג׳ קסטר, שנהרג עם אנשיו. הניצחון היה זמני. תגובת הצבא האמריקאי הייתה חריפה, והשבטים אולצו לשמורות.",
    "rank": 488
  },
  {
    "id": "anq_tel_dan",
    "deck": "anchors",
    "title": "מצבת תל דן",
    "start": -840,
    "end": -840,
    "date": "בערך 840 לפנה״ס",
    "place": "תל דן, ארץ ישראל",
    "lat": 33.248,
    "lon": 35.652,
    "desc": "במצבת ארמית שנחשפה בתל דן מתוארים ניצחונות של מלך ארם־דמשק על מלך ישראל ועל מלך ״בית דוד״. זוהי ההזכרה הקדומה ביותר של בית דוד מחוץ למקרא. הכתובת מציינת מלחמה בין ארם לישראל ויהודה במאה התשיעית לפנה״ס.",
    "rank": 489
  },
  {
    "id": "med_covadonga",
    "deck": "anchors",
    "title": "קרב קובדונגה בצפון ספרד",
    "start": 722,
    "end": 722,
    "date": "בערך 722 לספירה",
    "place": "קובדונגה, אסטוריאס (ספרד)",
    "lat": 43.31,
    "lon": -5.06,
    "desc": "כוח נוצרי קטן בראשות פלאיו ניצח יחידה מוסלמית בהרי אסטוריאס, בעת שרוב חצי האי האיברי היה בידי המוסלמים. הניצחון הצנוע קיבל משמעות סמלית גדולה והיה לימים לנקודת מוצא במסורת של הרקונקיסטה, השבת הארץ מידי המוסלמים.",
    "rank": 490
  },
  {
    "id": "mod_algeria",
    "deck": "anchors",
    "title": "מלחמת אלג׳יריה",
    "start": 1954,
    "end": 1962,
    "date": "⁦1954–1962⁩",
    "place": "אלג׳יר, אלג׳יריה",
    "lat": 36.75,
    "lon": 3.06,
    "desc": "ב־1954 פתח חזית השחרור הלאומית במרד נגד השלטון הצרפתי באלג׳יריה, שנחשבה חלק מצרפת. המלחמה כללה טרור, עינויים, ודיכוי אכזרי, והביאה למשבר פוליטי בצרפת. אחרי הסכם אוויאן ב־1962 הוכרזה עצמאות. מאות אלפי אלג׳יראים נהרגו, וכמיליון אירופאים עזבו.",
    "rank": 491
  },
  {
    "id": "anq_cleisthenes",
    "deck": "anchors",
    "title": "רפורמות קלייסתנס באתונה",
    "start": -508,
    "end": -508,
    "date": "בערך 508 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.97,
    "lon": 23.73,
    "desc": "קלייסתנס חילק את אזרחי אתונה לעשרה שבטים לפי מקום מגורים ולא לפי משפחות אצולה, ויצר מועצה של 500 ואסיפת עם. רפורמה זו נקראת לעיתים תחילת הדמוקרטיה האתונאית, אף על פי שנשים, עבדים וזרים נותרו מחוץ לה.",
    "rank": 492
  },
  {
    "id": "mod_slavery1833",
    "deck": "anchors",
    "title": "ביטול העבדות באימפריה הבריטית",
    "start": 1833,
    "end": 1833,
    "date": "1833",
    "place": "לונדון, אנגליה",
    "lat": 51.5,
    "lon": -0.12,
    "desc": "לאחר מסע ציבורי ממושך, בהנהגת ויליאם וילברפורס ותנועות מבטלי העבדות, העבירה בריטניה חוק שביטל את העבדות ברוב מושבותיה. בעלי העבדים קיבלו פיצוי כספי, והעבדים עצמם נדרשו לעבוד כשוליות עוד כמה שנים. החוק היה דוגמה לשאר העולם.",
    "rank": 493
  },
  {
    "id": "anq_zhang_qian",
    "deck": "anchors",
    "title": "מסעות ז׳אנג צ׳יאן",
    "start": -138,
    "end": -126,
    "date": "⁦138–126⁩ לפנה״ס",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.9,
    "desc": "שליח הקיסר וו מבית האן יצא למרכז אסיה בחיפוש אחר בעלי ברית נגד הסיונג־נו. הוא נתפס ושהה שנים אצל שבויים, ובשובו תיאר את ממלכות פרגאנה ובקטריה. דיווחיו פתחו את הדרך למסחר ולקשרים של סין עם המערב, שאחר כך נקרא דרך המשי.",
    "rank": 494
  },
  {
    "id": "med_ghetto",
    "deck": "anchors",
    "title": "הגטו של ונציה",
    "start": 1516,
    "end": 1516,
    "date": "1516",
    "place": "ונציה, איטליה",
    "lat": 45.445,
    "lon": 12.327,
    "desc": "שלטונות הרפובליקה הוונציאנית הורו שיהודי העיר יתגוררו רק באזור מגודר וננעל בלילות, שנקרא גטו. המונח התפשט אחר כך לאזורי מגורים מוגבלים ליהודים בערים אחרות באירופה. בתוך הגטו התקיים חיי קהילה ענפים, ובהם בתי דפוס ובתי כנסת.",
    "rank": 495
  },
  {
    "id": "med_grandcanal",
    "deck": "anchors",
    "title": "בניית התעלה הגדולה",
    "start": 605,
    "end": 611,
    "date": "⁦605–611⁩ לספירה",
    "place": "לואויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "הקיסר יאנג מסוי הורה על חפירה והרחבה של תעלות, שחיברו בין הנהר הצהוב לנהר היאנגצה. התעלה, שרבים נספו בבנייתה, שימשה להובלת תבואה מהדרום. היא אחת מערוצי התחבורה החשובים בהיסטוריה של סין.",
    "rank": 496
  },
  {
    "id": "mod_petersburg",
    "deck": "anchors",
    "title": "ייסוד סנקט פטרבורג",
    "start": 1703,
    "end": 1703,
    "date": "1703",
    "place": "סנקט פטרבורג, רוסיה",
    "lat": 59.95,
    "lon": 30.32,
    "desc": "פיוטר הגדול ייסד את העיר בביצות שכבש משוודיה במלחמה הצפונית הגדולה, ובנה בה את מבצר פטר ופאול. הוא רצה ״חלון לאירופה״ לרוסיה, והעביר אליה את הבירה ב־1712. העיר נבנתה בידי עשרות אלפי עובדים, רבים מהם נספו בתנאים הקשים.",
    "rank": 497
  },
  {
    "id": "anq_gordion",
    "deck": "anchors",
    "title": "מלך מידס בפריגיה",
    "start": -700,
    "end": -700,
    "date": "בערך 700 לפנה״ס",
    "place": "גורדיון, טורקיה",
    "lat": 39.65,
    "lon": 31.99,
    "desc": "מידס, מלך הפריגים, שלט מבירתו גורדיון באנטוליה, ובקבר גדול בסביבתה נמצאו רהיטי עץ ושרידי סעודת קבורה. האגדות היווניות מספרות על זהב שהפך כל מגע שלו. הממלכה נחלשה בהתקפת הקימרים ונפלה בידי ליודיה.",
    "rank": 498
  },
  {
    "id": "mod_appomattox",
    "deck": "anchors",
    "title": "כניעת הגנרל לי באפומטוקס",
    "start": 1865,
    "end": 1865,
    "date": "1865",
    "place": "אפומטוקס, וירג׳יניה, ארה״ב",
    "lat": 37.38,
    "lon": -78.8,
    "desc": "הגנרל רוברט לי נכנע בפני הגנרל יוליסס גרנט, ותנאי הכניעה היו נדיבים. האירוע סימן את סיום עיקר המלחמה האזרחית האמריקאית, שגבתה כ־620 אלף חיילים. ימים אחר כך נרצח הנשיא לינקולן, ובסוף השנה אושר התיקון ה־13 שביטל את העבדות.",
    "rank": 499
  },
  {
    "id": "anq_warring_states",
    "deck": "anchors",
    "title": "תחילת תקופת המדינות הלוחמות",
    "start": -403,
    "end": -403,
    "date": "403 לפנה״ס",
    "place": "ג׳ין, צפון סין",
    "lat": 35.6,
    "lon": 111.37,
    "desc": "מלך ג׳או הכיר רשמית בשלוש המדינות שקמו מפירוק מדינת ג׳ין, ובכך נחשבת לרוב ראשית התקופה. המדינות הגדולות נלחמו זו בזו בלי הפסקה, תוך שהן מתחדשות בצבאות, בחוקים ובדרכי מנהל. בתקופה זו פעלו גם הוגים כמו מנציוס וג׳ואנג־דזה.",
    "rank": 500
  },
  {
    "id": "med_grunwald",
    "deck": "anchors",
    "title": "קרב גרונוולד",
    "start": 1410,
    "end": 1410,
    "date": "1410",
    "place": "גרונוולד, פולין",
    "lat": 53.48,
    "lon": 20.12,
    "desc": "צבא משותף של פולין וליטא ניצח את מסדר האבירים הטבטוני, שהחזיק מדינה על חוף הים הבלטי. הניצחון שבר את כוחו הצבאי של המסדר והפך את האיחוד הפולני־ליטאי לכוח מרכזי במזרח אירופה.",
    "rank": 501
  },
  {
    "id": "mod_trailoftears",
    "deck": "anchors",
    "title": "שביל הדמעות",
    "start": 1838,
    "end": 1839,
    "date": "⁦1838–1839⁩",
    "place": "ניו אקוטה, ג׳ורג׳יה, ארה״ב",
    "lat": 34.54,
    "lon": -84.9,
    "desc": "כוחות ארצות הברית גירשו כ־16 אלף בני שבט הצ׳ירוקי מאדמותיהם בדרום מזרח המדינה למחוז בעבר המיסיסיפי. אלפים רבים נספו בדרך ממחלות, רעב וקור. הגירוש נעשה על פי חוק הרחקת האינדיאנים של הנשיא ג׳קסון.",
    "rank": 502
  },
  {
    "id": "anq_valerian",
    "deck": "anchors",
    "title": "שבי הקיסר ואלריאנוס",
    "start": 260,
    "end": 260,
    "date": "260 לספירה",
    "place": "אדסה, דרום־מזרח טורקיה",
    "lat": 37.16,
    "lon": 38.79,
    "desc": "קיסר רומא ואלריאנוס הובס בקרב מול שפור הראשון, מלך סאסאני, ונשבה. זה הקיסר הרומי היחיד שנפל בשבי אויב. שפור חרת את ניצחונו בסלע ליד פרספוליס. האירוע העמיק את משבר המאה השלישית של האימפריה. הקיסר מת בשבי, ושלטונו של בנו גליינוס נותר מוקף במשברים.",
    "rank": 503
  },
  {
    "id": "med_edessa",
    "deck": "anchors",
    "title": "נפילת אדסה",
    "start": 1144,
    "end": 1144,
    "date": "1144",
    "place": "אדסה (אורפה), טורקיה",
    "lat": 37.16,
    "lon": 38.79,
    "desc": "עימאד א־דין זנגי, שליט מוסול וחלב, כבש את אדסה, אחת המדינות הצלבניות הראשונות. נפילתה הייתה זעזוע בעולם הנוצרי והביאה לקריאה למסע הצלב השני. מבחינת המוסלמים היה זה צעד בדרך לאיחוד סוריה ומצרים נגד הצלבנים.",
    "rank": 504
  },
  {
    "id": "mod_reich",
    "deck": "anchors",
    "title": "הכרזת הקייזרריך הגרמני",
    "start": 1871,
    "end": 1871,
    "date": "1871",
    "place": "ורסאי, צרפת",
    "lat": 48.8,
    "lon": 2.12,
    "desc": "בזמן המצור על פריז הכריזו נסיכי גרמניה, בהיכל המראות בארמון ורסאי, על וילהלם הראשון מלך פרוסיה כקיסר גרמניה. ביסמרק עיצב את האיחוד ללא אוסטריה. האימפריה החדשה שינתה את מאזן הכוחות באירופה, והשפילה את צרפת המובסת.",
    "rank": 505
  },
  {
    "id": "anq_kadesh_treaty",
    "deck": "anchors",
    "title": "הסכם השלום בין מצרים לחתים",
    "start": -1259,
    "end": -1259,
    "date": "בערך 1259 לפנה״ס",
    "place": "פי־רעמסס, מצרים",
    "lat": 30.8,
    "lon": 31.83,
    "desc": "כחמש עשרה שנה אחרי קדש חתמו רעמסס השני וחתושילי השלישי על הסכם שלום ובריתות הגנה הדדית. נוסחו נשמר גם בהירוגליפים במצרים וגם בלוח חימר חתי. זהו אחד ההסכמים הבינלאומיים הקדומים ביותר שנודע בנוסחו המלא.",
    "rank": 506
  },
  {
    "id": "med_kiev",
    "deck": "anchors",
    "title": "המונגולים מחריבים את קייב",
    "start": 1240,
    "end": 1240,
    "date": "1240",
    "place": "קייב, אוקראינה",
    "lat": 50.45,
    "lon": 30.52,
    "desc": "צבא מונגולי בפיקוד בטו חאן, נכדו של ג׳ינגיס, כבש את קייב אחרי מצור קצר והחריב אותה כמעט לחלוטין. העיר הייתה מרכז הנצרות האורתודוקסית ברוסיה. נפילתה סימנה את כיבוש רוס בידי המונגולים, ששלטו בה כמעט 250 שנה.",
    "rank": 507
  },
  {
    "id": "mod_boer",
    "deck": "anchors",
    "title": "מלחמת הבורים השנייה",
    "start": 1899,
    "end": 1902,
    "date": "⁦1899–1902⁩",
    "place": "לדיסמית, דרום אפריקה",
    "lat": -28.56,
    "lon": 29.78,
    "desc": "הרפובליקות של הבורים, טרנסוואל ואורנג׳ החופשית, נלחמו בבריטניה ב־1899 אחרי מתיחות סביב מכרות הזהב והזכויות בהם. הבריטים פעלו נגד לוחמי גרילה בהרס חוות ובמחנות ריכוז, שבהם מתו אלפי נשים וילדים. בהסכם ורניחינג ב־1902 הוכפפו הרפובליקות לבריטניה, ובשנת 1910 קמה איחוד דרום אפריקה.",
    "rank": 508
  },
  {
    "id": "anq_behistun",
    "deck": "anchors",
    "title": "כתובת בהיסטון",
    "start": -522,
    "end": -520,
    "date": "בערך ⁦522–520⁩ לפנה״ס",
    "place": "בהיסטון, איראן",
    "lat": 34.39,
    "lon": 47.44,
    "desc": "דריוש הראשון הורה לחצוב על מצוק כתובת ענק בשלוש שפות מסמריות, ובה סיפור עלייתו לשלטון ודיכוי המרידות. בהיסטון שימשה לפענוח הכתב האכדי במאה ה־19, כפי שאבן רוזטה שימשה לפענוח ההירוגליפים.",
    "rank": 509
  },
  {
    "id": "med_suleymaniye",
    "deck": "anchors",
    "title": "מסגד סולימאניה",
    "start": 1557,
    "end": 1557,
    "date": "1557",
    "place": "איסטנבול, תורכיה",
    "lat": 41.016,
    "lon": 28.964,
    "desc": "האדריכל סינאן בנה לסולטן סולימאן המפואר מסגד גדול בקונסטנטינופול, שנחשב ליצירת המופת של האדריכלות העות׳מאנית. סביב המסגד נבנו בתי ספר, בית חולים ומטבח לעניים. בימי סולימאן הגיעה האימפריה לשיא עוצמתה.",
    "rank": 510
  },
  {
    "id": "mod_borodino",
    "deck": "anchors",
    "title": "קרב בורודינו",
    "start": 1812,
    "end": 1812,
    "date": "1812",
    "place": "בורודינו, רוסיה",
    "lat": 55.52,
    "lon": 35.82,
    "desc": "נפוליאון, שפלש לרוסיה בצבא ענק, נתקל בצבא רוסי בפיקוד קוטוזוב סמוך למוסקבה. הקרב היה אחד העקובים מדם של התקופה, ועשרות אלפי חיילים נהרגו. הצרפתים כבשו את מוסקבה, אך נאלצו לסגת בחורף ואיבדו את רוב צבאם.",
    "rank": 511
  },
  {
    "id": "anq_dacia",
    "deck": "anchors",
    "title": "כיבוש דקיה",
    "start": 101,
    "end": 106,
    "date": "⁦101–106⁩ לספירה",
    "place": "סרמיזגטוסה, רומניה",
    "lat": 45.62,
    "lon": 23.31,
    "desc": "הקיסר טראיאנוס ניצח בשתי מלחמות את דקביל, מלך הדקים, וסיפח את ממלכתו, אזור עשיר בזהב. אחרי הקרב האחרון התאבד דקביל. עמוד טראיאנוס ברומא מתאר את המערכה, והאימפריה הגיעה בתקופתו לשיא היקפה. הכיבוש הביא לרומא כמויות זהב רבות, ובמקום התיישבו מתיישבים מכל רחבי האימפריה, ומכאן שורשי השפה הרומנית.",
    "rank": 512
  },
  {
    "id": "med_xuanzang",
    "deck": "anchors",
    "title": "שואנזאנג חוזר מהודו",
    "start": 645,
    "end": 645,
    "date": "645 לספירה",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.95,
    "desc": "הנזיר שואנזאנג חזר אחרי כ־16 שנות מסע בהודו עם מאות כתבים בודהיסטיים וחבר ספר על מסעו. בשנים הבאות תירגם רבים מהם לסינית. תיאוריו הם מקור חשוב על הודו ואסיה התיכונה בתקופתו.",
    "rank": 513
  },
  {
    "id": "mod_canada",
    "deck": "anchors",
    "title": "ייסוד הקונפדרציה הקנדית",
    "start": 1867,
    "end": 1867,
    "date": "1867",
    "place": "אוטווה, קנדה",
    "lat": 45.42,
    "lon": -75.7,
    "desc": "אקט צפון אמריקה הבריטית איחד את קנדה, נובה סקוטיה וניו ברנזוויק לדומיניון בהנהגת ג׳ון מקדונלד. קנדה נשארה בשלטון כתר בריטי אבל קיבלה שלטון עצמי בענייני פנים. בעשורים הבאים הצטרפו מחוזות נוספים.",
    "rank": 514
  },
  {
    "id": "anq_olmec",
    "deck": "anchors",
    "title": "מרכז האולמקים בסן לורנסו",
    "start": -1200,
    "end": -1200,
    "date": "בערך 1200 לפנה״ס",
    "place": "סן לורנסו, מקסיקו",
    "lat": 17.76,
    "lon": -94.76,
    "desc": "האולמקים, התרבות המסואמריקנית הקדומה, הקימו בסן לורנסו שבחוף המפרץ מרכז עם תעלות ופסלי ראשי ענק מבזלת. נהוג לראות בהם אם התרבויות בהמשך, בתחום האמנות, הדת, לוח השנה והכתיבה. כיצד קראו לעצמם איננו ידוע.",
    "rank": 515
  },
  {
    "id": "med_rus988",
    "deck": "anchors",
    "title": "הטבלת רוס בקייב",
    "start": 988,
    "end": 988,
    "date": "בערך 988 לספירה",
    "place": "קייב, רוס (אוקראינה)",
    "lat": 50.45,
    "lon": 30.52,
    "desc": "הנסיך ולדימיר הראשון הכריע לאמץ את הנצרות הביזנטית, התנצר ונישא לאחות הקיסר הביזנטי. הוא הורה על הטבלה המונית בנהר הדנייפר. הנצרות האורתודוקסית הפכה לדת הרשמית ברוס והקשרה אותה לעולם הביזנטי והתרבותי.",
    "rank": 516
  },
  {
    "id": "mod_dien_bien_phu",
    "deck": "anchors",
    "title": "קרב דיין ביין פו",
    "start": 1954,
    "end": 1954,
    "date": "1954",
    "place": "דיין ביין פו, וייטנאם",
    "lat": 21.39,
    "lon": 103.02,
    "desc": "בין מרס למאי 1954 כתרו כוחות הווייט מין בפיקוד הגנרל ג׳אפ את המבצר הצרפתי בעמק מרוחק בצפון וייטנאם, וכבשו אותו. התבוסה הסיימה את שלטון צרפת באינדוצ׳ינה. בהסכמי ז׳נבה חולקה וייטנאם בקו הרוחב ה־17, והחלוקה הובילה למלחמת וייטנאם.",
    "rank": 517
  },
  {
    "id": "anq_syracuse",
    "deck": "anchors",
    "title": "ייסוד סירקוזה",
    "start": -733,
    "end": -733,
    "date": "בערך 733 לפנה״ס",
    "place": "סירקוזה, סיציליה",
    "lat": 37.06,
    "lon": 15.29,
    "desc": "מתיישבים מקורינתוס ייסדו את סירקוזה על האי אורטיגיה שבחוף סיציליה. העיר גדלה והפכה לאחת הערים היווניות הגדולות והעשירות במערב, עם שליטים עריצים וצי חזק. ארכימדס נולד בה כחמש מאות שנה אחרי ייסודה.",
    "rank": 518
  },
  {
    "id": "med_zohar",
    "deck": "anchors",
    "title": "התפשטות ספר הזוהר",
    "start": 1290,
    "end": 1290,
    "date": "בערך 1290",
    "place": "גוואדלחרה, ספרד",
    "lat": 40.63,
    "lon": -3.17,
    "desc": "בספרד של סוף המאה ה־13 החל להתפרסם ספר הזוהר, החיבור המרכזי של הקבלה. משה די ליאון, מקובל מאזור גוואדלחרה, הפיץ אותו כמיוחס לרבי שמעון בר יוחאי, וחוקרים רבים מייחסים לו את כתיבתו. הזוהר השפיע עמוקות על המיסטיקה היהודית בדורות הבאים.",
    "rank": 519
  },
  {
    "id": "mod_greekrevolt",
    "deck": "anchors",
    "title": "פרוץ מלחמת העצמאות היוונית",
    "start": 1821,
    "end": 1821,
    "date": "1821",
    "place": "פאטרס, יוון",
    "lat": 38.25,
    "lon": 21.73,
    "desc": "ביוון, בעידוד האגודה החשאית פיליקי אטיריה, פרצה מרידה נגד השלטון העות׳מאני. המורדים כבשו את חצי האי פלופונס ולאחר מכן הוקמה שם ממשלה. האירופים, שהיו חדורים רגשות פילהלניים, תמכו במורדים, וב־1830 הוכרה יוון כמדינה עצמאית.",
    "rank": 520
  },
  {
    "id": "anq_confucius_2",
    "deck": "anchors",
    "title": "מות קונפוציוס",
    "start": -479,
    "end": -479,
    "date": "479 לפנה״ס",
    "place": "צ׳יופו, סין",
    "lat": 35.6,
    "lon": 117,
    "desc": "קונפוציוס, הוגה ומורה ממדינת לו, מת לאחר שנים שבהן נדד בין חצרות שליטים בניסיון להשפיע על דרך שלטונם. תלמידיו אספו את דבריו בספר ״השיחות״. תורתו, שהדגישה מוסר, כיבוד הורים וסדר חברתי, עיצבה את התרבות והמדינה הסינית במשך כאלפיים שנה.",
    "rank": 521
  },
  {
    "id": "med_trent",
    "deck": "anchors",
    "title": "מועצת טרנטו",
    "start": 1545,
    "end": 1563,
    "date": "⁦1545–1563⁩",
    "place": "טרנטו, איטליה",
    "lat": 46.07,
    "lon": 11.12,
    "desc": "הכנסייה הקתולית כינסה מועצה בעיר בצפון איטליה כדי להשיב לרפורמציה. המועצה אישררה את הדוקטרינה הקתולית, ארגנה מחדש את חינוך הכמרים וביקורת הספרים ושללה את הגישות הפרוטסטנטיות. היא עיצבה את הקתוליות לדורות.",
    "rank": 522
  },
  {
    "id": "mod_sumter",
    "deck": "anchors",
    "title": "ההפגזה על פורט סאמטר",
    "start": 1861,
    "end": 1861,
    "date": "1861",
    "place": "צ׳רלסטון, דרום קרולינה, ארה״ב",
    "lat": 32.75,
    "lon": -79.87,
    "desc": "כוחות הקונפדרציה פתחו באש על המבצר האמריקאי בנמל צ׳רלסטון, חודשים לאחר שדרום קרולינה פרשה מהאיחוד בשל החשש מפגיעה בעבדות. המבצר נכנע. נשיא ארצות הברית לינקולן קרא להתגייסות, והמלחמה האזרחית החלה.",
    "rank": 523
  },
  {
    "id": "anq_tetrarchy",
    "deck": "anchors",
    "title": "הטטרארכיה",
    "start": 293,
    "end": 293,
    "date": "293 לספירה",
    "place": "ניקומדיה, טורקיה",
    "lat": 40.77,
    "lon": 29.92,
    "desc": "הקיסר דיוקלטיינוס חילק את השלטון בין ארבעה שליטים, שני אוגוסטים ושני קיסרים, כדי לייצב את האימפריה ולהגן על גבולותיה. ניקומדיה, ולא רומא, שימשה בירה במזרח. בהמשך נאבקו יורשיו בלי להצליח להחזיק במערכת.",
    "rank": 524
  },
  {
    "id": "med_york",
    "deck": "anchors",
    "title": "הטבח ביהודי יורק",
    "start": 1190,
    "end": 1190,
    "date": "1190",
    "place": "יורק, אנגליה",
    "lat": 53.956,
    "lon": -1.08,
    "desc": "בעקבות מהומות אנטי־יהודיות אחרי הכתרת ריצ׳רד הראשון נמלטו יהודי יורק למגדל הטירה. נצורים על ידי ההמון בחרו רבים מהם להתאבד. הטבח ושריפת שטרות החוב בכנסייה מעידים על המתח בין היהודים ללווים.",
    "rank": 525
  },
  {
    "id": "mod_arab_revolt",
    "deck": "anchors",
    "title": "המרד הערבי הגדול",
    "start": 1916,
    "end": 1916,
    "date": "1916",
    "place": "מכה, חג׳אז",
    "lat": 21.42,
    "lon": 39.83,
    "desc": "ביוני 1916 הכריז שריף מכה חוסיין בן עלי על מרד נגד השלטון העות׳מאני, בעידוד בריטי. בנו פייסל, בסיוע קצין הקישור הבריטי ט״א לורנס, הוביל לוחמים ערבים מהחג׳אז צפונה, וב־1918 נכנסו לדמשק. הבטחות הבריטים לעצמאות ערבית התנגשו עם הסכם סייקס־פיקו ועם הצהרת בלפור.",
    "rank": 526
  },
  {
    "id": "anq_merneptah",
    "deck": "anchors",
    "title": "מצבת מרנפתח ושמה של ישראל",
    "start": -1208,
    "end": -1208,
    "date": "בערך 1208 לפנה״ס",
    "place": "תבי, מצרים",
    "lat": 25.72,
    "lon": 32.65,
    "desc": "על מצבת הניצחון של הפרעה מרנפתח מופיעה רשימת עמים שהביס בכנען, ובהם ״ישראל״. זוהי ההזכרה הקדומה ביותר של השם בכתובת מחוץ למקרא. הכתובת מעידה על קבוצה בשם זה בכנען סמוך לסוף תקופת הברונזה, ללא פרטים על זהותה.",
    "rank": 527
  },
  {
    "id": "med_pachacuti",
    "deck": "anchors",
    "title": "פצ׳אקוטי ואימפריית האינקה",
    "start": 1438,
    "end": 1438,
    "date": "בערך 1438",
    "place": "קוסקו, פרו",
    "lat": -13.52,
    "lon": -71.97,
    "desc": "לפי המסורת הביס האינקה פצ׳אקוטי את שכניו הצ׳אנקה והפך את קוסקו מעיר־מדינה לבירת אימפריה. הוא ויורשיו הרחיבו את השלטון לאורך האנדים, ארגנו רשת דרכים ושיטת עבודה בשירות המדינה. האימפריה לא ידעה כתב, אך השתמשה בחבלי קשרים, הקיפו.",
    "rank": 528
  },
  {
    "id": "anq_carchemish",
    "deck": "anchors",
    "title": "קרב כרכמיש",
    "start": -605,
    "end": -605,
    "date": "בערך 605 לפנה״ס",
    "place": "כרכמיש, סוריה",
    "lat": 36.83,
    "lon": 38.01,
    "desc": "נבוכדנאצר, יורש העצר של בבל, הביס את צבא מצרים והשרידים האשוריים ליד נהר פרת. הניצחון הקנה לבבל שליטה בסוריה ובלבנט. יהודה נעשתה כפופה לבבל, ובכך נסללה הדרך לסוף ממלכתה.",
    "rank": 529
  },
  {
    "id": "med_goa",
    "deck": "anchors",
    "title": "הפורטוגלים כובשים את גואה",
    "start": 1510,
    "end": 1510,
    "date": "1510",
    "place": "גואה, הודו",
    "lat": 15.5,
    "lon": 73.83,
    "desc": "אפונסו דה אלבוקרקי כבש את גואה מידי סולטן ביג׳אפור והפך אותה לבירת האימפריה הפורטוגלית במזרח. העיר הייתה נמל מרכזי למסחר ולמסיון הנוצרי. גואה נשארה בידי פורטוגל עד 1961, הרבה אחרי שאר אחזקות האירופים בהודו.",
    "rank": 530
  },
  {
    "id": "mod_commune",
    "deck": "anchors",
    "title": "קומונת פריז",
    "start": 1871,
    "end": 1871,
    "date": "1871",
    "place": "פריז, צרפת",
    "lat": 48.86,
    "lon": 2.35,
    "desc": "לאחר התבוסה במלחמה מול פרוסיה השתלטו פועלים וחיילי המשמר הלאומי על פריז והקימו שלטון עצמי סוציאליסטי. ״השבוע הדמים״ הכניע אותה בטבח, ועשרות אלפים נהרגו או הוגלו. הקומונה הפכה לסמל לתנועות פועלים וסוציאליסטים.",
    "rank": 531
  },
  {
    "id": "anq_antonine_plague",
    "deck": "anchors",
    "title": "מגפת אנטונינוס",
    "start": 165,
    "end": 180,
    "date": "⁦165–180⁩ לספירה",
    "place": "סלאוקיה, עיראק",
    "lat": 33.09,
    "lon": 44.52,
    "desc": "מגפה, ככל הנראה אבעבועות שחורות, התפשטה ברחבי האימפריה הרומית בעקבות חיילים ששבו ממלחמת פרתיה. לפי כמה הערכות מתו בה מיליוני בני אדם, בהם הקיסר לוציוס וורוס. המגפה פגעה בכלכלה ובכוח האדם של הצבא. המגפה מכונה גם מגפת גאלן, על שם הרופא שתיאר אותה, והיא הקדימה את המשברים שפקדו את האימפריה בהמשך המאה.",
    "rank": 532
  },
  {
    "id": "med_tang",
    "deck": "anchors",
    "title": "ייסוד שושלת טאנג",
    "start": 618,
    "end": 618,
    "date": "618 לספירה",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.95,
    "desc": "לי יואן הכריז על עצמו כקיסר והקים את שושלת טאנג בצ׳אנגאן. תקופת טאנג נחשבת לתור זהב של התרבות הסינית, בשירה, באמנות ובמסחר. צ׳אנגאן הייתה אחת הערים הגדולות בעולם.",
    "rank": 533
  },
  {
    "id": "mod_lisbon",
    "deck": "anchors",
    "title": "רעידת האדמה הגדולה בליסבון",
    "start": 1755,
    "end": 1755,
    "date": "1755",
    "place": "ליסבון, פורטוגל",
    "lat": 38.72,
    "lon": -9.14,
    "desc": "ב־1 בנובמבר, יום כל הקדושים, פגעה ברעידת אדמה חזקה, ואחריה צונאמי ושריפות, שהרסו את רוב העיר. עשרות אלפי בני אדם נהרגו. ראש הממשלה מרקיז פומבל הנהיג את בנייתה מחדש, והאסון עורר ויכוחים פילוסופיים, בין השאר אצל וולטר.",
    "rank": 534
  },
  {
    "id": "anq_lion_gate",
    "deck": "anchors",
    "title": "שער האריות במיקנה",
    "start": -1250,
    "end": -1250,
    "date": "בערך 1250 לפנה״ס",
    "place": "מיקנה, יוון",
    "lat": 37.731,
    "lon": 22.756,
    "desc": "במיקנה שבפלופונס שלט מלך חזק על ארמון מבוצר. בכניסה לאקרופוליס הוקם שער האריות, ועליו תבליט של שתי לביאות. מיקנה הייתה מרכז התרבות המיקנית, שכתבה בכתב לינארי ב׳, שפה יוונית קדומה.",
    "rank": 535
  },
  {
    "id": "med_england_jews",
    "deck": "anchors",
    "title": "גירוש היהודים מאנגליה",
    "start": 1290,
    "end": 1290,
    "date": "1290",
    "place": "לונדון, אנגליה",
    "lat": 51.51,
    "lon": -0.1,
    "desc": "המלך אדוארד הראשון הוציא צו שהורה ליהודי אנגליה לעזוב את הממלכה, אחרי שנות מיסוי כבד ורדיפות. אלפי יהודים עזבו לצרפת, לפלנדריה ולמקומות אחרים. יהודים חזרו לאנגליה באופן רשמי רק במאה ה־17.",
    "rank": 536
  },
  {
    "id": "mod_sepoy",
    "deck": "anchors",
    "title": "המרד ההודי הגדול נגד הבריטים",
    "start": 1857,
    "end": 1857,
    "date": "1857",
    "place": "דלהי, הודו",
    "lat": 28.65,
    "lon": 77.23,
    "desc": "חיילים הודים בצבא חברת הודו המזרחית הבריטית התקוממו במירוט, הגיעו לדלהי והכריזו על הקיסר המוגולי האחרון, בהאדור שאה, כמנהיג. המרד התפשט בצפון הודו והוכחד באכזריות בידי הבריטים. החברה פורקה, וההודים עברו לשלטון ישיר של הכתר הבריטי.",
    "rank": 537
  },
  {
    "id": "anq_mesha",
    "deck": "anchors",
    "title": "מצבת מישע מלך מואב",
    "start": -840,
    "end": -840,
    "date": "בערך 840 לפנה״ס",
    "place": "דיבון, ירדן",
    "lat": 31.5,
    "lon": 35.78,
    "desc": "מישע, מלך מואב, הקים מצבת בזלת ובה סיפור מרד נגד ישראל ושחרור ממנה, ושם האל יהוה מופיע בה. היא נמצאה ב־1868 ושרדה בחלקה. הכתובת היא מן הכתובות הארוכות מן התקופה, בשפה הדומה מאוד לעברית.",
    "rank": 538
  },
  {
    "id": "med_isabella",
    "deck": "anchors",
    "title": "נישואי איזבלה ופרננדו",
    "start": 1469,
    "end": 1469,
    "date": "1469",
    "place": "בייאדוליד, ספרד",
    "lat": 41.65,
    "lon": -4.72,
    "desc": "איזבלה, יורשת כתר קסטיליה, נישאה לפרננדו, יורש כתר אראגון. אחרי שעלו לכס בשתי הממלכות החזקות בספרד, שלטו בהן במשותף, אף שכל אחת שמרה על מוסדותיה. מהאיחוד צמחה ספרד המודרנית.",
    "rank": 539
  },
  {
    "id": "mod_congo",
    "deck": "anchors",
    "title": "הקונגו של המלך ליאופולד",
    "start": 1885,
    "end": 1908,
    "date": "⁦1885–1908⁩",
    "place": "קינשסה (לאופולדוויל), קונגו",
    "lat": -4.32,
    "lon": 15.31,
    "desc": "ועידת ברלין הכירה ב־1885 בקונגו כנחלתו האישית של מלך בלגיה ליאופולד השני. שלטונו ניצל את האוכלוסייה בכפייה לייצור גומי ושנהב, ואכף זאת באלימות ובקטיעת איברים. מיליוני קונגולים מתו, ומחאה בין־לאומית אילצה את בלגיה להשתלט על השטח ב־1908.",
    "rank": 540
  },
  {
    "id": "anq_ionian",
    "deck": "anchors",
    "title": "מרד היוונים באסיה הקטנה",
    "start": -499,
    "end": -494,
    "date": "⁦499–494⁩ לפנה״ס",
    "place": "מילטוס, אסיה הקטנה",
    "lat": 37.53,
    "lon": 27.28,
    "desc": "ערים יווניות באיוניה התקוממו נגד השלטון הפרסי בהנהגת מילטוס, ואתונה ואריתריאה שלחו להן סיוע. המורדים הציתו את סרדיס, בירת הפרובינציה הפרסית, אך הצי היווני הובס בקרב לאדה והמרד דוכא. המרד שימש לדריווש הראשון עילה לצאת למסעות נגד יוון.",
    "rank": 541
  },
  {
    "id": "med_siege717",
    "deck": "anchors",
    "title": "המצור הערבי על קונסטנטינופול",
    "start": 717,
    "end": 718,
    "date": "⁦717–718⁩ לספירה",
    "place": "קונסטנטינופול, האימפריה הביזנטית",
    "lat": 41.01,
    "lon": 28.95,
    "desc": "צבא וצי של הח׳ליפות האומיית צרו על העיר במשך שנה. חומות העיר, החורף הקשה, האש היוונית והברית עם הבולגרים הכריעו, והצבא הערבי נסוג. הכישלון עצר את התפשטות המוסלמים בצד אירופה והציל את ביזנטיון.",
    "rank": 542
  },
  {
    "id": "mod_glorious",
    "deck": "anchors",
    "title": "המהפכה המפוארת",
    "start": 1688,
    "end": 1688,
    "date": "1688",
    "place": "לונדון, אנגליה",
    "lat": 51.51,
    "lon": -0.13,
    "desc": "נכבדי אנגליה הזמינו את וילהלם מאורנג׳, שליט הולנד, לפלוש לאנגליה, והמלך הקתולי ג׳יימס השני ברח מהארץ כמעט ללא קרב. וילהלם ואשתו מרי הוכתרו, ובשנה הבאה אושרה מגילת הזכויות. המהפכה ביססה את עליונות הפרלמנט על המלך.",
    "rank": 543
  },
  {
    "id": "anq_ardashir",
    "deck": "anchors",
    "title": "ייסוד האימפריה הסאסאנית",
    "start": 226,
    "end": 226,
    "date": "226 לספירה",
    "place": "קטסיפון, עיראק",
    "lat": 33.09,
    "lon": 44.58,
    "desc": "ארדשיר הראשון, שליט פרס, ניצח ב־224 את ארטבנוס הרביעי, מלך פרתיה האחרון, והוכתר ב־226 בקטסיפון כמלך המלכים. הוא הנהיג את הזורואסטרים כדת המדינה והקים משטר ריכוזי. האימפריה הסאסאנית התחרתה ברומא ובביזנטיון כארבע מאות שנה.",
    "rank": 544
  },
  {
    "id": "med_khwarazm",
    "deck": "anchors",
    "title": "המונגולים כובשים את חוארזם",
    "start": 1219,
    "end": 1221,
    "date": "⁦1219–1221⁩",
    "place": "בוכרה, אוזבקיסטן",
    "lat": 39.775,
    "lon": 64.43,
    "desc": "אחרי שמושל חוארזם הוציא להורג שליחי סוחרים מונגוליים, פלש ג׳ינגיס חאן לממלכה המוסלמית שבמרכז אסיה. בוכרה, סמרקנד ומרו נפלו זו אחר זו, ואוכלוסיות שלמות נטבחו או גורשו. המסע החריב ערי תרבות רבות והחל את התפשטות המונגולים מערבה.",
    "rank": 545
  },
  {
    "id": "mod_garibaldi",
    "deck": "anchors",
    "title": "מסע אלף הצוערים של גריבלדי",
    "start": 1860,
    "end": 1860,
    "date": "1860",
    "place": "מרסלה, איטליה",
    "lat": 37.8,
    "lon": 12.43,
    "desc": "ג׳וזפה גריבלדי נחת בסיציליה עם כאלף מתנדבים בחולצות אדומות, וכבש במהירות את ממלכת שתי הסיציליות הבורבונית. הוא העביר את השטחים למלך ויקטור עמנואל השני. ב־1861 הוכרזה ממלכת איטליה המאוחדת.",
    "rank": 546
  },
  {
    "id": "anq_sea_peoples",
    "deck": "anchors",
    "title": "קרב דלתת הנילוס נגד עמי הים",
    "start": -1177,
    "end": -1177,
    "date": "בערך 1177 לפנה״ס",
    "place": "דלתת הנילוס, מצרים",
    "lat": 31,
    "lon": 31,
    "desc": "רעמסס השלישי הדף מתקפות של עמי הים בקרב יבשתי וימי בשערי מצרים. הקרב מתועד בתבליטי מדינת הבו. מתקפות אלה התרחשו בעת התמוטטות מרכזי הברונזה במזרח הים התיכון, שבה חרבו ערים כמו אוגרית ומיקנה והאימפריה החתית.",
    "rank": 547
  },
  {
    "id": "med_nanak",
    "deck": "anchors",
    "title": "הולדת גורו נאנאק",
    "start": 1469,
    "end": 1469,
    "date": "1469",
    "place": "ננקאנה סאהיב, פקיסטן",
    "lat": 31.45,
    "lon": 73.71,
    "desc": "גורו נאנאק נולד בכפר טלוונדי שבפנג׳אב, כיום ננקאנה סאהיב, למשפחה הינדית. הוא קרא לאמונה באל אחד ולשוויון בין בני אדם, ללא הבדלי מעמד ודת. תורתו היא יסוד הדת הסיקית, ועיר הולדתו היא מקום קדוש.",
    "rank": 548
  },
  {
    "id": "mod_amritsar",
    "deck": "anchors",
    "title": "טבח אמריצר",
    "start": 1919,
    "end": 1919,
    "date": "1919",
    "place": "אמריצר, הודו",
    "lat": 31.62,
    "lon": 74.88,
    "desc": "ב־13 באפריל ירו חיילים בריטים בפיקוד הגנרל דייר על אלפי אנשים שהתכנסו בגן ג׳ליאנוואלה בעיר אמריצר, שבו נאסרו התקהלויות. לפי הערכה בריטית כ־380 נהרגו, ולפי הערכות הודיות יותר מ־1,000. הטבח חיזק את התנועה הלאומית ההודית והרחיק רבים מהשלטון הבריטי.",
    "rank": 549
  },
  {
    "id": "anq_pelusium",
    "deck": "anchors",
    "title": "קרב פלוזיום וכיבוש מצרים",
    "start": -525,
    "end": -525,
    "date": "בערך 525 לפנה״ס",
    "place": "פלוזיום, מצרים",
    "lat": 30.97,
    "lon": 32.55,
    "desc": "קמביסס השני, מלך פרס, ניצח את פסמתיק השלישי בקרב פלוזיום בסיני וכבש את מצרים. היא נעשתה נציבות פרסית והייתה לשושלת ה־27. מצרים נשארה תחת שלטון פרס כמאה ועשרים שנה, עד המרד.",
    "rank": 550
  },
  {
    "id": "med_pakal",
    "deck": "anchors",
    "title": "מותו של פאקאל הגדול בפאלנקה",
    "start": 683,
    "end": 683,
    "date": "683 לספירה",
    "place": "פאלנקה, מקסיקו",
    "lat": 17.48,
    "lon": -92.05,
    "desc": "פאקאל שלט בפאלנקה כשבעים שנה. הוא נקבר במקדש הכתובות, בקבר מפואר עם כתובות ופסלים. הקבר התגלה ב־1952, והכתובות במקום הן מקור מרכזי לידע על שושלות המאיה.",
    "rank": 551
  },
  {
    "id": "mod_yorktown",
    "deck": "anchors",
    "title": "המצור על יורקטאון",
    "start": 1781,
    "end": 1781,
    "date": "1781",
    "place": "יורקטאון, ארה״ב",
    "lat": 37.24,
    "lon": -76.51,
    "desc": "צבא אמריקאי־צרפתי בפיקוד ג׳ורג׳ וושינגטון וקומט דה רושמבו, עם צי צרפתי שחסם את הנמל, כיתר את הצבא הבריטי של לורד קורנווליס. קורנווליס נכנע עם כשבעת אלפים חיילים. התבוסה שברה את רצון בריטניה להמשיך את המלחמה, והוביל להכרה בעצמאות ארצות הברית ב־1783.",
    "rank": 552
  },
  {
    "id": "anq_carrhae",
    "deck": "anchors",
    "title": "קרב כרהאי",
    "start": -53,
    "end": -53,
    "date": "53 לפנה״ס",
    "place": "חראן, דרום־מזרח טורקיה",
    "lat": 36.87,
    "lon": 39.03,
    "desc": "המצביא הרומי קראסוס הוביל צבא לפרתיה ונוצח על ידי קשתים רכובים ופרשים משוריינים בפיקוד סורנה. קראסוס נהרג, ורבים מחייליו נהרגו או נשבו. התבוסה מהעוצמות המפתיעות של פרתיה סימנה את גבולה המזרחי של רומא.",
    "rank": 553
  },
  {
    "id": "med_umayyadspain",
    "deck": "anchors",
    "title": "עבד אל־רחמן הראשון מקים אמירות בקורדובה",
    "start": 756,
    "end": 756,
    "date": "756 לספירה",
    "place": "קורדובה, ספרד",
    "lat": 37.89,
    "lon": -4.78,
    "desc": "ניצול אחרון של השושלת האומיית, עבד אל־רחמן הראשון, ברח מהטבח של בני עבאס והגיע לספרד. שם הביס את המושל וייסד אמירות עצמאית בקורדובה. אל־אנדלוס נותרה בידי האומיים ובעוד שנים נעשתה מרכז תרבות מפואר.",
    "rank": 554
  },
  {
    "id": "mod_greatexhibition",
    "deck": "anchors",
    "title": "התערוכה הגדולה בהייד פארק",
    "start": 1851,
    "end": 1851,
    "date": "1851",
    "place": "לונדון, אנגליה",
    "lat": 51.5,
    "lon": -0.17,
    "desc": "בארמון הבדולח, מבנה ענק מברזל וזכוכית, הוצגו מוצרים תעשייתיים ואומנות מרחבי העולם בפני יותר משישה מיליון מבקרים. ההצגה שיקפה את מעמדה של בריטניה כמעצמה תעשייתית. התערוכה נחשבת לאב הטיפוס של יריד העולם.",
    "rank": 555
  },
  {
    "id": "anq_megiddo_1457",
    "deck": "anchors",
    "title": "קרב מגידו",
    "start": -1457,
    "end": -1457,
    "date": "בערך 1457 לפנה״ס",
    "place": "מגידו, ארץ ישראל",
    "lat": 32.585,
    "lon": 35.185,
    "desc": "תחות׳מס השלישי הביס קואליציה של נסיכי כנען שנאספה במגידו, ושעבד את סוריה וכנען לשלטון מצרים. הקרב מתועד בפירוט בכתובות המצרים וזהו הקרב המתועד הראשון בהיסטוריה. מגידו נשארה עיר אסטרטגית על הדרך הבינלאומית.",
    "rank": 556
  },
  {
    "id": "med_ankara",
    "deck": "anchors",
    "title": "קרב אנקרה",
    "start": 1402,
    "end": 1402,
    "date": "1402",
    "place": "אנקרה, תורכיה",
    "lat": 39.98,
    "lon": 32.88,
    "desc": "תימור הביס את הסולטן העות׳מאני בייזיד הראשון וכבש אותו בקרב ליד אנקרה. התבוסה הכניסה את האימפריה העות׳מאנית לעשור של מלחמת אחים על הירושה והאריכה את חיי ביזנטיון בכמה עשורים. בייזיד מת בשבי.",
    "rank": 557
  },
  {
    "id": "mod_bikini",
    "deck": "anchors",
    "title": "ניסויי הגרעין באטול ביקיני",
    "start": 1946,
    "end": 1946,
    "date": "1946",
    "place": "אטול ביקיני, איי מרשל",
    "lat": 11.6,
    "lon": 165.38,
    "desc": "ב־1946 פינתה ארצות הברית את תושבי אטול ביקיני שבאוקיינוס השקט ופוצצה בו פצצות אטומיות במבצע ״צומת דרכים״ כדי לבחון את השפעתן על ספינות. עד 1958 נערכו שם ובסביבה עשרות ניסויים נוספים. התושבים לא יכלו לשוב, והאטול נשאר מזוהם בקרינה.",
    "rank": 558
  },
  {
    "id": "anq_nabopolassar",
    "deck": "anchors",
    "title": "נבופולסר מייסד בבל החדשה",
    "start": -626,
    "end": -626,
    "date": "בערך 626 לפנה״ס",
    "place": "בבל, עיראק",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "נבופולסר, שר כלדי, הוכתר למלך בבל ושחרר אותה משלטון אשור, ובכך ייסד את האימפריה הבבלית החדשה. בנו נבוכדנאצר השני הפך את בבל למעצמה. השושלת שלטה כשמונים שנה עד כיבוש כורש.",
    "rank": 559
  },
  {
    "id": "med_iconoclasm",
    "deck": "anchors",
    "title": "תחילת האיקונוקלזם הביזנטי",
    "start": 726,
    "end": 730,
    "date": "בערך ⁦726–730⁩ לספירה",
    "place": "קונסטנטינופול, האימפריה הביזנטית",
    "lat": 41.01,
    "lon": 28.98,
    "desc": "הקיסר ליאון השלישי החל מדיניות נגד פולחן האיקונות והסרת תמונות הקדושים. המחלוקת הפכה למשבר דתי ופוליטי שנמשך עשרות שנים עם הפסקות. הוכרע לבסוף ב־843 והוחזר פולחן האיקונות.",
    "rank": 560
  },
  {
    "id": "mod_capetown",
    "deck": "anchors",
    "title": "הקמת תחנת האספקה ההולנדית בכף התקווה הטובה",
    "start": 1652,
    "end": 1652,
    "date": "1652",
    "place": "קייפטאון, דרום אפריקה",
    "lat": -33.92,
    "lon": 18.42,
    "desc": "יאן ואן ריבק הגיע מטעם חברת הודו המזרחית ההולנדית וייסד תחנת אספקה לספינות בדרך להודו. המתיישבים ההולנדים הראשונים החלו לעבד חוות באזור ופגשו את בני הקוי־קוי המקומיים. התחנה הפכה למושבה אירופית קבועה, ושימשה בסיס להתפשטות אירופית בדרום אפריקה.",
    "rank": 561
  },
  {
    "id": "anq_zhang_heng",
    "deck": "anchors",
    "title": "מכשיר רעידות האדמה של ג׳אנג הנג",
    "start": 132,
    "end": 132,
    "date": "132 לספירה",
    "place": "לויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "האסטרונום והממציא ג׳אנג הנג בנה כלי ברונזה גדול ובו שמונה ראשי דרקון שאחד מהם הפיל כדור כשהתרחשה רעידת אדמה רחוקה. הכלי, הראשון שידוע, הצביע על כיוון המקור. הוא עסק גם באסטרונומיה והמציא כדור שמיים הידראולי.",
    "rank": 562
  },
  {
    "id": "med_delhi_sultanate",
    "deck": "anchors",
    "title": "הקמת סולטנות דלהי",
    "start": 1206,
    "end": 1206,
    "date": "1206",
    "place": "דלהי, הודו",
    "lat": 28.525,
    "lon": 77.185,
    "desc": "קוטב אל־דין אייבק, מצביא תורכי ובעבר עבד צבאי של שליטי גור, הפך לשליט עצמאי בצפון הודו ונחשב לראשון סולטני דלהי. הסולטנות שלטה בחלקים גדולים מהודו במשך כשלוש מאות שנה, עד הכיבוש המוגולי. תחת שלטונה התפתחה תרבות הודית־מוסלמית משותפת.",
    "rank": 563
  },
  {
    "id": "mod_taiping",
    "deck": "anchors",
    "title": "מרד הטאיפינג",
    "start": 1850,
    "end": 1864,
    "date": "⁦1850–1864⁩",
    "place": "נאנג׳ינג, סין",
    "lat": 32.06,
    "lon": 118.78,
    "desc": "הונג שיוצ׳ואן, שהאמין שהוא אחיו הצעיר של ישו, הנהיג מרד נגד שושלת צ׳ינג, וכבש את נאנג׳ינג ב־1853 והקים בה בירה. המלחמה הייתה בין העקובות מדם בהיסטוריה, עם עשרות מיליוני הרוגים. צבאות אזוריים, בעזרת קצינים מערביים, דיכאו אותו.",
    "rank": 564
  },
  {
    "id": "anq_shoshenq",
    "deck": "anchors",
    "title": "מסע שישק לארץ ישראל",
    "start": -925,
    "end": -925,
    "date": "בערך 925 לפנה״ס",
    "place": "קרנך, מצרים",
    "lat": 25.72,
    "lon": 32.66,
    "desc": "פרעה שישק הראשון יצא למסע צבאי בכנען, ורשימת הערים שכבש נחרתה על קיר מקדש אמון בקרנך. הרשימה כוללת ערים בנגב, בשפלה וביזרעאל. המסע מוזכר בספר מלכים כמסע ״שישק מלך מצרים״ נגד ירושלים בימי רחבעם.",
    "rank": 565
  },
  {
    "id": "med_mohacs",
    "deck": "anchors",
    "title": "קרב מוהאץ׳",
    "start": 1526,
    "end": 1526,
    "date": "1526",
    "place": "מוהאץ׳, הונגריה",
    "lat": 45.99,
    "lon": 18.68,
    "desc": "הסולטן סולימאן המפואר הביס את צבא הונגריה, והמלך לאיוש השני נהרג בנסיגה. הונגריה נחלקה בין העות׳מאנים להבסבורגים ולנסיכות טרנסילבניה. מרכז הונגריה נשאר תחת שלטון עות׳מאני כ־150 שנה.",
    "rank": 566
  },
  {
    "id": "anq_megiddo_609",
    "deck": "anchors",
    "title": "מותו של יאשיהו במגידו",
    "start": -609,
    "end": -609,
    "date": "בערך 609 לפנה״ס",
    "place": "מגידו, ארץ ישראל",
    "lat": 32.585,
    "lon": 35.185,
    "desc": "יאשיהו מלך יהודה יצא נגד צבא נכו השני מלך מצרים, שצעד לעזרת אשור, ונהרג בקרב ליד מגידו. מצרים שלטה ביהודה זמן קצר, עד שבבל גברה עליה. המאורע מתואר בספר מלכים ובדברי הימים בגרסאות שונות.",
    "rank": 567
  },
  {
    "id": "med_pippin",
    "deck": "anchors",
    "title": "פפין הקצר נעשה למלך הפרנקים",
    "start": 751,
    "end": 751,
    "date": "751 לספירה",
    "place": "סואסון, ממלכת הפרנקים",
    "lat": 49.38,
    "lon": 3.32,
    "desc": "פפין, ראש משק המלוכה, הפיל את המלך המרובינגי האחרון בהסכמת האפיפיור. הבכירים הפרנקים בחרו בו למלך, וכך עבר השלטון לשושלת הקרולינגית. תמורת הלגיטימציה סייע פפין לאפיפיור נגד הלומברדים, ומתנתו הניחה את יסוד מדינת האפיפיור.",
    "rank": 568
  },
  {
    "id": "mod_firstfleet",
    "deck": "anchors",
    "title": "הצי הראשון והקמת מושבת העבריינים באוסטרליה",
    "start": 1788,
    "end": 1788,
    "date": "1788",
    "place": "סידני, אוסטרליה",
    "lat": -33.86,
    "lon": 151.21,
    "desc": "אחת־עשרה ספינות עם כאלף וארבע מאות איש, רובם אסירים, הגיעו מבריטניה בפיקוד ארתור פיליפ והקימו יישוב בסידני קוב. לאחר שאיבדה את מושבות אמריקה חיפשה בריטניה מקום לשלוח אליו אסירים. ההתיישבות פתחה את סיפור אוסטרליה המודרנית ואת ההפקעה של האדמות הילידיות.",
    "rank": 569
  },
  {
    "id": "anq_han_fall",
    "deck": "anchors",
    "title": "קץ שושלת האן",
    "start": 220,
    "end": 220,
    "date": "220 לספירה",
    "place": "לויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "קאו פי, בנו של קאו קאו, אילץ את הקיסר האחרון של האן לוותר על כסאו והכריז על שושלת ווי. בעקבות זאת נוצרו בסין שלוש ממלכות, ווי, שו ואו, שנלחמו זו בזו עשרות שנים. התקופה הונצחה בספר ״רומן שלוש הממלכות״.",
    "rank": 570
  },
  {
    "id": "med_songfound",
    "deck": "anchors",
    "title": "ייסוד שושלת סונג",
    "start": 960,
    "end": 960,
    "date": "960 לספירה",
    "place": "קאיפנג, סין",
    "lat": 34.8,
    "lon": 114.3,
    "desc": "המצביא ג׳או קואנגיין תפס את השלטון ופתח את שושלת סונג. בתקופתה פרחו המסחר והטכנולוגיה, ושימוש במצפן ובאבקת שריפה התפתח. בירתה, קאיפנג, הייתה מהערים הגדולות בעולם.",
    "rank": 571
  },
  {
    "id": "mod_railroad",
    "deck": "anchors",
    "title": "השלמת מסילת הרכבת הטרנס־יבשתית",
    "start": 1869,
    "end": 1869,
    "date": "1869",
    "place": "פרומונטורי, יוטה, ארה״ב",
    "lat": 41.62,
    "lon": -112.55,
    "desc": "שתי חברות, יוניון פסיפיק וסנטרל פסיפיק, חיברו את המסילה מהמזרח ומהמערב בהמסמר ה״זהב״. עובדים אירים וסינים רבים בנו את המסילה. הנסיעה מחוף לחוף התקצרה לימים אחדים, ושינתה את ההתיישבות במערב ואת שוק המדינה.",
    "rank": 572
  },
  {
    "id": "anq_newgrange",
    "deck": "anchors",
    "title": "בניית קבר המסדרון בניוגרנג׳",
    "start": -3200,
    "end": -3200,
    "date": "בערך 3200 לפנה״ס",
    "place": "ניוגרנג׳, אירלנד",
    "lat": 53.695,
    "lon": -6.475,
    "desc": "בעמק נהר בוין שבאירלנד הוקם תל קבורה גדול מאבן ומדשא, ובתוכו מסדרון ותא קבורה. פתח מיוחד מעליו מאיר את התא בקרני השמש בבוקר היום הקצר בשנה. המבנה קדם לפירמידות של מצרים ולסטונהנג׳ בכמה מאות שנים.",
    "rank": 573
  },
  {
    "id": "med_kulikovo",
    "deck": "anchors",
    "title": "קרב קוליקובו",
    "start": 1380,
    "end": 1380,
    "date": "1380",
    "place": "שדה קוליקובו, רוסיה",
    "lat": 53.66,
    "lon": 38.66,
    "desc": "דמיטרי, נסיך מוסקבה, הביס צבא של ההורדה הזהובה בשדה ליד הנהר דון. הניצחון לא שחרר את רוסיה מהמונגולים, שחזרו וכבשו את מוסקבה כשנתיים אחר כך. אך הוא חיזק את מעמד מוסקבה כמנהיגת הנסיכויות הרוסיות.",
    "rank": 574
  },
  {
    "id": "mod_sharpeville",
    "deck": "anchors",
    "title": "טבח שארפוויל",
    "start": 1960,
    "end": 1960,
    "date": "1960",
    "place": "שארפוויל, דרום אפריקה",
    "lat": -26.68,
    "lon": 27.87,
    "desc": "ב־21 במרס התקהלו אלפי שחורים בשארפוויל במחאה על חוקי המעבר של משטר האפרטהייד. המשטרה פתחה באש ו־69 בני אדם נהרגו, רבים מהם נורו בגבם. הטבח עורר גינוי עולמי, הוביל לאיסור על הקונגרס הלאומי האפריקאי, ודחף את מנהיגיו אל מאבק מזוין.",
    "rank": 575
  },
  {
    "id": "anq_zhou_fall",
    "deck": "anchors",
    "title": "נפילת ג׳ואו המערבית",
    "start": -771,
    "end": -771,
    "date": "בערך 771 לפנה״ס",
    "place": "האוג׳ינג, סין",
    "lat": 34.27,
    "lon": 108.8,
    "desc": "שבטים מערביים ובני ברית מורדים של המלך הפילו את הבירה האוג׳ינג והרגו את המלך יו מג׳ואו. בנו העביר את הבירה מזרחה ללואויי. בכך החלה תקופת ג׳ואו המזרחית, ובה פחתה סמכות המלך והנסיכים נאבקו זה בזה.",
    "rank": 576
  },
  {
    "id": "med_fatimid",
    "deck": "anchors",
    "title": "ייסוד הח׳ליפות הפאטמית",
    "start": 910,
    "end": 910,
    "date": "910 לספירה",
    "place": "רקאדה, אפריקיה (תוניסיה)",
    "lat": 35.59,
    "lon": 10.1,
    "desc": "עובדאללה אל־מהדי, שטען שהוא צאצא של פאטמה בת מוחמד, הוכרז לח׳ליף בתוניסיה בתמיכת הברברים הכתאמה. הפאטמים היו שיעים־אסמאעיליים, ובהמשך כבשו את מצרים. הם התחרו בעבאסים על ההנהגה של העולם המוסלמי.",
    "rank": 577
  },
  {
    "id": "mod_haitiindep",
    "deck": "anchors",
    "title": "הכרזת העצמאות של האיטי",
    "start": 1804,
    "end": 1804,
    "date": "1804",
    "place": "גונאיב, האיטי",
    "lat": 19.45,
    "lon": -72.69,
    "desc": "ז׳אן־ז׳אק דסלין הכריז על עצמאות האי והחזיר לו את שמו הטאינו, האיטי. זו הייתה המדינה הראשונה באמריקה הלטינית שהשיגה עצמאות והרפובליקה השחורה הראשונה בעולם. המעצמות סירבו להכיר בה, וצרפת הכירה בה רק ב־1825 תמורת פיצויים כבדים.",
    "rank": 578
  },
  {
    "id": "anq_sima_qian",
    "deck": "anchors",
    "title": "השי ג׳י של סימה צ׳יאן",
    "start": -91,
    "end": -91,
    "date": "בערך 91 לפנה״ס",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.9,
    "desc": "ההיסטוריון סימה צ׳יאן השלים את ״רשומות ההיסטוריון הגדול״, סקירה של תולדות סין מהעת העתיקה עד זמנו. הוא כתב אותה גם לאחר שנענש בסירוס על שהגן על מצביא שנפל בשבי. היצירה נעשתה מופת לכתיבת ההיסטוריה הסינית.",
    "rank": 579
  },
  {
    "id": "med_lalibela",
    "deck": "anchors",
    "title": "כנסיות הסלע של לליבלה",
    "start": 1200,
    "end": 1225,
    "date": "בערך ⁦1200–1225⁩",
    "place": "לליבלה, אתיופיה",
    "lat": 12.032,
    "lon": 39.047,
    "desc": "לפי המסורת הורה המלך לליבלה משושלת זאגווה לחצוב ברמה האתיופית אחת עשרה כנסיות מתוך סלע חי, כ״ירושלים חדשה״ לעולי הרגל. הכנסיות, ובהן בית גיאורגיס בצורת צלב, חצובות מלמעלה למטה. עד היום הן מרכז צליינות של הנצרות האתיופית.",
    "rank": 580
  },
  {
    "id": "mod_hungary1848",
    "deck": "anchors",
    "title": "המהפכה ההונגרית נגד האימפריה האוסטרית",
    "start": 1848,
    "end": 1848,
    "date": "1848",
    "place": "בודפשט, הונגריה",
    "lat": 47.5,
    "lon": 19.04,
    "desc": "בעקבות המהפכה בפריז קמו הונגרים בהנהגת לאיוש קושוט נגד שלטון בית הבסבורג, וחוקקו חוקי אפריל, שהביאו לביטול הצמיתות. אוסטריה, בעזרת צבא רוסי, דיכאה את המרד ב־1849. קושוט ברח לגלות, והמהפכה נותרה סמל לאומי.",
    "rank": 581
  },
  {
    "id": "anq_vandals_carthage",
    "deck": "anchors",
    "title": "כיבוש קרתגו בידי הוונדלים",
    "start": 439,
    "end": 439,
    "date": "439 לספירה",
    "place": "קרתגו, טוניסיה",
    "lat": 36.85,
    "lon": 10.32,
    "desc": "גייזריק, מלך הוונדלים, כבש את קרתגו, העיר השנייה בגודלה במערב, ללא קרב. הוא הקים ממלכה שמימנה שוד ים ושיבשה את אספקת התבואה לרומא. הממלכה קיימה עד שנת 534. כיבוש המחוז האפריקאי חיזק את מעמדם והפך אותם לשחקן ימי מרכזי, ושנים אחר כך שדדו הוונדלים את רומא.",
    "rank": 582
  },
  {
    "id": "med_tanegashima",
    "deck": "anchors",
    "title": "הרובים הראשונים ביפן",
    "start": 1543,
    "end": 1543,
    "date": "1543",
    "place": "טנגשימה, יפן",
    "lat": 30.6,
    "lon": 131,
    "desc": "ספינה עם סוחרים פורטוגלים עגנה באי טנגשימה, ומושל המקום רכש מהם רובי פתיל. חרשים יפנים העתיקו אותם במהירות וייצרו אלפים. הנשק החדש שינה את שיטות הלחימה ותרם לאיחוד יפן בסוף המאה ה־16.",
    "rank": 583
  },
  {
    "id": "mod_berlin_conf",
    "deck": "anchors",
    "title": "ועידת ברלין והחלוקה של אפריקה",
    "start": 1884,
    "end": 1885,
    "date": "⁦1884–1885⁩",
    "place": "ברלין, גרמניה",
    "lat": 52.51,
    "lon": 13.38,
    "desc": "נציגי מעצמות אירופה, ארצות הברית והאימפריה העות׳מאנית התכנסו בברלין כדי להסדיר את התחרות על אפריקה. הם קבעו כללים לתביעה לשטחים, והכירו בשליטת ליאופולד השני בקונגו. אפריקאים לא השתתפו. עד 1914 כמעט כל היבשת נכבשה, והגבולות הנוכחיים הם במידה רבה ירושה מתקופה זו.",
    "rank": 584
  },
  {
    "id": "anq_ugarit",
    "deck": "anchors",
    "title": "האלפבית באוגרית",
    "start": -1400,
    "end": -1400,
    "date": "בערך 1400 לפנה״ס",
    "place": "אוגרית, סוריה",
    "lat": 35.6,
    "lon": 35.78,
    "desc": "בעיר הנמל אוגרית נכתב אלפבית בן שלושים סימנים מסמריים. כתב זה שימש לכתיבת ספרות מיתולוגית ואדמיניסטרציה. הלוחות שהתגלו בתל ראס שמרה מעידים על קרבה לשפה העברית ועל דת הכנענית, וחשפו מקורות לשירה במקרא.",
    "rank": 585
  },
  {
    "id": "mod_saintdomingue",
    "deck": "anchors",
    "title": "מרד העבדים בסן־דומינג והמהפכה ההאיטית",
    "start": 1791,
    "end": 1804,
    "date": "⁦1791–1804⁩",
    "place": "קאפ־אַיִסיֵן, האיטי",
    "lat": 19.76,
    "lon": -72.2,
    "desc": "בקרב העבדים של המושבה הצרפתית העשירה ביותר בסוכר פרץ מרד גדול בצפון האי. טוסן לוברטור וממשיכיו, ובהם ז׳אן־ז׳אק דסלין, הביסו כוחות צרפתיים, ספרדיים ובריטיים. זו המהפכה היחידה של עבדים שהצליחה, והיא הובילה להכרזת העצמאות של האיטי ב־1804.",
    "rank": 586
  },
  {
    "id": "anq_thebes_sack",
    "deck": "anchors",
    "title": "אשור בוזזת את תבי",
    "start": -663,
    "end": -663,
    "date": "בערך 663 לפנה״ס",
    "place": "תבי, מצרים",
    "lat": 25.72,
    "lon": 32.66,
    "desc": "אשורבניפל, מלך אשור, שדד את תבי, העיר הקדושה של אמון, אחרי שהכושים חזרו להתקיף את מצרים. מקדשי העיר נבזזו ואובליסקים הועברו לנינוה. המאורע הרעיש את העולם הקדום והוזכר בספר נחום.",
    "rank": 587
  },
  {
    "id": "med_toledo",
    "deck": "anchors",
    "title": "אלפונסו השישי כובש את טולדו",
    "start": 1085,
    "end": 1085,
    "date": "1085",
    "place": "טולדו, ספרד",
    "lat": 39.86,
    "lon": -4.02,
    "desc": "מלך קסטיליה ולאון כבש את טולדו, אחת הערים הגדולות של אנדלוס, ממלכת הטאיפה המוסלמית. הכיבוש היה הצלחה גדולה של הרקונקיסטה והעביר את הגבול הדרומה. בטולדו המשיכו לפעול מתרגמים מערבית ללטינית, והעיר הפכה למרכז העברת ידע.",
    "rank": 588
  },
  {
    "id": "mod_serfs",
    "deck": "anchors",
    "title": "ביטול הצמיתות ברוסיה",
    "start": 1861,
    "end": 1861,
    "date": "1861",
    "place": "סנקט פטרבורג, רוסיה",
    "lat": 59.93,
    "lon": 30.33,
    "desc": "הצאר אלכסנדר השני פרסם מניפסט ששחרר כעשרים ושניים מיליון צמיתים. האיכרים קיבלו אדמות, אך נדרשו לשלם עליהן תשלומים כבדים לאצולה ולמדינה, והמצב הכלכלי נשאר קשה. ביטול הצמיתות היה העיקרי בין ״הרפורמות הגדולות״ של אלכסנדר.",
    "rank": 589
  },
  {
    "id": "anq_armenia",
    "deck": "anchors",
    "title": "אימוץ הנצרות בארמניה",
    "start": 301,
    "end": 314,
    "date": "בערך ⁦301–314⁩ לספירה",
    "place": "וגרשפט, ארמניה",
    "lat": 40.16,
    "lon": 44.29,
    "desc": "לפי המסורת גריגוריוס המאיר הטביל את המלך טרדת השלישי ועשה את הנצרות לדת הרשמית של ארמניה. התאריך המדויק שנוי במחלוקת. ארמניה נחשבת על כן למדינה הראשונה שאימצה את הנצרות כדת מדינה. הכנסייה הארמנית האפוסטולית נשארה עד היום עצמאית ובעלת מסורת ייחודית.",
    "rank": 590
  },
  {
    "id": "med_hideyoshi",
    "deck": "anchors",
    "title": "הידיושי מאחד את יפן",
    "start": 1590,
    "end": 1590,
    "date": "1590",
    "place": "אודווארה, יפן",
    "lat": 35.25,
    "lon": 139.15,
    "desc": "טויוטומי הידיושי, איכר שעלה לגדולה, כבש את מעוז משפחת הוג׳ו באודווארה והשלים איחוד יפן אחרי כמאה שנות מלחמות אזרחים. הוא ערך מדידת קרקעות, פירוק נשק מהאיכרים ויצר הפרדה בין סמוראים לאיכרים. אחריו קם שלטון הטוקוגאווה.",
    "rank": 591
  },
  {
    "id": "mod_nz_suffrage",
    "deck": "anchors",
    "title": "זכות הצבעה לנשים בניו זילנד",
    "start": 1893,
    "end": 1893,
    "date": "1893",
    "place": "וולינגטון, ניו זילנד",
    "lat": -41.29,
    "lon": 174.78,
    "desc": "בספטמבר 1893 חתם המושל על חוק שהעניק לנשים בניו זילנד, כולל נשות המאורי, זכות הצבעה בבחירות הארציות. בהנהגת קייט שפרד ואחרות נאספו כ־30 אלף חתימות על עצומה. ניו זילנד הייתה המדינה הראשונה בעולם שהעניקה לנשים זכות בחירה כללית, אם כי בלי זכות לכהן בפרלמנט.",
    "rank": 592
  },
  {
    "id": "anq_hattusa",
    "deck": "anchors",
    "title": "החתים מקימים את חתושה",
    "start": -1650,
    "end": -1650,
    "date": "בערך 1650 לפנה״ס",
    "place": "חתושה, טורקיה",
    "lat": 40.02,
    "lon": 34.61,
    "desc": "המלך חתושילי הראשון הפך את חתושה שבמרכז אנטוליה לבירת הממלכה החתית. החתים דיברו שפה הודו־אירופית, מן העתיקות שנכתבו, ושלטו באנטוליה כאלף שנים. הבירה הייתה מבוצרת בחומות ובשערים עם פסלי אריות וספינקסים.",
    "rank": 593
  },
  {
    "id": "med_yarmouk",
    "deck": "anchors",
    "title": "קרב הירמוך",
    "start": 636,
    "end": 636,
    "date": "636 לספירה",
    "place": "נהר הירמוך, סוריה וירדן",
    "lat": 32.78,
    "lon": 35.95,
    "desc": "צבא מוסלמי בפיקוד ח׳אלד בן אל־ולִיד ניצח את צבא ביזנטיון בקרב ליד נהר הירמוך. הניצחון הביא לאובדן סוריה וארץ ישראל בידי הביזנטים, ופתח את הדרך לכיבושי הח׳ליפות. הוא נחשב לאחד הקרבות המכריעים בהיסטוריה של הים התיכון.",
    "rank": 594
  },
  {
    "id": "mod_leipzig",
    "deck": "anchors",
    "title": "קרב העמים בלייפציג",
    "start": 1813,
    "end": 1813,
    "date": "1813",
    "place": "לייפציג, גרמניה",
    "lat": 51.34,
    "lon": 12.37,
    "desc": "צבאות רוסיה, אוסטריה, פרוסיה ושוודיה הביסו את נפוליאון בקרב הגדול ביותר באירופה עד מלחמת העולם הראשונה, ששמו המוכר קרב העמים. נפוליאון נסוג לצרפת ונאלץ לוותר על שליטה בגרמניה. ב־1814 התפטר ונשלח לאלבה.",
    "rank": 595
  },
  {
    "id": "anq_nimrud",
    "deck": "anchors",
    "title": "אשורנצירפל השני מקים את נמרוד",
    "start": -879,
    "end": -879,
    "date": "בערך 879 לפנה״ס",
    "place": "נמרוד, עיראק",
    "lat": 36.1,
    "lon": 43.33,
    "desc": "המלך האשורי אשורנצירפל השני הפך את נמרוד לבירה והקים בה ארמון ענק ומקדשים. הוא חגג את חנוכת הארמון במשתה לעשרות אלפי אורחים. בימיו התפשטה האימפריה האשורית לאורך הפרת ולכיוון הלבנט, תוך הפחדה צבאית שיטתית.",
    "rank": 596
  },
  {
    "id": "med_heian",
    "deck": "anchors",
    "title": "העברת הבירה להייאן־קיו",
    "start": 794,
    "end": 794,
    "date": "794 לספירה",
    "place": "קיוטו, יפן",
    "lat": 35.01,
    "lon": 135.77,
    "desc": "הקיסר קאנמו העביר את הבירה מנארה לעיר חדשה, הייאן־קיו, שהיא קיוטו. העיר נשארה בירת הקיסרים כמעט אלף שנה. תקופת הייאן הייתה זמן של פריחת התרבות החצרנית והספרות.",
    "rank": 597
  },
  {
    "id": "anq_delphi",
    "deck": "anchors",
    "title": "המלחמה הקדושה הראשונה על דלפי",
    "start": -591,
    "end": -591,
    "date": "בערך 591 לפנה״ס",
    "place": "דלפי, יוון",
    "lat": 38.48,
    "lon": 22.5,
    "desc": "ברית של ערים יווניות נלחמה בקריסה, עיר שניסתה לגבות מס מעולי הרגל למקדש אפולו בדלפי. הניצחון חיזק את מעמדה של דלפי כמרכז דתי שאינו כפוף לעיר אחת. אל מקדש אפולו פנו מלכים וערים לקבלת נבואות. התאריך מקורב.",
    "rank": 598
  },
  {
    "id": "med_panipat",
    "deck": "anchors",
    "title": "קרב פאניפאט הראשון",
    "start": 1526,
    "end": 1526,
    "date": "1526",
    "place": "פאניפאט, הודו",
    "lat": 29.39,
    "lon": 76.97,
    "desc": "באבר, צאצא של תימור וג׳ינגיס חאן ושליט קאבול, הביס את הסולטן איברהים לודי בעזרת תותחים וחיילי רובים. הניצחון פתח את דרכו לכיבוש צפון הודו והיה ראשית האימפריה המוגולית. האימפריה שלטה בהודו יותר מ־300 שנה.",
    "rank": 599
  },
  {
    "id": "mod_darwin_2",
    "deck": "anchors",
    "title": "ההפצצה על דרווין",
    "start": 1942,
    "end": 1942,
    "date": "1942",
    "place": "דרווין, אוסטרליה",
    "lat": -12.46,
    "lon": 130.84,
    "desc": "ב־19 בפברואר תקפו כ־240 מטוסים יפניים את דרווין שבצפון אוסטרליה, בהתקפה האווירית הגדולה ביותר על המדינה. כ־240 בני אדם נהרגו, ספינות ומתקנים נהרסו. היו עוד כ־60 התקפות על דרווין ועל אזורים בצפון, והאירוע שימש עדות לאיום היפני על אוסטרליה.",
    "rank": 600
  },
  {
    "id": "anq_gupta",
    "deck": "anchors",
    "title": "תחילת שלטון שושלת גופטה",
    "start": 320,
    "end": 320,
    "date": "320 לספירה",
    "place": "פאטליפוטרה, הודו",
    "lat": 25.61,
    "lon": 85.14,
    "desc": "צ׳נדרגופטה הראשון הקים את שושלת גופטה בצפון הודו והיה לשליט ממלכה גדולה. תקופת השושלת נחשבת לתור זהב של התרבות ההודית, עם התפתחות המתמטיקה, האסטרונומיה, הספרות והאמנות. מושג האפס כספרה התפתח בסביבה זו.",
    "rank": 601
  },
  {
    "id": "med_buddhismjapan",
    "deck": "anchors",
    "title": "הבודהיזם מגיע ליפן",
    "start": 552,
    "end": 552,
    "date": "בערך 552 לספירה",
    "place": "אסוקה, יפן",
    "lat": 34.47,
    "lon": 135.82,
    "desc": "לפי הכרוניקות היפניות שלח מלך בקצ׳ה פסל בודהה וסוטרות לחצר היפנית. סכסוך בין משפחות אצולה על קבלת הדת החדשה הסתיים בניצחון התומכים. הבודהיזם נעשה דת מרכזית ביפן.",
    "rank": 602
  },
  {
    "id": "mod_restoration",
    "deck": "anchors",
    "title": "חידוש המלוכה באנגליה",
    "start": 1660,
    "end": 1660,
    "date": "1660",
    "place": "לונדון, אנגליה",
    "lat": 51.51,
    "lon": -0.13,
    "desc": "לאחר מותו של אוליבר קרומוול ואי־יציבות פוליטית, הוזמן צ׳רלס השני, בנו של המלך שהוצא להורג, לשוב מהגלות ולשבת על כס המלכות. הפרלמנט שימר חלק גדול מכוחו, והחידוש סימן את סוף הניסוי הרפובליקאי באנגליה. הבית והתיאטראות נפתחו מחדש לאחר שנות הפוריטנים.",
    "rank": 603
  },
  {
    "id": "anq_nebra",
    "deck": "anchors",
    "title": "דיסקת השמיים מנברה",
    "start": -1600,
    "end": -1600,
    "date": "בערך 1600 לפנה״ס",
    "place": "נברה, גרמניה",
    "lat": 51.285,
    "lon": 11.525,
    "desc": "בגרמניה נטמנה דיסקת ברונזה ועליה סמלי זהב של שמש, ירח וכוכבים. היא נחשבת לתיאור הקדום ביותר של השמיים. התגלתה בידי שודדי קברים ב־1999, ויש בה ראיות לידע אסטרונומי בקרב חברות אירופה בתקופת הברונזה.",
    "rank": 604
  },
  {
    "id": "med_cordoba929",
    "deck": "anchors",
    "title": "עבד אל־רחמן השלישי מכריז על ח׳ליפות קורדובה",
    "start": 929,
    "end": 929,
    "date": "929 לספירה",
    "place": "קורדובה, ספרד",
    "lat": 37.89,
    "lon": -4.78,
    "desc": "האמיר עבד אל־רחמן השלישי הכריז על עצמו כח׳ליף, כשלא הכיר בעבאסים ובפאטמים. קורדובה הגיעה לשיא פריחתה: ספריות, מסגדים ומדעים. היהודים והנוצרים חיו בה כמיעוטים מוגנים, והעיר נחשבה לגדולה באירופה.",
    "rank": 605
  },
  {
    "id": "mod_sevastopol",
    "deck": "anchors",
    "title": "המצור על סבסטופול",
    "start": 1854,
    "end": 1855,
    "date": "⁦1854–1855⁩",
    "place": "סבסטופול, קרים",
    "lat": 44.6,
    "lon": 33.53,
    "desc": "בעת מלחמת קרים צרו צבאות בריטניה, צרפת והאימפריה העות׳מאנית על בסיס הצי הרוסי בים השחור במשך כשנה. מחלות והקור הרגו אלפי חיילים. נייטינגייל חוללה רפורמה בבתי החולים הצבאיים. נפילת העיר הובילה להסכם פריז ב־1856.",
    "rank": 606
  },
  {
    "id": "anq_piye",
    "deck": "anchors",
    "title": "כוש כובשת את מצרים",
    "start": -744,
    "end": -744,
    "date": "בערך 744 לפנה״ס",
    "place": "נפתה, סודן",
    "lat": 18.54,
    "lon": 31.83,
    "desc": "פיענחי, מלך כוש, יצא מבירתו נפתה שבסודן והחל לכבוש את מצרים. הוא ייסד את השושלת ה־25, ששלטה בנילוס כמעט מאה שנה. השליטים הכושיים אימצו את מנהגי מצרים וחידשו את בניית הפירמידות.",
    "rank": 607
  },
  {
    "id": "med_nachmanides",
    "deck": "anchors",
    "title": "הוויכוח של ברצלונה",
    "start": 1263,
    "end": 1263,
    "date": "1263",
    "place": "ברצלונה, ספרד",
    "lat": 41.385,
    "lon": 2.173,
    "desc": "בפקודת המלך חיימה הראשון מאראגון התקיים ויכוח פומבי בין הרמב״ן, מגדולי חכמי ספרד, לבין פבלו כריסטיאני, יהודי שהתנצר. הרמב״ן דיבר בחופשיות, והמלך כיבד אותו, אך בעקבות הוויכוח נאלץ לעזוב את ספרד. בהמשך עלה לארץ ישראל.",
    "rank": 608
  },
  {
    "id": "mod_indonesia",
    "deck": "anchors",
    "title": "הכרזת העצמאות של אינדונזיה",
    "start": 1945,
    "end": 1949,
    "date": "⁦1945–1949⁩",
    "place": "ג׳קרטה, אינדונזיה",
    "lat": -6.2,
    "lon": 106.85,
    "desc": "ב־17 באוגוסט 1945, כשיפן נכנעה, הכריזו סוקרנו וחתא על עצמאות אינדונזיה. הולנד ניסתה להחזיר את שלטונה, ובמלחמה של ארבע שנים נהרגו רבים. הלחץ הבין־לאומי הוביל להכרה הולנדית בעצמאות בסוף 1949, והמדינה הפכה לגדולה במדינות האסיאתיות שהשתחררו משלטון קולוניאלי.",
    "rank": 609
  },
  {
    "id": "anq_antoniniana",
    "deck": "anchors",
    "title": "צו קראקלה",
    "start": 212,
    "end": 212,
    "date": "212 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.49,
    "desc": "הקיסר קראקלה העניק אזרחות רומית לכל תושבי האימפריה החופשיים. לפי כמה היסטוריונים הצו נועד להרחיב את בסיס המס. פעולה זו חתמה על התהליך שבו רומא הפכה מעיר־מדינה לממלכה אחת של אזרחים. בכך נעשה ההבדל בין אזרח רומי לנתין פרובינקיה פחות משמעותי.",
    "rank": 610
  },
  {
    "id": "med_imjin",
    "deck": "anchors",
    "title": "פלישות הידיושי לקוריאה",
    "start": 1592,
    "end": 1598,
    "date": "⁦1592–1598⁩",
    "place": "פוסאן, קוריאה",
    "lat": 35.1,
    "lon": 129.04,
    "desc": "הידיושי שלח צבא ענק לכבוש את קוריאה, שמעבר לה ביקש להגיע לסין. הפולשים הגיעו עד פיונגיאנג, אך צבא מינג, מיליציות מקומיות והאדמירל יי סונסין, בעזרת ספינות הצב, שיבשו אותם. עם מות הידיושי ב־1598 נסוגו היפנים.",
    "rank": 611
  },
  {
    "id": "mod_erie",
    "deck": "anchors",
    "title": "פתיחת תעלת אירי",
    "start": 1825,
    "end": 1825,
    "date": "1825",
    "place": "באפלו, ארה״ב",
    "lat": 42.89,
    "lon": -78.88,
    "desc": "תעלה באורך של כ־580 ק״מ חיברה בין האגמים הגדולים לנהר ההדסון וגרמה לניו יורק להפוך לעיר הגדולה בארצות הברית. היא הוזילה את שינוע הסחורות לאין שיעור והאיצה את ההתיישבות במערב. התעלה פתחה עידן של בניית תעלות ורכבות.",
    "rank": 612
  },
  {
    "id": "anq_ahmose",
    "deck": "anchors",
    "title": "גירוש ההיקסוס ממצרים",
    "start": -1550,
    "end": -1550,
    "date": "בערך 1550 לפנה״ס",
    "place": "אוואריס, מצרים",
    "lat": 30.79,
    "lon": 31.82,
    "desc": "במשך כ־100 שנה שלטו ההיקסוס, עמים משמיים, בדלתת הנילוס מבירתם אוואריס. אחמוסה הראשון, מלך תבי, גירש אותם ואיחד שוב את מצרים. עם עלייתו החלה הממלכה החדשה, תקופת השיא של האימפריה המצרית.",
    "rank": 613
  },
  {
    "id": "med_vandalwar",
    "deck": "anchors",
    "title": "בליסריוס כובש את ממלכת הוונדלים",
    "start": 533,
    "end": 534,
    "date": "⁦533–534⁩ לספירה",
    "place": "קרתגו, צפון אפריקה",
    "lat": 36.85,
    "lon": 10.32,
    "desc": "יוסטיניאנוס שלח את המצביא בליסריוס בצי קטן אל צפון אפריקה. בתוך חודשים אחדים הביס הצבא הביזנטי את הוונדלים וכבש את קרתגו. המסע פתח את מסעות הכיבוש מחדש של יוסטיניאנוס ברחבי הים התיכון המערבי, ובהם איטליה.",
    "rank": 614
  },
  {
    "id": "mod_rome1870",
    "deck": "anchors",
    "title": "כיבוש רומא והשלמת איחוד איטליה",
    "start": 1870,
    "end": 1870,
    "date": "1870",
    "place": "רומא, איטליה",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "חיילים איטלקים פרצו לרומא בפורטה פיה לאחר שהצבא הצרפתי שהגן עליה התפנה למלחמה מול פרוסיה. רומא הפכה בירת איטליה והאפיפיור איבד את שלטונו הארצי. האפיפיור נותר ב״אסיר הוותיקן״ עד הסכמי לטרן ב־1929.",
    "rank": 615
  },
  {
    "id": "anq_necho_africa",
    "deck": "anchors",
    "title": "הפלגת הפיניקים סביב אפריקה",
    "start": -600,
    "end": -600,
    "date": "בערך 600 לפנה״ס",
    "place": "ים סוף, מצרים",
    "lat": 29.97,
    "lon": 32.55,
    "desc": "לפי הרודוטוס הורה פרעה נכו השני לספני פיניקים להפליג מים סוף ולחזור דרך עמודי הרקולס, והם עשו את המסע בשלוש שנים. העדות היחידה היא של הרודוטוס עצמו, שאף הוא הטיל ספק בחלק מפרטיה, ולכן ההפלגה נחשבת לאפשרית אך לא מוכחת.",
    "rank": 616
  },
  {
    "id": "med_cahokia",
    "deck": "anchors",
    "title": "צמיחת קאהוקיה",
    "start": 1050,
    "end": 1050,
    "date": "בערך 1050",
    "place": "קאהוקיה, אילינוי (ארצות הברית)",
    "lat": 38.66,
    "lon": -90.06,
    "desc": "בעמק המיסיסיפי צמחה עיר גדולה של תרבות המיסיסיפי, עם תלי אדמה ענקיים ואוכלוסייה של אלפים רבים. זו הייתה העיר הגדולה ביותר בצפון אמריקה שמצפון למקסיקו, ובהמשך נעזבה בהדרגה.",
    "rank": 617
  },
  {
    "id": "mod_federation",
    "deck": "anchors",
    "title": "הקמת הפדרציה האוסטרלית",
    "start": 1901,
    "end": 1901,
    "date": "1901",
    "place": "סידני, אוסטרליה",
    "lat": -33.9,
    "lon": 151.23,
    "desc": "ב־1 בינואר חוברו שש המושבות הבריטיות ביבשת לפדרציה אחת, חבר העמים של אוסטרליה, עם חוקה ופרלמנט פדרלי. הטקס נערך בסידני, ובירת הארץ הועברה בהמשך לקנברה. האבוריג׳ינים לא זכו אז לזכויות אזרח מלאות, והן ניתנו רק בהדרגה במאה העשרים.",
    "rank": 618
  },
  {
    "id": "anq_yellow_turban",
    "deck": "anchors",
    "title": "מרד הטורבנים הצהובים",
    "start": 184,
    "end": 184,
    "date": "184 לספירה",
    "place": "ג׳ולו, חבל הביי, סין",
    "lat": 37.3,
    "lon": 115,
    "desc": "תנועה דתית אוטופית בראשות ג׳אנג ג׳יאו, שתלמידיה חבשו עטיפות ראש צהובות, התקוממה באלפים נגד ממשלת האן המאוחרת. המרד דוכא אך החלש את השלטון המרכזי והעלה לכוח מצביאים אזוריים, ובהם קאו קאו. אחרי הדיכוי המשיכו מצביאים לשלוט בשטחים שבהם ניצחו, וכך הואצה פגיעתה של האימפריה.",
    "rank": 619
  },
  {
    "id": "med_fatehpur",
    "deck": "anchors",
    "title": "פתחפור סיקרי",
    "start": 1571,
    "end": 1585,
    "date": "⁦1571–1585⁩",
    "place": "פתחפור סיקרי, הודו",
    "lat": 27.09,
    "lon": 77.66,
    "desc": "הקיסר המוגולי אכבר הקים בירה חדשה, בסגנון אדריכלי המשלב מסורות הודיות ופרסיות. אכבר ניסה ליצור חברה משותפת להינדים ולמוסלמים, ובהם מדיניות סובלנות כלפי כל הדתות. הבירה נעזבה כעבור שנים אחדות, כנראה בשל מחסור במים.",
    "rank": 620
  },
  {
    "id": "mod_hawaii",
    "deck": "anchors",
    "title": "איחוד איי הוואי בידי קמהמהה",
    "start": 1810,
    "end": 1810,
    "date": "1810",
    "place": "הונולולו, הוואי",
    "lat": 21.31,
    "lon": -157.86,
    "desc": "קמהמהה הראשון, בעזרת נשק ויועצים אירופים, כבש את רוב האיים, וב־1810 הסכים קאומואליי, שליט קאואי, להכיר בריבונותו. כך קמה ממלכת הוואי המאוחדת, ששרדה כמעט מאה שנה. המלכות ניהלה סחר עם ספינות לווייתנים ועם סוחרי עץ סנדל.",
    "rank": 621
  },
  {
    "id": "anq_muye",
    "deck": "anchors",
    "title": "קרב מויה ועליית שושלת ג׳ואו",
    "start": -1046,
    "end": -1046,
    "date": "בערך 1046 לפנה״ס",
    "place": "מויה, סין",
    "lat": 35.3,
    "lon": 114,
    "desc": "המלך וו מג׳ואו הביס בקרב מויה את שליט שושלת שאנג האחרון. שושלת ג׳ואו, שהחלה כך, שלטה בסין כשמונה מאות שנה, אם כי בהמשך רק באופן נומינלי. היא פיתחה את הרעיון של ״מנדט שמים״, לפיו שליט צודק מקבל את סמכותו מן השמים.",
    "rank": 622
  },
  {
    "id": "med_ramla",
    "deck": "anchors",
    "title": "הסכם הרמלה בין ריצ׳רד לסלאח א־דין",
    "start": 1192,
    "end": 1192,
    "date": "1192",
    "place": "רמלה, ישראל",
    "lat": 31.93,
    "lon": 34.87,
    "desc": "אחרי מסע הצלב השלישי הסכימו ריצ׳רד לב הארי וסלאח א־דין על שביתת נשק. ירושלים נשארה בידי המוסלמים, אך הצלבנים שמרו על רצועת החוף מצור ליפו, ולנוצרים הותר לבקר בעיר. כך הסתיים מסע הצלב.",
    "rank": 623
  },
  {
    "id": "mod_nanjing",
    "deck": "anchors",
    "title": "הסכם נאנג׳ינג",
    "start": 1842,
    "end": 1842,
    "date": "1842",
    "place": "נאנג׳ינג, סין",
    "lat": 32.06,
    "lon": 118.78,
    "desc": "בתום מלחמת האופיום הראשונה אילצו הבריטים את שושלת צ׳ינג לחתום על הסכם: הונג קונג ניתנה לבריטניה, חמישה נמלים נפתחו לסחר זר, והוטל פיצוי כבד. זה היה הראשון בסדרת ״ההסכמים הבלתי שווים״, ותחילתה של תקופה שהסינים מכנים ״מאת שנות ההשפלה״.",
    "rank": 624
  },
  {
    "id": "anq_esarhaddon",
    "deck": "anchors",
    "title": "אסרחדון כובש את מצרים",
    "start": -671,
    "end": -671,
    "date": "בערך 671 לפנה״ס",
    "place": "ממפיס, מצרים",
    "lat": 29.85,
    "lon": 31.25,
    "desc": "אסרחדון, מלך אשור, כבש את ממפיס וגירש את תהרקה מלך כוש, ובכך הפך את מצרים לחלק מהאימפריה האשורית. אשור שלטה כעת מהמפרץ הפרסי עד הנילוס, שיא כוחה. השלטון במצרים לא החזיק מעמד זמן רב.",
    "rank": 625
  },
  {
    "id": "med_jews_1391",
    "deck": "anchors",
    "title": "הפרעות ביהודי ספרד",
    "start": 1391,
    "end": 1391,
    "date": "1391",
    "place": "סביליה, ספרד",
    "lat": 37.39,
    "lon": -5.99,
    "desc": "בעקבות דרשות מתססות בסביליה פרצו גלי אלימות נגד קהילות יהודיות ברחבי ספרד. קהילות רבות נפגעו, ורבים מהיהודים נאלצו להתנצר. אותם מומרים, ה״קונברסוס״, יצרו בעיה חברתית ודתית שהובילה בסופו של דבר לאינקוויזיציה ולגירוש.",
    "rank": 626
  },
  {
    "id": "mod_adwa",
    "deck": "anchors",
    "title": "קרב עדווה",
    "start": 1896,
    "end": 1896,
    "date": "1896",
    "place": "עדווה, אתיופיה",
    "lat": 14.16,
    "lon": 38.9,
    "desc": "ב־1 במרס הביס צבא אתיופי גדול בפיקוד הקיסר מנליק השני כוח איטלקי שביקש לכבוש את המדינה. אלפי חיילים איטלקים נהרגו או נשבו. אתיופיה שמרה על עצמאותה, וכמעט לבדה בין מדינות אפריקה, ונצחונה הפך לסמל לתנועות נגד קולוניאליזם.",
    "rank": 627
  },
  {
    "id": "anq_julian_temple",
    "deck": "anchors",
    "title": "ניסיון בניית המקדש בימי יוליאנוס",
    "start": 363,
    "end": 363,
    "date": "363 לספירה",
    "place": "ירושלים, פלשתינה",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "הקיסר יוליאנוס, האחרון שדגל בפגניות, התיר ליהודים לבנות מחדש את בית המקדש בירושלים. לפי מקורות עתיקים הבנייה נקטעה, ובהם סיפורים על אש ועל רעידת אדמה. יוליאנוס נהרג זמן קצר אחר כך, בקרב מול הפרסים, והתוכנית נגנזה.",
    "rank": 628
  },
  {
    "id": "med_safavid",
    "deck": "anchors",
    "title": "איסמעיל הראשון מייסד את שושלת הספוויים",
    "start": 1501,
    "end": 1501,
    "date": "1501",
    "place": "תבריז, איראן",
    "lat": 38.08,
    "lon": 46.29,
    "desc": "איסמעיל, צעיר ממסדר צופי, כבש את תבריז והכריז על עצמו שאה. הוא הפך את האסלאם השיעי, בענף השנים־עשר האימאמים, לדת הרשמית בפרס. המתח בין איראן השיעית לשכנותיה הסוניות, ובראשן העות׳מאנים, עיצב את המזרח התיכון בדורות הבאים.",
    "rank": 629
  },
  {
    "id": "mod_raffles",
    "deck": "anchors",
    "title": "הקמת סינגפור בידי סטמפורד ראפלס",
    "start": 1819,
    "end": 1819,
    "date": "1819",
    "place": "סינגפור",
    "lat": 1.29,
    "lon": 103.85,
    "desc": "פקיד חברת הודו המזרחית הבריטית סטמפורד ראפלס חתם על הסכם עם שליט מקומי והקים תחנת סחר בנמל שבקצה חצי האי המלאי. הנמל הוכרז נמל חופשי ומשך מהגרים וסוחרים מרחבי אסיה. סינגפור הפכה בהמשך לאחד הנמלים החשובים בעולם.",
    "rank": 630
  },
  {
    "id": "anq_hittites_babylon",
    "deck": "anchors",
    "title": "החתים כובשים את בבל",
    "start": -1595,
    "end": -1595,
    "date": "בערך 1595 לפנה״ס",
    "place": "בבל, מסופוטמיה",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "המלך החתי מורשילי הראשון יצא ממרכז אנטוליה לדרום, כבש את בבל והביא לסופה של שושלת חמורבי. הוא שב לארצו ונרצח, ובבל נפלה בידי הכשים. התאריך מבוסס על הכרונולוגיה האמצעית של המזרח הקדום.",
    "rank": 631
  },
  {
    "id": "med_saadia",
    "deck": "anchors",
    "title": "סעדיה גאון מתמנה לראש ישיבת סורא",
    "start": 928,
    "end": 928,
    "date": "928 לספירה",
    "place": "סורא, בבל (עיראק)",
    "lat": 32.4,
    "lon": 44.4,
    "desc": "סעדיה בן יוסף, יליד מצרים, מונה לגאון של ישיבת סורא, בין המנהיגים החשובים של יהדות בבל. הוא כתב בערבית פילוסופיה, תרגם את התנ״ך לערבית ופעל נגד הקראים. ספרו ״האמונות והדעות״ הוא אחד מספרי הפילוסופיה היהודית הראשונים.",
    "rank": 632
  },
  {
    "id": "mod_waitangi",
    "deck": "anchors",
    "title": "הסכם ווייטאנגי",
    "start": 1840,
    "end": 1840,
    "date": "1840",
    "place": "ווייטאנגי, ניו זילנד",
    "lat": -35.27,
    "lon": 174.08,
    "desc": "נציגי הכתר הבריטי וכמה עשרות ראשי חמולות מאורים חתמו על הסכם שהעניק לבריטניה ריבונות. נוסח ההסכם באנגלית ובמאורית נבדל בנקודות מרכזיות, והוא עדיין נתון לוויכוח. ההסכם הפך לבסיס של מעמד המאורים בניו זילנד ושל תביעות על אדמות.",
    "rank": 633
  },
  {
    "id": "anq_qarqar",
    "deck": "anchors",
    "title": "קרב קרקר",
    "start": -853,
    "end": -853,
    "date": "בערך 853 לפנה״ס",
    "place": "קרקר, סוריה",
    "lat": 35.8,
    "lon": 36.4,
    "desc": "שלמנאסר השלישי מלך אשור התמודד בקרקר עם קואליציה של מלכי ארם, סוריה והלבנט, ובהם אחאב מלך ישראל. אשור טענה לניצחון, אך לא הצליחה לכבוש את האזור. זהו האזכור החוץ־מקראי הראשון של מלך ישראלי.",
    "rank": 634
  },
  {
    "id": "med_kamakura",
    "deck": "anchors",
    "title": "יוריטומו הופך לשוגון",
    "start": 1192,
    "end": 1192,
    "date": "1192",
    "place": "קמאקורה, יפן",
    "lat": 35.32,
    "lon": 139.55,
    "desc": "מינאמוטו נו יוריטומו קיבל מהקיסר את התואר שוגון וניהל את המדינה ממטה הצבא בקמאקורה. נפתחה תקופה שבה שליטי הצבא הם בעלי הכוח האמיתי, והקיסר נותר בשוליים עד המאה ה־19.",
    "rank": 635
  },
  {
    "id": "mod_tsushima",
    "deck": "anchors",
    "title": "קרב צושימה",
    "start": 1905,
    "end": 1905,
    "date": "1905",
    "place": "מצר צושימה, בין יפן לקוריאה",
    "lat": 34.5,
    "lon": 129.9,
    "desc": "בסוף מאי הושמד כמעט כל הצי הרוסי הבלטי, ששט חצי עולם, בידי הצי היפני בפיקוד האדמירל טוגו. זו הייתה תבוסה ימית מוחצת, והיא הכריעה את המלחמה בין רוסיה ליפן. לראשונה במאה העשרים הביסה מעצמה אסיאתית מעצמה אירופית, ויפן התבססה כמעצמה בעולם.",
    "rank": 636
  },
  {
    "id": "anq_leuctra",
    "deck": "anchors",
    "title": "קרב לאוקטרה",
    "start": -371,
    "end": -371,
    "date": "371 לפנה״ס",
    "place": "לאוקטרה, בואוטיה, יוון",
    "lat": 38.2,
    "lon": 23.17,
    "desc": "צבא תבאי בפיקוד אפמינונדס, שהציב את כנף שמאל שלו בעומק רב במיוחד, הביס את הספרטנים ופגע בכוחם הצבאי המיתולוגי. הניצחון סיים את ההגמוניה הספרטנית ביוון והעמיד את תבאי כמעצמה לזמן קצר. הקרב נחשב לאחד המפורסמים בתולדות הטקטיקה היוונית.",
    "rank": 637
  },
  {
    "id": "med_kongo",
    "deck": "anchors",
    "title": "מלך קונגו מתנצר",
    "start": 1491,
    "end": 1491,
    "date": "1491",
    "place": "מבנזה קונגו, אנגולה",
    "lat": -6.27,
    "lon": 14.25,
    "desc": "נזינגה א נקווו, מלך קונגו, קיבל נצרות מידי מיסיונרים פורטוגלים ונטל את השם ז׳ואאו. בנו אפונסו הראשון חיזק את הקשרים עם פורטוגל ועם הכנסייה בשלטון ארוך. עם הזמן נפגעה הממלכה מסחר העבדים.",
    "rank": 638
  },
  {
    "id": "mod_quebec",
    "deck": "anchors",
    "title": "קרב רמת אברהם",
    "start": 1759,
    "end": 1759,
    "date": "1759",
    "place": "קוויבק, קנדה",
    "lat": 46.8,
    "lon": -71.22,
    "desc": "בעת מלחמת שבע השנים עלה צבא בריטי בפיקוד ג׳יימס וולף על צוקי העיר קוויבק והביס את הצבא הצרפתי בפיקוד מונטקלם. שני המפקדים נהרגו. נפילת העיר הובילה לכיבוש קנדה הצרפתית, ולפי הסכם פריז ב־1763 הועברה קנדה לשליטת בריטניה.",
    "rank": 639
  },
  {
    "id": "anq_sanxingdui",
    "deck": "anchors",
    "title": "הקרבנות בסאנשינגדוי",
    "start": -1200,
    "end": -1100,
    "date": "בערך ⁦1200–1100⁩ לפנה״ס",
    "place": "סאנשינגדוי, סין",
    "lat": 31,
    "lon": 104.2,
    "desc": "במחוז סצ׳ואן נחשפו בורות ובהם מסכות ברונזה, פסלים גבוהים ועצי שנהב, שייכים לתרבות שלא נשאר עליה תיעוד כתוב. סגנונה שונה לחלוטין מתרבות שאנג בצפון, ועדות על כך שבסין התקיימו בבת אחת כמה תרבויות מתקדמות.",
    "rank": 640
  },
  {
    "id": "mod_opiumlin",
    "deck": "anchors",
    "title": "השמדת האופיום בחומן",
    "start": 1839,
    "end": 1839,
    "date": "1839",
    "place": "חומן, גואנגדונג, סין",
    "lat": 22.82,
    "lon": 113.67,
    "desc": "הנציב לין דזשה סו החרים מסוחרים בריטים אלפי ארגזי אופיום והשמיד אותם בנמל. בריטניה ראתה במעשה פגיעה בסחר חופשי והכריזה על מלחמה. המלחמה, הראשונה במלחמות האופיום, חשפה את החולשה הצבאית של סין.",
    "rank": 641
  },
  {
    "id": "anq_urartu",
    "deck": "anchors",
    "title": "ממלכת אורארטו ומצודת טושפה",
    "start": -840,
    "end": -840,
    "date": "בערך 840 לפנה״ס",
    "place": "ואן, טורקיה",
    "lat": 38.5,
    "lon": 43.34,
    "desc": "בגבעות סביב אגם ואן שבמזרח אנטוליה קמה ממלכת אורארטו, שבירתה טושפה הייתה מצודה חצובה בסלע. המלכים האורארטים בנו מפעלי השקיה ומבצרים והתחרו באשור על השליטה באזור. הם השאירו כתובות מסמריות, ושמם נשתמר גם בשם הר אררט המקראי.",
    "rank": 642
  },
  {
    "id": "med_cyrilmethodius",
    "deck": "anchors",
    "title": "קיריל ומתודיוס במורביה הגדולה",
    "start": 863,
    "end": 863,
    "date": "863 לספירה",
    "place": "מורביה הגדולה (צ׳כיה)",
    "lat": 48.77,
    "lon": 17.07,
    "desc": "האחים מסלוניקי, קיריל ומתודיוס, נשלחו על ידי הקיסר הביזנטי לנסיך מורביה כדי להפיץ נצרות בשפה הסלאבית. הם המציאו אלפבית לשפה, שממנו התפתחו האלפבית הגלאגוליטי והקירילי. עבודתם הניחה יסוד לתרבות הכתובה של הסלאבים.",
    "rank": 643
  },
  {
    "id": "mod_sedan",
    "deck": "anchors",
    "title": "קרב סדאן",
    "start": 1870,
    "end": 1870,
    "date": "1870",
    "place": "סדאן, צרפת",
    "lat": 49.7,
    "lon": 4.94,
    "desc": "במלחמה הצרפתית־פרוסית הקיף צבא גרמני צבא צרפתי, ונפוליאון השלישי נכנע עם כ־100 אלף חיילים. בפריז הוכרזה רפובליקה חדשה, שהמשיכה את המלחמה. התבוסה הסתיימה בפירוק האימפריה הצרפתית השנייה.",
    "rank": 644
  },
  {
    "id": "anq_pydna",
    "deck": "anchors",
    "title": "קרב פידנה",
    "start": -168,
    "end": -168,
    "date": "168 לפנה״ס",
    "place": "פידנה, מקדוניה, יוון",
    "lat": 40.4,
    "lon": 22.55,
    "desc": "הקונסול הרומי פאולוס אמיליוס הביס את המלך פרסאוס ופירק את הממלכה המקדונית. מקדוניה חולקה לארבע רפובליקות, וכעבור שנים הוכרזה פרובינציה רומית. נפילת הפלנקס מול הלגיון הוכיחה את עליונות הלגיון על הצבאות ההלניסטיים.",
    "rank": 645
  },
  {
    "id": "med_triple_alliance",
    "deck": "anchors",
    "title": "הברית המשולשת האצטקית",
    "start": 1428,
    "end": 1428,
    "date": "בערך 1428",
    "place": "טקסקוקו, מקסיקו",
    "lat": 19.51,
    "lon": -98.88,
    "desc": "טנוצ׳טיטלן, טקסקוקו וטלקופן התאגדו וביססו שלטון על עמק מקסיקו, אחרי שהביסו את העיר אזקפוצלקו. הברית גבתה מס מעשרות ערים והייתה בסיס האימפריה האצטקית. מערכת זו נשארה בתוקף עד הכיבוש הספרדי.",
    "rank": 646
  },
  {
    "id": "anq_anyang",
    "deck": "anchors",
    "title": "אנייאנג בירת שאנג",
    "start": -1300,
    "end": -1300,
    "date": "בערך 1300 לפנה״ס",
    "place": "אנייאנג, סין",
    "lat": 36.12,
    "lon": 114.31,
    "desc": "בתקופת שושלת שאנג נעשתה אנייאנג בירה, ובה נחשפו ארמונות, קברי מלכים וכלי ברונזה. במקום נמצאו גם עצמות נבואה, ובהן הכתב הסיני הקדום ביותר שהגיע לידינו. הטקסטים עוסקים בשאלות שהופנו לאבות המלכים.",
    "rank": 647
  },
  {
    "id": "med_sui",
    "deck": "anchors",
    "title": "שושלת סוי מאחדת את סין",
    "start": 589,
    "end": 589,
    "date": "589 לספירה",
    "place": "ג׳יאנקאנג (נאנג׳ינג), סין",
    "lat": 32.06,
    "lon": 118.79,
    "desc": "הקיסר וון מסוי כבש את ממלכת צ׳ן, אחרונת הממלכות בדרום, וסיים כ־360 שנות פילוג. השושלת הקצרה הקימה בירוקרטיה ריכוזית וביצעה רפורמות במסים ובמשפט שהמשיכו גם בימי טאנג. סין שוב הייתה מאוחדת.",
    "rank": 648
  },
  {
    "id": "mod_ipiranga",
    "deck": "anchors",
    "title": "הכרזת העצמאות של ברזיל",
    "start": 1822,
    "end": 1822,
    "date": "1822",
    "place": "סאו פאולו, ברזיל",
    "lat": -23.585,
    "lon": -46.61,
    "desc": "הנסיך פדרו, בנו של מלך פורטוגל, הכריז על עצמאות בקריאה ״עצמאות או מוות״ על גדת נחל איפירנגה והוכתר כקיסר ברזיל. העצמאות הושגה ללא מלחמה ממושכת וללא קרע מהמשפחה המלכותית. ברזיל נשארה אימפריה עד 1889.",
    "rank": 649
  },
  {
    "id": "anq_hallstatt",
    "deck": "anchors",
    "title": "תרבות האלשטאט",
    "start": -800,
    "end": -800,
    "date": "בערך 800 לפנה״ס",
    "place": "האלשטאט, אוסטריה",
    "lat": 47.56,
    "lon": 13.65,
    "desc": "בהרי האלפים שבאוסטריה כרו סלע מלח וסחרו בו ברחבי אירופה. מקברי המקום יצאו כלי ברזל וכלי קישוט עשירים. תרבות האלשטאט נחשבת לשלב המוקדם של התרבות הקלטית, ושגשגה בראשית תקופת הברזל.",
    "rank": 650
  },
  {
    "id": "mod_liberia",
    "deck": "anchors",
    "title": "הכרזת העצמאות של ליבריה",
    "start": 1847,
    "end": 1847,
    "date": "1847",
    "place": "מונרוביה, ליבריה",
    "lat": 6.3,
    "lon": -10.8,
    "desc": "אפרו־אמריקאים משוחררים שהוגלו לחוף מערב אפריקה בידי אגודת ההתיישבות האמריקאית הכריזו על מדינה עצמאית בעלת חוקה דומה לאמריקאית. רפובליקת ליבריה הייתה אחת משתי המדינות האפריקאיות העצמאיות במאה ה־19 לצד אתיופיה, אבל המתיישבים שלטו בילידים.",
    "rank": 651
  },
  {
    "id": "anq_roman_china",
    "deck": "anchors",
    "title": "שגרירות רומית בסין",
    "start": 166,
    "end": 166,
    "date": "בערך 166 לספירה",
    "place": "לויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "בכרוניקות האן המאוחרות נאמר שבשנה זו הגיעו שליחים ממלך ״אנדון״, כנראה הקיסר מרקוס אורליוס אנטונינוס, דרך הים. ייתכן שהיו אלה סוחרים רומאים בלבד, שהציגו עצמם כשליחים. זה אחד המגעים הישירים הקדומים בין שתי האימפריות.",
    "rank": 652
  },
  {
    "id": "med_mohi",
    "deck": "anchors",
    "title": "קרב מוהי",
    "start": 1241,
    "end": 1241,
    "date": "1241",
    "place": "מוהי, הונגריה",
    "lat": 47.97,
    "lon": 21.07,
    "desc": "צבא מונגולי הביס את צבא המלך בלה הרביעי בנהר שאיו, יומיים אחרי שכוח מונגולי אחר הביס את הפולנים בליגניצה. הונגריה נחרבה והמלך נמלט עד לחוף האדריאטי. המונגולים נסוגו ב־1242, כנראה בעקבות מות הח׳אן הגדול אוגדאי.",
    "rank": 653
  },
  {
    "id": "mod_muhammadali",
    "deck": "anchors",
    "title": "עלייתו של מוחמד עלי לשלטון במצרים",
    "start": 1805,
    "end": 1805,
    "date": "1805",
    "place": "קהיר, מצרים",
    "lat": 30.04,
    "lon": 31.24,
    "desc": "קצין אלבני בצבא העות׳מאני התמנה לוואלי של מצרים בעקבות מרד של אנשי קהיר. הוא שבר את כוחם של המממלוכים והקים צבא ומנהל מודרניים. בנו ויורשיו שלטו במצרים כמעט 150 שנה, בדרך כלל כנתינים נומינליים של העות׳מאנים.",
    "rank": 654
  },
  {
    "id": "anq_uluburun",
    "deck": "anchors",
    "title": "ספינת אולובורון",
    "start": -1320,
    "end": -1320,
    "date": "בערך 1320 לפנה״ס",
    "place": "אולובורון, טורקיה",
    "lat": 36.13,
    "lon": 29.68,
    "desc": "ספינת סוחר טבעה בקרבת חופי אנטוליה ובמטען שלה נחושת, בדיל, זהב, שנהב, זכוכית וחרוזים מארצות שונות. הממצאים, שנחפרו מקרקעית הים בשנות השמונים, מעידים על קשרי מסחר ענפים בין מצרים, כנען, קפריסין ויוון בעת הברונזה המאוחרת.",
    "rank": 655
  },
  {
    "id": "med_vouille",
    "deck": "anchors",
    "title": "קרב ווּיֶה: הפרנקים מביסים את הוויזיגותים",
    "start": 507,
    "end": 507,
    "date": "507 לספירה",
    "place": "ווּיֶה, גאליה (צרפת)",
    "lat": 46.64,
    "lon": 0.17,
    "desc": "מלך הפרנקים כלוביס הביס בקרב את אלריק השני, מלך הוויזיגותים. הוויזיגותים נסוגו מרוב גאליה לחצי האי האיברי, והפרנקים הפכו לכוח המרכזי במערב אירופה. כלוביס, שהתנצר כקתולי, זכה לתמיכת הכנסייה.",
    "rank": 656
  },
  {
    "id": "mod_belgium",
    "deck": "anchors",
    "title": "המהפכה הבלגית",
    "start": 1830,
    "end": 1830,
    "date": "1830",
    "place": "בריסל, בלגיה",
    "lat": 50.85,
    "lon": 4.35,
    "desc": "מהומות בבריסל, שהחלו בעקבות הצגת אופרה, התפתחו למרד של קתולים וליברלים נגד שלטון ממלכת הולנד. בלגיה הכריזה על עצמאות והוקמה ממלכה חוקתית בהנהגת המלך ליאופולד הראשון. המעצמות הכירו בה והבטיחו את נייטרליותה.",
    "rank": 657
  },
  {
    "id": "anq_babylon_689",
    "deck": "anchors",
    "title": "סנחריב מחריב את בבל",
    "start": -689,
    "end": -689,
    "date": "בערך 689 לפנה״ס",
    "place": "בבל, עיראק",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "סנחריב מלך אשור, אחרי שבבל מרדה שוב ושוב, כבש את העיר, הרס את מקדשיה והסיט תעלות כך שהמים הציפו אותה. המעשה זעזע את תושבי מסופוטמיה, ובנו אסרחדון בנה אותה מחדש.",
    "rank": 658
  },
  {
    "id": "med_optics",
    "deck": "anchors",
    "title": "ספר האופטיקה של אבן אל־הית׳ם",
    "start": 1011,
    "end": 1021,
    "date": "⁦1011–1021⁩",
    "place": "קהיר, מצרים",
    "lat": 30.05,
    "lon": 31.26,
    "desc": "המדען אבן אל־הית׳ם כתב בקהיר את ״ספר האופטיקה״ ובו הסביר שראייה נובעת מקרני אור שנכנסות לעין. הוא נעזר בניסויים כדי לבחון תיאוריות. הספר השפיע על מדענים באירופה, ובהם רוג׳ר בייקון וקפלר.",
    "rank": 659
  },
  {
    "id": "mod_isandlwana",
    "deck": "anchors",
    "title": "קרב איסנדלוואנה",
    "start": 1879,
    "end": 1879,
    "date": "1879",
    "place": "איסנדלוואנה, קוואזולו־נטאל, דרום אפריקה",
    "lat": -28.35,
    "lon": 30.65,
    "desc": "צבא זולו בפיקוד המלך סטוואיו הביס כוח בריטי שחצה לאזור, ובו כאלף וחמש מאות חיילים נהרגו. התבוסה, עם נשק מודרני מול חניתות, זעזעה את בריטניה. הבריטים שלחו תגבורת והביסו את הזולו באולונדי, ואחרי כך סיפחו את האזור.",
    "rank": 660
  },
  {
    "id": "anq_wang_mang",
    "deck": "anchors",
    "title": "שלטון וואנג מאנג",
    "start": 9,
    "end": 9,
    "date": "9 לספירה",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.9,
    "desc": "הרשמי וואנג מאנג הדיח את ילד־הקיסר של שושלת האן והכריז על שושלת שין. הוא ניסה רפורמות, וביניהן הלאמת קרקעות, איסור סחר בעבדים ושינוי מטבעות. השיטה נכשלה והביאה למרידות, ואחריה חזרה שושלת האן, שנקראת האן המאוחרת.",
    "rank": 661
  },
  {
    "id": "med_lateran_iv",
    "deck": "anchors",
    "title": "מועצת לטראנו הרביעית",
    "start": 1215,
    "end": 1215,
    "date": "1215",
    "place": "רומא, איטליה",
    "lat": 41.886,
    "lon": 12.506,
    "desc": "האפיפיור אינוקנטיוס השלישי כינס מאות בישופים בבית הלטראנו. המועצה קבעה כעיקר אמונה שהלחם והיין בסעודת האדון הופכים לגופו ולדמו של ישו, והחייבה וידוי שנתי. היא גם הורתה שיהודים ומוסלמים יישאו סימן מזהה בלבושם, צעד חשוב בהפליית יהודים באירופה הנוצרית.",
    "rank": 662
  },
  {
    "id": "mod_dosdemayo",
    "deck": "anchors",
    "title": "מרד ה־2 במאי במדריד",
    "start": 1808,
    "end": 1808,
    "date": "1808",
    "place": "מדריד, ספרד",
    "lat": 40.42,
    "lon": -3.7,
    "desc": "תושבי מדריד התקוממו נגד הכוחות הצרפתיים שהשתלטו על ספרד, והצבא הצרפתי דיכא את המרד בכוח והוציא מורדים להורג. פרנסיסקו גויה הנציח את האירועים בציוריו. המרד הצית את מלחמת חצי האי, שבה נקשרו כוחות נפוליאון שנים רבות.",
    "rank": 663
  },
  {
    "id": "anq_ur_tombs",
    "deck": "anchors",
    "title": "הקברים המלכותיים של אור",
    "start": -2600,
    "end": -2600,
    "date": "בערך 2600 לפנה״ס",
    "place": "אור, מסופוטמיה",
    "lat": 30.963,
    "lon": 46.103,
    "desc": "בעיר אור שבדרום מסופוטמיה נקברו שליטים וקרובים, ובתוך הקברים נמצאו כלי נגינה, תכשיטי זהב ולפיס לזולי ושרידי משרתים שהוטמנו עמם. החפירות של ליאונרד וולי בשנות העשרים של המאה ה־20 חשפו את עושרה של העיר השומרית.",
    "rank": 664
  },
  {
    "id": "med_edington",
    "deck": "anchors",
    "title": "קרב אדינגטון וחלוקת אנגליה",
    "start": 878,
    "end": 878,
    "date": "878 לספירה",
    "place": "אדינגטון, ויילטשייר (אנגליה)",
    "lat": 51.28,
    "lon": -2.09,
    "desc": "המלך אלפרד הגדול ממלכת ווסקס ניצח את צבא הדנים בראשות גותרום אחרי שנדחק לביצות סומרסט. גותרום הסכים להתנצר, והושג הסכם גבולות. החלק הצפוני והמזרחי של אנגליה נשאר זמן רב בשליטה דנית, וידוע כ״דנלו״.",
    "rank": 665
  },
  {
    "id": "mod_algiers",
    "deck": "anchors",
    "title": "כיבוש אלג׳יר בידי צרפת",
    "start": 1830,
    "end": 1830,
    "date": "1830",
    "place": "אלג׳יר, אלג׳יריה",
    "lat": 36.77,
    "lon": 3.06,
    "desc": "צרפת שלחה כוח מצבא וצי נחיתה סמוך לאלג׳יר וכבשה את העיר מידי שליט עות׳מאני אשר שלט בה. המלחמה נועדה, בין השאר, להסיח דעת מהמשבר הפוליטי בצרפת. הכיבוש התפשט לכל אלג׳יריה במלחמה ממושכת, והמדינה נותרה בשליטה צרפתית עד 1962.",
    "rank": 666
  },
  {
    "id": "anq_ipsus",
    "deck": "anchors",
    "title": "קרב איפסוס",
    "start": -301,
    "end": -301,
    "date": "301 לפנה״ס",
    "place": "איפסוס, פריגיה, טורקיה",
    "lat": 38.6,
    "lon": 30.9,
    "desc": "קואליציית דיאדוכים בראשות סלווקוס וליסימכוס הביסה את אנטיגונוס מונופתלמוס ובנו דמטריוס. אנטיגונוס נהרג, ותקוותו לאחד מחדש את אימפריית אלכסנדר נעלמה לבלי שוב. סלווקוס קיבל את סוריה, ומכאן התגבשו המדינות ההלניסטיות הגדולות.",
    "rank": 667
  },
  {
    "id": "med_somnath",
    "deck": "anchors",
    "title": "מחמוד מע׳זני בוזז את מקדש סומנאת",
    "start": 1025,
    "end": 1025,
    "date": "1025",
    "place": "סומנאת, גוג׳ראט (הודו)",
    "lat": 20.89,
    "lon": 70.4,
    "desc": "מחמוד מע׳זני, שליט שושלת הע׳זנווים מאפגניסטן, יצא לפשיטות רבות בהודו. ב־1025 הגיע למקדש סומנאת בגוג׳ראט, בזז את אוצרותיו והרס אותו. האירוע נשאר זכור בהיסטוריוגרפיה של הודו ובמחלוקות על יחסי הינדים ומוסלמים.",
    "rank": 668
  },
  {
    "id": "mod_summerpalace",
    "deck": "anchors",
    "title": "שריפת ארמון הקיץ הישן",
    "start": 1860,
    "end": 1860,
    "date": "1860",
    "place": "בייג׳ינג, סין",
    "lat": 40,
    "lon": 116.27,
    "desc": "במלחמת האופיום השנייה כבשו כוחות בריטיים וצרפתיים את בייג׳ינג, בזזו את ארמון הקיץ הישן והעלו אותו באש כנקמה על עינוי שבויים. הארמון, אוצר של אמנות ותרבות, נהרס. האירוע נשאר סמל לתוקפנות הזרה בזיכרון הסיני.",
    "rank": 669
  },
  {
    "id": "anq_kerma",
    "deck": "anchors",
    "title": "ממלכת כרמה בנוביה",
    "start": -1650,
    "end": -1650,
    "date": "בערך 1650 לפנה״ס",
    "place": "כרמה, סודן",
    "lat": 19.6,
    "lon": 30.41,
    "desc": "בעיר כרמה שליד הקטרקט השלישי של הנילוס קמה ממלכה כושית חזקה, ובה קברים ענקיים ומקדשי לבנים. היא סחרה בזהב ובשנהב עם מצרים, ובתקופה מסוימת התחרתה בה. מצרים כבשה את כרמה בימי הממלכה החדשה.",
    "rank": 670
  },
  {
    "id": "med_joseon",
    "deck": "anchors",
    "title": "ייסוד שושלת ג׳וסון",
    "start": 1392,
    "end": 1392,
    "date": "1392",
    "place": "קסונג, קוריאה",
    "lat": 37.97,
    "lon": 126.56,
    "desc": "הגנרל יי סונג־גיה תפס את השלטון משושלת קוריו ולימים נודע כטאג׳ו, מייסד ממלכת ג׳וסון. הוא העביר את הבירה לסיאול והעמיד את הקונפוציאניזם כעיקרון המנחה של המדינה. השושלת שלטה בקוריאה יותר מחמש מאות שנה.",
    "rank": 671
  },
  {
    "id": "mod_poltava",
    "deck": "anchors",
    "title": "קרב פולטבה",
    "start": 1709,
    "end": 1709,
    "date": "1709",
    "place": "פולטבה, אוקראינה",
    "lat": 49.6,
    "lon": 34.55,
    "desc": "צבאו של פיוטר הגדול הביס את צבא שוודיה בפיקוד קרל ה־12, שחדר לעומק אוקראינה בתמיכת הקוזאקים של מזפה. קרל נמלט לאימפריה העות׳מאנית. הקרב סימן את סוף מעמדה של שוודיה כמעצמה גדולה ואת עלייתה של רוסיה למעצמה אירופית.",
    "rank": 672
  },
  {
    "id": "anq_khorsabad",
    "deck": "anchors",
    "title": "סרגון השני מקים את דור־שרוכין",
    "start": -706,
    "end": -706,
    "date": "בערך 706 לפנה״ס",
    "place": "חורסבאד, עיראק",
    "lat": 36.51,
    "lon": 43.23,
    "desc": "סרגון השני, מלך אשור, הקים בירה חדשה, דור־שרוכין, סמוך לנינוה, עם ארמון גדול ופסלי שוורים מכונפים בשערים. אחרי מותו בקרב נעזבה הבירה, ובנו סנחריב חזר לנינוה. פסלים מן האתר מוצגים כיום בלובר.",
    "rank": 673
  },
  {
    "id": "med_lechfeld",
    "deck": "anchors",
    "title": "קרב לכפלד",
    "start": 955,
    "end": 955,
    "date": "955 לספירה",
    "place": "אוגסבורג, גרמניה",
    "lat": 48.37,
    "lon": 10.9,
    "desc": "המלך אוטו הראשון ניצח את הפרשים ההונגרים ליד אוגסבורג והביא לסיום הפשיטות ההונגריות על מערב אירופה. הניצחון חיזק את מעמדו בקרב הנסיכים הגרמניים ואפשר לו להתכונן להכתרה לקיסר. ההונגרים עברו להתיישבות קבע.",
    "rank": 674
  },
  {
    "id": "mod_dolores",
    "deck": "anchors",
    "title": "קריאת דולורס",
    "start": 1810,
    "end": 1810,
    "date": "1810",
    "place": "דולורס הידלגו, מקסיקו",
    "lat": 21.16,
    "lon": -100.93,
    "desc": "הכומר מיגל הידלגו קרא למאמיניו בכנסייה לצאת נגד השלטון הספרדי ויצא בראש המון איכרים ואינדיאנים. המרד לא הצליח, והידלגו הוצא להורג ב־1811, אבל הוא הצית את מאבק העצמאות המקסיקני שהסתיים ב־1821. יום זה נחגג כיום העצמאות של מקסיקו.",
    "rank": 675
  },
  {
    "id": "anq_aksum",
    "deck": "anchors",
    "title": "התנצרות מלך אקסום",
    "start": 330,
    "end": 340,
    "date": "בערך ⁦330–340⁩ לספירה",
    "place": "אקסום, אתיופיה",
    "lat": 14.13,
    "lon": 38.72,
    "desc": "המלך עזנא קיבל את הנצרות כנראה בהשפעת פרומנטיוס, נוצרי מצור. מטבעותיו מתעדים את המעבר מסמלי שמש וירח לצלב. אקסום הייתה מעצמה מסחרית שחיברה בין אפריקה, הים האדום והודו, ועזנא הרחיב את שליטתה. ממלכת אקסום הייתה גם מהראשונות להטביע מטבעות באפריקה שמדרום לסהרה.",
    "rank": 676
  },
  {
    "id": "med_norwich",
    "deck": "anchors",
    "title": "עלילת הדם בנוריץ׳",
    "start": 1144,
    "end": 1144,
    "date": "1144",
    "place": "נוריץ׳, אנגליה",
    "lat": 52.63,
    "lon": 1.3,
    "desc": "אחרי מות נער בשם וויליאם נטען שהיהודים רצחו אותו לצורכי פולחן. זו עלילת הדם הראשונה הידועה באירופה. עלילות דומות חזרו בערים רבות והובילו לרדיפות.",
    "rank": 677
  },
  {
    "id": "mod_eureka",
    "deck": "anchors",
    "title": "מרד אוריקה",
    "start": 1854,
    "end": 1854,
    "date": "1854",
    "place": "באלרט, אוסטרליה",
    "lat": -37.56,
    "lon": 143.85,
    "desc": "כורי זהב בויקטוריה מחו על אגרות רישיון וחוסר ייצוג, והקימו מתרס בבאלרט. חיילים וכוחות משטרה תקפו אותו ועשרות נהרגו. מנהיגי המרד לא הורשעו, והממשל חוקק רפורמות. האירוע נחשב לעיתים ללידת הדמוקרטיה באוסטרליה.",
    "rank": 678
  },
  {
    "id": "anq_skara_brae",
    "deck": "anchors",
    "title": "הכפר הנאוליתי סקארה בריי",
    "start": -3180,
    "end": -3180,
    "date": "בערך 3180 לפנה״ס",
    "place": "איי אורקני, סקוטלנד",
    "lat": 59.049,
    "lon": -3.342,
    "desc": "בחוף איי אורקני הוקם כפר של בתי אבן עם ארונות, מיטות ותנורים מאבן, שנשמרו עד היום משום שחולות כיסו אותם. תושביו חיו מחקלאות, מרעה ודיג. הכפר נחשף אחרי סערה במאה ה־19 והוא מן המקומות המשמרים ביותר של החיים הנאוליתיים באירופה.",
    "rank": 679
  },
  {
    "id": "med_vijayanagara",
    "deck": "anchors",
    "title": "ייסוד אימפריית ויג׳יאנגרה",
    "start": 1336,
    "end": 1336,
    "date": "1336",
    "place": "האמפי, הודו",
    "lat": 15.335,
    "lon": 76.46,
    "desc": "האחים הרהרה ובוקה ייסדו ממלכה הינדית בדרום הודו, כמעוז מול התפשטות סולטנות דלהי. בירתה בהאמפי הפכה לאחת הערים הגדולות בעולם. האימפריה שלטה בדרום הודו כמאתיים שנה, עד שהובסה ב־1565 בידי קואליציה של סולטנויות.",
    "rank": 680
  },
  {
    "id": "mod_aurangzeb",
    "deck": "anchors",
    "title": "עלייתו של אורנגזב לשלטון באימפריה המוגולית",
    "start": 1658,
    "end": 1658,
    "date": "1658",
    "place": "דלהי, הודו",
    "lat": 28.65,
    "lon": 77.23,
    "desc": "אורנגזב ניצח את אחיו במלחמת הירושה, כלא את אביו שאה ג׳האן והוכתר כקיסר. בימי שלטונו הגיעה האימפריה המוגולית לשיא שטחה והוא פעל לאכיפת הלכה מוסלמית קפדנית. מלחמות ממושכות בדקאן ומרידות פנימיות החלישו את האימפריה לאחר מותו.",
    "rank": 681
  },
  {
    "id": "anq_chavin",
    "deck": "anchors",
    "title": "מקדש צ׳אבין דה וואנטר",
    "start": -900,
    "end": -900,
    "date": "בערך 900 לפנה״ס",
    "place": "צ׳אבין דה וואנטר, פרו",
    "lat": -9.593,
    "lon": -77.177,
    "desc": "במעלה הרי האנדים נבנה מתחם מקדש מאבן, ובו מסדרונות תת־קרקעיים, תעלות מים ופסל אל בצורת סכין. הוא היה מרכז פולחן שמשך עולי רגל. סגנון האמנות שלו, הדומה לדמויות של יגואר ונחש, השפיע על חלק גדול מהאנדים.",
    "rank": 682
  },
  {
    "id": "med_basil",
    "deck": "anchors",
    "title": "בזיל השני כובש את בולגריה",
    "start": 1018,
    "end": 1018,
    "date": "1018",
    "place": "אוחריד, בולגריה (מקדוניה הצפונית)",
    "lat": 41.12,
    "lon": 20.8,
    "desc": "הקיסר בזיל השני, שזכה לכינוי ״קוטל הבולגרים״, כבש בסדרת מסעות את הממלכה הבולגרית הראשונה והחזיר את הבלקן לשליטת הביזנטים. תקופת שלטונו הייתה שיא כוחה של האימפריה ביזנטית.",
    "rank": 683
  },
  {
    "id": "mod_braziljoao",
    "deck": "anchors",
    "title": "בריחת המלכות הפורטוגלית לברזיל",
    "start": 1808,
    "end": 1808,
    "date": "1808",
    "place": "ריו דה ז׳ניירו, ברזיל",
    "lat": -22.9,
    "lon": -43.17,
    "desc": "כשצבאו של נפוליאון התקרב לליסבון ברח הנסיך יוּאוּ, יורש העצר, עם בית המלוכה ובמלווה של אלפי איש בליווי צי בריטי. ריו דה ז׳ניירו הפכה לבירת האימפריה הפורטוגלית. נפתחו נמלי ברזיל לסחר חופשי, ויהיה זה צעד מכריע בדרך לעצמאותה.",
    "rank": 684
  },
  {
    "id": "anq_monte_alban",
    "deck": "anchors",
    "title": "ייסוד מונטה אלבן",
    "start": -500,
    "end": -500,
    "date": "בערך 500 לפנה״ס",
    "place": "אוחקה, מקסיקו",
    "lat": 17.04,
    "lon": -96.77,
    "desc": "הצאפוטקים בנו מרכז טקסי ואורבני על פסגה שמעל עמק אוחקה. מונטה אלבן הייתה במשך כאלף שנה אחד המרכזים החשובים של מסואמריקה, והכילה כיכרות, מקדשים ומגרש למשחק הכדור. ממצאיה כוללים גם כתב מוקדם ורישומים של מסעות כיבוש.",
    "rank": 685
  },
  {
    "id": "med_zagwe",
    "deck": "anchors",
    "title": "שושלת זאגווה באתיופיה",
    "start": 1137,
    "end": 1137,
    "date": "בערך 1137",
    "place": "רוהא (לליבלה), אתיופיה",
    "lat": 12.03,
    "lon": 39.04,
    "desc": "שושלת זאגווה תפסה את השלטון באתיופיה וקבעה את בירתה ברוהא. היא שלטה מהרמות המרכזיות כממלכה נוצרית. מלך מאוחר בשושלת, לליבלה, קשור במסורת לכנסיות החצובות בסלע בעיר שנקראת על שמו.",
    "rank": 686
  },
  {
    "id": "mod_frankfurt",
    "deck": "anchors",
    "title": "הפרלמנט של פרנקפורט",
    "start": 1848,
    "end": 1848,
    "date": "1848",
    "place": "פרנקפורט, גרמניה",
    "lat": 50.11,
    "lon": 8.68,
    "desc": "במהלך מהפכות 1848 התכנסו נציגים נבחרים מכל המדינות הגרמניות בכנסיית פאולוס לניסוח חוקה לגרמניה מאוחדת. הם הציעו את הכתר לפרידריך וילהלם הרביעי מלך פרוסיה, והוא סירב. הפרלמנט פוזר, ואיחוד גרמניה נעשה בהמשך בכוח הצבא הפרוסי.",
    "rank": 687
  },
  {
    "id": "anq_faxian",
    "deck": "anchors",
    "title": "מסע פא־שיאן להודו",
    "start": 399,
    "end": 412,
    "date": "⁦399–412⁩ לספירה",
    "place": "צ׳אנגאן, סין",
    "lat": 34.27,
    "lon": 108.9,
    "desc": "הנזיר הבודהיסטי פא־שיאן יצא ברגל מסין להודו כדי לחפש טקסטים בודהיסטיים. הוא ביקר באתרי קודש, הגיע עד סרי לנקה וחזר דרך הים. תיאורו הוא מקור חשוב לתולדות הודו בתקופת גופטה. הוא חזר עם כתבי יד רבים שתורגמו לסינית, ותיאוריו משמשים מקור חשוב להכרת הודו בימי גופטה.",
    "rank": 688
  },
  {
    "id": "med_ulugh_beg",
    "deck": "anchors",
    "title": "מצפה הכוכבים של אולוג בק",
    "start": 1428,
    "end": 1429,
    "date": "בערך ⁦1428–1429⁩",
    "place": "סמרקנד, אוזבקיסטן",
    "lat": 39.675,
    "lon": 66.99,
    "desc": "אולוג בק, נכדו של תימור ושליט סמרקנד, היה גם אסטרונום. הוא בנה מצפה כוכבים גדול וערך בו קטלוג כוכבים מדויק, שנחשב לטוב ביותר בימיו. בעקבות פעילותו הפכה סמרקנד למרכז מדעי. ב־1449 נרצח בידי בנו.",
    "rank": 689
  },
  {
    "id": "mod_valmy",
    "deck": "anchors",
    "title": "קרב ואלמי",
    "start": 1792,
    "end": 1792,
    "date": "1792",
    "place": "ואלמי, צרפת",
    "lat": 49.08,
    "lon": 4.77,
    "desc": "צבא המהפכה הצרפתי בפיקוד קלרמן ודומוריה עצר את צבא פרוסיה וצבא האמיגרנטים בהובלת הדוכס מברונשוויק, בעיקר בירי ארטילריה. למחרת ביטלה הוועידה הלאומית את המלוכה והכריזה על הרפובליקה. גתה, שנכח בשטח, אמר שמכאן תתחיל תקופה חדשה בהיסטוריה העולמית.",
    "rank": 690
  },
  {
    "id": "anq_poverty_point",
    "deck": "anchors",
    "title": "פובטי פוינט בלואיזיאנה",
    "start": -1700,
    "end": -1700,
    "date": "בערך 1700 לפנה״ס",
    "place": "לואיזיאנה, ארצות הברית",
    "lat": 32.64,
    "lon": -91.41,
    "desc": "ציידים־לקטים בעמק המיסיסיפי בנו שורת סוללות אדמה בצורת חצאי עיגולים וכמה תלים גדולים, ללא חקלאות. תושבי האתר סחרו באבנים ממרחקים גדולים. פובטי פוינט נחשב לאחד המבנים הגדולים בצפון אמריקה בימי קדם.",
    "rank": 691
  },
  {
    "id": "med_sind",
    "deck": "anchors",
    "title": "הכיבוש הערבי של סינד",
    "start": 711,
    "end": 713,
    "date": "⁦711–713⁩ לספירה",
    "place": "דיבל, סינד (פקיסטן)",
    "lat": 24.75,
    "lon": 67.53,
    "desc": "צבא בפיקוד מוחמד בן קאסם כבש את נמל דיבל ואחר כך חלקים נרחבים של סינד בעמק האינדוס. כך הגיע השלטון המוסלמי לתת־היבשת ההודית לראשונה. בחלק מהאזור נמשך השלטון עשרות שנים והשפיע על התרבות.",
    "rank": 692
  },
  {
    "id": "mod_peterloo",
    "deck": "anchors",
    "title": "טבח פיטרלו",
    "start": 1819,
    "end": 1819,
    "date": "1819",
    "place": "מנצ׳סטר, אנגליה",
    "lat": 53.48,
    "lon": -2.25,
    "desc": "עשרות אלפי אנשים התכנסו בשדה סנט פיטר במנצ׳סטר לדרוש ייצוג פרלמנטרי וקבלו תקיפה של פרשים שהורו עליהם להתפזר. כמה עשרות נהרגו. האירוע נהפך לסמל להתנגדות לדיכוי, והוביל להרחבת הדרישה לרפורמה.",
    "rank": 693
  },
  {
    "id": "anq_huan_qi",
    "deck": "anchors",
    "title": "הדוכס הואן מצי נעשה הגמון",
    "start": -681,
    "end": -681,
    "date": "בערך 681 לפנה״ס",
    "place": "לינג׳ה, סין",
    "lat": 36.8,
    "lon": 118.3,
    "desc": "בתקופת האביב והסתיו כינס הדוכס הואן ממדינת צי את הנסיכים לפסגה, והם הכירו בו כראשון ביניהם, תואר שנקרא ״הגמון״. בעזרת יועצו גואן ג׳ונג הנהיג רפורמות כלכליות, ובהן מונופול על המלח והברזל, והגן על שושלת ג׳ואו מפני עמי הערבות.",
    "rank": 694
  },
  {
    "id": "med_tonina",
    "deck": "anchors",
    "title": "התאריך האחרון בספירה הארוכה של המאיה",
    "start": 909,
    "end": 909,
    "date": "בערך 909 לספירה",
    "place": "טוניננה, צ׳יאפס (מקסיקו)",
    "lat": 16.9,
    "lon": -92,
    "desc": "באתר טוניננה נמצאה הכתובת האחרונה הידועה בספירה הארוכה של המאיה. בתקופה הזאת, סביב המאה ה־9 וה־10, התפוררו ערי המאיה הגדולות בדרום, מסיבות שונות: בצורת, מלחמות ומשבר פוליטי.",
    "rank": 695
  },
  {
    "id": "mod_berlin1878",
    "deck": "anchors",
    "title": "קונגרס ברלין",
    "start": 1878,
    "end": 1878,
    "date": "1878",
    "place": "ברלין, גרמניה",
    "lat": 52.52,
    "lon": 13.4,
    "desc": "לאחר מלחמת רוסיה והעות׳מאנים בשנים 1877–1878 כינס ביסמרק את המעצמות כדי לתקן את הסכם סן סטפנו. נקבעה עצמאות סרביה, רומניה ומונטנגרו, בולגריה חולקה, ואוסטריה קיבלה זכות לנהל את בוסניה. ההסדר הותיר מתחים בבלקן.",
    "rank": 696
  },
  {
    "id": "anq_serapeum",
    "deck": "anchors",
    "title": "חורבן הסראפאום",
    "start": 391,
    "end": 391,
    "date": "391 לספירה",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.19,
    "lon": 29.91,
    "desc": "אלימות של נוצרים בהנהגת הארכיבישוף תאופילוס הרסה את הסראפאום, מקדש גדול לאל הסראפיס ומרכז ספרייה. האירוע היה חלק מהמאבק בין פגאנים לנוצרים באימפריה. עם הזמן נעלמו הפולחנות הקדומים. האירוע מציין את סופה של ההתנגדות הפגאנית הגלויה בעיר, אף שהספרייה הגדולה כבר נחלשה קודם לכן.",
    "rank": 697
  },
  {
    "id": "med_lagos_slaves",
    "deck": "anchors",
    "title": "שבויים אפריקאים מגיעים לפורטוגל",
    "start": 1444,
    "end": 1444,
    "date": "1444",
    "place": "לגוש, פורטוגל",
    "lat": 37.1,
    "lon": -8.67,
    "desc": "ספינות פורטוגליות שחזרו מחוף מערב אפריקה הביאו ללגוש מאות שבויים אפריקאים, שנמכרו ברשות הנסיך אנריקה. אירוע זה נחשב לראשית הסחר האירופי הסדיר בעבדים מאפריקה, שגדל בהדרגה והיה למוסד מרכזי בעולם האטלנטי.",
    "rank": 698
  },
  {
    "id": "mod_pugachev",
    "deck": "anchors",
    "title": "מרד פוגצ׳וב",
    "start": 1773,
    "end": 1775,
    "date": "⁦1773–1775⁩",
    "place": "אורנבורג, רוסיה",
    "lat": 51.77,
    "lon": 55.1,
    "desc": "הקוזאק אמליאן פוגצ׳וב התחזה לצאר פיוטר השלישי שנרצח ועורר מרד של קוזאקים, איכרים ובני מיעוטים בעמק הוולגה והאורל. המורדים כבשו ערים רבות והגיעו קרוב למוסקבה. המרד דוכא, פוגצ׳וב הוצא להורג, וקתרינה השנייה החריפה את שליטתה באצולה.",
    "rank": 699
  },
  {
    "id": "anq_ebla",
    "deck": "anchors",
    "title": "ארכיון עבלה",
    "start": -2350,
    "end": -2350,
    "date": "בערך 2350 לפנה״ס",
    "place": "תל מרדיח, סוריה",
    "lat": 35.8,
    "lon": 36.8,
    "desc": "בעיר עבלה שבצפון סוריה התגלו כ־17 אלף לוחות וחלקי לוחות בשפה שמית קדומה, ובהם דיווחי מסחר, אמנות ומילונים. הארכיון חושף ממלכה אדירה שסחרה עם ערים ברחבי המזרח הקדום, ומעיד על מערכת מנהל מפותחת בלבנט עוד באלף השלישי לפנה״ס.",
    "rank": 700
  },
  {
    "id": "med_gokturk",
    "deck": "anchors",
    "title": "ייסוד הח׳אנות הטורקית הראשונה",
    "start": 552,
    "end": 552,
    "date": "בערך 552 לספירה",
    "place": "אוטוקן, מונגוליה",
    "lat": 47.5,
    "lon": 102.8,
    "desc": "בומין ח׳אן הביס את ג׳ואן ג׳ואן והקים את האימפריה הטורקית הראשונה. הח׳אנות שלטה בערבות מדרום סיביר ועד הים השחור. כתובות אורחון הן הדוגמה העתיקה ביותר לכתיבה טורקית.",
    "rank": 701
  },
  {
    "id": "mod_stockton",
    "deck": "anchors",
    "title": "מסילת הרכבת סטוקטון–דרלינגטון",
    "start": 1825,
    "end": 1825,
    "date": "1825",
    "place": "דרלינגטון, אנגליה",
    "lat": 54.52,
    "lon": -1.55,
    "desc": "ג׳ורג׳ סטפנסון הפעיל קטר קיטור בקו הראשון בעולם שהוביל נוסעים וסחורות בקטרים. הקו נועד בעיקר להובלת פחם לנמל. ההצלחה הובילה לפריחת הקמת הרכבות בבריטניה ואחר כך בעולם כולו.",
    "rank": 702
  },
  {
    "id": "anq_psamtik",
    "deck": "anchors",
    "title": "פסמתיק הראשון מאחד את מצרים",
    "start": -656,
    "end": -656,
    "date": "בערך 656 לפנה״ס",
    "place": "סאיס, מצרים",
    "lat": 30.96,
    "lon": 30.77,
    "desc": "פסמתיק, נציב אשורי בדלתה, שחרר את מצרים מן האשורים וייסד את השושלת ה־26 בסאיס. הוא לקח שכירי חרב יווניים וקריים, וחידש את האמנות והדת של הממלכה הקדומה. מצרים הייתה עצמאית ומשגשגת במשך כמאה שנה.",
    "rank": 703
  },
  {
    "id": "med_kilwa",
    "deck": "anchors",
    "title": "הפורטוגלים משתלטים על קילווה",
    "start": 1505,
    "end": 1505,
    "date": "1505",
    "place": "קילווה, טנזניה",
    "lat": -8.96,
    "lon": 39.51,
    "desc": "צי פורטוגלי בפיקוד פרנסיסקו דה אלמיידה כבש את העיר קילווה והקים בה מצודה, עיר סחר סווהילית עשירה על חוף מזרח אפריקה. קילווה סחרה בזהב מזימבבואה ובשנהב. פורטוגל ביקשה לשלוט בנתיבי הים באוקיינוס ההודי, וכך פגעה במערכת המסחר הקיימת.",
    "rank": 704
  },
  {
    "id": "mod_tanzimat",
    "deck": "anchors",
    "title": "צו גולחאנה והתחלת הטנזימאט",
    "start": 1839,
    "end": 1839,
    "date": "1839",
    "place": "איסטנבול, טורקיה",
    "lat": 41.01,
    "lon": 28.98,
    "desc": "הסולטאן עבדולמג׳יד הראשון הכריז על סדרת רפורמות שהבטיחה ביטחון לחיים ולרכוש, מיסוי הוגן ושוויון נתינים ללא הבדל דת. המטרה הייתה לחזק את האימפריה העות׳מאנית מול אירופה ומול תנועות לאומיות. רפורמות הטנזימאט שינו את הצבא, החוק והחינוך.",
    "rank": 705
  },
  {
    "id": "anq_caral",
    "deck": "anchors",
    "title": "העיר קרל בפרו",
    "start": -2600,
    "end": -2600,
    "date": "בערך 2600 לפנה״ס",
    "place": "עמק סופה, פרו",
    "lat": -10.893,
    "lon": -77.52,
    "desc": "בעמק סופה בחוף פרו קמה עיר ובה פירמידות מדורגות וכיכרות שקועות, שנבנו ללא קרמיקה וללא כתב. כלכלתה נשענה על חקלאות כותנה ועל מסחר בדגים. קרל היא אחד המרכזים העירוניים הקדומים ביותר ביבשת אמריקה.",
    "rank": 706
  },
  {
    "id": "med_whitby",
    "deck": "anchors",
    "title": "ועידת וויטבי",
    "start": 664,
    "end": 664,
    "date": "664 לספירה",
    "place": "וויטבי, נורת׳מבריה (אנגליה)",
    "lat": 54.49,
    "lon": -0.61,
    "desc": "מלך נורת׳מבריה כינס בוועידה את נציגי הנצרות האירית והרומית כדי להכריע בשאלת מועד חג הפסחא ובמנהגים נוספים. המלך אימץ את מנהג רומא. ההחלטה חיברה את הכנסייה באנגליה לכנסייה הרומית ולעולם הלטיני.",
    "rank": 707
  },
  {
    "id": "mod_meireki",
    "deck": "anchors",
    "title": "השריפה הגדולה של אדו",
    "start": 1657,
    "end": 1657,
    "date": "1657",
    "place": "אדו (טוקיו), יפן",
    "lat": 35.69,
    "lon": 139.76,
    "desc": "שריפה שפרצה בעיר הבירה של שוגונות טוקוגאווה, ונפוצה ברוחות חזקות, השמידה את רוב העיר, ובכללה את טירת השוגון. עשרות אלפי בני אדם נספו, ומספר ההרוגים המדויק אינו ידוע. השלטונות תכננו את העיר מחדש עם דרכי מילוט ושדרות מפרידות, והעיר גדלה בהמשך לאחת הגדולות בעולם.",
    "rank": 708
  },
  {
    "id": "anq_kanishka",
    "deck": "anchors",
    "title": "שלטון קאנישקה",
    "start": 127,
    "end": 127,
    "date": "בערך 127 לספירה",
    "place": "פשאוור, פקיסטן",
    "lat": 34,
    "lon": 71.57,
    "desc": "קאנישקה, מלך הקושאנים, שלט על אימפריה שהשתרעה ממרכז אסיה לצפון הודו, ובירתה בפורושפורה. הוא תמך בבודהיזם ובאמנות גנדהארה שמזגה סגנונות הודיים והלניסטיים. האימפריה שלטה בדרכי המסחר ובכך סייעה בהפצת הבודהיזם לסין.",
    "rank": 709
  },
  {
    "id": "med_brihadisvara",
    "deck": "anchors",
    "title": "השלמת מקדש בריהדיסווארה",
    "start": 1010,
    "end": 1010,
    "date": "1010",
    "place": "תנג׳ור, טמיל נאדו (הודו)",
    "lat": 10.78,
    "lon": 79.13,
    "desc": "המלך רג׳ארג׳ה הראשון משושלת צ׳ולה השלים בבירתו מקדש גדול לשיווה. המגדל שלו מגיע לגובה כ־60 מטר. המקדש הוא סמל לעוצמת צ׳ולה, שמלכיה שלטו בדרום הודו ושלחו צי אל דרום־מזרח אסיה.",
    "rank": 710
  },
  {
    "id": "mod_navarino",
    "deck": "anchors",
    "title": "קרב נאווארינו",
    "start": 1827,
    "end": 1827,
    "date": "1827",
    "place": "נאווארינו (פילוס), יוון",
    "lat": 36.93,
    "lon": 21.69,
    "desc": "צי משותף של בריטניה, צרפת ורוסיה השמיד את הצי העות׳מאני־מצרי במפרץ נאווארינו, ללא הכרזת מלחמה מפורשת. התבוסה אלצה את העות׳מאנים להכיר ביוון עצמאית, ואחר כך נתנה רוסיה סיוע לתוצאה זו בכוחות יבשה. הקרב היה אחד הקרבות הימיים האחרונים של ספינות מפרשים.",
    "rank": 711
  },
  {
    "id": "anq_ur_nammu",
    "deck": "anchors",
    "title": "אור־נמו וקוד החוקים של אור",
    "start": -2100,
    "end": -2100,
    "date": "בערך 2100 לפנה״ס",
    "place": "אור, מסופוטמיה",
    "lat": 30.963,
    "lon": 46.103,
    "desc": "אור־נמו, מייסד השושלת השלישית של אור, הקים זיגורט ענק לאל הירח ופרסם את קובץ החוקים הכתוב הקדום ביותר שנשמר, כשלוש מאות שנה לפני חמורבי. בקובץ נקבעו בעיקר פיצויים כספיים ולא עונשי גוף. הוא שלט על מסופוטמיה כולה.",
    "rank": 712
  },
  {
    "id": "med_yamen",
    "deck": "anchors",
    "title": "קרב יאמן ונפילת שושלת סונג",
    "start": 1279,
    "end": 1279,
    "date": "1279",
    "place": "יאמן, סין",
    "lat": 22.23,
    "lon": 113.1,
    "desc": "בקרב ימי מול חופי דרום סין הביס הצי המונגולי של שושלת יואן את שרידי חצר סונג. הקיסר הנער האחרון של סונג טבע בים. כך הושלם הכיבוש המונגולי של סין כולה, לראשונה בידי שליט זר.",
    "rank": 713
  },
  {
    "id": "mod_koniggratz",
    "deck": "anchors",
    "title": "קרב קניגרץ",
    "start": 1866,
    "end": 1866,
    "date": "1866",
    "place": "הראדץ קראלובה, צ׳כיה",
    "lat": 50.23,
    "lon": 15.7,
    "desc": "צבא פרוסיה, שהשתמש ברובי מילוי מאחור וברכבות, ניצח את אוסטריה בהחלטיות בתוך שבעה שבועות של מלחמה. התבוסה הוציאה את אוסטריה מגרמניה והעניקה לפרוסיה של ביסמרק עליונות בצפון גרמניה. כעבור שנה הוקמה אוסטריה־הונגריה.",
    "rank": 714
  },
  {
    "id": "anq_pithekoussai",
    "deck": "anchors",
    "title": "המושבה היוונית בפיתקוסאי",
    "start": -770,
    "end": -770,
    "date": "בערך 770 לפנה״ס",
    "place": "אישיה, איטליה",
    "lat": 40.73,
    "lon": 13.89,
    "desc": "סוחרים מאי אובויה ייסדו על האי אישיה שבמפרץ נאפולי את אחת המושבות היווניות הראשונות במערב. הם סחרו במתכות עם האטרוסקים ועם הפיניקים. בקבר במקום נמצא ״גביע נסטור״, ועליו אחת הכתובות היווניות הקדומות.",
    "rank": 715
  },
  {
    "id": "med_khosrow",
    "deck": "anchors",
    "title": "חוסרו הראשון ושיא האימפריה הסאסאנית",
    "start": 531,
    "end": 531,
    "date": "531 לספירה",
    "place": "קטסיפון, האימפריה הסאסאנית (עיראק)",
    "lat": 33.09,
    "lon": 44.58,
    "desc": "חוסרו הראשון עלה לכס בפרס אחרי תקופה של מהומות. הוא ביצע רפורמות במסים ובצבא, הקים תשתיות וחיזק את הממשל. בשלטונו, שנמשך עד 579, הגיעה האימפריה הסאסאנית לשיא כוחה, וניהלה מלחמות עם ביזנטיון.",
    "rank": 716
  },
  {
    "id": "mod_koxinga",
    "deck": "anchors",
    "title": "כיבוש טיוואן בידי קוקסינגה",
    "start": 1662,
    "end": 1662,
    "date": "1662",
    "place": "טאינאן, טיוואן",
    "lat": 23,
    "lon": 120.16,
    "desc": "המצביא ג׳נג צ׳נגגונג, הידוע בשם קוקסינגה, נאמן שושלת מינג שנסוגה, כבש את המבצר ההולנדי זילנדיה לאחר מצור של כתשעה חודשים. ההולנדים איבדו את אחיזתם באי ופינו אותו. משפחת ג׳נג שלטה בטיוואן עד שהאי נכבש בידי שושלת צ׳ינג בשנת 1683.",
    "rank": 717
  },
  {
    "id": "anq_aryabhata",
    "deck": "anchors",
    "title": "האריאבהטיה",
    "start": 499,
    "end": 499,
    "date": "499 לספירה",
    "place": "פאטליפוטרה, הודו",
    "lat": 25.61,
    "lon": 85.14,
    "desc": "המתמטיקאי והאסטרונום אריאבהטה השלים חיבור קצר על חשבון, אלגברה ואסטרונומיה. הוא הציע שכדור הארץ סובב סביב צירו וחישב קירוב מדויק של π. החיבור השפיע על המתמטיקה בעולם האסלאמי ובאירופה. בחיבור גם פתרון משוואות ושיטת חישוב סינוס, והוא היה בין הטקסטים החשובים ביותר של המתמטיקה ההודית.",
    "rank": 718
  },
  {
    "id": "med_danoura",
    "deck": "anchors",
    "title": "קרב דן־נו־אורה",
    "start": 1185,
    "end": 1185,
    "date": "1185",
    "place": "דן־נו־אורה, שימונוסקי (יפן)",
    "lat": 33.96,
    "lon": 130.93,
    "desc": "בקרב ימי במצר שימונוסקי ניצחו כוחות מינאמוטו את שבט טאירה. הקיסר הילד אנטוקו טבע. הניצחון סיים את מלחמת גנפיי והעביר את הכוח האמיתי לאצולה הצבאית.",
    "rank": 719
  },
  {
    "id": "mod_bloodriver",
    "deck": "anchors",
    "title": "קרב נהר הדם",
    "start": 1838,
    "end": 1838,
    "date": "1838",
    "place": "נטאל, דרום אפריקה",
    "lat": -28.12,
    "lon": 30.45,
    "desc": "קבוצת בורים, צאצאים של מתיישבים הולנדים שיצאו מהקייפ במסע הגדול, הביסה צבא זולו של המלך דינגאן. הם הקימו רפובליקה בנטאל, שבריטניה סיפחה אחרי שנים אחדות. הקרב הפך לסמל באידאולוגיה הלאומית של הבורים.",
    "rank": 720
  },
  {
    "id": "anq_mentuhotep",
    "deck": "anchors",
    "title": "איחוד מצרים בידי מנטוהוטפ השני",
    "start": -2055,
    "end": -2055,
    "date": "בערך 2055 לפנה״ס",
    "place": "תבי, מצרים",
    "lat": 25.72,
    "lon": 32.61,
    "desc": "לאחר תקופת פילוג ארוכה כבש מנטוהוטפ השני, שליט תבי, את הצפון ואיחד שוב את מצרים. כך החל הממלכה התיכונה, תקופה של שגשוג, ספרות ובנייה. מקדש המתים שלו בדיר אל־בחרי נחשב להישג אדריכלי מוקדם.",
    "rank": 721
  },
  {
    "id": "med_ashikaga",
    "deck": "anchors",
    "title": "שוגונות אשיקאגה",
    "start": 1338,
    "end": 1338,
    "date": "1338",
    "place": "קיוטו, יפן",
    "lat": 35.012,
    "lon": 135.768,
    "desc": "אשיקאגה טאקאוג׳י, שהתמרד נגד הקיסר גו־דאיגו, הוכרז כשוגון וקבע את מושבו בקיוטו. בתקופת שלטון משפחתו, תקופת מורומאצ׳י, פרחו תיאטרון נו וטקס התה, אך גם פרצו מלחמות פנימיות תכופות.",
    "rank": 722
  },
  {
    "id": "mod_paraguay",
    "deck": "anchors",
    "title": "מלחמת פרגוואי",
    "start": 1864,
    "end": 1870,
    "date": "⁦1864–1870⁩",
    "place": "אסונסיון, פרגוואי",
    "lat": -25.28,
    "lon": -57.63,
    "desc": "פרגוואי בהנהגת פרנסיסקו סולאנו לופס נלחמה נגד ברית משולשת של ברזיל, ארגנטינה ואורוגוואי. המלחמה, מהעקובות מדם בדרום אמריקה, הביאה למותם של חלק גדול מאוכלוסיית פרגוואי, ומדינה זו איבדה שטחים נרחבים. לופס נהרג בקרב האחרון.",
    "rank": 723
  },
  {
    "id": "anq_yungang",
    "deck": "anchors",
    "title": "מערות יונגאנג",
    "start": 460,
    "end": 460,
    "date": "בערך 460 לספירה",
    "place": "דאטונג, סין",
    "lat": 40.11,
    "lon": 113.13,
    "desc": "בתקופת שושלת וויי הצפונית החלו לחצוב מערות מקדש בצוק בדאטונג, בפקודת הנזיר טאן יאו. בקבוצות המערות פסלי בודהה ענקיים, בהשפעה הודית וגנדהארית. יונגאנג מעידה על התיישבות הבודהיזם במרכז סין. בהמשך נחצבו עשרות מערות ואלפי פסלים, והאתר הוכרז כאתר מורשת עולמית.",
    "rank": 724
  },
  {
    "id": "med_igbo",
    "deck": "anchors",
    "title": "הברונזה של איגבו־אוקווּ",
    "start": 900,
    "end": 900,
    "date": "בערך 900 לספירה",
    "place": "איגבו־אוקווּ, ניגריה",
    "lat": 6.01,
    "lon": 7,
    "desc": "בכפר בדרום מזרח ניגריה נתגלו יצירות ברונזה מהמאה ה־9 או ה־10, בעבודת יציקה מורכבת. הן מעידות על חברה מתוחכמת באזור היער, שהייתה מחוברת לרשתות סחר ארוכות. מקור המתכות עדיין נחקר.",
    "rank": 725
  },
  {
    "id": "mod_nerchinsk",
    "deck": "anchors",
    "title": "הסכם נרצ׳ינסק",
    "start": 1689,
    "end": 1689,
    "date": "1689",
    "place": "נרצ׳ינסק, רוסיה",
    "lat": 51.98,
    "lon": 116.58,
    "desc": "הסכם בין רוסיה לאימפריית צ׳ינג, הראשון שנחתם בין סין לבין מעצמה אירופית, קבע את הגבול באזור נהר האמור. רוסיה ויתרה על יישובים באגן האמור ושמרה על קשרי מסחר עם סין. ההסכם הסדיר את היחסים בין המדינות כמעט מאתיים שנה.",
    "rank": 726
  },
  {
    "id": "anq_vultures",
    "deck": "anchors",
    "title": "מצבת הנשרים של אנתום",
    "start": -2450,
    "end": -2450,
    "date": "בערך 2450 לפנה״ס",
    "place": "גירסו, מסופוטמיה",
    "lat": 31.42,
    "lon": 46.17,
    "desc": "אנתום, מלך לגש, ניצח את העיר השכנה אומה והקים מצבת אבן ועליה צבא שומרי, שבויים ונשרים. זהו אחד התיעודים הקדומים ביותר של מלחמה ושל חוזה גבול בין ערים, בדרום מסופוטמיה של תקופה שבה ערים נלחמו על תעלות ושדות.",
    "rank": 727
  },
  {
    "id": "med_tondibi",
    "deck": "anchors",
    "title": "המרוקאים מביסים את סונגהאי",
    "start": 1591,
    "end": 1591,
    "date": "1591",
    "place": "אזור גאו, מאלי",
    "lat": 16.6,
    "lon": -0.1,
    "desc": "צבא מרוקאי, בעל רובים, חצה את הסהרה והביס את צבא אימפריית סונגהאי בקרב טונדיבי. גאו, טימבוקטו וג׳ני נכבשו, והאימפריה התפרקה. הכיבוש פגע במרכזי הלימוד של טימבוקטו, אך לא יצר שלטון יציב.",
    "rank": 728
  },
  {
    "id": "mod_boyaca",
    "deck": "anchors",
    "title": "קרב בויאקה",
    "start": 1819,
    "end": 1819,
    "date": "1819",
    "place": "בויאקה, קולומביה",
    "lat": 5.45,
    "lon": -73.36,
    "desc": "סימון בוליבר חצה עם צבאו את האנדים ואת מישורי הגשמים והביס את הצבא הספרדי בקרב בויאקה. הניצחון שחרר את קולומביה והביא להקמת קולומביה הגדולה, שכללה את ונצואלה, אקוודור ופנמה. זה היה אחד מנקודות המפנה במלחמות העצמאות של דרום אמריקה.",
    "rank": 729
  },
  {
    "id": "anq_tikal",
    "deck": "anchors",
    "title": "סטלה 29 בטיקל",
    "start": 292,
    "end": 292,
    "date": "292 לספירה",
    "place": "טיקל, גואטמלה",
    "lat": 17.22,
    "lon": -89.62,
    "desc": "בטיקל הוקמה אבן חרוטה ועליה תאריך בספירה הארוכה של המאיה, המקביל ל־292 לספירה, הקדום ביותר שנמצא בעיר. התאריך מעיד על מלכות מבוססת ועל מערכת כתב ולוח מתקדמת. בהמשך הפכה טיקל לאחת הערים החשובות של התקופה הקלאסית אצל המאיה.",
    "rank": 730
  },
  {
    "id": "med_harsha",
    "deck": "anchors",
    "title": "שלטון הארשה בקנאוג׳",
    "start": 606,
    "end": 647,
    "date": "⁦606–647⁩ לספירה",
    "place": "קנאוג׳, צפון הודו",
    "lat": 27.07,
    "lon": 79.92,
    "desc": "הארשה ואררדהנה איחד חלק גדול מצפון הודו וקבע את בירתו בקנאוג׳. הוא תמך בהינדואיזם ובבודהיזם ובלימוד. הנזיר הסיני שואנזאנג ביקר בחצרו ותיאר אותו. אחרי מותו התפרקה הממלכה.",
    "rank": 731
  },
  {
    "id": "mod_guadalupe",
    "deck": "anchors",
    "title": "הסכם גוואדלופה הידלגו",
    "start": 1848,
    "end": 1848,
    "date": "1848",
    "place": "מקסיקו סיטי, מקסיקו",
    "lat": 19.48,
    "lon": -99.12,
    "desc": "בתום המלחמה האמריקאית־מקסיקנית ויתרה מקסיקו לארצות הברית על שטחים נרחבים, בהם קליפורניה, נבדה, יוטה וחלקים מאריזונה, ניו מקסיקו וקולורדו, בתמורה ל־15 מיליון דולר. כמעט מחצית מהשטח המקסיקני עבר לארצות הברית. ההסכם הרחיב את שטחה של המדינה לים השקט.",
    "rank": 732
  },
  {
    "id": "anq_lothal",
    "deck": "anchors",
    "title": "נמל לותל בהודו",
    "start": -2400,
    "end": -2400,
    "date": "בערך 2400 לפנה״ס",
    "place": "לותל, הודו",
    "lat": 22.52,
    "lon": 72.25,
    "desc": "בעיר לותל שבגוג׳ראט נחפר מבנה גדול שנחשב לאגן נמל, שדרכו סחרה ציוויליזציית עמק האינדוס עם מסופוטמיה ועם חצי האי ערב. נמצאו חרוזים, חותמות ומשקולות אחידים. פירוש המבנה כנמל שנוי במחלוקת בין החוקרים.",
    "rank": 733
  },
  {
    "id": "med_silla",
    "deck": "anchors",
    "title": "סילה מאחדת את קוריאה",
    "start": 676,
    "end": 676,
    "date": "676 לספירה",
    "place": "גיאונגג׳ו, קוריאה",
    "lat": 35.84,
    "lon": 129.22,
    "desc": "ממלכת סילה, בעזרת סין של טאנג, ניצחה את בקג׳ה ואת גוגוריאו וסילקה את הסינים. זה היה איחוד ראשון של רוב חצי האי הקוריאני. הבירה, גיאונגג׳ו, הייתה מרכז לבודהיזם ולאמנות.",
    "rank": 734
  },
  {
    "id": "mod_satsuma",
    "deck": "anchors",
    "title": "מרד סאטסומה",
    "start": 1877,
    "end": 1877,
    "date": "1877",
    "place": "קגושימה, יפן",
    "lat": 31.6,
    "lon": 130.56,
    "desc": "סאיגו טקאמורי, אחד ממנהיגי שיקום מייג׳י, הנהיג מרד של סמוראים לשעבר נגד הממשלה והצבא החדש שהתבסס על גיוס. הצבא המודרני ניצח את המורדים, וסאיגו מת בקרב האחרון בשירויאמה. המרד היה האחרון של הסמוראים.",
    "rank": 735
  },
  {
    "id": "anq_luoyang_move",
    "deck": "anchors",
    "title": "העברת הבירה ללואויאנג",
    "start": 494,
    "end": 494,
    "date": "494 לספירה",
    "place": "לואויאנג, סין",
    "lat": 34.62,
    "lon": 112.45,
    "desc": "קיסר שיאוון מבית וויי הצפונית העביר את הבירה מפינגצ׳נג ללואויאנג והנהיג הסתגלות לתרבות סינית, בין היתר באמצעות שינוי לבוש ושפה ושמות משפחה. הדבר השפיע על מבנה החברה ועל התפתחות אמנות לונגמן הבודהיסטית.",
    "rank": 736
  },
  {
    "id": "med_jokyu",
    "deck": "anchors",
    "title": "מלחמת ג׳וקיו",
    "start": 1221,
    "end": 1221,
    "date": "1221",
    "place": "קיוטו, יפן",
    "lat": 35.012,
    "lon": 135.768,
    "desc": "הקיסר לשעבר גו־טובה ניסה להשיב לחצר הקיסרית את השלטון מידי הבקופו, שלטון השוגונים בקמקורה, אך צבאות שבט הוג׳ו הביסו אותו במהירות. בעקבות כך חיזק הבקופו את שליטתו בקיוטו. הוא נשאר מוקד הכוח הממשי ביפן יותר ממאה שנה.",
    "rank": 737
  },
  {
    "id": "mod_nader",
    "deck": "anchors",
    "title": "כיבוש דלהי בידי נאדר שאה",
    "start": 1739,
    "end": 1739,
    "date": "1739",
    "place": "דלהי, הודו",
    "lat": 28.65,
    "lon": 77.23,
    "desc": "שליט פרס נאדר שאה הביס את הצבא המוגולי בקרב קארנאל ונכנס לדלהי. בעקבות התקוממות נגד חייליו הורה על טבח בתושבי העיר, והוא שב לפרס עם אוצרות רבים, בהם כס הטווס. האימפריה המוגולית נחלשה ונותרה צל של עצמה.",
    "rank": 738
  },
  {
    "id": "anq_ur_fall",
    "deck": "anchors",
    "title": "נפילת אור השלישית",
    "start": -2004,
    "end": -2004,
    "date": "בערך 2004 לפנה״ס",
    "place": "אור, מסופוטמיה",
    "lat": 30.963,
    "lon": 46.103,
    "desc": "בעקבות בצורת ושחיקת השלטון המרכזי כבשו העילמים את העיר אור ושבו את מלכה, אבי־סין. בכך קרס השלטון האחרון של ערי שומר. על חורבות העיר נכתב שיר קינה ארוך, ״קינה על חורבן אור״, מן היצירות הראשונות מסוגו.",
    "rank": 739
  },
  {
    "id": "med_caracol",
    "deck": "anchors",
    "title": "קראקול מביסה את טיקאל",
    "start": 562,
    "end": 562,
    "date": "562 לספירה",
    "place": "קראקול, בליז",
    "lat": 16.76,
    "lon": -89.12,
    "desc": "לפי כתובות מאיה הביסה העיר קראקול, בסיוע בעלי ברית, את טיקאל, אחת הערים החזקות באזור. התבוסה הביאה לעשרות שנים של נסיגה בטיקאל, והיא דוגמה למאבקי הכוח בין ערי המאיה.",
    "rank": 740
  },
  {
    "id": "mod_seringapatam",
    "deck": "anchors",
    "title": "נפילת סרינגפטם ומותו של טיפו סולטאן",
    "start": 1799,
    "end": 1799,
    "date": "1799",
    "place": "סרינגפטם, הודו",
    "lat": 12.42,
    "lon": 76.69,
    "desc": "כוחות חברת הודו המזרחית הבריטית כבשו את בירת ממלכת מייסור, וטיפו סולטאן, ״נמר מייסור״, נהרג בהגנה על החומות. שליטו ניהל מלחמות ארוכות נגד הבריטים ופיתח רקטות לקרב. נפילתו הרחיבה את השליטה הבריטית בדרום הודו.",
    "rank": 741
  },
  {
    "id": "anq_erlitou",
    "deck": "anchors",
    "title": "ארמון ארליטואו",
    "start": -1750,
    "end": -1750,
    "date": "בערך 1750 לפנה״ס",
    "place": "ארליטואו, סין",
    "lat": 34.69,
    "lon": 112.69,
    "desc": "באתר ארליטואו בעמק הנהר הצהוב נחשפו מתחמי ארמונות, בתי יציקת ברונזה וקברי עילית. יש חוקרים המזהים אותו כבירת שושלת שיה המסורתית, אולם בלי כתובות אין אפשרות להוכיח זאת. זהו המרכז העירוני המוקדם ביותר שנחשף בסין.",
    "rank": 742
  },
  {
    "id": "med_makuria",
    "deck": "anchors",
    "title": "הסכם הבקט בין מצרים לנוביה",
    "start": 652,
    "end": 652,
    "date": "בערך 652 לספירה",
    "place": "דונגולה, נוביה (סודן)",
    "lat": 19.18,
    "lon": 30.48,
    "desc": "אחרי ניסיונות כיבוש כושלים הסכימו המוסלמים בראשות מצרים והממלכה הנוצרית מקוריה על הסכם שקבע חילופי סחורות ומחויבות שנתית של עבדים. ההסכם נמשך כמעט שש מאות שנים, ואפשר למקוריה להישאר נוצרית ועצמאית.",
    "rank": 743
  },
  {
    "id": "anq_kanesh",
    "deck": "anchors",
    "title": "המושבה האשורית בקנש",
    "start": -1900,
    "end": -1900,
    "date": "בערך 1900 לפנה״ס",
    "place": "קולטפה, טורקיה",
    "lat": 38.85,
    "lon": 35.64,
    "desc": "סוחרים מאשור ייסדו בקנש שבאנטוליה מושבת מסחר, ושם החליפו בדים ובדיל בכסף. פעילותם הותירה אלפי לוחות חימר, ובהם מכתבים, חוזים וחשבונות. הם מהמקורות הכתובים הקדומים ביותר על אנטוליה.",
    "rank": 744
  },
  {
    "id": "med_aksumhimyar",
    "deck": "anchors",
    "title": "אקסום כובשת את חמיר",
    "start": 525,
    "end": 525,
    "date": "525 לספירה",
    "place": "ספאר, תימן",
    "lat": 14.2,
    "lon": 44.4,
    "desc": "הממלכה האתיופית אקסום עברה את הים האדום בעידוד ביזנטיון, והביסה את מלך חמיר היהודי דו נואס. הכיבוש הרחיב את השפעת אקסום בדרום ערב, ונחשב לשיא כוחה.",
    "rank": 745
  },
  {
    "id": "mod_mabo",
    "deck": "anchors",
    "title": "פסיקת מאבו",
    "start": 1992,
    "end": 1992,
    "date": "1992",
    "place": "קנברה, אוסטרליה",
    "lat": -35.3,
    "lon": 149.13,
    "desc": "ב־3 ביוני פסק בית המשפט העליון של אוסטרליה בעניין אדי מאבו, תושב איי מאריי במצר טורס, כי זכויות הבעלות של הילידים על אדמות לא נעלמו עם ההשתלטות הבריטית. פסק הדין דחה את העיקרון של ״אדמה של אף אחד״ והוביל לחוק ב־1993 שהכיר ב״זכות ילידית על קרקע״.",
    "rank": 746
  },
  {
    "id": "anq_mari",
    "deck": "anchors",
    "title": "חורבן מארי",
    "start": -1761,
    "end": -1761,
    "date": "בערך 1761 לפנה״ס",
    "place": "תל חרירי, סוריה",
    "lat": 34.55,
    "lon": 40.89,
    "desc": "חמורבי מלך בבל כבש את העיר מארי שעל הפרת והחריב את הארמון המפואר של זמרי־לים. בארמון נמצא ארכיון של יותר מעשרים אלף לוחות, ובהם מכתבים על דיפלומטיה, נבואות ושמות של שבטים. הם מהמקורות החשובים להכרת המאה ה־18 לפנה״ס.",
    "rank": 747
  },
  {
    "id": "med_quirigua",
    "deck": "anchors",
    "title": "קוויריגואה מביסה את קופאן",
    "start": 738,
    "end": 738,
    "date": "738 לספירה",
    "place": "קוויריגואה, גואטמלה",
    "lat": 15.27,
    "lon": -89.04,
    "desc": "שליט קוויריגואה, קאוויל, תפס את שליט קופאן, וואשאקלאחון אוב׳אה קאוויל, והוציא אותו להורג. הניצחון שחרר את קוויריגואה מתלות בקופאן ופגע קשות בכוחה של קופאן, אחת הערים הגדולות של המאיה.",
    "rank": 748
  },
  {
    "id": "mod_raclawice",
    "deck": "anchors",
    "title": "קרב ראצלביצה ומרד קושצ׳ושקו",
    "start": 1794,
    "end": 1794,
    "date": "1794",
    "place": "ראצלביצה, פולין",
    "lat": 50.31,
    "lon": 20.08,
    "desc": "טדאוש קושצ׳ושקו, שלחם גם במלחמת העצמאות האמריקאית, הנהיג מרד נגד רוסיה ופרוסיה והביס צבא רוסי בקרב ראצלביצה בעזרת איכרים חמושים בקלשונים. המרד דוכא בסופו של דבר. ב־1795 חולקה פולין בפעם השלישית ונעלמה מהמפה במשך 123 שנה.",
    "rank": 749
  },
  {
    "id": "new_magna_carta",
    "deck": "anchors",
    "title": "חתימת המגנא כרטא",
    "start": 1215,
    "end": 1215,
    "date": "1215",
    "place": "ראנימיד, אנגליה",
    "lat": 51.445,
    "lon": -0.564,
    "desc": "מלך ג׳ון נאלץ לחתום על מסמך המגביל את סמכויות הכתר מול הברונים. המסמך הניח את הבסיס לעקרון שלטון החוק ולזכויות אדם בעולם האנגלו־סכסי. סעיפים ממנו השפיעו על חוקת ארצות הברית והצהרת זכויות האדם.",
    "rank": 750
  },
  {
    "id": "new_shakespeare",
    "deck": "anchors",
    "title": "הצגת הבכורה של המלט",
    "start": 1601,
    "end": 1601,
    "date": "בערך 1601",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.097,
    "desc": "ויליאם שייקספיר כתב ובימוי את המלט, הנסיך הדני, שהוצגה לראשונה בתיאטרון הגלוב. המחזה נחשב לאחד היצירות הגדולות ביותר בספרות האנגלית. שייקספיר כתב כ־37 מחזות ששינו את התיאטרון העולמי.",
    "rank": 751
  },
  {
    "id": "new_beethoven_9th",
    "deck": "anchors",
    "title": "הביצוע הראשון של הסימפוניה התשיעית של בטהובן",
    "start": 1824,
    "end": 1824,
    "date": "1824",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.37,
    "desc": "לודוויג ואן בטהובן ניצח על הביצוע הראשון של הסימפוניה התשיעית, שכוללת את ׳אוד לשמחה׳ של שילר. בטהובן היה כבר חירש כמעט לחלוטין בעת הביצוע. היצירה הפכה לסמל אוניברסלי לאחווה ולתקווה, ומנגינתה היא ההמנון של האיחוד האירופי.",
    "rank": 752
  },
  {
    "id": "new_cinema",
    "deck": "anchors",
    "title": "ההקרנה הראשונה של האחים לומייר",
    "start": 1895,
    "end": 1895,
    "date": "1895",
    "place": "פריז, צרפת",
    "lat": 48.871,
    "lon": 2.342,
    "desc": "אוגוסט ולואי לומייר הקרינו עשרה סרטים קצרים בפני קהל משלם בבית הקפה הגראן קפה בפריז. בין הסרטים היו ׳יציאת הפועלים מהמפעל׳ ו׳הגעת הרכבת לתחנה׳. ההקרנה נחשבת ללידתו של הקולנוע כמדיום ציבורי.",
    "rank": 753
  },
  {
    "id": "new_pasteur",
    "deck": "anchors",
    "title": "ניסוי הפסטוריזציה של לואי פסטר",
    "start": 1862,
    "end": 1862,
    "date": "1862",
    "place": "פריז, צרפת",
    "lat": 48.846,
    "lon": 2.355,
    "desc": "לואי פסטר הוכיח שחיידקים גורמים להתקלקלות מזון ומחלות, והפריך סופית את תיאוריית הייצור הספונטני. פסטר פיתח את שיטת החיטוי בחום (פסטוריזציה) ומאוחר יותר חיסונים נגד כלבת ואנתרקס. עבודתו הניחה את היסודות למיקרוביולוגיה ולרפואה המודרנית.",
    "rank": 754
  },
  {
    "id": "new_telephone",
    "deck": "anchors",
    "title": "המצאת הטלפון",
    "start": 1876,
    "end": 1876,
    "date": "1876",
    "place": "בוסטון, מסצ׳וסטס",
    "lat": 42.36,
    "lon": -71.06,
    "desc": "אלכסנדר גרהם בל רשם פטנט על הטלפון ושידר את המשפט הראשון לעוזרו תומס ווטסון. ההמצאה חוללה מהפכה בתקשורת ואפשרה שיחה בזמן אמת בין אנשים בכל רחבי העולם. הטלפון הפך תוך עשורים לכלי הכרחי בחיי היומיום.",
    "rank": 755
  },
  {
    "id": "new_marconi",
    "deck": "anchors",
    "title": "שידור הרדיו הראשון מעבר לאוקיינוס האטלנטי",
    "start": 1901,
    "end": 1901,
    "date": "1901",
    "place": "סנט ג׳ונס, ניופאונדלנד",
    "lat": 47.57,
    "lon": -52.71,
    "desc": "גוליילמו מרקוני קלט אות מורס שנשלח מקורנוול שבאנגליה לסנט ג׳ונס שבניופאונדלנד, וכך הוכיח שגלי רדיו יכולים לעבור מעבר לאוקיינוס. הישג זה פתח את עידן התקשורת האלחוטית. מרקוני זכה בפרס נובל לפיזיקה ב־1909.",
    "rank": 756
  },
  {
    "id": "new_transistor",
    "deck": "anchors",
    "title": "המצאת הטרנזיסטור",
    "start": 1947,
    "end": 1947,
    "date": "1947",
    "place": "מוריי היל, ניו ג׳רזי",
    "lat": 40.683,
    "lon": -74.401,
    "desc": "ג׳ון בארדין, וולטר בראטיין ווויליאם שוקלי, חוקרים במעבדות בל, הדגימו את הטרנזיסטור הראשון שפעל. ההמצאה החליפה את שפופרות הוואקום ואפשרה מחשבים קטנים, זולים ויעילים. הטרנזיסטור הוא אבן היסוד של מהפכת המחשוב.",
    "rank": 757
  },
  {
    "id": "new_great_zimbabwe",
    "deck": "anchors",
    "title": "שגשוג זימבבואה הגדולה",
    "start": 1250,
    "end": 1350,
    "date": "בערך ⁦1250–1350⁩",
    "place": "זימבבואה הגדולה, זימבבואה",
    "lat": -20.267,
    "lon": 30.933,
    "desc": "מתחם האבן הגדול ביותר בדרום הסהרה שימש כבירת ממלכה עשירה ששלטה בסחר הזהב בין הפנים לחופי מזרח אפריקה. החומות נבנו ללא טיח מאבני גרניט מסותתות. באתר התגלו ממצאים מסין, מפרס ומעולם הסוואהילי.",
    "rank": 758
  },
  {
    "id": "new_benin_bronzes",
    "deck": "anchors",
    "title": "שיא ממלכת בנין ופסלי הברונזה",
    "start": 1440,
    "end": 1550,
    "date": "בערך ⁦1440–1550⁩",
    "place": "בנין סיטי, ניגריה",
    "lat": 6.335,
    "lon": 5.627,
    "desc": "ממלכת בנין הגיעה לשיאה בימי אובה אווארה ובניו, עם חצר מלכותית מפוארת ומסורת ייחודית של יציקת ברונזה ושנהב. אלפי פסלי ברונזה תיעדו את ההיסטוריה והפולחן המלכותי. בריטים בזזו אותם ב־1897 במסע עונשין, ויצירות רבות מוחזרות כיום.",
    "rank": 759
  },
  {
    "id": "new_swahili_coast",
    "deck": "anchors",
    "title": "שגשוג ערי המסחר הסוואהיליות",
    "start": 1000,
    "end": 1400,
    "date": "בערך ⁦1000–1400⁩",
    "place": "קילווה, טנזניה",
    "lat": -8.957,
    "lon": 39.522,
    "desc": "רשת עירונית של נמלי סחר ניצבה לאורך חוף מזרח אפריקה, מסומליה ועד מוזמביק. ערים כמו קילווה, מומבסה וזנזיבר סחרו בזהב, שנהב ועבדים עם הודו, פרס וסין. התרבות הסוואהילית שילבה אפריקה עם עולם האוקיינוס ההודי.",
    "rank": 760
  },
  {
    "id": "new_zulu",
    "deck": "anchors",
    "title": "עלייתה של אימפריית הזולו",
    "start": 1818,
    "end": 1828,
    "date": "בערך ⁦1818–1828⁩",
    "place": "קוואזולו, דרום אפריקה",
    "lat": -28.53,
    "lon": 30.89,
    "desc": "שאקה זולו איחד שבטים ויצר ממלכה צבאית חזקה בדרום־מזרח אפריקה. הוא שינה את שיטות הלחימה והנהיג גיוס המוני. המפנגה, גל הנדידות האלימות שנגרם מהתפשטות הזולו, שינה את פני כל דרום אפריקה.",
    "rank": 761
  },
  {
    "id": "new_songhai_empire",
    "deck": "anchors",
    "title": "סוני עלי וממלכת סונגהאי",
    "start": 1464,
    "end": 1492,
    "date": "בערך ⁦1464–1492⁩",
    "place": "גאו, מאלי",
    "lat": 16.27,
    "lon": -0.044,
    "desc": "סוני עלי כבש את טימבוקטו וג׳נה והפך את סונגהאי לאימפריה הגדולה ביותר שהכירה מערב אפריקה. ממשיכו אסכיה מוחמד הפך אותה למרכז דת ולמידה. האימפריה שלטה במסחר הזהב והמלח שחצה את הסהרה.",
    "rank": 762
  },
  {
    "id": "new_nok",
    "deck": "anchors",
    "title": "תרבות נוק בניגריה",
    "start": -500,
    "end": 200,
    "date": "בערך ⁦500⁩ לפנה״ס – ⁦200⁩ לספירה",
    "place": "נוק, ניגריה",
    "lat": 9.67,
    "lon": 8,
    "desc": "תרבות נוק היא הראשונה שידוע שהתיכה ברזל בצפון־מערב אפריקה, והיא הותירה פסלי טרקוטה מרשימים ובלתי רגילים. פסלי הטרקוטה הם מהעתיקים ביותר באפריקה שמדרום לסהרה. התרבות פרחה באזור המרכזי של ניגריה של ימינו.",
    "rank": 763
  },
  {
    "id": "new_samarkand",
    "deck": "anchors",
    "title": "תימור בונה את סמרקנד",
    "start": 1370,
    "end": 1405,
    "date": "בערך ⁦1370–1405⁩",
    "place": "סמרקנד, אוזבקיסטן",
    "lat": 39.654,
    "lon": 66.96,
    "desc": "תימור לנג הפך את סמרקנד לבירת אימפריה שנמתחה מהודו ועד טורקיה. הוא הביא אליה אומנים ואדריכלים מכל הארצות שכבש, ובנה מסגדים ומדרסות מפוארים. כיכר הרגיסטן שלה נחשבת לאחד הפלאים האדריכליים של מרכז אסיה.",
    "rank": 764
  },
  {
    "id": "new_silk_road",
    "deck": "anchors",
    "title": "פריחת דרך המשי",
    "start": -130,
    "end": -130,
    "date": "בערך 130 לפנה״ס",
    "place": "דונחואנג, סין",
    "lat": 40.142,
    "lon": 94.662,
    "desc": "ג׳אנג צ׳יאן, שגריר שושלת האן, חזר ממסע ארוך למרכז אסיה, והמידע שהביא פתח קשרי מסחר סדירים לאורך דרך המשי. הנתיב קישר את סין לפרס, הודו ורומא, ולאורכו עברו משי, תבלינים, דתות ומחלות. זו הייתה רשת המסחר הארוכה בעולם העתיק.",
    "rank": 765
  },
  {
    "id": "new_bukhara",
    "deck": "anchors",
    "title": "בוּכָרָה כמרכז למידה אסלאמי",
    "start": 892,
    "end": 999,
    "date": "בערך ⁦892–999⁩ לספירה",
    "place": "בוכרה, אוזבקיסטן",
    "lat": 39.774,
    "lon": 64.422,
    "desc": "בתקופת שושלת הסאמאנים הפכה בוכרה למרכז תרבות, פילוסופיה ומדע מוביל בעולם המוסלמי. אבן סינא (אוויצנה) ורודקי כתבו שם את יצירותיהם. העיר הייתה תחנה מרכזית בדרך המשי ומרכז סחר חשוב בין מזרח למערב.",
    "rank": 766
  },
  {
    "id": "new_kokand",
    "deck": "anchors",
    "title": "הכיבוש הרוסי של מרכז אסיה",
    "start": 1865,
    "end": 1876,
    "date": "⁦1865–1876⁩",
    "place": "טשקנט, אוזבקיסטן",
    "lat": 41.299,
    "lon": 69.24,
    "desc": "צבא הצאר כבש את חאנות בוכרה, חיווה וקוקנד ואת הנסיכות הטורקמניות. הכיבוש שם קץ לממלכות דרך המשי ההיסטוריות וסיפח את מרכז אסיה לאימפריה הרוסית. האזור הפך לספק כותנה לתעשייה הרוסית, ויצר מורשת שהשפיעה על האזור עד ימינו.",
    "rank": 767
  },
  {
    "id": "new_aral",
    "deck": "anchors",
    "title": "התייבשות ים אראל",
    "start": 1960,
    "end": 2010,
    "date": "⁦1960–2010⁩",
    "place": "ים אראל, אוזבקיסטן/קזחסטן",
    "lat": 45,
    "lon": 59,
    "desc": "הסטת מי הנהרות אמו דריא וסיר דריא להשקיית שדות כותנה סובייטיים גרמה לאסון סביבתי עצום: ים אראל, שהיה אחד מארבעת האגמים הגדולים בעולם, התכווץ לעשירית משטחו. עיירות דייגים הפכו למדבר מלוח, ורעלים נחשפו לאוויר.",
    "rank": 768
  },
  {
    "id": "new_great_game",
    "deck": "anchors",
    "title": "המשחק הגדול באפגניסטן",
    "start": 1839,
    "end": 1842,
    "date": "⁦1839–1842⁩",
    "place": "קאבול, אפגניסטן",
    "lat": 34.53,
    "lon": 69.17,
    "desc": "בריטניה פלשה לאפגניסטן כחלק מהתחרות הגיאופוליטית עם רוסיה על השליטה במרכז אסיה. הכוח הבריטי נמחק כמעט לחלוטין בנסיגה מקאבול, באחת התבוסות הגדולות ביותר של האימפריה הבריטית. אפגניסטן נשארה חיץ בין האימפריות.",
    "rank": 769
  },
  {
    "id": "new_kushan",
    "deck": "anchors",
    "title": "האימפריה הכושאנית",
    "start": 30,
    "end": 375,
    "date": "בערך ⁦30–375⁩ לספירה",
    "place": "באלח׳, אפגניסטן",
    "lat": 36.758,
    "lon": 66.898,
    "desc": "האימפריה הכושאנית שלטה מאפגניסטן ועד הגנגס וחיברה את העולם ההלניסטי, ההודי והסיני. תחת קנישקה הגדול פרחה הבודהיזם ושגשג הסחר בדרך המשי. הפסלים של גנדהארה, ששילבו אמנות יוונית והודית, הם מהיצירות הבולטות שלה.",
    "rank": 770
  },
  {
    "id": "new_majapahit",
    "deck": "anchors",
    "title": "שגשוג אימפריית מג׳אפהית",
    "start": 1293,
    "end": 1389,
    "date": "בערך ⁦1293–1389⁩",
    "place": "טרוולן, מזרח ג׳אווה",
    "lat": -7.763,
    "lon": 112.39,
    "desc": "מג׳אפהית הייתה אימפריה ימית שהשתרעה על רוב ארכיפלג האינדונזי של ימינו. תחת גאג׳ה מאדה ופראפנצ׳ה הגיעה לשיאה, עם שליטה בסחר התבלינים. ירידתה המאוחרת פינתה את הדרך לחדירת האסלאם לג׳אווה.",
    "rank": 771
  },
  {
    "id": "new_maori",
    "deck": "anchors",
    "title": "הגעת המאורים לאוטיארואה",
    "start": 1250,
    "end": 1300,
    "date": "בערך ⁦1250–1300⁩",
    "place": "מפרץ פובנקס, ניו זילנד",
    "lat": -37.8,
    "lon": 175.3,
    "desc": "מהגרים פולינזיים חצו את האוקיינוס השקט בסירות מפרש (ואקה) והגיעו לניו זילנד, הנקראת בלשונם אוטיארואה. הם פיתחו תרבות ייחודית מותאמת לאקלים הקריר יחסית, כולל קיבורי עץ מעוטרים, האקה ומערכת שבטים. ניו זילנד הייתה אחת מפיסות היבשה האחרונות שנגלו בידי בני אדם.",
    "rank": 772
  },
  {
    "id": "new_bagan",
    "deck": "anchors",
    "title": "ממלכת באגאן ובניית אלפי המקדשים",
    "start": 1057,
    "end": 1287,
    "date": "בערך ⁦1057–1287⁩",
    "place": "באגאן, מיאנמר",
    "lat": 21.172,
    "lon": 94.859,
    "desc": "מלך אנאוורתה איחד את בורמה בפעם הראשונה ואימץ את הבודהיזם של תרוואדה. במשך מאתיים שנה נבנו במישור באגאן למעלה מעשרת אלפים מקדשים ופגודות. עד היום נותרו יותר מ־2,200, והם מהווים אחד מאתרי המקדשים הצפופים ביותר בעולם.",
    "rank": 773
  },
  {
    "id": "new_malacca",
    "deck": "anchors",
    "title": "ייסוד סולטנות מלאקה",
    "start": 1400,
    "end": 1400,
    "date": "בערך 1400",
    "place": "מלאקה, מלזיה",
    "lat": 2.196,
    "lon": 102.251,
    "desc": "פארמשוארה ייסד את סולטנות מלאקה במצר האסטרטגי שבין סומטרה לחצי האי המלאי. העיר הפכה לנמל הסחר הגדול ביותר בדרום־מזרח אסיה, מקום מפגש בין סוחרים סינים, הודים וערבים. כיבושה בידי הפורטוגלים ב־1511 פתח את העידן הקולוניאלי באזור.",
    "rank": 774
  },
  {
    "id": "new_sukhothai",
    "deck": "anchors",
    "title": "ממלכת סוקוטאי ומלך ראם קמהנג",
    "start": 1238,
    "end": 1298,
    "date": "בערך ⁦1238–1298⁩",
    "place": "סוקוטאי, תאילנד",
    "lat": 17.014,
    "lon": 99.703,
    "desc": "ממלכת סוקוטאי היא הממלכה התאית הראשונה המשמעותית, שהשתחררה משלטון חמרי. מלך ראם קמהנג יצר את האלפבית התאי והרחיב את הממלכה. סוקוטאי נחשבת לערש התרבות התאילנדית.",
    "rank": 775
  },
  {
    "id": "new_aboriginal",
    "deck": "anchors",
    "title": "ציורי הסלע העתיקים באוסטרליה",
    "start": -28000,
    "end": -28000,
    "date": "בערך 28,000 לפנה״ס",
    "place": "קקאדו, אוסטרליה",
    "lat": -12.83,
    "lon": 132.88,
    "desc": "האבוריג׳ינים של אוסטרליה יצרו את אחד ממסורות האמנות הרציפות הארוכות ביותר בהיסטוריה האנושית, עם ציורי סלע בני עשרות אלפי שנים. אתרי קקאדו ושטח ארנהם כוללים אלפי ציורים המתעדים חיות, ציד ודמויות רוח. מסורת ה׳זמן החלום׳ מקשרת את ההווה למיתוסים העתיקים.",
    "rank": 776
  },
  {
    "id": "new_easter_island",
    "deck": "anchors",
    "title": "הקמת פסלי המואי באי הפסחא",
    "start": 1250,
    "end": 1500,
    "date": "בערך ⁦1250–1500⁩",
    "place": "אי הפסחא, צ׳ילה",
    "lat": -27.121,
    "lon": -109.366,
    "desc": "תושבי ראפא נוי יצרו והעבירו כ־900 פסלי אבן ענקיים (מואי), שגובהם הממוצע ארבעה מטר ומשקלם טונות רבות. הפסלים ייצגו אבות שבט מואלהים. ניצול מופרז של המשאבים באי המבודד גרם ככל הנראה לקריסה חברתית.",
    "rank": 777
  },
  {
    "id": "new_nazca",
    "deck": "anchors",
    "title": "קווי הנסקה בפרו",
    "start": -200,
    "end": 600,
    "date": "בערך 200 לפנה״ס – 600 לספירה",
    "place": "נסקה, פרו",
    "lat": -14.739,
    "lon": -75.13,
    "desc": "תרבות נסקה חקקה במדבר הפרואני מאות גיאוגליפים ענקיים — דמויות בעלי חיים, צמחים וקווים ישרים — הנראים רק ממעוף הציפור. חלקם באורך מאות מטרים. מטרתם המדויקת לא ידועה, אך ייתכן שקשורה לפולחן מים או אסטרונומיה.",
    "rank": 778
  },
  {
    "id": "new_tiwanaku",
    "deck": "anchors",
    "title": "שגשוג טיוואנאקו",
    "start": 500,
    "end": 900,
    "date": "בערך ⁦500–900⁩ לספירה",
    "place": "טיוואנאקו, בוליביה",
    "lat": -16.555,
    "lon": -68.674,
    "desc": "טיוואנאקו, ששכנה על שפת אגם טיטיקאקה בגובה קרוב ל־4,000 מטר, הייתה מרכז תרבותי ומדיני ששלט על חלקים נרחבים באנדים. היא פיתחה חקלאות מתקדמת בתנאי קיצון ובנתה מבנים מונומנטליים כמו שער השמש. טיוואנאקו השפיעה עמוקות על התרבויות שקמו אחריה, כולל האינקה.",
    "rank": 779
  },
  {
    "id": "new_potosi",
    "deck": "anchors",
    "title": "מכרות הכסף של פוטוסי",
    "start": 1545,
    "end": 1650,
    "date": "⁦1545–1650⁩",
    "place": "פוטוסי, בוליביה",
    "lat": -19.586,
    "lon": -65.754,
    "desc": "גילוי מרבצי כסף עצומים בהר סרו ריקו הפך את פוטוסי לאחת הערים הגדולות בעולם. הכסף ממנה מימן את האימפריה הספרדית ושינה את הכלכלה העולמית. מיליוני עובדי כפייה ילידים ואפריקאים עבדו בתנאים קשים במכרות.",
    "rank": 780
  },
  {
    "id": "new_tupac_amaru",
    "deck": "anchors",
    "title": "מרד טופאק אמארו השני",
    "start": 1780,
    "end": 1781,
    "date": "⁦1780–1781⁩",
    "place": "קוסקו, פרו",
    "lat": -13.52,
    "lon": -71.968,
    "desc": "חוסה גבריאל קונדורקאנקי, שנקרא טופאק אמארו השני, הנהיג את המרד הילידי הגדול ביותר באמריקה הדרומית נגד השלטון הספרדי. המרד נכשל והוא הוצא להורג ברבים, אך הדהים את השלטונות. דמותו הפכה לסמל מאבק בדרום אמריקה.",
    "rank": 781
  },
  {
    "id": "new_chaco",
    "deck": "anchors",
    "title": "בנייני פואבלו בוניטו בקניון צ׳אקו",
    "start": 850,
    "end": 1150,
    "date": "בערך ⁦850–1150⁩ לספירה",
    "place": "קניון צ׳אקו, ניו מקסיקו",
    "lat": 36.06,
    "lon": -107.961,
    "desc": "תרבות הפואבלו הקדומה בנתה בקניון צ׳אקו מבני אבן רב־קומתיים ובהם מאות חדרים וקיבות טקסיות. הבניין הגדול, פואבלו בוניטו, היה המבנה הגדול ביותר בצפון אמריקה עד המאה ה־19. רשת כבישים ישרים קישרה את האתר לעשרות יישובי לוואי.",
    "rank": 782
  },
  {
    "id": "new_khmer_fall",
    "deck": "anchors",
    "title": "נפילת אנגקור",
    "start": 1431,
    "end": 1431,
    "date": "1431",
    "place": "אנגקור, קמבודיה",
    "lat": 13.412,
    "lon": 103.866,
    "desc": "ממלכת אַיּוּטָיָה (סיאם) כבשה את אנגקור, בירת האימפריה החמרית. האימפריה, ששלטה במשך שישה מאות שנה בדרום־מזרח אסיה, התרוקנה מתושביה. הסיבות כללו גם בצורות, קריסת מערכת ההשקיה וסחר ימי שעקף את המרכז היבשתי.",
    "rank": 783
  },
  {
    "id": "new_zheng_he",
    "deck": "anchors",
    "title": "מסעות ג׳נג חה",
    "start": 1405,
    "end": 1433,
    "date": "⁦1405–1433⁩",
    "place": "נאנג׳ינג, סין",
    "lat": 32.06,
    "lon": 118.796,
    "desc": "האדמירל ג׳נג חה הוביל שבע משלחות ימיות ענקיות מטעם שושלת מינג לדרום־מזרח אסיה, הודו, פרס ומזרח אפריקה. הצי כלל ספינות גדולות פי כמה מאלה של קולומבוס. סין הפסיקה את המסעות לאחריהם, ויש הרואים בכך את ההחמצה הגדולה של ההיסטוריה הימית.",
    "rank": 784
  },
  {
    "id": "new_mona_lisa",
    "deck": "anchors",
    "title": "ציור המונה ליזה",
    "start": 1503,
    "end": 1519,
    "date": "בערך ⁦1503–1519⁩",
    "place": "פירנצה, איטליה",
    "lat": 43.77,
    "lon": 11.25,
    "desc": "לאונרדו דה וינצ׳י צייר את דיוקנה של ליזה גרדיני, אשת סוחר פירנצאי. הטכניקה החדשנית של ספומאטו יצרה את החיוך החמקמק. הציור, שתלוי כיום במוזיאון הלובר, הוא יצירת האמנות המפורסמת ביותר בעולם.",
    "rank": 785
  },
  {
    "id": "new_mozart",
    "deck": "anchors",
    "title": "הופעות הילד המוצרט ברחבי אירופה",
    "start": 1762,
    "end": 1766,
    "date": "⁦1762–1766⁩",
    "place": "זלצבורג, אוסטריה",
    "lat": 47.798,
    "lon": 13.044,
    "desc": "וולפגנג אמדאוס מוצרט, פלא מוזיקלי בן שש, יצא עם אביו ואחותו למסע הופעות בחצרות המלכותיות של אירופה. הוא הלחין את הסונטות הראשונות בגיל שמונה וכתב למעלה מ־600 יצירות בחייו הקצרים. מוצרט שינה את פני המוזיקה הקלאסית.",
    "rank": 786
  },
  {
    "id": "new_rembrandt",
    "deck": "anchors",
    "title": "ציור ׳משמר הלילה׳ של רמברנדט",
    "start": 1642,
    "end": 1642,
    "date": "1642",
    "place": "אמסטרדם, הולנד",
    "lat": 52.37,
    "lon": 4.885,
    "desc": "רמברנדט ואן ריין צייר את ׳משמר הלילה׳, דיוקן קבוצתי דרמטי ופורץ דרך של ליגיון ירי באמסטרדם. הציור היה מהפכני בשימוש בתנועה ותאורה. רמברנדט, מענקי עידן הזהב ההולנדי, פרש את גבולות הדיוקן, הנוף והחריטה.",
    "rank": 787
  },
  {
    "id": "new_mayan_calendar",
    "deck": "anchors",
    "title": "חישוב לוח השנה של המאיה",
    "start": -250,
    "end": -250,
    "date": "בערך 250 לפנה״ס",
    "place": "אישפה, גואטמלה",
    "lat": 15.667,
    "lon": -89.633,
    "desc": "ציוויליזציית המאיה פיתחה מערכת לוח שנה מורכבת שכללה ספירה ארוכה, לוח טקסי (צולקין) ולוח שמשי (האב). הם היו מהראשונים בעולם להשתמש ברעיון האפס. הדיוק האסטרונומי שלהם היה מהגבוהים ביותר בעולם העתיק.",
    "rank": 788
  },
  {
    "id": "new_hagia_irene",
    "deck": "anchors",
    "title": "חורבן פומפיי",
    "start": 79,
    "end": 79,
    "date": "79 לספירה",
    "place": "פומפיי, איטליה",
    "lat": 40.749,
    "lon": 14.485,
    "desc": "התפרצות הר הגעש וזוב קברה את ערי פומפיי והרקולנאום תחת שכבת אפר עבה. אלפי תושבים נספו. האתר שהתגלה ב־1748 משוחזר יוצא מן הכלל ומספק הצצה נדירה לחיי יומיום ברומא העתיקה.",
    "rank": 789
  },
  {
    "id": "new_kwame_nkrumah",
    "deck": "anchors",
    "title": "הקונגרס הפאן־אפריקאי החמישי",
    "start": 1945,
    "end": 1945,
    "date": "1945",
    "place": "מנצ׳סטר, אנגליה",
    "lat": 53.483,
    "lon": -2.244,
    "desc": "הקונגרס הפאן־אפריקאי בהנהגת קוואמי נקרומה וג׳ומו קנייאטה דרש לראשונה עצמאות מלאה לעמי אפריקה ולא רק רפורמות. הוועידה הפכה לנקודת מפנה בתנועת השחרור האפריקאית. תוך שני עשורים רוב אפריקה השיגה עצמאות.",
    "rank": 790
  },
  {
    "id": "new_srivijaya_peak",
    "deck": "anchors",
    "title": "בניית מקדש פרמבנאן",
    "start": 850,
    "end": 850,
    "date": "בערך 850 לספירה",
    "place": "יוגיאקרטה, אינדונזיה",
    "lat": -7.752,
    "lon": 110.491,
    "desc": "ממלכת מטאראם ההינדואית בנתה את פרמבנאן, מתחם המקדשים ההינדואי הגדול ביותר בדרום־מזרח אסיה. מתחם של 240 מקדשים הוקדש לשיווה, ויש בו תבליטים המספרים את הרמאיאנה. הוא נבנה כמענה בודהיסטי לבורובודור הסמוך.",
    "rank": 791
  },
  {
    "id": "new_nan_madol",
    "deck": "anchors",
    "title": "בניית נאן מאדול",
    "start": 1200,
    "end": 1500,
    "date": "בערך ⁦1200–1500⁩",
    "place": "פונפיי, מיקרונזיה",
    "lat": 6.843,
    "lon": 158.335,
    "desc": "שושלת סאודלור בנתה עיר של 92 אִיֵּי אבן מלאכותיים על שונית אלמוגים מחוץ לחוף פונפיי. המבנים בנויים מעמודי בזלת שמשקלם עד 50 טון, ושימשו כמרכז מנהלי, דתי וקבורתי. נאן מאדול מכונה ׳ונציה של האוקיינוס השקט׳.",
    "rank": 792
  },
  {
    "id": "new_versailles",
    "deck": "anchors",
    "title": "בניית ארמון ורסאי",
    "start": 1661,
    "end": 1710,
    "date": "⁦1661–1710⁩",
    "place": "ורסאי, צרפת",
    "lat": 48.805,
    "lon": 2.12,
    "desc": "לואי הי״ד הפך את לודג׳ הציד של אביו לארמון הגדול ביותר באירופה וריכז בו את חצר המלוכה הצרפתית. הארמון שימש כמכשיר שליטה: האצולה נכלאה בטקסי חצר הרחק מאחוזותיהם. ורסאי הפך לסמל למונרכיה האבסולוטית ולמותרות שהובילו למהפכה הצרפתית.",
    "rank": 793
  },
  {
    "id": "new_khmer_rouge_trial",
    "deck": "anchors",
    "title": "הכרה בינלאומית ברצח העם בקמבודיה",
    "start": 2018,
    "end": 2018,
    "date": "2018",
    "place": "פנום פן, קמבודיה",
    "lat": 11.556,
    "lon": 104.917,
    "desc": "בית הדין בחסות האו״ם הרשיע את מנהיגי החמר האדום ברצח עם, אחרי ארבעים שנה מסוף המשטר שהרג כשני מיליון בני אדם. נואון צ׳אה וחיאו סאמפאן נידונו למאסר עולם. זו הייתה הפעם השנייה שבית דין בינלאומי קבע רצח עם מאז רואנדה.",
    "rank": 794
  },
  {
    "id": "new_meroe",
    "deck": "anchors",
    "title": "ממלכת מרואה ופירמידות נוביה",
    "start": -270,
    "end": 350,
    "date": "בערך 270 לפנה״ס – 350 לספירה",
    "place": "מרואה, סודן",
    "lat": 16.938,
    "lon": 33.749,
    "desc": "ממלכת כוש העבירה את בירתה לדרום, למרואה, ופיתחה תרבות ייחודית ששילבה השפעות מצריות עם מסורות מקומיות. במרואה הניבו ברזל ובנו עשרות פירמידות חדות. הם פיתחו כתב משלהם, שטרם פוענח במלואו.",
    "rank": 795
  },
  {
    "id": "new_mapungubwe",
    "deck": "anchors",
    "title": "ממלכת מאפונגובווה",
    "start": 1075,
    "end": 1220,
    "date": "בערך ⁦1075–1220⁩",
    "place": "מאפונגובווה, דרום אפריקה",
    "lat": -22.192,
    "lon": 29.238,
    "desc": "מאפונגובווה הייתה ממלכה עשירה ששלטה בסחר הזהב והשנהב בצפון דרום אפריקה של ימינו. קרנף הזהב המפורסם שנמצא בגבעה מעיד על חברה מרובדת ותרבות חומרית מפותחת. היא קדמה לזימבבואה הגדולה ונחשבת למייסדת מסורת הזהב בדרום אפריקה.",
    "rank": 796
  },
  {
    "id": "new_verdi_aida",
    "deck": "anchors",
    "title": "הצגת הבכורה של אאידה",
    "start": 1871,
    "end": 1871,
    "date": "1871",
    "place": "קהיר, מצרים",
    "lat": 30.042,
    "lon": 31.234,
    "desc": "ג׳וזפה ורדי הלחין את האופרה אאידה לרגל חנוכת בית האופרה החדש בקהיר, חלק מחגיגות תעלת סואץ. האופרה עוסקת בקונפליקט בין אהבה לנאמנות לאומית על רקע מלחמה בין מצרים לאתיופיה. אאידה הפכה לאחת האופרות המבוצעות ביותר בעולם.",
    "rank": 797
  },
  {
    "id": "new_mongol_post",
    "deck": "anchors",
    "title": "הדואר המונגולי — רשת היאם",
    "start": 1234,
    "end": 1234,
    "date": "בערך 1234",
    "place": "קרקורום, מונגוליה",
    "lat": 47.2,
    "lon": 102.83,
    "desc": "אוגדיי חאן הקים את רשת היאם, מערכת תחנות דואר ורכיבה לאורך האימפריה המונגולית. שליחים החליפו סוסים כל 40 קילומטר ויכלו לעבור 300 קילומטר ביום. הרשת חיברה את סין לפרס ושימשה מאוחר יותר את מרקו פולו.",
    "rank": 798
  },
  {
    "id": "new_bamiyan",
    "deck": "anchors",
    "title": "פסלי הבודהה של באמיאן",
    "start": 507,
    "end": 554,
    "date": "בערך ⁦507–554⁩ לספירה",
    "place": "באמיאן, אפגניסטן",
    "lat": 34.832,
    "lon": 67.827,
    "desc": "פסלי בודהה ענקיים, בגובה 55 ו־38 מטר, נחצבו בצוקי עמק באמיאן על דרך המשי. הם שילבו אמנות הלניסטית, פרסית והודית ושימשו מוקד עלייה לרגל בודהיסטי. הטאליבן הרסו אותם ב־2001, מה שזעזע את העולם.",
    "rank": 799
  },
  {
    "id": "new_almaty",
    "deck": "anchors",
    "title": "ניסוי הגרעין הסובייטי הראשון",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "סמיפלטינסק, קזחסטן",
    "lat": 50.07,
    "lon": 78.43,
    "desc": "ברית המועצות פוצצה את פצצת הגרעין הראשונה שלה באתר הניסויים בסמיפלטינסק שבקזחסטן, ושברה את המונופול האמריקני על הנשק הגרעיני. האתר שימש ליותר מ־450 ניסויים עד 1989. התוצאות הבריאותיות והסביבתיות משפיעות על תושבי האזור עד היום.",
    "rank": 800
  },
  {
    "id": "gr_troy_war",
    "deck": "greco",
    "title": "מלחמת טרויה",
    "start": -1194,
    "end": -1184,
    "date": "בערך ⁦1194–1184⁩ לפנה״ס",
    "place": "טרויה, אנטוליה",
    "lat": 39.957,
    "lon": 26.239,
    "desc": "מלחמת טרויה, כפי שהועלתה על הכתב באיליאדה של הומרוס, הייתה מצור ארוך שניהלו היוונים נגד העיר טרויה. ההיסטוריונים חלוקים אם הייתה מלחמה בפועל, אך חפירות ארכיאולוגיות בחיסרליק חשפו שכבות חורבן מהתקופה המתאימה. הסיפור הפך ליצירת מופת ולאבן יסוד של התרבות היוונית.",
    "rank": 1
  },
  {
    "id": "gr_marathon",
    "deck": "greco",
    "title": "קרב מרתון",
    "start": -490,
    "end": -490,
    "date": "490 לפנה״ס",
    "place": "מרתון, אטיקה",
    "lat": 38.145,
    "lon": 23.975,
    "desc": "צבא אתונאי קטן בפיקוד מילטיאדס ניצח כוח פרסי גדול בהרבה במישור מרתון. הניצחון הוכיח שאפשר להביס את האימפריה הפרסית והפך לסמל לדמוקרטיה האתונאית. לפי המסורת, רץ מסר את בשורת הניצחון לאתונה ומת מתשישות — מקור מרוץ המרתון.",
    "rank": 2
  },
  {
    "id": "gr_caesar_assassinate",
    "deck": "greco",
    "title": "רצח יוליוס קיסר",
    "start": -44,
    "end": -44,
    "date": "44 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.477,
    "desc": "ב-15 במרץ (אידוס מרטיוס) דקרו סנאטורים בהנהגת ברוטוס וקסיוס את הדיקטטור יוליוס קיסר בבית הסנאט. הקנוניה נועדה להציל את הרפובליקה, אך הביאה לעוד מלחמות אזרחים ולסופה של הרפובליקה הרומית.",
    "rank": 3
  },
  {
    "id": "gr_rome_fall",
    "deck": "greco",
    "title": "נפילת רומא המערבית",
    "start": 476,
    "end": 476,
    "date": "476 לספירה",
    "place": "רוונה, איטליה",
    "lat": 44.418,
    "lon": 12.204,
    "desc": "אודואקר, מנהיג גרמאני, הדיח את הקיסר הצעיר רומולוס אוגוסטולוס ושלח את סימני הקיסרות לקונסטנטינופול. רומא המערבית חדלה להתקיים כישות מדינית, אם כי התהליך היה הדרגתי ונמשך עשרות שנים לפני כן.",
    "rank": 4
  },
  {
    "id": "gr_thermopylae",
    "deck": "greco",
    "title": "קרב תרמופילאי",
    "start": -480,
    "end": -480,
    "date": "480 לפנה״ס",
    "place": "תרמופילאי, יוון",
    "lat": 38.796,
    "lon": 22.537,
    "desc": "לאונידס מלך ספרטה ושלוש מאות לוחמים ספרטנים (ועוד אלפי יוונים) החזיקו את המעבר הצר בתרמופילאי מפני צבאו העצום של כסרכסס. הם נהרגו כולם לאחר שנסוגו יתר הכוחות, אך הקרבתם נתנה זמן ליוון להתארגן.",
    "rank": 5
  },
  {
    "id": "gr_alexander_empire",
    "deck": "greco",
    "title": "כיבושי אלכסנדר הגדול",
    "start": -334,
    "end": -323,
    "date": "⁦334–323⁩ לפנה״ס",
    "place": "פלה, מקדוניה",
    "lat": 40.761,
    "lon": 22.525,
    "desc": "אלכסנדר ממקדוניה כבש את האימפריה הפרסית, מצרים וחלקים מהודו בתוך עשר שנים בלבד ויצר את האימפריה הגדולה ביותר שהעולם ידע עד אז. הכיבושים הפיצו את התרבות היוונית בכל המזרח התיכון ומרכז אסיה והניחו את הבסיס לתקופה ההלניסטית.",
    "rank": 6
  },
  {
    "id": "gr_parthenon",
    "deck": "greco",
    "title": "בניית הפרתנון",
    "start": -447,
    "end": -432,
    "date": "⁦447–432⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.971,
    "lon": 23.727,
    "desc": "מקדש הפרתנון נבנה על האקרופוליס לכבוד האלה אתנה בהנחייתו של פריקלס, בתכנון האדריכלים איקטינוס וקאליקראטס ובפיסול פידיאס. הוא נחשב לשיא האדריכלות הקלאסית ולאחד המבנים המשפיעים ביותר בתולדות האדריכלות.",
    "rank": 7
  },
  {
    "id": "gr_democracy_athens",
    "deck": "greco",
    "title": "הדמוקרטיה האתונאית",
    "start": -508,
    "end": -508,
    "date": "בערך 508 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "רפורמות קלייסתנס הקימו את הדמוקרטיה הישירה באתונה, שבה כל אזרח זכר חופשי יכול היה להצביע באסיפה ולמלא תפקידים ציבוריים. מערכת זו הייתה הראשונה מסוגה בעולם. עקרון ההגרלה (סורטיציון) לתפקידים ציבוריים נועד למנוע ריכוז כוח.",
    "rank": 8
  },
  {
    "id": "gr_olympics",
    "deck": "greco",
    "title": "המשחקים האולימפיים הראשונים",
    "start": -776,
    "end": -776,
    "date": "776 לפנה״ס",
    "place": "אולימפיה, יוון",
    "lat": 37.638,
    "lon": 21.63,
    "desc": "לפי המסורת, המשחקים האולימפיים הראשונים נערכו באולימפיה לכבוד האל זאוס. בתחילה כללו רק מרוץ של סטדיון אחד (כ-192 מטר), ועם הזמן נוספו תחרויות נוספות. נערכו כל ארבע שנים ללא הפסקה עד שנאסרו ב-393 לספירה.",
    "rank": 9
  },
  {
    "id": "gr_salamis",
    "deck": "greco",
    "title": "קרב סלמיס",
    "start": -480,
    "end": -480,
    "date": "480 לפנה״ס",
    "place": "מיצר סלמיס, יוון",
    "lat": 37.951,
    "lon": 23.567,
    "desc": "הצי היווני בפיקודו של תמיסטוקלס מאתונה ניצח את הצי הפרסי האדיר במיצר סלמיס. הניצחון הימי המכריע שבר את כוחו של כסרכסס בים והבטיח שיוון לא תיכבש. קרב סלמיס נחשב לאחד הקרבות הימיים החשובים בהיסטוריה.",
    "rank": 10
  },
  {
    "id": "gr_socrates_trial",
    "deck": "greco",
    "title": "משפט סוקרטס ומותו",
    "start": -399,
    "end": -399,
    "date": "399 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "סוקרטס הואשם בכפירה באלים ובהשחתת הנוער, הורשע בידי מושבעים אתונאים ונידון לשתות רעל. סירובו לברוח הפך אותו לסמל של מסירות לאמת. דיאלוגים של תלמידו אפלטון הנציחו את שיטתו הפילוסופית.",
    "rank": 11
  },
  {
    "id": "gr_rome_founding",
    "deck": "greco",
    "title": "ייסוד רומא",
    "start": -753,
    "end": -753,
    "date": "בערך 753 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "לפי המסורת, רומולוס ייסד את העיר רומא על גבעת הפלטין לאחר שהרג את אחיו התאום רמוס. ממצאים ארכיאולוגיים מאשרים שהייתה התיישבות בגבעות רומא מהמאה השמינית לפנה״ס. שבעה מלכים, לפי האגדה, שלטו ברומא עד הקמת הרפובליקה.",
    "rank": 12
  },
  {
    "id": "gr_punic_wars",
    "deck": "greco",
    "title": "המלחמות הפוניות",
    "start": -264,
    "end": -146,
    "date": "⁦264–146⁩ לפנה״ס",
    "place": "מערב הים התיכון",
    "lat": 37.5,
    "lon": 10,
    "desc": "שלוש מלחמות בין רומא לקרתגו הכריעו מי ישלוט בים התיכון המערבי. במלחמה הראשונה רכשה רומא צי; בשנייה חניבעל כמעט הביס אותה; בשלישית קרתגו נחרבה לחלוטין. רומא יצאה כמעצמה הדומיננטית באגן הים התיכון.",
    "rank": 13
  },
  {
    "id": "gr_hannibal_alps",
    "deck": "greco",
    "title": "חניבעל חוצה את האלפים",
    "start": -218,
    "end": -218,
    "date": "218 לפנה״ס",
    "place": "מעברי האלפים",
    "lat": 44.85,
    "lon": 6.87,
    "desc": "חניבעל ברקא, מפקד קרתגי, חצה את הרי האלפים עם צבא וכ-37 פילי מלחמה בהישג צבאי מדהים. הצליח לנצח את הרומאים בקרבות גדולים בצפון איטליה ואחר כך בדרום, כולל קנאי. הוא נותר באיטליה כ-15 שנה אך לא הצליח לכבוש את רומא עצמה.",
    "rank": 14
  },
  {
    "id": "gr_cannae",
    "deck": "greco",
    "title": "קרב קנאי",
    "start": -216,
    "end": -216,
    "date": "216 לפנה״ס",
    "place": "קנאי, דרום איטליה",
    "lat": 41.305,
    "lon": 16.133,
    "desc": "חניבעל הביס את הצבא הרומי בתבוסה קטסטרופלית בטקטיקת מלכודת כפולה: כ-50,000 עד 70,000 חיילים רומאים נהרגו ביום אחד. קרב קנאי נלמד עד היום בבתי ספר צבאיים ברחבי העולם כדוגמה מושלמת להשמדת כוח עוין.",
    "rank": 15
  },
  {
    "id": "gr_vesuvius",
    "deck": "greco",
    "title": "התפרצות הר הגעש וזוב",
    "start": 79,
    "end": 79,
    "date": "79 לספירה",
    "place": "פומפיי, איטליה",
    "lat": 40.75,
    "lon": 14.485,
    "desc": "הר הגעש וזוב התפרץ בעוצמה וקבר את הערים פומפיי והרקולנאום תחת אפר ולבה. פליניוס הצעיר תיעד את האסון במכתבים לטאקיטוס. החפירות הארכיאולוגיות מהמאה ה-18 חשפו עיר רומית שנשתמרה בצורה יוצאת דופן.",
    "rank": 16
  },
  {
    "id": "gr_constantinople_fall",
    "deck": "greco",
    "title": "נפילת קונסטנטינופול",
    "start": 1453,
    "end": 1453,
    "date": "1453",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "הסולטאן העות'מאני מחמד השני כבש את קונסטנטינופול אחרי מצור של 53 יום, באמצעות תותחי ענק ומהלך מפתיע של גרירת ספינות ביבשה. הקיסר הביזנטי האחרון, קונסטנטינוס ה-11, נהרג בקרבות. אלף שנות אימפריה ביזנטית הגיעו לסיומן.",
    "rank": 17
  },
  {
    "id": "gr_peloponnesian_war",
    "deck": "greco",
    "title": "המלחמה הפלופונסית",
    "start": -431,
    "end": -404,
    "date": "⁦431–404⁩ לפנה״ס",
    "place": "יוון",
    "lat": 37.97,
    "lon": 23.72,
    "desc": "המלחמה בין אתונה וברית המדינות שלה לבין ספרטה וברית הפלופונסוס נמשכה כ-27 שנים והחריבה את יוון. תוקידידס תיעד את המלחמה בכתב ההיסטוריה הראשון שניתח את הגורמים למלחמה בצורה רציונלית. ספרטה ניצחה, אך כולם יצאו מוחלשים.",
    "rank": 18
  },
  {
    "id": "gr_augustus",
    "deck": "greco",
    "title": "אוגוסטוס מייסד את הקיסרות",
    "start": -27,
    "end": -27,
    "date": "27 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "אוקטביאנוס, בן דודו וצוואנו של יוליוס קיסר, קיבל מהסנאט את התואר אוגוסטוס והפך לקיסר הראשון של רומא. הוא שמר על מראית עין רפובליקנית בזמן שריכז את כל הכוח בידיו. שלטונו פתח את ה\"פאקס רומנה\" — שני מאות שנות שלום יחסי.",
    "rank": 19
  },
  {
    "id": "gr_colosseum",
    "deck": "greco",
    "title": "חנוכת הקולוסיאום",
    "start": 80,
    "end": 80,
    "date": "80 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.492,
    "desc": "הקיסר טיטוס חנך את האמפיתיאטרון הפלאווי (הקולוסיאום) במאה ימי משחקים. הזירה הכילה כ-50,000 צופים ואירחה קרבות גלדיאטורים, ציד חיות וביצוע הוצאות להורג. הוא נותר הסמל המובהק ביותר של רומא הקיסרית.",
    "rank": 20
  },
  {
    "id": "gr_spartacus",
    "deck": "greco",
    "title": "מרד ספרטקוס",
    "start": -73,
    "end": -71,
    "date": "⁦73–71⁩ לפנה״ס",
    "place": "קפואה, איטליה",
    "lat": 41.1,
    "lon": 14.25,
    "desc": "ספרטקוס, גלדיאטור תראקי, ברח מבית הספר לגלדיאטורים בקפואה והנהיג מרד עבדים שהגיע ל-70,000 לוחמים. הוא ניצח כוחות רומיים רבים לפני שהובס על ידי קראסוס. שישת אלפים שבויים נצלבו לאורך הדרך האפיאנית.",
    "rank": 21
  },
  {
    "id": "gr_republic_founding",
    "deck": "greco",
    "title": "הקמת הרפובליקה הרומית",
    "start": -509,
    "end": -509,
    "date": "בערך 509 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "לפי המסורת, הרומאים גירשו את טרקוויניוס המתנשא, המלך האחרון, והקימו רפובליקה עם שני קונסולים נבחרים במקום מלך. מערכת האיזונים והבלמים הרומית השפיעה עמוקות על חוקות מודרניות, בראש ובראשונה על חוקת ארצות הברית.",
    "rank": 22
  },
  {
    "id": "gr_pericles_age",
    "deck": "greco",
    "title": "תור הזהב של פריקלס",
    "start": -461,
    "end": -429,
    "date": "⁦461–429⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "תקופת שלטונו של פריקלס כסטרטגוס באתונה סימנה את שיא הדמוקרטיה, האמנות, הספרות והפילוסופיה היוונית. הוא יזם את בניית הפרתנון ובנייני האקרופוליס. עידן זה הוליד את סופוקלס, אוריפידס, הרודוטוס ופידיאס.",
    "rank": 23
  },
  {
    "id": "gr_plato_academy",
    "deck": "greco",
    "title": "אפלטון מקים את האקדמיה",
    "start": -387,
    "end": -387,
    "date": "בערך 387 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.993,
    "lon": 23.706,
    "desc": "אפלטון הקים את האקדמיה, מוסד ההוראה הגבוהה הראשון בעולם המערבי, בחורשה מחוץ לאתונה. היא פעלה כ-900 שנה עד שנסגרה בידי הקיסר יוסטיניאנוס. בין תלמידיה הבולטים היה אריסטו.",
    "rank": 24
  },
  {
    "id": "gr_aristotle",
    "deck": "greco",
    "title": "אריסטו מייסד את הלוקיון",
    "start": -335,
    "end": -335,
    "date": "בערך 335 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.979,
    "lon": 23.742,
    "desc": "אריסטו, שהיה מורו של אלכסנדר הגדול, ייסד את בית הספר הפילוסופי שלו, הלוקיון, באתונה. כתביו בלוגיקה, ביולוגיה, פיזיקה, אתיקה ופוליטיקה עיצבו את המחשבה המערבית והמוסלמית למשך כמעט אלפיים שנה.",
    "rank": 25
  },
  {
    "id": "gr_gaugamela",
    "deck": "greco",
    "title": "קרב גאוגמלה",
    "start": -331,
    "end": -331,
    "date": "331 לפנה״ס",
    "place": "גאוגמלה, עיראק",
    "lat": 36.56,
    "lon": 43.45,
    "desc": "אלכסנדר הגדול ניצח את דריוש השלישי בקרב מכריע שהפיל את האימפריה האכמנית. למרות עליונות מספרית ניכרת, תמרן אלכסנדר את הפלנגה המקדונית ואת הפרשים ופרץ ישירות לעבר דריוש שנס מהשדה. הדרך לפרספוליס ובבל הייתה פתוחה.",
    "rank": 26
  },
  {
    "id": "gr_julius_gallic_wars",
    "deck": "greco",
    "title": "מלחמות הגאלים של קיסר",
    "start": -58,
    "end": -50,
    "date": "⁦58–50⁩ לפנה״ס",
    "place": "גאליה (צרפת)",
    "lat": 47,
    "lon": 2,
    "desc": "יוליוס קיסר כבש את כל גאליה (צרפת, בלגיה, חלקי גרמניה) בשמונה שנות מלחמה, גם כדי לרכוש תהילה ועושר ולבנות צבא נאמן. ספרו \"על מלחמת הגאלים\" הוא עדות ישירה וכלי תעמולה מתוחכם. הכיבוש הטמיע את התרבות הרומית בצפון-מערב אירופה.",
    "rank": 27
  },
  {
    "id": "gr_actium",
    "deck": "greco",
    "title": "קרב אקטיום",
    "start": -31,
    "end": -31,
    "date": "31 לפנה״ס",
    "place": "אקטיום, יוון",
    "lat": 38.95,
    "lon": 20.72,
    "desc": "הצי של אוקטביאנוס (לימים אוגוסטוס) בפיקוד אגריפה ניצח את הצי המשולב של מרקוס אנטוניוס וקלאופטרה. הקרב הכריע את מלחמת האזרחים האחרונה של הרפובליקה ופינה את הדרך לקיסרות הרומית.",
    "rank": 28
  },
  {
    "id": "gr_cleopatra",
    "deck": "greco",
    "title": "מות קלאופטרה וסוף מצרים הפתולמאית",
    "start": -30,
    "end": -30,
    "date": "30 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.919,
    "desc": "קלאופטרה השביעית, המלכה האחרונה משושלת תלמי, שמה קץ לחייה לאחר כיבוש מצרים בידי אוקטביאנוס. מותה סיים את העידן ההלניסטי ואת מצרים כממלכה עצמאית. היא הייתה האחרונה ממנהיגי העולם ההלניסטי.",
    "rank": 29
  },
  {
    "id": "gr_crucifixion",
    "deck": "greco",
    "title": "צליבת ישו הנוצרי",
    "start": 30,
    "end": 33,
    "date": "בערך ⁦30–33⁩ לספירה",
    "place": "ירושלים",
    "lat": 31.778,
    "lon": 35.23,
    "desc": "ישו מנצרת נצלב בפקודת הנציב הרומי פונטיוס פילאטוס בירושלים. הנצרות שנולדה מאמונת תלמידיו הפכה לדת הגדולה בעולם. הצליבה כשיטת הוצאה להורג הייתה רומית מובהקת, שמורה לפושעים ולעבדים.",
    "rank": 30
  },
  {
    "id": "gr_minoan_civ",
    "deck": "greco",
    "title": "שיא התרבות המינואית",
    "start": -2000,
    "end": -1500,
    "date": "בערך ⁦2000–1500⁩ לפנה״ס",
    "place": "כנוסוס, כרתים",
    "lat": 35.298,
    "lon": 25.163,
    "desc": "התרבות המינואית בכרתים הייתה הציוויליזציה הראשונה באירופה, עם ארמונות מפוארים כמו כנוסוס, כתב (לינארית א'), צנרת מים ותרבות חומרית עשירה. ציורי הקיר שלהם מציגים חברה שבה לנשים היה מעמד גבוה. התרבות נעלמה בנסיבות עמומות, אולי בעקבות התפרצות געשית או פלישה.",
    "rank": 31
  },
  {
    "id": "gr_mycenae",
    "deck": "greco",
    "title": "שיא התרבות המיקנית",
    "start": -1600,
    "end": -1100,
    "date": "בערך ⁦1600–1100⁩ לפנה״ס",
    "place": "מיקנה, יוון",
    "lat": 37.731,
    "lon": 22.757,
    "desc": "ממלכות מיקנה, טירינס ופילוס היו מרכזי כוח של יוון בתקופת הברונזה, שולטות ברשתות סחר ברחבי הים התיכון. הכתב שלהם (לינארית ב') הוא הכתב היווני הקדום ביותר שפוענח. קריסתם, סביב 1100 לפנה״ס, פתחה את עידן החושך היווני.",
    "rank": 32
  },
  {
    "id": "gr_trojan_horse",
    "deck": "greco",
    "title": "סוס העץ של טרויה",
    "start": -1184,
    "end": -1184,
    "date": "בערך 1184 לפנה״ס",
    "place": "טרויה, אנטוליה",
    "lat": 39.957,
    "lon": 26.239,
    "desc": "לפי האפוס ההומרי, היוונים בנו סוס עץ ענק והחביאו בתוכו לוחמים. הטרויאנים הכניסו את הסוס לעיר, ובלילה יצאו הלוחמים ופתחו את השערים לצבא היווני. הביטוי \"סוס טרויאני\" הפך למטאפורה לתחבולה בכל שפה.",
    "rank": 33
  },
  {
    "id": "gr_homer",
    "deck": "greco",
    "title": "הומרוס מחבר את האיליאדה והאודיסיאה",
    "start": -750,
    "end": -700,
    "date": "בערך המאה ה-8 לפנה״ס",
    "place": "אסיה הקטנה או יוון",
    "lat": 38.37,
    "lon": 26.14,
    "desc": "האיליאדה והאודיסיאה, המיוחסות למשורר עיוור בשם הומרוס, הן היצירות הספרותיות הראשונות של התרבות המערבית. האיליאדה מספרת על המצור על טרויה, והאודיסיאה על שיבתו המפרכת של אודיסאוס הביתה. היצירות עיצבו את ערכי הכבוד, הגבורה והאירוח ביוון.",
    "rank": 34
  },
  {
    "id": "gr_persian_wars",
    "deck": "greco",
    "title": "המלחמות הפרסיות",
    "start": -499,
    "end": -449,
    "date": "⁦499–449⁩ לפנה״ס",
    "place": "יוון ואסיה הקטנה",
    "lat": 38.5,
    "lon": 24,
    "desc": "שתי פלישות פרסיות לשטח יוון — של דריוש הראשון ושל כסרכסס — איחדו את ערי המדינה היווניות לראשונה. הניצחונות במרתון, תרמופילאי, סלמיס ופלטאי מנעו את הכיבוש הפרסי וחיזקו את הזהות ההלנית.",
    "rank": 35
  },
  {
    "id": "gr_herodotus",
    "deck": "greco",
    "title": "הרודוטוס כותב את ההיסטוריות",
    "start": -440,
    "end": -425,
    "date": "בערך ⁦440–425⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "הרודוטוס מהליקרנסוס, \"אבי ההיסטוריה\", כתב את התיאור הראשון של עמים ואירועים בגישה חוקרת ולא מיתית. יצירתו סוקרת את המלחמות הפרסיות אך גם מנהגים של מצרים, סקיתים ופרסים. הוא שילב אנתרופולוגיה, גיאוגרפיה והיסטוריה.",
    "rank": 36
  },
  {
    "id": "gr_twelve_tables",
    "deck": "greco",
    "title": "חוקי שנים-עשר הלוחות",
    "start": -451,
    "end": -449,
    "date": "⁦451–449⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "החוקים הראשונים שנכתבו ברומא ונחרתו על שנים-עשר לוחות ברונזה בפורום. הפלבאים דרשו חוקים כתובים כדי שהפטריקים לא ינצלו את המשפט המנהגי. החוקים הניחו את הבסיס לכל המשפט הרומי ובעקיפין למשפט המערבי.",
    "rank": 37
  },
  {
    "id": "gr_philip_macedon",
    "deck": "greco",
    "title": "פיליפוס השני כובש את יוון",
    "start": -338,
    "end": -338,
    "date": "338 לפנה״ס",
    "place": "חיירוניאה, יוון",
    "lat": 38.499,
    "lon": 22.832,
    "desc": "פיליפוס מלך מקדוניה ניצח את הצבא המשולב של אתונה ותבי בקרב חיירוניאה, והפך לשליט בפועל של כל יוון. בנו אלכסנדר פיקד על הפרשים בקרב. מותו של פיליפוס שנתיים לאחר מכן העביר את השרביט לאלכסנדר.",
    "rank": 38
  },
  {
    "id": "gr_issus",
    "deck": "greco",
    "title": "קרב איסוס",
    "start": -333,
    "end": -333,
    "date": "333 לפנה״ס",
    "place": "איסוס, טורקיה",
    "lat": 36.85,
    "lon": 36.18,
    "desc": "אלכסנדר הגדול ניצח את דריוש השלישי בקרב ראשון ביניהם, בשטח צר ליד חוף הים. דריוש נמלט מהשדה, והשאיר את משפחתו בשבי. הפסיפס המפורסם מפומפיי מתאר את רגע העימות הדרמטי בין השניים.",
    "rank": 39
  },
  {
    "id": "gr_alexandria_founding",
    "deck": "greco",
    "title": "ייסוד אלכסנדריה",
    "start": -331,
    "end": -331,
    "date": "331 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.919,
    "desc": "אלכסנדר הגדול ייסד את אלכסנדריה על חוף הים התיכון כעיר יוונית במצרים. תחת שושלת תלמי הפכה למרכז הלמידה של העולם העתיק, עם הספרייה הגדולה ומגדלור פארוס. היא שמרה על מעמדה כעיר הגדולה ביותר בעולם ההלניסטי.",
    "rank": 40
  },
  {
    "id": "gr_library_alexandria",
    "deck": "greco",
    "title": "הספרייה הגדולה של אלכסנדריה",
    "start": -283,
    "end": -283,
    "date": "בערך 283 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.209,
    "lon": 29.909,
    "desc": "תלמי השני ביסס את הספרייה כמוסד מחקר שאסף כתבי יד מכל העולם הידוע. המלומדים שעבדו בה כללו את ארכימדס, ארטוסתנס ואוקלידס. חורבנה ההדרגתי הפך לסמל לאובדן ידע.",
    "rank": 41
  },
  {
    "id": "gr_rubicon",
    "deck": "greco",
    "title": "קיסר חוצה את הרוביקון",
    "start": -49,
    "end": -49,
    "date": "49 לפנה״ס",
    "place": "נהר הרוביקון, איטליה",
    "lat": 44.07,
    "lon": 12.41,
    "desc": "יוליוס קיסר חצה את נהר הרוביקון עם הלגיון שלו, בניגוד לחוק שאסר על מצביא להכניס כוח מזוין לתחומי איטליה. המהלך פתח במלחמת אזרחים נגד פומפיוס הגדול והסנאט. הביטוי \"לחצות את הרוביקון\" משמש עד היום לצעד בלתי חוזר.",
    "rank": 42
  },
  {
    "id": "gr_constantine_christianity",
    "deck": "greco",
    "title": "קונסטנטינוס מאמץ את הנצרות",
    "start": 313,
    "end": 313,
    "date": "313 לספירה",
    "place": "מילאנו, איטליה",
    "lat": 45.464,
    "lon": 9.19,
    "desc": "צו מילאנו של הקיסר קונסטנטינוס התיר את חופש הדת ברחבי האימפריה, ובפועל נתן לגיטימציה לנצרות. לפני קרב גשר מילוויוס ראה קונסטנטינוס, לפי המסורת, צלב בשמיים. ההכרה הקיסרית הפכה את הנצרות מדת רדופה לדת המדינה תוך עשרות שנים.",
    "rank": 43
  },
  {
    "id": "gr_constantinople_founding",
    "deck": "greco",
    "title": "ייסוד קונסטנטינופול",
    "start": 330,
    "end": 330,
    "date": "330 לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "קונסטנטינוס הגדול הכריז על ביזנטיון כבירה החדשה של האימפריה ושינה את שמה לקונסטנטינופול. העיר שכנה בנקודה אסטרטגית בין אירופה לאסיה ושלטה על מצר הבוספורוס. היא שימשה כבירת האימפריה הביזנטית למעלה מאלף שנה.",
    "rank": 44
  },
  {
    "id": "gr_justinian",
    "deck": "greco",
    "title": "שלטון יוסטיניאנוס הגדול",
    "start": 527,
    "end": 565,
    "date": "⁦527–565⁩ לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "הקיסר הביזנטי יוסטיניאנוס ניסה לשחזר את האימפריה הרומית וכבש חלקים מאיטליה, צפון אפריקה וספרד. הוא הורה על חיבור הקורפוס יוריס ציוויליס (קובץ החוקים הרומי) ובנה את כנסיית איה סופיה. מגפת הדבר הגדולה ב-541 החלישה את הישגיו.",
    "rank": 45
  },
  {
    "id": "gr_hagia_sophia",
    "deck": "greco",
    "title": "בניית איה סופיה",
    "start": 532,
    "end": 537,
    "date": "⁦532–537⁩ לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.009,
    "lon": 28.98,
    "desc": "הקיסר יוסטיניאנוס בנה את כנסיית \"החוכמה הקדושה\" עם כיפה עצומה שנחשבה לפלא הנדסי. לפי המסורת, יוסטיניאנוס הכריז בחנוכה: \"שלמה, ניצחתיך!\" הבניין שימש ככנסייה, מסגד ומוזיאון, וכיום מסגד שוב.",
    "rank": 46
  },
  {
    "id": "gr_hippocrates",
    "deck": "greco",
    "title": "היפוקרטס אבי הרפואה",
    "start": -430,
    "end": -400,
    "date": "בערך ⁦430–400⁩ לפנה״ס",
    "place": "קוס, יוון",
    "lat": 36.893,
    "lon": 27.005,
    "desc": "היפוקרטס מקוס הפריד בין רפואה לדת וכישוף והציע שמחלות נגרמות מסיבות טבעיות ולא מכעס האלים. \"שבועת היפוקרטס\" מנחה רופאים עד היום. בית ספרו הניח את יסודות הרפואה הקלינית.",
    "rank": 47
  },
  {
    "id": "gr_euclid",
    "deck": "greco",
    "title": "אוקלידס כותב את היסודות",
    "start": -300,
    "end": -300,
    "date": "בערך 300 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.919,
    "desc": "\"היסודות\" של אוקלידס הוא ספר הלימוד המשפיע ביותר בהיסטוריה של המתמטיקה, שמסדר את הגיאומטריה המישורית בשיטה אקסיומטית. הספר תורגם, הועתק ונלמד ברצף כמעט מרגע כתיבתו. רק התנ\"ך הודפס ביותר מהדורות.",
    "rank": 48
  },
  {
    "id": "gr_archimedes",
    "deck": "greco",
    "title": "ארכימדס בסרקוזה",
    "start": -287,
    "end": -212,
    "date": "⁦287–212⁩ לפנה״ס",
    "place": "סרקוזה, סיציליה",
    "lat": 37.075,
    "lon": 15.286,
    "desc": "ארכימדס, המתמטיקאי והמהנדס הגדול ביותר של העת העתיקה, גילה את עקרון הצפה, חישב את ערך פאי, והמציא מכונות מלחמה שהגנו על סרקוזה מפני הרומאים. נהרג כשהרומאים כבשו את העיר, לפי המסורת בעודו שקוע בבעיה מתמטית.",
    "rank": 49
  },
  {
    "id": "gr_sulla_march",
    "deck": "greco",
    "title": "סולה צועד על רומא",
    "start": -88,
    "end": -88,
    "date": "88 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "לוקיוס קורנליוס סולה היה הראשון שצעד על רומא עם צבא רומי — מעשה שנחשב בלתי נתפס. הוא עשה זאת כי הסנאט העביר את פיקוד המלחמה נגד מיתרידטס ממנו למריוס. הדיקטטורה שלו כללה רשימות חיסול (פרוסקריפציות) שטיהרו את אויביו.",
    "rank": 50
  },
  {
    "id": "gr_marius_reforms",
    "deck": "greco",
    "title": "רפורמות מריוס בצבא",
    "start": -107,
    "end": -107,
    "date": "בערך 107 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "גאיוס מריוס פתח את הצבא הרומי לפרולטריים חסרי קרקע ואיפשר קריירה צבאית מקצועית. הלגיונרים הפכו נאמנים למפקדם יותר מלמדינה, מה שהוביל בסופו של דבר לנפילת הרפובליקה. הצבא המקצועי ששינה היה יעיל בהרבה מצבא האזרחים הקודם.",
    "rank": 51
  },
  {
    "id": "gr_gracchi",
    "deck": "greco",
    "title": "רפורמות האחים גרכוס",
    "start": -133,
    "end": -121,
    "date": "⁦133–121⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "טיבריוס וגאיוס גרכוס, שני אחים שכיהנו כטריבונים, ניסו לחלק מחדש קרקע ציבורית לאזרחים עניים. שניהם נרצחו בידי אנשי הסנאט ובעלי הקרקעות. רצח נבחרי ציבור לראשונה ברפובליקה סימן את תחילת התפוררותה.",
    "rank": 52
  },
  {
    "id": "gr_plataea",
    "deck": "greco",
    "title": "קרב פלטאי",
    "start": -479,
    "end": -479,
    "date": "479 לפנה״ס",
    "place": "פלטאי, יוון",
    "lat": 38.22,
    "lon": 23.27,
    "desc": "הצבא היווני המאוחד בפיקוד פאוסניאס הספרטני ניצח את הכוח הפרסי של מרדוניוס בקרב יבשתי מכריע. הניצחון, יחד עם קרב מיקלה באותו יום, סיים את הפלישה הפרסית ליוון. יוון הקלאסית יכלה לפרוח.",
    "rank": 53
  },
  {
    "id": "gr_first_triumvirate",
    "deck": "greco",
    "title": "הטריאומווירט הראשון",
    "start": -60,
    "end": -53,
    "date": "⁦60–53⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "קיסר, פומפיוס וקראסוס חילקו ביניהם את השליטה ברומא בברית לא רשמית. מותו של קראסוס נגד הפרתים בקרב כרחי חיסל את האיזון, והוביל למלחמת האזרחים בין קיסר לפומפיוס. זה היה דגם שחזר בטריאומווירט השני.",
    "rank": 54
  },
  {
    "id": "gr_nero_fire",
    "deck": "greco",
    "title": "השריפה הגדולה ברומא",
    "start": 64,
    "end": 64,
    "date": "64 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.496,
    "desc": "שריפה גדולה פרצה ברומא ובערה ימים רבים, והחריבה חלקים ניכרים מהעיר. הקיסר נירון, לפי המסורת, נגן בכינור בזמן השריפה (ככל הנראה לא נכון). הוא האשים את הנוצרים ורדף אותם, ובנה על ההריסות את ארמון דומוס אאוריאה.",
    "rank": 55
  },
  {
    "id": "gr_hadrians_wall",
    "deck": "greco",
    "title": "בניית חומת אדריאנוס",
    "start": 122,
    "end": 128,
    "date": "⁦122–128⁩ לספירה",
    "place": "צפון אנגליה",
    "lat": 55.02,
    "lon": -2.26,
    "desc": "הקיסר אדריאנוס הורה על בניית חומה באורך 117 קילומטר לרוחב צפון בריטניה, מים לים. החומה סימנה את הגבול הצפוני של האימפריה הרומית בבריטניה. היא כללה מצודות, מגדלי תצפית ומחנות צבאיים ועומדת בחלקה עד היום.",
    "rank": 56
  },
  {
    "id": "gr_greek_tragedy",
    "deck": "greco",
    "title": "שיא הטרגדיה היוונית",
    "start": -472,
    "end": -405,
    "date": "⁦472–405⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.971,
    "lon": 23.725,
    "desc": "שלושת הטרגיקנים הגדולים — אסכילוס, סופוקלס ואוריפידס — יצרו בתיאטרון הדיוניסוס באתונה. הטרגדיה היוונית חקרה שאלות של גורל, צדק ויחסי אנוש ואלים. פחות מ-33 מחזות שרדו מתוך מאות שנכתבו.",
    "rank": 57
  },
  {
    "id": "gr_aeschylus",
    "deck": "greco",
    "title": "האורסטיאה של אסכילוס",
    "start": -458,
    "end": -458,
    "date": "458 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.971,
    "lon": 23.725,
    "desc": "אסכילוס, אבי הטרגדיה, הציג את הטרילוגיה \"האורסטיאה\" — היצירה הדרמטית השלמה היחידה ששרדה מיוון. היא עוקבת אחר שרשרת הנקמה בבית אגממנון ומסתיימת בהקמת בית המשפט באתונה. אסכילוס הוסיף שחקן שני לבמה, ויצר את הדיאלוג הדרמטי.",
    "rank": 58
  },
  {
    "id": "gr_sophocles_oedipus",
    "deck": "greco",
    "title": "אדיפוס המלך של סופוקלס",
    "start": -429,
    "end": -429,
    "date": "בערך 429 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.971,
    "lon": 23.725,
    "desc": "סופוקלס כתב את הטרגדיה \"אדיפוס המלך\" — על מלך שמגלה שהרג את אביו ונשא את אמו. אריסטו ראה בה את הטרגדיה המושלמת. פרויד שאל את השם למתן \"קומפלקס אדיפוס\".",
    "rank": 59
  },
  {
    "id": "gr_aristophanes",
    "deck": "greco",
    "title": "הקומדיה של אריסטופנס",
    "start": -425,
    "end": -388,
    "date": "⁦425–388⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.971,
    "lon": 23.725,
    "desc": "אריסטופנס, אבי הקומדיה, כתב מחזות סאטיריים חריפים על הפוליטיקה, המלחמה והתרבות באתונה. \"הציפורים\" ו\"ליסיסטרטה\" עדיין מוצגים. היה החריף ביותר מבין מבקרי המלחמה הפלופונסית.",
    "rank": 60
  },
  {
    "id": "gr_thucydides",
    "deck": "greco",
    "title": "תוקידידס כותב את ההיסטוריה של המלחמה הפלופונסית",
    "start": -411,
    "end": -400,
    "date": "בערך ⁦411–400⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "תוקידידס, מצביא אתונאי שגורש, כתב את ההיסטוריה הקפדנית הראשונה שמנתחת גורמים מדיניים ואנושיים ללא התערבות אלוהית. הדיאלוג המלי הוא אחד הטקסטים החשובים ביחסים בינלאומיים. עבודתו נחשבת לבסיס המדע המדיני.",
    "rank": 61
  },
  {
    "id": "gr_sparta",
    "deck": "greco",
    "title": "חוקת ליקורגוס בספרטה",
    "start": -750,
    "end": -750,
    "date": "בערך המאה ה-8 לפנה״ס",
    "place": "ספרטה, יוון",
    "lat": 37.076,
    "lon": 22.43,
    "desc": "המחוקק האגדי ליקורגוס נתן לספרטה את חוקתה הייחודית: אורח חיים צבאי קפדני מגיל שבע, חלוקת קרקע שוויונית, ושלטון דו-מלכותי. הספרטנים הפכו ללוחמים הטובים ביותר ביוון, אך החברה הנוקשה מנעה מהם להתפתח תרבותית.",
    "rank": 62
  },
  {
    "id": "gr_diadochi",
    "deck": "greco",
    "title": "מלחמות הדיאדוכים",
    "start": -322,
    "end": -281,
    "date": "⁦322–281⁩ לפנה״ס",
    "place": "המזרח התיכון",
    "lat": 35,
    "lon": 33,
    "desc": "לאחר מות אלכסנדר הגדול נלחמו מפקדיו (הדיאדוכים) על חלוקת האימפריה. לאחר ארבעים שנות מלחמות נוצרו שלוש ממלכות הלניסטיות גדולות: מצרים התלמאית, הסלווקים באסיה, ומקדוניה של האנטיגונידים.",
    "rank": 63
  },
  {
    "id": "gr_rosetta_stone",
    "deck": "greco",
    "title": "כתיבת אבן רוזטה",
    "start": -196,
    "end": -196,
    "date": "196 לפנה״ס",
    "place": "ממפיס, מצרים",
    "lat": 29.85,
    "lon": 31.25,
    "desc": "הכהנים במצרים חרתו צו לכבוד תלמי החמישי בשלוש כתבים: היירוגליפים, דמוטית ויוונית. האבן גילתה את המפתח לפענוח ההיירוגליפים כאשר שמפוליון פיענח אותה ב-1822. היא מדגימה את הדו-לשוניות של מצרים ההלניסטית.",
    "rank": 64
  },
  {
    "id": "gr_zama",
    "deck": "greco",
    "title": "קרב זאמה",
    "start": -202,
    "end": -202,
    "date": "202 לפנה״ס",
    "place": "זאמה, תוניסיה",
    "lat": 36.1,
    "lon": 8.9,
    "desc": "סקיפיו האפריקני ניצח את חניבעל באפריקה עצמה, באמצעות טקטיקות שלמד מהקרתגי עצמו. הקרב סיים את המלחמה הפונית השנייה וקבע את רומא כמעצמה העליונה בים התיכון. חניבעל גלה ולבסוף התאבד.",
    "rank": 65
  },
  {
    "id": "gr_corinth_destruction",
    "deck": "greco",
    "title": "חורבן קורינתוס",
    "start": -146,
    "end": -146,
    "date": "146 לפנה״ס",
    "place": "קורינתוס, יוון",
    "lat": 37.906,
    "lon": 22.88,
    "desc": "רומא החריבה את קורינתוס באותה שנה שבה נחרבה קרתגו, ובכך סיימה את עצמאות יוון. התושבים נמכרו לעבדות ויצירות האמנות נשדדו. קיסר בנה אותה מחדש מאה שנה מאוחר יותר כמושבה רומית.",
    "rank": 66
  },
  {
    "id": "gr_triumvirate2",
    "deck": "greco",
    "title": "הטריאומווירט השני",
    "start": -43,
    "end": -33,
    "date": "⁦43–33⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "אוקטביאנוס, מרקוס אנטוניוס ולפידוס חילקו ביניהם את האימפריה באופן רשמי לאחר רצח קיסר. הם ביצעו פרוסקריפציות שבהן נרצח גם ציצרו. בסופו של דבר אוקטביאנוס הדיח את שני שותפיו ושלט לבדו.",
    "rank": 67
  },
  {
    "id": "gr_cicero",
    "deck": "greco",
    "title": "נאומי ציצרו בסנאט",
    "start": -63,
    "end": -43,
    "date": "⁦63–43⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "ציצרו, עורך הדין, הפילוסוף והנואם הגדול ביותר של רומא, חשף את קשר קטילינה והגן על הרפובליקה בנאומים חוצבי להבות. כתביו השפיעו עמוקות על השפה הלטינית ועל הרטוריקה המערבית. נרצח בפקודת מרקוס אנטוניוס.",
    "rank": 68
  },
  {
    "id": "gr_pompeii_city",
    "deck": "greco",
    "title": "פומפיי כעיר רומית משגשגת",
    "start": -80,
    "end": 79,
    "date": "בערך המאה ה-1 לפנה״ס עד 79 לספירה",
    "place": "פומפיי, איטליה",
    "lat": 40.751,
    "lon": 14.487,
    "desc": "פומפיי הייתה עיר חוף עשירה עם פורום, תיאטרון, מרחצאות ציבוריים, בתי בושת, מסעדות וכ-11,000 תושבים. ציורי הקיר שנשתמרו מספקים את העדות הטובה ביותר לחיי היומיום ברומא. קיבורה תחת אפר וזוב שימרה אותה ב\"הקפאת זמן\".",
    "rank": 69
  },
  {
    "id": "gr_pax_romana",
    "deck": "greco",
    "title": "הפאקס רומנה",
    "start": -27,
    "end": 180,
    "date": "27 לפנה״ס עד 180 לספירה",
    "place": "האימפריה הרומית",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "תקופה של כמאתיים שנות שלום ושגשוג יחסיים ברחבי האימפריה הרומית, מאוגוסטוס ועד מרקוס אאורליוס. הסחר פרח, נבנו כבישים ואקוודוקטים, והאוכלוסייה גדלה. מדובר בתקופת היציבות הארוכה ביותר שהכיר עולם הים התיכון.",
    "rank": 70
  },
  {
    "id": "gr_trajan_column",
    "deck": "greco",
    "title": "עמוד טראיאנוס ברומא",
    "start": 113,
    "end": 113,
    "date": "113 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.896,
    "lon": 12.484,
    "desc": "העמוד, בגובה 35 מטר, מתעד בתבליטים ספירליים את מלחמותיו של הקיסר טראיאנוס בדאקיה (רומניה). הוא מציג את צבא רומא בפעולה — גשרים, מצורים, מאורעות וקרבות — ונחשב למקור הארכיאולוגי החשוב ביותר על הצבא הרומי.",
    "rank": 71
  },
  {
    "id": "gr_trajan_empire_peak",
    "deck": "greco",
    "title": "האימפריה הרומית בשיאה תחת טראיאנוס",
    "start": 117,
    "end": 117,
    "date": "117 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "תחת הקיסר טראיאנוס הגיעה האימפריה לשטח הגדול ביותר שלה, ממצרים ועד בריטניה, ומספרד ועד מסופוטמיה. יורשו אדריאנוס ויתר על הכיבושים המזרחיים ועבר למדיניות של התבצרות וגבולות.",
    "rank": 72
  },
  {
    "id": "gr_marcus_aurelius",
    "deck": "greco",
    "title": "מרקוס אאורליוס הקיסר הפילוסוף",
    "start": 161,
    "end": 180,
    "date": "⁦161–180⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "מרקוס אאורליוס, הקיסר \"הפילוסוף\", כתב את \"ההגיגים\" — יומן פילוסופי סטואי שנחשב לאחת היצירות החשובות ביותר בפילוסופיה המעשית. תקופתו סימנה את סוף ה\"פאקס רומנה\" עם מלחמות גבול ומגפת אנטונינוס.",
    "rank": 73
  },
  {
    "id": "gr_diocletian",
    "deck": "greco",
    "title": "רפורמות דיוקלטיאנוס",
    "start": 284,
    "end": 305,
    "date": "⁦284–305⁩ לספירה",
    "place": "ניקומדיה, אנטוליה",
    "lat": 40.76,
    "lon": 29.92,
    "desc": "דיוקלטיאנוס חילק את האימפריה לטטררכיה (ארבעה שליטים), ביצע רפורמות מנהליות וכלכליות מקיפות, ורדף נוצרים ברדיפה הגדולה האחרונה. הוא היה הקיסר הראשון שפרש מרצון, ובנה ארמון בספליט שנשמר עד היום.",
    "rank": 74
  },
  {
    "id": "gr_adrianople",
    "deck": "greco",
    "title": "קרב אדריאנופול",
    "start": 378,
    "end": 378,
    "date": "378 לספירה",
    "place": "אדריאנופול (אדירנה), תורכיה",
    "lat": 41.677,
    "lon": 26.556,
    "desc": "הוויזיגותים ניצחו את הצבא הרומי והרגו את הקיסר ואלנס. הקרב נחשב לנקודת מפנה שהראתה שהברברים יכולים להביס את רומא בקרב פתוח. מכאן, רומא הסתמכה יותר ויותר על לוחמים גרמניים בצבאה.",
    "rank": 75
  },
  {
    "id": "gr_alaric_sack",
    "deck": "greco",
    "title": "שוד רומא בידי אלאריק",
    "start": 410,
    "end": 410,
    "date": "410 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.496,
    "desc": "אלאריק מלך הוויזיגותים כבש ושדד את רומא — הפעם הראשונה ב-800 שנה שצבא זר נכנס לעיר. הזעזוע ברחבי האימפריה היה עצום; אוגוסטינוס כתב את \"עיר האלוהים\" בתגובה. רומא לא הייתה עוד הבירה, אך הסמליות הייתה מוחצת.",
    "rank": 76
  },
  {
    "id": "gr_greek_alphabet",
    "deck": "greco",
    "title": "פיתוח האלפבית היווני",
    "start": -800,
    "end": -750,
    "date": "בערך המאה ה-8 לפנה״ס",
    "place": "יוון",
    "lat": 37.97,
    "lon": 23.72,
    "desc": "היוונים אימצו ועיבדו את האלפבית הפיניקי והוסיפו לראשונה תנועות כאותיות נפרדות. זהו אב הקילשון לכל האלפביתים המערביים (לטיני, קירילי) ואבן יסוד לפיתוח הכתיבה האלפביתית. אפשר את התפשטות האוריינות ביוון.",
    "rank": 77
  },
  {
    "id": "gr_solon_reforms",
    "deck": "greco",
    "title": "רפורמות סולון",
    "start": -594,
    "end": -594,
    "date": "בערך 594 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "סולון, שנבחר לארכון באתונה, ביטל את עבדות החוב, חילק את האזרחים למעמדות לפי רכוש (לא לפי מוצא) ופתח את בתי המשפט לכל אזרח. רפורמותיו הניחו את הבסיס לדמוקרטיה שהשלים קלייסתנס שני דורות אחר כך.",
    "rank": 78
  },
  {
    "id": "gr_draco_laws",
    "deck": "greco",
    "title": "חוקי דראקון",
    "start": -621,
    "end": -621,
    "date": "בערך 621 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "דראקון כתב את קובץ החוקים הראשון של אתונה, שנודע באכזריותו — עונש מוות כמעט על כל עבירה. הביטוי \"חוק דרקוני\" שורד בכל שפה. סולון ביטל את רוב חוקיו מלבד חוקי הרצח.",
    "rank": 79
  },
  {
    "id": "gr_sappho",
    "deck": "greco",
    "title": "שירת סאפו",
    "start": -610,
    "end": -570,
    "date": "בערך ⁦610–570⁩ לפנה״ס",
    "place": "לסבוס, יוון",
    "lat": 39.17,
    "lon": 26.33,
    "desc": "סאפו מאי לסבוס נחשבה בעת העתיקה לאחת מגדולי המשוררים. שיריה הלירים עסקו באהבה, יופי וכמיהה בשפה עזה ואישית. מרבית יצירתה אבדה; שרדו שירים שלמים בודדים וקטעים.",
    "rank": 80
  },
  {
    "id": "gr_pheidippides",
    "deck": "greco",
    "title": "ריצת פיידיפידס מאתונה לספרטה",
    "start": -490,
    "end": -490,
    "date": "490 לפנה״ס",
    "place": "אתונה–ספרטה, יוון",
    "lat": 37.97,
    "lon": 23.72,
    "desc": "לפי הרודוטוס, הרץ פיידיפידס רץ מאתונה לספרטה (כ-240 ק\"מ) ביומיים כדי לבקש עזרה לפני קרב מרתון. הספרטנים סירבו לצאת לפני תום חג דתי. הסיפור התמזג עם אגדת הרץ מהקרב ליצירת מרוץ המרתון.",
    "rank": 81
  },
  {
    "id": "gr_delian_league",
    "deck": "greco",
    "title": "הקמת הברית הדלית",
    "start": -478,
    "end": -478,
    "date": "478 לפנה״ס",
    "place": "דלוס, יוון",
    "lat": 37.396,
    "lon": 25.269,
    "desc": "לאחר המלחמות הפרסיות הקימה אתונה ברית של ערי מדינה יווניות עם אוצר משותף בדלוס. הברית הפכה בהדרגה לאימפריה אתונאית כשפריקלס העביר את הקופה לאתונה ושלט ביד רמה בבנות הברית.",
    "rank": 82
  },
  {
    "id": "gr_phidias",
    "deck": "greco",
    "title": "פסלי פידיאס",
    "start": -440,
    "end": -430,
    "date": "בערך ⁦440–430⁩ לפנה״ס",
    "place": "אתונה ואולימפיה, יוון",
    "lat": 37.971,
    "lon": 23.727,
    "desc": "פידיאס, גדול הפסלים היוונים, יצר את פסל אתנה בפרתנון ואת פסל זאוס באולימפיה — אחד משבעת פלאי תבל. הפסלים אבדו, אך תיאורים ועותקים מעידים על גודלם ותפארתם.",
    "rank": 83
  },
  {
    "id": "gr_xenophon_anabasis",
    "deck": "greco",
    "title": "מסע עשרת האלפים",
    "start": -401,
    "end": -399,
    "date": "⁦401–399⁩ לפנה״ס",
    "place": "מפרס ליוון",
    "lat": 36.5,
    "lon": 43,
    "desc": "קסנופון הנהיג עשרת אלפים שכירי חרב יוונים בנסיגה ממעמקי פרס לחוף הים השחור אחרי שהנסיך שלהם נהרג. זעקתם \"תאלאסה! תאלאסה!\" (הים! הים!) כשראו את הים הפכה לאחד הרגעים המפורסמים בספרות העתיקה.",
    "rank": 84
  },
  {
    "id": "gr_leuctra",
    "deck": "greco",
    "title": "קרב לאוקטרה",
    "start": -371,
    "end": -371,
    "date": "371 לפנה״ס",
    "place": "לאוקטרה, יוון",
    "lat": 38.37,
    "lon": 23.14,
    "desc": "אפאמינונדאס מתבי ניצח את ספרטה בטקטיקה מהפכנית — ריכוז כוח באגף אחד (האגף השמאלי העמוק). זו הייתה התבוסה הקרבית הראשונה של ספרטה. תבי הפכה לרגע למעצמה המובילה ביוון.",
    "rank": 85
  },
  {
    "id": "gr_diogenes",
    "deck": "greco",
    "title": "דיוגנס הקיניקן",
    "start": -404,
    "end": -323,
    "date": "⁦404–323⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "דיוגנס מסינופה חי ברחוב עם חבית, דחה את כל המוסכמות החברתיות, ולפי האגדה ביקש מאלכסנדר הגדול רק שיזוז מהשמש. הפילוסופיה הקינית שלו, שהעריצה פשטות קיצונית, השפיעה על הסטואיקנים.",
    "rank": 86
  },
  {
    "id": "gr_alexander_gordian",
    "deck": "greco",
    "title": "אלכסנדר חותך את הקשר הגורדי",
    "start": -333,
    "end": -333,
    "date": "333 לפנה״ס",
    "place": "גורדיום, אנטוליה",
    "lat": 39.654,
    "lon": 31.97,
    "desc": "לפי האגדה, מי שיתיר את הקשר הסבוך בגורדיום ישלוט באסיה. אלכסנדר חתך אותו בחרב. הביטוי \"לחתוך את הקשר הגורדי\" משמש עד היום לפתרון בעיה סבוכה בצעד נועז.",
    "rank": 87
  },
  {
    "id": "gr_alexander_tyre",
    "deck": "greco",
    "title": "המצור על צור",
    "start": -332,
    "end": -332,
    "date": "332 לפנה״ס",
    "place": "צור, לבנון",
    "lat": 33.27,
    "lon": 35.2,
    "desc": "אלכסנדר בנה סוללה באורך קילומטר לעיר האי צור ולאחר מצור של שבעה חודשים כבש אותה. שלושים אלף תושבים נמכרו לעבדות. הישג הנדסי וצבאי מדהים שהפגין את נחישותו.",
    "rank": 88
  },
  {
    "id": "gr_ptolemaic_egypt",
    "deck": "greco",
    "title": "הקמת ממלכת תלמי במצרים",
    "start": -305,
    "end": -305,
    "date": "305 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.919,
    "desc": "תלמי הראשון, מפקד של אלכסנדר, הכתיר את עצמו למלך מצרים ויסד שושלת שמשלה כ-275 שנים. התלמאים אימצו מנהגים מצריים (כולל נישואי אחים) אך שלטו ביוונית. אלכסנדריה הפכה למרכז התרבותי הגדול ביותר בעולם.",
    "rank": 89
  },
  {
    "id": "gr_seleucid",
    "deck": "greco",
    "title": "הקמת האימפריה הסלווקית",
    "start": -312,
    "end": -312,
    "date": "312 לפנה״ס",
    "place": "בבל, עיראק",
    "lat": 32.536,
    "lon": 44.421,
    "desc": "סלווקוס ניקטור ייסד ממלכה שנמתחה מאנטוליה ועד גבולות הודו, הגדולה ביותר מבין ממלכות הדיאדוכים. הוא ייסד עשרות ערים יווניות, ביניהן אנטיוכיה (בירתו) וסלווקיה על הטיגריס. ההתמזגות של תרבות יוונית ומזרחית יצרה את העולם ההלניסטי.",
    "rank": 90
  },
  {
    "id": "gr_eratosthenes",
    "deck": "greco",
    "title": "ארטוסתנס מודד את היקף כדור הארץ",
    "start": -240,
    "end": -240,
    "date": "בערך 240 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.919,
    "desc": "ארטוסתנס חישב את היקף כדור הארץ בדייקנות מפתיעה על סמך הבדל זווית השמש בין אלכסנדריה לסיינה (אסוואן). התוצאה שלו הייתה קרובה מאוד למדידות המודרניות. הוא גם המציא את שיטת הנפה לחישוב מספרים ראשוניים.",
    "rank": 91
  },
  {
    "id": "gr_pharos",
    "deck": "greco",
    "title": "מגדלור אלכסנדריה",
    "start": -280,
    "end": -280,
    "date": "בערך 280 לפנה״ס",
    "place": "פארוס, אלכסנדריה",
    "lat": 31.214,
    "lon": 29.886,
    "desc": "מגדלור פארוס, אחד משבעת פלאי תבל, עמד בגובה של כ-100 מטר באי מול נמל אלכסנדריה. אורו, שהוגבר במראות, נראה לפי המסורת ממרחק 50 קילומטר. הוא עמד כ-1,500 שנה עד שרעידות אדמה הרסו אותו.",
    "rank": 92
  },
  {
    "id": "gr_roman_roads",
    "deck": "greco",
    "title": "הדרך האפיאנית",
    "start": -312,
    "end": -312,
    "date": "312 לפנה״ס",
    "place": "רומא לקפואה, איטליה",
    "lat": 41.842,
    "lon": 12.524,
    "desc": "הצנזור אפיוס קלאודיוס סלל את הדרך האפיאנית, הכביש הסלול הראשון של רומא, מרומא דרומה. \"מלכת הכבישים\" הניחה את הבסיס לרשת כבישים של 80,000 ק\"מ ברחבי האימפריה. חלקים ממנה עדיין מרוצפים באבניהם המקוריות.",
    "rank": 93
  },
  {
    "id": "gr_aqueducts",
    "deck": "greco",
    "title": "אקוודוקטים ברומא",
    "start": -312,
    "end": 226,
    "date": "312 לפנה״ס עד 226 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "רומא בנתה 11 אקוודוקטים שסיפקו מים מההרים לעיר, באורך כולל של כ-500 ק\"מ. פון דו גאר בצרפת הוא הדוגמה המרשימה ביותר ששרדה. מערכת המים אפשרה את המרחצאות הציבוריים, המזרקות ומערכת הביוב של רומא.",
    "rank": 94
  },
  {
    "id": "gr_gladiators",
    "deck": "greco",
    "title": "קרבות הגלדיאטורים ברומא",
    "start": -264,
    "end": 404,
    "date": "264 לפנה״ס עד 404 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.492,
    "desc": "קרבות הגלדיאטורים החלו כטקסי הלוויה והפכו לבידור עממי נרחב. הגלדיאטורים היו בדרך כלל עבדים או שבויי מלחמה שהתאמנו בבתי ספר מיוחדים. נאסרו ב-404 לספירה בידי הקיסר הנוצרי הונוריוס.",
    "rank": 95
  },
  {
    "id": "gr_mithridatic_wars",
    "deck": "greco",
    "title": "מלחמות מיתרידטס",
    "start": -89,
    "end": -63,
    "date": "⁦89–63⁩ לפנה״ס",
    "place": "אסיה הקטנה ויוון",
    "lat": 40,
    "lon": 36,
    "desc": "מיתרידטס השישי מלך פונטוס ניהל שלוש מלחמות מרות נגד רומא, ולפי המסורת רצח 80,000 רומאים ואיטלקים באסיה הקטנה ביום אחד. פומפיוס הגדול סיים את המלחמות וארגן מחדש את המזרח כפרובינקיות רומיות.",
    "rank": 96
  },
  {
    "id": "gr_crassus_parthia",
    "deck": "greco",
    "title": "תבוסת קראסוס בכרחי",
    "start": -53,
    "end": -53,
    "date": "53 לפנה״ס",
    "place": "חארן (כרחי), טורקיה",
    "lat": 36.863,
    "lon": 39.03,
    "desc": "מרקוס ליקיניוס קראסוס, האיש העשיר ביותר ברומא, יצא למלחמה נגד האימפריה הפרתית בחיפוש אחר תהילה צבאית. הפרשים הפרתיים השמידו את צבאו וקראסוס נהרג. מותו שבר את הטריאומווירט הראשון.",
    "rank": 97
  },
  {
    "id": "gr_pharsalus",
    "deck": "greco",
    "title": "קרב פרסלוס",
    "start": -48,
    "end": -48,
    "date": "48 לפנה״ס",
    "place": "פרסלוס, יוון",
    "lat": 39.27,
    "lon": 22.42,
    "desc": "קיסר ניצח את פומפיוס בקרב מכריע למרות שכוחותיו היו מועטים יותר. פומפיוס נמלט למצרים ונרצח שם. הניצחון הפך את קיסר לשליט בפועל של רומא והסתיימה מלחמת האזרחים.",
    "rank": 98
  },
  {
    "id": "gr_virgil_aeneid",
    "deck": "greco",
    "title": "ורגיליוס כותב את האנאידה",
    "start": -29,
    "end": -19,
    "date": "⁦29–19⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "ורגיליוס כתב את האפוס הלאומי של רומא — סיפור מסעו של אנאס מטרויה לאיטליה שבו ייסד את שושלת שתוליד את רומולוס ואת יוליוס קיסר. היצירה הוזמנה על ידי אוגוסטוס ושימשה כביטוי לזהות הרומית ולייעודה.",
    "rank": 99
  },
  {
    "id": "gr_ovid_metamorphoses",
    "deck": "greco",
    "title": "אובידיוס כותב את \"המטמורפוזות\"",
    "start": 8,
    "end": 8,
    "date": "בערך 8 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "אובידיוס יצר אוסף אפי של כ-250 מיתוסים יווניים ורומיים שבמרכזם שינויי צורה. היצירה השפיעה על שייקספיר, דנטה ואינספור אמנים. אוגוסטוס הגלה אותו לקצה האימפריה בנסיבות עמומות.",
    "rank": 100
  },
  {
    "id": "gr_tiberius",
    "deck": "greco",
    "title": "טיבריוס פורש לקפרי",
    "start": 26,
    "end": 37,
    "date": "⁦26–37⁩ לספירה",
    "place": "קפרי, איטליה",
    "lat": 40.553,
    "lon": 14.223,
    "desc": "הקיסר טיבריוס עזב את רומא ושלט מאי קפרי. הוא הפקיד את ניהול העיר בידי סיאנוס, ראש הפרטוריאנים, שניצל את כוחו. טיבריוס היה מצביא מצוין אך שליט בודד ומרתי שרבים פחדו ממנו.",
    "rank": 101
  },
  {
    "id": "gr_caligula",
    "deck": "greco",
    "title": "שלטון קליגולה",
    "start": 37,
    "end": 41,
    "date": "⁦37–41⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "גאיוס קליגולה, נכדו של טיבריוס, התחיל כקיסר פופולרי אך לפי המקורות נפל לטירוף — מינה את סוסו לקונסול, הכריז על עצמו כאל, ורדף סנאטורים. נרצח אחרי ארבע שנים בידי שומרי ראשו.",
    "rank": 102
  },
  {
    "id": "gr_claudius_britain",
    "deck": "greco",
    "title": "כיבוש בריטניה בידי קלאודיוס",
    "start": 43,
    "end": 43,
    "date": "43 לספירה",
    "place": "בריטניה",
    "lat": 51.5,
    "lon": -0.12,
    "desc": "הקיסר קלאודיוס, שנחשב למוגבל ועלה לשלטון במקרה, הזמין פלישה לבריטניה לרכוש תהילה צבאית. ארבעה לגיונות נחתו ובמהירות כבשו את דרום-מזרח האי. רומא שלטה בבריטניה כמעט 400 שנה.",
    "rank": 103
  },
  {
    "id": "gr_boudicca",
    "deck": "greco",
    "title": "מרד בואדיקאה",
    "start": 60,
    "end": 61,
    "date": "⁦60–61⁩ לספירה",
    "place": "בריטניה",
    "lat": 52.63,
    "lon": 1.3,
    "desc": "בואדיקאה, מלכת שבט האיקני, הנהיגה מרד נגד הכיבוש הרומי לאחר שנשותיה בוזו ובנותיה נאנסו. היא שרפה שלוש ערים רומיות כולל לונדיניום (לונדון). המרד הובס בסופו של דבר על ידי הנציב סואטוניוס פאולינוס.",
    "rank": 104
  },
  {
    "id": "gr_masada",
    "deck": "greco",
    "title": "נפילת מצדה",
    "start": 73,
    "end": 73,
    "date": "73 לספירה",
    "place": "מצדה, יהודה",
    "lat": 31.316,
    "lon": 35.354,
    "desc": "לגיון רומי צר על מבצר מצדה, המעוז האחרון של המרד הגדול ביהודה, ובנה סוללת עפר עד הפסגה. לפי יוסף בן מתתיהו, 960 מורדים בחרו בהתאבדות על פני שבי. הסיפור הפך לסמל יהודי וישראלי.",
    "rank": 105
  },
  {
    "id": "gr_pantheon",
    "deck": "greco",
    "title": "בניית הפנתיאון ברומא",
    "start": 118,
    "end": 128,
    "date": "בערך ⁦118–128⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.899,
    "lon": 12.477,
    "desc": "הקיסר אדריאנוס בנה את הפנתיאון עם כיפת בטון ללא תמיכה שקוטרה 43 מטר — שיא הנדסי שעמד כ-1,300 שנה. חור עגול בפסגתה (\"אוקולוס\") הוא מקור האור היחיד. הבניין עדיין עומד כמעט שלם.",
    "rank": 106
  },
  {
    "id": "gr_bar_kokhba",
    "deck": "greco",
    "title": "מרד בר כוכבא",
    "start": 132,
    "end": 136,
    "date": "⁦132–136⁩ לספירה",
    "place": "יהודה",
    "lat": 31.778,
    "lon": 35.23,
    "desc": "שמעון בר כוכבא הנהיג את המרד האחרון והגדול של יהודה נגד רומא. אדריאנוס דיכא את המרד בצורה אכזרית, שינה את שם הפרובינקיה לפלסטינה ואסר על יהודים להיכנס לירושלים. מכתבים של בר כוכבא נמצאו במדבר יהודה.",
    "rank": 107
  },
  {
    "id": "gr_antonine_plague",
    "deck": "greco",
    "title": "מגפת אנטונינוס",
    "start": 165,
    "end": 180,
    "date": "⁦165–180⁩ לספירה",
    "place": "האימפריה הרומית",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "מגפה, ככל הנראה אבעבועות שחורות, התפשטה ברחבי האימפריה מהחיילים ששבו מהמזרח. מתו כ-5 עד 10 מיליון בני אדם, כולל (אולי) הקיסר לוקיוס ורוס. המגפה החלישה את האימפריה בתקופה קריטית.",
    "rank": 108
  },
  {
    "id": "gr_commodus",
    "deck": "greco",
    "title": "קומודוס נלחם בזירה",
    "start": 180,
    "end": 192,
    "date": "⁦180–192⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.492,
    "desc": "הקיסר קומודוס, בנו של מרקוס אאורליוס, נלחם אישית בזירת הקולוסיאום כגלדיאטור — מעשה שנחשב מביש לכבוד הקיסרי. הוא הפגין חוסר אחריות שלטוני ונרצח בקשר. מותו פתח תקופה של מלחמות אזרחים.",
    "rank": 109
  },
  {
    "id": "gr_crisis_3rd",
    "deck": "greco",
    "title": "משבר המאה השלישית",
    "start": 235,
    "end": 284,
    "date": "⁦235–284⁩ לספירה",
    "place": "האימפריה הרומית",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "חמישים שנה של אנרכיה צבאית, פלישות ברבריות, מגפות ואינפלציה. עשרות קיסרים עלו ונפלו, האימפריה נפרדה לשלושה חלקים. אורליאנוס איחד אותה מחדש ודיוקלטיאנוס ייצב אותה ברפורמות יסוד.",
    "rank": 110
  },
  {
    "id": "gr_milvian_bridge",
    "deck": "greco",
    "title": "קרב גשר מילוויוס",
    "start": 312,
    "end": 312,
    "date": "312 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.937,
    "lon": 12.467,
    "desc": "קונסטנטינוס ניצח את מכסנטיוס בקרב על הגישה לרומא. לפי אוסביוס, לפני הקרב ראה קונסטנטינוס צלב בשמיים ואת הכיתוב \"בסימן זה תנצח\". הניצחון הפך את קונסטנטינוס לשליט המערב ואת הנצרות לכוח פוליטי.",
    "rank": 111
  },
  {
    "id": "gr_nicaea_council",
    "deck": "greco",
    "title": "הועידה הראשונה של ניקיאה",
    "start": 325,
    "end": 325,
    "date": "325 לספירה",
    "place": "ניקיאה (איזניק), טורקיה",
    "lat": 40.43,
    "lon": 29.72,
    "desc": "קונסטנטינוס כינס את הוועידה הנוצרית הראשונה הכלל-אימפריאלית כדי ליישב את מחלוקת אריוס — האם ישו שווה לאל או נברא אחריו. הוועידה ניסחה את הקרדו הניקאני שמגדיר את אמונת הנוצרים עד היום.",
    "rank": 112
  },
  {
    "id": "gr_julian_apostle",
    "deck": "greco",
    "title": "יוליאנוס הכופר",
    "start": 361,
    "end": 363,
    "date": "⁦361–363⁩ לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "יוליאנוס היה הקיסר האחרון שניסה להשיב את הפגאניות הרומית ולהחליש את הנצרות. הוא פתח מחדש מקדשים פגאניים ודרש סובלנות דתית. מותו בקרב נגד פרס אחרי שנתיים בלבד סיים את הניסיון.",
    "rank": 113
  },
  {
    "id": "gr_theodosius_christianity",
    "deck": "greco",
    "title": "תאודוסיוס מכריז על הנצרות כדת המדינה",
    "start": 380,
    "end": 380,
    "date": "380 לספירה",
    "place": "תסלוניקי, יוון",
    "lat": 40.64,
    "lon": 22.94,
    "desc": "הקיסר תאודוסיוס הכריז על הנצרות הניקאית כדת הרשמית היחידה של האימפריה. הפגאניות נאסרה הדרגתית, המשחקים האולימפיים הופסקו, ומקדשים עתיקים נסגרו או הוסבו לכנסיות.",
    "rank": 114
  },
  {
    "id": "gr_empire_split",
    "deck": "greco",
    "title": "חלוקת האימפריה הרומית",
    "start": 395,
    "end": 395,
    "date": "395 לספירה",
    "place": "רומא וקונסטנטינופול",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "לאחר מות תאודוסיוס חולקה האימפריה סופית בין בניו — הונוריוס במערב וארקדיוס במזרח. החלוקה הייתה מנהלית בתחילה אך הפכה לקבועה. המערב נפל תוך 80 שנה; המזרח (ביזנטיון) שרד עוד אלף.",
    "rank": 115
  },
  {
    "id": "gr_vandals_rome",
    "deck": "greco",
    "title": "שוד רומא בידי הוונדלים",
    "start": 455,
    "end": 455,
    "date": "455 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.496,
    "desc": "גאיסריך מלך הוונדלים הפליג מקרתגו ושדד את רומא במשך שבועיים. השוד היה שיטתי יותר מזה של אלאריק ב-410 — כלי קודש מבית המקדש בירושלים נלקחו. המילה \"ונדליזם\" מקורה באירוע זה.",
    "rank": 116
  },
  {
    "id": "gr_belisarius",
    "deck": "greco",
    "title": "כיבושי בליסריוס",
    "start": 533,
    "end": 540,
    "date": "⁦533–540⁩ לספירה",
    "place": "צפון אפריקה ואיטליה",
    "lat": 36.8,
    "lon": 10.18,
    "desc": "בליסריוס, המפקד המבריק של יוסטיניאנוס, כבש את צפון אפריקה מהוונדלים ואת איטליה מהאוסטרוגותים בכוחות קטנים. הוא נכנס לרומא ב-536 — הפעם הראשונה שהעיר הייתה תחת שלטון \"רומי\" מ-476. קיסרו חשד בו ושלל ממנו את פיקודו.",
    "rank": 117
  },
  {
    "id": "gr_justinian_plague",
    "deck": "greco",
    "title": "מגפת יוסטיניאנוס",
    "start": 541,
    "end": 542,
    "date": "⁦541–542⁩ לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "מגפת הדבר הראשונה הגדולה פגעה בקונסטנטינופול והרגה לפי ההערכות עד 25 מיליון בני אדם ברחבי האימפריה. המגפה ערערה את הניסיון של יוסטיניאנוס לשחזר את האימפריה הרומית ושינתה את מהלך ההיסטוריה.",
    "rank": 118
  },
  {
    "id": "gr_corpus_juris",
    "deck": "greco",
    "title": "עריכת הקורפוס יוריס ציוויליס",
    "start": 529,
    "end": 534,
    "date": "⁦529–534⁩ לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "בפקודת יוסטיניאנוס, ועדת משפטנים בהנהגת טריבוניאנוס ערכה את כל המשפט הרומי לקובץ אחד — דיגסטה, קודקס, אינסטיטוציות ונובלות. הקובץ הוא הבסיס של המשפט האזרחי ברוב מדינות אירופה ובמקומות רבים בעולם.",
    "rank": 119
  },
  {
    "id": "gr_nika_riots",
    "deck": "greco",
    "title": "מרד ניקה בקונסטנטינופול",
    "start": 532,
    "end": 532,
    "date": "532 לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.005,
    "lon": 28.977,
    "desc": "אוהדי מרוצי המרכבות בהיפודרום הפכו להמון זועם שכמעט הדיח את יוסטיניאנוס. הקיסרית תאודורה שכנעה אותו לא לברוח, ובליסריוס דיכא את המרד בטבח של אלפים בהיפודרום. יוסטיניאנוס בנה את איה סופיה על הריסות הכנסייה שנשרפה.",
    "rank": 120
  },
  {
    "id": "gr_heraclius_persia",
    "deck": "greco",
    "title": "הרקליוס מנצח את פרס",
    "start": 622,
    "end": 628,
    "date": "⁦622–628⁩ לספירה",
    "place": "האימפריה הביזנטית ופרס",
    "lat": 40,
    "lon": 44,
    "desc": "הקיסר הרקליוס הנהיג מסע צבאי דרמטי שהחזיר את צלב ישו מפרס והשיב את גבולות האימפריה. אך תוך עשור פלשו הערבים המוסלמים, והשטחים שנרכשו בדם רב אבדו לתמיד.",
    "rank": 121
  },
  {
    "id": "gr_iconoclasm",
    "deck": "greco",
    "title": "מחלוקת האיקונות הביזנטית",
    "start": 726,
    "end": 843,
    "date": "⁦726–843⁩ לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "קיסרים ביזנטיים הורו להשמיד צלמי קדושים (איקונות), מה שעורר מלחמת תרבות בין \"שוברי הצלמים\" ל\"חובבי הצלמים\". המחלוקת נמשכה מעל מאה שנה והעמיקה את הפער בין הכנסיות המזרחית והמערבית.",
    "rank": 122
  },
  {
    "id": "gr_basil_ii",
    "deck": "greco",
    "title": "בסיליוס השני שוחט הבולגרים",
    "start": 976,
    "end": 1025,
    "date": "⁦976–1025⁩ לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "בסיליוס השני היה הקיסר הביזנטי החזק ביותר: הוא הביס את הבולגרים (ולפי המסורת סימא 15,000 שבויים), הרחיב את האימפריה עד לשיאה. לאחר מותו נכנסה ביזנטיון לדעיכה הדרגתית.",
    "rank": 123
  },
  {
    "id": "gr_great_schism",
    "deck": "greco",
    "title": "הפילוג הגדול בין הכנסיות",
    "start": 1054,
    "end": 1054,
    "date": "1054",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "שליחי האפיפיור הניחו כתב חרם על הפטריארך הקונסטנטינופולי, והוא החרים אותם בתגובה. הפילוג בין הכנסייה הקתולית לאורתודוקסית נבע ממחלוקות תיאולוגיות (פיליוקוי), פוליטיות ותרבותיות שהצטברו מאות שנים.",
    "rank": 124
  },
  {
    "id": "gr_manzikert",
    "deck": "greco",
    "title": "קרב מנציקרט",
    "start": 1071,
    "end": 1071,
    "date": "1071",
    "place": "מנציקרט (מלאזגירד), טורקיה",
    "lat": 39.14,
    "lon": 43.48,
    "desc": "הסלג'וקים ניצחו את הצבא הביזנטי ושבו את הקיסר רומנוס הרביעי. התבוסה פתחה את אנטוליה — לב ביזנטיון — לפני ההתיישבות הטורקית, ושינתה את ההרכב האתני של האזור לעד.",
    "rank": 125
  },
  {
    "id": "gr_fourth_crusade",
    "deck": "greco",
    "title": "הצלבנים כובשים את קונסטנטינופול",
    "start": 1204,
    "end": 1204,
    "date": "1204",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "המסע הצלבני הרביעי, שהיה אמור לכבוש מצרים, פנה לקונסטנטינופול ושדד אותה. הצלבנים הקימו את האימפריה הלטינית, והביזנטים שבו רק ב-1261. האירוע העמיק את הקרע בין מזרח ומערב לבלתי ניתן לריפוי.",
    "rank": 126
  },
  {
    "id": "gr_greek_fire",
    "deck": "greco",
    "title": "\"האש היוונית\" של ביזנטיון",
    "start": 672,
    "end": 678,
    "date": "⁦672–678⁩ לספירה",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "הביזנטים השתמשו בנשק סודי — נוזל דליק שבער גם על מים — כדי להדוף את המצור הערבי הראשון על קונסטנטינופול. המתכון נשמר כסוד מדינה ואבד. הנשק הציל את האימפריה והיווה מעין \"נשק גרעיני\" של ימי הביניים.",
    "rank": 127
  },
  {
    "id": "gr_pythagoras",
    "deck": "greco",
    "title": "פיתגורס ובית ספרו",
    "start": -530,
    "end": -495,
    "date": "בערך ⁦530–495⁩ לפנה״ס",
    "place": "קרוטון, דרום איטליה",
    "lat": 39.08,
    "lon": 17.13,
    "desc": "פיתגורס מסאמוס ייסד קהילה פילוסופית-מיסטית בקרוטון שחקרה מתמטיקה, מוזיקה ואסטרונומיה. משפט פיתגורס הוא אחד היסודות של הגיאומטריה. הפיתגוראים גילו גם את המספרים האי-רציונליים — גילוי שהרעיד את עולמם.",
    "rank": 128
  },
  {
    "id": "gr_heraclitus",
    "deck": "greco",
    "title": "הרקליטוס והפילוסופיה של השינוי",
    "start": -500,
    "end": -500,
    "date": "בערך 500 לפנה״ס",
    "place": "אפסוס, אנטוליה",
    "lat": 37.94,
    "lon": 27.34,
    "desc": "הרקליטוס מאפסוס טען ש\"הכול זורם\" ושהשינוי הוא המציאות היסודית. האמרה \"אי אפשר לרדת פעמיים לאותו נהר\" מסכמת את תורתו. הוגדר כ\"הפילוסוף החשוך\" בגלל סגנון כתיבתו האניגמטי.",
    "rank": 129
  },
  {
    "id": "gr_democritus",
    "deck": "greco",
    "title": "דמוקריטוס ותורת האטומים",
    "start": -460,
    "end": -370,
    "date": "⁦460–370⁩ לפנה״ס",
    "place": "אבדרה, יוון",
    "lat": 40.95,
    "lon": 24.98,
    "desc": "דמוקריטוס טען שכל החומר מורכב מחלקיקים זעירים בלתי ניתנים לחלוקה — \"אטומים\" — שנעים בחלל ריק. הרעיון הקדים את הפיזיקה המודרנית ב-2,300 שנה. אף על פי שנדחה לטובת תורת אריסטו, הוא הפך ליסוד המדע המודרני.",
    "rank": 130
  },
  {
    "id": "gr_stoicism",
    "deck": "greco",
    "title": "זנון מקיטיון מייסד את הסטואה",
    "start": -301,
    "end": -301,
    "date": "בערך 301 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "זנון מקיטיון (קפריסין) לימד באולם המכונה \"סטואה פויקילה\" פילוסופיה שדגלה בשליטה ברגשות ובחיים לפי הטבע. הסטואיקנות השפיעה על רומא (סנקה, אפיקטטוס, מרקוס אאורליוס) ומהדהדת עד היום.",
    "rank": 131
  },
  {
    "id": "gr_epicurus",
    "deck": "greco",
    "title": "אפיקורוס ובית ספרו",
    "start": -307,
    "end": -307,
    "date": "בערך 307 לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "אפיקורוס ייסד בית ספר (\"הגן\") שלימד שמטרת החיים היא אטרקסיה — שלווה נפשית — ושהעונג האמיתי הוא היעדר סבל. הוא דחה את הפחד מהאלים וממוות. \"אפיקוראיות\" התעוותה לשם נרדף לתאוותנות, בניגוד לרוח המקורית.",
    "rank": 132
  },
  {
    "id": "gr_ptolemy_almagest",
    "deck": "greco",
    "title": "תלמי כותב את האלמגסט",
    "start": 150,
    "end": 150,
    "date": "בערך 150 לספירה",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.919,
    "desc": "קלאודיוס תלמיוס חיבר את \"האלמגסט\" — האנציקלופדיה האסטרונומית שהציגה את המודל הגיאוצנטרי. יצירתו שלטה באסטרונומיה 1,400 שנה, עד קופרניקוס. הוא גם חיבר את \"הגיאוגרפיה\" שמיפתה את העולם הידוע.",
    "rank": 133
  },
  {
    "id": "gr_galen",
    "deck": "greco",
    "title": "גאלנוס — רופאם של הקיסרים",
    "start": 162,
    "end": 200,
    "date": "⁦162–200⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "גאלנוס מפרגמון היה הרופא הרומי המשפיע ביותר; כתביו שלטו ברפואה המערבית עד הרנסנס. הוא ניתח חיות (לא בני אדם) ובנה תיאוריה מקיפה של ארבעת הליחות. שימש כרופא של מספר קיסרים.",
    "rank": 134
  },
  {
    "id": "gr_vitruvius",
    "deck": "greco",
    "title": "ויטרוויוס כותב על אדריכלות",
    "start": -30,
    "end": -15,
    "date": "בערך ⁦30–15⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "מרקוס ויטרוויוס כתב את \"עשרת הספרים על אדריכלות\" — הספר היחיד על אדריכלות ששרד מהעת העתיקה. עקרונותיו — תועלת, חוזק ויופי — השפיעו על אדריכלות הרנסנס. \"האדם הויטרובי\" של לאונרדו מבוסס על מידותיו.",
    "rank": 135
  },
  {
    "id": "gr_seneca",
    "deck": "greco",
    "title": "סנקה — פילוסוף ויועץ לנירון",
    "start": 54,
    "end": 65,
    "date": "⁦54–65⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "סנקה, פילוסוף סטואי ומחזאי, שימש כמורה ויועץ של הקיסר נירון. מכתביו המוסריים ומאמריו על הכעס, השלווה וקוצר החיים נקראים עד היום. כשנירון חשד בו בקשירת קשר, סנקה נצטווה להתאבד ועשה זאת בפומבי.",
    "rank": 136
  },
  {
    "id": "gr_epictetus",
    "deck": "greco",
    "title": "אפיקטטוס — מעבד לפילוסוף",
    "start": 89,
    "end": 135,
    "date": "⁦89–135⁩ לספירה",
    "place": "ניקופוליס, יוון",
    "lat": 38.96,
    "lon": 20.73,
    "desc": "אפיקטטוס, עבד לשעבר, לימד סטואיקנות: \"מה שבשליטתנו ומה שלא — זו ההבחנה היסודית\". תלמידו אריאנוס רשם את שיחותיו ב\"שיחות\" וב\"אנכירידיון\". מרקוס אאורליוס למד ממנו.",
    "rank": 137
  },
  {
    "id": "gr_roman_baths",
    "deck": "greco",
    "title": "מרחצאות קרקלה",
    "start": 212,
    "end": 216,
    "date": "⁦212–216⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.879,
    "lon": 12.493,
    "desc": "הקיסר קרקלה בנה מתחם מרחצאות ענק שהכיל בריכות חמות, פושרות וקרות, ספריות, גנים, ואולמות ספורט — הכול בכניסה חופשית לכל תושבי רומא. המרחצאות שימשו כמרכז חברתי ולא רק לרחיצה.",
    "rank": 138
  },
  {
    "id": "gr_pont_du_gard",
    "deck": "greco",
    "title": "בניית פון דו גאר",
    "start": 40,
    "end": 60,
    "date": "בערך המאה ה-1 לספירה",
    "place": "נים, צרפת",
    "lat": 43.947,
    "lon": 4.536,
    "desc": "גשר האקוודוקט הרומי פון דו גאר בדרום צרפת, בגובה 49 מטר ושלוש קומות קשתות, הוביל מים לעיר נמאוסוס (נים). הוא אחד המבנים הרומיים המרשימים ביותר ששרדו ונחשב לשיא ההנדסה הרומית.",
    "rank": 139
  },
  {
    "id": "gr_roman_senate",
    "deck": "greco",
    "title": "הסנאט הרומי",
    "start": -509,
    "end": 476,
    "date": "509 לפנה״ס עד 476 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הסנאט היה המוסד הפוליטי המרכזי של הרפובליקה — מועצת זקנים (300 ואחר כך 600 חברים) ששלטה בפועל במדיניות החוץ, בתקציב ובמינויים. תחת הקיסרות איבד כוח אך שמר על יוקרה. הביטוי S.P.Q.R. סימל את האחדות בין הסנאט לעם.",
    "rank": 140
  },
  {
    "id": "gr_polis",
    "deck": "greco",
    "title": "עליית הפוליס — עיר המדינה היוונית",
    "start": -800,
    "end": -500,
    "date": "המאות ⁦8–6⁩ לפנה״ס",
    "place": "יוון",
    "lat": 37.97,
    "lon": 23.72,
    "desc": "הפוליס — עיר מדינה עצמאית עם חוקים, צבא ומטבע משלה — הייתה היחידה הפוליטית הבסיסית ביוון. אתונה, ספרטה, קורינתוס ותבי הן הידועות, אך היו מאות. הפוליס עיצבה את הזהות היוונית: אזרח הפוליס ולא בן שבט.",
    "rank": 141
  },
  {
    "id": "gr_greek_colonization",
    "deck": "greco",
    "title": "ההתיישבות היוונית ברחבי הים התיכון",
    "start": -750,
    "end": -550,
    "date": "⁦750–550⁩ לפנה״ס",
    "place": "הים התיכון",
    "lat": 37,
    "lon": 15,
    "desc": "ערי מדינה יווניות ייסדו מושבות מספרד ועד הים השחור: מרסיי, נאפולי, סרקוזה, ביזנטיון ועוד עשרות. ההתיישבות הפיצה את התרבות, השפה והסחר היוונים. דרום איטליה נקראה \"מגנה גראקיה\" — יוון הגדולה.",
    "rank": 142
  },
  {
    "id": "gr_persian_royal_road",
    "deck": "greco",
    "title": "הדרך המלכותית הפרסית",
    "start": -500,
    "end": -500,
    "date": "בערך 500 לפנה״ס",
    "place": "סרדיס לשושן",
    "lat": 38.47,
    "lon": 28.04,
    "desc": "דריוש הראשון בנה כביש שחיבר את סרדיס (מערב אנטוליה) לשושן — כ-2,700 ק\"מ — עם תחנות דואר שאפשרו שליח רכוב לעבור את כולו ב-7 ימים. הרודוטוס תיאר את היעילות בהתפעלות. הדרך שירתה מסחר, צבא ומנהל.",
    "rank": 143
  },
  {
    "id": "gr_delphic_oracle",
    "deck": "greco",
    "title": "האורקל בדלפי",
    "start": -800,
    "end": 393,
    "date": "המאה ה-8 לפנה״ס עד 393 לספירה",
    "place": "דלפי, יוון",
    "lat": 38.483,
    "lon": 22.501,
    "desc": "מקדש אפולון בדלפי היה המקום הקדוש ביותר ביוון, שבו הנביאה (פיתיה) מסרה נבואות. מנהיגים מכל הים התיכון התייעצו עם האורקל לפני מלחמות וייסוד מושבות. הכיתוב \"דע את עצמך\" היה חרוט בכניסה.",
    "rank": 144
  },
  {
    "id": "gr_persian_immortals",
    "deck": "greco",
    "title": "\"האלמוותיים\" — הגארד הפרסי",
    "start": -550,
    "end": -330,
    "date": "⁦550–330⁩ לפנה״ס",
    "place": "פרספוליס, פרס",
    "lat": 29.935,
    "lon": 52.891,
    "desc": "עשרת אלפי \"האלמוותיים\" היו כוח העילית של הצבא הפרסי — כשאחד נפל, אחר מילא מיד את מקומו, כך שמספרם נשאר תמיד עשרת אלפים. הם מתוארים בתבליטי פרספוליס ובכתבי הרודוטוס.",
    "rank": 145
  },
  {
    "id": "gr_tyrants",
    "deck": "greco",
    "title": "עידן הטירנים ביוון",
    "start": -650,
    "end": -500,
    "date": "⁦650–500⁩ לפנה״ס",
    "place": "יוון",
    "lat": 37.94,
    "lon": 22.88,
    "desc": "\"טירן\" ביוונית לא היה בהכרח רודן — הוא שליט שתפס את השלטון שלא בדרך חוקית. טירנים כמו פיסיסטרטוס באתונה ופוליקראטס בסאמוס שיפרו לעיתים את חיי האזרחים. תקופתם הייתה מעבר מהאריסטוקרטיה לדמוקרטיה.",
    "rank": 146
  },
  {
    "id": "gr_olympic_truce",
    "deck": "greco",
    "title": "\"שביתת הנשק האולימפית\"",
    "start": -776,
    "end": -776,
    "date": "מהמאה ה-8 לפנה״ס",
    "place": "אולימפיה, יוון",
    "lat": 37.638,
    "lon": 21.63,
    "desc": "בזמן המשחקים האולימפיים הוכרזה \"אקכיריה\" — שביתת נשק שהבטיחה מעבר בטוח לספורטאים וצופים. המנהג איפשר ליוונים מכל ערי המדינה לנסוע לאולימפיה גם בזמן מלחמה. הוא סימל את האחדות הפאן-הלנית.",
    "rank": 147
  },
  {
    "id": "gr_thales",
    "deck": "greco",
    "title": "תאלס — אבי הפילוסופיה",
    "start": -585,
    "end": -585,
    "date": "בערך 585 לפנה״ס",
    "place": "מילטוס, אנטוליה",
    "lat": 37.53,
    "lon": 27.28,
    "desc": "תאלס ממילטוס, הראשון בשבעת החכמים, חיפש הסבר טבעי (לא מיתי) לתופעות העולם. הוא ניבא ליקוי חמה, חקר גיאומטריה ולימד שהמים הם יסוד כל דבר. נחשב לאבי הפילוסופיה והמדע המערביים.",
    "rank": 148
  },
  {
    "id": "gr_empedocles",
    "deck": "greco",
    "title": "ארבעת היסודות של אמפדוקלס",
    "start": -450,
    "end": -450,
    "date": "בערך 450 לפנה״ס",
    "place": "אקרגאס (אגריגנטו), סיציליה",
    "lat": 37.31,
    "lon": 13.59,
    "desc": "אמפדוקלס הציע שכל החומר מורכב מארבעה יסודות — אדמה, מים, אוויר ואש — שמתערבבים ונפרדים בכוחות אהבה ומריבה. התיאוריה שלטה בכימיה עד המאה ה-18. לפי האגדה, קפץ לתוך הר הגעש אטנה.",
    "rank": 149
  },
  {
    "id": "gr_parmenides",
    "deck": "greco",
    "title": "פרמנידס ותורת ה\"יש\"",
    "start": -485,
    "end": -485,
    "date": "בערך 485 לפנה״ס",
    "place": "אלאה, דרום איטליה",
    "lat": 40.16,
    "lon": 15.15,
    "desc": "פרמנידס טען שהשינוי הוא אשליה: רק ה\"יש\" קיים, נצחי ובלתי משתנה. עמדתו הרדיקלית אתגרה את כל הפילוסופים שבאו אחריו להסביר כיצד שינוי אפשרי. אפלטון קרא לו \"אבי הפילוסופים\".",
    "rank": 150
  },
  {
    "id": "gr_pindar_odes",
    "deck": "greco",
    "title": "שירי הניצחון של פינדאר",
    "start": -476,
    "end": -446,
    "date": "⁦476–446⁩ לפנה״ס",
    "place": "תבי, יוון",
    "lat": 38.319,
    "lon": 23.318,
    "desc": "פינדאר מתבי היה המשורר הלירי הגדול ביותר ביוון, שהלחין שירי ניצחון (אפיניקיות) לזוכים במשחקים הפאנהלניים. שיריו קישרו הצלחה אתלטית לשבח אלוהי. שרדו 45 שירים שלמים מתוך 17 ספרים.",
    "rank": 151
  },
  {
    "id": "gr_peisistratus",
    "deck": "greco",
    "title": "פיסיסטרטוס טירן אתונה",
    "start": -561,
    "end": -527,
    "date": "⁦561–527⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "פיסיסטרטוס תפס את שלטון אתונה שלוש פעמים וגורש פעמיים. בניגוד לצפוי, שלטונו היטיב עם העם: הוא חילק קרקעות, מימן בנייה ציבורית ועודד פסטיבלים תרבותיים. לפי המסורת, הוא הורה לערוך את שירי הומרוס.",
    "rank": 152
  },
  {
    "id": "gr_cato_elder",
    "deck": "greco",
    "title": "קטו הזקן — \"קרתגו צריכה להיחרב\"",
    "start": -157,
    "end": -149,
    "date": "⁦157–149⁩ לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הסנאטור קטו הזקן סיים כל נאום, בכל נושא, במשפט \"ומלבד זאת, דעתי היא שקרתגו צריכה להיחרב\". הפך לסמל של עקשנות פוליטית. נגד התרבות היוונית, הוא ייצג את הערכים הרומיים המסורתיים.",
    "rank": 153
  },
  {
    "id": "gr_pergamon",
    "deck": "greco",
    "title": "ממלכת פרגמון",
    "start": -282,
    "end": -133,
    "date": "⁦282–133⁩ לפנה״ס",
    "place": "פרגמון (ברגמה), טורקיה",
    "lat": 39.12,
    "lon": 27.18,
    "desc": "ממלכה הלניסטית קטנה ועשירה שתחרתה עם אלכסנדריה בחסות התרבות. מזבח פרגמון הוא יצירת מופת של הפיסול ההלניסטי. מלכה האחרון הוריש אותה לרומא — מקרה נדיר של סיפוח רצוני.",
    "rank": 154
  },
  {
    "id": "gr_antikythera",
    "deck": "greco",
    "title": "מנגנון אנטיקיתרה",
    "start": -150,
    "end": -100,
    "date": "בערך ⁦150–100⁩ לפנה״ס",
    "place": "יוון",
    "lat": 35.86,
    "lon": 23.31,
    "desc": "מנגנון שעונים מורכב שנמצא בספינה טרופה ליד אנטיקיתרה, מסוגל לחזות מיקומי כוכבי לכת, ליקויים ותאריכי משחקים אתלטיים. נחשב ל\"מחשב\" הראשון בהיסטוריה, ומעיד על רמה טכנולוגית יוונית שלא ידענו עליה.",
    "rank": 155
  },
  {
    "id": "gr_corinthian_order",
    "deck": "greco",
    "title": "שלושת הסדרים האדריכליים",
    "start": -600,
    "end": -400,
    "date": "המאות ⁦6–5⁩ לפנה״ס",
    "place": "יוון",
    "lat": 37.97,
    "lon": 23.72,
    "desc": "הסדרים הדורי, היוני והקורינתי מגדירים את הפרופורציות ועיטורי העמודים של האדריכלות היוונית. הדורי — פשוט וכבד; היוני — אלגנטי עם ווֹלוּטות; הקורינתי — מעוטר בעלי אקנתוס. השילוש הזה עיצב בניינים ברחבי העולם.",
    "rank": 156
  },
  {
    "id": "gr_venus_milo",
    "deck": "greco",
    "title": "ונוס ממילו",
    "start": -130,
    "end": -100,
    "date": "בערך ⁦130–100⁩ לפנה״ס",
    "place": "מילוס, יוון",
    "lat": 36.71,
    "lon": 24.42,
    "desc": "פסל שיש הלניסטי של אפרודיטה שנמצא באי מילוס ב-1820 ומוצג בלובר. חסר הזרועות, הוא נחשב לאחד הפסלים המפורסמים ביותר בעולם. הפסל מדגים את המעבר מהפרופורציות האידיאליות של פידיאס לריאליזם הלניסטי.",
    "rank": 157
  },
  {
    "id": "gr_laocoon",
    "deck": "greco",
    "title": "פסל לאוקואון ובניו",
    "start": -40,
    "end": -40,
    "date": "בערך המאה ה-1 לפנה״ס",
    "place": "רודוס או רומא",
    "lat": 36.41,
    "lon": 28.22,
    "desc": "קבוצת השיש של לאוקואון ובניו — כהן טרויאני הנחנק בנחשי ים כעונש מהאלים — נמצאה ברומא ב-1506. מיכלאנג'לו הגיע לראותה. היא נחשבת לשיא הפיסול ההלניסטי ולביטוי האולטימטיבי של סבל בפיסול.",
    "rank": 158
  },
  {
    "id": "gr_colossus_rhodes",
    "deck": "greco",
    "title": "הקולוסוס של רודוס",
    "start": -292,
    "end": -280,
    "date": "⁦292–280⁩ לפנה״ס",
    "place": "רודוס, יוון",
    "lat": 36.45,
    "lon": 28.227,
    "desc": "פסל ברונזה ענק של האל הליוס (אל השמש), אחד משבעת פלאי תבל העתיקים. עמד בגובה כ-33 מטר ליד הנמל. נהרס ברעידת אדמה אחרי 54 שנים בלבד, ולא שוחזר מעולם.",
    "rank": 159
  },
  {
    "id": "gr_praetorian_guard",
    "deck": "greco",
    "title": "הגארד הפרטורי",
    "start": -27,
    "end": 312,
    "date": "27 לפנה״ס עד 312 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.902,
    "lon": 12.504,
    "desc": "יחידת העילית של הצבא הרומי ששימשה כשומרי ראש הקיסר. עם הזמן הפכו לכוח פוליטי עצמאי שמינה והדיח קיסרים — הם רצחו את קליגולה ומכרו את הקיסרות למרבה במחיר. קונסטנטינוס פירק אותם.",
    "rank": 160
  },
  {
    "id": "gr_samnite_wars",
    "deck": "greco",
    "title": "מלחמות הסמניטים",
    "start": -343,
    "end": -290,
    "date": "⁦343–290⁩ לפנה״ס",
    "place": "מרכז איטליה",
    "lat": 41.3,
    "lon": 14.5,
    "desc": "שלוש מלחמות בין רומא לשבטים הסמניטיים בהרי מרכז איטליה עיצבו את עתיד רומא. בקרב המזלגות הקאודיניים (321 לפנה״ס) הושפל הצבא הרומי לחלוטין. בסופו של דבר רומא ניצחה ושלטה בכל חצי האי האיטלקי.",
    "rank": 161
  },
  {
    "id": "gr_pyrrhus",
    "deck": "greco",
    "title": "מלחמות פירוס — \"ניצחון פירוסי\"",
    "start": -280,
    "end": -275,
    "date": "⁦280–275⁩ לפנה״ס",
    "place": "דרום איטליה",
    "lat": 40.35,
    "lon": 15.85,
    "desc": "פירוס, מלך אפירוס, ניצח את הרומאים בקרבות דרום איטליה, אך מחיר הניצחונות היה כה גבוה שנאלץ לסגת. הביטוי \"ניצחון פירוסי\" — ניצחון שמחירו כתבוסה — מקורו בדבריו: \"עוד ניצחון כזה ואני אובד\".",
    "rank": 162
  },
  {
    "id": "gr_colosseum_games",
    "deck": "greco",
    "title": "משחקי חנוכת הקולוסיאום",
    "start": 80,
    "end": 80,
    "date": "80 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.492,
    "desc": "טיטוס חנך את הקולוסיאום במאה ימי משחקים רצופים: קרבות גלדיאטורים, קרבות ימיים מבוימים (נאומכיות) בזירה שהוצפה, וציד חיות שבו נהרגו לפי המסורת 9,000 בעלי חיים. הייתה זו הצגת עוצמה קיסרית ללא מתחרה.",
    "rank": 163
  },
  {
    "id": "gr_teutoburg",
    "deck": "greco",
    "title": "קרב יער טויטובורג",
    "start": 9,
    "end": 9,
    "date": "9 לספירה",
    "place": "יער טויטובורג, גרמניה",
    "lat": 52.41,
    "lon": 8.13,
    "desc": "שבטים גרמניים בהנהגת ארמיניוס השמידו שלושה לגיונות רומיים ביער עבות. אוגוסטוס, לפי המסורת, זעק: \"וארוס, החזר לי את הלגיונות!\" רומא נסוגה מעבר לריין ומעולם לא כבשה את גרמניה.",
    "rank": 164
  },
  {
    "id": "gr_josephus",
    "deck": "greco",
    "title": "יוסף בן מתתיהו כותב את מלחמת היהודים",
    "start": 75,
    "end": 79,
    "date": "⁦75–79⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "יוסף בן מתתיהו (יוספוס פלאוויוס), מפקד יהודי שעבר לצד הרומאים, כתב ברומא את ההיסטוריה של המרד היהודי נגד רומא. ספרו הוא המקור העיקרי למרד הגדול, לחורבן הבית ולמצדה.",
    "rank": 165
  },
  {
    "id": "gr_septimius_severus",
    "deck": "greco",
    "title": "ספטימיוס סוורוס — הקיסר האפריקני",
    "start": 193,
    "end": 211,
    "date": "⁦193–211⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "ספטימיוס סוורוס, שנולד בלפטיס מגנה (לוב), היה הקיסר הראשון ממוצא אפריקני. הוא חיזק את הצבא והפך את הקיסרות לצבאית יותר, ואמר לבניו: \"שלמו לחיילים, שאר הדברים לא חשובים\".",
    "rank": 166
  },
  {
    "id": "gr_aurelian_walls",
    "deck": "greco",
    "title": "חומות אאורליאנוס ברומא",
    "start": 271,
    "end": 275,
    "date": "⁦271–275⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הקיסר אאורליאנוס בנה חומות מגן סביב רומא לראשונה מזה מאות שנים, מתוך פחד מפלישות ברבריות. העובדה שהעיר הנצחית נזקקה לחומות סימלה את הידרדרות הביטחון. חומות אאורליאנוס עומדות ברובן עד היום.",
    "rank": 167
  },
  {
    "id": "gr_attila",
    "deck": "greco",
    "title": "אטילה ההוני מאיים על רומא",
    "start": 451,
    "end": 452,
    "date": "⁦451–452⁩ לספירה",
    "place": "גאליה ואיטליה",
    "lat": 49.25,
    "lon": 3.6,
    "desc": "אטילה, \"שוט האלוהים\", הוביל את ההונים לפלישה לגאליה ואיטליה. הובס בקרב השדות הקטלאוניים אך חזר ופלש לאיטליה. לפי המסורת, האפיפיור לאו הראשון שכנע אותו לסגת. מותו הפתאומי מנע הרס נוסף.",
    "rank": 168
  },
  {
    "id": "gr_romulus_augustulus",
    "deck": "greco",
    "title": "הדחת רומולוס אוגוסטולוס",
    "start": 476,
    "end": 476,
    "date": "476 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.496,
    "desc": "הנער רומולוס אוגוסטולוס (\"הקיסרון הקטן\") היה הקיסר הרומי האחרון במערב. אודואקר הדיח אותו ושלח את סימני הקיסרות לקונסטנטינופול. בשם — מרומולוס מייסד רומא ועד אוגוסטולוס אחרון קיסריה — נרשם סיפור האימפריה.",
    "rank": 169
  },
  {
    "id": "gr_theodoric",
    "deck": "greco",
    "title": "תאודוריק הגדול שולט באיטליה",
    "start": 493,
    "end": 526,
    "date": "⁦493–526⁩ לספירה",
    "place": "רוונה, איטליה",
    "lat": 44.418,
    "lon": 12.2,
    "desc": "תאודוריק, מלך האוסטרוגותים, שלט באיטליה מרוונה ושמר על המנהל הרומי. הוא תיקן אקוודוקטים ובנה כנסיות, ויצר מעין ממשיכות רומית תחת שלטון גרמאני. קברו ברוונה הוא דוגמה נדירה לאדריכלות גותית.",
    "rank": 170
  },
  {
    "id": "gr_battle_yarmouk",
    "deck": "greco",
    "title": "קרב הירמוך — ביזנטיון מאבדת את הלבנט",
    "start": 636,
    "end": 636,
    "date": "636 לספירה",
    "place": "נהר הירמוך",
    "lat": 32.67,
    "lon": 35.96,
    "desc": "הצבא הביזנטי הובס על ידי הכוחות הערביים המוסלמים ליד נהר הירמוך. הקרב סיים את השלטון הביזנטי בסוריה ובא\"י. תוך שנים ספורות נפלו גם מצרים וצפון אפריקה. ביזנטיון הפכה למעצמה אנטולית-בלקנית.",
    "rank": 171
  },
  {
    "id": "gr_byzantium_1261",
    "deck": "greco",
    "title": "שחרור קונסטנטינופול מהצלבנים",
    "start": 1261,
    "end": 1261,
    "date": "1261",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "מיכאל הפלאולוגוס כבש בחזרה את קונסטנטינופול מה\"אימפריה הלטינית\" שהקימו הצלבנים ב-1204. שושלת הפלאולוגים הייתה האחרונה בביזנטיון, אך האימפריה המחודשת הייתה צל חיוור של עצמה. היא שרדה עוד 192 שנה.",
    "rank": 172
  },
  {
    "id": "gr_ottoman_siege",
    "deck": "greco",
    "title": "תותחי מחמד השני בקונסטנטינופול",
    "start": 1453,
    "end": 1453,
    "date": "1453",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "מחמד השני השתמש ב\"תותח אורבאן\" הענק — תותח ברונזה באורך 8 מטרים ששקל 17 טון — כדי לפרוץ את חומות תאודוסיוס שעמדו אלף שנה. העות'מאנים גם גררו ספינות ביבשה מעבר לגבעה כדי לעקוף את שרשרת הנמל. זו הייתה תחילת עידן אבק השריפה בלחימה.",
    "rank": 173
  },
  {
    "id": "gr_constantine_xi",
    "deck": "greco",
    "title": "מות קונסטנטינוס האחד-עשר",
    "start": 1453,
    "end": 1453,
    "date": "1453",
    "place": "קונסטנטינופול",
    "lat": 41.008,
    "lon": 28.98,
    "desc": "הקיסר הביזנטי האחרון, קונסטנטינוס ה-11 פלאולוגוס, נהרג בקרבות על החומות בזמן שקונסטנטינופול נפלה. לפי האגדה, הסיר את סימני הקיסרות והתנפל לתוך הקרב כחייל פשוט. גופו מעולם לא נמצא.",
    "rank": 174
  },
  {
    "id": "gr_hannibal_elephants",
    "deck": "greco",
    "title": "פילי המלחמה של חניבעל",
    "start": -218,
    "end": -218,
    "date": "218 לפנה״ס",
    "place": "מעברי האלפים",
    "lat": 44.85,
    "lon": 6.87,
    "desc": "חניבעל יצא למסע עם 37 פילי מלחמה, אך רובם מתו בחציית האלפים ובחורף הראשון. הפיל הידוע בשם \"סירוס\" היה כנראה האחרון ששרד. פילי המלחמה הטילו אימה על סוסים רומיים שלא הכירו אותם, אך הוכחו כפחות יעילים ממה שקיוו.",
    "rank": 175
  },
  {
    "id": "gr_census_rome",
    "deck": "greco",
    "title": "הצנזוס הרומי",
    "start": -443,
    "end": -443,
    "date": "בערך 443 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הרומאים הנהיגו מפקד אוכלוסין (census) כל חמש שנים, לצרכי מיסוי וגיוס. הצנזור היה התפקיד המכובד ביותר ברפובליקה, שיכול היה להוציא סנאטורים מהסנאט על חוסר מוסריות. המילה \"צנזורה\" מקורה בתפקיד זה.",
    "rank": 176
  },
  {
    "id": "gr_tribunes",
    "deck": "greco",
    "title": "הקמת תפקיד הטריבון",
    "start": -494,
    "end": -494,
    "date": "494 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הפלבאים פרשו מרומא ל\"הר הקדוש\" (secessio plebis) ודרשו נציגות. נוצר תפקיד הטריבון — נבחר עם וטו על כל החלטה של הסנאט, גופו \"מקודש\" (sacrosanctus). זה היה הצעד הראשון של העם לכוח פוליטי ברפובליקה.",
    "rank": 177
  },
  {
    "id": "gr_roman_marriage",
    "deck": "greco",
    "title": "חוקי הנישואין של אוגוסטוס",
    "start": -18,
    "end": 9,
    "date": "18 לפנה״ס עד 9 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "אוגוסטוס חוקק חוקים שחייבו נישואין והעניקו הטבות למשפחות עם שלושה ילדים ויותר, מתוך דאגה לירידה בילודה במעמד השליט. החוקים הגבילו ניאוף וחייבו אלמנות להינשא מחדש. הם נחלו הצלחה חלקית בלבד.",
    "rank": 178
  },
  {
    "id": "gr_latin_language",
    "deck": "greco",
    "title": "הלטינית הופכת לשפת הים התיכון",
    "start": -200,
    "end": 200,
    "date": "המאות ⁦2 לפנה״ס – 2 לספירה⁩",
    "place": "האימפריה הרומית",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "עם התפשטות רומא, הלטינית הפכה מלשון אזורית של לאטיום לשפת הממשל, המשפט והספרות של כל מערב הים התיכון. ממנה התפתחו השפות הרומאניות — איטלקית, צרפתית, ספרדית, פורטוגזית ורומנית.",
    "rank": 179
  },
  {
    "id": "gr_titus_arch",
    "deck": "greco",
    "title": "שער טיטוס ברומא",
    "start": 81,
    "end": 81,
    "date": "81 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.891,
    "lon": 12.489,
    "desc": "שער הניצחון של טיטוס הוקם לכבוד כיבוש ירושלים ב-70 לספירה. התבליט המפורסם מציג חיילים רומאים נושאים את מנורת בית המקדש. השער נחשב לדגם של שערי ניצחון בכל העולם.",
    "rank": 180
  },
  {
    "id": "gr_edict_caracalla",
    "deck": "greco",
    "title": "צו קרקלה — אזרחות לכולם",
    "start": 212,
    "end": 212,
    "date": "212 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הקיסר קרקלה העניק אזרחות רומית לכל התושבים החופשיים באימפריה. בפעולה אחת נמחקו ההבדלים המשפטיים בין רומאים לפרובינקיאלים. המניע היה כנראה הרחבת בסיס המס, אך ההשפעה התרבותית הייתה עצומה.",
    "rank": 181
  },
  {
    "id": "gr_decius_persecution",
    "deck": "greco",
    "title": "רדיפת הנוצרים בימי דקיוס",
    "start": 250,
    "end": 251,
    "date": "⁦250–251⁩ לספירה",
    "place": "האימפריה הרומית",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "הקיסר דקיוס ציווה על כל תושבי האימפריה להקריב קורבנות לאלים ולקבל תעודה (libellus). מי שסירב — בעיקר נוצרים — נענש בכליאה, ענישה גופנית או מוות. זו הייתה הרדיפה השיטתית הראשונה שפגעה בכל הנצרות.",
    "rank": 182
  },
  {
    "id": "gr_silk_road_rome",
    "deck": "greco",
    "title": "המשי הסיני מגיע לרומא",
    "start": -50,
    "end": 200,
    "date": "המאה ה-1 לפנה״ס עד המאה ה-2 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "סחר המשי בין סין ורומא דרך דרך המשי הפך את המשי לסמל של מותרות ברומא. סנקה התלונן שנשים רומיות לובשות בדים שקופים. פליניוס הזקן חישב שרומא מוציאה 100 מיליון ססטרציוס בשנה על מותרות מזרחיות.",
    "rank": 183
  },
  {
    "id": "gr_nero_persecution",
    "deck": "greco",
    "title": "נירון רודף נוצרים",
    "start": 64,
    "end": 68,
    "date": "⁦64–68⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.496,
    "desc": "נירון האשים את הנוצרים בשריפת רומא והוציא אותם להורג בצורות אכזריות: הלבישם בעורות חיות למאכל כלבים, צלב אותם, והפך אותם ללפידים חיים בגנותיו. לפי המסורת, פטרוס ופאולוס הושמו למוות בתקופה זו.",
    "rank": 184
  },
  {
    "id": "gr_vespasian",
    "deck": "greco",
    "title": "וספסיאנוס מייסד את שושלת פלאוויוס",
    "start": 69,
    "end": 79,
    "date": "⁦69–79⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "וספסיאנוס, מפקד צבאי שעלה לשלטון אחרי \"שנת ארבעת הקיסרים\", ייצב את האימפריה ובנה את הקולוסיאום. אמרתו על מיסוי השתנות ציבוריים — \"כסף לא מסריח\" — הפכה לפתגם. היה הקיסר הראשון מהמעמד האיטלקי הבינוני.",
    "rank": 185
  },
  {
    "id": "gr_pliny_elder",
    "deck": "greco",
    "title": "פליניוס הזקן כותב את ההיסטוריה הטבעית",
    "start": 77,
    "end": 77,
    "date": "77 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "פליניוס הזקן כתב את \"ההיסטוריה הטבעית\" — אנציקלופדיה של 37 כרכים שמכסה אסטרונומיה, מינרלוגיה, בוטניקה, זואולוגיה ואמנות. היא הספר המדעי הראשון בכל מובן. פליניוס מת בהתפרצות הר וזוב מתוך סקרנות מדעית.",
    "rank": 186
  },
  {
    "id": "gr_tacitus",
    "deck": "greco",
    "title": "טאקיטוס כותב את ההיסטוריות",
    "start": 98,
    "end": 116,
    "date": "⁦98–116⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "טאקיטוס, גדול ההיסטוריונים הרומיים, כתב על ימי הקיסרות בסגנון חריף ואירוני. ב\"גרמניה\" תיאר את השבטים הגרמניים, ופוליטיקאים גרמניים ניכסו את הטקסט מאות שנים. הסגנון הקצר והאפל שלו הפך למודל ספרותי.",
    "rank": 187
  },
  {
    "id": "gr_pompeii_graffiti",
    "deck": "greco",
    "title": "גרפיטי בפומפיי",
    "start": -80,
    "end": 79,
    "date": "עד 79 לספירה",
    "place": "פומפיי, איטליה",
    "lat": 40.751,
    "lon": 14.487,
    "desc": "קירות פומפיי נשתמרו עם אלפי כתובות גרפיטי: הצהרות אהבה, בדיחות גסות, תעמולת בחירות ומודעות גלדיאטורים. הם מספקים חלון נדיר לחיי היומיום, השפה הדיבורית וההומור של אנשים רגילים ברומא.",
    "rank": 188
  },
  {
    "id": "gr_roman_currency",
    "deck": "greco",
    "title": "הדנריוס — המטבע הרומי",
    "start": -211,
    "end": 270,
    "date": "211 לפנה״ס עד המאה ה-3 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הדנריוס, מטבע כסף, היה בסיס הכלכלה הרומית למעלה מ-400 שנה. הפחתת תכולת הכסף במטבעות (\"פיחות\") בידי קיסרים חלשים גרמה לאינפלציה ולמשבר כלכלי. המילה \"דינר\" בערבית מקורה בדנריוס.",
    "rank": 189
  },
  {
    "id": "gr_roman_concrete",
    "deck": "greco",
    "title": "בטון רומי — סוד ההנדסה העתיקה",
    "start": -200,
    "end": 200,
    "date": "המאות ⁦2 לפנה״ס – 2 לספירה⁩",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הבטון הרומי (opus caementicium) שילב סיד, אפר געשי ומים ליצירת חומר בנייה חזק ועמיד שאפשר כיפות, קשתות ונמלים. הוא חזק יותר מבטון מודרני כי מתחזק עם הזמן. המתכון אבד ו\"גולה מחדש\" רק בעת החדשה.",
    "rank": 190
  },
  {
    "id": "gr_saturnalia",
    "deck": "greco",
    "title": "חג הסטורנליה",
    "start": -217,
    "end": 400,
    "date": "מהמאה ה-3 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "הסטורנליה, חג החורף הרומי לכבוד האל סטורנוס, כלל משתאות, חילופי מתנות והיפוך ההיררכיה — אדונים שירתו עבדים. מנהגים רבים של חג המולד (מתנות, נרות, עצים מקושטים) מקורם בסטורנליה.",
    "rank": 191
  },
  {
    "id": "gr_eleusinian",
    "deck": "greco",
    "title": "המיסתורין האלאוסיניים",
    "start": -1500,
    "end": 392,
    "date": "מהמאה ה-15 לפנה״ס עד 392 לספירה",
    "place": "אלאוסיס, יוון",
    "lat": 38.04,
    "lon": 23.54,
    "desc": "טקסי החניכה באלאוסיס לכבוד דמטר ופרספונה היו הטקסים הסודיים החשובים ביותר ביוון ורומא. משתתפים כללו שליטים ופילוסופים. תוכן הטקסים נשמר בסוד כל כך טוב שעד היום אין ידוע מה בדיוק קרה בהם.",
    "rank": 192
  },
  {
    "id": "gr_greek_vases",
    "deck": "greco",
    "title": "ציורי כדים יווניים",
    "start": -600,
    "end": -300,
    "date": "המאות ⁦6–4⁩ לפנה״ס",
    "place": "אתונה וקורינתוס, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "ציורי הכדים היוונים — בטכניקת הדמויות השחורות ואחר כך האדומות — הם המקור העיקרי לידע על החיים, המיתולוגיה והספורט ביוון. אלפי כדים שרדו ומוצגים במוזיאונים. הצייר אקסקיאס ואופרוניוס הם מהמפורסמים ביותר.",
    "rank": 193
  },
  {
    "id": "gr_roman_slavery",
    "deck": "greco",
    "title": "העבדות ברומא",
    "start": -200,
    "end": 400,
    "date": "המאות ⁦2 לפנה״ס – 4 לספירה⁩",
    "place": "האימפריה הרומית",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "בשיא האימפריה, כ-25%–35% מאוכלוסיית איטליה היו עבדים. עבדים עבדו במכרות, בחקלאות, בבתים, כמורים וכרופאים. שחרור עבדים (מנומיסיו) היה נפוץ, ומשוחררים יכלו להגיע לעושר גדול.",
    "rank": 194
  },
  {
    "id": "gr_ostia",
    "deck": "greco",
    "title": "נמל אוסטיה — שער רומא לעולם",
    "start": -200,
    "end": 300,
    "date": "המאות ⁦2 לפנה״ס – 3 לספירה⁩",
    "place": "אוסטיה, איטליה",
    "lat": 41.756,
    "lon": 12.286,
    "desc": "אוסטיה, נמל רומא בשפך הטיבר, הייתה השער שדרכו הגיעו תבואה ממצרים, שמן מספרד ומשי מסין. המחסנים (הוריאה) האדירים מעידים על היקף הסחר. חפירותיה חושפות עיר רומית מתפקדת עם אינסולות (בנייני דירות), פונדקים ומוזאיקות.",
    "rank": 195
  },
  {
    "id": "gr_miletus_school",
    "deck": "greco",
    "title": "אסכולת מילטוס",
    "start": -600,
    "end": -500,
    "date": "המאה ה-6 לפנה״ס",
    "place": "מילטוס, אנטוליה",
    "lat": 37.53,
    "lon": 27.28,
    "desc": "תאלס, אנקסימנדרוס ואנקסימנס — שלושת הפילוסופים הראשונים — חיפשו את חומר היסוד של המציאות במילטוס. אנקסימנדרוס הציע מפה ראשונה של העולם וטען שהאדם התפתח מיצורי ים. אסכולת מילטוס סימנה את תחילת המחשבה המדעית.",
    "rank": 196
  },
  {
    "id": "gr_livy",
    "deck": "greco",
    "title": "ליוויוס כותב את תולדות רומא",
    "start": -27,
    "end": 14,
    "date": "27 לפנה״ס עד 14 לספירה",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "טיטוס ליוויוס כתב \"מייסוד העיר\" — היסטוריה מקיפה של רומא ב-142 כרכים מרומולוס ועד ימיו. רק 35 שרדו. סגנונו הנשגב עיצב את הדימוי של רומא הרפובליקנית כעידן זהב של מעלות אזרחיות.",
    "rank": 197
  },
  {
    "id": "gr_greek_music",
    "deck": "greco",
    "title": "המוזיקה ביוון העתיקה",
    "start": -500,
    "end": -300,
    "date": "המאות ⁦5–4⁩ לפנה״ס",
    "place": "יוון",
    "lat": 37.97,
    "lon": 23.72,
    "desc": "המוזיקה היוונית הייתה חלק בלתי נפרד מהדרמה, הפולחן והחינוך. כלי נגינה מרכזיים היו הלירה, הקיתרה והאולוס (חליל כפול). פיתגורס גילה את היחסים המתמטיים בין צלילים — הבסיס לתורת המוזיקה המערבית.",
    "rank": 198
  },
  {
    "id": "gr_roman_triumph",
    "deck": "greco",
    "title": "מצעד הניצחון הרומי (טריאומפוס)",
    "start": -500,
    "end": 400,
    "date": "מהמאה ה-5 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.893,
    "lon": 12.485,
    "desc": "מצעד חגיגי שבו מפקד מנצח נכנס לרומא במרכבה זהובה, כשמאחוריו שבויים, שלל ולגיונותיו. עבד לחש באוזנו: \"זכור שאתה בן תמותה\". זכות הטריאומפוס הייתה הכבוד הצבאי הגבוה ביותר ברומא.",
    "rank": 199
  },
  {
    "id": "gr_roman_citizenship",
    "deck": "greco",
    "title": "האזרחות הרומית",
    "start": -300,
    "end": 212,
    "date": "מהמאה ה-3 לפנה״ס עד 212 לספירה",
    "place": "האימפריה הרומית",
    "lat": 41.9,
    "lon": 12.5,
    "desc": "האזרחות הרומית העניקה זכויות משפטיות (הגנה מענישה שרירותית, זכות ערעור, חופש מעבר), חובת שירות צבאי וזכות הצבעה. פאולוס השליח ניצל את אזרחותו כדי לערער על מעצרו. צו קרקלה ב-212 הרחיב אותה לכל בני חורין.",
    "rank": 200
  },
  {
    "id": "mu_beethoven_9th",
    "deck": "music",
    "title": "הבכורה של הסימפוניה התשיעית של בטהובן",
    "start": 1824,
    "end": 1824,
    "date": "1824",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "לודוויג ואן בטהובן הנחית את הבכורה של הסימפוניה התשיעית שלו בתיאטרון קרנטנרטור בוינה, כשהוא כבר חירש לחלוטין. הפרק הרביעי, ״אודה לשמחה״ על מילותיו של שילר, הפך ליצירת המופת הנודעת ביותר של המוזיקה הקלאסית ולהמנון האיחוד האירופי.",
    "rank": 1
  },
  {
    "id": "mu_beatles_please",
    "deck": "music",
    "title": "אלבום הבכורה של הביטלס",
    "start": 1963,
    "end": 1963,
    "date": "1963",
    "place": "לונדון, אנגליה",
    "lat": 51.532,
    "lon": -0.177,
    "desc": "הביטלס הקליטו את אלבום הבכורה שלהם ״Please Please Me״ באולפני אבי רואד בלונדון ביום אחד. הלהקה מליברפול — ג׳ון לנון, פול מקרטני, ג׳ורג׳ האריסון ורינגו סטאר — הפכה תוך חודשים לתופעה עולמית שעיצבה מחדש את המוזיקה הפופולרית.",
    "rank": 2
  },
  {
    "id": "mu_mozart_born",
    "deck": "music",
    "title": "לידתו של מוצרט",
    "start": 1756,
    "end": 1756,
    "date": "1756",
    "place": "זלצבורג, אוסטריה",
    "lat": 47.8,
    "lon": 13.044,
    "desc": "וולפגנג אמדאוס מוצרט נולד בזלצבורג. ילד פלא שהחל להלחין בגיל חמש, מוצרט כתב מעל 600 יצירות בחייו הקצרים — סימפוניות, אופרות, קונצ׳רטים ומוזיקת קאמרית — ונחשב לאחד המלחינים הגדולים בכל הזמנים.",
    "rank": 3
  },
  {
    "id": "mu_elvis_heartbreak",
    "deck": "music",
    "title": "אלביס פרסלי מקליט את ״מלון הלב השבור״",
    "start": 1956,
    "end": 1956,
    "date": "1956",
    "place": "נשוויל, טנסי, ארצות הברית",
    "lat": 36.162,
    "lon": -86.781,
    "desc": "אלביס פרסלי הקליט את ״Heartbreak Hotel״, שהפך ללהיט מספר אחד ברשימות ארצות הברית והכניס את הרוקנרול למיינסטרים. בתוך שנה הפך אלביס לסמל תרבותי שהסעיר את הנוער ונחשב עד היום ל״מלך הרוקנרול״.",
    "rank": 4
  },
  {
    "id": "mu_bach_welltempered",
    "deck": "music",
    "title": "באך מלחין את ״הקלווייר השווה״",
    "start": 1722,
    "end": 1722,
    "date": "1722",
    "place": "קטן, גרמניה",
    "lat": 51.754,
    "lon": 12.438,
    "desc": "יוהאן סבסטיאן באך חיבר את הכרך הראשון של ״הקלווייר המתואם היטב״, מחזור של פרלודים ופוגות בכל 24 הסולמות. היצירה הוכיחה את הכדאיות של כוונון שווה ונחשבת לאחד מיסודות המוזיקה המערבית.",
    "rank": 5
  },
  {
    "id": "mu_michael_thriller",
    "deck": "music",
    "title": "מייקל ג׳קסון מוציא את ״תרילר״",
    "start": 1982,
    "end": 1982,
    "date": "1982",
    "place": "לוס אנג׳לס, קליפורניה, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "מייקל ג׳קסון הוציא את ״Thriller״, שהפך לאלבום הנמכר ביותר בהיסטוריה עם למעלה מ־66 מיליון עותקים. הקליפ ליצירת הכותרת חולל מהפכה בעידן הווידאו־קליפ, ו״מלך הפופ״ הפך לאמן המשפיע ביותר בעשורים האחרונים של המאה ה־20.",
    "rank": 6
  },
  {
    "id": "mu_woodstock",
    "deck": "music",
    "title": "פסטיבל וודסטוק",
    "start": 1969,
    "end": 1969,
    "date": "1969",
    "place": "בת׳ל, ניו יורק, ארצות הברית",
    "lat": 41.703,
    "lon": -74.878,
    "desc": "כ־400,000 אנשים הגיעו לפסטיבל מוזיקה בן שלושה ימים בכפר בת׳ל שבמדינת ניו יורק. ג׳ימי הנדריקס, ג׳ניס ג׳ופלין, ג׳ו קוקר ועוד עלו לבמה. וודסטוק הפך לסמל של תרבות הנגד ושל דור הפרחים.",
    "rank": 7
  },
  {
    "id": "mu_vivaldi_seasons",
    "deck": "music",
    "title": "ויוואלדי מלחין את ״ארבע העונות״",
    "start": 1723,
    "end": 1723,
    "date": "1723",
    "place": "ונציה, איטליה",
    "lat": 45.434,
    "lon": 12.339,
    "desc": "אנטוניו ויוואלדי פרסם את ״ארבע העונות״, סדרת ארבעה קונצ׳רטים לכינור שמתארים בצלילים את מחזור השנה. היצירה נחשבת לאחת היצירות הנודעות ביותר במוזיקה הקלאסית ומבוצעת ברחבי העולם עד היום.",
    "rank": 8
  },
  {
    "id": "mu_bob_marley_exodus",
    "deck": "music",
    "title": "בוב מארלי מוציא את ״אקסודוס״",
    "start": 1977,
    "end": 1977,
    "date": "1977",
    "place": "לונדון, אנגליה",
    "lat": 51.534,
    "lon": -0.034,
    "desc": "בוב מארלי הוציא את אלבומו ״Exodus״ תוך גלות מג׳מייקה, לאחר ניסיון התנקשות בחייו. האלבום, שכולל את ״Jamming״ ו־״One Love״, הפך את מוזיקת הרגאיי לתופעה עולמית ואת מארלי לסמל של שלום, מרד ותרבות קריבית.",
    "rank": 9
  },
  {
    "id": "mu_stravinsky_rite",
    "deck": "music",
    "title": "הבכורה של ״פולחן האביב״ של סטרווינסקי",
    "start": 1913,
    "end": 1913,
    "date": "1913",
    "place": "פריז, צרפת",
    "lat": 48.862,
    "lon": 2.33,
    "desc": "הבכורה של הבלט ״פולחן האביב״ מאת איגור סטרווינסקי בתיאטרון השאנז אליזה בפריז עוררה מהומה בקהל. המקצבים הפרימיטיביים וההרמוניות הדיסוננטיות שברו את מוסכמות המוזיקה הקלאסית ופתחו את הדרך למודרניזם.",
    "rank": 10
  },
  {
    "id": "mu_miles_blue",
    "deck": "music",
    "title": "מיילס דייוויס מוציא את ״Kind of Blue״",
    "start": 1959,
    "end": 1959,
    "date": "1959",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "מיילס דייוויס הקליט עם ג׳ון קולטריין, ביל אוונס וקנונבול אדרלי את ״Kind of Blue״, אלבום הג׳אז הנמכר ביותר בהיסטוריה. האלבום הציג את שיטת האלתור המודאלי וקבע סטנדרט חדש לג׳אז.",
    "rank": 11
  },
  {
    "id": "mu_chopin_paris",
    "deck": "music",
    "title": "שופן מגיע לפריז",
    "start": 1831,
    "end": 1831,
    "date": "1831",
    "place": "פריז, צרפת",
    "lat": 48.87,
    "lon": 2.332,
    "desc": "פרדריק שופן עזב את פולין ועבר לפריז, שם הפך למלחין הפסנתר המשפיע ביותר של המאה ה־19. הנוקטורנים, המזורקות, הוואלסים והבלדות שלו מיזגו אלגנטיות סלונית עם געגועים לפולין ושינו את אמנות הנגינה בפסנתר.",
    "rank": 12
  },
  {
    "id": "mu_queen_bohemian",
    "deck": "music",
    "title": "קווין מוציאים את ״רפסודיה בוהמית״",
    "start": 1975,
    "end": 1975,
    "date": "1975",
    "place": "לונדון, אנגליה",
    "lat": 51.534,
    "lon": -0.013,
    "desc": "להקת קווין הוציאה את ״Bohemian Rhapsody״, שיר בן שש דקות שמשלב רוק, בלדה ואופרה. פרדי מרקורי כתב את היצירה החריגה, שהפכה לאחד השירים הנודעים ביותר בהיסטוריה ושברה את כל מוסכמות הפורמט הרדיו.",
    "rank": 13
  },
  {
    "id": "mu_handel_messiah",
    "deck": "music",
    "title": "הנדל מלחין את ה״משיח״",
    "start": 1741,
    "end": 1741,
    "date": "1741",
    "place": "לונדון, אנגליה",
    "lat": 51.514,
    "lon": -0.116,
    "desc": "גאורג פרידריך הנדל חיבר את האורטוריה ״המשיח״ בתוך 24 ימים בלבד. הבכורה הפומבית נערכה בדבלין, אירלנד, ב־1742. מקהלת ״הללויה״ הפכה ליצירה המוכרת ביותר במוזיקת הכורלית.",
    "rank": 14
  },
  {
    "id": "mu_wagner_ring",
    "deck": "music",
    "title": "ואגנר משלים את ״טבעת הניבלונג״",
    "start": 1876,
    "end": 1876,
    "date": "1876",
    "place": "ביירות, גרמניה",
    "lat": 49.946,
    "lon": 11.578,
    "desc": "ריכרד ואגנר הציג לראשונה את מחזור האופרות ״טבעת הניבלונג״ במלואו בבית האופרה שבנה לעצמו בביירות. ארבע האופרות, שהלחנתן נמשכה 26 שנה, שינו את פני האופרה בעיבוד התזמורתי, בלייטמוטיבים ובחזון אמנותי כולל.",
    "rank": 15
  },
  {
    "id": "mu_bob_dylan_electric",
    "deck": "music",
    "title": "בוב דילן עובר לחשמלי בפסטיבל ניוּפּורט",
    "start": 1965,
    "end": 1965,
    "date": "1965",
    "place": "ניוּפּורט, רוד איילנד, ארצות הברית",
    "lat": 41.49,
    "lon": -71.313,
    "desc": "בוב דילן עלה לבמה בפסטיבל הפולק של ניוּפּורט עם גיטרה חשמלית ולהקת רוק, והמהלך עורר זעם בקרב אוהדי הפולק. המעבר סימן את הולדת הפולק-רוק ושחרר את דילן ממוסכמות הז׳אנר. שנה מאוחר יותר הוציא את האלבום הכפול ״Blonde on Blonde״.",
    "rank": 16
  },
  {
    "id": "mu_nirvana_nevermind",
    "deck": "music",
    "title": "נירוונה מוציאים את ״Nevermind״",
    "start": 1991,
    "end": 1991,
    "date": "1991",
    "place": "לוס אנג׳לס, קליפורניה, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "להקת נירוונה מסיאטל הוציאה את ״Nevermind״ ובו הסינגל ״Smells Like Teen Spirit״, שהעלה את הגראנג׳ מאנדרגראונד למגרש הראשי. קורט קוביין הפך לקול של דור ה־X, ואלבום אלטרנטיבי הדיח את מייקל ג׳קסון מראש המצעדים.",
    "rank": 17
  },
  {
    "id": "mu_pink_floyd_wall",
    "deck": "music",
    "title": "פינק פלויד מוציאים את ״The Wall״",
    "start": 1979,
    "end": 1979,
    "date": "1979",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.165,
    "desc": "להקת פינק פלויד הוציאה את אלבום הקונספט ״The Wall״, סיפור אוטוביוגרפי על ניכור ומשוכות רגשיות. ״Another Brick in the Wall״ הפך ללהיט עולמי, והאלבום הפך לאופרת רוק ולסרט.",
    "rank": 18
  },
  {
    "id": "mu_verdi_aida",
    "deck": "music",
    "title": "הבכורה של ״אאידה״ של ורדי",
    "start": 1871,
    "end": 1871,
    "date": "1871",
    "place": "קהיר, מצרים",
    "lat": 30.045,
    "lon": 31.256,
    "desc": "ג׳וזפה ורדי חיבר את האופרה ״אאידה״ לכבוד פתיחת בית האופרה החדש בקהיר, סמוך לפתיחת תעלת סואץ. האופרה על אהבה טראגית בין נסיכה אתיופית למפקד מצרי הפכה לאחת האופרות המבוצעות ביותר בעולם.",
    "rank": 19
  },
  {
    "id": "mu_armstrong_west_end",
    "deck": "music",
    "title": "לואי ארמסטרונג מקליט את ״West End Blues״",
    "start": 1928,
    "end": 1928,
    "date": "1928",
    "place": "שיקגו, אילינוי, ארצות הברית",
    "lat": 41.881,
    "lon": -87.623,
    "desc": "לואי ארמסטרונג הקליט את ״West End Blues״ עם ה־Hot Five שלו בשיקגו. הקדנצה הפותחת בחצוצרה נחשבת לרגע מכונן בהיסטוריית הג׳אז, שהפך את הסולן לדמות מרכזית במקום צליל אחד בתזמורת.",
    "rank": 20
  },
  {
    "id": "mu_monteverdi_orfeo",
    "deck": "music",
    "title": "הבכורה של ״אורפיאו״ של מונטוורדי",
    "start": 1607,
    "end": 1607,
    "date": "1607",
    "place": "מנטובה, איטליה",
    "lat": 45.159,
    "lon": 10.791,
    "desc": "קלאודיו מונטוורדי הציג את האופרה ״אורפיאו״ בחצר הדוכסות של מנטובה. היצירה נחשבת לאופרה הראשונה המשמעותית ופתחה את עידן הבארוק. מונטוורדי מיזג שירה, ריקוד ותזמור באופן שיצר ז׳אנר חדש.",
    "rank": 21
  },
  {
    "id": "mu_led_zep_iv",
    "deck": "music",
    "title": "לד זפלין מוציאים את האלבום הרביעי",
    "start": 1971,
    "end": 1971,
    "date": "1971",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "להקת לד זפלין הוציאה את אלבומה הרביעי, ובו ״Stairway to Heaven״ — אחד השירים המושמעים ביותר ברדיו. האלבום מיזג בלוז, פולק ומטאל כבד, והגדיר את צליל ההארד רוק של שנות ה־70.",
    "rank": 22
  },
  {
    "id": "mu_tchaikovsky_nutcracker",
    "deck": "music",
    "title": "הבכורה של ״מפצח האגוזים״ של צ׳ייקובסקי",
    "start": 1892,
    "end": 1892,
    "date": "1892",
    "place": "סנקט פטרבורג, רוסיה",
    "lat": 59.934,
    "lon": 30.328,
    "desc": "הבלט ״מפצח האגוזים״ של פיוטר צ׳ייקובסקי בוצע לראשונה בתיאטרון מריינסקי בסנקט פטרבורג. למרות קבלת פנים צוננת, הפך הבלט למופע חג המולד הפופולרי ביותר בעולם, והמוזיקה שלו — לנודעת ביותר מבין כל יצירותיו.",
    "rank": 23
  },
  {
    "id": "mu_aretha_respect",
    "deck": "music",
    "title": "אריתה פרנקלין מקליטה את ״Respect״",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "אריתה פרנקלין הקליטה גרסה חדשה ל־״Respect״ של אוטיס רדינג, שהפכה להמנון פמיניסטי ולשיר ההגדרה של מוזיקת הסואול. ״מלכת הסואול״ חתכה את השיר מחדש עם מקצב חזק ותגובות מקהלה שהפכו לאיקוניים.",
    "rank": 24
  },
  {
    "id": "mu_opera_birth",
    "deck": "music",
    "title": "לידת האופרה בפירנצה",
    "start": 1597,
    "end": 1600,
    "date": "בערך ⁦1597–1600⁩",
    "place": "פירנצה, איטליה",
    "lat": 43.771,
    "lon": 11.254,
    "desc": "חבורת ה״קמראטה פיורנטינה״ — מלחינים, משוררים ואינטלקטואלים — יצרה את צורת הביטוי החדשה של האופרה, בהשראת הדרמה היוונית העתיקה. ״דפנה״ של יאקופו פרי נחשבת לאופרה הראשונה, ו״אאורידיצ׳ה״ היא הראשונה שנותרה בשלמותה.",
    "rank": 25
  },
  {
    "id": "mu_hendrix_monterey",
    "deck": "music",
    "title": "ג׳ימי הנדריקס בפסטיבל מונטריי",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "מונטריי, קליפורניה, ארצות הברית",
    "lat": 36.6,
    "lon": -121.894,
    "desc": "ג׳ימי הנדריקס עלה לבמה בפסטיבל מונטריי פופ והציג ביצוע מטלטל שבסופו הצית את גיטרתו. ההופעה הציגה לאמריקה את הגיטריסט הגדול ביותר ברוק, ושינתה את מה שאפשר לעשות עם גיטרה חשמלית.",
    "rank": 26
  },
  {
    "id": "mu_reggae_jamaica",
    "deck": "music",
    "title": "הולדת הרגאיי בג׳מייקה",
    "start": 1968,
    "end": 1968,
    "date": "בערך 1968",
    "place": "קינגסטון, ג׳מייקה",
    "lat": 18,
    "lon": -76.8,
    "desc": "סגנון הרגאיי התפתח מהסקה והרוקסטדי בקינגסטון, ג׳מייקה. הקצב המיוחד בזמן שלישי, השפעות ראסטפאריות והמסרים החברתיים הפכו את הרגאיי לקול של מאבק, אמונה וזהות קריבית שהתפשט לכל העולם.",
    "rank": 27
  },
  {
    "id": "mu_haydn_farewell",
    "deck": "music",
    "title": "סימפונית ״הפרידה״ של היידן",
    "start": 1772,
    "end": 1772,
    "date": "1772",
    "place": "אייזנשטאט, אוסטריה",
    "lat": 47.845,
    "lon": 16.519,
    "desc": "יוזף היידן, ״אבי הסימפוניה״, הלחין את סימפוניה מס׳ 45 (״הפרידה״) כדי לרמוז לנסיך אסטרהאזי שהמוזיקאים כבר מתגעגעים הביתה. בפרק האחרון, המנגנים כיבו את הנרות שלהם אחד אחד ועזבו את הבמה.",
    "rank": 28
  },
  {
    "id": "mu_rolling_stones_satisfaction",
    "deck": "music",
    "title": "הרולינג סטונס מקליטים את ״Satisfaction״",
    "start": 1965,
    "end": 1965,
    "date": "1965",
    "place": "הוליווד, קליפורניה, ארצות הברית",
    "lat": 34.098,
    "lon": -118.327,
    "desc": "הרולינג סטונס הקליטו את ״(I Can't Get No) Satisfaction״ באולפני RCA בהוליווד. ריף הגיטרה של קית׳ ריצ׳רדס, שלטענתו חלם עליו בשנתו, הפך לאחד הנודעים ביותר ברוק ובישר את פני הלהקה כ״הבנים הרעים של הרוק״.",
    "rank": 29
  },
  {
    "id": "mu_coltrane_love_supreme",
    "deck": "music",
    "title": "ג׳ון קולטריין מוציא את ״A Love Supreme״",
    "start": 1965,
    "end": 1965,
    "date": "1965",
    "place": "אנגלווד קליפס, ניו ג׳רזי, ארצות הברית",
    "lat": 40.884,
    "lon": -73.952,
    "desc": "הסקסופוניסט ג׳ון קולטריין הקליט את סוויטת ״A Love Supreme״, מדיטציה רוחנית בארבעה פרקים שמשלבת ג׳אז חופשי עם עוצמה מיסטית. האלבום נחשב לפסגת הג׳אז ולאחת מיצירות המופת הגדולות של המאה ה־20.",
    "rank": 30
  },
  {
    "id": "mu_punk_sex_pistols",
    "deck": "music",
    "title": "סקס פיסטולס מוציאים את ״Never Mind the Bollocks״",
    "start": 1977,
    "end": 1977,
    "date": "1977",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "סקס פיסטולס הוציאו את אלבומם היחיד, שהגדיר את הפאנק הבריטי. ג׳וני רוטן ולהקתו הטילו פצצה בעולם הרוק עם אנרגיה גולמית, פרובוקציה ודחייה של כל מה שרוק הפרוגרסיב ייצג. האלבום השפיע על דורות של מוזיקאים.",
    "rank": 31
  },
  {
    "id": "mu_debussy_prelude",
    "deck": "music",
    "title": "דביוסי מלחין את ״אחר צהריים של פאון״",
    "start": 1894,
    "end": 1894,
    "date": "1894",
    "place": "פריז, צרפת",
    "lat": 48.862,
    "lon": 2.33,
    "desc": "קלוד דביוסי הלחין את ״פרלוד לאחר צהריים של פאון״, יצירת תזמורת המבוססת על שירו של מלארמה. היצירה, עם הצלילים הערפיליים וההרמוניות הצפות, פתחה את הדרך לאימפרסיוניזם מוזיקלי ופרצה מהמסגרת הרומנטית.",
    "rank": 32
  },
  {
    "id": "mu_motown_founded",
    "deck": "music",
    "title": "הקמת חברת מוטאון",
    "start": 1959,
    "end": 1959,
    "date": "1959",
    "place": "דטרויט, מישיגן, ארצות הברית",
    "lat": 42.364,
    "lon": -83.088,
    "desc": "ברי גורדי ג׳וניור ייסד את חברת התקליטים מוטאון בדטרויט. הליבל הפך למפעל להיטים ששבר מחסומים גזעיים, עם אמנים כמו סטיבי וונדר, דיאנה רוס, מרווין גיי והטמפטיישנס, ויצר את ה״צליל של אמריקה הצעירה״.",
    "rank": 33
  },
  {
    "id": "mu_schoenberg_twelve_tone",
    "deck": "music",
    "title": "שנברג מפתח את שיטת שנים־עשר הצלילים",
    "start": 1923,
    "end": 1923,
    "date": "1923",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "ארנולד שנברג חיבר את ״סוויטה לפסנתר, אופוס 25״, היצירה הראשונה שנכתבה בשלמותה בשיטת שנים־עשר הצלילים שפיתח. הסריאליזם הפך לטכניקת ההלחנה הדומיננטית במוזיקה האוואנגרדית של המאה ה־20.",
    "rank": 34
  },
  {
    "id": "mu_gregorian_chant",
    "deck": "music",
    "title": "התפשטות השירה הגרגוריאנית",
    "start": 750,
    "end": 850,
    "date": "בערך ⁦750–850⁩ לספירה",
    "place": "אאכן, גרמניה",
    "lat": 50.775,
    "lon": 6.084,
    "desc": "בתקופת שלטון קרל הגדול הופצה מסורת שירת המזמורים הגרגוריאנית, ששמה נקראה על שם האפיפיור גרגוריוס הגדול, לכל מנזרי אירופה. שירה חד-קולית זו היא הבסיס לכל המוזיקה המערבית המתועדת, וממנה צמח התווי.",
    "rank": 35
  },
  {
    "id": "mu_prince_purple_rain",
    "deck": "music",
    "title": "פרינס מוציא את ״Purple Rain״",
    "start": 1984,
    "end": 1984,
    "date": "1984",
    "place": "מיניאפוליס, מינסוטה, ארצות הברית",
    "lat": 44.978,
    "lon": -93.264,
    "desc": "פרינס הוציא את האלבום ופס הקול ״Purple Rain״ לצד הסרט באותו שם. המיזוג של רוק, פאנק, פופ ו-R&B הפך אותו לאחד האמנים המקוריים ביותר בהיסטוריית המוזיקה. האלבום מכר יותר מ-25 מיליון עותקים.",
    "rank": 36
  },
  {
    "id": "mu_hip_hop_birth",
    "deck": "music",
    "title": "לידת ההיפ-הופ בברונקס",
    "start": 1973,
    "end": 1973,
    "date": "1973",
    "place": "ברונקס, ניו יורק, ארצות הברית",
    "lat": 40.846,
    "lon": -73.878,
    "desc": "די ג׳יי קול הרק ערך מסיבה ברחוב סדגוויק 1520 בברונקס, שם המציא את טכניקת ה-breakbeat — הארכת קטע המתופים בשיר לריקוד. הערב נחשב ליום ההולדת של תרבות ההיפ-הופ, שתצמח ממסיבות שכונה לתנועה עולמית.",
    "rank": 37
  },
  {
    "id": "mu_billie_holiday_fruit",
    "deck": "music",
    "title": "בילי הולידיי מבצעת את ״Strange Fruit״",
    "start": 1939,
    "end": 1939,
    "date": "1939",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.726,
    "lon": -74,
    "desc": "בילי הולידיי ביצעה לראשונה את ״Strange Fruit״ במועדון קפה סוסייטי בגריניץ׳ וילג׳. השיר, שמתאר לינץ׳ בגזענות מטאפורית של פירות תלויים על עצים, נחשב לשיר המחאה הראשון של המאה ה-20 ולאחד השירים החשובים ביותר בהיסטוריה.",
    "rank": 38
  },
  {
    "id": "mu_david_bowie_ziggy",
    "deck": "music",
    "title": "דיוויד בואי מציג את זיגי סטארדאסט",
    "start": 1972,
    "end": 1972,
    "date": "1972",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "דיוויד בואי הוציא את ״The Rise and Fall of Ziggy Stardust and the Spiders from Mars״, אלבום קונספט על כוכב רוק חייזרי. בואי אימץ את הפרסונה של זיגי על הבמה, ובכך פתח את עידן הגלאם רוק וטשטש את גבולות הזהות והמגדר.",
    "rank": 39
  },
  {
    "id": "mu_liszt_weimar",
    "deck": "music",
    "title": "ליסט מתמנה למנצח בוויימאר",
    "start": 1848,
    "end": 1848,
    "date": "1848",
    "place": "וויימאר, גרמניה",
    "lat": 50.979,
    "lon": 11.33,
    "desc": "פרנץ ליסט, הפסנתרן הוירטואוזי שהמציא את קונצרט הרסיטל, התמנה למנצח חצר בוויימאר. שם המציא את הפואמה הסימפונית, תרם להתפתחות ה״מוזיקה של העתיד״ והפך מנגן-על לדמות מרכזית בתרבות האירופית.",
    "rank": 40
  },
  {
    "id": "mu_kraftwerk_autobahn",
    "deck": "music",
    "title": "קראפטוורק מוציאים את ״Autobahn״",
    "start": 1974,
    "end": 1974,
    "date": "1974",
    "place": "דיסלדורף, גרמניה",
    "lat": 51.228,
    "lon": 6.773,
    "desc": "להקת קראפטוורק מדיסלדורף הוציאה את אלבום ״Autobahn״, יצירה אלקטרונית בת 23 דקות שמדמה נסיעה בכביש מהיר. הלהקה, שהחליפה כלי נגינה מסורתיים בסינתיסייזרים ומכונות תופים, הניחה את היסודות לכל המוזיקה האלקטרונית.",
    "rank": 41
  },
  {
    "id": "mu_naomi_shemer_gold",
    "deck": "music",
    "title": "נעמי שמר מבצעת לראשונה את ״ירושלים של זהב״",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "ירושלים, ישראל",
    "lat": 31.781,
    "lon": 35.229,
    "desc": "שולי נתן שרה לראשונה את ״ירושלים של זהב״ מאת נעמי שמר בפסטיבל השיר הישראלי, שלושה שבועות לפני מלחמת ששת הימים. לאחר שחרור העיר העתיקה, הוסיפה שמר בית שלישי, והשיר הפך להמנון הלא רשמי של ישראל.",
    "rank": 42
  },
  {
    "id": "mu_radiohead_ok",
    "deck": "music",
    "title": "רדיוהד מוציאים את ״OK Computer״",
    "start": 1997,
    "end": 1997,
    "date": "1997",
    "place": "באת, אנגליה",
    "lat": 51.381,
    "lon": -2.36,
    "desc": "רדיוהד הוציאו את ״OK Computer״, אלבום שהציב את החרדה מפני הטכנולוגיה והניכור המודרני במרכז. ביקורות תהילה הכתירו אותו לאחד מאלבומי הרוק הגדולים ביותר, ובמיוחד ״Paranoid Android״ הפך ליצירה מופתית של הרוק האלטרנטיבי.",
    "rank": 43
  },
  {
    "id": "mu_ellington_cotton_club",
    "deck": "music",
    "title": "דיוק אלינגטון מתחיל להופיע במועדון הכותנה",
    "start": 1927,
    "end": 1927,
    "date": "1927",
    "place": "הארלם, ניו יורק, ארצות הברית",
    "lat": 40.816,
    "lon": -73.949,
    "desc": "דיוק אלינגטון ותזמורתו החלו תקופת הופעות ארוכה במועדון הכותנה בהארלם, ששידר בשידור חי ברדיו לכל ארצות הברית. אלינגטון הפך למלחין הג׳אז הגדול ביותר, עם למעלה מאלף יצירות שכתב לאורך חייו.",
    "rank": 44
  },
  {
    "id": "mu_blues_delta",
    "deck": "music",
    "title": "הבלוז של דלתת המיסיסיפי",
    "start": 1903,
    "end": 1903,
    "date": "בערך 1903",
    "place": "קלארקסדייל, מיסיסיפי, ארצות הברית",
    "lat": 34.2,
    "lon": -90.571,
    "desc": "ו. ס. הנדי דיווח ששמע מוזיקאי מנגן גיטרה עם להב סכין בתחנת הרכבת של טוטוויילר. זו אחת העדויות הראשונות למה שייקרא ״בלוז הדלתא״ — המוזיקה שממנה צמח הבלוז, הג׳אז, הרוקנרול והסואול.",
    "rank": 45
  },
  {
    "id": "mu_stevie_wonder_innervisions",
    "deck": "music",
    "title": "סטיבי וונדר מוציא את ״Innervisions״",
    "start": 1973,
    "end": 1973,
    "date": "1973",
    "place": "לוס אנג׳לס, קליפורניה, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "סטיבי וונדר הוציא את ״Innervisions״, חלק מטרילוגיית אלבומים שמיזגה סואול, פאנק, ג׳אז ומסרים חברתיים. וונדר ניגן, שר, הלחין והפיק כמעט הכול בעצמו. האלבום זכה בגראמי לאלבום השנה וביסס את מעמדו כגאון מוזיקלי.",
    "rank": 46
  },
  {
    "id": "mu_palestrina_missa",
    "deck": "music",
    "title": "פלסטרינה מלחין את ״מיסה פאפא מרצ׳לי״",
    "start": 1567,
    "end": 1567,
    "date": "בערך 1567",
    "place": "רומא, איטליה",
    "lat": 41.899,
    "lon": 12.476,
    "desc": "ג׳ובאני פיירלואיג׳י דה פלסטרינה הלחין את ״מיסה פאפא מרצ׳לי״, מיסה שישה-קולית שנחשבת לשיא הפוליפוניה של הרנסנס. לפי המסורת, היצירה הצילה את הפוליפוניה מביטול על ידי מועצת טרנט, שדרשה שהטקסט יישמע בבירור.",
    "rank": 47
  },
  {
    "id": "mu_brahms_first",
    "deck": "music",
    "title": "הבכורה של הסימפוניה הראשונה של בראמס",
    "start": 1876,
    "end": 1876,
    "date": "1876",
    "place": "קרלסרוהה, גרמניה",
    "lat": 49.009,
    "lon": 8.404,
    "desc": "יוהנס בראמס הציג את סימפוניה מספר 1 בדו מינור, שלקח 21 שנה לכתוב, מתוך חרדה שעבודתו תימדד מול בטהובן. המבקר הנס פון בילוב כינה אותה ״הסימפוניה העשירית של בטהובן״ — מחמאה עצומה שאישרה את מקומו של בראמס.",
    "rank": 48
  },
  {
    "id": "mu_marvin_gaye_going_on",
    "deck": "music",
    "title": "מרווין גיי מוציא את ״What's Going On״",
    "start": 1971,
    "end": 1971,
    "date": "1971",
    "place": "דטרויט, מישיגן, ארצות הברית",
    "lat": 42.364,
    "lon": -83.088,
    "desc": "מרווין גיי הוציא את ״What's Going On״, אלבום קונספט שעסק במלחמת וייטנאם, עוני ומשבר הסביבה. האלבום שבר את המוסכמה של מוטאון כמפעל סינגלים והפך את מוזיקת הסואול לכלי מחאה אמנותי. הוא נחשב לאחד האלבומים הגדולים אי פעם.",
    "rank": 49
  },
  {
    "id": "mu_madonna_like_virgin",
    "deck": "music",
    "title": "מדונה מוציאה את ״Like a Virgin״",
    "start": 1984,
    "end": 1984,
    "date": "1984",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "מדונה הוציאה את אלבומה השני ״Like a Virgin״, שמכר מיליוני עותקים והפך אותה ל״מלכת הפופ״. הביצוע בטקס ה-MTV בשמלת כלה לבנה נחשב לאחד הרגעים האייקוניים ביותר בתרבות הפופ של שנות ה-80.",
    "rank": 50
  },
  {
    "id": "mu_notre_dame_school",
    "deck": "music",
    "title": "בית ספר נוטרדאם והפוליפוניה המוקדמת",
    "start": 1160,
    "end": 1250,
    "date": "בערך ⁦1160–1250⁩ לספירה",
    "place": "פריז, צרפת",
    "lat": 48.853,
    "lon": 2.349,
    "desc": "המלחינים לאונין ופרוטין שפעלו בקתדרלת נוטרדאם דה פריז פיתחו את האורגנום — פוליפוניה מוקדמת ששיכבה קולות זה על זה. עבודתם היא הצעד המכריע מהמונופוניה הגרגוריאנית לרב-קוליות, אבן הפינה של המוזיקה המערבית.",
    "rank": 51
  },
  {
    "id": "mu_james_brown_live",
    "deck": "music",
    "title": "ג׳יימס בראון מקליט את ״Live at the Apollo״",
    "start": 1962,
    "end": 1962,
    "date": "1962",
    "place": "הארלם, ניו יורק, ארצות הברית",
    "lat": 40.81,
    "lon": -73.95,
    "desc": "ג׳יימס בראון, ״אבי הפאנק״ ו״אבי הסואול״, הקליט הופעה חיה בתיאטרון אפולו בהארלם. האלבום תפס את האנרגיה הבלתי נתפסת של הופעותיו, עם צעקות, ריקודים וקצב חזק שהגדירו את הפאנק עוד לפני שהמונח נולד.",
    "rank": 52
  },
  {
    "id": "mu_bach_matthew",
    "deck": "music",
    "title": "הבכורה של ״הפסיון על פי מתי״ של באך",
    "start": 1727,
    "end": 1727,
    "date": "1727",
    "place": "לייפציג, גרמניה",
    "lat": 51.34,
    "lon": 12.375,
    "desc": "יוהאן סבסטיאן באך הציג את ״הפסיון על פי מתי״ בכנסיית תומאס בלייפציג. היצירה לסולנים, מקהלות ותזמורת כפולה מספרת את סיפור הצליבה ונחשבת לפסגת המוזיקה הכנסייתית של הבארוק.",
    "rank": 53
  },
  {
    "id": "mu_tupac_eyez",
    "deck": "music",
    "title": "טופאק שאקור מוציא את ״All Eyez on Me״",
    "start": 1996,
    "end": 1996,
    "date": "1996",
    "place": "לוס אנג׳לס, קליפורניה, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "טופאק שאקור הוציא את האלבום הכפול ״All Eyez on Me״, שמיזג שירה אישית ומחאה חברתית. חודשים לאחר מכן נרצח בירי בלאס וגאס, בשיא העימות בין החופים. הפך לאייקון של ההיפ-הופ ולסמל של דור שנקטף מוקדם מדי.",
    "rank": 54
  },
  {
    "id": "mu_fela_kuti_zombie",
    "deck": "music",
    "title": "פלא קוטי מוציא את ״Zombie״",
    "start": 1977,
    "end": 1977,
    "date": "1977",
    "place": "לאגוס, ניגריה",
    "lat": 6.524,
    "lon": 3.379,
    "desc": "המוזיקאי הניגרי פלא קוטי הוציא את ״Zombie״, שיר אפרוביט בן 12 דקות שלעג לצבא הניגרי כ״זומבים״ שמצייתים בעיוורון. האלבום עורר זעם כזה שאלף חיילים תקפו את ביתו. קוטי נחשב למייסד האפרוביט ולסמל התנגדות מוזיקלי באפריקה.",
    "rank": 55
  },
  {
    "id": "mu_arik_einstein_poozy",
    "deck": "music",
    "title": "אריק איינשטיין מוציא את ״פוזי״",
    "start": 1969,
    "end": 1969,
    "date": "1969",
    "place": "תל אביב, ישראל",
    "lat": 32.064,
    "lon": 34.778,
    "desc": "אריק איינשטיין הוציא את ״פוזי״ (פיוז), מהאלבומים הראשונים ברוק ישראלי, בשיתוף עם שלום חנוך. האלבום שילב רוק מערבי עם שירה בעברית ושינה את פני המוזיקה הישראלית, שעד אז נשלטה בידי שירי ארץ ישראל.",
    "rank": 56
  },
  {
    "id": "mu_ravi_shankar_concert",
    "deck": "music",
    "title": "ראווי שאנקר מופיע בקונצרט לבנגלדש",
    "start": 1971,
    "end": 1971,
    "date": "1971",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "הסיטריסט ההודי ראווי שאנקר וג׳ורג׳ האריסון ארגנו את ״קונצרט לבנגלדש״ במדיסון סקוור גארדן, אחד מאירועי הצדקה המוזיקליים הראשונים. שאנקר, שהכיר את המוזיקה ההודית לעולם המערבי, השפיע על הביטלס ועל דור שלם של מוזיקאים.",
    "rank": 57
  },
  {
    "id": "mu_beethoven_eroica",
    "deck": "music",
    "title": "הבכורה של הסימפוניה השלישית (״ההרואית״) של בטהובן",
    "start": 1805,
    "end": 1805,
    "date": "1805",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "בטהובן הציג את הסימפוניה השלישית, שכונתה ״ההרואית״. המקור היה הערצתו לנפוליאון, אך כשזה הכתיר את עצמו, בטהובן מחק את ההקדשה בזעם. היצירה, ארוכה ומורכבת חסרת תקדים, פתחה את העידן הרומנטי.",
    "rank": 58
  },
  {
    "id": "mu_notorious_ready",
    "deck": "music",
    "title": "נוטוריוס בי.אי.ג׳י מוציא את ״Ready to Die״",
    "start": 1994,
    "end": 1994,
    "date": "1994",
    "place": "ברוקלין, ניו יורק, ארצות הברית",
    "lat": 40.668,
    "lon": -73.957,
    "desc": "כריסטופר ״ביגי״ וואלאס מברוקלין הוציא את אלבום הבכורה ״Ready to Die״ שהפך לקלאסיקה של ההיפ-הופ בחוף המזרחי. סיפורי הרחוב והזרימה הייחודית שלו העמידו אותו מול טופאק ביריבות שהסתיימה ברצח שניהם.",
    "rank": 59
  },
  {
    "id": "mu_thelonious_monk_round",
    "deck": "music",
    "title": "תלוניוס מונק מקליט את ״Round Midnight״",
    "start": 1947,
    "end": 1947,
    "date": "1947",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "הפסנתרן תלוניוס מונק הקליט את ״Round Midnight״ עם להקתו לחברת Blue Note. הסטנדרט הפך לאחד השירים המוקלטים ביותר בהיסטוריית הג׳אז, ומונק עצמו — עם הסגנון הזוויתי והמקורי — לאחד מגדולי מחדשי הז׳אנר.",
    "rank": 60
  },
  {
    "id": "mu_guido_arezzo",
    "deck": "music",
    "title": "גווידו מארצו ממציא את שיטת התווים",
    "start": 1025,
    "end": 1025,
    "date": "בערך 1025 לספירה",
    "place": "ארצו, איטליה",
    "lat": 43.463,
    "lon": 11.879,
    "desc": "הנזיר גווידו מארצו פיתח את שיטת כתיבת התווים על חמישה קווים (חמשה), ואת שמות הצלילים דו-רה-מי (מראשי תיבות של המנון לטיני). המצאתו אפשרה לראשונה רישום מדויק של מנגינות — המהפכה שבלעדיה לא הייתה קיימת מוזיקה מערבית כפי שאנו מכירים.",
    "rank": 61
  },
  {
    "id": "mu_eminem_slim_shady",
    "deck": "music",
    "title": "אמינם מוציא את ״The Slim Shady LP״",
    "start": 1999,
    "end": 1999,
    "date": "1999",
    "place": "דטרויט, מישיגן, ארצות הברית",
    "lat": 42.331,
    "lon": -83.046,
    "desc": "מרשל מת׳רס (אמינם) מדטרויט הוציא את ״The Slim Shady LP״ בהפקת ד״ר דרה. הראפר הלבן שבר מחסומים גזעיים בהיפ-הופ עם טכניקה מהירה, הומור שחור ותוכן שנוי במחלוקת. הפך לאחד האמנים הנמכרים ביותר בהיסטוריה.",
    "rank": 62
  },
  {
    "id": "mu_buena_vista",
    "deck": "music",
    "title": "אלבום ״מועדון בואנה ויסטה החברתי״",
    "start": 1997,
    "end": 1997,
    "date": "1997",
    "place": "הוואנה, קובה",
    "lat": 23.135,
    "lon": -82.359,
    "desc": "ריי קודר הקליט בהוואנה קבוצת מוזיקאים קובניים מזדקנים שכמעט נשכחו. האלבום ״Buena Vista Social Club״ מכר מיליוני עותקים, זכה בגראמי, והפך לסרט של וים ונדרס. המוזיקה הקובנית חזרה בסערה לבמה העולמית.",
    "rank": 63
  },
  {
    "id": "mu_schubert_winterreise",
    "deck": "music",
    "title": "שוברט מלחין את ״מסע החורף״",
    "start": 1827,
    "end": 1827,
    "date": "1827",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "פרנץ שוברט הלחין את ״מסע החורף״ (Winterreise), מחזור של 24 שירי ליד על מילותיו של וילהלם מילר. היצירה, שנכתבה שנה לפני מותו, היא אחת מפסגות השירה הלירית ומביעה בדידות, אבל ויופי בצורה שלא הושגה שוב.",
    "rank": 64
  },
  {
    "id": "mu_run_dmc_aerosmith",
    "deck": "music",
    "title": "ראן-די.אם.סי ואירוסמית׳ מקליטים את ״Walk This Way״",
    "start": 1986,
    "end": 1986,
    "date": "1986",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "ראן-די.אם.סי הקליטו גרסה משותפת עם להקת הרוק אירוסמית׳ לשיר ״Walk This Way״. השיתוף שבר את המחסום בין היפ-הופ לרוק, פתח את הדלת לראפ במיינסטרים, ונחשב לאחד הרגעים המכריעים בהיסטוריית המוזיקה הפופולרית.",
    "rank": 65
  },
  {
    "id": "mu_public_enemy_nation",
    "deck": "music",
    "title": "פאבליק אנמי מוציאים את ״It Takes a Nation of Millions to Hold Us Back״",
    "start": 1988,
    "end": 1988,
    "date": "1988",
    "place": "לונג איילנד, ניו יורק, ארצות הברית",
    "lat": 40.789,
    "lon": -73.135,
    "desc": "פאבליק אנמי הוציאו את אלבומם השני, שמיזג ראפ אגרסיבי, דגימות צפופות ומסרים פוליטיים חותכים. צ׳אק די וזרע התודעה שלו הפכו את ההיפ-הופ לכלי מחאה פוליטי, והאלבום נחשב לאחד החשובים ביותר בז׳אנר.",
    "rank": 66
  },
  {
    "id": "mu_house_chicago",
    "deck": "music",
    "title": "לידת מוזיקת ההאוס בשיקגו",
    "start": 1984,
    "end": 1984,
    "date": "בערך 1984",
    "place": "שיקגו, אילינוי, ארצות הברית",
    "lat": 41.881,
    "lon": -87.623,
    "desc": "הדי ג׳יי פרנקי נאקלס החל לנגן סגנון אלקטרוני חדש במועדון ה-Warehouse בשיקגו, ששילב ביטים אלקטרוניים עם אלמנטים של דיסקו וסואול. הסגנון קיבל את שמו מהמועדון — ״האוס מיוזיק״ — והתפשט לאירופה ולעולם.",
    "rank": 67
  },
  {
    "id": "mu_josquin_missa",
    "deck": "music",
    "title": "ז׳וסקן דה פרה מלחין את ״מיסה פנגה לינגואה״",
    "start": 1515,
    "end": 1515,
    "date": "בערך 1515",
    "place": "קונדה, צרפת",
    "lat": 50.457,
    "lon": 3.589,
    "desc": "ז׳וסקן דה פרה, שמרטין לותר כינה ״אדון הצלילים״, חיבר את ״מיסה פנגה לינגואה״ המבוססת על מנגינת מזמור. ז׳וסקן נחשב למלחין הגדול ביותר של הרנסנס, ויצירתו שילבה מורכבות פוליפונית עם ביטוי רגשי עמוק.",
    "rank": 68
  },
  {
    "id": "mu_shalom_hanoch_waiting",
    "deck": "music",
    "title": "שלום חנוך מוציא את ״מחכה למשיח״",
    "start": 1985,
    "end": 1985,
    "date": "1985",
    "place": "תל אביב, ישראל",
    "lat": 32.064,
    "lon": 34.778,
    "desc": "שלום חנוך, ״אבי הרוק הישראלי״, הוציא את ״מחכה למשיח״ — אלבום שביסס את מעמדו כמוזיקאי-משורר. חנוך, ששיתף פעולה עם מאיר אריאל ואריק איינשטיין, עיצב את הזהות של הרוק הישראלי בעברית אותנטית.",
    "rank": 69
  },
  {
    "id": "mu_kendrick_damn",
    "deck": "music",
    "title": "קנדריק למאר זוכה בפרס פוליצר על ״DAMN.״",
    "start": 2018,
    "end": 2018,
    "date": "2018",
    "place": "לוס אנג׳לס, קליפורניה, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "קנדריק למאר מקומפטון הפך לראפר הראשון שזכה בפרס פוליצר למוזיקה, על אלבומו ״DAMN.״. הפרס הכיר סוף סוף בהיפ-הופ כאמנות ברמה הגבוהה ביותר, ולמאר נחשב לקול הספרותי החשוב ביותר בראפ בן זמנו.",
    "rank": 70
  },
  {
    "id": "mu_kanye_graduation",
    "deck": "music",
    "title": "קניה ווסט מוציא את ״Graduation״",
    "start": 2007,
    "end": 2007,
    "date": "2007",
    "place": "לוס אנג׳לס, קליפורניה, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "קניה ווסט הוציא את ״Graduation״, שמכר 957,000 עותקים בשבוע הראשון במרוץ מול 50 סנט. ווסט שילב אלקטרוניקה, סינת׳פופ ודגימות יצירתיות, והוכיח שהיפ-הופ יכול להיות גם אמנותי וגם מסחרי. האלבום שינה את כיוון הז׳אנר.",
    "rank": 71
  },
  {
    "id": "mu_mahler_8th",
    "deck": "music",
    "title": "הבכורה של הסימפוניה השמינית של מאהלר",
    "start": 1910,
    "end": 1910,
    "date": "1910",
    "place": "מינכן, גרמניה",
    "lat": 48.135,
    "lon": 11.575,
    "desc": "גוסטב מאהלר הנחית את הבכורה של הסימפוניה השמינית, ״סימפוניית האלף״, עם למעלה מאלף מבצעים על הבמה. היצירה, שמשלבת המנון לטיני ואת הסצנה האחרונה מ״פאוסט״ של גתה, נחשבת לשיא הרומנטיקה המאוחרת.",
    "rank": 72
  },
  {
    "id": "mu_record_player",
    "deck": "music",
    "title": "אדיסון ממציא את הפונוגרף",
    "start": 1877,
    "end": 1877,
    "date": "1877",
    "place": "מנלו פארק, ניו ג׳רזי, ארצות הברית",
    "lat": 40.567,
    "lon": -74.36,
    "desc": "תומאס אדיסון המציא את הפונוגרף, המכשיר הראשון שהקליט והשמיע צלילים. המילים הראשונות שהוקלטו היו ״Mary had a little lamb״. ההמצאה אפשרה לראשונה לשמר ולשכפל מוזיקה, ופתחה את העידן של תעשיית ההקלטות.",
    "rank": 73
  },
  {
    "id": "mu_techno_detroit",
    "deck": "music",
    "title": "לידת הטכנו בדטרויט",
    "start": 1985,
    "end": 1988,
    "date": "בערך ⁦1985–1988⁩",
    "place": "דטרויט, מישיגן, ארצות הברית",
    "lat": 42.331,
    "lon": -83.046,
    "desc": "חואן אטקינס, דריק מיי וקווין סנדרסון — ה״שלישייה של בלוויל״ — יצרו בדטרויט סגנון אלקטרוני חדש שמיזג פאנק, סינת׳פופ ועתידנות. הטכנו עבר לאירופה, שם השתלט על תרבות המועדונים ורייבים והפך לתנועה עולמית.",
    "rank": 74
  },
  {
    "id": "mu_troubadours",
    "deck": "music",
    "title": "עידן הטרובדורים בדרום צרפת",
    "start": 1100,
    "end": 1300,
    "date": "בערך ⁦1100–1300⁩ לספירה",
    "place": "טולוז, צרפת",
    "lat": 43.604,
    "lon": 1.444,
    "desc": "הטרובדורים — משוררי-זמרי חצר בדרום צרפת — יצרו שירי אהבה בפרובנסלית שהפכו לבסיס של המוזיקה החילונית המערבית. גיום התשיעי דוכס אקיטניה נחשב לטרובדור הראשון. שיריהם על אהבה חצרנית עיצבו את תרבות האהבה האירופית.",
    "rank": 75
  },
  {
    "id": "mu_bartok_concerto",
    "deck": "music",
    "title": "ברטוק מלחין את הקונצ׳רטו לתזמורת",
    "start": 1943,
    "end": 1943,
    "date": "1943",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "בלה ברטוק, בגלותו מהונגריה הנאצית, הלחין את ״קונצ׳רטו לתזמורת״ בניו יורק בהזמנת סרגיי קוסוויצקי. היצירה, שמשלבת מנגינות עממיות הונגריות עם מודרניזם, נחשבת לשיא יצירתו ולאחת היצירות האורקסטרליות הנודעות ביותר של המאה ה-20.",
    "rank": 76
  },
  {
    "id": "mu_clash_london",
    "deck": "music",
    "title": "הקלאש מוציאים את ״London Calling״",
    "start": 1979,
    "end": 1979,
    "date": "1979",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "להקת הקלאש הוציאה את ״London Calling״, אלבום כפול שמיזג פאנק עם רגאיי, רוקבילי, סקא וג׳אז. האלבום הרחיב את גבולות הפאנק מעבר למחאה גולמית ונחשב לאחד האלבומים הגדולים ביותר ברוק.",
    "rank": 77
  },
  {
    "id": "mu_puccini_boheme",
    "deck": "music",
    "title": "הבכורה של ״לה בוהם״ של פוצ׳יני",
    "start": 1896,
    "end": 1896,
    "date": "1896",
    "place": "טורינו, איטליה",
    "lat": 45.071,
    "lon": 7.685,
    "desc": "ג׳אקומו פוצ׳יני הציג את האופרה ״לה בוהם״, סיפור על אמנים צעירים ועניים ברובע הלטיני בפריז. האופרה, שנחשבת לפופולרית ביותר ברפרטואר, השפיעה על תרבות הפופ — כולל המחזמר ״Rent״.",
    "rank": 78
  },
  {
    "id": "mu_beatles_sgt_pepper",
    "deck": "music",
    "title": "הביטלס מוציאים את ״Sgt. Pepper's Lonely Hearts Club Band״",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "לונדון, אנגליה",
    "lat": 51.532,
    "lon": -0.177,
    "desc": "הביטלס הוציאו את ״Sgt. Pepper's״, אלבום הקונספט שנחשב למהפכה באמנות ההקלטה. 700 שעות באולפן, תזמורת, אפקטים וכריכה אייקונית יצרו יצירת מופת שהפכה את האלבום מאוסף שירים ליצירה אחידה.",
    "rank": 79
  },
  {
    "id": "mu_dr_dre_chronic",
    "deck": "music",
    "title": "ד״ר דרה מוציא את ״The Chronic״",
    "start": 1992,
    "end": 1992,
    "date": "1992",
    "place": "לוס אנג׳לס, קליפורניה, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "ד״ר דרה הוציא את ״The Chronic״ והמציא את סגנון ה-G-funk — ראפ חוף מערבי עם סינתיסייזרים מפרפרים. האלבום הציג את סנופ דוג וקבע סטנדרט חדש בהפקת היפ-הופ שהשפיע על עשורים של מוזיקה.",
    "rank": 80
  },
  {
    "id": "mu_ars_nova",
    "deck": "music",
    "title": "עידן ״אמנות חדשה״ (ארס נובה) בצרפת",
    "start": 1320,
    "end": 1380,
    "date": "בערך ⁦1320–1380⁩ לספירה",
    "place": "פריז, צרפת",
    "lat": 48.853,
    "lon": 2.349,
    "desc": "פיליפ דה ויטרי ומאשו פיתחו סגנון מוזיקלי חדש שהציג קצבים מורכבים ופוליפוניה מתוחכמת. מסת נוטרדאם של מאשו היא הראשונה שהולחנה כיצירה שלמה על ידי מלחין אחד. הארס נובא שחרר את המוזיקה ממגבלות ימי הביניים.",
    "rank": 81
  },
  {
    "id": "mu_kpop_gangnam",
    "deck": "music",
    "title": "סיי מוציא את ״גנגנם סטייל״",
    "start": 2012,
    "end": 2012,
    "date": "2012",
    "place": "סיאול, דרום קוריאה",
    "lat": 37.566,
    "lon": 126.978,
    "desc": "הראפר הקוריאני סיי הוציא את ״גנגנם סטייל״, שהפך לסרטון הראשון שחצה מיליארד צפיות ביוטיוב. השיר הפך את הקיי-פופ מתופעה אסייתית לכוח גלובלי, ופתח את הדרך להצלחה העולמית של BTS ובלקפינק.",
    "rank": 82
  },
  {
    "id": "mu_idan_raichel",
    "deck": "music",
    "title": "עידן רייכל מוציא את אלבומו הראשון",
    "start": 2002,
    "end": 2002,
    "date": "2002",
    "place": "תל אביב, ישראל",
    "lat": 32.064,
    "lon": 34.778,
    "desc": "עידן רייכל הוציא את ״פרויקט עידן רייכל״, שמיזג מוזיקה אתיופית, תימנית, ערבית ואלקטרונית. האלבום שינה את פני המוזיקה הישראלית בכך שנתן במה לקולות מזרחיים ואפריקאיים, ומכר מעל 200,000 עותקים בישראל.",
    "rank": 83
  },
  {
    "id": "mu_shostakovich_5th",
    "deck": "music",
    "title": "שוסטקוביץ׳ מלחין את הסימפוניה החמישית",
    "start": 1937,
    "end": 1937,
    "date": "1937",
    "place": "לנינגרד, ברית המועצות",
    "lat": 59.934,
    "lon": 30.328,
    "desc": "דמיטרי שוסטקוביץ׳ הלחין את הסימפוניה החמישית לאחר שסטלין גינה את אופרתו הקודמת. היצירה, שכינה ״תגובת אמן סובייטי לביקורת צודקת״, הכילה מחאה סמויה מתחת לפני השטח ושיקפה את אימת החיים תחת הטרור הסטליניסטי.",
    "rank": 84
  },
  {
    "id": "mu_greek_lyre",
    "deck": "music",
    "title": "הלירה היוונית והמוזיקה בתרבות העתיקה",
    "start": -700,
    "end": -500,
    "date": "בערך ⁦700–500⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.975,
    "lon": 23.722,
    "desc": "ביוון העתיקה הייתה המוזיקה חלק מרכזי מהחינוך, הפולחן והדרמה. תאוריית המוזיקה שפיתח פיתגורס — יחסים מתמטיים בין צלילים — הניחה את הבסיס למערכת הסולמות המערבית. כלי הנגינה העיקריים היו הלירה, האאולוס והקיתרה.",
    "rank": 85
  },
  {
    "id": "mu_rachmaninoff_2nd",
    "deck": "music",
    "title": "הבכורה של הקונצ׳רטו השני לפסנתר של רחמנינוב",
    "start": 1901,
    "end": 1901,
    "date": "1901",
    "place": "מוסקבה, רוסיה",
    "lat": 55.755,
    "lon": 37.618,
    "desc": "סרגיי רחמנינוב הציג את הקונצ׳רטו השני לפסנתר, שנכתב לאחר התאוששות מדיכאון קשה. היצירה, עם הפתיחה האייקונית שלה בפעמוני פסנתר, הפכה לאחת היצירות הפופולריות ביותר ברפרטואר הפסנתרני.",
    "rank": 86
  },
  {
    "id": "mu_dvorak_new_world",
    "deck": "music",
    "title": "הבכורה של הסימפוניה ״מהעולם החדש״ של דבורז׳אק",
    "start": 1893,
    "end": 1893,
    "date": "1893",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "אנטונין דבורז׳אק הציג את הסימפוניה התשיעית ״מהעולם החדש״ בקרנגי הול. המלחין הצ׳כי שאב השראה ממנגינות עממיות אפרו-אמריקאיות ואינדיאניות, ויצר יצירה שמגשרת בין המוזיקה האירופית לאמריקנית.",
    "rank": 87
  },
  {
    "id": "mu_u2_joshua",
    "deck": "music",
    "title": "יו-טו מוציאים את ״The Joshua Tree״",
    "start": 1987,
    "end": 1987,
    "date": "1987",
    "place": "דבלין, אירלנד",
    "lat": 53.35,
    "lon": -6.26,
    "desc": "יו-טו מאירלנד הוציאו את ״The Joshua Tree״, שהפך אותם ללהקת הרוק הגדולה ביותר בעולם. ״With or Without You״ ו-״Where the Streets Have No Name״ שילבו שירה רגשית עם גיטרות אטמוספריות ומסרים על אמריקה.",
    "rank": 88
  },
  {
    "id": "mu_nwa_compton",
    "deck": "music",
    "title": "NWA מוציאים את ״Straight Outta Compton״",
    "start": 1988,
    "end": 1988,
    "date": "1988",
    "place": "קומפטון, קליפורניה, ארצות הברית",
    "lat": 33.896,
    "lon": -118.221,
    "desc": "NWA — איס קיוב, ד״ר דרה, איזי-אי ועוד — הוציאו את ״Straight Outta Compton״, שהגדיר את הגנגסטה ראפ. האלבום תיאר חיים באלימות, עוני ואכיפת חוק גזענית בלוס אנג׳לס. ה-FBI שלח מכתב אזהרה ללייבל, מה שרק הגביר את המכירות.",
    "rank": 89
  },
  {
    "id": "mu_ethnix_ya_habibi",
    "deck": "music",
    "title": "אתניקס מוציאים את ״יא חביבי אני״",
    "start": 1995,
    "end": 1995,
    "date": "1995",
    "place": "תל אביב, ישראל",
    "lat": 32.064,
    "lon": 34.778,
    "desc": "להקת אתניקס הוציאה את ״יא חביבי אני״, אלבום שמיזג פופ ישראלי עם השפעות מזרחיות ואלקטרוניות. השיר ״עוד יום עולה״ הפך ללהיט ענק, ואתניקס ביססו סגנון ישראלי ייחודי שפנה גם למערב וגם למזרח.",
    "rank": 90
  },
  {
    "id": "mu_messiaen_turangalila",
    "deck": "music",
    "title": "הבכורה של ״סימפוניית טורנגלילה״ של מסיאן",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "בוסטון, מסצ׳וסטס, ארצות הברית",
    "lat": 42.36,
    "lon": -71.059,
    "desc": "אוליבייה מסיאן הציג את ״סימפוניית טורנגלילה״ בבוסטון, יצירה בת עשרה פרקים על אהבה, שמחה ומוות. השימוש בכלי הנגינה ״אונד מרטנו״ ובצבעים תזמורתיים ייחודיים עיצב את עולם הצלילים של המחצית השנייה של המאה ה-20.",
    "rank": 91
  },
  {
    "id": "mu_guitar_invention",
    "deck": "music",
    "title": "אנטוניו דה טורס מעצב את הגיטרה המודרנית",
    "start": 1856,
    "end": 1856,
    "date": "בערך 1856",
    "place": "אלמריה, ספרד",
    "lat": 36.838,
    "lon": -2.464,
    "desc": "הלותייר הספרדי אנטוניו דה טורס עיצב את הגיטרה הקלאסית המודרנית, עם גוף גדול יותר, מניפה (דוגמא) פנימית ומיתרים חופשיים. העיצוב הפך לסטנדרט העולמי, ובמאה ה-20 היווה את הבסיס שממנו התפתחה הגיטרה החשמלית.",
    "rank": 92
  },
  {
    "id": "mu_abbey_road",
    "deck": "music",
    "title": "הביטלס מוציאים את ״Abbey Road״",
    "start": 1969,
    "end": 1969,
    "date": "1969",
    "place": "לונדון, אנגליה",
    "lat": 51.532,
    "lon": -0.177,
    "desc": "הביטלס הקליטו את ״Abbey Road״, אלבומם האחרון יחד. תמונת הכריכה של ארבעתם חוצים את מעבר החצייה ברחוב אבי רואד הפכה לאייקונית ביותר בהיסטוריית המוזיקה. המדלי בצד ב׳ נחשב לאחת מפסגות האמנות של הרוק.",
    "rank": 93
  },
  {
    "id": "mu_mtv_launch",
    "deck": "music",
    "title": "השקת ערוץ MTV",
    "start": 1981,
    "end": 1981,
    "date": "1981",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "ערוץ MTV עלה לאוויר עם הקליפ ״Video Killed the Radio Star״. הערוץ שינה את תעשיית המוזיקה: מעתה לא מספיק לשמוע טוב — צריך גם להיראות טוב. מייקל ג׳קסון, מדונה ודוראן דוראן שלטו בעידן הווידאו-קליפ.",
    "rank": 94
  },
  {
    "id": "mu_bach_goldberg",
    "deck": "music",
    "title": "באך מלחין את ״וריאציות גולדברג״",
    "start": 1741,
    "end": 1741,
    "date": "1741",
    "place": "לייפציג, גרמניה",
    "lat": 51.34,
    "lon": 12.375,
    "desc": "יוהאן סבסטיאן באך חיבר סדרה של 30 וריאציות לקלוויצ׳מבלו, שנקראו על שם התלמיד שביצע אותן — יוהאן גוטליב גולדברג. היצירה, שגלן גולד הפך למיתוס ב-1955, נחשבת לפסגת אמנות הוריאציה.",
    "rank": 95
  },
  {
    "id": "mu_spotify_launch",
    "deck": "music",
    "title": "השקת ספוטיפיי",
    "start": 2008,
    "end": 2008,
    "date": "2008",
    "place": "סטוקהולם, שוודיה",
    "lat": 59.329,
    "lon": 18.069,
    "desc": "שירות הסטרימינג ספוטיפיי הושק בשוודיה, והציע גישה חוקית ונוחה למיליוני שירים. הפלטפורמה שינתה את הדרך שבה אנשים צורכים מוזיקה, העבירה את התעשייה ממכירת אלבומים לסטרימינג, ויצרה דגם כלכלי חדש לאמנים.",
    "rank": 96
  },
  {
    "id": "mu_sumer_hymn",
    "deck": "music",
    "title": "המנוני שומר: המוזיקה המתועדת העתיקה ביותר",
    "start": -2400,
    "end": -2400,
    "date": "בערך 2400 לפנה״ס",
    "place": "אור, עיראק",
    "lat": 30.963,
    "lon": 46.103,
    "desc": "לוחות חרס מאור בשומר נושאים את התיעוד העתיק ביותר שידוע לנו של מוזיקה כתובה — המנונים לאלת המקדש. אף שאיננו יודעים בדיוק כיצד נשמעה המוזיקה, הלוחות מוכיחים שתורת המוזיקה קדמה לתרבות יוון בכ-2000 שנה.",
    "rank": 97
  },
  {
    "id": "mu_beyonce_lemonade",
    "deck": "music",
    "title": "ביונסה מוציאה את ״Lemonade״",
    "start": 2016,
    "end": 2016,
    "date": "2016",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "ביונסה הוציאה את האלבום החזותי ״Lemonade״, שמיזג R&B, רוק, קאנטרי והיפ-הופ עם סרט שלם. היצירה עסקה בבגידה, גזענות ועוצמה נשית שחורה, ונחשבת לאחד הפרויקטים האמנותיים המשמעותיים ביותר של המאה ה-21.",
    "rank": 98
  },
  {
    "id": "mu_ramones_debut",
    "deck": "music",
    "title": "הריימונס מוציאים את אלבום הבכורה שלהם",
    "start": 1976,
    "end": 1976,
    "date": "1976",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.726,
    "lon": -73.99,
    "desc": "הריימונס הוציאו את אלבום הבכורה שלהם, 14 שירים ב-29 דקות של רוק מהיר, גולמי ופשוט. אף שלא זכה להצלחה מסחרית מיידית, האלבום נחשב למצית מהפכת הפאנק ולהשראה לאינספור להקות אלטרנטיביות.",
    "rank": 99
  },
  {
    "id": "mu_vivaldi_born",
    "deck": "music",
    "title": "ויוואלדי הכומר האדום מלמד בבית היתומים בונציה",
    "start": 1703,
    "end": 1703,
    "date": "בערך 1703",
    "place": "ונציה, איטליה",
    "lat": 45.434,
    "lon": 12.339,
    "desc": "אנטוניו ויוואלדי מונה למורה לכינור ולמנצח באוספדלה דלה פייטה, בית יתומות בונציה. הבנות שלימד הפכו לתזמורת מפורסמת באירופה, וויוואלדי הלחין עבורן מאות קונצ׳רטים שהגדירו את צליל הבארוק.",
    "rank": 100
  },
  {
    "id": "mu_meir_ariel_shlomtsiyon",
    "deck": "music",
    "title": "מאיר אריאל מוציא את ״שלומציון״",
    "start": 1980,
    "end": 1980,
    "date": "1980",
    "place": "תל אביב, ישראל",
    "lat": 32.064,
    "lon": 34.778,
    "desc": "מאיר אריאל, מגדולי המשוררים-זמרים בעברית, הוציא את אלבומו ״שלומציון״. השילוב של טקסטים ליריים עמוקים, ניבים ישראליים וצליל בלתי מסורתי עיצב מסורת של שיר-יוצר ישראלי, והשפעתו ניכרת ביוצרים רבים עד היום.",
    "rank": 101
  },
  {
    "id": "mu_grunge_seattle",
    "deck": "music",
    "title": "זירת הגראנג׳ בסיאטל",
    "start": 1988,
    "end": 1991,
    "date": "בערך ⁦1988–1991⁩",
    "place": "סיאטל, וושינגטון, ארצות הברית",
    "lat": 47.606,
    "lon": -122.332,
    "desc": "סצנת המוזיקה המחתרתית של סיאטל — להקות כמו סאונדגארדן, אליס אין צ׳יינס ופרל ג׳אם לצד נירוונה — יצרה את הגראנג׳. לייבל Sub Pop חתם את הלהקות, שמיזגו פאנק עם מטאל, ובתוך שנים הסגנון כבש את המיינסטרים.",
    "rank": 102
  },
  {
    "id": "mu_robert_johnson_crossroads",
    "deck": "music",
    "title": "רוברט ג׳ונסון מקליט את ״Cross Road Blues״",
    "start": 1936,
    "end": 1936,
    "date": "1936",
    "place": "סן אנטוניו, טקסס, ארצות הברית",
    "lat": 29.425,
    "lon": -98.494,
    "desc": "רוברט ג׳ונסון הקליט 29 שירים בשתי הקלטות שהפכו לאגדיים. האגדה שמכר את נשמתו לשטן בצומת דרכים מסבירה את גיטרתו העל-אנושית. ג׳ונסון מת בגיל 27, אך הבלוז שלו עיצב את אריק קלפטון, הרולינג סטונס ואת כל הרוק.",
    "rank": 103
  },
  {
    "id": "mu_rave_uk",
    "deck": "music",
    "title": "תרבות הרייב בבריטניה",
    "start": 1988,
    "end": 1992,
    "date": "בערך ⁦1988–1992⁩",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "תרבות הרייב פרצה בבריטניה עם מסיבות ענק בלתי חוקיות בשדות ומחסנים, לצלילי אסיד האוס. מאות אלפי צעירים השתתפו, והממשלה חוקקה את ״חוק הסדר הפלילי והצדק״ כדי לאסור התקהלות לצלילי ביטים חוזרים.",
    "rank": 104
  },
  {
    "id": "mu_carmen_premiere",
    "deck": "music",
    "title": "הבכורה של ״כרמן״ של ביזה",
    "start": 1875,
    "end": 1875,
    "date": "1875",
    "place": "פריז, צרפת",
    "lat": 48.871,
    "lon": 2.344,
    "desc": "ז׳ורז׳ ביזה הציג את האופרה ״כרמן״ באופרה קומיק בפריז. הקהל נדהם מהריאליזם — ציגנית פורצת מוסכמות נרצחת על הבמה. ביזה מת שלושה חודשים מאוחר יותר, מבלי לדעת שיצר את אחת האופרות הפופולריות ביותר אי-פעם.",
    "rank": 105
  },
  {
    "id": "mu_printing_music",
    "deck": "music",
    "title": "פטרוצ׳י מדפיס מוזיקה לראשונה",
    "start": 1501,
    "end": 1501,
    "date": "1501",
    "place": "ונציה, איטליה",
    "lat": 45.434,
    "lon": 12.339,
    "desc": "אוטוויאנו פטרוצ׳י פרסם את ״הרמוניצ׳ה מוסיצ׳ס אודקטון״ — האוסף המודפס הראשון של מוזיקה פוליפונית. הדפוס המוזיקלי הפך יצירות בלעדיות של חצרות ומנזרים לנגישות ברחבי אירופה, ושינה את הפצת המוזיקה לצמיתות.",
    "rank": 106
  },
  {
    "id": "mu_piazzolla_tango",
    "deck": "music",
    "title": "פיאצולה יוצר את הטנגו נואבו",
    "start": 1955,
    "end": 1955,
    "date": "בערך 1955",
    "place": "בואנוס איירס, ארגנטינה",
    "lat": -34.604,
    "lon": -58.382,
    "desc": "אסטור פיאצולה חזר מלימודי קומפוזיציה אצל נדיה בולנז׳ה בפריז ויצר את ה״טנגו נואבו״ — מיזוג של טנגו ארגנטינאי עם ג׳אז ומוזיקה קלאסית. ה-bandoneón שלו הפך כלי של מיליציה ריקודית לכלי קונצרטי, ושינה את פניו של הטנגו.",
    "rank": 107
  },
  {
    "id": "mu_acid_house_303",
    "deck": "music",
    "title": "לידת האסיד האוס בשיקגו",
    "start": 1987,
    "end": 1987,
    "date": "בערך 1987",
    "place": "שיקגו, אילינוי, ארצות הברית",
    "lat": 41.881,
    "lon": -87.623,
    "desc": "מוזיקאים בשיקגו גילו שמכונת הבאס TB-303 של רולנד, שנועדה לדמות גיטרה בס, מייצרת צלילים חומציים ומעוותים כשמשחקים עם הכפתורים. פוצ׳ס הוצ׳ יצר עם ״Acid Tracks״ ז׳אנר חדש שכבש את מועדוני אירופה.",
    "rank": 108
  },
  {
    "id": "mu_glass_einstein",
    "deck": "music",
    "title": "הבכורה של ״איינשטיין על החוף״ של גלאס",
    "start": 1976,
    "end": 1976,
    "date": "1976",
    "place": "אביניון, צרפת",
    "lat": 43.949,
    "lon": 4.806,
    "desc": "פיליפ גלאס והבמאי רוברט וילסון הציגו את האופרה המינימליסטית ״איינשטיין על החוף״ בפסטיבל אביניון. היצירה בת חמש שעות, ללא עלילה מסורתית, קבעה את המינימליזם המוזיקלי כתנועה משמעותית.",
    "rank": 109
  },
  {
    "id": "mu_umm_kulthum",
    "deck": "music",
    "title": "אום כולתום שרה ״אל-אטלאל״",
    "start": 1966,
    "end": 1966,
    "date": "1966",
    "place": "קהיר, מצרים",
    "lat": 30.045,
    "lon": 31.256,
    "desc": "אום כולתום, ״כוכב המזרח״, ביצעה את ״אל-אטלאל״ (״החורבות״) בקונצרט שידור חי ברדיו שהשבית את הרחובות בעולם הערבי כולו. הזמרת המצרית נחשבת לאחת האמניות המשפיעות ביותר בהיסטוריה עם מאות מיליוני מעריצים.",
    "rank": 110
  },
  {
    "id": "mu_opera_verismo",
    "deck": "music",
    "title": "הבכורה של ״ליצנים״ של לאונקבלו",
    "start": 1892,
    "end": 1892,
    "date": "1892",
    "place": "מילאנו, איטליה",
    "lat": 45.464,
    "lon": 9.191,
    "desc": "רוג׳רו לאונקבלו הציג את ״ליצנים״ (Pagliacci), אופרה וריסטית המבוססת על פסק דין אמיתי. ״Vesti la giubba״ — הלבש את הבגד — הפך לאריה הנודעת ביותר במוזיקה. יחד עם ״כבוד כפרי״ של מסקאני, הגדיר את הוריסמו האופראי.",
    "rank": 111
  },
  {
    "id": "mu_sabbath_black",
    "deck": "music",
    "title": "בלאק סבאת׳ מוציאים את אלבום הבכורה שלהם",
    "start": 1970,
    "end": 1970,
    "date": "1970",
    "place": "ברמינגהם, אנגליה",
    "lat": 52.483,
    "lon": -1.894,
    "desc": "להקת בלאק סבאת׳ מברמינגהם הוציאה את אלבום הבכורה שלה, שנפתח בצלילי סערה ואקורד טריטון מאיים. אוזי אוסבורן וטוני איומי יצרו את ההבי מטאל — ז׳אנר שעדיין חי ומפרה שהגדיר את הקצה הכבד והחשוך של הרוק.",
    "rank": 112
  },
  {
    "id": "mu_persian_maqam",
    "deck": "music",
    "title": "התגבשות מערכת המקאם הפרסית",
    "start": 800,
    "end": 1000,
    "date": "בערך ⁦800–1000⁩ לספירה",
    "place": "בגדאד, עיראק",
    "lat": 33.312,
    "lon": 44.366,
    "desc": "בבית אלחיכמה בבגדאד תרגם אל-כינדי טקסטים יווניים על תאוריית המוזיקה, ואל-פאראבי כתב את ה״כתאב אלמוסיקי אלכביר״. חוקרים מוסלמים פיתחו את מערכת המקאם — סולמות מלודיים שמהווים את בסיס המוזיקה הערבית, הפרסית והטורקית עד היום.",
    "rank": 113
  },
  {
    "id": "mu_la_scala_opens",
    "deck": "music",
    "title": "פתיחת תיאטרון לה סקאלה",
    "start": 1778,
    "end": 1778,
    "date": "1778",
    "place": "מילאנו, איטליה",
    "lat": 45.467,
    "lon": 9.189,
    "desc": "תיאטרון לה סקאלה נפתח במילאנו ובתוך עשרות שנים הפך לבית האופרה החשוב בעולם. על הבמה הזו יעלו בכורות של רוסיני, דוניצטי, בליני, ורדי ופוצ׳יני. שמו של לה סקאלה הפך לשם נרדף לאופרה ברמה הגבוהה ביותר.",
    "rank": 114
  },
  {
    "id": "mu_joy_division_unknown",
    "deck": "music",
    "title": "ג׳וי דיוויז׳ן מוציאים את ״Unknown Pleasures״",
    "start": 1979,
    "end": 1979,
    "date": "1979",
    "place": "מנצ׳סטר, אנגליה",
    "lat": 53.483,
    "lon": -2.244,
    "desc": "ג׳וי דיוויז׳ן ממנצ׳סטר הוציאו את ״Unknown Pleasures״, אלבום פוסט-פאנק אפלולי שהגדיר סגנון חדש. הכריכה האייקונית עם גלי הרדיו של פולסר הפכה לסמל תרבותי. מות הסולן איאן קרטיס ב-1980 הפך את הלהקה לאגדה.",
    "rank": 115
  },
  {
    "id": "mu_prokofiev_romeo",
    "deck": "music",
    "title": "הבכורה של ״רומיאו ויוליה״ של פרוקופייב",
    "start": 1938,
    "end": 1938,
    "date": "1938",
    "place": "ברנו, צ׳כוסלובקיה",
    "lat": 49.195,
    "lon": 16.608,
    "desc": "הבלט ״רומיאו ויוליה״ של סרגיי פרוקופייב בוצע לראשונה בברנו. ״ריקוד האבירים״ הפך ליצירה הקלאסית המוכרת ביותר מהמאה ה-20, ומושמע בהקשרים רבים — מאירועי ספורט ועד פרסומות.",
    "rank": 116
  },
  {
    "id": "mu_flamenco_cafes",
    "deck": "music",
    "title": "עידן הזהב של הפלמנקו",
    "start": 1850,
    "end": 1910,
    "date": "בערך ⁦1850–1910⁩",
    "place": "סביליה, ספרד",
    "lat": 37.389,
    "lon": -5.984,
    "desc": "בבתי הקפה של אנדלוסיה התפתח הפלמנקו מאמנות רחוב צוענית לצורה מוזיקלית מובנית עם שירה (cante), גיטרה (toque) וריקוד (baile). הפלמנקו משקף מפגש תרבויות — ערבית, יהודית, צוענית ונוצרית — בדרום ספרד.",
    "rank": 117
  },
  {
    "id": "mu_swing_goodman",
    "deck": "music",
    "title": "בני גודמן ״מלך הסווינג״ בקרנגי הול",
    "start": 1938,
    "end": 1938,
    "date": "1938",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.765,
    "lon": -73.98,
    "desc": "הקלרנטיסט בני גודמן הופיע עם תזמורתו בקרנגי הול — הפעם הראשונה שקונצרט ג׳אז נערך באולם מוזיקה קלאסית יוקרתי. ההופעה שברה מחסומים חברתיים (תזמורת מעורבת גזעית) ואומנותיים, ושינתה את מעמד הג׳אז.",
    "rank": 118
  },
  {
    "id": "mu_musica_ricercata",
    "deck": "music",
    "title": "ליגטי מלחין את ״מוסיקה ריצ׳רקטה״",
    "start": 1953,
    "end": 1953,
    "date": "בערך ⁦1951–1953⁩",
    "place": "בודפשט, הונגריה",
    "lat": 47.497,
    "lon": 19.04,
    "desc": "ג׳רג׳ ליגטי חיבר את ״מוסיקה ריצ׳רקטה״ — 11 פרקים לפסנתר שהראשון משתמש בצליל יחיד בלבד, והשני מוסיף צליל, וכן הלאה. ליגטי, שברח מהונגריה ב-1956, הפך לאחד מקולות המאה ה-20 הייחודיים (מוכר מסרטי קובריק).",
    "rank": 119
  },
  {
    "id": "mu_charlie_parker_koko",
    "deck": "music",
    "title": "צ׳רלי פארקר מקליט את ״Ko-Ko״",
    "start": 1945,
    "end": 1945,
    "date": "1945",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "הסקסופוניסט צ׳רלי ״בירד״ פארקר הקליט את ״Ko-Ko״, יצירה שנחשבת לגולת הכותרת של מהפכת הביבופ. המהירות, ההרמוניות המורכבות והאלתור הגאוני שברו את מוסכמות הג׳אז ופתחו את הדרך לג׳אז כאמנות גבוהה.",
    "rank": 120
  },
  {
    "id": "mu_depeche_mode_violator",
    "deck": "music",
    "title": "דפש מוד מוציאים את ״Violator״",
    "start": 1990,
    "end": 1990,
    "date": "1990",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "דפש מוד הוציאו את ״Violator״, אלבום שהגדיר את הסינת׳פופ כז׳אנר בוגר ואפל. ״Enjoy the Silence״ ו-״Personal Jesus״ הפכו ללהיטים עולמיים, והלהקה הוכיחה שמוזיקה אלקטרונית יכולה להיות גם רגשית וגם מסחרית.",
    "rank": 121
  },
  {
    "id": "mu_persian_tar",
    "deck": "music",
    "title": "התגבשות הטאר והסטאר בפרס",
    "start": 1400,
    "end": 1500,
    "date": "בערך ⁦1400–1500⁩",
    "place": "שיראז, פרס",
    "lat": 29.592,
    "lon": 52.584,
    "desc": "בתקופת הטימורידים התגבשה הצורה המודרנית של כלי המיתר הפרסיים — הטאר, הסטאר והקמנצ׳ה. כלים אלו, לצד שירת הגזל, עיצבו את המוזיקה הקלאסית הפרסית שהשפיעה על כל המוזיקה של מרכז אסיה ודרום אסיה.",
    "rank": 122
  },
  {
    "id": "mu_ella_fitzgerald_songbook",
    "deck": "music",
    "title": "אלה פיצג׳רלד מוציאה את ״הספר של קול פורטר״",
    "start": 1956,
    "end": 1956,
    "date": "1956",
    "place": "לוס אנג׳לס, קליפורניה, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "אלה פיצג׳רלד, ״הגברת הראשונה של השיר״, החלה את סדרת אלבומי ה-Songbook עם ״The Cole Porter Songbook״. הסדרה שימרה את שירי הפופ הגדולים של אמריקה כקלאסיקות, ובקולה הצלול וטכניקת הסקאט שלה הגדירה את שירת הג׳אז.",
    "rank": 123
  },
  {
    "id": "mu_indie_pixies",
    "deck": "music",
    "title": "הפיקסיז מוציאים את ״Doolittle״",
    "start": 1989,
    "end": 1989,
    "date": "1989",
    "place": "בוסטון, מסצ׳וסטס, ארצות הברית",
    "lat": 42.36,
    "lon": -71.059,
    "desc": "להקת הפיקסיז הוציאה את ״Doolittle״, אלבום שהשפיע על כל סצנת האלטרנטיב רוק של שנות ה-90. קורט קוביין הודה שניסה לכתוב שיר של הפיקסיז כשכתב את ״Smells Like Teen Spirit״. המעבר בין שקט ורעש הפך לנוסחת הגראנג׳.",
    "rank": 124
  },
  {
    "id": "mu_haydn_creation",
    "deck": "music",
    "title": "הבכורה של ״הבריאה״ של היידן",
    "start": 1798,
    "end": 1798,
    "date": "1798",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "יוזף היידן הציג את האורטוריה ״הבריאה״, שנכתבה על פי ספר בראשית ו״גן העדן האבוד״ של מילטון. היצירה מתארת בצלילים את בריאת האור, הים, בעלי החיים והאדם, ונחשבת ליצירתו הגדולה ביותר.",
    "rank": 125
  },
  {
    "id": "mu_samba_rio",
    "deck": "music",
    "title": "הסמבה הולכת מהפבלות למיינסטרים",
    "start": 1917,
    "end": 1917,
    "date": "בערך 1917",
    "place": "ריו דה ז׳נרו, ברזיל",
    "lat": -22.907,
    "lon": -43.173,
    "desc": "הסמבה התפתחה בשכונות השחורות של ריו דה ז׳נרו, מעבדים שחרורים שהביאו מקצבי אפריקה. ״Pelo Telefone״ נחשב לשיר הסמבה המוקלט הראשון. הסגנון הפך לסמל הלאומי של ברזיל ולנשמת הקרנבל.",
    "rank": 126
  },
  {
    "id": "mu_nusrat_qawwali",
    "deck": "music",
    "title": "נוסרת פאתח עלי חאן מביא את הקוואלי לעולם",
    "start": 1985,
    "end": 1985,
    "date": "בערך 1985",
    "place": "לאהור, פקיסטן",
    "lat": 31.55,
    "lon": 74.35,
    "desc": "נוסרת פאתח עלי חאן, הזמר הסופי הגדול ביותר בהיסטוריה, החל להופיע בפסטיבלי WOMAD בהזמנת פיטר גבריאל. הקול העוצמתי שלו הביא את הקוואלי — שירה דתית סופית — לקהלים מערביים ושיתף פעולה עם אדי ודר ופיטר גבריאל.",
    "rank": 127
  },
  {
    "id": "mu_corelli_concerti",
    "deck": "music",
    "title": "קורלי מפרסם את הקונצ׳רטי גרוסי",
    "start": 1714,
    "end": 1714,
    "date": "1714",
    "place": "רומא, איטליה",
    "lat": 41.899,
    "lon": 12.476,
    "desc": "ארקנג׳לו קורלי, מגדולי הכנרים והמלחינים של הבארוק, פרסם את ה״קונצ׳רטי גרוסי, אופוס 6״, שקבעו את המבנה של הקונצ׳רטו הבארוקי. עבודתו השפיעה ישירות על באך, הנדל וויוואלדי.",
    "rank": 128
  },
  {
    "id": "mu_garage_motown_stooges",
    "deck": "music",
    "title": "הסטוג׳ס מוציאים את אלבום הבכורה שלהם",
    "start": 1969,
    "end": 1969,
    "date": "1969",
    "place": "אן ארבור, מישיגן, ארצות הברית",
    "lat": 42.281,
    "lon": -83.748,
    "desc": "איגי פופ והסטוג׳ס הוציאו את ״The Stooges״, אלבום גולמי ואגרסיבי שקדם לפאנק בשבע שנים. ״I Wanna Be Your Dog״ השפיע על הריימונס, סקס פיסטולס ועל כל מה שיבוא. איגי נחשב ל״אבי הפאנק רוק״.",
    "rank": 129
  },
  {
    "id": "mu_ofra_haza_im_ninalu",
    "deck": "music",
    "title": "עפרה חזה מוציאה את ״אם ננעלו״",
    "start": 1984,
    "end": 1984,
    "date": "1984",
    "place": "תל אביב, ישראל",
    "lat": 32.064,
    "lon": 34.778,
    "desc": "עפרה חזה הוציאה את הגרסה המודרנית ל״אם ננעלו״, פיוט תימני שהפכה ללהיט בינלאומי ב-1988 ונכנס לעשירייה הפותחת באירופה. חזה, ילידת שכונת התקווה, הפכה לאמנית הישראלית הבינלאומית ביותר בהיסטוריה.",
    "rank": 130
  },
  {
    "id": "mu_mendelssohn_wedding",
    "deck": "music",
    "title": "מנדלסון מלחין את ״צעדת החתונה״",
    "start": 1842,
    "end": 1842,
    "date": "1842",
    "place": "ברלין, גרמניה",
    "lat": 52.516,
    "lon": 13.378,
    "desc": "פליקס מנדלסון הלחין את ״צעדת החתונה״ כחלק ממוזיקה תאטרלית ל״חלום ליל קיץ״ של שייקספיר. המנגינה הפכה למוזיקה הנודעת ביותר שנשמעת בטקסי חתונה בעולם המערבי, ומנדלסון — למלחין הרומנטי הקלאסי ביותר.",
    "rank": 131
  },
  {
    "id": "mu_daft_punk_discovery",
    "deck": "music",
    "title": "דאפט פאנק מוציאים את ״Discovery״",
    "start": 2001,
    "end": 2001,
    "date": "2001",
    "place": "פריז, צרפת",
    "lat": 48.862,
    "lon": 2.33,
    "desc": "הצמד הצרפתי דאפט פאנק הוציא את ״Discovery״, שמיזג האוס צרפתי עם דיסקו ופאנק. ״One More Time״ ו-״Harder, Better, Faster, Stronger״ הפכו ללהיטי ענק. דאפט פאנק, במסכות הרובוטים שלהם, הפכו אלקטרוניקה לפופ.",
    "rank": 132
  },
  {
    "id": "mu_cello_suites_bach",
    "deck": "music",
    "title": "באך מלחין את הסוויטות לצ׳לו סולו",
    "start": 1720,
    "end": 1720,
    "date": "בערך 1720",
    "place": "קטן, גרמניה",
    "lat": 51.754,
    "lon": 12.438,
    "desc": "באך חיבר שש סוויטות לצ׳לו ללא ליווי — יצירות שנחשבו לתרגילים טכניים עד שפאבלו קזאלס גילה אותן מחדש ב-1890 בחנות יד שנייה. הסוויטות נחשבות כיום לקנון המרכזי של ספרות הצ׳לו.",
    "rank": 133
  },
  {
    "id": "mu_talking_heads_remain",
    "deck": "music",
    "title": "טוקינג הדס מוציאים את ״Remain in Light״",
    "start": 1980,
    "end": 1980,
    "date": "1980",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.748,
    "lon": -73.986,
    "desc": "טוקינג הדס עם המפיק בריאן אינו הוציאו את ״Remain in Light״, שמיזג ניו ווייב עם מקצבי אפרוביט ופולירית׳מיקה. ״Once in a Lifetime״ הפך ללהיט עם קליפ חדשני, והאלבום נחשב לאחד המקוריים ביותר ברוק.",
    "rank": 134
  },
  {
    "id": "mu_strauss_blue_danube",
    "deck": "music",
    "title": "יוהן שטראוס מלחין את ״על גדות הדנובה הכחולה״",
    "start": 1867,
    "end": 1867,
    "date": "1867",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "יוהן שטראוס הבן, ״מלך הוואלס״, הלחין את ״על גדות הדנובה הכחולה״ — הוואלס הנודע ביותר בהיסטוריה. היצירה הפכה להמנון הבלתי רשמי של וינה ומבוצעת בכל ערב ראש השנה בקונצרט הפילהרמונית הווינאית.",
    "rank": 135
  },
  {
    "id": "mu_rossini_barber",
    "deck": "music",
    "title": "הבכורה של ״הספר מסביליה״ של רוסיני",
    "start": 1816,
    "end": 1816,
    "date": "1816",
    "place": "רומא, איטליה",
    "lat": 41.899,
    "lon": 12.476,
    "desc": "ג׳ואקינו רוסיני הציג את ״הספר מסביליה״ בתיאטרון ארג׳נטינה ברומא. למרות בכורה כושלת, הפכה האופרה הבופה לאחת מיצירות האופרה הנודעות ביותר. ״פיגארו, פיגארו, פיגארו!״ הפך לביטוי שגור בכל שפה.",
    "rank": 136
  },
  {
    "id": "mu_amy_winehouse_back",
    "deck": "music",
    "title": "איימי ויינהאוס מוציאה את ״Back to Black״",
    "start": 2006,
    "end": 2006,
    "date": "2006",
    "place": "לונדון, אנגליה",
    "lat": 51.522,
    "lon": -0.071,
    "desc": "איימי ויינהאוס מקמדן, לונדון, הוציאה את ״Back to Black״ שמיזג סואול של שנות ה-60 עם ג׳אז ופופ בריטי. קולה העוצמתי והטקסטים האישיים הפכו אותה לכוכבת עולמית. מותה בגיל 27 ב-2011 הצטרף לרשימת ה-27 הטראגית.",
    "rank": 137
  },
  {
    "id": "mu_gamelan_java",
    "deck": "music",
    "title": "תזמורת הגמלן בג׳אווה ובאלי",
    "start": 500,
    "end": 900,
    "date": "בערך ⁦500–900⁩ לספירה",
    "place": "יוגיאקרטה, אינדונזיה",
    "lat": -7.797,
    "lon": 110.361,
    "desc": "תזמורת הגמלן — אנסמבל של מתכות מוכות (גונגים, מטלופונים ותופים) — התפתחה בג׳אווה ובאלי כחלק מפולחן ומופעי חצר. דביוסי שמע גמלן בתערוכת פריז ב-1889 והשפעתה ניכרת ביצירותיו. הגמלן הוא מסורת מוזיקלית חיה ועשירה.",
    "rank": 138
  },
  {
    "id": "mu_israel_philharmonic",
    "deck": "music",
    "title": "הקמת התזמורת הפילהרמונית הישראלית",
    "start": 1936,
    "end": 1936,
    "date": "1936",
    "place": "תל אביב, ישראל",
    "lat": 32.064,
    "lon": 34.778,
    "desc": "הכנר ברוניסלב הוברמן ייסד את תזמורת ארץ ישראל (כיום הפילהרמונית הישראלית), ובכך הציל עשרות מוזיקאים יהודים מאירופה מפני הנאצים. ארטורו טוסקניני ניצח על הקונצרט הפותח. התזמורת הפכה לסמל תרבותי ישראלי מרכזי.",
    "rank": 139
  },
  {
    "id": "mu_grateful_dead_live",
    "deck": "music",
    "title": "הגרייטפול דד מופיעים לראשונה בסן פרנסיסקו",
    "start": 1966,
    "end": 1966,
    "date": "1966",
    "place": "סן פרנסיסקו, קליפורניה, ארצות הברית",
    "lat": 37.774,
    "lon": -122.419,
    "desc": "הגרייטפול דד בהנהגת ג׳רי גרסיה התחילו להופיע במסיבות ה-Acid Tests של קן קיזי בסן פרנסיסקו. הופעותיהם המאולתרות, שנמשכו שעות, יצרו תרבות של ״דדהדס״ — מעריצים שעקבו אחריהם מהופעה להופעה. מודל הופעות חיות כפרנסה.",
    "rank": 140
  },
  {
    "id": "mu_bernstein_west_side",
    "deck": "music",
    "title": "הבכורה של ״סיפור הפרברים״ של ברנסטיין",
    "start": 1957,
    "end": 1957,
    "date": "1957",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.762,
    "lon": -73.985,
    "desc": "לאונרד ברנסטיין, סטיבן סונדהיים וג׳רום רובינס הציגו את ״סיפור הפרברים״ (West Side Story) בברודווי. המחזמר העביר את ״רומיאו ויוליה״ לרחובות ניו יורק עם כנופיות, ושילב ג׳אז, לטינו ובלט בדרך שלא נעשתה לפניה.",
    "rank": 141
  },
  {
    "id": "mu_jay_z_blueprint",
    "deck": "music",
    "title": "ג׳יי-זי מוציא את ״The Blueprint״",
    "start": 2001,
    "end": 2001,
    "date": "2001",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "שון ״ג׳יי-זי״ קרטר מברוקלין הוציא את ״The Blueprint״, אלבום שהגדיר מחדש את ההיפ-הופ עם דגימות סואול וראפ מלוטש. ג׳יי-זי הפך מראפר למוגול עסקי — בעל לייבל, מועדונים ושותפות עם ביונסה — ולסמל של ההיפ-הופ כתעשייה.",
    "rank": 142
  },
  {
    "id": "mu_stradivari_violins",
    "deck": "music",
    "title": "תקופת הזהב של סטרדיווריוס",
    "start": 1700,
    "end": 1720,
    "date": "בערך ⁦1700–1720⁩",
    "place": "קרמונה, איטליה",
    "lat": 45.133,
    "lon": 10.025,
    "desc": "הלותייר האיטלקי אנטוניו סטרדיווארי הגיע לשיא מלאכתו וייצר את הכינורות הנודעים בהיסטוריה. עד היום לא הצליח איש לשחזר את סוד הצליל שלהם. כינור סטרדיווריוס נמכר היום במיליוני דולרים.",
    "rank": 143
  },
  {
    "id": "mu_bach_toccata",
    "deck": "music",
    "title": "באך מלחין את הטוקטה והפוגה ברה מינור",
    "start": 1708,
    "end": 1708,
    "date": "בערך 1708",
    "place": "ארנשטאט, גרמניה",
    "lat": 50.838,
    "lon": 10.947,
    "desc": "יוהאן סבסטיאן באך חיבר (ככל הנראה) את ״טוקטה ופוגה ברה מינור״ לעוגב, היצירה הנודעת ביותר ברפרטואר של כלי זה. הפתיחה הדרמטית הפכה לסמל של מוזיקה קלאסית בכלל ומושמעת בסרטי אימה, פרסומות והופעות.",
    "rank": 144
  },
  {
    "id": "mu_bts_dynamite",
    "deck": "music",
    "title": "BTS משיקים את ״Dynamite״ באנגלית",
    "start": 2020,
    "end": 2020,
    "date": "2020",
    "place": "סיאול, דרום קוריאה",
    "lat": 37.566,
    "lon": 126.978,
    "desc": "להקת הבנים הקוריאנית BTS הוציאה את ״Dynamite״, הסינגל הראשון שלהם באנגלית, שהגיע למקום הראשון בביל-בורד. הצלחתם ביססה את הקיי-פופ כתופעה עולמית, ו-ARMY — קהילת המעריצים שלהם — הפכה לכוח תרבותי בפני עצמו.",
    "rank": 145
  },
  {
    "id": "mu_mahalia_jackson_gospel",
    "deck": "music",
    "title": "מאהליה ג׳קסון שרה בוושינגטון",
    "start": 1963,
    "end": 1963,
    "date": "1963",
    "place": "וושינגטון, ארצות הברית",
    "lat": 38.889,
    "lon": -77.05,
    "desc": "מאהליה ג׳קסון, ״מלכת הגוספל״, שרה ליד אנדרטת לינקולן לפני נאום ״יש לי חלום״ של מרטין לותר קינג. ג׳קסון, שסירבה לשיר מוזיקה חילונית, הפכה את הגוספל לכוח של זכויות אזרח והשפיעה על אריתה פרנקלין וסואול שלם.",
    "rank": 146
  },
  {
    "id": "mu_gluck_orfeo",
    "deck": "music",
    "title": "הבכורה של ״אורפיאו ואאורידיצ׳ה״ של גלוק",
    "start": 1762,
    "end": 1762,
    "date": "1762",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "כריסטוף וויליבלד גלוק הציג את ״אורפיאו ואאורידיצ׳ה״ בוינה, שפתחה את רפורמת האופרה. גלוק דרש שהמוזיקה תשרת את הדרמה ולא את שרירת הזמרים, ובכך סלל את הדרך לוואגנר ולאופרה המודרנית.",
    "rank": 147
  },
  {
    "id": "mu_rap_sugarhill",
    "deck": "music",
    "title": "״Rapper's Delight״ של שוגרהיל גנג",
    "start": 1979,
    "end": 1979,
    "date": "1979",
    "place": "אנגלווד, ניו ג׳רזי, ארצות הברית",
    "lat": 40.893,
    "lon": -73.973,
    "desc": "שוגרהיל גנג הוציאו את ״Rapper's Delight״, נחשב לשיר ההיפ-הופ הראשון שנכנס למצעדים. הסינגל בן 15 הדקות, שדגם את קו הבאס של ״Good Times״ של שיק, הציג את הראפ לקהל המיינסטרים.",
    "rank": 148
  },
  {
    "id": "mu_gilberto_bossa",
    "deck": "music",
    "title": "ז׳ואאו ז׳ילברטו מוציא את ״Chega de Saudade״",
    "start": 1959,
    "end": 1959,
    "date": "1959",
    "place": "ריו דה ז׳נרו, ברזיל",
    "lat": -22.907,
    "lon": -43.173,
    "desc": "ז׳ואאו ז׳ילברטו הוציא את ״Chega de Saudade״ על מילותיו של ויניסיוס דה מוראאיס ומוזיקת אנטוניו קרלוס ז׳ובים — לידת הבוסה נובה. הסגנון שילב סמבה עם ג׳אז, והפך את ״הנערה מאיפנמה״ לאחד השירים המוקלטים ביותר בהיסטוריה.",
    "rank": 149
  },
  {
    "id": "mu_tango_buenos_aires",
    "deck": "music",
    "title": "הולדת הטנגו בבואנוס איירס",
    "start": 1880,
    "end": 1900,
    "date": "בערך ⁦1880–1900⁩",
    "place": "בואנוס איירס, ארגנטינה",
    "lat": -34.604,
    "lon": -58.382,
    "desc": "הטנגו נולד בשכונות המהגרים של בואנוס איירס, מיזוג של מקצבים אפריקאיים, הבנרה קובנית ומזורקה אירופית. מתחילתו כריקוד של סביבות נמוכות הפך לריקוד חצרנות מכובד שכבש את פריז ואת העולם.",
    "rank": 150
  },
  {
    "id": "mu_berry_maybellene",
    "deck": "music",
    "title": "צ׳אק ברי מקליט את ״Maybellene״",
    "start": 1955,
    "end": 1955,
    "date": "1955",
    "place": "שיקגו, אילינוי, ארצות הברית",
    "lat": 41.881,
    "lon": -87.623,
    "desc": "צ׳אק ברי הקליט את ״Maybellene״ באולפני צ׳ס רקורדס בשיקגו. הנגינה בגיטרה החשמלית ומילות השיר על מרוצי מכוניות הגדירו את הרוקנרול. ג׳ון לנון אמר: ״אם הייתם יכולים לתת לרוקנרול שם אחר, הייתם קוראים לו צ׳אק ברי.״",
    "rank": 151
  },
  {
    "id": "mu_electric_guitar",
    "deck": "music",
    "title": "לאו פנדר מציג את הגיטרה החשמלית Telecaster",
    "start": 1950,
    "end": 1950,
    "date": "1950",
    "place": "פולרטון, קליפורניה, ארצות הברית",
    "lat": 33.87,
    "lon": -117.924,
    "desc": "לאו פנדר ייצר את ה-Telecaster (בתחילה Broadcaster), הגיטרה החשמלית הסולידית המסחרית הראשונה. שלוש שנים מאוחר יותר הציג את ה-Stratocaster. שתי הגיטרות הפכו לכלי העבודה של הרוקנרול ועיצבו את צליל המאה ה-20.",
    "rank": 152
  },
  {
    "id": "mu_salieri_vienna",
    "deck": "music",
    "title": "סלייארי מתמנה למנצח חצר בוינה",
    "start": 1774,
    "end": 1774,
    "date": "1774",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "אנטוניו סלייארי התמנה למלחין חצר של הקיסר יוזף השני בוינה, עמדה שהחזיק בה 36 שנה. למד את שוברט, ליסט ובטהובן. הסרט ״אמדאוס״ הפך את היריבות בינו לבין מוצרט לאגדה, אך בפועל סלייארי היה מלחין מכובד ומוערך.",
    "rank": 153
  },
  {
    "id": "mu_penderecki_threnody",
    "deck": "music",
    "title": "פנדרצקי מלחין את ״תרנוס לקורבנות הירושימה״",
    "start": 1960,
    "end": 1960,
    "date": "1960",
    "place": "קרקוב, פולין",
    "lat": 50.065,
    "lon": 19.945,
    "desc": "קז׳ימייז׳ פנדרצקי חיבר ״תרנוס לקורבנות הירושימה״ ל-52 כלי מיתר — יצירה שהשתמשה בטכניקות חדשות כמו גלישות וחבטות על הכלים. צלילי החרדה של היצירה הופיעו בסרטי ״הניצוץ״ ו-״שנים עשר מאות״ של קובריק.",
    "rank": 154
  },
  {
    "id": "mu_paganini_caprices",
    "deck": "music",
    "title": "פגניני מפרסם את הקפריצ׳ות לכינור",
    "start": 1817,
    "end": 1817,
    "date": "1817",
    "place": "מילאנו, איטליה",
    "lat": 45.464,
    "lon": 9.191,
    "desc": "ניקולו פגניני פרסם את 24 הקפריצ׳ות לכינור סולו, יצירות בעלות קושי טכני שלא נתפס. פגניני, שהפגין יכולות כה מדהימות על הבמה עד שעלו שמועות שמכר את נשמתו לשטן, יצר סטנדרט חדש לוירטואוזיות וניגון תצוגתי.",
    "rank": 155
  },
  {
    "id": "mu_cabaret_weimar",
    "deck": "music",
    "title": "תרבות הקברט ברפובליקה של ויימאר",
    "start": 1920,
    "end": 1933,
    "date": "בערך ⁦1920–1933⁩",
    "place": "ברלין, גרמניה",
    "lat": 52.516,
    "lon": 13.378,
    "desc": "ברלין של שנות ה-20 הפכה לבירת הקברט, עם מופעים סטיריים ופרובוקטיביים במועדונים עשנים. קורט וייל וברטולט ברכט יצרו את ״אופרת שלוש הפרוטות״ (1928), ומרלנה דיטריך כבשה את העולם. תרבות זו השפיעה על מוזיקת הפופ עד בואי ובמדונה.",
    "rank": 156
  },
  {
    "id": "mu_muddy_waters_chicago",
    "deck": "music",
    "title": "מאדי ווטרס ממציא את הבלוז החשמלי בשיקגו",
    "start": 1948,
    "end": 1948,
    "date": "1948",
    "place": "שיקגו, אילינוי, ארצות הברית",
    "lat": 41.881,
    "lon": -87.623,
    "desc": "מאדי ווטרס, שעלה מהדלתא של מיסיסיפי לשיקגו, הקליט את ״I Can't Be Satisfied״ — מהשירים שהגדירו את הבלוז החשמלי. הוספת הגיטרה החשמלית, הבאס והתופים לבלוז יצרה את הצליל שממנו צמח הרוקנרול.",
    "rank": 157
  },
  {
    "id": "mu_minimalism_riley",
    "deck": "music",
    "title": "טרי ריילי מציג את ״In C״",
    "start": 1964,
    "end": 1964,
    "date": "1964",
    "place": "סן פרנסיסקו, קליפורניה, ארצות הברית",
    "lat": 37.774,
    "lon": -122.419,
    "desc": "טרי ריילי הציג את ״In C״, יצירה של 53 פרזות קצרות שכל מנגן מבצע בקצב שלו. היצירה נחשבת למייסדת המינימליזם המוזיקלי — תנועה שהשפיעה על פיליפ גלאס, סטיב רייך ועל מוזיקה אלקטרונית ואמביינט.",
    "rank": 158
  },
  {
    "id": "mu_cure_disintegration",
    "deck": "music",
    "title": "הקיור מוציאים את ״Disintegration״",
    "start": 1989,
    "end": 1989,
    "date": "1989",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "רוברט סמית׳ והקיור הוציאו את ״Disintegration״, אלבום גות-רוק אטמוספרי שמיזג מלנכוליה, רברב עמוק ופופ אפלולי. ״Lovesong״ הפך ללהיט גדול, והאלבום ביסס את הקיור כלהקה שמגשרת בין אנדרגראונד למיינסטרים.",
    "rank": 159
  },
  {
    "id": "mu_berlioz_symphonie_fantastique",
    "deck": "music",
    "title": "הבכורה של ״הסימפוניה הפנטסטית״ של ברליוז",
    "start": 1830,
    "end": 1830,
    "date": "1830",
    "place": "פריז, צרפת",
    "lat": 48.862,
    "lon": 2.33,
    "desc": "הקטור ברליוז הציג את ״הסימפוניה הפנטסטית״, שמספרת בצלילים על אמן שמנסה להתאבד בגלל אהבה חד-צדדית. היצירה הפכה את התזמורת לכלי סיפורי, המציאה את ה-idée fixe (מנגינה חוזרת) ופתחה את המוזיקה הפרוגרמטית.",
    "rank": 160
  },
  {
    "id": "mu_sabbath_paranoid",
    "deck": "music",
    "title": "בלאק סבאת׳ מוציאים את ״Paranoid״",
    "start": 1970,
    "end": 1970,
    "date": "1970",
    "place": "ברמינגהם, אנגליה",
    "lat": 52.483,
    "lon": -1.894,
    "desc": "בלאק סבאת׳ הוציאו את ״Paranoid״ חודשים ספורים אחרי אלבום הבכורה. שיר הכותרת, ״War Pigs״ ו-״Iron Man״ ביססו את ההבי מטאל כז׳אנר עם ריפים כבדים, מילים אפוקליפטיות וצליל שחור. האלבום מכר מיליוני עותקים.",
    "rank": 161
  },
  {
    "id": "mu_dvorak_cello",
    "deck": "music",
    "title": "הבכורה של הקונצ׳רטו לצ׳לו של דבורז׳אק",
    "start": 1896,
    "end": 1896,
    "date": "1896",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "אנטונין דבורז׳אק הציג את הקונצ׳רטו לצ׳לו בסי מינור, שנחשב לגדול בכל קונצ׳רטי הצ׳לו. בראמס, ששמע את היצירה, אמר: ״לו ידעתי שאפשר לכתוב קונצ׳רטו כזה לצ׳לו, הייתי כותב אחד בעצמי מזמן.״",
    "rank": 162
  },
  {
    "id": "mu_gershwin_rhapsody",
    "deck": "music",
    "title": "הבכורה של ״רפסודיה בכחול״ של גרשווין",
    "start": 1924,
    "end": 1924,
    "date": "1924",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "ג׳ורג׳ גרשווין הציג את ״רפסודיה בכחול״ עם תזמורתו של פול ווייטמן באולם איאוליאן. היצירה, שפותחת בגליסנדו מפורסם של קלרינט, מיזגה ג׳אז ומוזיקה קלאסית ויצרה סגנון אמריקאי ייחודי.",
    "rank": 163
  },
  {
    "id": "mu_cape_jazz",
    "deck": "music",
    "title": "עבדאללה אבראהים והג׳אז של קייפ טאון",
    "start": 1968,
    "end": 1968,
    "date": "בערך 1968",
    "place": "קייפ טאון, דרום אפריקה",
    "lat": -33.925,
    "lon": 18.424,
    "desc": "הפסנתרן עבדאללה אבראהים (דולר בראנד) הגלה מדרום אפריקה בשל האפרטהייד ויצר ג׳אז שמיזג מנגינות של מלאיים, קהילה ״צבעונית״ ותעצומות נפש אפריקאיות. הפך לאחד מגדולי הג׳אז של אפריקה ולסמל של מאבק באפרטהייד.",
    "rank": 164
  },
  {
    "id": "mu_cage_433",
    "deck": "music",
    "title": "ג׳ון קייג׳ מציג את ״4׳33״",
    "start": 1952,
    "end": 1952,
    "date": "1952",
    "place": "וודסטוק, ניו יורק, ארצות הברית",
    "lat": 42.04,
    "lon": -74.118,
    "desc": "ג׳ון קייג׳ הציג את ״4 דקות ו-33 שניות״ — יצירה שבה הפסנתרן יושב בדממה ולא מנגן דבר. היצירה הפכה את רעשי הסביבה למוזיקה ושינתה את ההגדרה של מה נחשב מוזיקה. קייג׳ הפך לדמות מרכזית באוואנגרד.",
    "rank": 165
  },
  {
    "id": "mu_monk_brilliant",
    "deck": "music",
    "title": "תלוניוס מונק מוציא את ״Brilliant Corners״",
    "start": 1957,
    "end": 1957,
    "date": "1957",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "תלוניוס מונק הוציא את ״Brilliant Corners״, אלבום כה מורכב שהלהקה לא הצליחה לנגן את שיר הכותרת בשלמותו, והוא הורכב מכמה טייקים. סונני רולינס וסלן ההולידיי השתתפו בהקלטה. מונק ביסס את הסגנון הזוויתי שהפך לחתימתו.",
    "rank": 166
  },
  {
    "id": "mu_new_wave_blondie",
    "deck": "music",
    "title": "בלונדי מוציאים את ״Parallel Lines״",
    "start": 1978,
    "end": 1978,
    "date": "1978",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.726,
    "lon": -73.99,
    "desc": "בלונדי הוציאו את ״Parallel Lines״ ובו ״Heart of Glass״ — דיסקו-פאנק שפרץ למקום הראשון במצעדים. דבורה הארי הפכה לאייקונית של הניו ווייב, ובלונדי סימנו את המעבר מהפאנק של CBGB למוזיקה פופולרית ורחבה.",
    "rank": 167
  },
  {
    "id": "mu_organ_hydraulis",
    "deck": "music",
    "title": "המצאת ההידראוליס — העוגב המימי",
    "start": -250,
    "end": -250,
    "date": "בערך 250 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.198,
    "lon": 29.919,
    "desc": "קטסיביוס מאלכסנדריה המציא את ההידראוליס — עוגב שהפעיל צינורות באמצעות לחץ מים. הכלי היה פופולרי בזירות הרומיות ובביזנטיון. מההידראוליס התפתח העוגב הכנסייתי שהפך לכלי הנגינה הגדול והמורכב ביותר ולסמל מוזיקלי של הכנסייה.",
    "rank": 168
  },
  {
    "id": "mu_ladysmith_graceland",
    "deck": "music",
    "title": "פול סיימון מוציא את ״Graceland״",
    "start": 1986,
    "end": 1986,
    "date": "1986",
    "place": "יוהנסבורג, דרום אפריקה",
    "lat": -26.205,
    "lon": 28.049,
    "desc": "פול סיימון הקליט את ״Graceland״ עם מוזיקאים מדרום אפריקה, כולל לידיסמית׳ בלאק ממבזו. האלבום מיזג פופ מערבי עם צלילים אפריקאיים, אך עורר ביקורת על הפרת החרם על דרום אפריקה. הוא זכה בגראמי והפך לקלאסיקה.",
    "rank": 169
  },
  {
    "id": "mu_opera_seria_naples",
    "deck": "music",
    "title": "עידן האופרה סריה בנאפולי",
    "start": 1720,
    "end": 1760,
    "date": "בערך ⁦1720–1760⁩",
    "place": "נאפולי, איטליה",
    "lat": 40.852,
    "lon": 14.268,
    "desc": "נאפולי הפכה למרכז האופרה האירופית עם הקונסרבטוריונים שלה, שהכשירו את הזמרים הגדולים ביותר — כולל הקסטרטים. אלסנדרו סקרלאטי, לאונרדו ויינצ׳י ופרגולזי יצרו את צורת האופרה סריה שואגנר ימרוד בה מאה שנה מאוחר יותר.",
    "rank": 170
  },
  {
    "id": "mu_radiohead_kid_a",
    "deck": "music",
    "title": "רדיוהד מוציאים את ״Kid A״",
    "start": 2000,
    "end": 2000,
    "date": "2000",
    "place": "אוקספורד, אנגליה",
    "lat": 51.752,
    "lon": -1.258,
    "desc": "רדיוהד הוציאו את ״Kid A״, שנטש את הגיטרות לטובת אלקטרוניקה, אמביינט ועיבודים דיגיטליים. האלבום הדהים — להקת רוק מצליחה שהחליטה לשבור הכול. הוכיח שאלבום ניסיוני יכול להגיע למקום הראשון בביל-בורד.",
    "rank": 171
  },
  {
    "id": "mu_country_carter_family",
    "deck": "music",
    "title": "משפחת קרטר מקליטה בבריסטול",
    "start": 1927,
    "end": 1927,
    "date": "1927",
    "place": "בריסטול, טנסי, ארצות הברית",
    "lat": 36.595,
    "lon": -82.189,
    "desc": "משפחת קרטר וג׳ימי רוג׳רס הקליטו בהקלטות בריסטול של ויקטור — רגע שנחשב ל״מפץ הגדול של מוזיקת הקאנטרי״. השירים הכפריים, על פי בלדות בריטיות ומנגינות אפלצ׳יות, הגדירו ז׳אנר שעדיין הוא הפופולרי ביותר בארצות הברית.",
    "rank": 172
  },
  {
    "id": "mu_synthesizer_moog",
    "deck": "music",
    "title": "רוברט מוג מציג את הסינתיסייזר",
    "start": 1964,
    "end": 1964,
    "date": "1964",
    "place": "טרומנסבורג, ניו יורק, ארצות הברית",
    "lat": 42.542,
    "lon": -76.659,
    "desc": "רוברט מוג הציג את סינתיסייזר המוג, כלי אלקטרוני שיצר צלילים חדשים לחלוטין. ״Switched-On Bach״ של ונדי קרלוס ב-1968 הפגין את פוטנציאל הכלי. הסינתיסייזר שינה את המוזיקה הפופולרית והקלאסית ופתח את עידן המוזיקה האלקטרונית.",
    "rank": 173
  },
  {
    "id": "mu_hindustani_raga",
    "deck": "music",
    "title": "התגבשות מערכת הראגה בצפון הודו",
    "start": 1200,
    "end": 1400,
    "date": "בערך ⁦1200–1400⁩ לספירה",
    "place": "דלהי, הודו",
    "lat": 28.613,
    "lon": 77.209,
    "desc": "בתקופת סולטנות דלהי התגבשה מערכת הראגה ההינדוסטנית — סדרות מלודיות עם כללי אלתור, הבנויות על שעות היום ומצבי רוח. המוזיקה ההודית הקלאסית, עם הסיטאר והטבלה, הפכה למסורת חיה שעדיין מתפתחת.",
    "rank": 174
  },
  {
    "id": "mu_lauryn_hill_miseducation",
    "deck": "music",
    "title": "לורין היל מוציאה את ״The Miseducation of Lauryn Hill״",
    "start": 1998,
    "end": 1998,
    "date": "1998",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "לורין היל, ידועה מלהקת הפיוג׳יס, הוציאה אלבום סולו שמיזג היפ-הופ, R&B, רגאיי וסואול. האלבום זכה בחמישה גראמי וביסס את היל כקול נשי ושחור ייחודי שעסק באמהות, אהבה ואמונה בכנות יוצאת דופן.",
    "rank": 175
  },
  {
    "id": "mu_bruckner_9th",
    "deck": "music",
    "title": "הבכורה של הסימפוניה התשיעית של ברוקנר",
    "start": 1903,
    "end": 1903,
    "date": "1903",
    "place": "וינה, אוסטריה",
    "lat": 48.203,
    "lon": 16.375,
    "desc": "הסימפוניה התשיעית של אנטון ברוקנר, שנותרה ללא פרק רביעי עקב מותו, בוצעה לראשונה בוינה. ברוקנר הקדיש אותה ״לאל הטוב״. הסימפוניות האדירות שלו, שדורשות תזמורות ענקיות, מהוות את גולת הכותרת של הרומנטיקה הדתית.",
    "rank": 176
  },
  {
    "id": "mu_edith_piaf",
    "deck": "music",
    "title": "אדית פיאף שרה את ״לא ראי דה ריין״",
    "start": 1960,
    "end": 1960,
    "date": "1960",
    "place": "פריז, צרפת",
    "lat": 48.862,
    "lon": 2.33,
    "desc": "אדית פיאף, ״הדרור הקטן של פריז״, שרה את ״Non, je ne regrette rien״ שהפך להמנון שלה ולסמל של שאנסון צרפתית. קולה העוצמתי וסיפור חייה הטראגיים — יתומה מרחוב שהפכה לנערצת של אומה — הפכו אותה לסמל של צרפת.",
    "rank": 177
  },
  {
    "id": "mu_outkast_stankonia",
    "deck": "music",
    "title": "אאוטקאסט מוציאים את ״Stankonia״",
    "start": 2000,
    "end": 2000,
    "date": "2000",
    "place": "אטלנטה, ג׳ורג׳יה, ארצות הברית",
    "lat": 33.749,
    "lon": -84.388,
    "desc": "אנדרה 3000 וביג בוי מאטלנטה הוציאו את ״Stankonia״, שמיזג ראפ דרומי עם פאנק, רוק ואלקטרוניקה. ״B.O.B.״ ו-״Ms. Jackson״ הפכו ללהיטים, ואאוטקאסט הוכיחו שהיפ-הופ מהדרום יכול להיות חדשני כמו מניו יורק.",
    "rank": 178
  },
  {
    "id": "mu_griot_west_africa",
    "deck": "music",
    "title": "מסורת הגריאו במערב אפריקה",
    "start": 1200,
    "end": 1400,
    "date": "בערך ⁦1200–1400⁩ לספירה",
    "place": "טימבוקטו, מאלי",
    "lat": 16.774,
    "lon": -3.009,
    "desc": "בממלכות מערב אפריקה — מאלי, סונגהאי, מנדינקה — פעלו הגריאו: משוררים-היסטוריונים-מוזיקאים שנשאו את ההיסטוריה בעל פה. כלי הקורה (הארפה האפריקאית) מלווה את סיפוריהם. מסורת הגריאו חיה עד היום, ונחשבת לשורש הראפ.",
    "rank": 179
  },
  {
    "id": "mu_sibelius_finlandia",
    "deck": "music",
    "title": "סיבליוס מלחין את ״פינלנדיה״",
    "start": 1899,
    "end": 1899,
    "date": "1899",
    "place": "הלסינקי, פינלנד",
    "lat": 60.17,
    "lon": 24.938,
    "desc": "יאן סיבליוס הלחין את הפואמה הסימפונית ״פינלנדיה״ כמחאה נגד השלטון הרוסי. היצירה הפכה להמנון הלאומי הבלתי רשמי של פינלנד וסימלה את הכוח של מוזיקה כנשק לשחרור לאומי.",
    "rank": 180
  },
  {
    "id": "mu_bb_king_thrill",
    "deck": "music",
    "title": "בי.בי. קינג מקליט את ״The Thrill Is Gone״",
    "start": 1969,
    "end": 1969,
    "date": "1969",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "בי.בי. קינג הקליט את ״The Thrill Is Gone״ עם עיבוד מיתרים שהביא את הבלוז לקהל חדש. קינג, עם הגיטרה ״לוסיל״ שלו, הפך ל״מלך הבלוז״ ונחשב לאחד הגיטריסטים המשפיעים ביותר בהיסטוריה — השראה ישירה של קלפטון, הנדריקס ומאייר.",
    "rank": 181
  },
  {
    "id": "mu_sufi_whirling",
    "deck": "music",
    "title": "מוזיקת הדרווישים המסתחררים",
    "start": 1270,
    "end": 1270,
    "date": "בערך 1270 לספירה",
    "place": "קוניה, טורקיה",
    "lat": 37.871,
    "lon": 32.493,
    "desc": "ג׳לאל א-דין רומי ייסד את מסדר המולוויה בקוניה, שם התפתח הסמאע — טקס רוחני בו הדרווישים מסתחררים לצלילי חליל הניי והתופים. מוזיקת המולוויה, שמשלבת מדיטציה עם אקסטזה, היא מהמסורות המוזיקליות הסופיות החשובות ביותר.",
    "rank": 182
  },
  {
    "id": "mu_philip_glass_koyaanisqatsi",
    "deck": "music",
    "title": "גלאס מלחין את המוזיקה ל-״Koyaanisqatsi״",
    "start": 1982,
    "end": 1982,
    "date": "1982",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "פיליפ גלאס חיבר את פס הקול המינימליסטי לסרט ״Koyaanisqatsi״ של גודפרי רג׳ו — סרט ללא מילים על יחסי אדם-טבע. המוזיקה החזרתית ההיפנוטית הגדירה צליל חדש לקולנוע והביאה את המינימליזם לקהל רחב.",
    "rank": 183
  },
  {
    "id": "mu_caruso_recordings",
    "deck": "music",
    "title": "אנריקו קרוזו מתחיל להקליט",
    "start": 1902,
    "end": 1902,
    "date": "1902",
    "place": "מילאנו, איטליה",
    "lat": 45.464,
    "lon": 9.191,
    "desc": "הטנור האיטלקי אנריקו קרוזו הקליט את תקליטיו הראשונים עבור חברת גרמופון בלונדון. קרוזו היה האמן הראשון שמכר מיליון תקליטים, והוכיח שאפשר להרוויח ממוזיקה מוקלטת. הוא הפך לזמר הנודע ביותר בעולם.",
    "rank": 184
  },
  {
    "id": "mu_boulez_marteau",
    "deck": "music",
    "title": "בולז מלחין את ״הפטיש ללא אדון״",
    "start": 1955,
    "end": 1955,
    "date": "1955",
    "place": "באדן באדן, גרמניה",
    "lat": 48.762,
    "lon": 8.241,
    "desc": "פייר בולז הלחין את ״Le marteau sans maître״, יצירה סריאלית על שירי רנה שאר. היצירה מיזגה סריאליזם עם צלילים מוזיקליים מבאלי ואפריקה, ונחשבת ליצירה המרכזית של האוואנגרד אחרי המלחמה.",
    "rank": 185
  },
  {
    "id": "mu_korngold_robin_hood",
    "deck": "music",
    "title": "קורנגולד מלחין את המוזיקה ל״הרפתקאות רובין הוד״",
    "start": 1938,
    "end": 1938,
    "date": "1938",
    "place": "הוליווד, קליפורניה, ארצות הברית",
    "lat": 34.098,
    "lon": -118.327,
    "desc": "אריך וולפגנג קורנגולד, שברח מוינה הנאצית, הלחין את המוזיקה ל״הרפתקאות רובין הוד״ וזכה באוסקר. קורנגולד המציא את שפת ההוליווד הסימפונית שהשפיעה ישירות על ג׳ון ויליאמס ועל כל מוזיקת הקולנוע שאחריו.",
    "rank": 186
  },
  {
    "id": "mu_africa_70_afrobeat",
    "deck": "music",
    "title": "לידת האפרוביט בלאגוס",
    "start": 1970,
    "end": 1970,
    "date": "בערך 1970",
    "place": "לאגוס, ניגריה",
    "lat": 6.524,
    "lon": 3.379,
    "desc": "פלא קוטי עם להקת Africa 70 יצר את האפרוביט — מיזוג של היי-לייף ניגרי, פאנק אמריקאי וג׳אז, עם טקסטים פוליטיים חריפים. מועדון ״שריין״ בלאגוס הפך למרכז מוזיקלי ומחאה נגד שלטון צבאי ניגרי.",
    "rank": 187
  },
  {
    "id": "mu_springsteen_born",
    "deck": "music",
    "title": "ברוס ספרינגסטין מוציא את ״Born to Run״",
    "start": 1975,
    "end": 1975,
    "date": "1975",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "ברוס ספרינגסטין מניו ג׳רזי הוציא את ״Born to Run״, שהעלה אותו על שערי טיים וניוזוויק באותו שבוע. שיר הכותרת על רצון לברוח מעיירה קטנה הפך להמנון של מעמד הפועלים האמריקאי, ו״הבוס״ — לאחד מגדולי הרוק.",
    "rank": 188
  },
  {
    "id": "mu_smith_horses",
    "deck": "music",
    "title": "פטי סמית׳ מוציאה את ״Horses״",
    "start": 1975,
    "end": 1975,
    "date": "1975",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.726,
    "lon": -73.99,
    "desc": "פטי סמית׳, ״סמכת המטרנית של הפאנק״, הוציאה את ״Horses״ — אלבום שמיזג שירה, רוק ואנרגיה גולמית. הפתיחה ״Jesus died for somebody's sins but not mine״ הכריזה על כוח נשי בלתי מתפשר ברוק.",
    "rank": 189
  },
  {
    "id": "mu_miriam_makeba",
    "deck": "music",
    "title": "מרים מקבה שרה את ״פטה פטה״",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "מרים מקבה, ״מאמא אפריקה״, הוציאה את ״פטה פטה״ בארצות הברית, שהפך ללהיט עולמי. מקבה, שגורשה מדרום אפריקה בגלל האפרטהייד, השתמשה במוזיקה כנשק למאבק ונשאה את קולות אפריקה לכל העולם.",
    "rank": 190
  },
  {
    "id": "mu_stockhausen_gesang",
    "deck": "music",
    "title": "שטוקהאוזן מלחין את ״שירת הנערים״",
    "start": 1956,
    "end": 1956,
    "date": "1956",
    "place": "קלן, גרמניה",
    "lat": 50.938,
    "lon": 6.956,
    "desc": "קרלהיינץ שטוקהאוזן יצר את ״Gesang der Jünglinge״, יצירה פורצת דרך שמיזגה קול של ילד שר עם צלילים אלקטרוניים. היא נחשבת ליצירה הראשונה שהשיגה מיזוג אמיתי של קול ואלקטרוניקה, ועיצבה את עולם הצלילים של המאה.",
    "rank": 191
  },
  {
    "id": "mu_miles_bitches_brew",
    "deck": "music",
    "title": "מיילס דייוויס מוציא את ״Bitches Brew״",
    "start": 1970,
    "end": 1970,
    "date": "1970",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "מיילס דייוויס הוציא את ״Bitches Brew״, אלבום כפול שמיזג ג׳אז עם רוק, פאנק ואלקטרוניקה. האלבום המציא את הג׳אז-פיוז׳ן ועורר מחלוקת בקרב פוריסטים, אך הפך לאחד האלבומים המשפיעים ביותר בהיסטוריית המוזיקה.",
    "rank": 192
  },
  {
    "id": "mu_afro_cuban_jazz",
    "deck": "music",
    "title": "מצ׳יטו והולדת הג׳אז האפרו-קובני",
    "start": 1943,
    "end": 1943,
    "date": "בערך 1943",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "מצ׳יטו (פרנק גריו) ותזמורתו הציגו בניו יורק את שילוב הג׳אז עם מקצבים אפרו-קובניים. הפגישה בין מוזיקאי קובה, פורטו ריקו וג׳אזיסטים אמריקאים יצרה את הסלסה ואת הלטין ג׳אז — שני ענפים שמעצבים מוזיקה עד היום.",
    "rank": 193
  },
  {
    "id": "mu_hurrian_hymn",
    "deck": "music",
    "title": "ההמנון ההורי: היצירה המתועדת העתיקה ביותר",
    "start": -1400,
    "end": -1400,
    "date": "בערך 1400 לפנה״ס",
    "place": "אוגרית, סוריה",
    "lat": 35.601,
    "lon": 35.786,
    "desc": "לוח חרס מאוגרית (רס שמרה, סוריה) נושא את ״ההמנון ההורי מס׳ 6״ — כתב תווים עתיק ביותר של מנגינה שלמה. הטקסט הוא המנון לאלת הירח ניקאל, ומפענוחו עולה מנגינה דיאטונית — עדות לתחכום מוזיקלי של העת העתיקה.",
    "rank": 194
  },
  {
    "id": "mu_ornette_coleman_free",
    "deck": "music",
    "title": "אורנט קולמן מוציא את ״Free Jazz״",
    "start": 1961,
    "end": 1961,
    "date": "1961",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.764,
    "lon": -73.98,
    "desc": "הסקסופוניסט אורנט קולמן הוציא את ״Free Jazz: A Collective Improvisation״, אלתור חופשי בן 37 דקות של קוורטט כפול. האלבום פתח את דרך הג׳אז החופשי שבו אין הרמוניות, מבנה או קצב קבועים — חופש מוחלט.",
    "rank": 195
  },
  {
    "id": "mu_tallis_spem",
    "deck": "music",
    "title": "תומאס טאליס מלחין את ״Spem in alium״",
    "start": 1570,
    "end": 1570,
    "date": "בערך 1570",
    "place": "לונדון, אנגליה",
    "lat": 51.507,
    "lon": -0.127,
    "desc": "תומאס טאליס חיבר את המוטט ״Spem in alium״ ל-40 קולות עצמאיים — שמונה מקהלות של חמישה קולות. היצירה נחשבת לפסגת הפוליפוניה של הרנסנס האנגלי ונשמעת היום גם בתערוכות אמנות ובמיצבי קול.",
    "rank": 196
  },
  {
    "id": "mu_napster_launch",
    "deck": "music",
    "title": "השקת נאפסטר",
    "start": 1999,
    "end": 1999,
    "date": "1999",
    "place": "בוסטון, מסצ׳וסטס, ארצות הברית",
    "lat": 42.36,
    "lon": -71.059,
    "desc": "שון פאנינג בן ה-19 השיק את נאפסטר, שירות שיתוף קבצים שאפשר הורדת מוזיקה בחינם. תוך חודשים הצטרפו עשרות מיליוני משתמשים, ותעשיית המוזיקה תבעה. נאפסטר נסגר ב-2001, אך שינה לצמיתות את הדרך שבה עולם צורך מוזיקה.",
    "rank": 197
  },
  {
    "id": "mu_satie_gymnopedies",
    "deck": "music",
    "title": "סאטי מלחין את ה״ג׳ימנופדי״",
    "start": 1888,
    "end": 1888,
    "date": "1888",
    "place": "פריז, צרפת",
    "lat": 48.862,
    "lon": 2.33,
    "desc": "אריק סאטי חיבר שלוש ״ג׳ימנופדי״ לפסנתר — יצירות פשוטות, שקטות ועדינות שעמדו בניגוד מוחלט לפאר הרומנטי. סאטי, אקסצנטרי שחי בעוני, קדם למינימליזם ולמוזיקת אמביינט בעשרות שנים.",
    "rank": 198
  },
  {
    "id": "mu_arik_sa_le_at",
    "deck": "music",
    "title": "אריק איינשטיין שר את ״סע לאט״",
    "start": 1971,
    "end": 1971,
    "date": "1971",
    "place": "תל אביב, ישראל",
    "lat": 32.064,
    "lon": 34.778,
    "desc": "אריק איינשטיין, ״המלך״ של המוזיקה הישראלית, הוציא את ״סע לאט סע לאט״ על מילותיו של יונתן גפן ומוזיקת שלום חנוך. השיר הפך לשיר ישראלי מהנודעים ביותר וביטא את הצד הרגוע, האנושי והלא-אידאולוגי של הישראליות.",
    "rank": 199
  },
  {
    "id": "mu_rossini_william_tell",
    "deck": "music",
    "title": "הבכורה של ״וילהלם טל״ של רוסיני",
    "start": 1829,
    "end": 1829,
    "date": "1829",
    "place": "פריז, צרפת",
    "lat": 48.862,
    "lon": 2.33,
    "desc": "ג׳ואקינו רוסיני הציג את אופרתו האחרונה ״וילהלם טל״ (גיום טל) בפריז. הפתיחה — במיוחד הגאלופ המסיים — הפכה לאחת מיצירות המוזיקה הקלאסית המוכרות ביותר בתרבות הפופולרית, ומושמעת בכל הקשר של מרוץ, הרפתקאות ומהירות.",
    "rank": 200
  },
  {
    "id": "jh_independence",
    "deck": "jewish",
    "title": "הכרזת העצמאות של מדינת ישראל",
    "start": 1948,
    "end": 1948,
    "date": "1948",
    "place": "תל אביב, ישראל",
    "lat": 32.063,
    "lon": 34.774,
    "desc": "דוד בן־גוריון הקריא את מגילת העצמאות בבניין מוזיאון תל אביב ביום שישי אחר הצהריים, שעות לפני כניסת השבת. בלילה שאחריו פלשו צבאות חמש מדינות ערביות לשטחי המדינה החדשה. ההכרזה סימנה את סיום המנדט הבריטי ואת הקמת המדינה היהודית הראשונה אחרי כאלפיים שנה.",
    "rank": 1
  },
  {
    "id": "jh_second_temple_destruction",
    "deck": "jewish",
    "title": "חורבן בית המקדש השני",
    "start": 70,
    "end": 70,
    "date": "70 לספירה",
    "place": "ירושלים, ישראל",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "הלגיונות הרומיים בפיקוד טיטוס כבשו את ירושלים והחריבו את בית המקדש השני בתשעה באב. רבבות יהודים נהרגו, נמכרו לעבדות או נמלטו. החורבן שינה את היהדות מדת מקדש לדת של תפילה, לימוד ובתי כנסת, ותשעה באב נותר יום האבל המרכזי בלוח היהודי.",
    "rank": 2
  },
  {
    "id": "jh_holocaust",
    "deck": "jewish",
    "title": "השואה — רצח יהודי אירופה",
    "start": 1941,
    "end": 1945,
    "date": "⁦1941–1945⁩",
    "place": "אירופה",
    "lat": 52.23,
    "lon": 21.01,
    "desc": "המשטר הנאצי ובעלי בריתו רצחו כשישה מיליון יהודים באירועי ההשמדה השיטתית הגדולים בהיסטוריה. הרצח בוצע ביריות המוניות, במחנות השמדה ובצעדות מוות. השואה שינתה את פני העם היהודי לעד והשפיעה עמוקות על הקמת מדינת ישראל.",
    "rank": 3
  },
  {
    "id": "jh_exodus",
    "deck": "jewish",
    "title": "יציאת מצרים",
    "start": -1250,
    "end": -1250,
    "date": "בערך המאה ה־13 לפנה״ס",
    "place": "סיני, מצרים",
    "lat": 28.55,
    "lon": 33.97,
    "desc": "לפי המסורת, משה רבנו הוציא את בני ישראל מעבדות במצרים, חצה עימם את ים סוף ונדד ארבעים שנה במדבר. יציאת מצרים היא הסיפור המכונן של העם היהודי ובסיס חג הפסח. ההיסטוריונים חלוקים על פרטיו, אך ההשפעה התרבותית עצומה.",
    "rank": 4
  },
  {
    "id": "jh_six_day_war",
    "deck": "jewish",
    "title": "מלחמת ששת הימים",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "ישראל, סיני, רמת הגולן",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "ישראל תקפה את מצרים, ירדן וסוריה בתגובה לריכוזי כוחות וסגירת מצרי טיראן, וכבשה תוך שישה ימים את סיני, רצועת עזה, הגדה המערבית, ירושלים המזרחית ורמת הגולן. איחוד ירושלים הפך לסמל לאומי, ושאלת השטחים שנכבשו מעצבת את המציאות עד היום.",
    "rank": 5
  },
  {
    "id": "jh_ten_commandments",
    "deck": "jewish",
    "title": "מעמד הר סיני ומתן תורה",
    "start": -1250,
    "end": -1250,
    "date": "בערך המאה ה־13 לפנה״ס",
    "place": "הר סיני, סיני",
    "lat": 28.539,
    "lon": 33.975,
    "desc": "לפי המסורת היהודית, הקב״ה נתן את עשרת הדיברות ואת התורה למשה על הר סיני, שבעה שבועות אחרי יציאת מצרים. מעמד הר סיני הוא הבסיס לברית בין אלוהים לעם ישראל, ומתוכו נובעת מערכת המצוות וההלכה. חג השבועות מציין אירוע זה.",
    "rank": 6
  },
  {
    "id": "jh_first_temple_destruction",
    "deck": "jewish",
    "title": "חורבן בית המקדש הראשון והגלות לבבל",
    "start": -586,
    "end": -586,
    "date": "586 לפנה״ס",
    "place": "ירושלים, ישראל",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "נבוכדנאצר מלך בבל כבש את ירושלים, החריב את בית המקדש שבנה שלמה והגלה את רוב תושבי יהודה לבבל. הגלות יצרה את הדפוס הראשון של קיום יהודי בגולה. על נהרות בבל, שם ישבו וגם בכו, נולדה היהדות כדת שאינה תלויה במקדש.",
    "rank": 7
  },
  {
    "id": "jh_yom_kippur",
    "deck": "jewish",
    "title": "מלחמת יום הכיפורים",
    "start": 1973,
    "end": 1973,
    "date": "1973",
    "place": "סיני ורמת הגולן, ישראל",
    "lat": 31.5,
    "lon": 34.5,
    "desc": "מצרים וסוריה תקפו בהפתעה ביום הכיפורים. צה״ל ספג מכה קשה בימים הראשונים אך הצליח לגבש מתקפת נגד, חצה את תעלת סואץ וכיתר חלק מהצבא המצרי. המלחמה הסתיימה בהפסקת אש ולאחריה נפתח תהליך השלום עם מצרים. היא גם הובילה לטלטלה פוליטית עמוקה בישראל.",
    "rank": 8
  },
  {
    "id": "jh_masada",
    "deck": "jewish",
    "title": "נפילת מצדה",
    "start": 73,
    "end": 73,
    "date": "73 לספירה",
    "place": "מצדה, ישראל",
    "lat": 31.316,
    "lon": 35.354,
    "desc": "לאחר מצור ממושך, כבשו הרומאים את מצדה, המבצר האחרון של המורדים היהודים. לפי יוסף בן מתתיהו, תושבי המצדה בחרו להתאבד מאשר ליפול בשבי. סיפור מצדה הפך לסמל של גבורה וחירות בתרבות הישראלית.",
    "rank": 9
  },
  {
    "id": "jh_bar_kokhba",
    "deck": "jewish",
    "title": "מרד בר כוכבא",
    "start": 132,
    "end": 135,
    "date": "⁦132–135⁩ לספירה",
    "place": "יהודה, ישראל",
    "lat": 31.7,
    "lon": 35.1,
    "desc": "שמעון בר כוכבא הנהיג את המרד האחרון של היהודים ברומא. המורדים השתלטו על יהודה למשך שנתיים, אך הקיסר אדריאנוס ריכז כוחות אדירים ודיכא את המרד באכזריות. הרומאים שינו את שם הפרובינקיה לפלסטינה ואסרו על יהודים להיכנס לירושלים.",
    "rank": 10
  },
  {
    "id": "jh_maccabees",
    "deck": "jewish",
    "title": "מרד המכבים וחנוכת המקדש",
    "start": -167,
    "end": -160,
    "date": "⁦167–160⁩ לפנה״ס",
    "place": "מודיעין, ישראל",
    "lat": 31.907,
    "lon": 35.008,
    "desc": "מתתיהו ובניו יצאו למרד נגד האימפריה הסלווקית שגזרה גזרות על הדת היהודית. יהודה המכבי ניצח בקרבות מפתיעים, שחרר את ירושלים וחנך מחדש את בית המקדש. חג החנוכה מציין את חנוכת המקדש ואת ניצחון המעטים על הרבים.",
    "rank": 11
  },
  {
    "id": "jh_balfour",
    "deck": "jewish",
    "title": "הצהרת בלפור",
    "start": 1917,
    "end": 1917,
    "date": "1917",
    "place": "לונדון, בריטניה",
    "lat": 51.504,
    "lon": -0.076,
    "desc": "שר החוץ הבריטי בלפור שלח מכתב לורד רוטשילד שבו הביעה בריטניה תמיכה בהקמת בית לאומי לעם היהודי בפלסטינה. ההצהרה שילבה בין האינטרסים הבריטיים לשאיפות הציוניות, ומנגד עוררה התנגדות ערבית חריפה. היא הייתה הבסיס המשפטי הבינלאומי הראשון לציונות.",
    "rank": 12
  },
  {
    "id": "jh_herzl_congress",
    "deck": "jewish",
    "title": "הקונגרס הציוני הראשון",
    "start": 1897,
    "end": 1897,
    "date": "1897",
    "place": "באזל, שווייץ",
    "lat": 47.558,
    "lon": 7.587,
    "desc": "בנימין זאב הרצל כינס את הקונגרס הציוני הראשון בבאזל, בו אומצה תוכנית באזל הקוראת להקמת בית לעם היהודי בארץ ישראל. הרצל כתב ביומנו: ׳בבאזל ייסדתי את מדינת היהודים.׳ הקונגרס הפך את הציונות מרעיון ספרותי לתנועה פוליטית מאורגנת.",
    "rank": 13
  },
  {
    "id": "jh_camp_david",
    "deck": "jewish",
    "title": "הסכם השלום בין ישראל למצרים",
    "start": 1979,
    "end": 1979,
    "date": "1979",
    "place": "וושינגטון, ארצות הברית",
    "lat": 38.897,
    "lon": -77.037,
    "desc": "מנחם בגין ואנואר סאדאת חתמו על הסכם שלום בתיווך הנשיא קרטר, הסכם השלום הראשון בין ישראל למדינה ערבית. ישראל נסוגה מסיני בתמורה להכרה מלאה ויחסים דיפלומטיים. בגין וסאדאת זכו בפרס נובל לשלום, אך סאדאת שילם על כך בחייו כשנרצח.",
    "rank": 14
  },
  {
    "id": "jh_auschwitz",
    "deck": "jewish",
    "title": "מחנה ההשמדה אושוויץ",
    "start": 1940,
    "end": 1945,
    "date": "⁦1940–1945⁩",
    "place": "אושוויץ, פולין",
    "lat": 50.036,
    "lon": 19.178,
    "desc": "מחנה אושוויץ־בירקנאו היה המחנה הגדול והקטלני ביותר במערך ההשמדה הנאצי. כמיליון ומאה אלף בני אדם, רובם יהודים, נרצחו בתאי הגזים ובעבודת כפייה. המחנה שוחרר על ידי הצבא האדום בינואר 1945 והפך לסמל העולמי של השואה.",
    "rank": 15
  },
  {
    "id": "jh_solomon_temple",
    "deck": "jewish",
    "title": "בניית בית המקדש הראשון",
    "start": -960,
    "end": -950,
    "date": "בערך המאה ה־10 לפנה״ס",
    "place": "ירושלים, ישראל",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "המלך שלמה בנה את בית המקדש הראשון בירושלים, מרכז הפולחן של ממלכת ישראל המאוחדת. לפי המקרא, הבנייה נמשכה שבע שנים ובמקדש הונח ארון הברית. בית המקדש היה המבנה הקדוש ביותר ביהדות עד חורבנו בידי הבבלים.",
    "rank": 16
  },
  {
    "id": "jh_david_jerusalem",
    "deck": "jewish",
    "title": "כיבוש ירושלים בידי דוד המלך",
    "start": -1000,
    "end": -1000,
    "date": "בערך 1000 לפנה״ס",
    "place": "ירושלים, ישראל",
    "lat": 31.774,
    "lon": 35.234,
    "desc": "דוד המלך כבש את ירושלים מידי היבוסים והפך אותה לבירת ממלכת ישראל המאוחדת. הוא העביר את ארון הברית לעיר, ובכך הפך אותה למרכז דתי ופוליטי כאחד. ירושלים נותרה מאז העיר הקדושה ביותר ליהדות.",
    "rank": 17
  },
  {
    "id": "jh_rabin_assassination",
    "deck": "jewish",
    "title": "רצח יצחק רבין",
    "start": 1995,
    "end": 1995,
    "date": "1995",
    "place": "תל אביב, ישראל",
    "lat": 32.074,
    "lon": 34.781,
    "desc": "ראש הממשלה יצחק רבין נרצח בידי יגאל עמיר בתום עצרת שלום בכיכר מלכי ישראל בתל אביב. הרצח זעזע את החברה הישראלית ושינה את הנוף הפוליטי. רבין, שחתם על הסכמי אוסלו עם אש״ף, שילם בחייו על תהליך השלום שהוביל.",
    "rank": 18
  },
  {
    "id": "jh_oslo",
    "deck": "jewish",
    "title": "הסכמי אוסלו",
    "start": 1993,
    "end": 1993,
    "date": "1993",
    "place": "וושינגטון, ארצות הברית",
    "lat": 38.897,
    "lon": -77.037,
    "desc": "ישראל ואש״ף חתמו על הצהרת העקרונות שנוסחה במגעים סודיים בנורווגיה. הצדדים הכירו זה בזה, והפלסטינים קיבלו שלטון עצמי חלקי בעזה וביריחו. לחיצת היד בין רבין לערפאת על מדשאת הבית הלבן הייתה רגע היסטורי, אך הסכם הקבע לא הושג.",
    "rank": 19
  },
  {
    "id": "jh_dead_sea_scrolls",
    "deck": "jewish",
    "title": "גילוי מגילות ים המלח",
    "start": 1947,
    "end": 1947,
    "date": "1947",
    "place": "קומראן, ישראל",
    "lat": 31.741,
    "lon": 35.459,
    "desc": "רועה בדואי מצא מגילות עתיקות במערה ליד קומראן שעל שפת ים המלח. המגילות, מהמאות ה־3 לפנה״ס עד המאה ה־1 לספירה, כללו את כתבי המקרא העתיקים ביותר שנמצאו. הגילוי חולל מהפכה בחקר המקרא, היהדות של ימי הבית השני והנצרות הקדומה.",
    "rank": 20
  },
  {
    "id": "jh_rambam",
    "deck": "jewish",
    "title": "הרמב״ם כותב את משנה תורה",
    "start": 1170,
    "end": 1180,
    "date": "בערך ⁦1170–1180⁩",
    "place": "פוסטאט (קהיר), מצרים",
    "lat": 30.003,
    "lon": 31.231,
    "desc": "רבי משה בן מימון חיבר את ״משנה תורה״, קודיפיקציה שיטתית של כל ההלכה היהודית בארבעה עשר ספרים. הוא שילב פילוסופיה עם הלכה ושימש גם רופא חצר הסולטאן בקהיר. ״ממשה עד משה לא קם כמשה״ — משפט שמבטא את מעמדו הייחודי.",
    "rank": 21
  },
  {
    "id": "jh_diaspora_begins",
    "deck": "jewish",
    "title": "תחילת הגלות הגדולה",
    "start": 70,
    "end": 135,
    "date": "⁦70–135⁩ לספירה",
    "place": "ארץ ישראל",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "החורבן של בית המקדש השני ודיכוי מרד בר כוכבא הביאו לגלות ממושכת של העם היהודי מארצו. הרומאים גירשו יהודים מירושלים ושינו את שם הארץ. בעוד קהילה יהודית קטנה נותרה, רוב העם נפוץ ברחבי האימפריה הרומית ומעבר לה.",
    "rank": 22
  },
  {
    "id": "jh_eichmann_trial",
    "deck": "jewish",
    "title": "משפט אייכמן",
    "start": 1961,
    "end": 1961,
    "date": "1961",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "אדולף אייכמן, אחד ממתכנני הפתרון הסופי, נחטף על ידי המוסד בארגנטינה והועמד לדין בירושלים. המשפט שודר בטלוויזיה והביא את סיפור השואה לתודעת הציבור הישראלי והעולמי. אייכמן הורשע בפשעים נגד האנושות ונתלה — גזר הדין היחיד למוות בהיסטוריה של ישראל.",
    "rank": 23
  },
  {
    "id": "jh_aliyah_first",
    "deck": "jewish",
    "title": "העלייה הראשונה",
    "start": 1882,
    "end": 1903,
    "date": "⁦1882–1903⁩",
    "place": "ארץ ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "כ־35,000 יהודים, בעיקר מרוסיה ורומניה, עלו לארץ ישראל בעקבות הפוגרומים. הם ייסדו את המושבות הראשונות כמו ראשון לציון, זיכרון יעקב ופתח תקוה. העלייה הראשונה הניחה את היסודות של ההתיישבות היהודית החדשה בארץ ישראל.",
    "rank": 24
  },
  {
    "id": "jh_kristallnacht",
    "deck": "jewish",
    "title": "ליל הבדולח",
    "start": 1938,
    "end": 1938,
    "date": "1938",
    "place": "גרמניה ואוסטריה",
    "lat": 52.52,
    "lon": 13.405,
    "desc": "בליל ה־9 בנובמבר ניהל המשטר הנאצי פוגרום מאורגן נגד יהודי גרמניה ואוסטריה. מאות בתי כנסת הוצתו, אלפי חנויות נהרסו וכ־30,000 יהודים נעצרו ונשלחו למחנות ריכוז. ליל הבדולח סימן את המעבר מרדיפה חוקית לאלימות פיזית גלויה.",
    "rank": 25
  },
  {
    "id": "jh_war_independence",
    "deck": "jewish",
    "title": "מלחמת העצמאות",
    "start": 1948,
    "end": 1949,
    "date": "⁦1948–1949⁩",
    "place": "ישראל",
    "lat": 31.78,
    "lon": 35,
    "desc": "מלחמה בין ישראל לצבאות מצרים, ירדן, סוריה, עיראק ולבנון, שפרצה למחרת ההכרזה על העצמאות. ישראל ניצחה ואף הרחיבה את שטחה מעבר למה שהוקצה לה בתוכנית החלוקה. כ־6,000 ישראלים נהרגו, כאחוז מהאוכלוסייה. מאות אלפי ערבים עזבו או גורשו.",
    "rank": 26
  },
  {
    "id": "jh_rashi",
    "deck": "jewish",
    "title": "רש״י כותב את פירושו לתלמוד ולתורה",
    "start": 1070,
    "end": 1105,
    "date": "בערך ⁦1070–1105⁩",
    "place": "טרואה, צרפת",
    "lat": 48.299,
    "lon": 4.074,
    "desc": "רבי שלמה יצחקי (רש״י) חיבר את הפירוש המקיף ביותר לתלמוד ולתורה, שהפך לפירוש היסודי ביותר בלימוד יהודי עד היום. כתיבתו הבהירה והתמציתית הפכה את הטקסטים הקשים לנגישים. כמעט כל מהדורת תלמוד מודפסת מאז כוללת את רש״י.",
    "rank": 27
  },
  {
    "id": "jh_talmud",
    "deck": "jewish",
    "title": "חתימת התלמוד הבבלי",
    "start": 500,
    "end": 550,
    "date": "בערך המאה ה־6 לספירה",
    "place": "בבל (עיראק של היום)",
    "lat": 32.62,
    "lon": 44.42,
    "desc": "התלמוד הבבלי, הנערך סביב המשנה, הושלם אחרי כמאתיים שנות עריכה על ידי דורות של אמוראים. הוא כולל הלכה, אגדה, פילוסופיה ומדע, ומשמש את הבסיס המרכזי של ההלכה היהודית. 63 מסכתות, כ־2,711 דפים — ספר הספרים של היהדות אחרי המקרא.",
    "rank": 28
  },
  {
    "id": "jh_great_revolt",
    "deck": "jewish",
    "title": "המרד הגדול ברומא",
    "start": 66,
    "end": 73,
    "date": "⁦66–73⁩ לספירה",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.235,
    "desc": "יהודי ארץ ישראל מרדו באימפריה הרומית בעקבות עריצות הנציבים. המורדים ניצחו בתחילה, אך רומא שלחה כוחות אדירים. ירושלים נפלה ובית המקדש נחרב ב־70, ומצדה נכבשה ב־73. המרד הגדול סימן את סוף הריבונות היהודית בארץ לכמעט אלפיים שנה.",
    "rank": 29
  },
  {
    "id": "jh_hebron_massacre",
    "deck": "jewish",
    "title": "הטבח בחברון",
    "start": 1929,
    "end": 1929,
    "date": "1929",
    "place": "חברון, ישראל",
    "lat": 31.529,
    "lon": 35.096,
    "desc": "במסגרת מאורעות תרפ״ט, ערבים רצחו 67 יהודים בחברון ופצעו עוד עשרות. הקהילה היהודית העתיקה בעיר פונתה. הפרעות, שפרצו על רקע סכסוך על הכותל המערבי, שינו את דפוסי ההתיישבות היהודית והגבירו את הדרישה להגנה עצמית יהודית.",
    "rank": 30
  },
  {
    "id": "jh_un_partition",
    "deck": "jewish",
    "title": "החלטת החלוקה של האו״ם",
    "start": 1947,
    "end": 1947,
    "date": "1947",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.749,
    "lon": -73.968,
    "desc": "עצרת האו״ם אישרה את תוכנית החלוקה של ארץ ישראל למדינה יהודית ומדינה ערבית. היהודים קיבלו את התוכנית וחגגו ברחובות, בעוד המנהיגות הערבית דחתה אותה. ההצבעה ב־29 בנובמבר, כ״ט בכסלו, הפכה לאחד הרגעים הגורליים בהיסטוריה הציונית.",
    "rank": 31
  },
  {
    "id": "jh_aliyah_second",
    "deck": "jewish",
    "title": "העלייה השנייה",
    "start": 1904,
    "end": 1914,
    "date": "⁦1904–1914⁩",
    "place": "ארץ ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "כ־40,000 יהודים, בעיקר צעירים סוציאליסטים מרוסיה, עלו לארץ ישראל. הם ייסדו את הקיבוץ הראשון (דגניה), את השומר, ואת הבסיס של תנועת העבודה. העלייה השנייה עיצבה את התרבות והמוסדות של היישוב יותר מכל גל עלייה אחר.",
    "rank": 32
  },
  {
    "id": "jh_abraham",
    "deck": "jewish",
    "title": "אברהם אבינו ומסעו לארץ כנען",
    "start": -1800,
    "end": -1800,
    "date": "בערך המאה ה־18 לפנה״ס",
    "place": "חברון, ארץ כנען",
    "lat": 31.529,
    "lon": 35.096,
    "desc": "לפי המסורת, אברהם יצא מאור כשדים לארץ כנען בעקבות ציווי אלוהי — ״לך לך מארצך.״ הוא כרת ברית עם אלוהים, שהבטיח לו את הארץ ולזרעו. אברהם נחשב לאב המייסד של היהדות, הנצרות והאסלאם.",
    "rank": 33
  },
  {
    "id": "jh_western_wall",
    "deck": "jewish",
    "title": "שחרור הכותל המערבי",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "ירושלים, ישראל",
    "lat": 31.777,
    "lon": 35.234,
    "desc": "במהלך מלחמת ששת הימים, צנחנים ישראלים כבשו את העיר העתיקה וחיילים הגיעו לכותל המערבי. הרב הצבאי שלמה גורן תקע בשופר, ומפקד הצנחנים מוטה גור הודיע: ״הר הבית בידינו.״ הרגע הפך לרגע המכונן ביותר בהיסטוריה הישראלית המודרנית.",
    "rank": 34
  },
  {
    "id": "jh_mishnah",
    "deck": "jewish",
    "title": "עריכת המשנה בידי רבי יהודה הנשיא",
    "start": 200,
    "end": 220,
    "date": "בערך 200 לספירה",
    "place": "ציפורי, ישראל",
    "lat": 32.752,
    "lon": 35.278,
    "desc": "רבי יהודה הנשיא ערך את המשנה, הקודיפיקציה הראשונה של התורה שבעל פה. ששה סדרים ו־63 מסכתות מסכמים דורות של מסורת משפטית ודתית. המשנה הפכה לבסיס שעליו נכתב התלמוד, והיא אחד הטקסטים המשפיעים ביותר ביהדות.",
    "rank": 35
  },
  {
    "id": "jh_expulsion_spain",
    "deck": "jewish",
    "title": "גירוש יהודי ספרד",
    "start": 1492,
    "end": 1492,
    "date": "1492",
    "place": "ספרד",
    "lat": 40.42,
    "lon": -3.7,
    "desc": "פרדיננד ואיזבלה חתמו על צו אלהמברה, שגזר גירוש כל יהודי ספרד שלא המירו את דתם. כ־200,000 יהודים גורשו ונפוצו בצפון אפריקה, באימפריה העות׳מאנית ובאיטליה. הגירוש סיים את תור הזהב של יהדות ספרד, אחת הקהילות הגדולות והמשפיעות ביותר.",
    "rank": 36
  },
  {
    "id": "jh_warsaw_ghetto_uprising",
    "deck": "jewish",
    "title": "מרד גטו ורשה",
    "start": 1943,
    "end": 1943,
    "date": "1943",
    "place": "ורשה, פולין",
    "lat": 52.249,
    "lon": 20.995,
    "desc": "לוחמי הגטו, בפיקוד מרדכי אנילביץ׳, יצאו למרד מזוין נגד הגרמנים שבאו לחסל את הגטו. הקרבות נמשכו כחודש, למרות הנחיתות העצומה בכוחות ובנשק. מרד גטו ורשה הפך לסמל ההתנגדות היהודית בשואה.",
    "rank": 37
  },
  {
    "id": "jh_dreyfus",
    "deck": "jewish",
    "title": "פרשת דרייפוס",
    "start": 1894,
    "end": 1906,
    "date": "⁦1894–1906⁩",
    "place": "פריז, צרפת",
    "lat": 48.856,
    "lon": 2.352,
    "desc": "הקפטן היהודי אלפרד דרייפוס הורשע בריגול על סמך ראיות מזויפות ונשלח לכלא באי השד. הפרשה חילקה את צרפת ועוררה גל אנטישמי. הרצל, ששידר את המשפט כעיתונאי, הגיע למסקנה שרק מדינה יהודית תפתור את בעיית האנטישמיות.",
    "rank": 38
  },
  {
    "id": "jh_cyrus",
    "deck": "jewish",
    "title": "הצהרת כורש ושיבת ציון",
    "start": -538,
    "end": -538,
    "date": "538 לפנה״ס",
    "place": "בבל (עיראק של היום)",
    "lat": 32.54,
    "lon": 44.42,
    "desc": "כורש הגדול, מלך פרס, כבש את בבל והתיר ליהודים לשוב לארצם ולבנות מחדש את בית המקדש. שיבת ציון הייתה השיבה הגדולה הראשונה מהגלות, אך רק מיעוט חזר בפועל. כורש נחשב במסורת היהודית למשיח — מלך גוי שמילא ייעוד אלוהי.",
    "rank": 39
  },
  {
    "id": "jh_second_temple_built",
    "deck": "jewish",
    "title": "בניית בית המקדש השני",
    "start": -516,
    "end": -516,
    "date": "בערך 516 לפנה״ס",
    "place": "ירושלים, ישראל",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "שבי ציון בנו מחדש את בית המקדש בירושלים, כעשרים שנה אחרי הצהרת כורש. המקדש השני היה צנוע בתחילתו, אך במאות הבאות הורחב ושופץ, ובימי הורדוס הפך למבנה מפואר. הוא שימש מרכז דתי ולאומי ליהדות עד חורבנו ב־70 לספירה.",
    "rank": 40
  },
  {
    "id": "jh_entebbe",
    "deck": "jewish",
    "title": "מבצע אנטבה",
    "start": 1976,
    "end": 1976,
    "date": "1976",
    "place": "אנטבה, אוגנדה",
    "lat": 0.042,
    "lon": 32.443,
    "desc": "כוח צה״ל הגיע במטוסי הרקולס לאוגנדה וחילץ 102 בני ערובה ישראלים ויהודים שנחטפו בטיסת אייר פראנס. מפקד המבצע, יוני נתניהו, נהרג בפעולה. המבצע הפך לסמל של העזה ישראלית ולאחד הסיפורים הצבאיים המפורסמים בעולם.",
    "rank": 41
  },
  {
    "id": "jh_pogroms_russia",
    "deck": "jewish",
    "title": "הפוגרומים ברוסיה",
    "start": 1881,
    "end": 1884,
    "date": "⁦1881–1884⁩",
    "place": "אודסה וקייב, רוסיה",
    "lat": 46.484,
    "lon": 30.732,
    "desc": "גל פרעות אלימות פרץ נגד קהילות יהודיות ברחבי תחום המושב לאחר רצח הצאר אלכסנדר השני. המוני יהודים נרצחו, ורכוש רב נבזז. הפוגרומים הניעו את גלי ההגירה הגדולים לאמריקה ולארץ ישראל ועוררו את הציונות כתנועה פוליטית.",
    "rank": 42
  },
  {
    "id": "jh_ben_yehuda",
    "deck": "jewish",
    "title": "אליעזר בן יהודה ותחיית העברית",
    "start": 1881,
    "end": 1922,
    "date": "⁦1881–1922⁩",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "אליעזר בן יהודה הגיע לארץ ישראל עם חזון להפוך את העברית משפת תפילה ולימוד לשפה חיה מדוברת. הוא חינך את בנו כדובר עברית ראשון ופיתח מילון מקיף. תחיית העברית היא אחת מהתופעות הלשוניות הייחודיות בהיסטוריה.",
    "rank": 43
  },
  {
    "id": "jh_lebanon_war_first",
    "deck": "jewish",
    "title": "מלחמת לבנון הראשונה",
    "start": 1982,
    "end": 1985,
    "date": "⁦1982–1985⁩",
    "place": "לבנון",
    "lat": 33.88,
    "lon": 35.5,
    "desc": "ישראל פלשה ללבנון במטרה לסלק את אש״ף מגבולה. הצבא הגיע עד ביירות, אש״ף פונה לתוניס, אך ישראל נשארה בדרום לבנון 18 שנה. הטבח בסברה ושתילה עורר זעם בארץ והוביל להקמת ועדת כהן ולהדחת שרון מתפקיד שר הביטחון.",
    "rank": 44
  },
  {
    "id": "jh_kabbala_zohar",
    "deck": "jewish",
    "title": "התפשטות ספר הזוהר",
    "start": 1280,
    "end": 1290,
    "date": "בערך ⁦1280–1290⁩",
    "place": "קסטיליה, ספרד",
    "lat": 41.65,
    "lon": -4.73,
    "desc": "ספר הזוהר, היצירה המרכזית של הקבלה, החל להתפשט בספרד. מיוחס לרשב״י, אך ככל הנראה חובר על ידי משה דה לאון. הזוהר מציע פרשנות מיסטית לתורה ועיצב את ההגות הרוחנית היהודית, במיוחד אחרי גירוש ספרד.",
    "rank": 45
  },
  {
    "id": "jh_aliyah_mass",
    "deck": "jewish",
    "title": "העלייה ההמונית ממדינות ערב",
    "start": 1948,
    "end": 1951,
    "date": "⁦1948–1951⁩",
    "place": "ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "כ־700,000 יהודים עלו לישראל ממדינות ערב ומצפון אפריקה במבצעים כמו ״על כנפי נשרים״ מתימן ו״עזרא ונחמיה״ מעיראק. רובם הגיעו כפליטים שנאלצו לעזוב את רכושם. העלייה ההמונית הכפילה את אוכלוסיית ישראל ושינתה את הרכב החברה הישראלית.",
    "rank": 46
  },
  {
    "id": "jh_shabbtai_zvi",
    "deck": "jewish",
    "title": "שבתי צבי מכריז על עצמו כמשיח",
    "start": 1665,
    "end": 1666,
    "date": "⁦1665–1666⁩",
    "place": "איזמיר, תורכיה",
    "lat": 38.419,
    "lon": 27.129,
    "desc": "שבתי צבי, רב מאיזמיר, הכריז על עצמו כמשיח ומשך מאמינים מכל קהילות ישראל. הוא עורר תקוות גדולות אך המיר את דתו לאסלאם כשהעות׳מאנים איימו עליו. הנפילה הטראגית זעזעה את העולם היהודי ועיצבה זהירות רבה כלפי תנועות משיחיות.",
    "rank": 47
  },
  {
    "id": "jh_intifada_first",
    "deck": "jewish",
    "title": "האינתיפאדה הראשונה",
    "start": 1987,
    "end": 1993,
    "date": "⁦1987–1993⁩",
    "place": "הגדה המערבית ורצועת עזה",
    "lat": 31.9,
    "lon": 35.2,
    "desc": "התקוממות עממית פלסטינית פרצה בשטחים שנכבשו, כללה שביתות, הפגנות ויידוי אבנים. הצבא הישראלי נאבק להתמודד עם מרד אזרחי שלא נועד לנצח צבאית אלא לשנות תודעה. האינתיפאדה הובילה בסופו של דבר למגעים שהניבו את הסכמי אוסלו.",
    "rank": 48
  },
  {
    "id": "jh_hasidism",
    "deck": "jewish",
    "title": "עליית תנועת החסידות",
    "start": 1740,
    "end": 1760,
    "date": "בערך אמצע המאה ה־18",
    "place": "מדז׳יבוז׳, אוקראינה",
    "lat": 49.437,
    "lon": 27.408,
    "desc": "ישראל בעל שם טוב (הבעש״ט) הקים את תנועת החסידות, שהדגישה תפילה בשמחה, דבקות באלוהים ויחס אישי לרבי. התנועה משכה המונים של יהודים פשוטים שחשו מנוכרים מהלימוד התלמודי הגבוה. החסידות התפשטה במהירות למרות התנגדות המתנגדים בהנהגת הגר״א.",
    "rank": 49
  },
  {
    "id": "jh_wannsee",
    "deck": "jewish",
    "title": "ועידת ואנזה — התוכנית להשמדת היהודים",
    "start": 1942,
    "end": 1942,
    "date": "1942",
    "place": "ברלין, גרמניה",
    "lat": 52.433,
    "lon": 13.164,
    "desc": "פקידים בכירים של המשטר הנאצי התכנסו בפרבר ואנזה שבברלין לתאם את ביצוע ״הפתרון הסופי של השאלה היהודית.״ היידריך הציג תוכנית שיטתית להשמדת 11 מיליון יהודי אירופה. הפרוטוקול של הישיבה הוא מהמסמכים החשובים ביותר לתיעוד השואה.",
    "rank": 50
  },
  {
    "id": "jh_haskalah",
    "deck": "jewish",
    "title": "תנועת ההשכלה (ההסכלה)",
    "start": 1770,
    "end": 1880,
    "date": "בערך ⁦1770–1880⁩",
    "place": "ברלין, גרמניה",
    "lat": 52.52,
    "lon": 13.405,
    "desc": "משה מנדלסון וממשיכיו הובילו תנועה שקראה ליהודים ללמוד שפות ומדעים ולהשתלב בחברה הכללית. המשכילים תרגמו את התורה לגרמנית וייסדו כתבי עת בעברית. ההשכלה שינתה את פני היהדות האירופית וסללה את הדרך לתנועות הרפורמה, הציונות וההגירה ההמונית.",
    "rank": 51
  },
  {
    "id": "jh_haganah",
    "deck": "jewish",
    "title": "הקמת ארגון ההגנה",
    "start": 1920,
    "end": 1920,
    "date": "1920",
    "place": "ארץ ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "לאחר מאורעות תר״פ הוקם ארגון ההגנה כמיליציה יהודית חשאית להגנה על היישוב מפני פרעות ערביות. ההגנה גדלה לארגון מורכב עם זרועות מודיעין, אספקה ותעשייה צבאית. עם הקמת המדינה שימשה בסיס לצה״ל.",
    "rank": 52
  },
  {
    "id": "jh_kibbutz",
    "deck": "jewish",
    "title": "ייסוד הקיבוץ הראשון — דגניה",
    "start": 1910,
    "end": 1910,
    "date": "1910",
    "place": "דגניה, ישראל",
    "lat": 32.707,
    "lon": 35.576,
    "desc": "קבוצת צעירים מהעלייה השנייה ייסדו את דגניה על חוף הכנרת כמשק חקלאי קולקטיבי, הקיבוץ הראשון. הקיבוץ שילב סוציאליזם עם ציונות ויצר מודל חברתי ייחודי של שוויון ושיתוף מלא. תנועת הקיבוצים עיצבה את התרבות, הפוליטיקה וההגנה של היישוב.",
    "rank": 53
  },
  {
    "id": "jh_nuremberg_laws",
    "deck": "jewish",
    "title": "חוקי נירנברג",
    "start": 1935,
    "end": 1935,
    "date": "1935",
    "place": "נירנברג, גרמניה",
    "lat": 49.454,
    "lon": 11.077,
    "desc": "המשטר הנאצי חוקק חוקים ששללו את האזרחות מיהודי גרמניה ואסרו נישואים ויחסים בין יהודים וגרמנים. החוקים הגדירו ״יהודי״ לפי ״גזע,״ לא דת, ויצרו מסגרת משפטית לרדיפה. חוקי נירנברג היו שלב מכריע בדרך מהפליה חוקית להשמדה.",
    "rank": 54
  },
  {
    "id": "jh_herod_temple",
    "deck": "jewish",
    "title": "שיפוץ בית המקדש בידי הורדוס",
    "start": -20,
    "end": -20,
    "date": "בערך 20 לפנה״ס",
    "place": "ירושלים, ישראל",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "הורדוס הגדול הרחיב ושיפץ את בית המקדש השני בפרויקט בנייה עצום שכלל הרחבת הר הבית, בניית חומות תמך אדירות (הכותל המערבי מביניהן) ועיטור המבנה בשיש וזהב. לפי יוסף בן מתתיהו, מי שלא ראה את בניין הורדוס לא ראה בניין יפה מימיו.",
    "rank": 55
  },
  {
    "id": "jh_white_paper",
    "deck": "jewish",
    "title": "הספר הלבן של מקדונלד",
    "start": 1939,
    "end": 1939,
    "date": "1939",
    "place": "לונדון, בריטניה",
    "lat": 51.504,
    "lon": -0.076,
    "desc": "הממשלה הבריטית פרסמה מדיניות חדשה שהגבילה בחריפות את העלייה היהודית לארץ ישראל ואת רכישת הקרקעות. הספר הלבן פורסם בערב מלחמת העולם השנייה, בזמן שיהודי אירופה נזקקו בייאוש למקלט. היישוב היהודי ראה בו בגידה בהצהרת בלפור.",
    "rank": 56
  },
  {
    "id": "jh_altalena",
    "deck": "jewish",
    "title": "פרשת אלטלנה",
    "start": 1948,
    "end": 1948,
    "date": "1948",
    "place": "תל אביב, ישראל",
    "lat": 32.053,
    "lon": 34.763,
    "desc": "בן גוריון הורה לירות באוניית נשק שהביא האצ״ל, למרות שהמדינה הייתה בעיצומה של מלחמה. ספינת ״אלטלנה״ עלתה באש על חוף תל אביב, ומספר אנשי אצ״ל נהרגו. ההחלטה חיזקה את הריבונות הצבאית של המדינה אך יצרה שסע עמוק שנמשך שנים.",
    "rank": 57
  },
  {
    "id": "jh_josephus",
    "deck": "jewish",
    "title": "יוסף בן מתתיהו כותב את תולדות מלחמת היהודים",
    "start": 75,
    "end": 79,
    "date": "בערך ⁦75–79⁩ לספירה",
    "place": "רומא, איטליה",
    "lat": 41.89,
    "lon": 12.49,
    "desc": "יוסף בן מתתיהו, מפקד יהודי שנפל בשבי הרומאים, כתב את הדיווח המפורט ביותר על המרד הגדול, חורבן ירושלים ונפילת מצדה. כתביו הם המקור ההיסטורי העיקרי לתקופת בית שני ולחיי היהודים תחת שלטון רומא.",
    "rank": 58
  },
  {
    "id": "jh_philistines",
    "deck": "jewish",
    "title": "קרב דוד וגוליית",
    "start": -1020,
    "end": -1020,
    "date": "בערך המאה ה־11 לפנה״ס",
    "place": "עמק האלה, ישראל",
    "lat": 31.693,
    "lon": 34.962,
    "desc": "לפי המסורת, דוד הרועה הצעיר הכריע את גוליית הפלשתי באבן קלע והפך לגיבור לאומי. הניצחון על הפלשתים סלל את דרכו למלוכה. הסיפור הפך לאחד הארכיטיפים המפורסמים ביותר בתרבות המערבית — ניצחון החלש על החזק.",
    "rank": 59
  },
  {
    "id": "jh_printing_prague",
    "deck": "jewish",
    "title": "הדפסת הספר העברי הראשון",
    "start": 1475,
    "end": 1475,
    "date": "בערך 1475",
    "place": "רגיו די קלבריה, איטליה",
    "lat": 38.114,
    "lon": 15.648,
    "desc": "פירוש רש״י לתורה היה מהספרים העבריים הראשונים שהודפסו, בדרום איטליה. הדפוס חולל מהפכה בלימוד היהודי: טקסטים שנעתקו ביד במשך דורות הפכו נגישים לכל. תוך עשורים הודפסו תלמוד, סידורים ומדרשים בוונציה, קושטא ושאלוניקי.",
    "rank": 60
  },
  {
    "id": "jh_ghetto_venice",
    "deck": "jewish",
    "title": "הקמת הגטו בוונציה",
    "start": 1516,
    "end": 1516,
    "date": "1516",
    "place": "וונציה, איטליה",
    "lat": 45.445,
    "lon": 12.327,
    "desc": "ממשלת וונציה הורתה ליהודי העיר לגור באזור מגורים סגור, ״הגטו,״ שנסגר בלילה. זה היה הגטו הראשון באירופה, והמילה עצמה מקורה ב״גטו״ הוונציאני (מתפרש כ״בית יציקה״). המודל התפשט לערים רבות ברחבי איטליה ואירופה.",
    "rank": 61
  },
  {
    "id": "jh_sanhedrin",
    "deck": "jewish",
    "title": "הסנהדרין — בית הדין העליון של היהודים",
    "start": -200,
    "end": 425,
    "date": "בערך מהמאה ה־2 לפנה״ס עד 425 לספירה",
    "place": "ירושלים ואחר כך יבנה וטבריה, ישראל",
    "lat": 32.794,
    "lon": 35.531,
    "desc": "הסנהדרין שימש כגוף המחוקק העליון של העם היהודי, בית דין של 71 חכמים שדן בהלכה, דיני נפשות ועניינים לאומיים. אחרי החורבן עברה הסנהדרין מירושלים ליבנה ולאחר מכן לגליל. ביטולה ב־425 סימן את סוף המוסד המרכזי של ההנהגה היהודית בארץ ישראל.",
    "rank": 62
  },
  {
    "id": "jh_operation_moses",
    "deck": "jewish",
    "title": "מבצע משה — עליית יהודי אתיופיה",
    "start": 1984,
    "end": 1985,
    "date": "⁦1984–1985⁩",
    "place": "סודן ואתיופיה",
    "lat": 12.6,
    "lon": 37.47,
    "desc": "ישראל ביצעה מבצע חשאי להעלאת יהודי אתיופיה (ביתא ישראל) שחצו רגלית לסודן. כ־8,000 יהודים הועלו במטוסים, אך מאות מתו בדרך. המבצע הושלם במבצע שלמה ב־1991, שבו הועלו כ־14,000 נוספים תוך 36 שעות.",
    "rank": 63
  },
  {
    "id": "jh_saul_king",
    "deck": "jewish",
    "title": "שאול — המלך הראשון של ישראל",
    "start": -1020,
    "end": -1000,
    "date": "בערך המאה ה־11 לפנה״ס",
    "place": "גבעת שאול, ישראל",
    "lat": 31.915,
    "lon": 35.222,
    "desc": "לפי המקרא, שמואל הנביא משח את שאול בן קיש למלך ראשון על ישראל, בתקופה שהעם דרש מלוכה להתמודד עם איום הפלשתים. שאול נלחם בפלשתים ובעמלק אך איבד את אמון שמואל ואת נפשו בקרב בהר הגלבוע.",
    "rank": 64
  },
  {
    "id": "jh_split_kingdom",
    "deck": "jewish",
    "title": "פילוג הממלכה — ישראל ויהודה",
    "start": -930,
    "end": -930,
    "date": "בערך 930 לפנה״ס",
    "place": "שכם, ישראל",
    "lat": 32.214,
    "lon": 35.271,
    "desc": "אחרי מות שלמה, עשרת השבטים הצפוניים סירבו לקבל את מלכות בנו רחבעם והקימו ממלכה נפרדת בהנהגת ירבעם. ממלכת ישראל בצפון וממלכת יהודה בדרום התקיימו זו לצד זו כמאתיים שנה, עד שאשור כבשה את ממלכת ישראל ב־722 לפנה״ס.",
    "rank": 65
  },
  {
    "id": "jh_fall_samaria",
    "deck": "jewish",
    "title": "נפילת שומרון — גלות עשרת השבטים",
    "start": -722,
    "end": -722,
    "date": "722 לפנה״ס",
    "place": "שומרון, ישראל",
    "lat": 32.277,
    "lon": 35.191,
    "desc": "האימפריה האשורית כבשה את שומרון, בירת ממלכת ישראל, והגלתה את תושביה. עשרת השבטים הצפוניים נעלמו מהזירה ההיסטורית — ״עשרת השבטים האבודים.״ מכאן ואילך נותרה רק ממלכת יהודה כנושאת הנס של העם היהודי.",
    "rank": 66
  },
  {
    "id": "jh_ezra",
    "deck": "jewish",
    "title": "עזרא הסופר ותקנותיו",
    "start": -458,
    "end": -440,
    "date": "בערך המאה ה־5 לפנה״ס",
    "place": "ירושלים, ישראל",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "עזרא הסופר הגיע מבבל לירושלים וחיזק את שמירת התורה בקרב שבי ציון. הוא תיקן תקנות מפליגות, ובהן קריאת התורה בציבור ואיסור נישואים עם עמי הארצות. המסורת מייחסת לו תפקיד מכריע בעיצוב היהדות כ״דת הספר.״",
    "rank": 67
  },
  {
    "id": "jh_irgun_david",
    "deck": "jewish",
    "title": "פיצוץ מלון המלך דוד",
    "start": 1946,
    "end": 1946,
    "date": "1946",
    "place": "ירושלים, ישראל",
    "lat": 31.774,
    "lon": 35.224,
    "desc": "האצ״ל בפיקוד מנחם בגין פוצץ את הכנף הדרומית של מלון המלך דוד, ששימש מפקדה בריטית. 91 בני אדם נהרגו. הפיגוע היה חלק ממרד הפרטיזנים נגד המנדט הבריטי, ועורר ויכוח חריף בתוך היישוב על אמצעי המאבק.",
    "rank": 68
  },
  {
    "id": "jh_death_march",
    "deck": "jewish",
    "title": "צעדות המוות",
    "start": 1945,
    "end": 1945,
    "date": "1945",
    "place": "מרכז אירופה",
    "lat": 50.8,
    "lon": 13.5,
    "desc": "עם התקדמות בעלות הברית, הנאצים פינו מחנות ריכוז והובילו עשרות אלפי אסירים רזים וחולים בצעדות מוות בשלג. מי שלא יכול היה ללכת נורה בצד הדרך. עשרות אלפים מתו בצעדות אלה, שהיו הפשע האחרון של הרייך השלישי לפני קריסתו.",
    "rank": 69
  },
  {
    "id": "jh_septuagint",
    "deck": "jewish",
    "title": "תרגום השבעים",
    "start": -250,
    "end": -200,
    "date": "בערך המאה ה־3 לפנה״ס",
    "place": "אלכסנדריה, מצרים",
    "lat": 31.2,
    "lon": 29.92,
    "desc": "לפי המסורת, 72 חכמים תרגמו את התורה ליוונית באלכסנדריה. תרגום השבעים הפך את המקרא לנגיש לעולם ההלניסטי ולימים שימש בסיס לברית החדשה הנוצרית. זהו אחד המפעלים הספרותיים הראשונים של תרגום בין-תרבותי.",
    "rank": 70
  },
  {
    "id": "jh_gaon_saadia",
    "deck": "jewish",
    "title": "רב סעדיה גאון — האמונות והדעות",
    "start": 933,
    "end": 933,
    "date": "בערך 933 לספירה",
    "place": "סורא, בבל (עיראק)",
    "lat": 32.15,
    "lon": 44.2,
    "desc": "רב סעדיה גאון, ראש ישיבת סורא, חיבר את ״האמונות והדעות,״ היצירה הפילוסופית היהודית המקיפה הראשונה. הוא גם תרגם את התורה לערבית וניהל מאבק נגד הכתות הקראית. פעילותו עיצבה את הרבנות כסמכות אינטלקטואלית ולא רק הלכתית.",
    "rank": 71
  },
  {
    "id": "jh_blood_libel",
    "deck": "jewish",
    "title": "עלילת הדם הראשונה — נורוויץ׳",
    "start": 1144,
    "end": 1144,
    "date": "1144",
    "place": "נורוויץ׳, אנגליה",
    "lat": 52.63,
    "lon": 1.297,
    "desc": "עלילת הדם הראשונה המתועדת הושמעה כנגד יהודי נורוויץ׳, שהואשמו ברצח נער נוצרי לצרכים פולחניים. השקר הזדוני התפשט ברחבי אירופה והוביל לרציחות, גירושים ופוגרומים. עלילות דם נמשכו עד המאה ה־20 ושימשו דלק לאנטישמיות.",
    "rank": 72
  },
  {
    "id": "jh_yavne",
    "deck": "jewish",
    "title": "רבן יוחנן בן זכאי מייסד את ישיבת יבנה",
    "start": 70,
    "end": 70,
    "date": "בערך 70 לספירה",
    "place": "יבנה, ישראל",
    "lat": 31.878,
    "lon": 34.738,
    "desc": "לפי המסורת, רבן יוחנן בן זכאי הוברח בארון מת מירושלים הנצורה וביקש מווספסיאנוס ״תן לי יבנה וחכמיה.״ ביבנה ביסס מרכז תורני חדש שהחליף את בית המקדש. ההחלטה להעדיף לימוד על קרב הצילה את היהדות מהכחדה.",
    "rank": 73
  },
  {
    "id": "jh_intifada_second",
    "deck": "jewish",
    "title": "האינתיפאדה השנייה",
    "start": 2000,
    "end": 2005,
    "date": "⁦2000–2005⁩",
    "place": "ישראל והשטחים",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "גל אלימות שכלל פיגועי התאבדות קטלניים בערי ישראל פרץ אחרי כישלון שיחות קמפ דיוויד. ישראל ביצעה מבצעים צבאיים בשטחי הרשות והחלה בבניית גדר ההפרדה. כ־1,000 ישראלים וכ־3,000 פלסטינים נהרגו. הגל קבר את תקוות אוסלו לשנים.",
    "rank": 74
  },
  {
    "id": "jh_maimon_guide",
    "deck": "jewish",
    "title": "הרמב״ם כותב את מורה הנבוכים",
    "start": 1190,
    "end": 1190,
    "date": "בערך 1190",
    "place": "פוסטאט (קהיר), מצרים",
    "lat": 30.003,
    "lon": 31.231,
    "desc": "הרמב״ם חיבר את ״מורה הנבוכים״ בערבית-יהודית, ניסיון לגשר בין הפילוסופיה האריסטוטלית לאמונה היהודית. הספר עורר ויכוח סוער שחילק את העולם היהודי, אך השפיע עמוקות על תומאס אקווינאס ועל ההגות המערבית כולה.",
    "rank": 75
  },
  {
    "id": "jh_vilna_gaon",
    "deck": "jewish",
    "title": "הגאון מווילנה",
    "start": 1720,
    "end": 1797,
    "date": "⁦1720–1797⁩",
    "place": "וילנה, ליטא",
    "lat": 54.687,
    "lon": 25.28,
    "desc": "רבי אליהו מווילנה נחשב לגדול חכמי דורו: בקי בתלמוד, קבלה, מתמטיקה ודקדוק. הוא הנהיג את ההתנגדות לחסידות ועיצב את המסורת הליטאית של לימוד תלמוד אנליטי. ווילנה הפכה בהשפעתו ל״ירושלים דליטא.״",
    "rank": 76
  },
  {
    "id": "jh_beit_alpha",
    "deck": "jewish",
    "title": "פסיפס בית הכנסת בבית אלפא",
    "start": 500,
    "end": 530,
    "date": "בערך המאה ה־6 לספירה",
    "place": "בית אלפא, ישראל",
    "lat": 32.503,
    "lon": 35.438,
    "desc": "בית כנסת עתיק מהתקופה הביזנטית נחשף בעמק בית שאן, עם פסיפס רצפה מרהיב הכולל גלגל מזלות, עקדת יצחק ומנורת שבעה קנים. הממצא מעיד על שילוב מפתיע של מוטיבים אליליים ויהודיים באמנות בתי הכנסת בגליל.",
    "rank": 77
  },
  {
    "id": "jh_salonika",
    "deck": "jewish",
    "title": "שאלוניקי — ״ירושלים של הבלקן״",
    "start": 1492,
    "end": 1943,
    "date": "⁦1492–1943⁩",
    "place": "שאלוניקי, יוון",
    "lat": 40.64,
    "lon": 22.944,
    "desc": "אחרי גירוש ספרד קלטה שאלוניקי אלפי יהודים ספרדים שהפכו לרוב אוכלוסייתה. הנמל היה סגור בשבתות. הקהילה, שדיברה לאדינו, פרחה עד מלחמת העולם השנייה, בה נשלחו כ־50,000 יהודי שאלוניקי לאושוויץ.",
    "rank": 78
  },
  {
    "id": "jh_galut_england",
    "deck": "jewish",
    "title": "גירוש היהודים מאנגליה",
    "start": 1290,
    "end": 1290,
    "date": "1290",
    "place": "לונדון, אנגליה",
    "lat": 51.504,
    "lon": -0.076,
    "desc": "אדוארד הראשון גירש את כל יהודי אנגליה, הגירוש הלאומי הראשון בהיסטוריה האירופית. כ־3,000 יהודים עזבו, רכושם הוחרם. רק ב־1656 הותר ליהודים לחזור, בימי הפוריטן אוליבר קרומוול.",
    "rank": 79
  },
  {
    "id": "jh_rhineland_1096",
    "deck": "jewish",
    "title": "גזרות תתנ״ו — טבח יהודי הריין",
    "start": 1096,
    "end": 1096,
    "date": "1096",
    "place": "ורמס ומיינץ, גרמניה",
    "lat": 49.633,
    "lon": 8.361,
    "desc": "צלבנים בדרכם לארץ הקודש טבחו בקהילות יהודיות לאורך נהר הריין. אלפי יהודים נרצחו, רבים מהם קידשו את השם. גזרות תתנ״ו הפכו לטראומה מכוננת ביהדות אשכנז, ותפילות הזכרה נאמרות עד היום.",
    "rank": 80
  },
  {
    "id": "jh_black_death",
    "deck": "jewish",
    "title": "עלילות הרעלת הבארות בימי המוות השחור",
    "start": 1348,
    "end": 1351,
    "date": "⁦1348–1351⁩",
    "place": "אירופה",
    "lat": 47.37,
    "lon": 8.54,
    "desc": "בזמן מגפת המוות השחור, הואשמו יהודי אירופה בהרעלת בארות כדי להסביר את המגפה. מאות קהילות הושמדו, במיוחד בגרמניה ובצרפת. הרדיפות גרמו לנדידה מזרחה לפולין, שהפכה למרכז היהודי הגדול באירופה.",
    "rank": 81
  },
  {
    "id": "jh_pale",
    "deck": "jewish",
    "title": "תחום המושב ברוסיה",
    "start": 1791,
    "end": 1917,
    "date": "⁦1791–1917⁩",
    "place": "מערב רוסיה ופולין",
    "lat": 50.45,
    "lon": 30.52,
    "desc": "הצארים הגבילו את מגורי יהודי רוסיה ל״תחום המושב,״ רצועה בגבול המערבי של האימפריה. כחמישה מיליון יהודים חיו בצפיפות ובעוני, עם הגבלות על לימודים ומקצועות. תחום המושב הוביל להגירה ההמונית ולצמיחת הציונות והבונד.",
    "rank": 82
  },
  {
    "id": "jh_telaviv",
    "deck": "jewish",
    "title": "ייסוד תל אביב",
    "start": 1909,
    "end": 1909,
    "date": "1909",
    "place": "תל אביב, ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "66 משפחות יהודיות ייסדו שכונה חדשה על דיונות החול מצפון ליפו, שנקראה בשם ״תל אביב״ על שם ספרו של הרצל. השכונה הקטנה צמחה לעיר העברית הראשונה, מרכז כלכלי ותרבותי ובירה דה פקטו של היישוב ולאחר מכן של ישראל.",
    "rank": 83
  },
  {
    "id": "jh_gra_aliyah",
    "deck": "jewish",
    "title": "עליית תלמידי הגר״א",
    "start": 1809,
    "end": 1812,
    "date": "⁦1809–1812⁩",
    "place": "צפת וירושלים, ישראל",
    "lat": 32.964,
    "lon": 35.497,
    "desc": "מאות תלמידים של הגאון מווילנה עלו לארץ ישראל והתיישבו בצפת ובירושלים. הם ייסדו את ״הפרושים,״ קהילה אשכנזית שהחיתה את הנוכחות היהודית בארץ. עלייתם הייתה מהגלים הממוסדים הראשונים לפני עליות הציונות.",
    "rank": 84
  },
  {
    "id": "jh_knesset",
    "deck": "jewish",
    "title": "הבחירות הראשונות לכנסת",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "ב־25 בינואר, כתשעה חודשים אחרי הקמת המדינה, נערכו הבחירות הראשונות לכנסת ישראל. מפא״י בהנהגת בן גוריון זכתה ב־46 מושבים, ובן גוריון הקים את הממשלה הראשונה. 86.9% מהזכאים הצביעו, שיעור שלא חזר על עצמו.",
    "rank": 85
  },
  {
    "id": "jh_law_return",
    "deck": "jewish",
    "title": "חוק השבות",
    "start": 1950,
    "end": 1950,
    "date": "1950",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "הכנסת חוקקה את חוק השבות, המעניק לכל יהודי את הזכות לעלות לישראל ולקבל אזרחות. החוק מבטא את ייעודה של ישראל כבית לאומי לעם היהודי. תיקון מאוחר הרחיב את הזכות לבני משפחה, ועורר ויכוח על ההגדרה ״מיהו יהודי.״",
    "rank": 86
  },
  {
    "id": "jh_reform_movement",
    "deck": "jewish",
    "title": "לידת היהדות הרפורמית",
    "start": 1810,
    "end": 1820,
    "date": "בערך ⁦1810–1820⁩",
    "place": "המבורג, גרמניה",
    "lat": 53.551,
    "lon": 9.993,
    "desc": "בית הכנסת הרפורמי הראשון נפתח בהמבורג, עם תפילה בגרמנית, עוגב ושינויים בסדר התפילה. תנועת הרפורמה ביקשה להתאים את היהדות לעידן המודרני. היא התפשטה לאמריקה ומונה היום מיליוני חברים, בעיקר בארצות הברית.",
    "rank": 87
  },
  {
    "id": "jh_yiddish",
    "deck": "jewish",
    "title": "פריחת ספרות היידיש",
    "start": 1860,
    "end": 1940,
    "date": "בערך ⁦1860–1940⁩",
    "place": "מזרח אירופה",
    "lat": 52.23,
    "lon": 21.01,
    "desc": "מנדלי מוכר ספרים, שלום עליכם ויצחק לייבוש פרץ כתבו את יצירות המופת של ספרות היידיש, שביטאו את חיי היהודים בשטעטל ובעיר הגדולה. יצחק בשביס זינגר זכה בפרס נובל לספרות ב־1978. השואה הכחידה את רוב דוברי היידיש.",
    "rank": 88
  },
  {
    "id": "jh_massada_revolt",
    "deck": "jewish",
    "title": "ייסוד הטכניון בחיפה",
    "start": 1924,
    "end": 1924,
    "date": "1924",
    "place": "חיפה, ישראל",
    "lat": 32.776,
    "lon": 35.024,
    "desc": "הטכניון נפתח כמוסד ההשכלה הגבוהה הראשון בארץ ישראל. ״מלחמת השפות״ ב־1913 הכריעה שהעברית, ולא הגרמנית, תהיה שפת ההוראה. הטכניון הפך לאחד ממכוני המחקר המובילים בעולם ולמנוע של תעשיית הטכנולוגיה הישראלית.",
    "rank": 89
  },
  {
    "id": "jh_technion",
    "deck": "jewish",
    "title": "ייסוד האוניברסיטה העברית",
    "start": 1925,
    "end": 1925,
    "date": "1925",
    "place": "ירושלים, ישראל",
    "lat": 31.793,
    "lon": 35.245,
    "desc": "האוניברסיטה העברית נפתחה בטקס על הר הצופים בנוכחות בלפור, ויצמן ואלנבי. היא הייתה ביטוי לשאיפה ליצור מרכז אקדמי יהודי בארץ ישראל. איינשטיין היה מחברי הנאמנים הראשונים, ופרויד תרם את ספרייתו.",
    "rank": 90
  },
  {
    "id": "jh_maimonides_controversy",
    "deck": "jewish",
    "title": "מחלוקת הרמב״ם",
    "start": 1232,
    "end": 1232,
    "date": "בערך 1232",
    "place": "מונפלייה, צרפת",
    "lat": 43.611,
    "lon": 3.877,
    "desc": "רבנים בצרפת שרפו את כתבי הרמב״ם, במיוחד את ״מורה הנבוכים,״ בטענה שהפילוסופיה מערערת את האמונה. המחלוקת חילקה את העולם היהודי לדורות: תומכי הלימוד הרציונלי מול מי שדגלו בגישה מסורתית בלבד.",
    "rank": 91
  },
  {
    "id": "jh_bnei_akiva",
    "deck": "jewish",
    "title": "הקמת בני עקיבא",
    "start": 1929,
    "end": 1929,
    "date": "1929",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.23,
    "desc": "תנועת הנוער הציונית-דתית ״בני עקיבא״ נוסדה בירושלים ושילבה לימוד תורה עם עבודת האדמה. היא הפכה לתנועת הנוער הגדולה בעולם היהודי, עם סניפים בעשרות מדינות, ועיצבה את הציונות הדתית כזרם פוליטי ותרבותי.",
    "rank": 92
  },
  {
    "id": "jh_exodus_ship",
    "deck": "jewish",
    "title": "פרשת האקסודוס",
    "start": 1947,
    "end": 1947,
    "date": "1947",
    "place": "חיפה, ישראל",
    "lat": 32.81,
    "lon": 34.98,
    "desc": "ספינת מעפילים ובה 4,500 ניצולי שואה עוכבה על ידי הצי הבריטי מול חופי חיפה והנוסעים הוחזרו בכוח לגרמניה. התמונות עוררו גל אהדה בינלאומית ותרמו להחלטת האו״ם בנושא חלוקת ארץ ישראל.",
    "rank": 93
  },
  {
    "id": "jh_bund",
    "deck": "jewish",
    "title": "הקמת הבונד — מפלגת הפועלים היהודית",
    "start": 1897,
    "end": 1897,
    "date": "1897",
    "place": "וילנה, ליטא",
    "lat": 54.687,
    "lon": 25.28,
    "desc": "הבונד נוסד בוילנה כמפלגה סוציאליסטית יהודית שדגלה באוטונומיה תרבותית בגולה ובשפת היידיש, בניגוד לציונות. הוא היה מהמפלגות הגדולות והמאורגנות ביותר ברוסיה ובפולין עד שהשואה הכחידה את בסיס הכוח שלו.",
    "rank": 94
  },
  {
    "id": "jh_dimona",
    "deck": "jewish",
    "title": "הקמת הכור הגרעיני בדימונה",
    "start": 1958,
    "end": 1963,
    "date": "⁦1958–1963⁩",
    "place": "דימונה, ישראל",
    "lat": 31.07,
    "lon": 35.15,
    "desc": "ישראל הקימה כור גרעיני בנגב בסיוע צרפתי, תחת עטיפה של ״מפעל טקסטיל.״ ישראל מעולם לא אישרה ולא הכחישה שיש לה נשק גרעיני — מדיניות העמימות. הכור הפך את ישראל למעצמה גרעינית אזורית.",
    "rank": 95
  },
  {
    "id": "jh_aliyah_third",
    "deck": "jewish",
    "title": "העלייה השלישית",
    "start": 1919,
    "end": 1923,
    "date": "⁦1919–1923⁩",
    "place": "ארץ ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "כ־40,000 עולים, בעיקר מרוסיה ופולין, הגיעו אחרי מלחמת העולם הראשונה והצהרת בלפור. הם ייסדו את ההסתדרות, הקימו קיבוצים חדשים ובנו כבישים ותשתיות. העלייה השלישית חיזקה את המוסדות המדיניים של היישוב.",
    "rank": 96
  },
  {
    "id": "jh_mendelssohn",
    "deck": "jewish",
    "title": "משה מנדלסון מתרגם את התורה לגרמנית",
    "start": 1783,
    "end": 1783,
    "date": "1783",
    "place": "ברלין, גרמניה",
    "lat": 52.52,
    "lon": 13.405,
    "desc": "הפילוסוף משה מנדלסון פרסם תרגום של התורה לגרמנית באותיות עבריות, עם ביאור משלו. התרגום עורר ויכוח חריף: חסידים שרפו אותו, אך הוא פתח את שער ההשכלה האירופית בפני יהודים רבים. מנדלסון נחשב לאבי ההשכלה היהודית.",
    "rank": 97
  },
  {
    "id": "jh_oslo_intifada",
    "deck": "jewish",
    "title": "מבצע חומת מגן",
    "start": 2002,
    "end": 2002,
    "date": "2002",
    "place": "הגדה המערבית",
    "lat": 32.22,
    "lon": 35.25,
    "desc": "אחרי גל פיגועי התאבדות שהגיע לשיאו בפיגוע בפסח במלון פארק בנתניה, צה״ל נכנס לערי הרשות הפלסטינית. בקרב בג׳נין נהרגו 23 חיילי צה״ל ועשרות פלסטינים. המבצע הפחית את הפיגועים אך העמיק את המשבר.",
    "rank": 98
  },
  {
    "id": "jh_sephardic_golden",
    "deck": "jewish",
    "title": "תור הזהב של יהדות ספרד",
    "start": 900,
    "end": 1150,
    "date": "בערך ⁦900–1150⁩",
    "place": "קורדובה, ספרד",
    "lat": 37.879,
    "lon": -4.78,
    "desc": "תחת שלטון מוסלמי סובלני, פרחו בספרד שירה עברית (שלמה אבן גבירול, יהודה הלוי), פילוסופיה ומדע. חסדאי אבן שפרוט כיהן כשר החוץ של ח׳ליף קורדובה. זו הייתה תקופת היצירה התרבותית הגדולה ביותר של יהדות הגולה.",
    "rank": 99
  },
  {
    "id": "jh_disengagement",
    "deck": "jewish",
    "title": "תוכנית ההתנתקות מרצועת עזה",
    "start": 2005,
    "end": 2005,
    "date": "2005",
    "place": "רצועת עזה",
    "lat": 31.35,
    "lon": 34.31,
    "desc": "ממשלת שרון החליטה לפנות את כל ההתנחלויות מרצועת עזה ולהוציא את צה״ל מהרצועה. כ־8,000 מתנחלים פונו, חלקם בכוח. ההתנתקות חילקה את החברה הישראלית ולא הביאה לשקט — חמאס השתלט על עזה ב־2007.",
    "rank": 100
  },
  {
    "id": "jh_gaon_period",
    "deck": "jewish",
    "title": "תקופת הגאונים בבבל",
    "start": 589,
    "end": 1038,
    "date": "בערך ⁦589–1038⁩ לספירה",
    "place": "סורא ופומבדיתא, בבל (עיראק)",
    "lat": 32.6,
    "lon": 44.4,
    "desc": "ראשי הישיבות בבבל, שנקראו ״גאונים,״ שימשו כסמכות הלכתית עליונה של כל העולם היהודי. הם ענו על שאלות הלכתיות (תשובות הגאונים) מקהילות רחוקות וקבעו נוסח תפילה ומנהגים. תקופתם סימנה את שיא ההנהגה הרוחנית מבבל.",
    "rank": 101
  },
  {
    "id": "jh_chmielnitsky",
    "deck": "jewish",
    "title": "גזרות ת״ח ות״ט — טבח חמלניצקי",
    "start": 1648,
    "end": 1649,
    "date": "⁦1648–1649⁩",
    "place": "אוקראינה",
    "lat": 49,
    "lon": 31,
    "desc": "במרד הקוזקים של בוגדן חמלניצקי נגד פולין, נטבחו עשרות אלפי יהודים באוקראינה. קהילות שלמות נהרסו באכזריות שלא נודעה מאז מסעי הצלב. הטבח ערער את ביטחון יהדות פולין ויצר קרקע למשיחיות של שבתי צבי.",
    "rank": 102
  },
  {
    "id": "jh_mahapach",
    "deck": "jewish",
    "title": "המהפך — בגין עולה לשלטון",
    "start": 1977,
    "end": 1977,
    "date": "1977",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "מנחם בגין והליכוד ניצחו בבחירות אחרי 29 שנות שלטון רצוף של מפא״י ומערך. ״המהפך״ ביטא את כוחם של יהודי המזרח ושל המעמדות שחשו מודרים. בגין שינה את פני הפוליטיקה הישראלית וחתם על שלום עם מצרים.",
    "rank": 103
  },
  {
    "id": "jh_jericho",
    "deck": "jewish",
    "title": "כיבוש יריחו בידי יהושע",
    "start": -1200,
    "end": -1200,
    "date": "בערך המאה ה־13 לפנה״ס",
    "place": "יריחו, ישראל",
    "lat": 31.871,
    "lon": 35.444,
    "desc": "לפי ספר יהושע, בני ישראל חצו את הירדן וכבשו את יריחו אחרי שבעה ימים של הקפה, שבהם חומות העיר נפלו. הסיפור פותח את תקופת ההתנחלות בארץ כנען. הממצאים הארכיאולוגיים שנויים במחלוקת בנוגע לתיארוך.",
    "rank": 104
  },
  {
    "id": "jh_dead_sea_war",
    "deck": "jewish",
    "title": "מלחמת המגילות — קרב בני האור בבני החושך",
    "start": -150,
    "end": -50,
    "date": "בערך המאות ה־2–1 לפנה״ס",
    "place": "קומראן, ישראל",
    "lat": 31.741,
    "lon": 35.459,
    "desc": "כת מדבר יהודה, כנראה האיסיים, התבדלה מהחברה היהודית והתגוררה בקומראן. הם חיו חיי קדושה ומשמעת, כתבו מגילות והתכוננו למלחמה קוסמית בין אור לחושך. הכת מאירה את המגוון הדתי של היהדות לפני החורבן.",
    "rank": 105
  },
  {
    "id": "jh_spinoza",
    "deck": "jewish",
    "title": "חרם ברוך שפינוזה",
    "start": 1656,
    "end": 1656,
    "date": "1656",
    "place": "אמסטרדם, הולנד",
    "lat": 52.37,
    "lon": 4.895,
    "desc": "הקהילה היהודית הספרדית באמסטרדם הטילה חרם על שפינוזה בן ה־23 בשל דעותיו הכפרניות. שפינוזה פיתח פילוסופיה רציונליסטית שערערה על הסמכות הדתית. הוא נחשב לאבי הביקורת המקראית המודרנית ולאחד מאבות הנאורות.",
    "rank": 106
  },
  {
    "id": "jh_leon_uris",
    "deck": "jewish",
    "title": "פרסום הרומן ״אקסודוס״ של ליאון יוריס",
    "start": 1958,
    "end": 1958,
    "date": "1958",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.749,
    "lon": -73.968,
    "desc": "הרומן ההיסטורי ״אקסודוס״ סיפר את סיפור הקמת מדינת ישראל והפך לרב מכר עולמי. הוא שינה את תדמית ישראל בעולם ועורר גל אהדה ועלייה. הסרט שנבנה עליו ב־1960, בכיכובו של פול ניומן, חיזק את ההשפעה.",
    "rank": 107
  },
  {
    "id": "jh_rachel",
    "deck": "jewish",
    "title": "פטירת המשוררת רחל",
    "start": 1931,
    "end": 1931,
    "date": "1931",
    "place": "תל אביב, ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "רחל בלובשטיין, ״רחל המשוררת,״ נפטרה מהשחפת בתל אביב. שיריה הפשוטים והמרגשים, כמו ״כנרת שלי,״ ביטאו געגוע לנוף ולקיבוץ והפכו לחלק מהתרבות הישראלית. היא היתה מהמשוררות העבריות הראשונות שכתבו על חוויה אישית ונשית.",
    "rank": 108
  },
  {
    "id": "jh_agnon_nobel",
    "deck": "jewish",
    "title": "עגנון זוכה בפרס נובל לספרות",
    "start": 1966,
    "end": 1966,
    "date": "1966",
    "place": "שטוקהולם, שוודיה",
    "lat": 59.329,
    "lon": 18.069,
    "desc": "שמואל יוסף עגנון הפך לסופר הישראלי הראשון שזכה בפרס נובל לספרות, על יצירותיו ״תמול שלשום,״ ״סיפור פשוט״ ועוד. עגנון שילב בכתיבתו מקורות תלמודיים עם מודרניזם ויצר שפה עברית ייחודית שעיצבה את הספרות הישראלית.",
    "rank": 109
  },
  {
    "id": "jh_hatikvah",
    "deck": "jewish",
    "title": "כתיבת השיר ״התקווה״",
    "start": 1878,
    "end": 1878,
    "date": "1878",
    "place": "יאשי, רומניה",
    "lat": 47.157,
    "lon": 27.587,
    "desc": "נפתלי הרץ אימבר כתב את השיר ״תקוותנו,״ שהתגלגל לימים ל״התקווה.״ השיר אומץ בקונגרס הציוני ולאחר הקמת המדינה הפך להמנון הלאומי של ישראל. ״עוד לא אבדה תקוותנו, התקווה בת שנות אלפיים״ — ביטוי לשאיפת העם ליציאה מן הגלות.",
    "rank": 110
  },
  {
    "id": "jh_likud",
    "deck": "jewish",
    "title": "הקמת תנועת הליכוד",
    "start": 1973,
    "end": 1973,
    "date": "1973",
    "place": "תל אביב, ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "אריאל שרון יזם את איחוד מפלגות הימין לתנועת הליכוד, תחת הנהגת מנחם בגין. הליכוד הציע חזון לאומי שונה ממפא״י, שהתנגד לנסיגות ושאף לשליטה בכל ארץ ישראל. ב־1977 עלה הליכוד לשלטון במהפך ומאז הוא אחד משני הגושים המרכזיים.",
    "rank": 111
  },
  {
    "id": "jh_treblinka",
    "deck": "jewish",
    "title": "מחנה ההשמדה טרבלינקה",
    "start": 1942,
    "end": 1943,
    "date": "⁦1942–1943⁩",
    "place": "טרבלינקה, פולין",
    "lat": 52.631,
    "lon": 22.051,
    "desc": "מחנה ההשמדה טרבלינקה פעל כ־14 חודשים בלבד אך נרצחו בו כ־900,000 יהודים, רובם מגטו ורשה. ההרג היה יעיל ומהיר — רוב הנספים נרצחו ביום הגעתם. באוגוסט 1943 פרץ מרד, והנאצים סגרו את המחנה ומחקו את עקבותיו.",
    "rank": 112
  },
  {
    "id": "jh_mizrachi_party",
    "deck": "jewish",
    "title": "הקמת תנועת המזרחי",
    "start": 1902,
    "end": 1902,
    "date": "1902",
    "place": "וילנה, ליטא",
    "lat": 54.687,
    "lon": 25.28,
    "desc": "הרב יצחק יעקב ריינס הקים את תנועת ״המזרחי,״ סיעה ציונית-דתית, בסיסמה ״ארץ ישראל לעם ישראל על פי תורת ישראל.״ המזרחי שילב ציונות מדינית עם שמירת מצוות, בניגוד לרוב הרבנים שהתנגדו לציונות. מהמזרחי צמח הציונות הדתית.",
    "rank": 113
  },
  {
    "id": "jh_jews_poland",
    "deck": "jewish",
    "title": "ייסוד קהילת יהודי פולין",
    "start": 1264,
    "end": 1264,
    "date": "1264",
    "place": "קליש, פולין",
    "lat": 51.768,
    "lon": 18.092,
    "desc": "בולסלב האדוק, נסיך פולין, הוציא את ״צ׳רטר קליש,״ שהעניק ליהודים חופש דת, מסחר ומשפט עצמי. המסמך משך יהודים שנרדפו ממערב אירופה, ופולין הפכה למרכז היהודי הגדול ביותר בעולם. זו הייתה תחילת 700 שנות נוכחות יהודית מרכזית בפולין.",
    "rank": 114
  },
  {
    "id": "jh_ottoman_safed",
    "deck": "jewish",
    "title": "פריחת צפת — מרכז הקבלה",
    "start": 1530,
    "end": 1590,
    "date": "בערך ⁦1530–1590⁩",
    "place": "צפת, ישראל",
    "lat": 32.964,
    "lon": 35.497,
    "desc": "צפת הפכה תחת השלטון העות׳מאני למרכז הקבלה החשוב בעולם. האר״י הקדוש (רבי יצחק לוריא) פיתח את הקבלה הלוריאנית, ורבי יוסף קארו כתב את ה״שולחן ערוך.״ מצפת יצאו שתי היצירות ההלכתיות והמיסטיות המשפיעות ביותר ביהדות.",
    "rank": 115
  },
  {
    "id": "jh_shulchan_aruch",
    "deck": "jewish",
    "title": "השולחן ערוך",
    "start": 1565,
    "end": 1565,
    "date": "1565",
    "place": "צפת, ישראל",
    "lat": 32.964,
    "lon": 35.497,
    "desc": "רבי יוסף קארו פרסם את ה״שולחן ערוך,״ קיצור הלכתי שיטתי שהפך לקוד ההלכתי המוסמך ביותר ביהדות. הרמ״א הוסיף הגהות אשכנזיות, ויחד הפכו את הספר למדריך ההלכתי המרכזי לכל הזרמים.",
    "rank": 116
  },
  {
    "id": "jh_histadrut",
    "deck": "jewish",
    "title": "הקמת ההסתדרות",
    "start": 1920,
    "end": 1920,
    "date": "1920",
    "place": "חיפה, ישראל",
    "lat": 32.81,
    "lon": 34.98,
    "desc": "ההסתדרות הכללית של העובדים העברים בארץ ישראל נוסדה בחיפה. מעבר לאיגוד מקצועי, היא הפעילה קופת חולים, חברות בנייה, בנק ומשק חקלאי. ההסתדרות הייתה מעין מדינה בתוך מדינה, והנהגתה (בן גוריון, גולדה מאיר) הנהיגה את היישוב.",
    "rank": 117
  },
  {
    "id": "jh_night",
    "deck": "jewish",
    "title": "אלי ויזל מפרסם את ״הלילה״",
    "start": 1958,
    "end": 1958,
    "date": "1958",
    "place": "פריז, צרפת",
    "lat": 48.856,
    "lon": 2.352,
    "desc": "אלי ויזל, ניצול אושוויץ, פרסם את עדות ״הלילה,״ ספר קצר ומזעזע שהפך ליצירה המרכזית של ספרות השואה. ויזל הפך לדובר הבולט ביותר של ניצולי השואה וזכה בפרס נובל לשלום ב־1986.",
    "rank": 118
  },
  {
    "id": "jh_birobidzhan",
    "deck": "jewish",
    "title": "אזור היהודים האוטונומי בבירובידז׳אן",
    "start": 1934,
    "end": 1934,
    "date": "1934",
    "place": "בירובידז׳אן, ברית המועצות",
    "lat": 48.794,
    "lon": 132.921,
    "desc": "סטלין הקים ״אזור יהודי אוטונומי״ במזרח הרחוק של ברית המועצות, כחלופה לציונות. תנאי האקלים הקשים, הריחוק והדיכוי הסובייטי גרמו לרוב המתיישבים לעזוב. הניסוי לבנות ״מולדת יהודית סובייטית״ נחל כישלון.",
    "rank": 119
  },
  {
    "id": "jh_palmach",
    "deck": "jewish",
    "title": "הקמת הפלמ״ח",
    "start": 1941,
    "end": 1941,
    "date": "1941",
    "place": "ארץ ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "הפלמ״ח הוקם כזרוע ההכאה של ההגנה, כוח קבע של לוחמים מגויסים. הפלמ״ח לחם נגד הבריטים, הגן על הגבולות ותרם לניצחון במלחמת העצמאות. בין מפקדיו היו יגאל אלון ויצחק רבין, ותרבות הפלמ״ח עיצבה את דמות הצבר הישראלי.",
    "rank": 120
  },
  {
    "id": "jh_chabad",
    "deck": "jewish",
    "title": "ייסוד חב״ד",
    "start": 1775,
    "end": 1775,
    "date": "בערך 1775",
    "place": "ליאדי, בלארוס",
    "lat": 54.88,
    "lon": 30.67,
    "desc": "רבי שניאור זלמן מליאדי ייסד את חסידות חב״ד (חכמה, בינה, דעת) ושילב תורת החסידות עם לימוד אינטלקטואלי עמוק. ספרו ״התניא״ הפך ליצירת היסוד של החסידות. חב״ד התפשטה ברחבי העולם, ובמאה ה־20 הפכה לתנועה עולמית בהנהגת הרבי מלובביץ׳.",
    "rank": 121
  },
  {
    "id": "jh_aleppo_codex",
    "deck": "jewish",
    "title": "כתר ארם צובא",
    "start": 930,
    "end": 930,
    "date": "בערך 930 לספירה",
    "place": "טבריה, ישראל",
    "lat": 32.794,
    "lon": 35.531,
    "desc": "כתב יד המקרא השלם המנוקד העתיק ביותר הוגה בידי אהרן בן אשר בטבריה. הרמב״ם הכיר בו כנוסח המוסמך ביותר. הכתר עבר לחלב (ארם צובא) ונשמר שם מאות שנים, עד שהוברח לישראל בשנות ה־50 — אך כרבע ממנו אבד.",
    "rank": 122
  },
  {
    "id": "jh_sassoon",
    "deck": "jewish",
    "title": "יהודי בגדאד — שושלת ששון",
    "start": 1830,
    "end": 1920,
    "date": "בערך ⁦1830–1920⁩",
    "place": "בגדאד, עיראק ובומביי, הודו",
    "lat": 33.315,
    "lon": 44.366,
    "desc": "משפחת ששון מבגדאד בנתה אימפריה מסחרית שפעלה מהודו ועד סין. הם נקראו ״הרוטשילדים של המזרח.״ יהודי עיראק מילאו תפקיד מרכזי במסחר, בתרבות ובמוסיקה, עד שנאלצו לעזוב בראשית שנות ה־50.",
    "rank": 123
  },
  {
    "id": "jh_dreyfus_zola",
    "deck": "jewish",
    "title": "״ז׳אקוז!״ — אמיל זולא מגן על דרייפוס",
    "start": 1898,
    "end": 1898,
    "date": "1898",
    "place": "פריז, צרפת",
    "lat": 48.856,
    "lon": 2.352,
    "desc": "הסופר אמיל זולא פרסם מכתב גלוי לנשיא צרפת בעיתון ״לאורור,״ שבו האשים את הצבא במעשה שקר ואי צדק כלפי דרייפוס. ״ז׳אקוז!״ הפך לסמל של מאבק לצדק ולאומץ אינטלקטואלי. המכתב הוביל בסופו של דבר לזיכויו של דרייפוס.",
    "rank": 124
  },
  {
    "id": "jh_galut_france",
    "deck": "jewish",
    "title": "גירוש היהודים מצרפת",
    "start": 1306,
    "end": 1306,
    "date": "1306",
    "place": "פריז, צרפת",
    "lat": 48.856,
    "lon": 2.352,
    "desc": "פיליפ הרביעי גירש את כל יהודי צרפת, כ־100,000, והחרים את רכושם. היהודים הוחזרו ב־1315, גורשו שוב ב־1322 ושוב ב־1394. הגירושים החוזרים הביאו לסוף הנוכחות היהודית בצרפת עד המהפכה הצרפתית.",
    "rank": 125
  },
  {
    "id": "jh_nachmanides",
    "deck": "jewish",
    "title": "הוויכוח של הרמב״ן בברצלונה",
    "start": 1263,
    "end": 1263,
    "date": "1263",
    "place": "ברצלונה, ספרד",
    "lat": 41.385,
    "lon": 2.173,
    "desc": "רבי משה בן נחמן (הרמב״ן) ייצג את היהדות בוויכוח דתי פומבי מול הנזיר פבלו כריסטיאני בחצר המלך חיימה הראשון. הרמב״ן ויתר הרמב״ן הגן על האמונה היהודית בעוז. לאחר מכן עלה לארץ ישראל והקים בית כנסת בירושלים.",
    "rank": 126
  },
  {
    "id": "jh_lehi",
    "deck": "jewish",
    "title": "הקמת הלח״י",
    "start": 1940,
    "end": 1940,
    "date": "1940",
    "place": "ארץ ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "אברהם שטרן (יאיר) פרש מהאצ״ל והקים את לוחמי חירות ישראל (לח״י), שנלחמו בבריטים גם בזמן מלחמת העולם. הלח״י ביצעו פעולות נועזות, כולל רצח לורד מוין ב־1944. חברי הארגון, ובהם יצחק שמיר, עיצבו את הזהות הישראלית הלחימתית.",
    "rank": 127
  },
  {
    "id": "jh_mapai",
    "deck": "jewish",
    "title": "הקמת מפא״י",
    "start": 1930,
    "end": 1930,
    "date": "1930",
    "place": "תל אביב, ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "מפלגת פועלי ארץ ישראל נוסדה מאיחוד אחדות העבודה והפועל הצעיר, בהנהגת דוד בן גוריון. מפא״י הנהיגה את היישוב ואחר כך את המדינה 29 שנה, בנתה את המוסדות, קלטה עלייה ופיקדה על הצבא. היא היתה המפלגה הדומיננטית בתולדות ישראל.",
    "rank": 128
  },
  {
    "id": "jh_immigration_ussr",
    "deck": "jewish",
    "title": "עליית יהודי ברית המועצות",
    "start": 1990,
    "end": 2000,
    "date": "⁦1990–2000⁩",
    "place": "ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "עם נפילת מסך הברזל, כמיליון יהודים מברית המועצות עלו לישראל תוך עשור. הם הביאו עימם השכלה גבוהה, תרבות רוסית ותפיסת עולם חילונית. העלייה הגדולה שינתה את הדמוגרפיה, הכלכלה והתרבות של ישראל.",
    "rank": 129
  },
  {
    "id": "jh_temple_mount",
    "deck": "jewish",
    "title": "ביקור שרון בהר הבית",
    "start": 2000,
    "end": 2000,
    "date": "2000",
    "place": "ירושלים, ישראל",
    "lat": 31.778,
    "lon": 35.235,
    "desc": "אריאל שרון ביקר בהר הבית בליווי שוטרים, מעשה שרבים ראו בו פרובוקציה. הפלסטינים הגיבו בהפגנות אלימות שהתגלגלו לאינתיפאדה השנייה. הביקור עצמו לא גרם את ההתקוממות, אך שימש טריגר לכעס שהצטבר לאחר כישלון שיחות קמפ דיוויד.",
    "rank": 130
  },
  {
    "id": "jh_hannah_senesh",
    "deck": "jewish",
    "title": "חנה סנש קופצת מעל הונגריה",
    "start": 1944,
    "end": 1944,
    "date": "1944",
    "place": "הונגריה",
    "lat": 47.498,
    "lon": 19.04,
    "desc": "חנה סנש, משוררת צעירה מארץ ישראל, צנחה מעל יוגוסלביה כחלק ממשימה בריטית להציל יהודים הונגרים. היא נתפסה, עונתה ונורתה. שיריה (״הליכה לקיסריה,״ ״אלי, אלי, שלא ייגמר לעולם״) הפכו לנכסי תרבות ישראלית.",
    "rank": 131
  },
  {
    "id": "jh_1947_hebron",
    "deck": "jewish",
    "title": "הקמת יד ושם",
    "start": 1953,
    "end": 1953,
    "date": "1953",
    "place": "ירושלים, ישראל",
    "lat": 31.774,
    "lon": 35.175,
    "desc": "הכנסת חוקקה את חוק הזיכרון ליד ושם, שהקים אתר הנצחה ומרכז תיעוד לשואה על הר הזיכרון בירושלים. יד ושם הפך למרכז העולמי לחקר השואה ולהנצחתה, עם מאגר שמות של מיליוני קורבנות ושדרת חסידי אומות העולם.",
    "rank": 132
  },
  {
    "id": "jh_wailing_wall_riots",
    "deck": "jewish",
    "title": "מאורעות הכותל",
    "start": 1929,
    "end": 1929,
    "date": "1929",
    "place": "ירושלים, ישראל",
    "lat": 31.777,
    "lon": 35.234,
    "desc": "ב־1928 הקים מופתי ירושלים, חאג׳ אמין אל חוסייני, מחלוקת על זכויות התפילה בכותל. בקיץ 1929 פרצו מהומות דמים שהתפשטו מירושלים לחברון, צפת ויפו. 133 יהודים ו־116 ערבים נהרגו, והאירועים חידדו את הסכסוך הלאומי.",
    "rank": 133
  },
  {
    "id": "jh_dead_sea_industry",
    "deck": "jewish",
    "title": "הקמת מפעלי ים המלח",
    "start": 1930,
    "end": 1930,
    "date": "1930",
    "place": "ים המלח, ישראל",
    "lat": 31.2,
    "lon": 35.37,
    "desc": "המהנדס משה נובומייסקי הקים את מפעלי ים המלח להפקת אשלג וברום מהים המלח. המפעל היה מפעל התעשייה הראשון והגדול ביותר בארץ ישראל ואחד הבסיסים הכלכליים של היישוב. כיום ״כיל״ היא חברת כימיקלים בינלאומית.",
    "rank": 134
  },
  {
    "id": "jh_tower_stockade",
    "deck": "jewish",
    "title": "התיישבות חומה ומגדל",
    "start": 1936,
    "end": 1939,
    "date": "⁦1936–1939⁩",
    "place": "ארץ ישראל",
    "lat": 32.5,
    "lon": 35.3,
    "desc": "בתגובה למרד הערבי הגדול ולהגבלות הבריטיות, הוקמו עשרות יישובים חדשים בתוך לילה אחד, עם חומה ומגדל שמירה. שיטת ההתיישבות יצרה עובדות בשטח ועיצבה את גבולות המדינה העתידית. 52 יישובים הוקמו בשיטה זו.",
    "rank": 135
  },
  {
    "id": "jh_trumpeldor",
    "deck": "jewish",
    "title": "נפילת תל חי",
    "start": 1920,
    "end": 1920,
    "date": "1920",
    "place": "תל חי, ישראל",
    "lat": 33.24,
    "lon": 35.57,
    "desc": "יוסף טרומפלדור ושבעה מגינים נפלו בקרב נגד תוקפים ערבים ביישוב תל חי בגליל העליון. על פי המסורת, מילותיו האחרונות היו ״אין דבר, טוב למות בעד ארצנו.״ תל חי הפך לסמל הגבורה הציונית ולמיתוס מכונן.",
    "rank": 136
  },
  {
    "id": "jh_israel_jordan_peace",
    "deck": "jewish",
    "title": "הסכם השלום עם ירדן",
    "start": 1994,
    "end": 1994,
    "date": "1994",
    "place": "הערבה, ישראל",
    "lat": 29.93,
    "lon": 35.12,
    "desc": "ישראל וירדן חתמו על הסכם שלום באזור הערבה, מעבר הגבול בדרום. המלך חוסיין ויצחק רבין חתמו על ההסכם שכלל הסדרת גבולות, שיתוף מים ויחסים דיפלומטיים. זהו הסכם השלום השני של ישראל עם מדינה ערבית.",
    "rank": 137
  },
  {
    "id": "jh_abraham_accords",
    "deck": "jewish",
    "title": "הסכמי אברהם",
    "start": 2020,
    "end": 2020,
    "date": "2020",
    "place": "וושינגטון, ארצות הברית",
    "lat": 38.897,
    "lon": -77.037,
    "desc": "ישראל חתמה על הסכמי נורמליזציה עם איחוד האמירויות, בחריין ומרוקו בתיווך אמריקני. ההסכמים סימנו פריצת דרך ביחסי ישראל והעולם הערבי, ללא פתרון לסוגיה הפלסטינית. טיסות ישירות, סחר ותיירות נפתחו בין המדינות.",
    "rank": 138
  },
  {
    "id": "jh_arava",
    "deck": "jewish",
    "title": "ייסוד עיר הנגב — באר שבע",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "באר שבע, ישראל",
    "lat": 31.252,
    "lon": 34.791,
    "desc": "אחרי מלחמת העצמאות הפכה באר שבע ממעין כפר לעיר פיתוח. בן גוריון ראה בנגב את עתיד ישראל ודגל ביישובו. באר שבע צמחה לעיר רבתי עם אוניברסיטה, בתי חולים ומרכז תעשייה, מחווה לחזון פיתוח הנגב.",
    "rank": 139
  },
  {
    "id": "jh_kotel_tunnels",
    "deck": "jewish",
    "title": "חשיפת מנהרות הכותל",
    "start": 1968,
    "end": 1985,
    "date": "⁦1968–1985⁩",
    "place": "ירושלים, ישראל",
    "lat": 31.777,
    "lon": 35.234,
    "desc": "חפירות ארכיאולוגיות לאורך הכותל המערבי חשפו את יתרת החומה שנעלמה מתחת למבנים מאוחרים, כולל אבנים עצומות מימי הורדוס, מנהרות ומקוואות. המנהרות מספקות עדות מרשימה להיקף הבנייה ולגדולתו של הר הבית.",
    "rank": 140
  },
  {
    "id": "jh_maimon_death",
    "deck": "jewish",
    "title": "פטירת הרמב״ם",
    "start": 1204,
    "end": 1204,
    "date": "1204",
    "place": "פוסטאט (קהיר), מצרים",
    "lat": 30.003,
    "lon": 31.231,
    "desc": "רבי משה בן מימון נפטר בקהיר בגיל 69 וגופתו הובלה לטבריה, שם קברו מהווה אתר עלייה לרגל עד היום. הרמב״ם הותיר מורשת אינטלקטואלית עצומה: הלכה, פילוסופיה, רפואה ומנהיגות קהילתית. השפעתו על היהדות אינה פוחתת.",
    "rank": 141
  },
  {
    "id": "jh_iraq_jews",
    "deck": "jewish",
    "title": "מבצע עזרא ונחמיה — עליית יהודי עיראק",
    "start": 1950,
    "end": 1951,
    "date": "⁦1950–1951⁩",
    "place": "עיראק וישראל",
    "lat": 33.315,
    "lon": 44.366,
    "desc": "כ־120,000 יהודי עיראק עלו לישראל בגשר אווירי לאחר שנאלצו לוותר על אזרחותם ורכושם. קהילת בבל, שהתקיימה 2,500 שנה, נעלמה כמעט לחלוטין. העולים מעיראק חוו קשיים בקליטה אך תרמו רבות לתרבות ולמוסיקה הישראלית.",
    "rank": 142
  },
  {
    "id": "jh_maalot",
    "deck": "jewish",
    "title": "הטבח במעלות",
    "start": 1974,
    "end": 1974,
    "date": "1974",
    "place": "מעלות, ישראל",
    "lat": 33.016,
    "lon": 35.272,
    "desc": "מחבלים מהחזית הדמוקרטית לשחרור פלסטין חדרו לבית ספר במעלות וכלאו 105 תלמידים כבני ערובה. בניסיון החילוץ נהרגו 22 תלמידים ומורה. האסון הכואב עיצב את מדיניות מאבק הטרור הישראלית ונחרת בזיכרון הקולקטיבי.",
    "rank": 143
  },
  {
    "id": "jh_mossad",
    "deck": "jewish",
    "title": "הקמת המוסד",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "ראובן שילוח, לפי הנחיית בן גוריון, הקים את ״המוסד למודיעין ולתפקידים מיוחדים.״ המוסד הפך לאחד מארגוני המודיעין המפורסמים בעולם, עם מבצעים כמו חטיפת אייכמן, חיסולי מחבלים ומבצעים חשאיים ברחבי העולם.",
    "rank": 144
  },
  {
    "id": "jh_arab_revolt_1936",
    "deck": "jewish",
    "title": "המרד הערבי הגדול בארץ ישראל",
    "start": 1936,
    "end": 1939,
    "date": "⁦1936–1939⁩",
    "place": "ארץ ישראל",
    "lat": 32,
    "lon": 35,
    "desc": "הערבים הפלסטינים מרדו בשלטון הבריטי ובהגירה היהודית. שביתה כללית, הפגנות ותקיפות נמשכו שלוש שנים. הבריטים דיכאו את המרד ומינו את ועדת פיל, שהמליצה לראשונה על חלוקת הארץ. המרד הקיף כ־5,000 הרוגים.",
    "rank": 145
  },
  {
    "id": "jh_begin_sadat",
    "deck": "jewish",
    "title": "ביקור סאדאת בישראל",
    "start": 1977,
    "end": 1977,
    "date": "1977",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "נשיא מצרים אנואר סאדאת הגיע לביקור היסטורי בישראל ונאם בכנסת. הביקור, שהפתיע את העולם כולו, שבר את הקרח בין ישראל למצרים והוביל להסכם קמפ דיוויד. בגין ציטט בנאומו: ״לא עוד מלחמה, לא עוד שפיכות דמים.״",
    "rank": 146
  },
  {
    "id": "jh_ugandan_proposal",
    "deck": "jewish",
    "title": "תוכנית אוגנדה",
    "start": 1903,
    "end": 1903,
    "date": "1903",
    "place": "באזל, שווייץ",
    "lat": 47.558,
    "lon": 7.587,
    "desc": "הרצל הציע בקונגרס הציוני השישי לייסד מקלט יהודי זמני במזרח אפריקה הבריטית (כיום קניה). ההצעה עוררה ויכוח סוער בין ״ציוני ציון״ ובין פרגמטיסטים, וכמעט פילגה את התנועה. התוכנית נדחתה בקונגרס הבא.",
    "rank": 147
  },
  {
    "id": "jh_emancipation",
    "deck": "jewish",
    "title": "אמנסיפציה — שוויון ליהודי צרפת",
    "start": 1791,
    "end": 1791,
    "date": "1791",
    "place": "פריז, צרפת",
    "lat": 48.856,
    "lon": 2.352,
    "desc": "האספה הלאומית הצרפתית העניקה ליהודים אזרחות שווה, בפעם הראשונה במדינה אירופית. ההחלטה ביטאה את עקרונות המהפכה הצרפתית והפכה לתקדים. במהלך המאה ה־19 קיבלו מדינות אירופיות נוספות חוקי אמנסיפציה ליהודים.",
    "rank": 148
  },
  {
    "id": "jh_yehuda_halevi",
    "deck": "jewish",
    "title": "יהודה הלוי כותב את ״הכוזרי״",
    "start": 1140,
    "end": 1140,
    "date": "בערך 1140",
    "place": "טולדו, ספרד",
    "lat": 39.857,
    "lon": -4.024,
    "desc": "המשורר והפילוסוף יהודה הלוי חיבר את ״הכוזרי,״ דיאלוג בין מלך הכוזרים לחכם יהודי, שמגן על ייחוד היהדות מול הפילוסופיה, הנצרות והאסלאם. הלוי שר את שירי הגעגוע לציון (״לבי במזרח ואנכי בסוף מערב״) ונדד בסוף חייו לארץ ישראל.",
    "rank": 149
  },
  {
    "id": "jh_irgun",
    "deck": "jewish",
    "title": "הקמת האצ״ל",
    "start": 1931,
    "end": 1931,
    "date": "1931",
    "place": "ארץ ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "הארגון הצבאי הלאומי (אצ״ל) פרש מההגנה בשל חילוקי דעות על מדיניות ההבלגה. הארגון דגל בתגובה צבאית תקיפה. תחת מנחם בגין, ניהל האצ״ל מרד אקטיבי נגד הבריטים, כולל פיצוץ מלון המלך דוד, ושימש בסיס פוליטי לליכוד.",
    "rank": 150
  },
  {
    "id": "jh_nuremberg_trials",
    "deck": "jewish",
    "title": "משפטי נירנברג",
    "start": 1945,
    "end": 1946,
    "date": "⁦1945–1946⁩",
    "place": "נירנברג, גרמניה",
    "lat": 49.454,
    "lon": 11.077,
    "desc": "בעלות הברית העמידו לדין 22 מנהיגים נאצים בכירים בפשעי מלחמה ופשעים נגד האנושות. 12 נידונו למוות ו־7 למאסר. המשפטים קבעו תקדים בינלאומי לאחריות אישית על פשעים המוניים, והניחו את הבסיס לבית הדין הפלילי הבינלאומי.",
    "rank": 151
  },
  {
    "id": "jh_kibbutz_galuyot",
    "deck": "jewish",
    "title": "מבצע שלמה — עליית יהודי אתיופיה",
    "start": 1991,
    "end": 1991,
    "date": "1991",
    "place": "אדיס אבבה, אתיופיה",
    "lat": 9.024,
    "lon": 38.747,
    "desc": "בתוך 36 שעות, העלתה ישראל 14,325 יהודים אתיופים ב־35 טיסות, כמה מהם ללא מושבים. המבצע בוצע בזמן שהמשטר באתיופיה קרס. ״מבצע שלמה״ הפגין את המחויבות לקיבוץ גלויות, אך קליטת העולים נתקלה בקשיים חברתיים וכלכליים.",
    "rank": 152
  },
  {
    "id": "jh_protocols",
    "deck": "jewish",
    "title": "פרסום ״הפרוטוקולים של זקני ציון״",
    "start": 1903,
    "end": 1903,
    "date": "1903",
    "place": "רוסיה",
    "lat": 55.756,
    "lon": 37.617,
    "desc": "המשטרה החשאית הרוסית חיברה זיוף אנטישמי שטען לחשוף ״תוכנית יהודית להשתלטות על העולם.״ הטקסט הופרך, אך התפשט ברחבי העולם ושימש דלק לאנטישמיות, כולל תעמולה נאצית. הפרוטוקולים הם תיעוד של הכוח ההרסני של תעמולת שנאה.",
    "rank": 153
  },
  {
    "id": "jh_galut_portugal",
    "deck": "jewish",
    "title": "גירוש והמרה כפויה של יהודי פורטוגל",
    "start": 1497,
    "end": 1497,
    "date": "1497",
    "place": "ליסבון, פורטוגל",
    "lat": 38.716,
    "lon": -9.139,
    "desc": "מלך פורטוגל מנואל הראשון גזר גירוש על כל יהודי פורטוגל, אך במקום גירוש ממשי הוביל אותם בכוח לטבילה נוצרית. אנוסים רבים המשיכו לשמור מצוות בסתר. קהילות ״קריפטו-יהודיות״ שרדו בפורטוגל עד המאה ה־20.",
    "rank": 154
  },
  {
    "id": "jh_terezin",
    "deck": "jewish",
    "title": "גטו טרזיינשטדט",
    "start": 1941,
    "end": 1945,
    "date": "⁦1941–1945⁩",
    "place": "טרזין, צ׳כיה",
    "lat": 50.512,
    "lon": 14.152,
    "desc": "הנאצים הקימו ״גטו מופת״ בעיירה טרזין, שנועד לשמש חלון ראווה של ״הומניות.״ חיי תרבות עשירים התנהלו בצל הרעב והמוות: אופרת ילדים, ציורים, הרצאות. רוב תושבי הגטו נשלחו לאושוויץ. ציורי ילדי טרזין הם מהעדויות המרגשות ביותר לשואה.",
    "rank": 155
  },
  {
    "id": "jh_sinai_campaign",
    "deck": "jewish",
    "title": "מבצע קדש — מלחמת סיני",
    "start": 1956,
    "end": 1956,
    "date": "1956",
    "place": "סיני, מצרים",
    "lat": 30,
    "lon": 33.5,
    "desc": "ישראל, בשיתוף פעולה עם בריטניה וצרפת, כבשה את חצי האי סיני בתגובה להתקפות פדאיון וסגירת מצרי טיראן. הלחץ האמריקני אילץ את ישראל לסגת, אך המבצע הוכיח את כוחה הצבאי והביא לשנים של שקט יחסי בגבול הדרומי.",
    "rank": 156
  },
  {
    "id": "jh_eilat",
    "deck": "jewish",
    "title": "כיבוש אילת — ״עובדה״",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "אילת, ישראל",
    "lat": 29.557,
    "lon": 34.952,
    "desc": "בימי הפסקת האש האחרונים של מלחמת העצמאות, כוחות צה״ל נעו דרומה וכבשו את אום ראשרש (אילת) ללא קרב. הנפת דגל הדיו ביום ש־10 במרס סימנה את השגת גישה ישראלית לים סוף, חיונית לסחר עם אסיה ואפריקה.",
    "rank": 157
  },
  {
    "id": "jh_ari_luria",
    "deck": "jewish",
    "title": "האר״י הקדוש — קבלת צפת",
    "start": 1570,
    "end": 1572,
    "date": "⁦1570–1572⁩",
    "place": "צפת, ישראל",
    "lat": 32.964,
    "lon": 35.497,
    "desc": "רבי יצחק לוריא (האר״י) הגיע לצפת ופיתח את הקבלה הלוריאנית: צמצום, שבירת הכלים ותיקון. למרות שחי בצפת רק שנתיים (ונפטר בגיל 38), תורתו חוללה מהפכה בהגות היהודית ועיצבה את התפילה, המנהגים ותנועת החסידות.",
    "rank": 158
  },
  {
    "id": "jh_yemenite_aliyah",
    "deck": "jewish",
    "title": "מבצע על כנפי נשרים — עליית יהודי תימן",
    "start": 1949,
    "end": 1950,
    "date": "⁦1949–1950⁩",
    "place": "תימן וישראל",
    "lat": 15.369,
    "lon": 44.191,
    "desc": "כ־49,000 יהודי תימן הועלו לישראל בגשר אווירי. רבים מהם לא ראו מטוס מימיהם וקראו למבצע ״על כנפי נשרים,״ על שם הפסוק. קהילת תימן, ששמרה על מסורות עתיקות, תרמה עושר תרבותי ייחודי לישראל — שירה, נקד, תכשיטים.",
    "rank": 159
  },
  {
    "id": "jh_rothschild",
    "deck": "jewish",
    "title": "הברון רוטשילד תומך במושבות בארץ ישראל",
    "start": 1882,
    "end": 1900,
    "date": "⁦1882–1900⁩",
    "place": "זיכרון יעקב, ישראל",
    "lat": 32.573,
    "lon": 34.958,
    "desc": "הברון אדמונד ג׳יימס דה רוטשילד מפריז תמך כלכלית בעשרות מושבות בארץ ישראל ומימן חקלאות, יקבים ותשתיות. בלי תמיכתו ספק אם העלייה הראשונה הייתה שורדת. הוא נקרא ״אבי היישוב״ והובא לקבורה מחדש בזיכרון יעקב ב־1954.",
    "rank": 160
  },
  {
    "id": "jh_maimonides_egypt",
    "deck": "jewish",
    "title": "הרמב״ם בורח מספרד למצרים",
    "start": 1165,
    "end": 1165,
    "date": "1165",
    "place": "פוסטאט (קהיר), מצרים",
    "lat": 30.003,
    "lon": 31.231,
    "desc": "אחרי נדודים בספרד, מרוקו וארץ ישראל, התיישב הרמב״ם בפוסטאט שבמצרים. הוא הפך לנגיד הקהילה היהודית ולרופא חצר הסולטאן צלאח אד-דין. במצרים חיבר את יצירותיו הגדולות: משנה תורה ומורה הנבוכים.",
    "rank": 161
  },
  {
    "id": "jh_dona_gracia",
    "deck": "jewish",
    "title": "דונה גרציה נשיא — מנהיגת האנוסים",
    "start": 1553,
    "end": 1569,
    "date": "⁦1553–1569⁩",
    "place": "קושטא, תורכיה",
    "lat": 41.008,
    "lon": 28.978,
    "desc": "דונה גרציה נשיא, מהנשים העשירות והמשפיעות בעולם, הפעילה רשת חילוץ אנוסים מפורטוגל לאימפריה העות׳מאנית. היא ארגנה חרם סחר על נמל אנקונה שבה נשרפו יהודים, וניסתה להקים מושבה יהודית בטבריה.",
    "rank": 162
  },
  {
    "id": "jh_shoah_law",
    "deck": "jewish",
    "title": "הסכם השילומים עם גרמניה",
    "start": 1952,
    "end": 1952,
    "date": "1952",
    "place": "לוקסמבורג",
    "lat": 49.611,
    "lon": 6.131,
    "desc": "ישראל וגרמניה חתמו על הסכם שילומים שבו גרמניה שילמה לישראל 3 מיליארד מרק כפיצוי על רכוש יהודי שנבזז. ההסכם עורר ויכוח סוער וקריאות ״דמי דם.״ בן גוריון טען שבלי השילומים המדינה תקרוס כלכלית. הכסף סייע לפיתוח תשתיות.",
    "rank": 163
  },
  {
    "id": "jh_galilee_boat",
    "deck": "jewish",
    "title": "גילוי סירת הכנרת העתיקה",
    "start": 1986,
    "end": 1986,
    "date": "1986",
    "place": "כנרת, ישראל",
    "lat": 32.82,
    "lon": 35.56,
    "desc": "בשנת בצורת שחשפה את חוף הכנרת, נמצאה סירת דייגים מתקופת בית שני. הסירה, שנקראה ״סירת ישו,״ תוארכה למאה ה־1 לספירה ומספקת עדות חומרית נדירה לחיי הדייגים בגליל בתקופה שבה חי ישו מנצרת.",
    "rank": 164
  },
  {
    "id": "jh_elijah_cave",
    "deck": "jewish",
    "title": "אליהו הנביא על הר הכרמל",
    "start": -870,
    "end": -870,
    "date": "בערך המאה ה־9 לפנה״ס",
    "place": "הר הכרמל, ישראל",
    "lat": 32.737,
    "lon": 34.983,
    "desc": "לפי מלכים א׳, אליהו הנביא ערך עימות דרמטי עם נביאי הבעל על הר הכרמל, שבו אש ירדה מן השמים על קרבנו. הסיפור מבטא את המאבק בין אמונת ישראל לפולחנים כנעניים. אליהו נחשב במסורת היהודית למבשר הגאולה.",
    "rank": 165
  },
  {
    "id": "jh_october_war_aftermath",
    "deck": "jewish",
    "title": "ועדת אגרנט",
    "start": 1974,
    "end": 1974,
    "date": "1974",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "ועדת חקירה בראשות שופט העליון שמעון אגרנט בדקה את המחדלים של מלחמת יום הכיפורים. הוועדה הטילה אחריות על הרמטכ״ל ועל ראש אמ״ן, אך פטרה את דיין וגולדה. הציבור לא קיבל את המסקנות, ובלחץ ציבורי התפטרה ממשלת מאיר.",
    "rank": 166
  },
  {
    "id": "jh_habima",
    "deck": "jewish",
    "title": "ייסוד תיאטרון הבימה",
    "start": 1918,
    "end": 1918,
    "date": "1918",
    "place": "מוסקבה, רוסיה",
    "lat": 55.756,
    "lon": 37.617,
    "desc": "תיאטרון הבימה, התיאטרון העברי הראשון, נוסד במוסקבה בהנהגת נחום צמח. ההצגה המפורסמת ״הדיבוק״ הפכה לסמל. הבימה עברה לארץ ישראל ב־1928 והפכה לתיאטרון הלאומי של ישראל.",
    "rank": 167
  },
  {
    "id": "jh_weizmann_institute",
    "deck": "jewish",
    "title": "הקמת מכון ויצמן למדע",
    "start": 1934,
    "end": 1934,
    "date": "1934",
    "place": "רחובות, ישראל",
    "lat": 31.908,
    "lon": 34.81,
    "desc": "חיים ויצמן, כימאי וראש ההסתדרות הציונית, הקים את מכון זיו (מאוחר יותר מכון ויצמן למדע) ברחובות. המכון הפך לאחד ממרכזי המחקר המובילים בעולם, במיוחד בכימיה, ביולוגיה ופיזיקה. ויצמן עצמו היה נשיא ישראל הראשון.",
    "rank": 168
  },
  {
    "id": "jh_lod_airport",
    "deck": "jewish",
    "title": "הטבח בנמל התעופה בלוד",
    "start": 1972,
    "end": 1972,
    "date": "1972",
    "place": "לוד, ישראל",
    "lat": 31.999,
    "lon": 34.894,
    "desc": "שלושה מחבלים יפנים מהצבא האדום היפני, ששלחו על ידי החזית העממית לשחרור פלסטין, ירו באש אוטומטית בטרמינל הנוסעים. 26 אנשים נהרגו ו־80 נפצעו. הפיגוע הראה כי הטרור הבינלאומי חורג מגבולות הסכסוך.",
    "rank": 169
  },
  {
    "id": "jh_moroccan_jews",
    "deck": "jewish",
    "title": "עליית יהודי מרוקו",
    "start": 1956,
    "end": 1964,
    "date": "⁦1956–1964⁩",
    "place": "מרוקו וישראל",
    "lat": 33.59,
    "lon": -7.61,
    "desc": "כ־160,000 יהודי מרוקו עלו לישראל, חלקם במסגרת מבצע יכין. קהילת מרוקו, הגדולה שבקהילות צפון אפריקה, הביאה עימה מסורת עשירה של פיוט, בישול, חינוך ומנהגים. יהודי מרוקו הפכו לקהילה הגדולה ביותר בישראל ממוצא ערבי-מוסלמי.",
    "rank": 170
  },
  {
    "id": "jh_shas",
    "deck": "jewish",
    "title": "הקמת תנועת ש״ס",
    "start": 1984,
    "end": 1984,
    "date": "1984",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "הרב עובדיה יוסף הקים את תנועת ש״ס, מפלגה דתית-חברתית שייצגה את יהודי המזרח. ש״ס שילבה הלכה ספרדית עם מאבק למען מודרים חברתיים, והפכה לכוח פוליטי גדול. הרב עובדיה, ״מרן,״ נחשב לפוסק הגדול של הדור ולמנהיג עדתי-רוחני.",
    "rank": 171
  },
  {
    "id": "jh_canal_zone",
    "deck": "jewish",
    "title": "מלחמת ההתשה",
    "start": 1967,
    "end": 1970,
    "date": "⁦1967–1970⁩",
    "place": "תעלת סואץ ובקעת הירדן",
    "lat": 30.5,
    "lon": 32.3,
    "desc": "מצרים ניהלה מלחמת התשה נגד ישראל לאורך תעלת סואץ, עם הפגזות, תקיפות אוויריות ופשיטות קומנדו. ישראל הגיבה בהפצצות עומק במצרים. מאות חיילים נהרגו משני הצדדים. המלחמה הסתיימה בהפסקת אש אמריקנית ב־1970.",
    "rank": 172
  },
  {
    "id": "jh_lydda_airport",
    "deck": "jewish",
    "title": "פתיחת נמל התעופה בן גוריון",
    "start": 1936,
    "end": 1936,
    "date": "1936",
    "place": "לוד, ישראל",
    "lat": 31.999,
    "lon": 34.894,
    "desc": "הבריטים פתחו את שדה התעופה בלוד (לידא), שהפך לשער האווירי המרכזי של ישראל. אחרי הקמת המדינה נקרא על שם בן גוריון ושימש כמרכז התעבורה האווירית, קליטת העלייה ונקודת חיבור לעולם.",
    "rank": 173
  },
  {
    "id": "jh_dead_sea_community",
    "deck": "jewish",
    "title": "ייסוד קהילת קומראן",
    "start": -150,
    "end": -130,
    "date": "בערך אמצע המאה ה־2 לפנה״ס",
    "place": "קומראן, ישראל",
    "lat": 31.741,
    "lon": 35.459,
    "desc": "קבוצה של כוהנים ופרושים הקימו קהילה מנותקת לצד ים המלח, ככל הנראה כמחאה נגד השחיתות במקדש. הם שמרו על טהרה קיצונית, חיו בשיתוף ועסקו בהעתקת כתבי קודש. מגילות ים המלח שנמצאו במערותיהם שינו את הבנת היהדות העתיקה.",
    "rank": 174
  },
  {
    "id": "jh_cairo_geniza",
    "deck": "jewish",
    "title": "גילוי הגניזה הקהירית",
    "start": 1896,
    "end": 1896,
    "date": "1896",
    "place": "קהיר, מצרים",
    "lat": 30.003,
    "lon": 31.231,
    "desc": "שלמה שכטר גילה בעליית הגג של בית הכנסת בן עזרא בקהיר אוסף עצום של כתבי יד מימי הביניים. הגניזה הכילה כ־300,000 קטעים: מכתבים, חוזים, שירים ותפילות, ושפכה אור חסר תקדים על חיי היהודים, המסחר והתרבות בעולם המוסלמי.",
    "rank": 175
  },
  {
    "id": "jh_yigael_yadin",
    "deck": "jewish",
    "title": "חפירות יגאל ידין במצדה",
    "start": 1963,
    "end": 1965,
    "date": "⁦1963–1965⁩",
    "place": "מצדה, ישראל",
    "lat": 31.316,
    "lon": 35.354,
    "desc": "הארכיאולוג יגאל ידין ניהל חפירות מקיפות במצדה, בהשתתפות אלפי מתנדבים מרחבי העולם. הממצאים — כולל מגילות, מקוואות ושרידי ארמון הורדוס — חיזקו את הקשר בין ישראל המודרנית לעברה ההיסטורי. מצדה הפכה לאתר מורשת עולמי.",
    "rank": 176
  },
  {
    "id": "jh_rothschild_wine",
    "deck": "jewish",
    "title": "ייסוד יקב ראשון לציון",
    "start": 1882,
    "end": 1882,
    "date": "1882",
    "place": "ראשון לציון, ישראל",
    "lat": 31.951,
    "lon": 34.789,
    "desc": "מתיישבי ראשון לציון, בתמיכת הברון רוטשילד, הקימו את היקב הראשון בארץ ישראל. יין כרמל הפך למותג הדגל של התעשייה היהודית בארץ. היקב היה מהמפעלים הראשונים של היישוב ועזר לממן את המושבות.",
    "rank": 177
  },
  {
    "id": "jh_war_attrition",
    "deck": "jewish",
    "title": "חיסול מחבלי מינכן",
    "start": 1972,
    "end": 1979,
    "date": "⁦1972–1979⁩",
    "place": "אירופה",
    "lat": 48.135,
    "lon": 11.582,
    "desc": "אחרי טבח הספורטאים הישראלים באולימפיאדת מינכן, הורתה גולדה מאיר על ״מבצע זעם האל״ — ציד שיטתי של מתכנני הפיגוע ברחבי אירופה. סוכני המוסד חיסלו כמה מטרות, אך גם חטאו למטרה (פרשת לילהמר). המבצע עיצב את תורת ההרתעה הישראלית.",
    "rank": 178
  },
  {
    "id": "jh_munich_1972",
    "deck": "jewish",
    "title": "טבח הספורטאים באולימפיאדת מינכן",
    "start": 1972,
    "end": 1972,
    "date": "1972",
    "place": "מינכן, גרמניה",
    "lat": 48.175,
    "lon": 11.548,
    "desc": "מחבלי ״ספטמבר השחור״ חדרו לכפר האולימפי ורצחו 11 ספורטאים ישראלים. ניסיון חילוץ גרמני כשל באופן טראגי. הטבח זעזע את העולם ושינה את נוהלי הביטחון באירועים בינלאומיים. ישראל ענתה בחיסולים ממוקדים.",
    "rank": 179
  },
  {
    "id": "jh_israel_philharmonic",
    "deck": "jewish",
    "title": "ייסוד התזמורת הפילהרמונית הישראלית",
    "start": 1936,
    "end": 1936,
    "date": "1936",
    "place": "תל אביב, ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "הכנר ברוניסלב הוברמן ייסד את התזמורת הפלסטינית (לימים הפילהרמונית הישראלית), שגייסה נגנים יהודים מאירופה ובכך הצילה אותם מהנאצים. הקונצרט הראשון נוצח על ידי ארטורו טוסקניני. התזמורת הפכה לאחת המובילות בעולם.",
    "rank": 180
  },
  {
    "id": "jh_black_panther",
    "deck": "jewish",
    "title": "הפנתרים השחורים הישראלים",
    "start": 1971,
    "end": 1971,
    "date": "1971",
    "place": "ירושלים, ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "צעירים ממוצא מזרחי ממוסלמות בשכונת מוסררה הקימו תנועת מחאה בשם ״הפנתרים השחורים.״ הם דרשו שוויון חברתי ומחו על אפליה עדתית. גולדה מאיר כינתה אותם ״לא נחמדים,״ אך המחאה שינתה את שיח הזהויות בישראל.",
    "rank": 181
  },
  {
    "id": "jh_olim_france",
    "deck": "jewish",
    "title": "גל עלייה מצרפת",
    "start": 2012,
    "end": 2020,
    "date": "⁦2012–2020⁩",
    "place": "צרפת וישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "אחרי פיגועים אנטישמיים (טולוז 2012, היפר כשר 2015), עלו אלפי יהודים מצרפת לישראל. צרפת הייתה לראשונה מקור העלייה הגדול ממערב אירופה. העולים, רבים מהם ממעמד בינוני-גבוה, התיישבו בעיקר בנתניה, רעננה ואשדוד.",
    "rank": 182
  },
  {
    "id": "jh_suez_war_context",
    "deck": "jewish",
    "title": "חטיפת האוניה אטלית",
    "start": 1946,
    "end": 1946,
    "date": "1946",
    "place": "הים התיכון",
    "lat": 32.7,
    "lon": 34.94,
    "desc": "הפלמ״ח תקף את מחנה המעצר הבריטי בעתלית וחילץ כ־200 מעפילים ניצולי שואה. המבצע, שבוצע בתחבולה ובהפתעה, היה אחד מהמבצעים הנועזים של המאבק נגד המנדט. מחנה עתלית הפך לסמל המאבק לעלייה חופשית.",
    "rank": 183
  },
  {
    "id": "jh_talpiot",
    "deck": "jewish",
    "title": "הקמת יחידת תלפיות",
    "start": 1979,
    "end": 1979,
    "date": "1979",
    "place": "ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "צה״ל הקים תוכנית מובחרת לצעירים מצטיינים שמשלבת שירות צבאי עם לימודים אקדמיים בפיזיקה, מתמטיקה ומדעי המחשב. בוגרי תלפיות הפכו למנועי טכנולוגיה עילית בישראל ומנכ״לים של חברות הזנק. היחידה סימלה את השילוב הישראלי בין צבא לטכנולוגיה.",
    "rank": 184
  },
  {
    "id": "jh_nachalat_binyamin",
    "deck": "jewish",
    "title": "כתיבת הירושלמי — התלמוד הארצישראלי",
    "start": 350,
    "end": 400,
    "date": "בערך המאה ה־4 לספירה",
    "place": "טבריה, ישראל",
    "lat": 32.794,
    "lon": 35.531,
    "desc": "התלמוד הירושלמי (הארצישראלי) נחתם בטבריה, אם כי הושלם פחות מן הבבלי. הוא נערך על ידי חכמי ארץ ישראל ומשקף את חיי היהודים תחת השלטון הרומי-ביזנטי. הירושלמי שומר על מסורות ומנהגים ייחודיים שאבדו מהבבלי.",
    "rank": 185
  },
  {
    "id": "jh_yehoshua_kenaz",
    "deck": "jewish",
    "title": "פרסום ״אחרי הגשם״ של יהושע קנז",
    "start": 1963,
    "end": 1963,
    "date": "1963",
    "place": "תל אביב, ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "יהושע קנז, מהסופרים הישראלים הבולטים של ״דור המדינה,״ החל לפרסם יצירות שהעמידו במרכז את הפרט מול הקולקטיב. הספרות הישראלית בשנות ה־60 עברה מעוז ואידיאליזם לעמדה ביקורתית ואישית, עם עמוס עוז, א.ב. יהושע ויהושע קנז.",
    "rank": 186
  },
  {
    "id": "jh_tower_david",
    "deck": "jewish",
    "title": "חשיפת עיר דוד הארכיאולוגית",
    "start": 1867,
    "end": 1867,
    "date": "1867",
    "place": "ירושלים, ישראל",
    "lat": 31.773,
    "lon": 35.236,
    "desc": "צ׳ארלס וורן ערך את החפירות הארכיאולוגיות הראשונות בירושלים העתיקה וחשף מנהרות, פירים ושרידים מימי בית ראשון ושני. מאז ועד היום, החפירות בעיר דוד ממשיכות לחשוף שכבות של היסטוריה ומעוררות מחלוקת פוליטית וארכיאולוגית.",
    "rank": 187
  },
  {
    "id": "jh_wadi_ara",
    "deck": "jewish",
    "title": "הסכמי שביתת הנשק — קווי ירוקים",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "רודוס, יוון",
    "lat": 36.434,
    "lon": 28.227,
    "desc": "ישראל חתמה על הסכמי שביתת נשק עם מצרים, ירדן, לבנון וסוריה באי רודוס. הקווים, שסומנו בדיו ירוק, הגדירו את גבולות ישראל בפועל עד 1967. ההסכמים הדגישו שקווי שביתת הנשק אינם גבולות מוכרים — סוגיה שטרם נפתרה.",
    "rank": 188
  },
  {
    "id": "jh_water_carrier",
    "deck": "jewish",
    "title": "השלמת המוביל הארצי",
    "start": 1964,
    "end": 1964,
    "date": "1964",
    "place": "ישראל",
    "lat": 32.81,
    "lon": 35.56,
    "desc": "ישראל השלימה את המוביל הארצי, צינור ענק שמוביל מים מהכנרת בצפון לנגב בדרום. הפרויקט אפשר פיתוח חקלאי ביישובים דרומיים ושינה את נוף ישראל. סוריה ניסתה למנוע את הפרויקט על ידי הסטת מקורות הירדן, מה שהוביל לעימותים צבאיים.",
    "rank": 189
  },
  {
    "id": "jh_jnf",
    "deck": "jewish",
    "title": "הקמת הקרן הקיימת לישראל",
    "start": 1901,
    "end": 1901,
    "date": "1901",
    "place": "באזל, שווייץ",
    "lat": 47.558,
    "lon": 7.587,
    "desc": "הקונגרס הציוני החמישי הקים את הקרן הקיימת לישראל (קק״ל) לרכישת אדמות בארץ ישראל. הקופסה הכחולה של קק״ל הונחה בכל בית יהודי כסמל של שותפות בבניין הארץ. הקרן נטעה מיליוני עצים, בנתה מאגרי מים ופיתחה תשתיות.",
    "rank": 190
  },
  {
    "id": "jh_maccabiah",
    "deck": "jewish",
    "title": "המכביה הראשונה",
    "start": 1932,
    "end": 1932,
    "date": "1932",
    "place": "תל אביב, ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "המכביה הראשונה, ״האולימפיאדה היהודית,״ נערכה בתל אביב בהשתתפות 390 ספורטאים מ־18 מדינות. המשחקים נועדו לחזק את הקשר בין יהודי התפוצות לארץ ישראל ולטפח גאווה לאומית. מאז נערכת המכביה כל ארבע שנים.",
    "rank": 191
  },
  {
    "id": "jh_bus_300_affair",
    "deck": "jewish",
    "title": "פרשת קו שלוש מאות",
    "start": 1984,
    "end": 1984,
    "date": "1984",
    "place": "רצועת עזה וישראל",
    "lat": 31.35,
    "lon": 34.31,
    "desc": "מחבלים חטפו אוטובוס קו 300, וצה״ל חילץ את הנוסעים. שני מחבלים שנתפסו חיים הוכו למוות על ידי אנשי שב״כ. הפרשה חשפה שקרים של השב״כ, הובילה למשבר אמון ולרפורמה בארגון. ראש השב״כ אברהם שלום קיבל חנינה מנשיאתית.",
    "rank": 192
  },
  {
    "id": "jh_iron_dome",
    "deck": "jewish",
    "title": "הפעלת מערכת כיפת ברזל",
    "start": 2011,
    "end": 2011,
    "date": "2011",
    "place": "ישראל",
    "lat": 31.25,
    "lon": 34.79,
    "desc": "ישראל הפעילה לראשונה את מערכת כיפת ברזל ליירוט רקטות קצרות טווח שנורו מרצועת עזה. המערכת, שפותחה על ידי רפאל, יירטה רקטות בהצלחה גבוהה ושינתה את מאזן ההרתעה. כיפת ברזל הפכה לסמל טכנולוגי ישראלי בינלאומי.",
    "rank": 193
  },
  {
    "id": "jh_karaites",
    "deck": "jewish",
    "title": "עליית הקראיות",
    "start": 760,
    "end": 760,
    "date": "בערך המאה ה־8 לספירה",
    "place": "בגדאד, בבל (עיראק)",
    "lat": 33.315,
    "lon": 44.366,
    "desc": "ענן בן דוד הקים את הקראיות, זרם יהודי שדחה את התורה שבעל פה (המשנה והתלמוד) ודגל בקריאה ישירה של המקרא בלבד. הקראים היו קהילה משמעותית בימי הביניים, בעיקר במצרים ובקרים, והאתגר שהציבו חידד את הסמכות הרבנית.",
    "rank": 194
  },
  {
    "id": "jh_start_up_nation",
    "deck": "jewish",
    "title": "ישראל כ״אומת הסטארט-אפ״",
    "start": 1998,
    "end": 2010,
    "date": "בערך ⁦1998–2010⁩",
    "place": "ישראל",
    "lat": 32.08,
    "lon": 34.78,
    "desc": "ישראל הפכה למעצמת טכנולוגיה עילית עם ריכוז הסטארט-אפים הגבוה ביותר לנפש בעולם. בוגרי יחידות 8200, תלפיות ואוניברסיטאות ישראליות ייסדו חברות בתחומי סייבר, בינה מלאכותית וביו-טכנולוגיה. ספר ״אומת הסטארט-אפ״ תיעד את התופעה.",
    "rank": 195
  },
  {
    "id": "jh_bahai_haifa",
    "deck": "jewish",
    "title": "בניין הכנסת בירושלים",
    "start": 1966,
    "end": 1966,
    "date": "1966",
    "place": "ירושלים, ישראל",
    "lat": 31.777,
    "lon": 35.206,
    "desc": "בניין הכנסת החדש נחנך בגבעת רם בירושלים, בתכנון יוסף קלארוויין ובמימון הברון ג׳יימס דה רוטשילד. הבניין כולל את השטיחים של מארק שאגאל ומנורת הכנסת של בנו גור. הוא משמש כסמל הדמוקרטיה הישראלית.",
    "rank": 196
  },
  {
    "id": "jh_dead_sea_fortress",
    "deck": "jewish",
    "title": "ייסוד נצרת עילית (נוף הגליל)",
    "start": 1957,
    "end": 1957,
    "date": "1957",
    "place": "נצרת עילית, ישראל",
    "lat": 32.718,
    "lon": 35.303,
    "desc": "ישראל הקימה עיר פיתוח יהודית על הגבעות מעל נצרת כחלק ממדיניות ״ייהוד הגליל.״ העיר קלטה עולים חדשים, בעיקר ממצרים ומרומניה. ב־2019 שונה שמה ל״נוף הגליל.״ ייסודה ביטא את המתח בין יהודים לערבים בגליל.",
    "rank": 197
  },
  {
    "id": "jh_ruth_calderon",
    "deck": "jewish",
    "title": "רות קלדרון נואמת תלמוד בכנסת",
    "start": 2013,
    "end": 2013,
    "date": "2013",
    "place": "ירושלים, ישראל",
    "lat": 31.777,
    "lon": 35.206,
    "desc": "חברת הכנסת רות קלדרון, מייסדת בית המדרש החילוני ״אלמא,״ נאמה בכנסת על סוגיה תלמודית כנאום בכורה. הנאום הפך ויראלי וסימל את המאבק על בעלות על הטקסטים היהודיים — שהם לא רק נחלת הציבור הדתי.",
    "rank": 198
  },
  {
    "id": "jh_beresheet",
    "deck": "jewish",
    "title": "שיגור חללית בראשית",
    "start": 2019,
    "end": 2019,
    "date": "2019",
    "place": "כף קנוורל, ארצות הברית",
    "lat": 28.562,
    "lon": -80.577,
    "desc": "ספייס-איי-אל, ארגון ישראלי פרטי, שיגר את חללית ״בראשית״ במטרה לנחות על הירח. החללית הגיעה למסלול ירח אך התרסקה בניסיון הנחיתה. למרות הכישלון, ישראל הפכה למדינה השביעית שהגיעה למסלול הירח — הישג לארגון פרטי ולמדינה קטנה.",
    "rank": 199
  },
  {
    "id": "jh_haredim_draft",
    "deck": "jewish",
    "title": "משבר גיוס החרדים",
    "start": 1948,
    "end": 2024,
    "date": "⁦1948–2024⁩",
    "place": "ישראל",
    "lat": 31.78,
    "lon": 35.21,
    "desc": "בן גוריון פטר 400 תלמידי ישיבה משירות צבאי, אך הפטור הפך לעשרות אלפים וליצר מחלוקת חברתית עמוקה. בג״ץ פסל שוב ושוב את חוקי הפטור, הפוליטיקאים התקשו לאכוף, והמתח בין חילונים לחרדים בנושא הגיוס נותר אחד הנושאים הבוערים ביותר בישראל.",
    "rank": 200
  },
  {
    "id": "ar_mona_lisa",
    "deck": "art",
    "title": "ציור המונה ליזה",
    "start": 1503,
    "end": 1519,
    "date": "בערך ⁦1503–1519⁩",
    "place": "פירנצה, איטליה",
    "lat": 43.769,
    "lon": 11.255,
    "desc": "לאונרדו דה וינצ׳י צייר את דיוקנה של ליזה גרדיני, רעייתו של סוחר פלורנטיני. טכניקת הספומאטו שלו יצרה חיוך חמקמק שריתק צופים במשך מאות שנים. היצירה מוצגת במוזיאון הלובר בפריז והיא הציור המפורסם ביותר בעולם.",
    "rank": 1
  },
  {
    "id": "ar_sistine_ceiling",
    "deck": "art",
    "title": "ציורי התקרה של הקפלה הסיסטינית",
    "start": 1508,
    "end": 1512,
    "date": "⁦1508–1512⁩",
    "place": "הוותיקן, רומא",
    "lat": 41.903,
    "lon": 12.454,
    "desc": "מיכלאנג׳לו בואונרוטי צייר את תקרת הקפלה הסיסטינית בהזמנת האפיפיור יוליוס השני. על פני כאלף מטר רבוע הוא תיאר סצנות מספר בראשית, כולל בריאת אדם. העבודה נמשכה ארבע שנים בתנוחה מענה על פיגום גבוה.",
    "rank": 2
  },
  {
    "id": "ar_starry_night",
    "deck": "art",
    "title": "ליל כוכבים של ואן גוך",
    "start": 1889,
    "end": 1889,
    "date": "1889",
    "place": "סן-רמי דה פרובאנס, צרפת",
    "lat": 43.789,
    "lon": 4.832,
    "desc": "וינסנט ואן גוך צייר את ליל כוכבים מחלון חדרו במוסד הפסיכיאטרי בסן-רמי. ערבולי השמיים המפורסמים הפכו לסמל האמנות המודרנית. הציור מוצג במוזיאון לאמנות מודרנית בניו יורק.",
    "rank": 3
  },
  {
    "id": "ar_guernica",
    "deck": "art",
    "title": "גרניקה של פיקאסו",
    "start": 1937,
    "end": 1937,
    "date": "1937",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "פבלו פיקאסו צייר את הציור המונומנטלי אחרי שמטוסי הלופטוואפה הגרמנית הפציצו את העיירה הבאסקית גרניקה במלחמת האזרחים הספרדית. היצירה בשחור, לבן ואפור הפכה לאחד הסמלים הבולטים ביותר נגד המלחמה. הציור מוצג במוזיאון ריינה סופיה במדריד.",
    "rank": 4
  },
  {
    "id": "ar_david_michel",
    "deck": "art",
    "title": "פסל דוד של מיכלאנג׳לו",
    "start": 1501,
    "end": 1504,
    "date": "⁦1501–1504⁩",
    "place": "פירנצה, איטליה",
    "lat": 43.776,
    "lon": 11.259,
    "desc": "מיכלאנג׳לו פיסל את דוד מגוש שיש ענק שאמנים אחרים נטשו. בגובה 5.17 מטר, הפסל מציג את הגיבור המקראי רגע לפני הקרב עם גוליית. הוצב בכיכר הסיניוריה כסמל לרפובליקה הפלורנטינית.",
    "rank": 5
  },
  {
    "id": "ar_last_supper",
    "deck": "art",
    "title": "הסעודה האחרונה של לאונרדו",
    "start": 1495,
    "end": 1498,
    "date": "⁦1495–1498⁩",
    "place": "מילאנו, איטליה",
    "lat": 45.466,
    "lon": 9.171,
    "desc": "לאונרדו דה וינצ׳י צייר את ציור הקיר בשיטה ניסיונית של שמן על גבי טיח יבש בקיר חדר האוכל של מנזר סנטה מריה דלה גרציה. היצירה מתארת את הרגע שבו ישו מודיע על בגידתו של אחד השליחים. הציור החל להתפורר כבר בחיי לאונרדו ועבר שיקומים רבים.",
    "rank": 6
  },
  {
    "id": "ar_lascaux",
    "deck": "art",
    "title": "ציורי המערה בלאסקו",
    "start": -17000,
    "end": -15000,
    "date": "בערך ⁦17,000–15,000⁩ לפנה״ס",
    "place": "לאסקו, צרפת",
    "lat": 45.054,
    "lon": 1.168,
    "desc": "במערת לאסקו בדורדון צוירו מאות דמויות של חיות, בני אדם וסמלים מופשטים. הציורים, בפיגמנטים טבעיים, מעידים על חשיבה סמלית מפותחת בתקופת הפלאוליתית העליונה. המערה נחשפה בידי נערים מקומיים ונסגרה לקהל מפני נזקי לחות.",
    "rank": 7
  },
  {
    "id": "ar_birth_venus",
    "deck": "art",
    "title": "הולדת ונוס של בוטיצ׳לי",
    "start": 1484,
    "end": 1486,
    "date": "בערך ⁦1484–1486⁩",
    "place": "פירנצה, איטליה",
    "lat": 43.769,
    "lon": 11.255,
    "desc": "סנדרו בוטיצ׳לי צייר את אלת האהבה עולה מן הים על צדפה, בהשראת מיתולוגיה קלאסית ושירה ניאו-פלטונית. היצירה הייתה מהראשונות שהציגו עירום נשי בגודל טבעי מאז ימי הרנסנס. מוצגת בגלריית אופיצי בפירנצה.",
    "rank": 8
  },
  {
    "id": "ar_parthenon",
    "deck": "art",
    "title": "בניית הפרתנון באתונה",
    "start": -447,
    "end": -432,
    "date": "⁦447–432⁩ לפנה״ס",
    "place": "אתונה, יוון",
    "lat": 37.971,
    "lon": 23.727,
    "desc": "פריקלס יזם את בניית המקדש לאתנה פרתנוס על האקרופוליס, בתכנון האדריכל איקטינוס והפסל פידיאס. פסלי השיש שעיטרו את המבנה נחשבים לפסגת האמנות הקלאסית. חלק מהפריז נמצא כיום במוזיאון הבריטי.",
    "rank": 9
  },
  {
    "id": "ar_impression_sunrise",
    "deck": "art",
    "title": "רושם: זריחה של מונה",
    "start": 1872,
    "end": 1872,
    "date": "1872",
    "place": "לה-אבר, צרפת",
    "lat": 49.494,
    "lon": 0.108,
    "desc": "קלוד מונה צייר את נמל לה-אבר בשעת שחר בקווי מכחול רופפים ואור מפוזר. כשהציור הוצג בתערוכה, מבקר לעגני כינה את הקבוצה ״אימפרסיוניסטים״ על שם הכותרת, והשם נדבק לזרם כולו.",
    "rank": 10
  },
  {
    "id": "ar_girl_pearl",
    "deck": "art",
    "title": "נערה עם עגיל פנינה",
    "start": 1665,
    "end": 1665,
    "date": "בערך 1665",
    "place": "דלפט, הולנד",
    "lat": 52.011,
    "lon": 4.357,
    "desc": "יוהנס ורמיר צייר דיוקן של נערה אלמונית על רקע שחור עם עגיל פנינה זוהר. הציור מכונה ״המונה ליזה של הצפון״ בזכות מבטה החידתי. מוצג במוזיאון מאוריצהאוס בהאג.",
    "rank": 11
  },
  {
    "id": "ar_scream",
    "deck": "art",
    "title": "הצעקה של מונק",
    "start": 1893,
    "end": 1893,
    "date": "1893",
    "place": "אוסלו, נורבגיה",
    "lat": 59.913,
    "lon": 10.752,
    "desc": "אדוורד מונק יצר את הדמות העוויתית על רקע שמיים אדומים, שמבטאת חרדה קיומית. קיימים ארבעה גרסאות, בטכניקות שונות. היצירה הפכה לסמל מודרני של מצוקה נפשית ולאחת האיקונות המוכרות ביותר באמנות.",
    "rank": 12
  },
  {
    "id": "ar_fountain",
    "deck": "art",
    "title": "המזרקה של דושאן",
    "start": 1917,
    "end": 1917,
    "date": "1917",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.712,
    "lon": -74.006,
    "desc": "מרסל דושאן הגיש משתנה תעשייתי הפוך, חתום בשם ״ר. מאט״, לתערוכת אמנות בניו יורק. ההגשה נדחתה אך שינתה לעד את הגדרת האמנות. זו נחשבת לנקודת המוצא של האמנות הקונספטואלית.",
    "rank": 13
  },
  {
    "id": "ar_persistence_memory",
    "deck": "art",
    "title": "עקשנות הזיכרון של דאלי",
    "start": 1931,
    "end": 1931,
    "date": "1931",
    "place": "פורט ליגאט, ספרד",
    "lat": 42.294,
    "lon": 3.287,
    "desc": "סלבדור דאלי צייר נוף שומם עם שעונים רכים נמסים, בהשראת גבינת קממבר נמסה. הציור הפך לסמל הסוריאליזם ולאחד מדימויי האמנות המוכרים ביותר של המאה העשרים. מוצג במוזיאון לאמנות מודרנית בניו יורק.",
    "rank": 14
  },
  {
    "id": "ar_venus_willendorf",
    "deck": "art",
    "title": "ונוס מווילנדורף",
    "start": -28000,
    "end": -25000,
    "date": "בערך ⁦28,000–25,000⁩ לפנה״ס",
    "place": "וילנדורף, אוסטריה",
    "lat": 48.325,
    "lon": 15.399,
    "desc": "פסלון גיר קטן בגובה 11 סנטימטר, המתאר דמות נשית עם גוף מוגזם, נמצא בוילנדורף שבאוסטריה. הוא אחד הפסלים הקדומים ביותר שידועים, ומעיד על תפיסות פוריות בחברות פרהיסטוריות. השם ״ונוס״ ניתן בהומור על ידי הארכאולוגים.",
    "rank": 15
  },
  {
    "id": "ar_great_wave",
    "deck": "art",
    "title": "הגל הגדול מול קנאגאווה",
    "start": 1831,
    "end": 1831,
    "date": "בערך 1831",
    "place": "אדו (טוקיו), יפן",
    "lat": 35.685,
    "lon": 139.751,
    "desc": "קצושיקה הוקוסאי יצר את חיתוך העץ המפורסם כחלק מסדרה של שלושים ושישה מראות של הר פוג׳י. הגל המתנשא מול הר הקודש הפך לאחת היצירות היפניות המוכרות ביותר במערב. היצירה השפיעה על האימפרסיוניסטים הצרפתים.",
    "rank": 16
  },
  {
    "id": "ar_kiss_klimt",
    "deck": "art",
    "title": "הנשיקה של קלימט",
    "start": 1907,
    "end": 1908,
    "date": "⁦1907–1908⁩",
    "place": "וינה, אוסטריה",
    "lat": 48.208,
    "lon": 16.373,
    "desc": "גוסטב קלימט צייר את שני האוהבים המתחבקים בעיטורי זהב עשירים בתקופת הזהב שלו. היצירה משלבת סימבוליזם, ארט נובו ועיטורים ביזנטיים. מוצגת בגלריה בלוודרה בוינה.",
    "rank": 17
  },
  {
    "id": "ar_night_watch",
    "deck": "art",
    "title": "משמר הלילה של רמברנדט",
    "start": 1642,
    "end": 1642,
    "date": "1642",
    "place": "אמסטרדם, הולנד",
    "lat": 52.37,
    "lon": 4.885,
    "desc": "רמברנדט ואן ריין צייר קבוצת מיליציה אזרחית בסצנה דרמטית ודינמית, בשונה מדיוקנאות קבוצתיים סטטיים שהיו מקובלים. משחק האור והצל יצר עומק תיאטרלי שמאפיין את סגנונו. הציור הענק מוצג בריקסמוזיאום באמסטרדם.",
    "rank": 18
  },
  {
    "id": "ar_thinker",
    "deck": "art",
    "title": "ההוגה של רודן",
    "start": 1880,
    "end": 1904,
    "date": "⁦1880–1904⁩",
    "place": "פריז, צרפת",
    "lat": 48.855,
    "lon": 2.316,
    "desc": "אוגוסט רודן פיסל את הדמות ההוגה כחלק מ״שערי הגיהינום״ בהשראת דנטה, אך הפסל זכה לחיים עצמאיים. הדמות העירומה היושבת בתנוחת מחשבה הפכה לסמל אוניברסלי של הגות פילוסופית. הוגדל ויצוק בברונזה בגודל טבעי ומוצב ברחבי העולם.",
    "rank": 19
  },
  {
    "id": "ar_campbell_soup",
    "deck": "art",
    "title": "פחיות המרק של וורהול",
    "start": 1962,
    "end": 1962,
    "date": "1962",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "אנדי וורהול הציג סדרה של שלושים ושתיים קנבסים, כל אחד מתאר זן אחר של מרק קמפבל. התערוכה בגלריה פרוס בלוס אנג׳לס סימנה את לידת הפופ ארט. וורהול טשטש את הגבול בין אמנות, פרסום ותרבות צריכה.",
    "rank": 20
  },
  {
    "id": "ar_gobekli_tepe",
    "deck": "art",
    "title": "גבקלי טפה: המקדש העתיק בעולם",
    "start": -9500,
    "end": -8000,
    "date": "בערך ⁦9500–8000⁩ לפנה״ס",
    "place": "אורפה, טורקיה",
    "lat": 37.223,
    "lon": 38.922,
    "desc": "קומפלקס של עמודי אבן מגוּלפים בצורת T, שנבנה עוד לפני המצאת החקלאות. התגלית שינתה את ההבנה שמקדשים קדמו ליישובים קבועים. עמודי האבן עוטרו בתבליטי חיות כמו נחשים, שועלים ועקרבים.",
    "rank": 21
  },
  {
    "id": "ar_terracotta",
    "deck": "art",
    "title": "צבא הטרה-קוטה של צ׳ין",
    "start": -210,
    "end": -209,
    "date": "בערך ⁦210⁩ לפנה״ס",
    "place": "שיאן, סין",
    "lat": 34.384,
    "lon": 109.278,
    "desc": "הקיסר הראשון של סין, צ׳ין שי הואנג, נקבר עם צבא של אלפי פסלי חיילים בגודל טבעי. כל פסל שונה בפרצופו ובשריונו, כנראה על בסיס חיילים אמיתיים. הממצא נחשף בידי חקלאים והוא אחד הגילויים הארכאולוגיים המדהימים ביותר.",
    "rank": 22
  },
  {
    "id": "ar_hagia_sophia",
    "deck": "art",
    "title": "בניית איה סופיה",
    "start": 532,
    "end": 537,
    "date": "⁦532–537⁩ לספירה",
    "place": "קונסטנטינופול (איסטנבול), טורקיה",
    "lat": 41.009,
    "lon": 28.98,
    "desc": "הקיסר יוסטיניאנוס בנה את הקתדרלה כסמל לכוח הביזנטי. כיפתה בקוטר 31 מטר הייתה פלא הנדסי שלא הושג שוב במשך אלף שנה. שימשה כנסייה, מסגד ומוזיאון, וכיום מסגד פעיל.",
    "rank": 23
  },
  {
    "id": "ar_giotto_scrovegni",
    "deck": "art",
    "title": "ציורי ג׳וטו בקפלת סקרובני",
    "start": 1303,
    "end": 1305,
    "date": "⁦1303–1305⁩",
    "place": "פדובה, איטליה",
    "lat": 45.412,
    "lon": 11.88,
    "desc": "ג׳וטו די בונדונה צייר מחזור של שלושים ושמונה סצנות מחיי ישו ומריה על קירות הקפלה בפדובה. הדמויות שלו מציגות רגש ומשקל גוף חסרי תקדים בציור הימי-ביניימי. ג׳וטו נחשב למייסד הציור המערבי המודרני.",
    "rank": 24
  },
  {
    "id": "ar_waterlilies",
    "deck": "art",
    "title": "חבצלות המים של מונה",
    "start": 1896,
    "end": 1926,
    "date": "⁦1896–1926⁩",
    "place": "ג׳יברני, צרפת",
    "lat": 49.076,
    "lon": 1.533,
    "desc": "קלוד מונה צייר כ-250 ציורים של הבריכה בגן ביתו בג׳יברני לאורך שלושים שנה. סדרת חבצלות המים הפכה יותר ויותר מופשטת ומהווה גשר בין אימפרסיוניזם לאמנות מופשטת. הפאנלים הגדולים מוצגים במוזיאון האורנז׳רי בפריז.",
    "rank": 25
  },
  {
    "id": "ar_caravaggio_calling",
    "deck": "art",
    "title": "קריאת מתי של קאראוואג׳ו",
    "start": 1599,
    "end": 1600,
    "date": "⁦1599–1600⁩",
    "place": "רומא, איטליה",
    "lat": 41.899,
    "lon": 12.474,
    "desc": "קאראוואג׳ו צייר את הרגע שישו בוחר במתי הגובה, עם קרן אור דרמטית חותכת חדר חשוך. טכניקת הקיארוסקורו שלו, ניגוד חד בין אור וחושך, שינתה את הציור הבארוקי. הציור נמצא בכנסיית סן לואיג׳י דיי פרנצ׳זי ברומא.",
    "rank": 26
  },
  {
    "id": "ar_sunflowers",
    "deck": "art",
    "title": "חמניות של ואן גוך",
    "start": 1888,
    "end": 1889,
    "date": "⁦1888–1889⁩",
    "place": "ארל, צרפת",
    "lat": 43.677,
    "lon": 4.631,
    "desc": "וינסנט ואן גוך צייר סדרת ציורי חמניות בגווני צהוב עזים לקישוט חדרו של חברו פול גוגן בבית הצהוב בארל. הציורים מפגינים את משיכות המכחול האנרגטיות ושימוש ייחודי בצבע שמאפיינים את סגנונו. הפכו לסמל עליז של האמנות הפוסט-אימפרסיוניסטית.",
    "rank": 27
  },
  {
    "id": "ar_rodin_gates",
    "deck": "art",
    "title": "שערי הגיהינום של רודן",
    "start": 1880,
    "end": 1917,
    "date": "⁦1880–1917⁩",
    "place": "פריז, צרפת",
    "lat": 48.855,
    "lon": 2.316,
    "desc": "אוגוסט רודן עבד על מבנה פיסולי מונומנטלי בהשראת ה״קומדיה האלוהית״ של דנטה לאורך שלושים ושבע שנה. מתוך הפרויקט צמחו פסלים עצמאיים כמו ההוגה והנשיקה. היצירה לא נוצקה בברונזה בחייו ונשארה כפרויקט בלתי גמור שהשפיע עמוקות על הפיסול המודרני.",
    "rank": 28
  },
  {
    "id": "ar_gothic_notre_dame",
    "deck": "art",
    "title": "בניית קתדרלת נוטרדאם בפריז",
    "start": 1163,
    "end": 1345,
    "date": "⁦1163–1345⁩",
    "place": "פריז, צרפת",
    "lat": 48.853,
    "lon": 2.349,
    "desc": "קתדרלת נוטרדאם היא אחד המבנים הגותיים החשובים ביותר, עם קשתות מעופפות, חלונות ורדים וגרגוילים. הבנייה נמשכה כמעט מאתיים שנה ושירתה כמודל לקתדרלות ברחבי אירופה. בשריפה הגדולה של 2019 נהרס הצריח אך המבנה שרד ושוקם.",
    "rank": 29
  },
  {
    "id": "ar_arnolfini",
    "deck": "art",
    "title": "דיוקן הזוג ארנולפיני",
    "start": 1434,
    "end": 1434,
    "date": "1434",
    "place": "ברוז׳, בלגיה",
    "lat": 51.209,
    "lon": 3.225,
    "desc": "יאן ואן אייק צייר בשמן את הסוחר האיטלקי ואשתו בחדרם, עם מראה קמורה המשקפת את החדר כולו. הציור מדגים את המהפכה של ציור שמן פלמי, עם פרטים מציאותיים חסרי תקדים. מוצג בגלריה הלאומית בלונדון.",
    "rank": 30
  },
  {
    "id": "ar_school_athens",
    "deck": "art",
    "title": "אסכולת אתונה של רפאל",
    "start": 1509,
    "end": 1511,
    "date": "⁦1509–1511⁩",
    "place": "הוותיקן, רומא",
    "lat": 41.903,
    "lon": 12.454,
    "desc": "רפאל סנציו צייר את הפרסקו בחדרי האפיפיור, המתאר פילוסופים יווניים עם אפלטון ואריסטו במרכז. היצירה מייצגת את שיא הרנסנס הגבוה ואת השאיפה לשלב תבונה קלאסית עם אמונה נוצרית. הפילוסופים מצוירים בדמויות בני הזמן, כולל מיכלאנג׳לו ולאונרדו.",
    "rank": 31
  },
  {
    "id": "ar_les_demoiselles",
    "deck": "art",
    "title": "עלמות אביניון של פיקאסו",
    "start": 1907,
    "end": 1907,
    "date": "1907",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "פבלו פיקאסו צייר חמש נשים עירומות בצורות גיאומטריות מנופצות, בהשראת מסכות אפריקאיות ואיבריות. הציור נחשב למהפכני ביותר במאה העשרים ולנקודת הפתיחה של הקוביזם. אפילו חבריו הקרובים של פיקאסו נדהמו מהיצירה.",
    "rank": 32
  },
  {
    "id": "ar_liberty_delacroix",
    "deck": "art",
    "title": "החירות מובילה את העם",
    "start": 1830,
    "end": 1830,
    "date": "1830",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "אז׳ן דלקרואה צייר את האלגוריה של החירות כאישה הנושאת את דגל צרפת על בריקדות מהפכת יולי. הציור משלב ריאליזם ואלגוריה ונחשב ליצירה הרומנטית הצרפתית החשובה ביותר. הדמות הפכה למקור ההשראה לפסל החירות.",
    "rank": 33
  },
  {
    "id": "ar_sagrada",
    "deck": "art",
    "title": "תחילת בניית הסגרדה פמיליה",
    "start": 1882,
    "end": 1882,
    "date": "1882",
    "place": "ברצלונה, ספרד",
    "lat": 41.404,
    "lon": 2.174,
    "desc": "אנטוני גאודי קיבל לידיו את תכנון הבזיליקה והקדיש לה את שארית חייו. הסגנון המשלב גותיקה ואמנות נובו עם צורות אורגניות ייחודי לגאודי. הבנייה עדיין נמשכת, יותר ממאה שנה אחרי מותו.",
    "rank": 34
  },
  {
    "id": "ar_goya_third_may",
    "deck": "art",
    "title": "הירי בשלישי במאי של גויא",
    "start": 1814,
    "end": 1814,
    "date": "1814",
    "place": "מדריד, ספרד",
    "lat": 40.414,
    "lon": -3.692,
    "desc": "פרנסיסקו גויא צייר את הוצאתם להורג של מורדים ספרדיים בידי כוחות נפוליאון. היצירה מתעדת את אכזריות המלחמה ללא כל אידיאליזציה, בניגוד לציורי קרב הירואיים שהיו מקובלים. היא נחשבת לציור המלחמה המודרני הראשון.",
    "rank": 35
  },
  {
    "id": "ar_pietà",
    "deck": "art",
    "title": "פייטה של מיכלאנג׳לו",
    "start": 1498,
    "end": 1499,
    "date": "⁦1498–1499⁩",
    "place": "רומא, איטליה",
    "lat": 41.902,
    "lon": 12.454,
    "desc": "מיכלאנג׳לו פיסל את מריה מחזיקה את גופת ישו בגיל 24 בלבד. ליטוש השיש יוצר מראה של בשר חי, ופני מריה הצעירים מבטאים צער שליו. הפסל עומד בבזיליקת פטרוס הקדוש בוותיקן ונפגע בהתקפה בידי מטורף ב-1972.",
    "rank": 36
  },
  {
    "id": "ar_nighthawks",
    "deck": "art",
    "title": "ינשופי לילה של הופר",
    "start": 1942,
    "end": 1942,
    "date": "1942",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.712,
    "lon": -74.006,
    "desc": "אדוארד הופר צייר סועדים בודדים במסעדת לילה אמריקנית, מוארת באור פלורסנטי חד. הציור מבטא את הבדידות והניכור של חיי העיר המודרנית. הפך לאחד הציורים האמריקניים המצוטטים ביותר.",
    "rank": 37
  },
  {
    "id": "ar_velazquez_meninas",
    "deck": "art",
    "title": "משרתות הכבוד של ולאסקס",
    "start": 1656,
    "end": 1656,
    "date": "1656",
    "place": "מדריד, ספרד",
    "lat": 40.414,
    "lon": -3.692,
    "desc": "דייגו ולאסקס צייר את הנסיכה מרגריטה עם פמלייתה, כשהוא עצמו מופיע בציור מצייר את המלך והמלכה הנשקפים במראה. משחק המראות והנקודות מזוויות שונות הפך את היצירה לחידה ויזואלית שריתקה אמנים ופילוסופים. מוצג בפראדו במדריד.",
    "rank": 38
  },
  {
    "id": "ar_duchamp_nude",
    "deck": "art",
    "title": "עירום יורד במדרגות של דושאן",
    "start": 1912,
    "end": 1912,
    "date": "1912",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "מרסל דושאן שילב קוביזם ופוטוריזם בציור המתאר תנועה מפורקת לצורות גיאומטריות חופפות. הציור עורר שערורייה בתערוכת הארמורי שואו בניו יורק ובין הקוביסטים בפריז. היצירה סימנה מעבר מציור לפעולה קונספטואלית.",
    "rank": 39
  },
  {
    "id": "ar_brunelleschi_dome",
    "deck": "art",
    "title": "כיפת ברונלסקי בפירנצה",
    "start": 1420,
    "end": 1436,
    "date": "⁦1420–1436⁩",
    "place": "פירנצה, איטליה",
    "lat": 43.773,
    "lon": 11.256,
    "desc": "פיליפו ברונלסקי תכנן ובנה את הכיפה המתומנת של הקתדרלה ללא פיגום מלא, פתרון הנדסי שאיש לא הצליח למצוא קודם לכן. בקוטר של 45 מטר, היא עדיין הכיפה הלבנית הגדולה בעולם. הפרויקט נחשב לנקודת הפתיחה של אדריכלות הרנסנס.",
    "rank": 40
  },
  {
    "id": "ar_pollock_drip",
    "deck": "art",
    "title": "ציור הנטפה של פולוק",
    "start": 1947,
    "end": 1950,
    "date": "⁦1947–1950⁩",
    "place": "ספרינגס, ניו יורק, ארצות הברית",
    "lat": 40.98,
    "lon": -72.156,
    "desc": "ג׳קסון פולוק פיתח את טכניקת הנטפה: שפיכת צבע מלמעלה על קנבס ענק מונח על הרצפה. השיטה הפכה את תהליך הציור עצמו ליצירה ואת ניו יורק לבירת האמנות העולמית. פולוק היה הפנים של האקספרסיוניזם המופשט.",
    "rank": 41
  },
  {
    "id": "ar_warhol_marilyn",
    "deck": "art",
    "title": "דיוקני מרילין של וורהול",
    "start": 1962,
    "end": 1962,
    "date": "1962",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "אנדי וורהול יצר סדרת הדפסי רשת של מרילין מונרו בצבעים עזים מיד אחרי מותה. ההדפסות הפכו לסמל הפופ ארט ולפרשנות על תרבות הסלבריטי וההמונים. אחד הדיוקנים נמכר ב-195 מיליון דולר, השיא בציור אמריקני.",
    "rank": 42
  },
  {
    "id": "ar_degas_dancers",
    "deck": "art",
    "title": "רקדניות הבלט של דגא",
    "start": 1873,
    "end": 1876,
    "date": "בערך ⁦1873–1876⁩",
    "place": "פריז, צרפת",
    "lat": 48.872,
    "lon": 2.332,
    "desc": "אדגר דגא צייר ופיסל מאות יצירות של רקדניות באופרה של פריז, בזוויות בלתי שגרתיות ובתאורה מלאכותית. הוא תפס רגעי חזרות ומאחורי הקלעים בדרך שצילום עדיין לא יכול היה להציע. דגא נחשב לגשר בין אימפרסיוניזם לאמנות מודרנית.",
    "rank": 43
  },
  {
    "id": "ar_matisse_dance",
    "deck": "art",
    "title": "הריקוד של מאטיס",
    "start": 1910,
    "end": 1910,
    "date": "1910",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "אנרי מאטיס צייר חמש דמויות רוקדות במעגל בצבעים שטוחים של כחול, ירוק ואדום. הציור הוזמן על ידי האספן הרוסי סרגיי שצ׳וקין. מאטיס הוביל את הפוביזם ושחרר את הצבע מהתפקיד של חיקוי המציאות.",
    "rank": 44
  },
  {
    "id": "ar_rothko_chapel",
    "deck": "art",
    "title": "קפלת רותקו בהיוסטון",
    "start": 1964,
    "end": 1971,
    "date": "⁦1964–1971⁩",
    "place": "יוסטון, טקסס, ארצות הברית",
    "lat": 29.737,
    "lon": -95.396,
    "desc": "מארק רותקו צייר ארבעה עשר ציורים ענקיים בגווני שחור וסגול כהה עבור קפלה בין-דתית. הקפלה שימשה כמקום מדיטציה בלתי קונפסיונלי ומסמלת את שיא חתירתו של רותקו לרוחניות דרך צבע. רותקו התאבד שנה לפני שהקפלה נפתחה לציבור.",
    "rank": 45
  },
  {
    "id": "ar_nefertiti",
    "deck": "art",
    "title": "חזה נפרטיטי",
    "start": -1345,
    "end": -1345,
    "date": "בערך 1345 לפנה״ס",
    "place": "אל-עמארנה, מצרים",
    "lat": 27.645,
    "lon": 30.898,
    "desc": "חזה גיר צבוע של המלכה נפרטיטי נמצא בסדנת הפסל תחותמוס בתל אל-עמארנה. פניה הסימטריים, עור חלק וכתר כחול גבוה הפכו אותה לאחד הפסלים הקדומים המפורסמים ביותר. מוצג במוזיאון החדש בברלין, וגרר מחלוקת דיפלומטית עם מצרים.",
    "rank": 46
  },
  {
    "id": "ar_borobudur",
    "deck": "art",
    "title": "בניית מקדש בורובודור",
    "start": 750,
    "end": 842,
    "date": "בערך ⁦750–842⁩ לספירה",
    "place": "ג׳אווה, אינדונזיה",
    "lat": -7.608,
    "lon": 110.204,
    "desc": "שושלת שיילנדרה בנתה את מקדש הבודהיזם הגדול ביותר בעולם על גבעה בג׳אווה המרכזית. תשע רמות מעוטרות ב-2,672 פאנלי תבליט ו-504 פסלי בודהה. המקדש מייצג את הקוסמולוגיה הבודהיסטית ואת המסע מעולם התשוקה לנירוונה.",
    "rank": 47
  },
  {
    "id": "ar_angkor_wat",
    "deck": "art",
    "title": "בניית אנגקור ואט",
    "start": 1113,
    "end": 1150,
    "date": "בערך ⁦1113–1150⁩",
    "place": "אנגקור, קמבודיה",
    "lat": 13.412,
    "lon": 103.867,
    "desc": "המלך סוריאוורמן השני בנה את מקדש הווישנו הענק כעיר מקדשים מוקפת חפיר. תבליטים באורך כולל של כשמונה מאות מטר מספרים אפוסים הינדואיים ואירועים היסטוריים. אנגקור ואט הוא המבנה הדתי הגדול ביותר שנבנה אי-פעם.",
    "rank": 48
  },
  {
    "id": "ar_taj_mahal",
    "deck": "art",
    "title": "בניית הטאג׳ מאהל",
    "start": 1632,
    "end": 1653,
    "date": "⁦1632–1653⁩",
    "place": "אגרה, הודו",
    "lat": 27.175,
    "lon": 78.042,
    "desc": "הקיסר המוגולי שאה ג׳אהאן בנה את המאוזוליאום ממוזאיקת שיש לבן לזכר אשתו מומתאז מאהל שמתה בלידה. המבנה משלב אדריכלות מוגולית, פרסית, עות׳מאנית והודית. נחשב לפסגת האדריכלות המוגולית ולאחד המבנים היפים ביותר בעולם.",
    "rank": 49
  },
  {
    "id": "ar_hokusai_manga",
    "deck": "art",
    "title": "מנגה של הוקוסאי",
    "start": 1814,
    "end": 1878,
    "date": "⁦1814–1878⁩",
    "place": "אדו (טוקיו), יפן",
    "lat": 35.685,
    "lon": 139.751,
    "desc": "קצושיקה הוקוסאי הוציא לאור חמישה עשר כרכים של רישומים שכיסו כל נושא אפשרי, מבני אדם ודרך חיות ועד מפלצות. ה״מנגה״ שימשה ספר לימוד לאמנים ונפוצה במערב כסמל לאמנות יפנית. היא נחשבת לאחד מקודמני הקומיקס המודרני.",
    "rank": 50
  },
  {
    "id": "ar_moai",
    "deck": "art",
    "title": "פסלי המואי באי הפסחא",
    "start": 1100,
    "end": 1500,
    "date": "בערך ⁦1100–1500⁩",
    "place": "אי הפסחא, צ׳ילה",
    "lat": -27.125,
    "lon": -109.277,
    "desc": "תושבי ראפא נואי פיסלו כתשע מאות פסלי ראש ענקיים מאבן געשית, שמשקלם עד 82 טון. הפסלים מייצגים אבות קדושים והוצבו על פלטפורמות אבן פונים פנימה אל הכפרים. כיצד הועברו הפסלים עדיין נושא למחקר.",
    "rank": 51
  },
  {
    "id": "ar_renoir_moulin",
    "deck": "art",
    "title": "ריקוד במולן דה לה גאלט",
    "start": 1876,
    "end": 1876,
    "date": "1876",
    "place": "פריז, צרפת",
    "lat": 48.887,
    "lon": 2.34,
    "desc": "אוגוסט רנואר צייר מסיבת ריקודים חוצות במונמארטר עם אפקט של אור שמש מסונן דרך עצים. הציור מדגים את הרעיון האימפרסיוניסטי של לכידת רגע חולף של שמחה ואור. מוצג במוזיאון ד׳אורסה בפריז.",
    "rank": 52
  },
  {
    "id": "ar_michelangelo_judgment",
    "deck": "art",
    "title": "יום הדין של מיכלאנג׳לו",
    "start": 1536,
    "end": 1541,
    "date": "⁦1536–1541⁩",
    "place": "הוותיקן, רומא",
    "lat": 41.903,
    "lon": 12.454,
    "desc": "מיכלאנג׳לו חזר לקפלה הסיסטינית כדי לצייר את הפרסקו הענק על קיר המזבח, כעשרים שנה אחרי התקרה. הציור מתאר את ישו השופט ומאות דמויות עירומות, מה שגרר ביקורת עד שבגדים צוירו מעליהן. היצירה נחשבת לפסגת הדרמה הויזואלית ברנסנס.",
    "rank": 53
  },
  {
    "id": "ar_bayeux",
    "deck": "art",
    "title": "שטיח באייה",
    "start": 1070,
    "end": 1080,
    "date": "בערך ⁦1070–1080⁩",
    "place": "באייה, נורמנדיה, צרפת",
    "lat": 49.277,
    "lon": -0.703,
    "desc": "רקמה באורך 70 מטר המתארת את כיבוש אנגליה בידי ויליאם מנורמנדיה, מתוכננת כרצף נרטיבי מפורט. היצירה כוללת 626 דמויות, סוסים, ספינות וסצנות קרב עם כתוביות בלטינית. זו מקור ויזואלי ייחודי לאירועי המאה האחת עשרה ולפרטי לבוש, נשק ואניות.",
    "rank": 54
  },
  {
    "id": "ar_cezanne_saint_victoire",
    "deck": "art",
    "title": "הר סנט ויקטואר של סזאן",
    "start": 1882,
    "end": 1906,
    "date": "⁦1882–1906⁩",
    "place": "אקס-אן-פרובאנס, צרפת",
    "lat": 43.533,
    "lon": 5.633,
    "desc": "פול סזאן צייר את ההר שליד ביתו עשרות פעמים, כל גרסה מפרקת את הנוף ליותר צורות גיאומטריות. עבודתו על מבנה הצורה והצבע בנוף הפכה אותו ל״אבי המודרניזם״. פיקאסו, בראק ומאטיס ראו בו את המורה החשוב ביותר שלהם.",
    "rank": 55
  },
  {
    "id": "ar_kandinsky_composition",
    "deck": "art",
    "title": "הקומפוזיציה הראשונה המופשטת של קנדינסקי",
    "start": 1910,
    "end": 1910,
    "date": "1910",
    "place": "מוסקבה, רוסיה",
    "lat": 55.755,
    "lon": 37.618,
    "desc": "ואסילי קנדינסקי צייר אקוורל ללא כל נושא ייצוגי, מהראשונים בהיסטוריה. הוא גרס שצורות וצבעים יכולים לעורר רגשות ישירות כמו מוזיקה, בלי לייצג מאומה. קנדינסקי הניח את היסודות התיאורטיים של האמנות המופשטת.",
    "rank": 56
  },
  {
    "id": "ar_book_kells",
    "deck": "art",
    "title": "ספר קלס",
    "start": 800,
    "end": 800,
    "date": "בערך 800 לספירה",
    "place": "אי איונה / קלס, אירלנד",
    "lat": 53.727,
    "lon": -6.669,
    "desc": "נזירים נוצרים יצרו כתב יד מאויר מפואר של ארבעת הבשורות בציורים עשירים בצבעים חיים ועיטורים סבוכים. הוא נחשב לפסגת האמנות הקלטית-נוצרית ולאחד כתבי היד המעוטרים ביותר שנותרו. מוצג בספריית הטריניטי בדבלין.",
    "rank": 57
  },
  {
    "id": "ar_malevich_square",
    "deck": "art",
    "title": "הריבוע השחור של מלביץ׳",
    "start": 1915,
    "end": 1915,
    "date": "1915",
    "place": "פטרוגרד (סנט פטרבורג), רוסיה",
    "lat": 59.934,
    "lon": 30.335,
    "desc": "קזימיר מלביץ׳ הציג ריבוע שחור על רקע לבן בתערוכה בפטרוגרד כהצהרת אמנות טהורה. הציור תלה בפינה העליונה של החדר, המקום המסורתי לאיקונות רוסיות. מלביץ׳ כינה את הזרם ״סופרמטיזם״ וטען שצורה וצבע הם תוכן האמנות.",
    "rank": 58
  },
  {
    "id": "ar_rubens_descent",
    "deck": "art",
    "title": "הורדה מהצלב של רובנס",
    "start": 1612,
    "end": 1614,
    "date": "⁦1612–1614⁩",
    "place": "אנטוורפן, בלגיה",
    "lat": 51.221,
    "lon": 4.401,
    "desc": "פיטר פאול רובנס צייר את טריפטיכון הענק לקתדרלת אנטוורפן, עם גופו של ישו שופע מוצנע מהצלב בתנועה דרמטית. השימוש בצבע ודינמיקה של גופות הפך את רובנס למנהיג הבארוק הפלמי. היצירה עוררה השראה לדורות של ציירים.",
    "rank": 59
  },
  {
    "id": "ar_bauhaus_weimar",
    "deck": "art",
    "title": "הקמת בית הספר באוהאוס",
    "start": 1919,
    "end": 1919,
    "date": "1919",
    "place": "ויימאר, גרמניה",
    "lat": 50.979,
    "lon": 11.323,
    "desc": "האדריכל ולטר גרופיוס ייסד את בית הספר שאיחד אמנות, עיצוב ומלאכה. הבאוהאוס טען שאמנות וטכנולוגיה חייבות להתמזג ושעיצוב טוב נגיש לכולם. אף שנסגר בידי הנאצים אחרי 14 שנה, עקרונותיו עיצבו את כל העיצוב המודרני.",
    "rank": 60
  },
  {
    "id": "ar_monet_impression",
    "deck": "art",
    "title": "התערוכה האימפרסיוניסטית הראשונה",
    "start": 1874,
    "end": 1874,
    "date": "1874",
    "place": "פריז, צרפת",
    "lat": 48.871,
    "lon": 2.331,
    "desc": "שלושים אמנים שנדחו מהסלון הרשמי הציגו בסטודיו של נאדר בשדרות הקפוצינים. מבקרים לעגו לסגנון הרופף, אך התערוכה סימנה את לידת התנועה האימפרסיוניסטית. בין המציגים: מונה, רנואר, דגא, פיסארו, סיסלי ומוריזו.",
    "rank": 61
  },
  {
    "id": "ar_mondrian_composition",
    "deck": "art",
    "title": "קומפוזיציה עם אדום, כחול וצהוב של מונדריאן",
    "start": 1930,
    "end": 1930,
    "date": "1930",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "פיט מונדריאן צמצם את הציור לקווים שחורים ישרים עם מלבנים בצבעי היסוד. גישתו של ניאו-פלסטיציזם חיפשה איזון אוניברסלי והרמוניה בלי לייצג מאומה. ההשפעה ניכרת בעיצוב, אופנה ואדריכלות עד היום.",
    "rank": 62
  },
  {
    "id": "ar_wright_falling",
    "deck": "art",
    "title": "בית המפל של פרנק לויד רייט",
    "start": 1936,
    "end": 1939,
    "date": "⁦1936–1939⁩",
    "place": "מיל ראן, פנסילבניה, ארצות הברית",
    "lat": 39.906,
    "lon": -79.468,
    "desc": "פרנק לויד רייט תכנן בית נופש מעל מפל טבעי, עם מרפסות בטון מרחפות מעל המים. הבניין מגלם את הפילוסופיה של ״אדריכלות אורגנית״ המשתלבת בטבע. נחשב לאחד המבנים החשובים ביותר באדריכלות האמריקנית.",
    "rank": 63
  },
  {
    "id": "ar_durer_rhinoceros",
    "deck": "art",
    "title": "הקרנף של דירר",
    "start": 1515,
    "end": 1515,
    "date": "1515",
    "place": "נירנברג, גרמניה",
    "lat": 49.454,
    "lon": 11.077,
    "desc": "אלברכט דירר יצר חיתוך עץ של קרנף הודי על סמך תיאור ורישום שקיבל, בלי לראות את החיה בעצמו. למרות אי-דיוקים אנטומיים, התמונה נחשבה לתיאור מדויק ושועתקה למעלה מ-300 שנה. היא אחת מיצירות חיתוך העץ המפורסמות ביותר.",
    "rank": 64
  },
  {
    "id": "ar_rembrandt_self",
    "deck": "art",
    "title": "הדיוקנאות העצמיים של רמברנדט",
    "start": 1628,
    "end": 1669,
    "date": "⁦1628–1669⁩",
    "place": "אמסטרדם, הולנד",
    "lat": 52.37,
    "lon": 4.885,
    "desc": "רמברנדט צייר כ-80 דיוקנאות עצמיים לאורך ארבעים שנה, מצעירוּת שאפתנית ועד זיקנה מיוסרת. הסדרה מהווה רשומה ויזואלית ייחודית של הזדקנות ושינוי פנימי. רמברנדט נחשב לאחד הציירים הגדולים ביותר בהיסטוריה.",
    "rank": 65
  },
  {
    "id": "ar_turner_rain",
    "deck": "art",
    "title": "גשם, קיטור ומהירות של טרנר",
    "start": 1844,
    "end": 1844,
    "date": "1844",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.118,
    "desc": "ג׳וזף מאלורד וויליאם טרנר צייר קטר חוצה גשר בגשם סוער, כשהצורות נמסות לאור ואדי מים. הציור חזה את ההתפתחות לכיוון ההפשטה וקנה לטרנר את התואר ״צייר האור״. מוצג בגלריה הלאומית בלונדון.",
    "rank": 66
  },
  {
    "id": "ar_seurat_sunday",
    "deck": "art",
    "title": "אחר הצהריים של יום ראשון באי לה גראנד ז׳את",
    "start": 1884,
    "end": 1886,
    "date": "⁦1884–1886⁩",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "ז׳ורז׳ סרה פיתח את טכניקת הפוינטיליזם: נקודות צבע קטנות המתמזגות בעין הצופה. הציור מציג פריזאים נחים על גדת הסן בסדר כמעט גיאומטרי. סרה מת בגיל 31, אך השיטה שלו השפיעה על אמנים רבים.",
    "rank": 67
  },
  {
    "id": "ar_vermeer_milkmaid",
    "deck": "art",
    "title": "החולבת של ורמיר",
    "start": 1658,
    "end": 1660,
    "date": "בערך ⁦1658–1660⁩",
    "place": "דלפט, הולנד",
    "lat": 52.011,
    "lon": 4.357,
    "desc": "יוהנס ורמיר צייר משרתת שופכת חלב בתאורה צדדית רכה, ברמת פרטים מדהימה. הציור מגלם את מאפייני ורמיר: רוגע, אור טבעי ונושאים יומיומיים מוגבהים לפואטיקה. מוצג בריקסמוזיאום באמסטרדם.",
    "rank": 68
  },
  {
    "id": "ar_bernini_ecstasy",
    "deck": "art",
    "title": "אקסטזה של תרזה הקדושה",
    "start": 1647,
    "end": 1652,
    "date": "⁦1647–1652⁩",
    "place": "רומא, איטליה",
    "lat": 41.903,
    "lon": 12.497,
    "desc": "ג׳אן לורנצו ברניני פיסל את הנזירה התרזיאנית ברגע של חוויה מיסטית, כשמלאך חודר את ליבה בחץ. השיש מדמה בד מקומט, בשר חי ועננים צפים בתאורה מכוונת מחלון נסתר. היצירה היא פסגת הדרמה הבארוקית.",
    "rank": 69
  },
  {
    "id": "ar_gaudi_park",
    "deck": "art",
    "title": "פארק גואל של גאודי",
    "start": 1900,
    "end": 1914,
    "date": "⁦1900–1914⁩",
    "place": "ברצלונה, ספרד",
    "lat": 41.414,
    "lon": 2.153,
    "desc": "אנטוני גאודי עיצב פארק ציבורי מכוסה מוזאיקות צבעוניות מחרסינה שבורה (טרנקדיס). הלטאה הגדולה, הספסל המתפתל והעמודים המוטים מגלמים את הסגנון האורגני של גאודי. הפארק תוכנן כשכונת גנים אך כשל מסחרית והפך למתחם ציבורי.",
    "rank": 70
  },
  {
    "id": "ar_frida_two_fridas",
    "deck": "art",
    "title": "שתי הפרידות של קאלו",
    "start": 1939,
    "end": 1939,
    "date": "1939",
    "place": "מקסיקו סיטי, מקסיקו",
    "lat": 19.432,
    "lon": -99.133,
    "desc": "פרידה קאלו ציירה את עצמה כפולה: אחת בלבוש אירופי והשנייה בלבוש מקסיקני, מחוברות בכלי דם. הציור נוצר אחרי הגירושים מדייגו ריברה ומבטא את הזהות הכפולה שלה. קאלו הפכה לאייקון של הסוריאליזם, הפמיניזם והזהות הלטינו-אמריקנית.",
    "rank": 71
  },
  {
    "id": "ar_sphinx",
    "deck": "art",
    "title": "הספינקס הגדול בגיזה",
    "start": -2500,
    "end": -2500,
    "date": "בערך 2500 לפנה״ס",
    "place": "גיזה, מצרים",
    "lat": 29.975,
    "lon": 31.138,
    "desc": "פסל ענק בצורת אריה עם ראש אנושי חצוב בסלע חי ליד הפירמידות. באורך 73 מטר ובגובה 20 מטר, הוא הפסל המונוליתי הגדול ביותר בעולם. זהות הפרצוף שנויה במחלוקת, אך הנחה מקובלת היא שמדובר בפרעה ח׳פרע.",
    "rank": 72
  },
  {
    "id": "ar_altamira",
    "deck": "art",
    "title": "ציורי מערת אלטמירה",
    "start": -36000,
    "end": -15000,
    "date": "בערך ⁦36,000–15,000⁩ לפנה״ס",
    "place": "סנטיאנה דל מאר, ספרד",
    "lat": 43.379,
    "lon": -4.12,
    "desc": "ציורי ביזונים פוליכרומטיים על תקרת המערה נחשבים לשיא האמנות הפרהיסטורית. כשנתגלו לראשונה סירבו מומחים להאמין שבני אדם פרהיסטוריים יכלו ליצור אמנות כזו מתוחכמת. המערה נסגרה לקהל כדי לשמור על הציורים, ונבנה עותק.",
    "rank": 73
  },
  {
    "id": "ar_koons_balloon",
    "deck": "art",
    "title": "כלב הבלון של קונס",
    "start": 1994,
    "end": 2000,
    "date": "⁦1994–2000⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "ג׳ף קונס יצר פסלי פלדת אל-חלד ענקיים בצורת בלוני מסיבה מפותלים, בגובה שלושה מטר. הפסלים מטשטשים את הגבול בין קיטש, אמנות גבוהה ותרבות צריכה. כלב הבלון הכתום נמכר ב-58 מיליון דולר ב-2013.",
    "rank": 74
  },
  {
    "id": "ar_chauvet",
    "deck": "art",
    "title": "ציורי מערת שובה",
    "start": -36000,
    "end": -32000,
    "date": "בערך ⁦36,000–32,000⁩ לפנה״ס",
    "place": "אדרש, צרפת",
    "lat": 44.389,
    "lon": 4.42,
    "desc": "ציורי הפחם והאוכרה במערת שובה הם מהעתיקים ביותר שנמצאו, כולל אריות, דובים, ממותות וקרנפים. הציורים מפגינים פרספקטיבה ותנועה מתוחכמות שלא נצפו בציורים פרהיסטוריים אחרים. המערה נמצאת בוודאי ארדש ונמצאה רק ב-1994.",
    "rank": 75
  },
  {
    "id": "ar_elgin_marbles",
    "deck": "art",
    "title": "שיירי הפרתנון מגיעים ללונדון",
    "start": 1801,
    "end": 1812,
    "date": "⁦1801–1812⁩",
    "place": "לונדון, אנגליה",
    "lat": 51.519,
    "lon": -0.127,
    "desc": "לורד אלגין הוריד פסלים ופריזים מהפרתנון באתונה והעבירם לאנגליה. הגבות נרכשו על ידי המוזיאון הבריטי ומוצגות שם מאז, וגרמו לוויכוח בינלאומי מתמשך. יוון דורשת את השבתן מאז שנות ה-80.",
    "rank": 76
  },
  {
    "id": "ar_liu_calligraphy",
    "deck": "art",
    "title": "הקליגרפיה הסינית מגיעה לשיאה",
    "start": 303,
    "end": 361,
    "date": "⁦303–361⁩ לספירה",
    "place": "ג׳יאנגנאן, סין",
    "lat": 30.274,
    "lon": 120.155,
    "desc": "ואנג שי-ג׳י נחשב ל״מלך הקליגרפיה״ וקבע את הסטנדרט לכתב ההמהלך (שינגשו) שהשפיע על אלפי שנים של קליגרפיה סינית. יצירתו ״הקדמה לאוסף ביתן האורכידאה״ מוחזקת כאחת היצירות הנעלות ביותר בקליגרפיה. האמנות נחשבת בסין לצורת ביטוי נשגבת מציור.",
    "rank": 77
  },
  {
    "id": "ar_chartres",
    "deck": "art",
    "title": "השלמת קתדרלת שארטר",
    "start": 1194,
    "end": 1220,
    "date": "⁦1194–1220⁩",
    "place": "שארטר, צרפת",
    "lat": 48.448,
    "lon": 1.488,
    "desc": "קתדרלת שארטר נבנתה מחדש בסגנון גותי עילי אחרי שריפה, עם חלונות ויטראז׳ מהמרשימים בעולם. הכחול העמוק של חלונות שארטר הפך לאגדי ולא שוחזר מאז. הפסלים ב-2,000 דמויות מפיצים את סיפורי המקרא לאנשים שלא ידעו לקרוא.",
    "rank": 78
  },
  {
    "id": "ar_ukiyoe",
    "deck": "art",
    "title": "פריחת אמנות האוקייו-אה ביפן",
    "start": 1680,
    "end": 1680,
    "date": "בערך 1680",
    "place": "אדו (טוקיו), יפן",
    "lat": 35.685,
    "lon": 139.751,
    "desc": "אמנות ״התמונות של העולם הצף״ פרחה בתקופת אדו, עם הדפסי עץ המתארים גישות, שחקנים, נופים ופנאי. אמנים כמו הירושיגה, אוטמארו והוקוסאי הפכו את הטכניקה לאמנות עממית נגישה. כשהגיעה לאירופה, עוררה את ה״ז׳אפוניזם״ והשפיעה על האימפרסיוניסטים.",
    "rank": 79
  },
  {
    "id": "ar_alhambra",
    "deck": "art",
    "title": "בניית אלהמברה בגרנדה",
    "start": 1238,
    "end": 1358,
    "date": "⁦1238–1358⁩",
    "place": "גרנדה, ספרד",
    "lat": 37.177,
    "lon": -3.588,
    "desc": "שליטי נצריד בנו את מכלול הארמונות על גבעה מעל גרנדה, עם חצרות, מזרקות ועיטורי גבס מורכבים. חצר האריות עם 124 עמודי שיש דקים נחשבת לפסגת האדריכלות האסלאמית בספרד. ואשינגטון אירווינג הפך את המקום למפורסם בספרו ״סיפורי אלהמברה״.",
    "rank": 80
  },
  {
    "id": "ar_benin_bronzes",
    "deck": "art",
    "title": "ברונזות בנין",
    "start": 1550,
    "end": 1650,
    "date": "בערך ⁦1550–1650⁩",
    "place": "בנין סיטי, ניגריה",
    "lat": 6.335,
    "lon": 5.627,
    "desc": "אמני ממלכת בנין יצרו מאות לוחות פליז ותבליטים מפורטים שעיטרו את ארמון האובה. היציקות מציגות רמה טכנית שהדהימה את האירופים כשנשדדו בידי הבריטים ב-1897. מוזיאונים מערביים החלו להשיב חלק מהברונזות לניגריה.",
    "rank": 81
  },
  {
    "id": "ar_daguerre",
    "deck": "art",
    "title": "המצאת הדאגרוטיפ",
    "start": 1839,
    "end": 1839,
    "date": "1839",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "לואי דאגר הציג את תהליך הצילום הראשון המעשי, המייצר תמונה ישירה על לוחית כסף. ממשלת צרפת רכשה את הפטנט ונתנה אותו לעולם כולו. ההמצאה שינתה את האמנות, המדע והתקשורת ועוררה שאלות שעדיין מהדהדות: האם צילום הוא אמנות?",
    "rank": 82
  },
  {
    "id": "ar_rothko_seagram",
    "deck": "art",
    "title": "ציורי סיגרם של רותקו",
    "start": 1958,
    "end": 1959,
    "date": "⁦1958–1959⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.758,
    "lon": -73.972,
    "desc": "מארק רותקו הוזמן לצייר ציורי קיר למסעדת הפור סיזנס ביקרת בניין סיגרם, אך בסוף החזיר את התשלום כי סירב שהעשירים ייהנו מעבודתו תוך כדי אכילה. הציורים הכהים חולקו בין טייט מודרן, קאוואקאן ובגלריה הלאומית. הסדרה מייצגת את ההתעצמות הרוחנית של עבודתו.",
    "rank": 83
  },
  {
    "id": "ar_christo_gates",
    "deck": "art",
    "title": "השערים של כריסטו בסנטרל פארק",
    "start": 2005,
    "end": 2005,
    "date": "2005",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.783,
    "lon": -73.965,
    "desc": "כריסטו וז׳אן-קלוד הקימו 7,503 שערים בגובה חמישה מטר עם בדים כתומים לאורך שבילי הפארק. המיצב הארעי עמד שישה עשר ימים בלבד ומשך ארבעה מיליון מבקרים. כריסטו מימן את הפרויקט מכספו, בעלות של 21 מיליון דולר.",
    "rank": 84
  },
  {
    "id": "ar_wright_guggenheim",
    "deck": "art",
    "title": "מוזיאון גוגנהיים בניו יורק",
    "start": 1956,
    "end": 1959,
    "date": "⁦1956–1959⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.783,
    "lon": -73.959,
    "desc": "פרנק לויד רייט תכנן את המבנה הספירלי הלבן כך שהמבקר עולה ברמפה רציפה ורואה אמנות לאורכה. הצורה הייחודית עוררה מחלוקת בין אמנים לאדריכלים. המוזיאון הפך לאחד המבנים המזוהים ביותר של ניו יורק.",
    "rank": 85
  },
  {
    "id": "ar_lumiere",
    "deck": "art",
    "title": "הקרנת הסרט הראשונה של האחים לומייר",
    "start": 1895,
    "end": 1895,
    "date": "1895",
    "place": "פריז, צרפת",
    "lat": 48.871,
    "lon": 2.342,
    "desc": "האחים לואי ואוגוסט לומייר הקרינו עשרה סרטים קצרים בפני קהל משלם בגרנד קפה של שדרות הקפוצינים. הצופים נחרדו מרכבת שנראתה דוהרת אליהם מן המסך. ההקרנה נחשבת ללידת הקולנוע כמדיום אמנותי ומסחרי.",
    "rank": 86
  },
  {
    "id": "ar_sydney_opera",
    "deck": "art",
    "title": "בניית בית האופרה בסידני",
    "start": 1959,
    "end": 1973,
    "date": "⁦1959–1973⁩",
    "place": "סידני, אוסטרליה",
    "lat": -33.857,
    "lon": 151.215,
    "desc": "האדריכל הדני יורן אוטצון זכה בתחרות תכנון עם עיצוב של מפרשים לבנים חופפים. הבנייה ארכה ארבע עשרה שנה ועלתה פי ארבע עשרה מהתקציב המקורי, ואוטצון פוטר לפני השלמתה. המבנה הפך לאייקון של אוסטרליה ולאחד בתי האופרה המוכרים בעולם.",
    "rank": 87
  },
  {
    "id": "ar_banksy_wall",
    "deck": "art",
    "title": "גרפיטי של בנקסי על גדר ההפרדה",
    "start": 2005,
    "end": 2005,
    "date": "2005",
    "place": "בית לחם, הגדה המערבית",
    "lat": 31.705,
    "lon": 35.202,
    "desc": "אמן הרחוב האנונימי בנקסי צייר סדרה של ציורי גרפיטי על גדר ההפרדה הישראלית, כולל ילדה מעפילה בלון ונופים מדומים. העבודות הפכו למוקד תיירותי ולסמל של מחאה אמנותית. בנקסי פתח מאוחר יותר מלון ״וולד אוף״ ליד הגדר.",
    "rank": 88
  },
  {
    "id": "ar_botticelli_primavera",
    "deck": "art",
    "title": "האביב של בוטיצ׳לי",
    "start": 1477,
    "end": 1482,
    "date": "בערך ⁦1477–1482⁩",
    "place": "פירנצה, איטליה",
    "lat": 43.769,
    "lon": 11.255,
    "desc": "סנדרו בוטיצ׳לי צייר סצנה אלגורית של האביב עם ונוס, מרקוריוס, החסדים השלוש וזפירוס הרוח. נחשבת לאחד הציורים הגדולים ביותר של הרנסנס המוקדם ולמחלקת האמנות ההדוקה ביותר למיתולוגיה קלאסית. מוצגת באופיצי בפירנצה.",
    "rank": 89
  },
  {
    "id": "ar_ai_weiwei_seeds",
    "deck": "art",
    "title": "מאה מיליון זרעי חמנייה של אי וויוויי",
    "start": 2010,
    "end": 2010,
    "date": "2010",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.1,
    "desc": "אי וויוויי כיסה את רצפת אולם הטורבינות בטייט מודרן במאה מיליון זרעי חמנייה מפורצלן מצוירים ביד. כל זרע יוצר על ידי אחד מ-1,600 בעלי מלאכה בג׳ינגדג׳ן. היצירה מעלה שאלות על ייצור המוני, אינדיבידואליות ויחסי סין עם המערב.",
    "rank": 90
  },
  {
    "id": "ar_brancusi_bird",
    "deck": "art",
    "title": "הציפור במרחב של ברנקוזי",
    "start": 1923,
    "end": 1923,
    "date": "1923",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "קונסטנטין ברנקוזי פיסל צורת ברונזה חלקה ומוארכת, המסמלת את מהות הטיסה בלי לתאר ציפור ממשית. בכניסתו לארצות הברית סירבו המכס להכיר בו כאמנות וסיווגו אותו כמתכת חייבת מכס. המשפט שבא בעקבות כך הגדיר מחדש את האמנות בחוק האמריקני.",
    "rank": 91
  },
  {
    "id": "ar_moore_reclining",
    "deck": "art",
    "title": "הדמות השוכבת של הנרי מור",
    "start": 1929,
    "end": 1929,
    "date": "1929",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.118,
    "desc": "הנרי מור פיתח את מוטיב הדמות השוכבת לאורך עשרות שנים, בגרסאות של אבן, ברונזה ועץ. הצורות האורגניות החלולות השפיעו על הפיסול של המאה העשרים. פסליו הענקיים מוצבים בחללים ציבוריים ברחבי העולם.",
    "rank": 92
  },
  {
    "id": "ar_maya_murals",
    "deck": "art",
    "title": "ציורי הקיר של בונמפק",
    "start": 790,
    "end": 790,
    "date": "בערך 790 לספירה",
    "place": "בונמפק, מקסיקו",
    "lat": 16.704,
    "lon": -91.065,
    "desc": "ציורי קיר מאיים בשלושה חדרים בעיר מאיה מתארים טקסים, קרבות ושבויים בצבעים עזים ובפרטים מדויקים. הציורים הם המקור הוויזואלי החשוב ביותר לחיי היומיום של תרבות המאיה הקלאסית. נשתמרו בזכות שכבת אבנית שכיסתה אותם.",
    "rank": 93
  },
  {
    "id": "ar_frieze_alexander",
    "deck": "art",
    "title": "מוזאיקת אלכסנדר בפומפיי",
    "start": -100,
    "end": -100,
    "date": "בערך 100 לפנה״ס",
    "place": "פומפיי, איטליה",
    "lat": 40.75,
    "lon": 14.486,
    "desc": "מוזאיקת רצפה גדולה בבית הפאון בפומפיי מתארת את קרב איסוס בין אלכסנדר הגדול לדריוש השלישי. היצירה מכילה כמיליון וחצי קוביות אבן ומציגה פרטים של חיילים, סוסים ונשק. היא כנראה עותק רומי של ציור יווני אבוד.",
    "rank": 94
  },
  {
    "id": "ar_kahlo_diary",
    "deck": "art",
    "title": "היומן המאויר של פרידה קאלו",
    "start": 1944,
    "end": 1954,
    "date": "⁦1944–1954⁩",
    "place": "מקסיקו סיטי, מקסיקו",
    "lat": 19.432,
    "lon": -99.133,
    "desc": "בעשר שנותיה האחרונות ניהלה פרידה קאלו יומן מאויר עם ציורים, טקסטים ושירים המתעדים כאב פיזי, אהבה ומחשבות פוליטיות. היומן כולל 170 עמודים עם שפה ויזואלית ייחודית. הוא מהווה חלון אינטימי לנפשה ונחשב ליצירה עצמאית.",
    "rank": 95
  },
  {
    "id": "ar_le_corbusier_chapel",
    "deck": "art",
    "title": "קפלת רונשאן של לה קורבוזיה",
    "start": 1950,
    "end": 1955,
    "date": "⁦1950–1955⁩",
    "place": "רונשאן, צרפת",
    "lat": 47.704,
    "lon": 6.621,
    "desc": "לה קורבוזיה תכנן את הקפלה הקטנה עם גג מעוקל כמפרש וקירות עבים שבהם חלונות בצורות משתנות. המבנה שבר עם הרציונליזם שלו עצמו ויצר חלל רוחני של אור וצל. נחשב לאחד המבנים הדתיים המשמעותיים ביותר של המאה העשרים.",
    "rank": 96
  },
  {
    "id": "ar_giacometti_walking",
    "deck": "art",
    "title": "האדם ההולך של ג׳אקומטי",
    "start": 1961,
    "end": 1961,
    "date": "1961",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "אלברטו ג׳אקומטי פיסל דמות מוארכת וכחושה צועדת קדימה, המבטאת בדידות קיומית. סגנון הדמויות הארוכות והדקות שלו הושפע מהאקזיסטנציאליזם ומחוויית המלחמה. עותק ברונזה נמכר ב-141 מיליון דולר, שיא לפסל במכירה פומבית.",
    "rank": 97
  },
  {
    "id": "ar_van_eyck_altarpiece",
    "deck": "art",
    "title": "מזבח גנט של ואן אייק",
    "start": 1426,
    "end": 1432,
    "date": "⁦1426–1432⁩",
    "place": "גנט, בלגיה",
    "lat": 51.053,
    "lon": 3.727,
    "desc": "הוברט ויאן ואן אייק יצרו פוליפטיכון עם שנים עשר פאנלים, כולל ״סגידה לשה האלוהים״ כפאנל מרכזי. היצירה חוללה מהפכה בציור שמן פלמי ובטכניקת הפרטים הריאליסטיים. המזבח נגנב שש פעמים, כולל על ידי הנאצים, ותמיד הושב.",
    "rank": 98
  },
  {
    "id": "ar_kusama_infinity",
    "deck": "art",
    "title": "חדרי האינסוף של קוסמה",
    "start": 1965,
    "end": 1965,
    "date": "1965",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "יאיוי קוסמה יצרה את חדרי המראות המנוקדים הראשונים, מיצבים סוחפים שמייצרים אשליית מרחב אינסופי. קוסמה, שסובלת ממחלת נפש, הפכה את ההזיות שלה לאמנות. היום בגילה המתקדם היא האמנית החיה בעלת ההכנסות הגבוהות ביותר.",
    "rank": 99
  },
  {
    "id": "ar_hirst_shark",
    "deck": "art",
    "title": "הכריש בפורמלדהיד של הירסט",
    "start": 1991,
    "end": 1991,
    "date": "1991",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.118,
    "desc": "דמיאן הירסט הציב כריש טיגריסי בן ארבעה מטר בתוך ויטרינת זכוכית מלאה פורמלדהיד, ונתן ליצירה כותרת ארוכה. העבודה הפכה את הירסט למנהיג קבוצת yBa (אמנים בריטיים צעירים) והגדירה מחדש מה מותר באמנות עכשווית. נמכרה באמצע שנות ה-2000 בשמונה מיליון דולר.",
    "rank": 100
  },
  {
    "id": "ar_gauguin_tahiti",
    "deck": "art",
    "title": "הציורים הטהיטיאניים של גוגן",
    "start": 1891,
    "end": 1893,
    "date": "⁦1891–1893⁩",
    "place": "טהיטי, פולינזיה הצרפתית",
    "lat": -17.535,
    "lon": -149.569,
    "desc": "פול גוגן עזב את פריז לטהיטי בחיפוש אחר ״פרימיטיביות״ ואותנטיות. הציורים שצייר שם, עם צבעים שטוחים ועזים ודמויות פולינזיות, הפכו לסמל הפוסט-אימפרסיוניזם. מורשתו מורכבת: חלוץ אמנותי אך גם דמות קולוניאליסטית בעייתית.",
    "rank": 101
  },
  {
    "id": "ar_eisenstein_potemkin",
    "deck": "art",
    "title": "שריון הקרב פוטיומקין של אייזנשטיין",
    "start": 1925,
    "end": 1925,
    "date": "1925",
    "place": "מוסקבה / אודסה, ברית המועצות",
    "lat": 46.482,
    "lon": 30.723,
    "desc": "סרגיי אייזנשטיין ביים את הסרט שכלל את סצנת מדרגות אודסה, מהסצנות המצוטטות ביותר בתולדות הקולנוע. טכניקת המונטאז׳ שפיתח שינתה את שפת הסרט. הסרט הוזמן כפרופגנדה סובייטית אך הפך ליצירה קולנועית חוצת גבולות.",
    "rank": 102
  },
  {
    "id": "ar_kapoor_bean",
    "deck": "art",
    "title": "שער הענן של קאפור בשיקגו",
    "start": 2004,
    "end": 2006,
    "date": "⁦2004–2006⁩",
    "place": "שיקגו, ארצות הברית",
    "lat": 41.883,
    "lon": -87.623,
    "desc": "אניש קאפור יצר פסל פלדת אל-חלד מלוטש בצורת שעועית ענקית שמשקף את קו הרקיע של שיקגו. ה-Cloud Gate, הידוע כ״השעועית״, הפך במהירות לאייקון של העיר ומושך מיליוני מבקרים. פני השטח המעוותים יוצרים רפלקסיה שמשלבת את הצופה ביצירה.",
    "rank": 103
  },
  {
    "id": "ar_nadar_photography",
    "deck": "art",
    "title": "הדיוקנאות הצילומיים של נאדר",
    "start": 1854,
    "end": 1870,
    "date": "בערך ⁦1854–1870⁩",
    "place": "פריז, צרפת",
    "lat": 48.871,
    "lon": 2.331,
    "desc": "גספאר-פליקס טורנשון, הידוע כנאדר, צילם דיוקנאות של גדולי התרבות הצרפתית כמו בודלר, ויקטור הוגו ושרה ברנהרדט. הוא הפך את הצילום לאמנות דיוקן מכובדת ולא רק תיעוד טכני. הסטודיו שלו שימש גם להקרנת האימפרסיוניסטים.",
    "rank": 104
  },
  {
    "id": "ar_van_gogh_room",
    "deck": "art",
    "title": "חדר השינה בארל של ואן גוך",
    "start": 1888,
    "end": 1888,
    "date": "1888",
    "place": "ארל, צרפת",
    "lat": 43.677,
    "lon": 4.631,
    "desc": "וינסנט ואן גוך צייר שלוש גרסאות של חדר שינתו הפשוט בבית הצהוב בארל, בצבעים שטוחים ופרספקטיבה מעוותת. הציור מבטא את שאיפתו למנוחה ופשטות בתקופה סוערת. את הגרסה הראשונה צייר ימים לפני שגוגן הגיע לגור איתו.",
    "rank": 105
  },
  {
    "id": "ar_donatello_david",
    "deck": "art",
    "title": "דוד של דונטלו",
    "start": 1440,
    "end": 1440,
    "date": "בערך 1440",
    "place": "פירנצה, איטליה",
    "lat": 43.769,
    "lon": 11.255,
    "desc": "דונטלו פיסל את דוד הנער בברונזה כפסל העירום הראשון בגודל טבעי מאז ימי רומא העתיקה. הנער העדין עומד על ראשו הכרות של גוליית בתנוחה ניגודית. הפסל סימן את שיבת האנטומיה והעירום לאמנות המערבית.",
    "rank": 106
  },
  {
    "id": "ar_marina_artist_present",
    "deck": "art",
    "title": "האמנית נוכחת של מרינה אברמוביץ׳",
    "start": 2010,
    "end": 2010,
    "date": "2010",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.978,
    "desc": "מרינה אברמוביץ׳ ישבה בשתיקה על כיסא במוזיאון MoMA שבע שעות ביום במשך שלושה חודשים, מול כל מבקר שרצה לשבת מולה. הפרפורמנס הפך מבקרים לדמעות ויצר תורים של שעות. היצירה הפכה את אמנות הביצוע לאירוע המוני.",
    "rank": 107
  },
  {
    "id": "ar_smithson_spiral",
    "deck": "art",
    "title": "שובל הספירלה של סמית׳סון",
    "start": 1970,
    "end": 1970,
    "date": "1970",
    "place": "אגם המלח הגדול, יוטה, ארצות הברית",
    "lat": 41.438,
    "lon": -112.669,
    "desc": "רוברט סמית׳סון בנה שובל של בזלת, אדמה וגבישי מלח שנכנס לאגם בצורת ספירלה באורך 460 מטר. היצירה, שעולה ונעלמת עם מפלס האגם, נחשבת ליצירת הלנד ארט החשובה ביותר. סמית׳סון נהרג בתאונת מטוס שלוש שנים מאוחר יותר.",
    "rank": 108
  },
  {
    "id": "ar_titian_venus",
    "deck": "art",
    "title": "ונוס מאורבינו של טיציאן",
    "start": 1534,
    "end": 1534,
    "date": "1534",
    "place": "ונציה, איטליה",
    "lat": 45.44,
    "lon": 12.332,
    "desc": "טיציאנו וצ׳ליו צייר אישה עירומה שוכבת על מיטה עם מבט ישיר לצופה. הציור עורר ביקורת ונחשב לפרובוקטיבי בגלל העירום הגלוי. מאנה של אדואר מאנה (1863) שיחק עם הקומפוזיציה הזו ועורר שערורייה דומה.",
    "rank": 109
  },
  {
    "id": "ar_citizen_kane",
    "deck": "art",
    "title": "אזרח קיין של אורסון וולס",
    "start": 1941,
    "end": 1941,
    "date": "1941",
    "place": "הוליווד, ארצות הברית",
    "lat": 34.098,
    "lon": -118.326,
    "desc": "אורסון וולס ביים, כתב וכיכב בסרטו הראשון בגיל 25, עם חידושים בצילום, עריכה ומבנה נרטיבי. הסרט מספר את חייו של איל תקשורת ונחשב על ידי רבים לסרט הגדול ביותר שנעשה. בזמנו נכשל מסחרית בגלל לחץ של וויליאם רנדולף הרסט, עליו התבסס הסיפור.",
    "rank": 110
  },
  {
    "id": "ar_manet_olympia",
    "deck": "art",
    "title": "אולימפיה של מאנה",
    "start": 1863,
    "end": 1863,
    "date": "1863",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "אדואר מאנה צייר יצאנית פריזאית עירומה בתאורה שטוחה ובמבט חסר בושה, בניגוד לעירומים אידיאליים מקובלים. הציור עורר שערורייה בסלון ונחשב לנקודת פתיחה של המודרניזם בציור. מאנה שבר את הקונבנציות ופתח את הדרך לאימפרסיוניסטים.",
    "rank": 111
  },
  {
    "id": "ar_david_oath",
    "deck": "art",
    "title": "שבועת ההוראציים של דוד",
    "start": 1784,
    "end": 1784,
    "date": "1784",
    "place": "רומא / פריז",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "ז׳אק-לואי דוד צייר שלושה אחים רומאים נשבעים לאביהם להילחם, בהשראת סיפור רומי קלאסי. הציור הניאו-קלאסי הפך לסמל של ערכי הרפובליקה לפני המהפכה הצרפתית. דוד עצמו היה חבר בועדה שהצביעה על הוצאתו להורג של לואי השישה עשר.",
    "rank": 112
  },
  {
    "id": "ar_picasso_blue",
    "deck": "art",
    "title": "התקופה הכחולה של פיקאסו",
    "start": 1901,
    "end": 1904,
    "date": "⁦1901–1904⁩",
    "place": "ברצלונה / פריז",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "פבלו פיקאסו צייר סדרת ציורים בגווני כחול ותכלת, המתארים עניים, מוזרים ובודדים. התקופה החלה אחרי התאבדות חברו הצייר קרלוס קסאחמס. ציורי התקופה הכחולה הם מהיקרים ביותר בעולם האמנות.",
    "rank": 113
  },
  {
    "id": "ar_kurosawa_rashomon",
    "deck": "art",
    "title": "רשומון של קורוסאווה",
    "start": 1950,
    "end": 1950,
    "date": "1950",
    "place": "קיוטו, יפן",
    "lat": 35.012,
    "lon": 135.768,
    "desc": "אקירה קורוסאווה ביים את הסרט שמציג אותו אירוע מנקודות מבט סותרות של ארבעה עדים. הסרט זכה באריה הזהב בוונציה והפך את הקולנוע היפני לכוח בינלאומי. ״אפקט רשומון״ נכנס לשפה כביטוי לסובייקטיביות של עדויות.",
    "rank": 114
  },
  {
    "id": "ar_stieglitz_gallery",
    "deck": "art",
    "title": "גלריית ״291״ של שטיגליץ",
    "start": 1905,
    "end": 1917,
    "date": "⁦1905–1917⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.748,
    "lon": -73.985,
    "desc": "אלפרד שטיגליץ פתח גלריה ברחוב חמישי 291 שהציגה צילום כאמנות לגיטימית לצד ציור ופיסול. הוא הביא את מאטיס, פיקאסו ורודן לקהל האמריקני לראשונה. שטיגליץ הגדיר את הצילום כאמנות שווה ערך לכל מדיום אחר.",
    "rank": 115
  },
  {
    "id": "ar_klee_angelus",
    "deck": "art",
    "title": "מלאך ההיסטוריה של פאול קלה",
    "start": 1920,
    "end": 1920,
    "date": "1920",
    "place": "מינכן, גרמניה",
    "lat": 48.137,
    "lon": 11.575,
    "desc": "פאול קלה צייר מלאך עם פנים שטוחים וכנפיים פרושות באקוורל ועט שמן. ולטר בנימין רכש את הציור ופירש אותו כאלגוריה לפילוסופיה של ההיסטוריה: המלאך מובל לאחור בידי סערת הקדמה ורואה הריסות. הציור מוצג במוזיאון ישראל בירושלים.",
    "rank": 116
  },
  {
    "id": "ar_melies_moon",
    "deck": "art",
    "title": "מסע לירח של מלייס",
    "start": 1902,
    "end": 1902,
    "date": "1902",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "ז׳ורז׳ מלייס ביים את הסרט בן ארבע עשרה הדקות עם אפקטים מיוחדים חלוציים, כולל הדימוי המפורסם של פגז תקוע בעין הירח. הסרט נחשב לסרט המדע הבדיוני הראשון ולציון דרך באמנות הקולנוע. מלייס, קוסם במקורו, המציא טכניקות שהגדירו את שפת הקולנוע.",
    "rank": 117
  },
  {
    "id": "ar_van_gogh_ear",
    "deck": "art",
    "title": "הדיוקן העצמי עם אוזן חבושה",
    "start": 1889,
    "end": 1889,
    "date": "1889",
    "place": "ארל, צרפת",
    "lat": 43.677,
    "lon": 4.631,
    "desc": "ואן גוך צייר את עצמו אחרי שחתך את אוזנו בעקבות עימות עם גוגן. הדיוקן העצמי על רקע כתום וירוק מציג כובע פרווה ומקטרת, ומבטא רוגע מפתיע. הציור הפך לסמל הקשר בין אמנות וייסורים נפשיים.",
    "rank": 118
  },
  {
    "id": "ar_gutenberg_bible",
    "deck": "art",
    "title": "התנ״ך של גוטנברג",
    "start": 1454,
    "end": 1455,
    "date": "⁦1454–1455⁩",
    "place": "מיינץ, גרמניה",
    "lat": 50.001,
    "lon": 8.272,
    "desc": "יוהנס גוטנברג הדפיס את הספר הראשון באירופה בדפוס אותיות ניידות, תנ״ך לטיני ב-42 שורות. הספר שילב הדפסה ביד מאוירת ורמת איכות טיפוגרפית שלא הושגה שוב במשך דורות. ההמצאה חוללה מהפכה בהפצת ידע ושינתה את מהלך ההיסטוריה.",
    "rank": 119
  },
  {
    "id": "ar_african_nok",
    "deck": "art",
    "title": "פסלי טרה-קוטה של תרבות נוק",
    "start": -500,
    "end": 200,
    "date": "בערך ⁦500⁩ לפנה״ס – ⁦200⁩ לספירה",
    "place": "מרכז ניגריה",
    "lat": 9.455,
    "lon": 8.028,
    "desc": "תרבות נוק במרכז ניגריה יצרה ראשי טרה-קוטה בעיניים חלולות ושפתיים מפוסלות בסגנון ייחודי. אלה מהפסלים העתיקים ביותר שנמצאו באפריקה שמדרום לסהרה. הם מעידים על חברה מפותחת שעיבדה ברזל ויצרה אמנות פיגורטיבית.",
    "rank": 120
  },
  {
    "id": "ar_mughal_miniature",
    "deck": "art",
    "title": "מיניאטורות מוגוליות",
    "start": 1560,
    "end": 1620,
    "date": "בערך ⁦1560–1620⁩",
    "place": "אגרה / לאהור, הודו",
    "lat": 27.175,
    "lon": 78.042,
    "desc": "הקיסרים אכבר וג׳אהאנגיר הקימו סדנאות ציור מלכותיות שבהן עשרות אמנים יצרו מיניאטורות צבעוניות מפורטות. הציורים תיעדו חיי חצר, ציד, קרבות וטבע בשילוב מסורות פרסיות והודיות. המסורת השפיעה על אמנות ההודית ונחשבת לפסגת הציור המוגולי.",
    "rank": 121
  },
  {
    "id": "ar_duchamp_bicycle",
    "deck": "art",
    "title": "גלגל האופניים של דושאן",
    "start": 1913,
    "end": 1913,
    "date": "1913",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "מרסל דושאן הציב גלגל קדמי של אופניים הפוך על שרפרף מטבח, ויצר את הרדי-מייד הראשון. הוא טען שבחירת האובייקט היא פעולה אמנותית כשלעצמה. היצירה שינתה את הגדרת האמנות ופתחה את הדרך לאמנות הקונספטואלית.",
    "rank": 122
  },
  {
    "id": "ar_new_wave",
    "deck": "art",
    "title": "הגל החדש הצרפתי בקולנוע",
    "start": 1959,
    "end": 1964,
    "date": "⁦1959–1964⁩",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "במאים צעירים כמו גודאר, טריפו, שאברול וריבט שברו את המוסכמות של הקולנוע הצרפתי. סרטים כמו ״נשימה אחרונה״ ו״ארבע מאות המכות״ הציגו עריכת קפיצה, צילום רחוב ונרטיב לא לינארי. הגל החדש השפיע על כל הקולנוע שבא אחריו.",
    "rank": 123
  },
  {
    "id": "ar_picasso_dove",
    "deck": "art",
    "title": "יונת השלום של פיקאסו",
    "start": 1949,
    "end": 1949,
    "date": "1949",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "פבלו פיקאסו צייר ליתוגרפיה של יונה לבנה שנבחרה כפוסטר לקונגרס השלום הבינלאומי בפריז. התמונה הפכה לסמל השלום המוכר ביותר בעולם. פיקאסו שם את בתו שנולדה באותה שנה ״פלומה״ — יונה בספרדית.",
    "rank": 124
  },
  {
    "id": "ar_corbusier_unite",
    "deck": "art",
    "title": "יחידת המגורים של לה קורבוזיה במרסיי",
    "start": 1947,
    "end": 1952,
    "date": "⁦1947–1952⁩",
    "place": "מרסיי, צרפת",
    "lat": 43.261,
    "lon": 5.396,
    "desc": "לה קורבוזיה תכנן בניין מגורים מבטון חשוף לאלף ושש מאות תושבים, הכולל חנויות, גן ילדים ובריכה על הגג. המבנה מגלם את חזון ״מכונת המגורים״ שלו ואת הברוטליזם. השפיע עמוקות על שיכון ציבורי ואדריכלות מודרנית.",
    "rank": 125
  },
  {
    "id": "ar_warhol_factory",
    "deck": "art",
    "title": "הפקטורי של אנדי וורהול",
    "start": 1962,
    "end": 1968,
    "date": "⁦1962–1968⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.741,
    "lon": -73.995,
    "desc": "וורהול הפך את הסטודיו שלו במנהטן ל״מפעל״ שבו יצר אמנות, סרטים ומוזיקה עם קבוצה אקלקטית של סלבריטאים, דראג קווינס ואמנים. המקום הגדיר מחדש את מושג הסטודיו ואת יחסי אמנות-חברה. בשנת 1968 נורה וורהול שם על ידי ולרי סולנאס.",
    "rank": 126
  },
  {
    "id": "ar_de_kooning_woman",
    "deck": "art",
    "title": "אישה של דה קונינג",
    "start": 1950,
    "end": 1953,
    "date": "⁦1950–1953⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "וילם דה קונינג צייר סדרת ציורי ״אישה״ מטלטלים, עם משיכות מכחול אלימות ודמויות מעוותות. הסדרה עוררה מחלוקת בתוך האקספרסיוניזם המופשט, שנטה להפשטה טהורה. דה קונינג התעקש על חזרה לדמות האנושית בכל תוקף.",
    "rank": 127
  },
  {
    "id": "ar_judd_marfa",
    "deck": "art",
    "title": "מיצבי דונלד ג׳אד במרפה",
    "start": 1979,
    "end": 1994,
    "date": "⁦1979–1994⁩",
    "place": "מרפה, טקסס, ארצות הברית",
    "lat": 30.31,
    "lon": -104.022,
    "desc": "דונלד ג׳אד הפך בסיס צבאי נטוש בעיירה מדברית למוזיאון קבוע ליצירותיו. מאה קופסאות אלומיניום ענקיות בשני מחסנים מגדירות את מהות המינימליזם: צורה, חומר ומרחב, בלי ייצוג. מרפה הפכה למרכז עלייה לרגל של חובבי אמנות.",
    "rank": 128
  },
  {
    "id": "ar_dali_elephants",
    "deck": "art",
    "title": "הפילים של דאלי",
    "start": 1948,
    "end": 1948,
    "date": "1948",
    "place": "פורט ליגאט, ספרד",
    "lat": 42.294,
    "lon": 3.287,
    "desc": "סלבדור דאלי צייר פילים עם רגליים ארוכות ודקות כמו קורי עכביש הנושאים אוביליסקים על גבם. הציור מגלם את הסוריאליזם של דאלי: עולם חלומות שבו חוקי הפיזיקה מתבטלים. הדימוי חוזר בכמה מיצירותיו.",
    "rank": 129
  },
  {
    "id": "ar_ottoman_tiles",
    "deck": "art",
    "title": "אריחי איזניק בסגנון עות׳מאני",
    "start": 1480,
    "end": 1600,
    "date": "בערך ⁦1480–1600⁩",
    "place": "איזניק, טורקיה",
    "lat": 40.431,
    "lon": 29.723,
    "desc": "בעלי מלאכה באיזניק ייצרו אריחי קרמיקה מעוטרים בדגמי פרחים, ערבסקות וקליגרפיה בצבעי כחול, אדום וטורקיז. האריחים עיטרו את מסגדי איסטנבול כולל המסגד הכחול וסולימנייה. הטכניקה נחשבת לפסגת הקרמיקה האסלאמית.",
    "rank": 130
  },
  {
    "id": "ar_delaunay_simultaneous",
    "deck": "art",
    "title": "חלונות סימולטניים של דלונה",
    "start": 1912,
    "end": 1912,
    "date": "1912",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "רובר דלונה צייר חלונות מנוסרים לצורות צבעוניות חופפות, זרם שכינה אורפיזם. הציורים הם מהמופשטים הראשונים בפריז, ושמים את הצבע עצמו כנושא. אפולינר כתב ש״דלונה ממציא אמנות שתלך כולה על צבע בלבד.״",
    "rank": 131
  },
  {
    "id": "ar_ernst_europe",
    "deck": "art",
    "title": "אירופה אחרי הגשם של מקס ארנסט",
    "start": 1940,
    "end": 1942,
    "date": "⁦1940–1942⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "מקס ארנסט צייר נוף של הרס ברטיבות ג׳ונגל, מראה חזיוני של אירופה אחרי מלחמה. הטכניקה של ״דקלקומניה״ — לחיצת צבע בין שני משטחים — יצרה מרקמים אורגניים מוזרים. ארנסט ברח מאירופה הנאצית ויצר את היצירה בגלות.",
    "rank": 132
  },
  {
    "id": "ar_lichtenstein_whaam",
    "deck": "art",
    "title": "וואם! של ליכטנשטיין",
    "start": 1963,
    "end": 1963,
    "date": "1963",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "רוי ליכטנשטיין צייר סצנת קרב אווירי בסגנון קומיקס מוגדל עם נקודות בן-דיי ובועות דיבור. הציור מתח את גבולות האמנות הגבוהה והתרבות הפופולרית. ליכטנשטיין היה מרכיב מפתח בפופ ארט יחד עם וורהול.",
    "rank": 133
  },
  {
    "id": "ar_man_ray_rayograph",
    "deck": "art",
    "title": "הריוגרפים של מאן ריי",
    "start": 1922,
    "end": 1922,
    "date": "1922",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "מאן ריי הניח חפצים ישירות על נייר צילומי וחשף אותם לאור, ויצר תמונות ללא מצלמה. הטכניקה שכינה ״ריוגרפים״ קישרה את הדאדא והסוריאליזם לצילום ניסיוני. מאן ריי טשטש את הגבול בין צילום, ציור ואמנות.",
    "rank": 134
  },
  {
    "id": "ar_serra_tilted",
    "deck": "art",
    "title": "הקשת הנטויה של סרה",
    "start": 1981,
    "end": 1989,
    "date": "⁦1981–1989⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.714,
    "lon": -74.002,
    "desc": "ריצ׳רד סרה הציב לוח פלדה קורטן ענק וקמור בכיכר פדרל פלאזה במנהטן. עובדים קרובים דרשו הסרתו, ומשפט ציבורי ב-1985 נתן צו להסרה. ב-1989 נהרס הפסל, ויצר את הדיון המכונן על אמנות ציבורית ומרחב ציבורי.",
    "rank": 135
  },
  {
    "id": "ar_chartres_window",
    "deck": "art",
    "title": "ויטראז׳ הכחול של נוטרדאם דה לה בל ורייר",
    "start": 1170,
    "end": 1180,
    "date": "בערך ⁦1170–1180⁩",
    "place": "שארטר, צרפת",
    "lat": 48.448,
    "lon": 1.488,
    "desc": "חלון ויטראז׳ בקתדרלת שארטר המתאר את מריה הבתולה עם הילד ישו, ידוע בכחול העמוק שנקרא ״כחול שארטר״. המרכב המדויק של הזכוכית אבד ולא שוחזר. החלון שרד שתי מלחמות עולם ונחשב לפסגת אמנות הזכוכית הצבעונית.",
    "rank": 136
  },
  {
    "id": "ar_calder_mobile",
    "deck": "art",
    "title": "המוביילים של קלדר",
    "start": 1931,
    "end": 1931,
    "date": "1931",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "אלכסנדר קלדר המציא את הפסל הקינטי: צורות מתכת צבעוניות המאוזנות על מוטות ונעות ברוח. מרסל דושאן כינה את היצירות ״מוביילים״ והשם נדבק. קלדר שינה את הגדרת הפיסול מחפץ סטטי למבנה נע.",
    "rank": 137
  },
  {
    "id": "ar_hiroshige_tokaido",
    "deck": "art",
    "title": "חמישים ושלוש תחנות הטוקאידו",
    "start": 1833,
    "end": 1834,
    "date": "⁦1833–1834⁩",
    "place": "אדו (טוקיו), יפן",
    "lat": 35.685,
    "lon": 139.751,
    "desc": "אנדו הירושיגה יצר סדרת הדפסי עץ של הנופים לאורך דרך הטוקאידו, מאדו לקיוטו. מוטיבים של גשם, שלג ואור ירח השפיעו עמוקות על ואן גוך ומונה. הסדרה הפכה לאחד הביטויים החשובים ביותר של אמנות האוקייו-אה.",
    "rank": 138
  },
  {
    "id": "ar_basquiat_samo",
    "deck": "art",
    "title": "ז׳אן-מישל בסקיאט עובר מהרחוב לגלריה",
    "start": 1981,
    "end": 1982,
    "date": "⁦1981–1982⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.725,
    "lon": -73.994,
    "desc": "בסקיאט עבר מגרפיטי תחת שם SAMO לתערוכות בגלריות סוהו ומדיסון אווניו. ציוריו שילבו טקסט, דמויות שחורות, אנטומיה ומוזיקה בסגנון ניאו-אקספרסיוניסטי אנרגטי. מת ממנת יתר בגיל 27 והפך לאגדה של אמנות ניו יורקית.",
    "rank": 139
  },
  {
    "id": "ar_hogarth_progress",
    "deck": "art",
    "title": "דרכו של הוויתרן של הוגארת",
    "start": 1732,
    "end": 1735,
    "date": "⁦1732–1735⁩",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.118,
    "desc": "וויליאם הוגארת צייר סדרות נרטיביות סטיריות המתארות את שקיעת דמויות בשחיתות, שיכרות ופשע. כל ציור מלא ברמזים מוסריים וחברתיים שהיוו ביקורת חריפה על החברה הבריטית. הוגארת הגדיר את הז׳אנר של ״ספורי מוסר מצוירים״.",
    "rank": 140
  },
  {
    "id": "ar_islamic_calligraphy",
    "deck": "art",
    "title": "פריחת הקליגרפיה האסלאמית",
    "start": 700,
    "end": 900,
    "date": "בערך ⁦700–900⁩ לספירה",
    "place": "בגדאד / דמשק",
    "lat": 33.312,
    "lon": 44.366,
    "desc": "עם התפשטות האסלאם, הפכה הקליגרפיה הערבית לאמנות הנעלה ביותר — חלופה לציור פיגורטיבי שהיה אסור. סגנונות כמו כופי ונסח פיתחו את הכתב לשפה אסתטית מורכבת. קליגרפיה אסלאמית מעטרת מסגדים, ארמונות וספרים ברחבי העולם.",
    "rank": 141
  },
  {
    "id": "ar_cindy_sherman",
    "deck": "art",
    "title": "מסגרות סרט ללא כותרת של סינדי שרמן",
    "start": 1977,
    "end": 1980,
    "date": "⁦1977–1980⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.725,
    "lon": -73.994,
    "desc": "סינדי שרמן צילמה עצמה בתחפושות ותפאורות שחיקו סצנות מסרטים של שנות ה-50 וה-60. הסדרה חקרה את בניית הזהות הנשית בתרבות הפופולרית. שרמן נחשבת מהאמניות המשפיעות ביותר בצילום הפוסט-מודרני.",
    "rank": 142
  },
  {
    "id": "ar_mies_barcelona",
    "deck": "art",
    "title": "הביתן הגרמני של מיס ואן דר רוהה בברצלונה",
    "start": 1929,
    "end": 1929,
    "date": "1929",
    "place": "ברצלונה, ספרד",
    "lat": 41.371,
    "lon": 2.149,
    "desc": "מיס ואן דר רוהה תכנן את הביתן ליריד העולמי עם קירות שיש חופשיים, עמודי כרום ובריכות מים. הביתן מגלם את עקרון ״פחות זה יותר״ ואת הזרימה הפתוחה של חללים מודרניים. נהרס אחרי היריד ונבנה מחדש ב-1986.",
    "rank": 143
  },
  {
    "id": "ar_hockney_splash",
    "deck": "art",
    "title": "שכשוך גדול יותר של הוקני",
    "start": 1967,
    "end": 1967,
    "date": "1967",
    "place": "לוס אנג׳לס, ארצות הברית",
    "lat": 34.052,
    "lon": -118.244,
    "desc": "דייוויד הוקני צייר בריכת שחייה קליפורנית עם שכשוך מים לבן על רקע שמיים כחולים ודקלים. הציור מבטא את חיי הפנאי והשמש בלוס אנג׳לס ואת סגנונו הצבעוני המזוהה. הוקני נחשב מהאמנים הבריטיים המשפיעים ביותר של המאה העשרים.",
    "rank": 144
  },
  {
    "id": "ar_friedrich_wanderer",
    "deck": "art",
    "title": "הנוסע מעל ים הערפל של פרידריך",
    "start": 1818,
    "end": 1818,
    "date": "1818",
    "place": "דרזדן, גרמניה",
    "lat": 51.051,
    "lon": 13.738,
    "desc": "קספר דוד פרידריך צייר גבר מהגב עומד על צוק מעל ערפל, מסמל את ההתבוננות הרומנטית בטבע. הציור הפך לסמל המובהק ביותר של הרומנטיקה הגרמנית ושל מושג ה״נשגב״. משמש עד היום כמטאפורה ויזואלית של הרפתקנות והתבוננות.",
    "rank": 145
  },
  {
    "id": "ar_turrell_roden",
    "deck": "art",
    "title": "מכתש רודן של ג׳יימס טארל",
    "start": 1979,
    "end": 2024,
    "date": "1979–כיום",
    "place": "פלגסטאף, אריזונה, ארצות הברית",
    "lat": 35.381,
    "lon": -111.544,
    "desc": "ג׳יימס טארל רכש מכתש געשי כבוי ועובד עליו כבר ארבעים וחמש שנה כדי ליצור מצפה אור ענק. מנהרות ואולמות חצובים בהר מכוונים אור שמש, ירח וכוכבים. הפרויקט, שטרם הושלם, נחשב ליצירת האמנות האדירה ביותר של דורנו.",
    "rank": 146
  },
  {
    "id": "ar_versailles",
    "deck": "art",
    "title": "בניית ארמון ורסאי",
    "start": 1661,
    "end": 1710,
    "date": "⁦1661–1710⁩",
    "place": "ורסאי, צרפת",
    "lat": 48.805,
    "lon": 2.12,
    "desc": "לואי הארבעה עשרה הפך את בית מנוחה כפרי למתחם ארמון ענק עם אולם המראות, גנים מעוצבים ומזרקות. הארמון שימש כסמל לכוח המוחלט של המלוכה הצרפתית. האדריכלות והעיצוב הפנימי הגדירו את סגנון הבארוק הצרפתי.",
    "rank": 147
  },
  {
    "id": "ar_klimt_secession",
    "deck": "art",
    "title": "הקמת הסצסיון הווינאי",
    "start": 1897,
    "end": 1897,
    "date": "1897",
    "place": "וינה, אוסטריה",
    "lat": 48.2,
    "lon": 16.372,
    "desc": "גוסטב קלימט וחבריו פרשו מאקדמיית האמנות השמרנית וייסדו תנועת אמנות חדשה. בניין הסצסיון, עם כיפת הזהב שלו, הפך לסמל הפרישה מהאקדמיזם. התנועה שילבה ציור, עיצוב ואדריכלות ופתחה את הדרך לארט נובו.",
    "rank": 148
  },
  {
    "id": "ar_judd_specific",
    "deck": "art",
    "title": "״אובייקטים ספציפיים״ של ג׳אד",
    "start": 1965,
    "end": 1965,
    "date": "1965",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "דונלד ג׳אד פרסם את המאמר המכונן שטען שהאמנות החדשה אינה ציור ואינה פיסול אלא אובייקטים תלת-ממדיים ספציפיים. המאמר הגדיר את המינימליזם ואת הרעיון שהיצירה היא מה שהיא, בלי סמלים או ייצוג. ג׳אד יצר קופסאות ומדפים תעשייתיים כאמנות.",
    "rank": 149
  },
  {
    "id": "ar_richter_atlas",
    "deck": "art",
    "title": "האטלס של גרהרד ריכטר",
    "start": 1962,
    "end": 2013,
    "date": "⁦1962–2013⁩",
    "place": "קלן, גרמניה",
    "lat": 50.941,
    "lon": 6.958,
    "desc": "גרהרד ריכטר אסף אלפי תצלומים, גזרי עיתונים ורישומים בלוחות אטלס שמהווים ארכיון חזותי של חייו ותקופתו. האוסף שימש כמקור חומר גולמי לציוריו ומהווה יצירה עצמאית. ריכטר נחשב מהאמנים החיים החשובים ביותר.",
    "rank": 150
  },
  {
    "id": "ar_gentileschi_judith",
    "deck": "art",
    "title": "יהודית הורגת את הולופרנס",
    "start": 1620,
    "end": 1620,
    "date": "בערך 1620",
    "place": "פירנצה, איטליה",
    "lat": 43.769,
    "lon": 11.255,
    "desc": "ארטמיזיה ג׳נטילסקי ציירה את הסצנה המקראית באלימות ישירה, שונה מגרסאות גבריות שריככו את המעשה. ג׳נטילסקי, שנאנסה על ידי מורה ועברה משפט ציבורי, מזוהה עם הגיבורה התנ״כית. היא נחשבת לציירת הבארוק המשמעותית ביותר.",
    "rank": 151
  },
  {
    "id": "ar_rodin_kiss",
    "deck": "art",
    "title": "הנשיקה של רודן",
    "start": 1882,
    "end": 1889,
    "date": "⁦1882–1889⁩",
    "place": "פריז, צרפת",
    "lat": 48.855,
    "lon": 2.316,
    "desc": "אוגוסט רודן פיסל זוג אוהבים מחובקים בשיש, בהשראת סיפורם של פאולו ופרנצ׳סקה מ״קומדיה אלוהית״. הפסל, שמלכתחילה היה חלק מ״שערי הגיהינום״, נחשב לרגשני מדי על ידי רודן עצמו. למרות זאת הוא אחד הפסלים הרומנטיים המפורסמים ביותר בעולם.",
    "rank": 152
  },
  {
    "id": "ar_shirin_neshat",
    "deck": "art",
    "title": "נשים ללא גברים של שירין נשאט",
    "start": 2009,
    "end": 2009,
    "date": "2009",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "שירין נשאט ביימה סרט שמבוסס על רומן של שהרנוש פרסיפור, המציג חמש נשים איראניות בתקופת מהפכה. הסרט זכה באריה הכסף בפסטיבל ונציה ומיצב את נשאט כאחת האמניות החשובות בנושא מגדר, גלות ואיסלאם. עבודתה הקודמת, סדרת הצילומים ״נשים אללה״, הפכה לאייקון.",
    "rank": 153
  },
  {
    "id": "ar_great_mosque_djenne",
    "deck": "art",
    "title": "המסגד הגדול בג׳נה",
    "start": 1907,
    "end": 1907,
    "date": "1907 (שוחזר)",
    "place": "ג׳נה, מאלי",
    "lat": 13.905,
    "lon": -4.554,
    "desc": "המסגד הגדול בג׳נה הוא מבנה הטיט הגדול ביותר בעולם, בנוי בסגנון סודנו-סאהלי ייחודי. כל שנה מתקיים טקס קהילתי של חידוש הטיט על הקירות. המבנה המקורי מהמאה השלוש עשרה נהרס ונבנה מחדש ב-1907 בצורתו הנוכחית.",
    "rank": 154
  },
  {
    "id": "ar_constable_haywain",
    "deck": "art",
    "title": "עגלת החציר של קונסטבל",
    "start": 1821,
    "end": 1821,
    "date": "1821",
    "place": "סאפולק, אנגליה",
    "lat": 51.966,
    "lon": 1.02,
    "desc": "ג׳ון קונסטבל צייר עגלת סוסים חוצה נחל בכפר אנגלי ירוק ושליו. הציור הרשים את הצרפתים בסלון של 1824 והשפיע על דלקרואה והציור הרומנטי. קונסטבל העלה את ציור הנוף ממעמד נחות לז׳אנר מכובד.",
    "rank": 155
  },
  {
    "id": "ar_ajanta_caves",
    "deck": "art",
    "title": "ציורי מערות אג׳נטה",
    "start": -200,
    "end": 480,
    "date": "בערך ⁦200⁩ לפנה״ס – ⁦480⁩ לספירה",
    "place": "מהרשטרה, הודו",
    "lat": 20.552,
    "lon": 75.7,
    "desc": "שלושים מערות חצובות בסלע מעוטרות בציורי קיר ופסלים בודהיסטיים מפוארים שנוצרו לאורך שבע מאות שנה. ציורי הקיר מציגים סצנות מחיי בודהה ומסיפורי ג׳אטאקה בצבעים שנשתמרו באופן יוצא דופן. הם נחשבים לפסגת הציור ההודי הקדום.",
    "rank": 156
  },
  {
    "id": "ar_braque_violin",
    "deck": "art",
    "title": "הכינור והקנקן של בראק",
    "start": 1910,
    "end": 1910,
    "date": "1910",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "ז׳ורז׳ בראק צייר כלי נגינה מפורקים לצורות גיאומטריות חופפות יחד עם פיקאסו. בראק ופיקאסו פיתחו את הקוביזם כ״שני מטפסי הרים קשורים בחבל״, כפי שכינה זאת בראק. הציורים שינו את הדרך שבה אמנות מייצגת מרחב ומציאות.",
    "rank": 157
  },
  {
    "id": "ar_dorothea_lange",
    "deck": "art",
    "title": "אם נודדת של דורותיאה לאנג",
    "start": 1936,
    "end": 1936,
    "date": "1936",
    "place": "ניפומו, קליפורניה, ארצות הברית",
    "lat": 35.038,
    "lon": -120.473,
    "desc": "דורותיאה לאנג צילמה את פלורנס אוונס תומפסון ושבעת ילדיה במחנה קוטפי אפונה בעת השפל הגדול. התצלום הפך לסמל העוני האמריקני והניע סיוע ממשלתי. הוא אחד התצלומים המפורסמים ביותר בהיסטוריה.",
    "rank": 158
  },
  {
    "id": "ar_notre_dame_reims",
    "deck": "art",
    "title": "פסלי קתדרלת ריימס",
    "start": 1211,
    "end": 1275,
    "date": "⁦1211–1275⁩",
    "place": "ריימס, צרפת",
    "lat": 49.254,
    "lon": 3.975,
    "desc": "קתדרלת ריימס, מקום הכתרת מלכי צרפת, מעוטרת באלפי פסלי אבן גותיים. ״המלאך המחייך״ בחזית המערבית נחשב לפסגת הפיסול הגותי. הפסלים ניזוקו קשות בהפצצות מלחמת העולם הראשונה ושוקמו בקפידה.",
    "rank": 159
  },
  {
    "id": "ar_kiefer_margarethe",
    "deck": "art",
    "title": "שירך הזהוב מרגרטה של קיפר",
    "start": 1981,
    "end": 1981,
    "date": "1981",
    "place": "פרנקפורט, גרמניה",
    "lat": 50.111,
    "lon": 8.682,
    "desc": "אנסלם קיפר יצר ציורי ענק המתמודדים עם ההיסטוריה הגרמנית והנאצית בחומרים כמו תבן, עופרת ואפר. היצירה מבוססת על שירו של פאול צלאן ״פוגה של מוות״. קיפר מהאמנים הגרמנים המשמעותיים ביותר של תקופת שלאחר המלחמה.",
    "rank": 160
  },
  {
    "id": "ar_kapoor_descension",
    "deck": "art",
    "title": "המערבולת של אניש קאפור",
    "start": 2014,
    "end": 2014,
    "date": "2014",
    "place": "ורסאי, צרפת",
    "lat": 48.805,
    "lon": 2.12,
    "desc": "אניש קאפור יצר מערבולת מים שחורים שנראית בולעת את הרצפה, מוצבת בארמון ורסאי. יצירותיו של קאפור חוקרות חלל, ריקנות ואינסוף באמצעות צורות פשוטות ופני שטח מבריקים. הוא ידוע גם ברכישת הזכויות הבלעדיות לפיגמנט השחור ביותר בעולם.",
    "rank": 161
  },
  {
    "id": "ar_diego_detroit",
    "deck": "art",
    "title": "ציורי הקיר של דייגו ריברה בדטרויט",
    "start": 1932,
    "end": 1933,
    "date": "⁦1932–1933⁩",
    "place": "דטרויט, מישיגן, ארצות הברית",
    "lat": 42.359,
    "lon": -83.065,
    "desc": "דייגו ריברה צייר עשרים ושבעה פאנלים ענקיים במכון האמנויות של דטרויט, המתארים את תעשיית הרכב. הציורים שילבו סוציאליזם מקסיקני עם קפיטליזם תעשייתי אמריקני ועוררו מחלוקת. ריברה הוא מגדולי המורליסטים המקסיקנים יחד עם אורוסקו וסיקיירוס.",
    "rank": 162
  },
  {
    "id": "ar_pompeii_frescoes",
    "deck": "art",
    "title": "ציורי הפרסקו בפומפיי",
    "start": -100,
    "end": 79,
    "date": "בערך ⁦100⁩ לפנה״ס – 79 לספירה",
    "place": "פומפיי, איטליה",
    "lat": 40.75,
    "lon": 14.486,
    "desc": "ציורי הקיר בבתים ובווילות של פומפיי נשתמרו מתחת לאפר הר הגעש ווזוב. הם מציגים ארבעה סגנונות צמודים בזמן: חיקוי שיש, פרספקטיבה אדריכלית, סצנות מיתולוגיות ועיטור פנטסטי. הציורים הם המקור החשוב ביותר לציור הרומי שנותר.",
    "rank": 163
  },
  {
    "id": "ar_ghiberti_doors",
    "deck": "art",
    "title": "שערי גן העדן של גיברטי",
    "start": 1425,
    "end": 1452,
    "date": "⁦1425–1452⁩",
    "place": "פירנצה, איטליה",
    "lat": 43.773,
    "lon": 11.255,
    "desc": "לורנצו גיברטי יצר את דלתות הברונזה המוזהבות של בפטיסטריום פירנצה עם עשרה פאנלים מן התנ״ך. מיכלאנג׳לו כינה אותן ״שערי גן העדן״ בזכות יופיין. היציקה נמשכה 27 שנה ומסמלת את המעבר מגותיקה לרנסנס.",
    "rank": 164
  },
  {
    "id": "ar_meissonier_friedland",
    "deck": "art",
    "title": "אמנות הסלון הצרפתי בשיאה",
    "start": 1863,
    "end": 1863,
    "date": "1863",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "סלון האמנות הרשמי בפריז שלט בטעם הציבורי והאקדמי, קידם ציור ריאליסטי, היסטורי ומיתולוגי. ב-1863 נפתח ה-Salon des Refusés למי שנדחו, כולל מאנה, ובכך החלה המרד נגד הממסד. ההתנגשות בין הסלון לסלון הנדחים סימנה את תחילת המודרניזם.",
    "rank": 165
  },
  {
    "id": "ar_kapoor_void",
    "deck": "art",
    "title": "הוויד של אניש קאפור בטייט מודרן",
    "start": 2003,
    "end": 2003,
    "date": "2003",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.1,
    "desc": "קאפור יצר פסל PVC ענק באולם הטורבינות בצורת חצוצרה אדומה כהה. הצופים נכנסו לתוך הפתח החשוך ונבלעו במרחב שנראה אינסופי. היצירה חקרה את הגבולות בין פנים וחוץ, גוף וריק.",
    "rank": 166
  },
  {
    "id": "ar_tutankhamun_mask",
    "deck": "art",
    "title": "מסכת הזהב של תות-ענח-אמון",
    "start": -1323,
    "end": -1323,
    "date": "בערך 1323 לפנה״ס",
    "place": "עמק המלכים, מצרים",
    "lat": 25.74,
    "lon": 32.601,
    "desc": "מסכת קבורה מזהב מוצק במשקל 11 קילוגרם, משובצת לאפיס לזולי וזכוכית צבעונית. נמצאה בקבר הפרעה הצעיר על ידי הווארד קרטר ב-1922 והפכה לסמל של מצרים העתיקה. המסכה מוצגת במוזיאון המצרי בקהיר.",
    "rank": 167
  },
  {
    "id": "ar_celtic_crosses",
    "deck": "art",
    "title": "צלבים קלטיים באירלנד",
    "start": 700,
    "end": 1100,
    "date": "בערך ⁦700–1100⁩ לספירה",
    "place": "אירלנד",
    "lat": 53.35,
    "lon": -6.26,
    "desc": "צלבי אבן גבוהים מעוטרים בקלטון, סצנות תנ״כיות ודגמים גיאומטריים הוצבו בבתי קברות ומנזרים ברחבי אירלנד. הם משלבים סמליות נוצרית עם מסורת אמנותית קלטית. צלב מונסטרבויס וצלב האוויות הם מהמפורסמים שבהם.",
    "rank": 168
  },
  {
    "id": "ar_noguchi_garden",
    "deck": "art",
    "title": "גן הפיסול של נוגוצ׳י",
    "start": 1961,
    "end": 1985,
    "date": "⁦1961–1985⁩",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.768,
    "lon": -73.937,
    "desc": "איסאמו נוגוצ׳י עיצב מוזיאון וגן פיסול בלונג איילנד סיטי עם פסלי אבן, מתכת ועץ בחלל פתוח. נוגוצ׳י, ממוצא יפני-אמריקני, שילב אסתטיקה יפנית עם מודרניזם מערבי. הוא עיצב גם גנים ציבוריים, מנורות וריהוט שנחשבים לאייקונים עיצוביים.",
    "rank": 169
  },
  {
    "id": "ar_meret_oppenheim",
    "deck": "art",
    "title": "ארוחת הצהריים בפרווה של אופנהיים",
    "start": 1936,
    "end": 1936,
    "date": "1936",
    "place": "פריז, צרפת",
    "lat": 48.861,
    "lon": 2.337,
    "desc": "מרט אופנהיים כיסתה כוס תה, תחתית וכפית בפרווה של צביה סינית. האובייקט הסוריאליסטי הפך מיד לאייקון של הזרם ומסמל את הזרות המוחלטת של חפץ מוכר. היצירה מוצגת במוזיאון לאמנות מודרנית בניו יורק.",
    "rank": 170
  },
  {
    "id": "ar_borromini_carlo",
    "deck": "art",
    "title": "כנסיית סן קרלו של בורומיני",
    "start": 1638,
    "end": 1641,
    "date": "⁦1638–1641⁩",
    "place": "רומא, איטליה",
    "lat": 41.904,
    "lon": 12.49,
    "desc": "פרנצ׳סקו בורומיני תכנן את הכנסייה הקטנה עם חזית גלית וכיפה אובלית שאין לה קו ישר אחד. המבנה מגלם את הבארוק הרומי בשיאו ואת היריבות האמנותית בין בורומיני לברניני. בורומיני, שסבל מדיכאון, התאבד ב-1667.",
    "rank": 171
  },
  {
    "id": "ar_laocoon",
    "deck": "art",
    "title": "פסל לאוקואון ובניו",
    "start": -40,
    "end": -40,
    "date": "בערך 40 לפנה״ס",
    "place": "רומא, איטליה",
    "lat": 41.903,
    "lon": 12.454,
    "desc": "פסל שיש הלניסטי המתאר את הכהן הטרויאני ובניו נלחמים בנחשי ים שנשלחו על ידי האלים. נתגלה ברומא ב-1506 והשפיע על מיכלאנג׳לו ועל כל הפיסול האירופי. וינקלמן, אבי ההיסטוריה של האמנות, הגדיר אותו כדוגמה ל״שלווה נעלה.״",
    "rank": 172
  },
  {
    "id": "ar_bourgeois_spider",
    "deck": "art",
    "title": "אמא של לואיז בורז׳ואה",
    "start": 1999,
    "end": 1999,
    "date": "1999",
    "place": "ניו יורק, ארצות הברית",
    "lat": 51.508,
    "lon": -0.1,
    "desc": "לואיז בורז׳ואה יצרה פסלי עכבישים ענקיים מברונזה בגובה תשעה מטרים, מוקדשים לזכר אמה שהייתה אורגת. הפסלים, שכוננו ״מאמאן״, מוצבים ברחבי העולם ומבטאים את הזיקה בין פחד ואהבה אימהית. בורז׳ואה הפכה לאמנית המשפיעה ביותר בזיקנתה.",
    "rank": 173
  },
  {
    "id": "ar_greek_kouros",
    "deck": "art",
    "title": "פסלי הקורוס היווניים",
    "start": -600,
    "end": -480,
    "date": "בערך ⁦600–480⁩ לפנה״ס",
    "place": "יוון",
    "lat": 37.971,
    "lon": 23.727,
    "desc": "פסלי שיש בגודל טבעי של נערים עירומים בעמידה קשוחה, בהשראת פסלי מצרים. לאורך מאה ועשרים שנה הפכו מדמויות נוקשות לגופות ריאליסטיים, ותיעדו את ״המהפכה היוונית״ באמנות. הם עמדו בבתי קברות ובמקדשים כהנצחת נערים שנפלו.",
    "rank": 174
  },
  {
    "id": "ar_raphael_madonna",
    "deck": "art",
    "title": "מדונה הסיסטינית של רפאל",
    "start": 1512,
    "end": 1514,
    "date": "⁦1512–1514⁩",
    "place": "רומא, איטליה",
    "lat": 41.903,
    "lon": 12.454,
    "desc": "רפאל סנציו צייר את מריה הבתולה יורדת מהענן כשהיא מחזיקה את הילד ישו, עם שני מלאכים כנפיים נשענים בתחתית. שני הפוטי (מלאכי התינוק) הפכו לדימוי נפוץ ביותר בפופ-תרבות, מכרטיסי ברכה ועד חולצות. הציור מוצג בדרזדן, גרמניה.",
    "rank": 175
  },
  {
    "id": "ar_olafur_weather",
    "deck": "art",
    "title": "פרויקט מזג האוויר של אליאסון",
    "start": 2003,
    "end": 2004,
    "date": "⁦2003–2004⁩",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.1,
    "desc": "אולפור אליאסון יצר שמש מלאכותית ענקית ואדי ערפל באולם הטורבינות של טייט מודרן. מבקרים שכבו על הרצפה והביטו בהשתקפותם בתקרה כמראה ענקית. שני מיליון צופים ביקרו במיצב שהפך אירוע תרבותי.",
    "rank": 176
  },
  {
    "id": "ar_ife_heads",
    "deck": "art",
    "title": "ראשי הברונזה של איפה",
    "start": 1200,
    "end": 1400,
    "date": "בערך ⁦1200–1400⁩",
    "place": "איפה, ניגריה",
    "lat": 7.478,
    "lon": 4.575,
    "desc": "ראשי ברונזה ריאליסטיים בגודל טבעי נוצרו בממלכת איפה בטכניקת שעווה אבודה מתוחכמת. כשנחשפו, היו אירופים שסירבו להאמין שנוצרו באפריקה. הם מעידים על מסורת פיסולית מפותחת שקדמה למגע עם אירופה.",
    "rank": 177
  },
  {
    "id": "ar_mies_farnsworth",
    "deck": "art",
    "title": "בית פארנסוורת׳ של מיס ואן דר רוהה",
    "start": 1945,
    "end": 1951,
    "date": "⁦1945–1951⁩",
    "place": "פלאנו, אילינוי, ארצות הברית",
    "lat": 41.636,
    "lon": -88.537,
    "desc": "מיס ואן דר רוהה תכנן בית נופש ממתכת וזכוכית בלבד, מורם על עמודים מעל שפת נהר. המבנה השקוף מטשטש את הגבול בין פנים לחוץ. המזמינה, ד״ר פארנסוורת׳, תבעה את מיס על חריגה מהתקציב.",
    "rank": 178
  },
  {
    "id": "ar_doryphoros",
    "deck": "art",
    "title": "הדוריפורוס של פוליקליטוס",
    "start": -440,
    "end": -440,
    "date": "בערך 440 לפנה״ס",
    "place": "ארגוס, יוון",
    "lat": 37.631,
    "lon": 22.727,
    "desc": "פוליקליטוס פיסל את ה״נושא החנית״ כגילום של ה״קנון״ — היחסים המתמטיים המושלמים של הגוף האנושי. המקור הברונזי אבד ונותרו רק עותקים רומיים בשיש. הפסל הגדיר את הפרופורציות האידיאליות שהנחו אמנים לאורך הדורות.",
    "rank": 179
  },
  {
    "id": "ar_yayoi_pumpkin",
    "deck": "art",
    "title": "הדלעת של קוסמה בנאושימה",
    "start": 1994,
    "end": 1994,
    "date": "1994",
    "place": "נאושימה, יפן",
    "lat": 34.443,
    "lon": 133.997,
    "desc": "יאיוי קוסמה הציבה פסל דלעת צהובה ענקית מנוקדת על רציף באי נאושימה. הדלעת הפכה לסמל האי שהוקדש כולו לאמנות עכשווית בידי קרן בנסה. הפסל נסחף בטייפון ב-2021 ושוחזר.",
    "rank": 180
  },
  {
    "id": "ar_bruegel_hunters",
    "deck": "art",
    "title": "ציידים בשלג של ברויגל",
    "start": 1565,
    "end": 1565,
    "date": "1565",
    "place": "אנטוורפן, בלגיה",
    "lat": 51.221,
    "lon": 4.401,
    "desc": "פיטר ברויגל האב צייר נוף חורפי עם ציידים חוזרים לכפר, חלקלקים על קרח ודאפים שחורים. הציור הוא חלק מסדרת החודשים ומציג את ״תור הקרח הקטן״ של אירופה. הנוף הפנורמי הפך לאחד הנופים המצוטטים ביותר באמנות.",
    "rank": 181
  },
  {
    "id": "ar_barragán_house",
    "deck": "art",
    "title": "בית ברגאן במקסיקו סיטי",
    "start": 1948,
    "end": 1948,
    "date": "1948",
    "place": "מקסיקו סיטי, מקסיקו",
    "lat": 19.359,
    "lon": -99.192,
    "desc": "לואיס ברגאן תכנן את ביתו-סטודיו עם קירות צבעוניים, מפלי מים ואור טבעי מסונן. המבנה שילב מודרניזם עם מסורת מקסיקנית ועיצוב נוף. ברגאן זכה בפרס פריצקר ונחשב לאחד האדריכלים המשפיעים ביותר באמריקה הלטינית.",
    "rank": 182
  },
  {
    "id": "ar_catalan_gothic",
    "deck": "art",
    "title": "ציורי הפרסקו הרומאניים בקטלוניה",
    "start": 1100,
    "end": 1150,
    "date": "בערך ⁦1100–1150⁩",
    "place": "ואל דה בוי, קטלוניה, ספרד",
    "lat": 42.502,
    "lon": 0.773,
    "desc": "כנסיות רומאניות בפירנאים הקטלוניים עוטרו בציורי קיר צבעוניים של פנטוקרטור, מלאכים ופרטי יומיום. בתחילת המאה העשרים הורדו הציורים מהכנסיות והועברו למוזיאון הלאומי לאמנות קטלוניה בברצלונה. הם נחשבים לפסגת האמנות הרומאנית בספרד.",
    "rank": 183
  },
  {
    "id": "ar_magritte_pipe",
    "deck": "art",
    "title": "זו לא מקטרת של מאגריט",
    "start": 1929,
    "end": 1929,
    "date": "1929",
    "place": "בריסל, בלגיה",
    "lat": 50.846,
    "lon": 4.358,
    "desc": "רנה מאגריט צייר מקטרת עם הכיתוב ״Ceci n'est pas une pipe״ — ״זו אינה מקטרת״. הציור חוקר את הפער בין ייצוג ומציאות: הציור הוא תמונה של מקטרת, לא מקטרת עצמה. היצירה הפכה לאחד הסמלים המוכרים ביותר של הסוריאליזם ושל פילוסופיה ויזואלית.",
    "rank": 184
  },
  {
    "id": "ar_gehry_bilbao",
    "deck": "art",
    "title": "מוזיאון גוגנהיים בילבאו",
    "start": 1993,
    "end": 1997,
    "date": "⁦1993–1997⁩",
    "place": "בילבאו, ספרד",
    "lat": 43.269,
    "lon": -2.934,
    "desc": "פרנק גרי תכנן את המוזיאון מלוחות טיטניום מעוקלים שמשקפים את הנהר ואת השמיים. הבניין הפך את בילבאו מעיר תעשייתית נטושה ליעד תיירותי עולמי — תופעה שנקראה ״אפקט בילבאו״. נחשב למבנה החשוב ביותר באדריכלות הדקונסטרוקטיביסטית.",
    "rank": 185
  },
  {
    "id": "ar_giorgione_tempest",
    "deck": "art",
    "title": "הסופה של ג׳ורג׳ונה",
    "start": 1508,
    "end": 1508,
    "date": "בערך 1508",
    "place": "ונציה, איטליה",
    "lat": 45.44,
    "lon": 12.332,
    "desc": "ג׳ורג׳ונה צייר נוף סוער עם חייל ואישה מניקה בשני צידי נחל, ללא נרטיב מזוהה. הציור נחשב לראשון שבו הנוף הוא הנושא העיקרי ולא רקע לעלילה. ג׳ורג׳ונה מת בגיל שלושים ושלוש, ומעט מאוד מיצירותיו נותרו.",
    "rank": 186
  },
  {
    "id": "ar_olowe_yoruba",
    "deck": "art",
    "title": "גילופי עץ של אולואה מאיסה",
    "start": 1900,
    "end": 1938,
    "date": "בערך ⁦1900–1938⁩",
    "place": "איסה, ניגריה",
    "lat": 7.464,
    "lon": 5.238,
    "desc": "אולואה מאיסה, גלף יורובה, יצר עמודי ארמון, דלתות ועמודי ורנדה בגילוף מורכב ודינמי. הדמויות שלו מפגינות מתח דרמטי ופרופורציות ייחודיות שהשפיעו על אמנות מודרניסטית. הוא נחשב לאחד הפסלים הגדולים ביותר של אפריקה.",
    "rank": 187
  },
  {
    "id": "ar_zaha_hadid_fire",
    "deck": "art",
    "title": "תחנת הכבאים של זאהה חדיד",
    "start": 1991,
    "end": 1993,
    "date": "⁦1991–1993⁩",
    "place": "וייל אם ריין, גרמניה",
    "lat": 47.604,
    "lon": 7.622,
    "desc": "זאהה חדיד תכננה את המבנה הדקונסטרוקטיביסטי עם קווים חדים וזוויות אגרסיביות למפעל ויטרה. זה היה המבנה הראשון שלה שנבנה, אחרי שנים של תוכניות שנחשבו בלתי ניתנות לבנייה. חדיד הייתה האישה הראשונה שזכתה בפרס פריצקר.",
    "rank": 188
  },
  {
    "id": "ar_joseph_beuys_felt",
    "deck": "art",
    "title": "חליפת הלבד של יוזף בויס",
    "start": 1970,
    "end": 1970,
    "date": "1970",
    "place": "דיסלדורף, גרמניה",
    "lat": 51.226,
    "lon": 6.776,
    "desc": "יוזף בויס יצר מאה חליפות לבד אפורות כחלק מפרויקט מרובה. הלבד והשומן היו חומרים מרכזיים ביצירתו, הקשורים למיתוס ההצלה שלו על ידי טטרים במלחמת העולם השנייה. בויס הרחיב את הגדרת האמנות ל״פיסול חברתי״ וטען ש״כל אדם הוא אמן.״",
    "rank": 189
  },
  {
    "id": "ar_vermeer_astronomy",
    "deck": "art",
    "title": "האסטרונום של ורמיר",
    "start": 1668,
    "end": 1668,
    "date": "1668",
    "place": "דלפט, הולנד",
    "lat": 52.011,
    "lon": 4.357,
    "desc": "ורמיר צייר חוקר מסתכל בגלובוס שמימי לאור חלון, יצירה תואמת ל״הגיאוגרף״. שני הציורים הם היחידים של ורמיר עם דמות גברית. נבזז בידי הנאצים ומוצג כיום בלובר בפריז.",
    "rank": 190
  },
  {
    "id": "ar_caravaggio_narcissus",
    "deck": "art",
    "title": "נרקיסוס של קאראוואג׳ו",
    "start": 1599,
    "end": 1599,
    "date": "בערך 1599",
    "place": "רומא, איטליה",
    "lat": 41.903,
    "lon": 12.474,
    "desc": "קאראוואג׳ו צייר את הנער מהמיתולוגיה היוונית מביט בהשתקפותו בבריכה חשוכה. הניגוד בין פניו המוארים לחשכה סביבו מדגים את טכניקת הקיארוסקורו. הציור מוצג בגלריה הלאומית לאמנות עתיקה ברומא.",
    "rank": 191
  },
  {
    "id": "ar_whistler_mother",
    "deck": "art",
    "title": "אמו של וויסלר",
    "start": 1871,
    "end": 1871,
    "date": "1871",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.118,
    "desc": "ג׳יימס מקניל וויסלר צייר את אמו בפרופיל, יושבת בכבדות על רקע אפור. הכותרת הרשמית היא ״סידור באפור ושחור מס׳ 1״ כדי להדגיש את הצורנות על פני הנושא. הציור הפך לאייקון אמריקני של אימהות ומוצג במוזיאון ד׳אורסה בפריז.",
    "rank": 192
  },
  {
    "id": "ar_ando_light",
    "deck": "art",
    "title": "כנסיית האור של טאדאו אנדו",
    "start": 1989,
    "end": 1989,
    "date": "1989",
    "place": "איבראקי, אוסקה, יפן",
    "lat": 34.813,
    "lon": 135.568,
    "desc": "טאדאו אנדו תכנן כנסייה קטנה מבטון חשוף עם חריץ צלב בקיר שדרכו חודר אור. הניגוד בין חומריות הבטון לרוחניות האור מגלם את הפילוסופיה של אנדו. הבניין נחשב לאחד הדגמים המושלמים ביותר של אדריכלות מינימליסטית.",
    "rank": 193
  },
  {
    "id": "ar_kara_walker",
    "deck": "art",
    "title": "הצלליות של קארה ווקר",
    "start": 1994,
    "end": 1994,
    "date": "1994",
    "place": "ניו יורק, ארצות הברית",
    "lat": 40.761,
    "lon": -73.977,
    "desc": "קארה ווקר יצרה פנורמות של צלליות נייר שחור על קירות לבנים, המתארות סצנות אלימות ומיניות מתקופת העבדות באמריקה. הסגנון התמים לכאורה מנוגד לתוכן הנורא ויוצר מתח מטריד. ווקר נחשבת מהאמניות המעוררות מחלוקת והשיח החשובות ביותר.",
    "rank": 194
  },
  {
    "id": "ar_tintoretto_paradise",
    "deck": "art",
    "title": "גן העדן של טינטורטו",
    "start": 1588,
    "end": 1592,
    "date": "⁦1588–1592⁩",
    "place": "ונציה, איטליה",
    "lat": 45.434,
    "lon": 12.339,
    "desc": "יאקופו טינטורטו צייר את ציור הקנבס הגדול ביותר בעולם, ברוחב 22 מטר, על קיר ארמון הדוג׳ים בונציה. הציור מתאר מאות דמויות בגן העדן בסחרחורת של צורות ואור. טינטורטו, ״הטינטורטו המשוגע״, עבד במהירות חסרת תקדים ובדרמטיות שהקדימה את הבארוק.",
    "rank": 195
  },
  {
    "id": "ar_maya_lin_memorial",
    "deck": "art",
    "title": "אנדרטת הוותיקים של מאיה לין",
    "start": 1981,
    "end": 1982,
    "date": "⁦1981–1982⁩",
    "place": "וושינגטון, ארצות הברית",
    "lat": 38.891,
    "lon": -77.048,
    "desc": "מאיה לין, סטודנטית בת 21, זכתה בתחרות עיצוב אנדרטת זיכרון לחללי מלחמת ויאטנאם. קיר גרניט שחור בצורת V שקוע באדמה נושא 58,318 שמות. העיצוב עורר מחלוקת אך הפך לאנדרטה המבוקרת ביותר בוושינגטון.",
    "rank": 196
  },
  {
    "id": "ar_canova_psyche",
    "deck": "art",
    "title": "אמור ופסיכה של קאנובה",
    "start": 1787,
    "end": 1793,
    "date": "⁦1787–1793⁩",
    "place": "רומא, איטליה",
    "lat": 41.903,
    "lon": 12.474,
    "desc": "אנטוניו קאנובה פיסל את אמור מעיר את פסיכה מנשיקה, בקומפוזיציה ספירלית של שני גופות שלובים. הפסל מגלם את האידיאל הניאו-קלאסי של יופי טהור ורגש מאופק. מוצג בלובר ונחשב לאחד הפסלים הרומנטיים ביותר.",
    "rank": 197
  },
  {
    "id": "ar_el_greco_burial",
    "deck": "art",
    "title": "קבורת הרוזן מאורגז של אל גרקו",
    "start": 1586,
    "end": 1588,
    "date": "⁦1586–1588⁩",
    "place": "טולדו, ספרד",
    "lat": 39.857,
    "lon": -4.024,
    "desc": "אל גרקו צייר את סצנת הקבורה בחלק תחתון ריאליסטי ובחלק עליון מיסטי של שמיים פתוחים. הדמויות המוארכות והצבעים הייחודיים שלו לא היו מקובלים בזמנו אך הפכו להשראה למודרניסטים. הציור מוצג בכנסיית סנטו טומה בטולדו.",
    "rank": 198
  },
  {
    "id": "ar_niki_phalle",
    "deck": "art",
    "title": "הנאנאס של ניקי דה סן פאל",
    "start": 1966,
    "end": 1966,
    "date": "1966",
    "place": "סטוקהולם, שוודיה",
    "lat": 59.329,
    "lon": 18.069,
    "desc": "ניקי דה סן פאל יצרה פסלי נשים ענקיים צבעוניים שכינתה ״נאנאס״, ובשיאם פסל ענק של אישה שוכבת שמבקרים נכנסו לתוכה דרך רגליה. הפסלים חגגו את הגוף הנשי ושברו מוסכמות. היא תכננה גם את גן הטארוט המופלא בטוסקנה.",
    "rank": 199
  },
  {
    "id": "ar_bill_viola",
    "deck": "art",
    "title": "חמשת המלאכים למילניום של ביל ויולה",
    "start": 2001,
    "end": 2001,
    "date": "2001",
    "place": "לונדון, אנגליה",
    "lat": 51.508,
    "lon": -0.1,
    "desc": "ביל ויולה יצר מיצב וידאו על חמישה מסכי ענק המציגים דמויות צוללות ועולות ממים בהילוך איטי. עבודות הוידאו שלו חוקרות לידה, מוות ורוחניות בקצב מדיטטיבי. ויולה נחשב לאבי אמנות הווידאו העכשווית.",
    "rank": 200
  }
]
